import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "welcome": "Welcome",
      "go_to_app": "Go To Application",
      "dashboard_title": "Performance Reports",
      "assets": "Assets",
      "work_orders": "Work Orders",
      "username": "User ID",
      "password": "Password",
      "login_btn": "Sign In",
      "forgot_pwd": "Forgot Password?",
      "vendors_title": "Vendor Directory",
      "new_vendor": "New Company",
      "search_placeholder": "Search by ID, Name or TRN...",
      "comp_id": "Company ID",
      "comp_name": "Company Name",
      "type": "Type",
      "currency": "Currency",
      brand: { name: "TEKNORA EAM", tagline: "Asset Excellence", version: "Teknova v1.0.4" },
      search: { placeholder: "Search Modules..." },
      menu: {
        settings: "Settings", organization: "Organization", domains: "Domains", field_config: "Field Config", classifications: "Classifications", importer: "Universal Importer", cobie: "COBie Manager", workflow: "Workflow Engine", scripts: "Action Scripts",
        analytics: "Analytics", dashboards: "BI Dashboards", report_designer: "Report Designer", report_wizard: "Report Wizard",
        assets: "Assets", asset_registry: "Asset Registry", locations: "Locations", categories: "Asset Categories", meters: "Meters", failure_codes: "Failure Codes",
        work_management: "Work Management", wo_tracking: "Work Order Tracking", labor_reporting: "Scheduler",
        resources: "Resources", crafts: "Crafts", labor: "Labor", person: "Person",
        service_desk: "Service Desk", service_requests: "Service Requests", incidents: "Incident Registry",
        procurement: "Procurement", po: "Purchase Orders", pr: "Purchase Requests", rfq: "RFQ", receiving: "Receiving", vendors: "Vendors",
        contracts: "Contracts", contracts_master: "Contracts Master", sla: "Service Level Agreement",
        inventory: "Inventory", item_master: "Item Master", tools: "Tools", balances: "Inventory Balances", transfers: "Issues & Transfers", storerooms: "Storerooms",
        planning: "Planning", pm_schedules: "PM Schedules", safety_plans: "Safety Plans", hazards: "Hazards", precautions: "Precautions", tagouts: "Tagouts", job_plans: "Job Plans",
        security: "Security", user_list: "User List", groups: "Security Groups", "recent": "Recently Visited"
      },
      user_settings: { title: "User Settings", default_info: "Default Information", personal_info: "Personal Information", password_info: "Password Information", sign_out: "Sign Out", "system_info": "System Info" },
      notifications: { title: "Inbox Tasks", new_alerts: "New", empty: "Your inbox is clean", view_all: "View All Activities" },
      sidebar: {
        queries: "Available Queries", all_assets: "All Assets", operating_assets: "Operating Assets", critical_assets: "Critical Assets", my_bookmarks: "My Bookmarks", common_actions: "Common Actions", new: "New", move_assets: "Move Assets", print_barcodes: "Print Barcodes", create_report: "Create Report", wo_queries: "WO Queries", all_wo: "All Workorders", waiting_approval: "Waiting for Approval", wip: "Work in Progress", completed_today: "Completed Today", bulk_approve: "Bulk Approve", record_actions: "Record Actions", save: "Save", delete: "Delete", workflow_status: "Workflow / Status", change_status: "Change Status", view_history: "View History", item_ops: "Item Operations", add_to_storeroom: "Add Item To Storeroom", inv_ops: "Inventory Operations", reorder: "Reorder", tax_ops: "TAX Operations", tax_category: "Tax Category", create_po: "Create PO", settings_group: "Settings", system_settings: "System Settings", email_settings: "Email Settings", asset_ops: "Asset Operations", meter_readings: "Meter Readings", hist_readings: "Historical Readings", report_downtime: "Report Downtime", downtime_hist: "Downtime History", move_mod_asset: "Move/Modify Asset", asset_move_hist: "Asset Move History", create_related: "Create Related", create_incident: "Create Incident", view_inc_hist: "View Incident History", create_wo: "Create Work Order", sr: "Service Request", apply_sla: "Apply SLA", approve_wo: "Approve WO", start_work: "Start Work", complete_work: "Complete Work", close_wo: "Close WO", analytics: "View / Analytics", wf_history: "View Work Flow History", history_log: "History Log", wo_costs: "WO Costs", purchase_info: "Purchase Info", all_records: "All Records", find_nav: "Find Navigation Item", more_actions: "More Actions", settings: "Settings", export_data: "Export Data", audit_log: "Audit Log", share_app: "Share Application"
      },
      apps: {
        ORGANIZATION: "Organizations", ASSET: "Assets", LOCATION: "Locations", WORKORDER: "Work Orders", INVENTORY: "Inventory", CLASSIFICATION: "Classifications", VENDOR: "Vendors", METER: "Meters", DOMAINS: "Domains", CRAFTS: "Crafts", STOREROOMS: "Storerooms", ITEMS: "Item Master", INVENTORYUSAGE: "Inv Usage", MR: "Material Requests", PR: "Purchase Reqs", PO: "Purchase Orders", LABOR: "Labor", PM: "PM Schedules", SAFETY: "Safety Plans", HAZARD: "Hazards", TAGOUT: "Tagouts", PRECUTION: "Precautions", SR: "Service Requests", INCIDENTS: "Incidents", ASSET_CATEGORIES: "Asset Categories", FAILURECLASS: "Failure Codes", RFQ: "RFQ", CONTRACT: "Contracts", SLA: "SLA", FAILURE_CODES: "Failure Codes", REPORTLIST: "Reports", 
        "REPORT_DESIGNER": "Report Designer", "REPORT_WIZARD": "Report Wizard", "BIM_INTEGRATOR": "BIM Integrator", "UNIVERSAL_IMPORTER": "Universal Importer", "WORKFLOW_ENGINE": "Workflow Engine", "ACTION_SCRIPTS": "Action Scripts" ,
        "VENDORS": "Vendors", "RECEIVING": "Receiving", "PRECAUTIONS": "Precautions", "TAGOUT": "Tagouts","JOBPLAN": "Job Plans","ROLE": "Roles", "TOOLS": "Tools", "USER": "User"
      },
      dashboard: { tab_bi: "KPIs Template", tab_inbox: "Workflow Inbox", advanced_analytics: "Advanced Analytics (Apache Superset)", workflow_center: "Workflow Execution Center", active_tasks: "Active Tasks", history_tasks: "History Tasks", no_data: "No data found in this section", take_action: "Take Action", previous: "Previous", next: "Next", showing: "Showing", of: "of", actual: "Actual", target: "Target", kpi_graph: "KPI Graph" },
      login: {
        id_placeholder: "Enter your ID",
        error_msg: "Invalid ID or Password",
        server_error: "Server connection failed",
        just_smart: "Just Smart"
      },
      organizations: { title: "Organizations", org_id: "Organization", description: "Description", active: "Active?" },
      org_detail: {
        org_label: "Organization", tabs: { organization: "Organization", sites: "Sites", map: "Geolocation Map" },
        fields: { currency1: "Base Currency 1", currency2: "Base Currency 2", item_set: "Item Set", company_set: "Company Set", item_status: "Default Item Status", active: "Active?" },
        descs: { currency1: "Primary Currency", currency2: "Secondary Currency", item_set: "ITEM SET", company_set: "COMPANY SET" },
        lookups: { currency: "Currency", item_set: "Item Set", company_set: "Company Set", status: "Status", governorate: "Governorate" },
        sites: { management: "Sites Management", new_row: "New Row", of: "of", site_id: "Site ID", description: "Description", active: "Active?", action: "Action", site_details: "Site Details", state: "State / Governorate", contact: "Primary Contact", fin_info: "Financial / Budget Information", yearly_budget: "Yearly Budget", monthly_budget: "Monthly Budget", utilization: "Current Year Utilization", fin_health: "Financial health is stable for this site." },
        toasts: { id_required: "Organization ID is required!", saving: "Saving changes...", success: "Organization and Sites Saved Successfully!", fail: "Save Failed" }
      },
      domains: { title: "Domains", find_placeholder: "Find Domain...", new_domain: "New Domain", domain_id: "Domain", description: "Description", type: "Type", values: "Values" ,
        save_btn: "Save Domain", desc_placeholder: "Domain Description", synonym_values: "Synonym Values", new_row: "New Row",
        internal_val: "Internal Value", external_desc: "External Description", default: "Default?", action: "Action",
        no_values: "No values defined for this domain. Click 'New Row' to add.",
        toasts: { loading: "Loading Domain Data...", load_fail: "Failed to load domain data", id_required: "Domain ID is required!", saving: "Saving Domain...", save_success: "Saved successfully!", save_fail: "Save failed" }
      },
      classifications: { parent: "Parent Classification", order: "Order", hierarchy: "Classification Structure", hierarchy: "Full Hierarchy Path", parent: "Parent Classification", order: "Order", gen_desc: "Generate Description?", upload_img: "Upload Image", 
        use_with: "Use With Objects", obj_name: "Object Name", top_level: "Top Level?", attributes: "Classification Attributes", attr_id: "Attribute ID", section: "Section", uom: "UOM",
        lookups: { select_parent: "Select Parent", select_attr: "Select Attribute", select_type: "Select Type", select_domain: "Select Domain", select_uom: "Select UOM" }
      },
      bim: {
        title: "BIM Integrator Pro", subtitle: "Advanced Revit to COBie Mapping",
        waiting_translation: "Waiting for Model Translation...",
        tabs: { "3d": "3D Viewer", data: "Data Table" },
        preview_table_title: "COBie Component Preview",
        controls: { destination: "Destination", select_site: "Select Site", uploads: "File Uploads", select_cobie: "Select COBie File", upload_revit: "Upload Revit Files", models_ready: "Models Ready", preview_list: "Preview Models", finalizing: "Finalizing Sync...", commit: "Commit BIM Integration" },
        table: { asset_name: "Asset Name", location: "Space / Location" },
        toasts: { load_org_fail: "Failed to load organizations", analyzing_excel: "Analyzing Spreadsheet Data...", excel_ready: "Excel Preview Ready", preview_fail: "Preview failed", uploading: "Uploading", models: "Model(s)", models_ready: "Models Ready for Preview", upload_fail: "Upload Failed", select_required: "Select Site and COBie File", finalizing_sync: "Finalizing Integration: Mapping Assets to Models...", integration_success: "BIM-COBie Integration Successful!", import_fail: "Import failed", upload_first: "Upload COBie to preview assets..." }
      },
      importer: {
        title: "Universal Data Loader", target_table: "Target Table", download_template: "Download Template",
        upload_instruction: "Select Excel file to upload", field_mapping: "Field Mapping", excel: "Excel", ignore: "Ignore",
        preview_title: "Preview (First 10 Rows)", execute_btn: "EXECUTE IMPORT PROCESS",
        toasts: { template_downloaded: "Template Downloaded!", template_fail: "Failed to download template", analyzing: "Analyzing file...", preview_ready: "Preview Ready", upload_fail: "Upload failed", no_file: "Please upload a file first", processing: "Processing Master Import...", import_complete: "Import Process Completed!", import_fail: "Import Failed" }
      },
      workflow: {
        title: "Workflow Engine", subtitle: "Automation Control Center", export_btn: "Export CSV", new_process: "New Process", loading: "Loading Processes...", unnamed: "Unnamed Process", no_desc: "No description provided.", linked_to: "Linked to", create_path: "Create New Path",
        table: { id: "ID", name: "Process Name", app: "App", status: "Status", created: "Created At" },
        tooltips: { edit: "Edit Logic", settings: "Global Settings", delete: "Delete Process" },
        toasts: { fetch_fail: "Failed to fetch workflows", no_data: "No data to export" },
        designer_title: "Workflow Logic Designer (Loopback Enabled)", publish_btn: "PUBLISH", loading_designer: "Reconstructing Logic Path...", logic_palette: "Logic Palette", config_title: "Configuration", node_label: "Label", assign_roles: "Assign Roles", post_action: "Post-Action Scripts", select_lookup: "SELECT FROM LOOKUP", script_hint: "* Multiple scripts can be separated by commas.", status_auto: "Status Auto-Action", trigger: "Trigger", target_status: "Target Status", cond_expr: "Conditional Expression (Python)", escalation: "Escalation (Hours)", select_node: "Select a node to edit",
        options: { no_change: "NO STATUS CHANGE", change_status: "CHANGE STATUS", select_status: "SELECT STATUS" },
        lookups: { select_roles: "Lookup Roles", select_scripts: "Select Scripts" },
        swal: { publish_title: "Publish Workflow?", publish_text: "This will synchronize the engine steps with the database.", confirm_publish: "Yes, Publish Now", delete_title: "Purge Logic?", delete_text: "Are you sure you want to delete", confirm_delete: "Yes, Delete Everything" },
        toasts: { id_required: "Please enter a process name", saving: "Synchronizing workflow...", save_success: "Workflow Logic Synchronized! 🚀", save_fail: "Sync Failed", purging: "Purging workflow...", delete_success: "Workflow permanently deleted", delete_fail: "Delete Failed" }
      },
      field_config: { title: "Metadata Field Mapping", table_name: "TABLE NAME", field_name: "FIELD NAME (BACKEND)", current_mappings: "CURRENT MAPPINGS FOR", field: "Field", linked_domain: "Linked Domain" },
      scripts: {
        title: "ACTION SCRIPTS", subtitle: "Manage Automation & Logic Templates", new_btn: "CREATE NEW SCRIPT", search_placeholder: "Search scripts by name or object...",
        table: { name: "Script Name", object: "Target Object", created: "Created At" },
        toasts: { fetch_fail: "Failed to load scripts" }
      },
      studio: {
        schema_explorer: "SCHEMA EXPLORER", target_context: "Target Object Context", name_placeholder: "Give your script a name...", engine_info: "ENGINE: PYTHON 3.10 / CPYTHON", console_title: "System Execution Console", clear_console: "Clear Console", field_from: "Field from", access_col: "Access database column: ", db_model: "Database Model",
        btns: { compile: "COMPILE", compiling: "COMPILING...", save_deploy: "SAVE & DEPLOY" },
        toasts: { preserved: "Script preserved and deployed!", compiled: "Compilation successful!" },
        console: { init: "Studio initialized. Models syncing...", schema_sync: "Models Dictionary synchronized successfully.", schema_fail: "Failed to sync models dictionary.", saved_prefix: "Script saved successfully", error_op: "Error occurred during save operation.", compiling: "Starting compilation and syntax check...", build_finish: "Build Finished: 0 errors, 0 warnings.", syntax_error: "Syntax Error identified.", build_fail: "Compilation Failed", analyzing: "Executing syntax analysis..." }
      },
      reports: {
        title: "Report Templates", new_btn: "Create New Report", search_placeholder: "Search for reports...",
        table: { name: "Report Name", ref_obj: "Reference Object", updated: "Last Updated" },
        swal: { delete_title: "Are you sure you want to delete this report template?", delete_text: "You will not be able to recover this template after deletion.", confirm_delete: "Yes, delete it" },
        toasts: { load_fail: "Failed to load reports", clone_success: "Report has been cloned successfully", clone_fail: "Clone failed", delete_success: "Template deleted successfully", delete_fail: "Failed to delete template", save_success: "Report template saved successfully", save_fail: "Failed to save template" },
          designer: {
          title: "REPORT ENGINE PRO", live_preview: "Live Preview", publish: "Publish Template", model_select: "Model Selection", data_explorer: "Data Explorer", components: "Components", page_break: "Page Break", is_summary: "Summary Report?", user_params: "User Parameters", add_param: "Add Input Field", master_info: "Master Info", relational_data: "Relational Data", detail_tables: "Detail Tables",
          tabs: { body: "Body (Content)", header: "Page Header", footer: "Page Footer", css: "Global CSS" },
          fields: { wonum: "WO Number",assetnum: "Asset Number", desc: "Description", status: "Status", asset: "Asset Name", location: "Location ID", tasks_table: "Tasks Table", mat_table: "Materials Table", asset_basic: "Asset Basic", inv_basic: "Inventory Basic", vend_basic: "Vendor Basic" }
        },
      },
      assets: {
        map: { "gps_location": "Geographical Location (GPS)", "gps_coordinates": "GPS Coordinates" },
        list: { system_title: "Asset Management System", new_asset: "New Asset Record", all_orgs: "All Organizations", all_sites: "All Sites", db_total: "Database Total:", display_page: "Displaying Page:", all: "ALL", col_site: "Site", col_org: "Org", navigate_hint: "Use Arrows to Navigate" },
        modal: { migration_title: "Massive Asset Migration", caution_prefix: "Caution: You are about to relocate", caution_suffix: "assets. This will update their physical location and financial mapping immediately.", dest_label: "New Destination Location", placeholder: "SELECT LOCATION...", abort: "Abort", execute: "Execute Bulk Migration" },
        headers: { asset_num: "Asset Number", desc: "Description", status: "Status", downtime: "Total Downtime", site: "Site" },
        tabs: { details: "Asset Details", spare_parts: "Spare Parts", safety: "Safety", meters: "Meters", specs: "Specifications", history: "Work History", map: "Geomap", bim: "3D View", ai: "AI Analyze", eval: "Evaluation", attachments: "Attachments" },
        sections: { "linear_details": "Linear Reference Details",general: "General Information", details: "Details", finance: "Address & Financial", image: "Asset Image", audit: "Audit Info", bim_info: "BIM Info", reliability: "Reliability Analysis" },
        fields: { "is_linear": "Is Linear Asset?", "start_measure": "Start Measure", "end_measure": "End Measure", "measure_unit": "Unit of Measure", "direction": "Flow Direction",type: "Asset Type", location: "Location", parent: "Parent Asset", category: "Asset Category", is_running: "Asset Up / Is Running?", serial: "Serial Number", item: "Rotating Item", failure: "Failure Class", safety_plan: "Safety Plan", vendor: "Vendor", price: "Purchase Price", replace: "Replacement Cost", priority: "Priority", ytd_cost: "YTD Cost" },
        meters: { seq: "Sequence", name: "Meter", reading: "Last Reading", date: "Reading Date", inspector: "Inspector", remarks: "Remarks" },
        ai: { title: "Asset Intelligence", run: "Run Diagnostics", summary: "Technical Summary", recommend: "Recommendations", telemetry: "Analyzing Telemetry..." },
        spare_fields: { item: "Rotating Item", qty: "Quantity", issued: "Issued Qty", remarks: "Remarks", item_details: "Item Details" },
        safety: {
          plan_card: "Associated Safety Plans", active_plan: "Active Safety Plan", no_plan: "NO PLAN LINKED", link_plan: "Link Safety Plan", change_plan: "Change Plan", hazard_title: "Asset Specific Hazards", hazard_num: "Hazard", hazard_type: "Type / Priority", no_hazards: "No specific hazards linked to this asset.", add_hazard: "Add Hazard", loto_title: "Lock Out / Tag Out (Isolation Points)", tag_id: "Tag Out ID", req_state: "Required State", no_loto: "No isolation points defined.", add_loto: "Add Isolation Point", applying_proto: "Applying Safety Protocol..."
        },
        meters: {
          title: "Associated Meters",
          details_title: "Meter Details",
          seq: "Sequence",
          meter_name: "Meter Name",
          meter_type: "Meter Type",
          uom: "Unit of Measure",
          active_status: "Active?",
          last_reading: "Last Reading",
          last_date: "Last Reading Date",
          inspector: "Inspector",
          remarks: "Remarks",
          new_meter: "New Meter"
        },
        specs: {
          classification: "Classification",
          select_class: "Select Classification...",
          tech_specs: "Technical Specifications",
          attribute: "Attribute",
          value: "Value",
          uom: "UOM",
          data_type: "Data Type",
          attr_details: "Attribute Details",
          select_val: "Select Value"
        },
        history: {
          title: "Historical Work Orders",
          wo_num: "WONUM",
          finish_date: "Finished Date",
          no_history: "No previous work orders found for this asset.",
          fetching: "Fetching History...",
          wo_type: "Type"
        },
        bim: {
          show_3d: "View Digital Twin (3D)",
          model_status: "Model Status",
          linked: "LINKED & ACTIVE",
          not_linked: "NOT LINKED",
          upload_revit: "Upload Revit (.rvt)",
          urn_label: "Model URN"
        },
        ai: {
          title: "ASSET INTELLIGENCE",
          sub_title: "AI Analyzer",
          tagline: "Industrial IoT Predictive Diagnostics",
          run_btn: "RUN DIAGNOSTICS",
          analyzing: "ANALYZING TELEMETRY STREAM...",
          health_score: "Health Score",
          thermal: "Thermal Alert",
          vibration: "Vibration Alert",
          tech_summary: "TECHNICAL SUMMARY",
          recommendations: "RECOMMENDATIONS",
          sensors_chart: "Sensors vs Critical Limits",
          init_prompt: "Click RUN DIAGNOSTICS to initialize AI Analysis",
          critical: "CRITICAL",
          normal: "NORMAL",
          stable: "STABLE",
          detected: "DETECTED", "predictive_trajectory": "Predictive Failure Trajectory", "est_failure": "Est. Failure", "loading_pred": "Generating Forecast Model..."
        },
        "features": {
          "feature_id": "Feature ID",
          "label": "Label",
          "start": "Start Measure",
          "end": "End Measure (Empty = Point)",
          "value": "Value (e.g. 500mm)",
          "details": "Feature Details",
          "y_offset": "Y-Offset (Right/Left)",
          "z_offset": "Z-Offset (Depth/Height)"
        }

      },
      common: {"days": "Days", "weeks": "Weeks", "months": "Months", "years": "Years", "daysList": {"saturday": "Saturday", "sunday": "Sunday", "monday": "Monday", "tuesday": "Tuesday", "wednesday": "Wednesday", "thursday": "Thursday", "friday": "Friday"}, "select": "Select", "search": "Search", "pending": "Pending", "pendingSelection": "--- PENDING SELECTION ---", confirm: "Confirm", new_row: "New Row", save_settings: "Save AI Configuration", selected: "Assets Selected", bulk_move: "Massive Asset Migration", change_status: "Change Status", cancel: "Reset All Filters", save: "Save", cancel: "Cancel", delete: "Delete", back: "Back", record: "Record", total: "Total", print: "Print", active: "Active", critical: "Critical", warning: "Warning", healthy: "Healthy", "filter": "Filter...", "save_success": "تم الحفظ بنجاح", "save_fail": "فشل الحفظ", "delete": "حذف", "delete_success": "تم الحذف بنجاح", "delete_fail": "فشل الحذف", "are_you_sure": "هل أنت متأكد؟", "cancel": "إلغاء", "confirm": "تأكيد", "first": "الأول", "last": "الأخير", "next": "التالي", "prev": "السابق", "sar": "ر.س", "all": "الكل",    "attachments": "المرفقات", "history": "السجل", "change_status": "تغيير الحالة", "totalRecords": "إجمالي السجلات", copy: "Copy", cancel: "Cancel", clone: "Clone", back: "Back", save: "Save", cancel: "Cancel", delete: "Delete", back: "Back", record: "Record", total: "Total", print: "Print", active: "Active", critical: "Critical", warning: "Warning", healthy: "Healthy", "save_success": "Saved Successfully", "save_fail": "Save Failed", "delete": "Delete", "delete_success": "Deleted Successfully", "delete_fail": "Delete Failed", "are_you_sure": "Are you sure?", "cancel": "Cancel", "confirm": "Confirm", "first": "First", "last": "Last", "next": "Next", "prev": "Previous", "sar": "SAR", "all": "ALL", "attachments": "Attachments", "history": "History", "change_status": "Change Status", "totalRecords": "Total Records", yes: "Yes", no: "No", active: "ACTIVE", inactive: "INACTIVE", "main": "Main Details", "save": "SAVE", "change_status": "Change Status", "history": "History", "delete": "Delete", "org": "Organization", "site": "Site", "new_row": "NEW ROW", "location": "Location", "asset": "Asset", "no_records": "No records found", "saving": "Saving...", "save_success": "Saved Successfully!", "save_fail": "Save Failed", "are_you_sure": "Are you sure?", "yes_delete": "Yes, delete it!", "cancel": "Cancel", "delete_success": "Deleted successfully", "delete_fail": "Delete failed: ", "clear_filters": "CLEAR FILTERS", "all": "ALL", "syncing": "Syncing Data...", "showing": "Showing", "total": "Total", "created_by": "Created By", "changed_date": "Changed Date"}, 
      toasts: { save_success: "Saved Successfully", save_fail: "Save Failed", load_fail: "Data Load Failed", delete_success: "Deleted Successfully" },
      swal: { delete_title: "Are you sure?", delete_text: "You are about to delete Asset:", confirm_delete: "Yes, Delete Record" },
      "ai_settings": {
        "title": "AI Engineer Settings",
        "sub_title": "AI Predictive Maintenance Engine",
        "enable_label": "Enable Auto-Predictive Maintenance",
        "enable_sub": "Auto-create WO based on AI analysis",
        "target_lang": "Reports & Tasks Language",
        "threshold": "Confidence Threshold for Decision",
        "auto_tasks": "Auto-generate Work Tasks (WOTasks)",
        "task_desc": "Write job steps automatically in tasks table",
        "max_tasks": "Max steps per Work Order",
        "section": "Section",
        "technicalDetails": "Technical Details"
      },
      export_technical_report: "EXPORT TECHNICAL REPORT (PDF)",
      availability: "Availability",
      mtbf: "MTBF",
      mttr: "MTTR",
      hrs: "HRS",
      "reliability_score": "Reliability Score",
      "score": "Score",
      "downtime_history_trend": "Downtime History Trend (Last 10 Events)",
      "values_in_hours": "Values in Hours",
      "timeline_event_date": "Timeline (Event Date)",
      "downtime_hours": "Downtime (Hours)",
      "no_downtime_records": "No downtime records found for this asset yet.",
      "reliability_analysis": "Reliability Analysis",
      "total_failures": "Total Failures",
      "total_down_time": "Total Down Time",
      "last_calculation": "Last Calculation",
      "maintenance_strategy_note": "Maintenance Strategy Note",
      "high_mttr_detected": "High MTTR detected. Recommendation: Evaluate spare parts availability and technical training for this asset category.",
      "critical_availability": "Critical Availability level. Consider increasing PM frequency or scheduled overhauls.",
      "nominal_performance": "Asset performance is within nominal parameters. Continue standard PM schedule.",
      "current_load_factor": "Current Load Factor",
      "optimal": "Optimal",
      statusModal: {
        "loadError": "Could not load statuses",
        "selectFirst": "Please select a status first",
        "updating": "Updating status...",
        "success": "Status Updated",
        "failed": "Update failed",
        "changeStatus": "Change Status:",
        "currentStatus": "Current Status",
        "availableStatuses": "Available Statuses",
        "loading": "Loading...",
        "chooseStatus": "Choose Status...",
        "memo": "Justification / Memo",
        "enterNotes": "Enter your notes...",
        "cancel": "Cancel",
        "update": "Update"
      },
      attachmentsModal: {
        "loadError": "Error loading files",
        "uploadSuccess": "File attached successfully",
        "uploadFailed": "Upload failed",
        "deleteConfirmTitle": "ARE YOU SURE?",
        "deleteConfirmText": "You are about to permanently delete '{{name}}'. This will remove the file from our servers.",
        "btnYesDelete": "YES, DELETE IT!",
        "btnCancel": "CANCEL",
        "processingDelete": "Processing deletion...",
        "deletedTitle": "DELETED!",
        "deletedText": "The attachment has been removed successfully.",
        "deleteFailed": "Delete failed",
        "headerTitle": "Attachment Library",
        "linkingTo": "Linking to:",
        "filesFound": "FILES FOUND:",
        "uploadBtn": "UPLOAD NEW DOCUMENT",
        "thName": "Name",
        "thOwner": "Owner",
        "thStatus": "Status",
        "thActions": "Actions",
        "statusPrivate": "Private",
        "statusPublic": "Public",
        "noDocs": "No documents linked yet"
      },
      enterMeters: {
        "noMeters": "No meters linked to asset:",
        "saving": "Saving readings...",
        "enterAtLeastOne": "Please enter at least one new reading",
        "saveSuccess": "All readings saved successfully!",
        "saveFailed": "Failed to save readings",
        "title": "Enter Meter Readings | Asset:",
        "titleLoc": "Enter Meter Readings | Location:",
        "thIdentification": "Meter Identification",
        "thNewReading": "* New Reading",
        "thReadingDate": "* Reading Date",
        "thMeterType": "Meter Type",
        "thLastRecorded": "Last Recorded",
        "noDescription": "No description",
        "enterValue": "Enter value...",
        "notAvailable": "N/A",
        "operator": "Operator:",
        "btnCancel": "Cancel",
        "btnUpdate": "Update Readings"
      },
      emailSettings: {
        "loadFailed": "Failed to load settings",
        "saveSuccess": "Mail settings saved successfully!",
        "saveFailed": "Failed to save settings",
        "connecting": "Connecting to SMTP server...",
        "connFailed": "Connection Failed!",
        "outgoingTitle": "Outgoing Mail (SMTP - Sending)",
        "incomingTitle": "Incoming Mail (IMAP - Monitoring)",
        "title": "SMTP Configuration",
        "subtitle": "Mail Server Settings",
        "lblHost": "SMTP Host",
        "lblPort": "SMTP Port",
        "lblImapHost": "IMAP Host",
        "lblImapPort": "IMAP Port",
        "enableImap": "Enable Inbox Monitoring (RFQ Radar)",
        "imapDesc": "Automatically fetch and parse vendor quotations from the inbox.",
        "lblUser": "SMTP Username / Email",
        "lblPass": "SMTP Password",
        "lblSender": "System Sender Email (From Address)",
        "gmailNote": "For Gmail, use an 'App Password' from Google Security. Account passwords will not work with 2FA enabled.",
        "btnTest": "TEST",
        "btnCancel": "CANCEL",
        "btnSave": "SAVE CONFIGURATION"
      },
      locationDetails: {
        "noBimModel": "No 3D Model Linked to this Location",
        "noBimLinked": "This location is not linked to BIM",
        "locMandatory": "Location is a mandatory field!",
        "saving": "Saving changes...",
        "saveSuccess": "Location saved successfully",
        "saveFailed": "Save failed:",
        "deleteTitle": "Are you sure?",
        "deleteText": "You are about to delete Location {{id}}. This action cannot be undone!",
        "btnYesDelete": "Yes, delete it!",
        "btnCancel": "Cancel",
        "deleting": "Deleting location...",
        "deleteSuccess": "Location deleted successfully",
        "deleteFailed": "Delete failed!",
        "uploadingRevit": "Uploading & Translating Revit Model...",
        "revitSuccess": "Model Linked Successfully!",
        "uploadFailed": "Upload Failed:",
        "loadingCtx": "LOADING LOCATION CONTEXT...",
        "tooltipChangeStatus": "Change Status",
        "tooltipStatusHistory": "Status History",
        "tooltipDelete": "Delete",
        "btnSave": "SAVE",
        "lblLocation": "Location",
        "lblDescription": "Description",
        "btnRevitLinked": "Revit Linked",
        "tabLocation": "Location",
        "tabAssets": "Assets",
        "tabSpecs": "Specifications",
        "tabSafety": "Safety",
        "tabMeters": "Meters",
        "tab3D": "3D View",
        "tabHistory": "History",
        "secIdentity": "Location Identity",
        "lblStatus": "Status",
        "lblType": "Type",
        "lblParentLoc": "Parent Location",
        "lblSiteID": "Site ID",
        "secGeoInfo": "Geographic & Address Information",
        "lblServiceAddr": "Service Address",
        "lblBimSpaceId": "BIM Space ID",
        "lblGisCoords": "GIS Coordinates",
        "secRefImage": "Reference Image",
        "btnUploadPhoto": "Upload Photo",
        "thAssetNum": "Asset Num",
        "thStatus": "Status",
        "lblClass": "Classification",
        "thAttr": "Attribute",
        "thDesc": "Description",
        "thValue": "Value",
        "titleHazards": "Reported Hazards at this Location",
        "btnAddHazard": "Add Hazard",
        "lblSelectHazards": "Select Hazards",
        "thHazard": "Hazard",
        "thPrecaution": "Precaution",
        "titleLocMeters": "Location Meters",
        "showingMeters": "Showing {{current}} of {{total}}",
        "noMetersDef": "No meters defined",
        "thSeq": "Seq",
        "thMeterNum": "Meter Num",
        "thType": "Type",
        "thUOM": "UOM",
        "thActive": "Active",
        "newMeter": "NEW_METER",
        "clickNewRow": "Click 'New Row' to add a meter to this location",
        "titleMeterConfig": "Meter Details Configuration",
        "newEntry": "New Entry",
        "lblMeterNum": "* Meter Number",
        "lblMeterType": "Meter Type",
        "lblUOM": "Unit of Measure",
        "lblMeterActive": "Meter is Active",
        "lblLastReading": "Last Reading",
        "lblReadingDate": "Reading Date",
        "lblInspector": "Meter Inspector",
        "lblRemarks": "Remarks / Comments",
        "placeholderRemarks": "Enter technical notes about this meter...",
        "btnAddMeterRow": "Add New Meter Row",
        "titleModelStatus": "Model Status",
        "statusLinked": "LINKED & ACTIVE",
        "statusNotLinked": "NOT LINKED",
        "btnUploadRevit": "Upload Revit (.rvt)",
        "titleHistory": "Transaction History & Audit Log",
        "lblChangedBy": "Changed by:",
        "failedFetchAttr": "Failed to fetch attributes"
      },
      "locationList": {
        "loadFailed": "Failed to load locations from Server.",
        "title": "Locations",
        "searchPlaceholder": "Global Search...",
        "btnClearAll": "Clear All",
        "btnExport": "Export",
        "btnNewLocation": "New Location",
        "thLocationId": "Location ID",
        "thDescription": "Description",
        "thType": "Type",
        "thStatus": "Status",
        "thSite": "Site",
        "optAll": "ALL",
        "optOperating": "OPERATING",
        "optDecommissioned": "DECOMMISSIONED",
        "fetchingData": "Fetching Data from Server...",
        "noRecords": "No matching records found.",
        "recordsFound": "Records Found:",
        "page": "Page:"
      },
      "universalLookup": {
        "selectValue": "Select Value:",
        "total": "Total",
        "searchPlaceholder": "Search by code or description...",
        "valueCode": "Value / Code",
        "description": "Description",
        "site": "Site",
        "synchronizing": "Synchronizing...",
        "noRecords": "No matching records found.",
        "loadingMore": "Loading more records...",
        "results": "Results:",
        "cancel": "Cancel"
      },
      "statusHistory": {
        "title": "Status Audit Trail",
        "loading": "LOADING HISTORY...",
        "noRecords": "No status changes recorded for this item.",
        "initial": "INITIAL",
        "btnClose": "Close"
      },
      "personalInfo": {
        "updateSuccess": "Profile Updated Successfully",
        "sessionExpired": "Session expired, please login again",
        "updateFailed": "Update failed",
        "title": "Personal Information & Defaults",
        "lblDisplayName": "Full Display Name",
        "lblEmail": "Email Address",
        "lblDefaultOrg": "Default Organization",
        "selectOrg": "Select Org...",
        "lblDefaultSite": "Default Site",
        "selectSite": "Select Site...",
        "lblDefaultLang": "Default Language",
        "btnCancel": "Cancel",
        "btnSave": "Apply & Save Changes",
        "securityTitle": "Security & 2FA",
        "enable2FA": "Enable Two-Factor Authentication (2FA)",
        "googleAuth": "Google Authenticator",
        "emailOTP": "Email OTP",
        "configure2FA": "Configure 2FA Setup",
        "scanQR": "Scan this QR Code using Google Authenticator or Authy, then enter the 6-digit code below to verify.",
        "btnVerify": "Verify",
        "setupSuccess": "2FA Setup Successful!",
        "invalidCode": "Invalid Verification Code",
        "failedQR": "Failed to generate QR Code"
      },
      "appSettings": {
        "savingSettings": "Saving Settings...",
        "saveSuccess": "Settings updated successfully!",
        "saveFailed": "Failed to save settings.",
        "title": "Enterprise Configuration",
        "org": "Organization",
        "tabs": {
          "WORKORDER": "Work Orders",
          "ASSET": "Asset Registry",
          "INVENTORY": "Warehouse & Stock",
          "PURCHASE": "Procurement",
          "PR": "PR",
          "JP": "JP",
          "PM": "PM",
          "MR": "MR",
          "SR": "SR"
        },
        "systemRules": "{{tab}} System Rules",
        "prefix": "Sequence Prefix",
        "preview": "Preview",
        "seed": "Start Value (Seed)",
        "valuationStrategy": "Valuation Strategy",
        "movingAvg": "Moving Average (Recommended)",
        "fifo": "First-In, First-Out (FIFO)",
        "lifo": "Last-In, First-Out (LIFO)",
        "allowNegative": "Allow Negative Balance",
        "negativeWarning": "Warning: Affects financial accuracy",
        "encrypting": "Encrypting & Transmitting...",
        "auditLogged": "All changes are logged in audit trail",
        "btnCancel": "Cancel",
        "btnSave": "Save System Policy"
      },
      "workflowAction": {
        "successMove": "Workflow Moved Successfully! 🚀",
        "failedMove": "Action Failed",
        "btnRoute": "Route Workflow",
        "modalTitle": "WORKFLOW ACTION",
        "assignedAs": "Assigned To You As:",
        "defaultInstruction": "Please review and take action.",
        "lblChoosePath": "Choose Path",
        "valSelectPath": "Please select a path",
        "optApprove": "APPROVE / MOVE FORWARD",
        "optReject": "REJECT / RETURN",
        "lblMemo": "Action Memo / Comments",
        "placeholderMemo": "Add your comments here...",
        "btnCancel": "Cancel",
        "btnComplete": "COMPLETE STEP"
      },
      "meterHistory": {
        "title": "Historical Meter Readings",
        "lblAsset": "Asset",
        "fetching": "Fetching Archives...",
        "noRecords": "No historical readings found for this asset.",
        "thMeterName": "Meter Name",
        "thReadingVal": "Reading Value",
        "thReadingDate": "Reading Date",
        "thEnteredBy": "Entered By",
        "thEntryDate": "Entry Date",
        "btnClose": "Close History",
        "lblLocation": "Location",
        "noRecordsLoc": "No historical readings found for this location."
      },
      "rpt_print": "Print Reports",
      "no_templates": "No templates available",
      "wo": {
        "tabs": { "workOrder": "Work Order", "plans": "Plans", "assignments": "Assignments", "actuals": "Actuals", "safety": "Safety", "failure": "Failure Reporting" },
        "subTabs": { "tasks": "Tasks", "labor": "Labor", "materials": "Materials", "tools": "Tools", "services": "Services" },
        "headers": { "workOrder": "Work Order", "status": "Status", "totalCost": "Total Cost", "activeSla": "ACTIVE SLA MONITORING", "targetRes": "TARGET RESOLUTION", "targetResp": "TARGET RESPONSE", "trackingTitle": "Work Order Tracking", "globalView": "Global Org View", "site": "Site", "selected": "Selected" },
        "sections": { "assetDetails": "Asset Details", "scheduling": "Scheduling Information", "responsibility": "Responsibility", "laborAssign": "Labor Assignments & Scheduling", "totalAssign": "Total Assignments" },
        "fields": { "description": "Description", "location": "Location", "asset": "Asset", "workType": "Work Type", "safetyCode": "Safety Code", "supervisor": "Supervisor", "failureClass": "Failure Class", "targStart": "Target Start", "targFinish": "Target Finish", "schedStart": "Scheduled Start", "schedFinish": "Scheduled Finish", "earlyStart": "Start No Earlier Than", "lateFinish": "Finish No Later Than", "actStart": "Actual Start", "actFinish": "Actual Finish", "duration": "Duration", "timeRemaining": "Time Remaining", "predecessors": "Predecessors", "includeTasks": "Include Tasks in Schedule?", "site": "Site", "organization": "Organization", "priorityHigh": "Priority: High (Level 1)" },
        "actions": { "routeWorkflow": "Route Workflow", "wfHistory": "Workflow History", "changeStatus": "Change Status", "attachments": "Attachments", "printWO": "Print Work Order", "printSafety": "Print Safety Sheet", "history": "Status History", "newTask": "New Task", "selectLoc": "Select Location", "selectAsset": "Select Asset", "selectType": "Select Work Type", "selectSafety": "Select Safety Plan", "selectSup": "Select Supervisor", "selectFail": "Select Failure Class", "selectCraft": "Select Craft", "selectLabor": "Select Labor", "selectItem": "Select Item", "selectStore": "Select Store", "selectTool": "Select Tool", "addLabor": "Add Labor", "addMaterial": "Add Material", "addTool": "Add Tool", "addService": "Add Service", "newAssign": "New Assignment", "compAssign": "Complete Assignment", "createMR": "Create Material Request", "yesCreate": "Yes, Create New Request", "yesChange": "Yes, Change It", "approve": "Approve", "cancel": "Cancel", "startWork": "Start Work", "close": "Close", "complete": "Complete", "selectProblem": "Select Problem", "selectCause": "Select Cause", "selectRemedy": "Select Remedy", "newWO": "New Work Order" },
        "tables": { "sequence": "Seq", "taskDesc": "Task Description", "estDur": "Est. Duration", "status": "Status", "craft": "Craft", "labor": "Labor", "qty": "Qty", "hrs": "Hrs", "rate": "Rate", "lineCost": "Line Cost", "lineType": "Line Type", "itemNum": "Item #", "description": "Description", "unitCost": "Unit Cost", "storeroom": "Storeroom", "item": "Item", "material": "Material", "toolNum": "Tool #", "serviceDesc": "Service Desc", "vendor": "Vendor", "cost": "Cost", "start": "Start", "finish": "Finish", "failCode": "Failure Code" },
        "footer": { "totalLabor": "Total Labor", "totalMaterial": "Total Material", "assigned": "Assigned (Est.)", "toolsServ": "Tools & Serv.", "totalActual": "Total Actual Cost", "loaded": "Loaded", "total": "Total", "page": "Page", "of": "of" },
        "safety": { "hazardsTitle": "Hazards and Required Precautions", "hazardCode": "Hazard Code", "hazardDesc": "Hazard Description", "precautions": "Required Precautions / Actions", "noHazards": "No hazards identified for this work order.", "lotoTitle": "Lock Out / Tag Out (Isolation Steps)", "step": "Step", "tagNum": "Tag Out Num", "isoDesc": "Isolation Description", "reqState": "Required State", "completed": "Completed?", "noLoto": "No isolation steps (LOTO) required." },
        "failure": { "title": "Failure Analysis & RCA", "currClass": "Current Failure Class", "notDefined": "NOT DEFINED", "problems": "PROBLEMS (THE ISSUE)", "causes": "CAUSES (ROOT REASON)", "remedies": "REMEDIES (THE ACTION)", "records": "RECORDS" },
        "placeholders": { "desc": "Enter Work Order description...", "taskDesc": "TASK DESCRIPTION...", "searchWO": "Find Work Order..." },
        "messages": { "loadError": "Error loading Work Order", "taskStatusLocal": "New task status updated locally", "selectItemStore": "Please select both Item and Storeroom first", "duplicateReqTitle": "Duplicate Item Request", "duplicateReqText": "An open MR exists for item {{item}}. Create another?", "creatingMR": "Creating Material Request...", "mrCreated": "MR {{num}} created successfully", "mrFail": "Failed to create Material Request", "confirmStatusChange": "Are you sure you want to change WO {{wonum}} status to {{status}}?", "statusSuccess": "Status changed successfully", "statusFail": "Failed to change status", "saving": "Saving Work Order...", "deleteConfirm": "You are about to delete Workorder {{wonum}}. This action cannot be undone!", "saveBeforeSLA": "Please save the Work Order first before applying SLA", "slaExists": "SLA already applied!", "matchingSLA": "Matching Service Level Agreements...", "slaApplied": "SLA Applied Successfully", "noMatchingSLA": "No matching SLA found", "slaError": "SLA Engine Communication Error", "failureTreeLoaded": "Default failure codes applied for {{class}}", "zeroBalance": "Warning: Zero balance for item in {{store}}", "balanceOk": "Price fetched: {{cost}} - Balance: {{bal}}", "storeError": "Failed to connect to storeroom", "assetLinked": "Asset Linked: {{asset}}", "openAssignError": "Cannot close: {{count}} labor assignments not completed.", "budgetExceeded": "Budget Exceeded!", "assignComplete": "Assignment completed successfully", "actionNotAllowed": "Cannot perform this action for {{status}} status", "locked": "Locked", "cantChangeCancel": "Cancelled requests cannot change status", "printFail": "Failed to generate PDF file", "wfRouted": "Workflow Routed Successfully! 🚀", "wfFail": "Failed to route workflow", "taskStatusChanged": "Task {{task}} status changed to {{status}}", "noLaborAssign": "No labor assigned to this work order yet.", "updateTaskProg": "Update progress of planned tasks", "noMaterials": "No materials reported yet. Click the button below to add.", "linkedMRs": "Linked Material Requests (Status Tracking)", "sessionExpired": "Session expired. Please login again.", "fetchError": "Error fetching data", "loadingWOs": "Loading Work Orders...", "syncing": "Syncing next batch...", "stocknobalance": "⚠️ Warning: This item has a (zero) balance in the warehouse" },
        "linearDefect": {
          "title": "Linear Defect Location",
          "startMeasure": "Start Measure",
          "endMeasure": "End Measure (Optional)",
          "unit": "Unit",
          "yOffset": "Y-Offset (m)"
        },
        "costs": {
          "title": "Work Order Costs",
          "estimated": "Estimated Costs",
          "actual": "Actual Costs",
          "labor": "Labor",
          "materials": "Materials",
          "tools": "Tools",
          "services": "Services",
          "total": "Total",
          "variance": "Variance (Actual - Est)",
          "calculating": "Calculating...",
          "no_data": "No cost data available."
        },
        "purchase_info": {
          "title": "Related Purchase Info",
          "mr_title": "Material Requests (MR)",
          "pr_title": "Purchase Requests (PR)",
          "po_title": "Purchase Orders (PO)",
          "mr_num": "MR NUM",
          "pr_num": "PR NUM",
          "po_num": "PO NUM",
          "vendor": "Vendor",
          "status": "Status",
          "req_date": "Required Date",
          "total_cost": "Total Cost",
          "fetching": "Fetching Data...",
          "no_records": "No records found."
        },
    
      },
      "pm": {
        "tabs": { "pm": "PM", "frequency": "Frequency", "sequence": "Sequence", "seasonaldates": "Seasonal Dates", "forecast": "Forecast" },
        "sections": { "assetLoc": "Asset & Geographical Location", "defaults": "Generation Defaults & Personnel", "compliance": "Compliance Metadata", "siteContext": "Site Context Info", "timeBased": "Time Based Interval Configuration", "meters": "Meter Readings & Triggers", "sequences": "Progressive Job Plan Sequences", "seasonal": "Weekly Active Window Schedule", "projections": "Maintenance Projection Logs" },
        "fields": { "pmNum": "PM Number", "description": "Maintenance Description", "status": "Record Status", "site": "Organizational Site", "asset": "Asset Identification", "location": "Assigned Location", "route": "Route Assignment", "counter": "Current Counter", "jpnum": "Job Plan (JPNUM)", "worktype": "Work Type Code", "supervisor": "Maintenance Supervisor", "glaccount": "Financial GL Account", "woStatus": "WO Default Status", "priority": "Criticality Priority", "lastStart": "Last Cycle Start Date", "lastComp": "Last Cycle Completion", "nextDue": "Calculated Next Due Date", "forecastFlag": "Forecasting Flag", "org": "Organization", "freqInt": "Frequency Interval", "freqUnit": "Frequency Unit", "targStart": "Target Start Time" },
        "actions": { "forecast": "FORECAST", "savePM": "SAVE PM", "addMeter": "ADD METER", "addStep": "ADD STEP", "newPM": "New PM Record" },
        "tables": { "meterName": "Meter Name / Identifier", "freq": "Frequency", "nextProj": "Next Projection", "seq": "Cycle Seq.", "jpnum": "Assigned Job Plan", "fcDate": "Forecasted Date", "targetJp": "Target Job Plan", "estCost": "Est. Total Cost", "status": "Status", "woNum": "Work Order #", "generated": "GENERATED", "projected": "PROJECTED" },
        "messages": { "executingForecast": "Executing PM Forecasting Engine...", "forecastSuccess": "Forecasting Completed Successfully", "forecastFail": "Forecasting Calculation Failed", "seasonalInfo": "Checked days represent allowed execution dates. If a PM is due on an unchecked day, the system will skip to the next available checked day.", "noMeters": "No meter-based triggers defined for this record", "noSeq": "Rotating Sequence Disabled", "noForecasts": "No forecasts available yet.", "showingProjections": "Showing {{count}} projections per page", "fetchListError": "Failed to load Preventive Maintenance records", "syncingList": "Synchronizing PM Records with Server...", "noRecords": "No Preventive Maintenance Records found matching your criteria." },
        "placeholders": { "desc": "Type PM summary description here...", "globalSearch": "Global Smart Search (PM #, Asset, Description)..." },
        "headers": {"masterDir": "PM Master Directory"},
        "footer": {"dbTotal": "Database Total Found:", "currentPage": "Current Page:", "useNavArrows": "Use Navigation Arrows"},
        
      },
      "workflowHistory": {
        "title": "Workflow Audit Trail",
        "trackingId": "Tracking ID:",
        "fetching": "Fetching records...",
        "currentTask": "Current Active Task",
        "since": "Since:",
        "by": "by",
        "noHistory": "No history recorded for this transaction yet",
        "closeBtn": "Close History"
      },
      "pr": {
        "headers": { "prList": "Purchase Requests" },
        "actions": { "newPR": "NEW PR", "clearFilters": "CLEAR FILTERS", "routeWf": "ROUTE WORKFLOW" },
        "tabs": { "pr": "PR", "prlines": "PR Lines" },
        "sections": { "general": "General Information", "financial": "Financial Summary" },
        "fields": { "prNum": "PR Num", "requestedBy": "Requested By", "reqDate": "Required Date", "refMr": "Reference MR", "vendor": "Vendor", "glAccount": "GL Account" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Tax Total", "grandTotal": "Grand Total" },
        "tables": { "prNum": "PR Num", "description": "Description", "status": "Status", "totalCost": "Total Cost", "reqDate": "Req Date", "site": "Site", "itemNum": "Item #", "itemType": "Item Type", "qty": "Qty", "unitCost": "Unit Cost", "tax": "Tax", "lineTotal": "Line Total", "taxCat": "Tax Cat." },
        "messages": { "loadFailed": "Failed to load Purchase Requests", "syncing": "Syncing Records...", "noData": "No data matches your search", "noLines": "No PR lines added yet.", "fetchingMRLines": "Fetching lines for MR: {{mrnum}}...", "loadedMRLines": "Loaded {{count}} lines from MR", "noMRLines": "This MR has no lines", "failedMRLines": "Failed to load MR lines" },
        "swal": { "lockedTitle": "Locked", "cantDeleteStatus": "Cannot delete a record with status: {{status}}", "cantChangeCancel": "Cancelled requests cannot change status", "deleteWarnText": "This will permanently delete the Purchase Request and all its lines." },
        "placeholders": { "desc": "Type PR description here...", "globalSearch": "Global Smart Search..." },
        "footer": { "showing": "Showing", "totalRecords": "Total Records" }
      },
      "po": {
        "headers": { "poList": "Purchase Orders" },
        "actions": { "newPO": "NEW PO", "clearFilters": "CLEAR FILTERS", "routeWf": "ROUTE WORKFLOW", "addManualRow": "ADD MANUAL ROW", "wfHistory": "Workflow Timeline" },
        "tabs": { "po": "PO", "polines": "PO Lines" },
        "sections": { "general": "General Information", "financial": "Financial Summary", "lines": "Purchase Order Lines" },
        "fields": { "poNum": "PO Num", "requestedBy": "Requested By", "orderDate": "Order Date", "refPr": "Reference PR", "vendor": "Vendor", "glAccount": "GL Account" },
        "financial": { "subtotal": "Subtotal (Net)", "taxTotal": "Tax Amount", "grandTotal": "Grand Total" },
        "tables": { "poNum": "PO Num", "totalCost": "Total Cost", "orderDate": "Order Date", "itemNum": "Item #", "itemType": "Item Type", "unitCost": "Unit Cost", "tax": "Tax", "lineTotal": "Line Total", "taxCat": "Tax Cat." },
        "messages": { "loadFailed": "Failed to load Purchase Orders", "syncing": "Syncing Records...", "noData": "No POs match these filters", "noLines": "No lines added yet. Search MR/PR or add manually.", "vendorRequired": "Vendor is mandatory before saving or changing status.", "fetchingLines": "Fetching lines for reference: {{num}}...", "loadedLines": "Loaded {{count}} lines successfully", "noLinesFound": "This reference document has no lines", "failedLines": "Failed to load lines", "cantChangeCancel": "Cancelled requests cannot change status", "cantDeleteStatus": "Cannot delete a record with status: {{status}}" },
        "swal": { "deleteWarnText": "This will permanently delete the Purchase Order and all its lines." },
        "placeholders": { "desc": "Type PO description here...", "globalSearch": "Global Smart Search..." },
        "footer": { "showing": "Showing" }
      },
      "mr": {
        "headers": { "mrList": "Material Requests" },
        "actions": { "targetStore": "Target Store", "chargeLoc": "Charge Loc", "chargeAsset": "Charge Asset", "chargeWO": "Charge WO", "newMR": "NEW MR", "clearFilters": "CLEAR FILTERS", "routeWf": "ROUTE WORKFLOW", "createUsage": "CREATE USAGE", "createUsageDesc": "Create Issue/Transfer Record", "createPR": "CREATE PR", "createPRDesc": "Create Purchase Request", "addMaterial": "Add Material" },
        "tabs": { "mr": "MR Info", "mrlines": "Request Lines" },
        "sections": { "general": "General Information", "financial": "Financial Summary", "mrItems": "Material Request Items", "financialCharging": "Financial Charging Details"  },
        "fields": { "mrNum": "MR Num", "requestedBy": "Requested By", "reqDate": "Required Date", "refMr": "Reference MR", "vendor": "Vendor", "glAccount": "GL Account" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Tax Total", "grandTotal": "Grand Total" },
        "tables": { "stockItem": "Stock Item", "qtyReq": "Qty Requested", "estUnitCost": "Est. Unit Cost", "mrNum": "MR Num", "description": "Description", "status": "Status", "totalCost": "Total Cost", "enteredDate": "Entered Date", "site": "Site", "itemNum": "Item #", "itemType": "Item Type", "qty": "Qty", "unitCost": "Unit Cost", "tax": "Tax", "lineTotal": "Line Total", "taxCat": "Tax Cat." },
        "messages": { "storeRequired": "Store is required!", "generateFail": "Failed to generate {{docType}}","generating": "Generating {{docType}}...", "generatedSuccess": "{{docType}} {{docnum}} generated successfully!", "loadFailed": "Failed to load Material Requests", "syncing": "Syncing Records...", "noData": "No data matches your search", "noLines": "No material lines added yet.", "fetchingMRLines": "Fetching lines for MR: {{mrnum}}...", "loadedMRLines": "Loaded {{count}} lines from MR", "noMRLines": "This MR has no lines", "failedMRLines": "Failed to load MR lines" },
        "swal": { "lockedTitle": "Locked", "cantDeleteStatus": "Cannot delete a record with status: {{status}}", "cantChangeCancel": "Cancelled requests cannot change status", "deleteWarnText": "This will permanently delete the Material Request and all its lines." },
        "placeholders": { "desc": "Type MR description here...", "globalSearch": "Global Smart Search...", "chooseLoc": "CHOOSE LOC", "selectAsset": "SELECT ASSET", "chargeWO": "CHARGE TO WO" },
        "footer": { "showing": "Showing", "totalRecords": "Total Records" },
        "lookups": {"storerooms": "Storerooms", "inventory": "Inventory Lookup", "locations": "Site Locations", "assets": "Asset Registry", "workorders": "Work Orders" },
      },
      "contract": {
        "headers": { "masterNode": "Contracts Master Node" },
        "placeholders": { "globalSearch": "Global Smart Search (Contract #, Vendor, Desc)...", "desc": "Enter contract summary...", "termDesc": "Write clause details..." },
        "actions": { "newContract": "NEW CONTRACT", "save": "SAVE CONTRACT", "addTerm": "ADD CLAUSE", "addLine": "APPEND LINE ITEM", "wfHistory": "Workflow Timeline" },
        "tabs": { "general": "General", "slaperformance": "SLA (Performance)", "termslegal": "Terms & Legal", "contractlines": "Contract Lines" },
        "sections": { "identity": "Contract Identity & Validity", "communication": "Communication Hub", "auditInfo": "Master Audit Info", "masterSLA": "Master SLA Link", "slaBenchmarks": "Service Level Benchmarks (SLA)", "termsList": "Contract Legal Clauses", "lines": "Scope of Work / Supply Line Items" },
        "options": { "supply": "Supply Contract", "labor": "Labor/Service Contract", "lease": "Lease Agreement", "allTypes": "ALL TYPES", "allStatus": "ALL STATUS", "general": "GENERAL", "payment": "PAYMENT", "termination": "TERMINATION", "warranty": "WARRANTY", "liability": "LIABILITY" },
        "fields": { "contractNum": "Contract Num", "vendorRef": "Vendor Reference", "startDate": "Commencement Date", "endDate": "Expiration Date", "contractValue": "Contract Value", "currency": "Currency Code", "contactPerson": "Contact Person", "vendorEmail": "Vendor Official Email", "slaRef": "SLA Template Reference", "respTime": "Response Time (Hrs)", "resTime": "Resolution Time (Hrs)", "uptime": "Availability Target (%)", "penalty": "Penalty Rate (Per Hr Over)", "grandTotal": "Calculated Contract Grand Total" },
        "tables": { "contractNum": "Contract #", "grandTotal": "Grand Total", "clauseType": "Clause Category", "clauseDesc": "Legal Condition Details", "lineDesc": "Service / Item Detailed Description", "rate": "Rate (Unit)", "lineTotal": "Computed Total" },
        "messages": { "fetchError": "Failed to sync contracts", "syncing": "Syncing Master Contract Records...", "noData": "No matching contracts found in database", "descMandatory": "Description is mandatory", "vendorSelected": "Vendor {{name}} Selected", "noTerms": "No Legal Clauses Defined for this Contract", "noLines": "No Scope Line Items Defined for this Contract Record", "slaHint": "Linking a master SLA applies its rules globally to any Work Order or PO created against this contract." },
        "swal": { "deleteTitle": "Final Deletion?", "deleteText": "This will erase the master contract and all its SLA/Lines permanently." },
        "footer": { "masterRecords": "Master Records:", "currentPage": "Current Node Page:" }
      },
      "rfq": {
        "headers": { "rfqList": "RFQs Management" },
        "tabs": { "rfq": "RFQ", "rfqlines": "RFQ Lines", "quotations": "Quotations" },
        "sections": { "general": "General Information", "financial": "Financial Summary" },
        "fields": { "requestedBy": "Requested By", "reqDate": "Required Date", "refPr": "Reference PR", "vendor": "Vendor", "vendorEmail": "Vendor Email", "glAccount": "GL Account" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Tax Total", "grandTotal": "Grand Total" },
        "tables": { "rfqNum": "RFQ Num", "totalCost": "Total Cost", "itemNum": "Item #", "itemType": "Item Type", "unitCost": "Unit Cost", "tax": "Tax", "taxCat": "Tax Cat." },
        "options": { "awarded": "AWARDED" },
        "actions": { "newRFQ": "NEW RFQ", "sendEmail": "SEND EMAIL", "wfHistory": "WF History", "award": "AWARD & CREATE PO" },
        "messages": { "loadFailed": "Failed to load RFQs", "syncing": "Syncing Records...", "noData": "No records found", "noLines": "No Scope Line Items Defined", "pullingPR": "Pulling lines from PR: {{prnum}}...", "prImported": "PR Lines imported!", "prFailed": "Failed to import PR lines", "noEmail": "Vendor email is missing!", "sending": "Sending Email...", "sendSuccess": "Email sent successfully!", "sendFailed": "Email failed", "quotesHint": "Incoming quotes from vendors will automatically appear here once their email reply is processed.", "noQuotes": "No quotations received yet.", "awarding": "Awarding Quote & Generating PO...", "awardSuccess": "Quotation Awarded Successfully!", "poCreated": "PO Generated", "awardFailed": "Failed to award quotation" },
        "swal": { "sendTitle": "Send RFQ?", "sendText": "Do you want to email this request to {{vendor}}?", "awardTitle": "Award Quotation?", "awardText": "This will mark the quote as winning and generate a Purchase Order automatically." },
        "footer": { "showing": "Showing" }
      },
      "itemList": {
        "headers": { "master": "Item Master" },
        "actions": { "newItem": "New Item" },
        "tables": { "item": "Item", "rotating": "Rotating?" },
        "messages": { "syncFailed": "Failed to sync with Master Data", "syncing": "Syncing Records...", "noData": "No items match these filters" },
        "footer": { "totalItems": "Total Items:", "page": "PAGE" }
      },
      "itemDetails": {
        "tabs": { "item": "ITEM", "inventory": "INVENTORY", "vendors": "VENDORS", "specs": "SPECS", "assembly": "ASSEMBLY" },
        "sections": { "config": "Item Configuration", "units": "Units & Tracking", "bomList": "BOM List", "supplierHistory": "Procurement & Supplier History" },
        "actions": { "save": "SAVE ITEM", "addStore": "ADD TO STORE", "newSpec": "NEW SPEC ROW", "addComponent": "ADD COMPONENT" },
        "fields": { "itemSet": "Item Set", "rotating": "Rotating? (Linked to Assets)", "lotControl": "Lot Control?", "inspectionReq": "Inspection Required?", "orderUnit": "Order Unit", "issueUnit": "Issue Unit", "condition": "Condition Enabled?", "sparepart": "Add as Spare Part?", "classification": "Classification" },
        "tables": { "store": "Store", "avgCost": "Avg Cost", "balance": "Balance", "attribute": "Attribute", "value": "Value", "uom": "UOM", "subItem": "Sub-Item", "remarks": "Remarks", "vendor": "Vendor (Comp Num)", "supplierName": "Supplier Name", "unitCost": "Unit Cost", "refPO": "Reference PO", "activeVendors": "ACTIVE VENDORS" },
        "messages": { "reqFields": "Item Number and Description are required!", "fetchingAttributes": "Fetching specification attributes...", "attributesLoaded": "Classification & Attributes Loaded", "failedAttributes": "Failed to load attributes", "stockMsgTitle": "STOCK MESSAGE", "stockMsgDesc": "Updating these units will impact all site storerooms.", "noInventory": "No inventory records for this item.", "noSpecs": "No specifications defined.", "noBom": "No Bill of Materials (BOM) defined.", "noVendors": "No Procurement Records Found" },
        "swal": { "deleteText": "You are about to delete Item {{num}}. This action cannot be undone!" }
      },
      "changePassword": {
        "title": "Change Password",
        "currentPwd": "Current Password",
        "newPwd": "New Password",
        "confirmPwd": "Confirm New Password",
        "securityTitle": "Security Verification",
        "googleAuthMsg": "Enter the 6-digit code from Google Authenticator to confirm this change.",
        "emailOtpMsg": "An OTP code was sent to your email.",
        "btnCancel": "Cancel",
        "btnUpdate": "Update Password",
        "btnVerify": "Verify & Change",
        "btnBack": "Go Back",
        "errMismatch": "New passwords do not match!",
        "errLength": "Password must be at least 6 characters long.",
        "msgVerifyReq": "Please verify your identity to continue.",
        "msgSuccess": "Password changed successfully!",
        "errFailed": "Failed to change password."
      },
      "userDetails": {
        "titleNew": "NEW USER",
        "titleEdit": "SECURITY / USERS",
        "btnSave": "SAVE USER",
        "saving": "SAVING...",
        "secIdent": "User Identification",
        "lblLoginId": "User Login ID",
        "lblFullName": "Full Name",
        "lblDisplayName": "Display Name",
        "lblEmail": "Email Address",
        "lblPassword": "Password",
        "lblActive": "Active Status",
        "secAccess": "Security & Access Control",
        "lblPrimaryRole": "Primary Security Role",
        "lblSecRoles": "Secondary Roles (Additional)",
        "lblDefOrg": "Default Organization",
        "lblDefSite": "Default Site",
        "secDelegation": "Work Delegation",
        "lblDelegateTo": "Delegate Work To",
        "lblStartDate": "Start Date & Time",
        "lblEndDate": "End Date & Time"
      },
      "receivingDetails": {
        "errLoadLines": "Failed to load PO lines",
        "errMissingDist": "Please specify Storeroom and Quantity for all lines",
        "errInspMandatory": "Inspection Decision is MANDATORY for this item",
        "errRejectExceeds": "Check rejected quantities (cannot exceed arrived qty)",
        "msgSuccess": "Transaction Processed Successfully!",
        "msgAutoClosed": "Automatically Closed: ",
        "swalAssignTitle": "Storeroom Assignment",
        "swalAssignText": "Item {{item}} is not currently assigned to {{loc}}. Assign it now and complete the receipt?",
        "swalAssignBtn": "Yes, Assign & Complete",
        "errUnexpected": "An unexpected error occurred during receipt",
        "hubTitle": "Bulk Receiving Hub",
        "poRef": "PO REFERENCE: ",
        "btnExecuting": "EXECUTING...",
        "btnConfirm": "CONFIRM RECEIPT",
        "tblItemsPending": "Items Pending Receipt",
        "colItemDetails": "Item Details",
        "colBalance": "Balance",
        "lblQualityCheck": "QUALITY CHECK REQUIRED",
        "lblUnits": "Units",
        "msgNoPending": "No pending items found",
        "lblLandedCost": "Landed Cost (Total Extra Charges)",
        "lblBaseCost": "Base PO Unit Cost",
        "lblStoreMatrix": "Store Distribution Matrix",
        "btnSplitStore": "Split Store",
        "colStoreroom": "Storeroom",
        "colArrived": "Arrived",
        "colRejected": "Rejected",
        "plcClickSearch": "Click Search ->",
        "lookupSelectStore": "Select Storeroom",
        "lblQcMatrix": "Quality Control Decision Matrix",
        "optSelectDecision": "-- Required: Select Decision --",
        "optPassed": "FULLY PASSED (ACCEPT ALL)",
        "optFailed": "FULLY REJECTED (RETURN TO VENDOR)",
        "optPartial": "PARTIAL ACCEPTANCE (CHECK REJECTED FIELD)",
        "lblInvValuation": "Inventory Valuation (Avg Unit Cost)",
        "lblNetArrived": "Net Stock Arrived",
        "msgSelectLine": "Select an active PO line to start processing"
      },
      "userList": {
        "title": "USER SECURITY",
        "plcSearch": "Search User or Email...",
        "btnNewUser": "NEW USER",
        "colUserId": "USER ID",
        "colFullName": "FULL NAME",
        "colRole": "ROLE",
        "colSite": "SITE",
        "colStatus": "STATUS",
        "colEmail": "EMAIL",
        "msgSyncing": "Synchronizing Security...",
        "lblNoRole": "NO ROLE",
        "lblAll": "ALL",
        "lblTotalUsers": "TOTAL USERS:",
        "lblPage": "PAGE",
        "errLoadUsers": "Error loading users"
      },
      "crafts": {
        "headers": {
          "craftList": "Craft Catalog"
        },
        "actions": {
          
        },
        "tables": {
          "craftCode": "Craft Code",
          "description": "Description",
          "stdRate": "Std Rate/Hour",
          "site": "Site",
          "org": "Organization"
        },
        "messages": {
          "loadFailed": "Failed to load Crafts"
        },
        "tabs": {
          "skills": "Craft Skills & Levels"
        },
        "sections": {
          "costing": "Costing",
          "control": "Control"
        },
        "fields": {
          "stdHourlyRate": "Standard Hourly Rate",
          "skillLevel": "Skill Level (e.g. Expert, Junior)",
          "hourlyRate": "Hourly Rate"
        },
        "placeholders": {
          "enterLevel": "ENTER LEVEL..."
        },
        "messages": {
          "autoCalc": "Calculated automatically from skills sum",
          "noSkills": "No skills defined yet"
        },
        "actions": {
          "newCraft": "New Craft",
          "addSkill": "Add Skill Level"
        }
      },
      "persons": {
        "headers": {
          "directory": "People Directory"
        },
        "actions": {
          "newPerson": "New Person", "addContact": "Add Contact"
        },
        "tables": {
          "personId": "Person ID",
          "name": "Display Name",
          "site": "Site",
          "email": "Email",
          "phone": "Phone"
        },
        "messages": {
          "loadFailed": "Failed to load People list"
        },
        "tabs": {
          "profile": "Profile Info",
          "contact": "Contact Directory",
          "access": "System Access"
        },
        "sections": {
          "personalInfo": "Personal Information",
          "statusControl": "Status & Control",
          "contactsDirectory": "Related Contacts"
        },
        "fields": {
          "location": "Location",
          "firstName": "First Name",
          "lastName": "Last Name",
          "title": "Job Title",
          "department": "Department",
          "currentStatus": "Current Status",
          "contactName": "Contact Name",
          "position": "Position",
          "email": "Email Address",
          "phone": "Phone",
          "mobile": "Mobile",
          "primary": "Primary",
          "address": "Address",
          "city": "City",
          "country": "Country",
        },
        "messages": {
          "noContacts": "No contacts added yet",
          "accessControlled": "System Access is controlled by the User Security Module"
        }
      },
      "jp": {
        "list": {
          "title": "Job Plans Directory",
          "new_plan": "NEW PLAN",
          "filter_jp": "Filter JP...",
          "search_desc": "Search description...",
          "filter_site": "Site...",
          "no_records": "No Job Plans found",
          "fetch_error": "Failed to load Job Plans"
        },
        "fields": {
          "jpnum": "Plan #",
          "description": "Description",
          "status": "Status",
          "revision": "Revision",
          "site": "Site"
        },
        "details": {
          "load_error": "Failed to load Job Plan",
          "delete_warn": "You are about to delete Jobplan {{jpnum}}. This action cannot be undone!"
        },
        "tabs": {
          "job_plan": "Job Plan",
          "plans": "Plans",
          "assets": "Assets"
        },
        "subtabs": {
          "tasks": "Tasks",
          "labor": "Labor",
          "materials": "Materials",
          "tools": "Tools"
        },
        "sections": {
          "details": "Plan Details",
          "responsibility": "Responsibility",
          "woassets": "Work Assets and Safety Plans"
        },
        "fields": {
          "jpnum": "Job Plan",
          "status": "Status",
          "description": "Description",
          "template_type": "Template Type",
          "duration": "Duration (Hrs)",
          "supervisor": "Supervisor",
          "class": "Class Structure",
          "safety_plan": "Safety Plan",
          "revision": "Revision"
        },
        "table": {
          "seq": "Seq",
          "duration": "Duration",
          "craft": "Craft",
          "labor": "Labor",
          "qty": "Qty",
          "hours": "Hours",
          "rate": "Rate",
          "item": "Item",
          "unitcost": "Unit Cost",
          "tool": "Tool"
        }
      },
      "meters": {
        "list": {
          "title": "Meter Definitions",
          "search": "Filter by Num or Name...",
          "new_meter": "NEW METER",
          "no_records": "No Meters Found"
        },
        "fields": {
          "meter_num": "Meter Num",
          "meter_name": "Meter Name",
          "type": "Type",
          "uom": "UOM"
        },
        "tabs": {
          "meter": "Meter Details",
          "where_used": "Where Used"
        },
        "sections": {
          "info": "Meter Information",
          "additional": "Additional Details",
          "stats": "Meter Statistics"
        },
        "fields": {
          "active": "Active?",
          "remarks": "Remarks / Notes",
          "last_reading": "LAST READING",
          "last_date": "LAST READING DATE",
          "rollovers": "TOTAL ROLLOVERS"
        },
        "where_used": {
          "linked_assets": "Linked Assets",
          "linked_locations": "Linked Locations",
          "linked_items": "Linked Items",
          "searching": "🔍 Searching across the system...",
          "no_assoc": "No associations found in this category.",
          "asset_num": "Asset Num",
          "site": "Site",
          "status": "Status",
          "location": "Location",
          "item_num": "Item Num",
          "category": "Category"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Asset Categories",
          "search": "Search Categories...",
          "new_category": "NEW CATEGORY",
          "no_records": "No Categories Found"
        },
        "fields": {
          "category_id": "Category Code",
          "description": "Description",
          "dep_method": "Dep. Method",
          "life": "Life (Yrs)"
        }
      },
      "export": {
        "loading": "Extracting data...",
        "success": "Exported successfully!",
        "error": "Error exporting data."
      },
      "labor": {
        "list": {
          "title": "Labor Registry",
          "new": "NEW LABOR",
          "total": "Total Labor",
          "unique_crafts": "Page Unique Crafts",
          "no_records": "No labor records found matching your search."
        },
        "tabs": {
          "main": "MAIN",
          "person": "PERSON",
          "crafts": "CRAFTS",
          "log": "LOG"
        },
        "sections": {
          "basic": "Basic Information",
          "status": "Status & Organization",
          "additional_crafts": "Additional Crafts & Specialized Skills"
        },
        "fields": {
          "personid": "Person Reference",
          "primary_craft": "Primary Craft",
          "actual_rate": "Actual Rate (Hourly)",
          "skill": "Skill Level",
          "rate": "Hourly Rate",
          "primary": "Primary?",
          "laborcode": "Labor Code",
          "fullname": "Full Name",
          "craft": "Craft / Trade"
        },
        "actions": {
          "add_craft": "ADD CRAFT LINE"
        },
        "lookup": {
          "person": "Select Person",
          "craft": "Select Craft",
          "skill": "Select Skill Level"
        },
        "messages": {
          "no_crafts": "No Craft Associations Found"
        },
        "details": {
          "delete_warn": "You will not be able to recover this record!"
        }
      },
      "sr": {
        "list": {
          "title": "Service Request Tracking",
          "new": "NEW REQUEST"
        },
        "messages": {
          "no_records": "No service requests found"
        },
        "tabs": {
          "main": "Service Request",
          "related": "Related Records"
        },
        "sections": {
          "requester": "Requester & Contact",
          "problem": "Problem Specifications",
          "logistics": "Logistics & Priority"
        },
        "fields": {
          "srnum": "SR Number",
          "description": "Description",
          "reportedby": "Reported By",
          "reportdate": "Report Date",
          "priority": "Priority",        
          "phone": "Phone",
          "email": "Email",
          "asset": "Asset",
          "location": "Location",
          "long_desc": "Problem Long Description",
          "priority_1": "1 - EMERGENCY (IMMEDIATE)",
          "priority_2": "2 - HIGH (SAME DAY)",
          "priority_3": "3 - MEDIUM (72 HOURS)",
          "priority_4": "4 - LOW (PLANNED)"
        },
        "lookup": {
          "person": "Select Person",
          "asset": "Select Asset",
          "location": "Select Location"
        },
        "details": {
          "delete_new_only": "Only NEW requests can be deleted",
          "delete_warn": "This will permanently delete this Service Request.",
          "wf_tip": "Automated Workflow: After saving, use the 'Route Workflow' button to send this request for technical review.",
          "wo_tip": "Tip: You can generate a Work Order from this SR via the Workflow actions or the 'Create WO' automated script."
        },
        "related": {
          "title": "Linked Work Orders for SR:",
          "wonum": "WO Number",
          "worktype": "Work Type",
          "no_wo": "No Work Orders have been created for this SR yet.",
          "go_to_wo": "Go to Work Order"
        }
      },
      "invusage": {
        "list": {
          "title": "Inventory Usage History",
          "new": "Create New Transaction"
        },
        "types": {
          "all": "ALL",
          "issue": "ISSUE",
          "transfer": "TRANSFER",
          "return": "RETURN"
        },
        "tabs": {
          "lines": "USAGE LINES",
          "log": "TRANSACTION LOG"
        },
        "details": {
          "summary": "Lines Summary",
          "transfer_dest": "Transfer Destination Details",
          "financial": "Financial Charging & Reference"
        },
        "actions": {
          "add_item": "Add Item",
          "add_part": "Add Part",
          "select_mr": "SELECT MR"
        },
        "fields": {
          "usagenum": "Usage ID",
          "type": "Type",
          "fromstore": "From Store",
          "lines": "Lines",
          "enterby": "Entered By",
          "stock_item": "Stock Item",
          "issueunit": "Issue Unit",
          "qty": "Quantity",
          "unitcost": "Unit Cost",
          "linecost": "Total Line Value",
          "target_bin": "Target Bin in",
          "target_loc": "Target Loc",
          "assetnum": "Asset Number",
          "wonum": "Work Order Reference",
          "glaccount": "Debit GL Account"
        },
        "placeholders": {
          "select_item": "SELECT ITEM...",
          "dest_bin": "ENTER DESTINATION BIN...",
          "choose_loc": "CHOOSE LOCATION",
          "select_asset": "SELECT ASSET",
          "charge_wo": "CHARGE TO WO"
        },
        "lookup": {
          "store": "Storerooms",
          "dest_store": "Destination Stores",
          "mr": "Select Approved MR",
          "item": "Inventory Lookup",
          "loc": "Site Locations",
          "asset": "Asset Registry",
          "wo": "Work Orders"
        },
        "messages": {
          "req_fromstore": "Please select a Storeroom first!",
          "mr_loaded": "Loaded items from MR:",
          "mr_fail": "Failed to load MR items",
          "insufficient_title": "Insufficient Stock!",
          "available": "Available",
          "create_pr": "Create PR?",
          "btn_create_pr": "Create PR",
          "processing": "Processing Inventory Adjustments...",
          "inventory_updated": "Inventory levels updated successfully",
          "cant_delete_comp": "Cannot delete a completed transaction!",
          "delete_warn": "This will permanently delete the draft transaction.",
          "req_fields": "Description and Storeroom are required!",
          "req_transfer": "To Store is required for transfers!",
          "locked_title": "Record Locked",
          "locked_text": "This transaction is COMPLETED and cannot be modified or reversed.",
          "cant_save_comp": "Cannot save changes to a completed record",
          "balance_move": "Note: Balance will be moved to",
          "upon_comp": "upon completion."
        }
      },
      "downtime": {
        "title": "Report Asset Downtime",
        "subtitle": "Asset Management System",
        "asset": "Asset",
        "status": "Offline Recording",
        "start": "Start Date & Time",
        "end": "End Date (Optional)",
        "type": "Downtime Type",
        "types": {
          "unplanned": "UNPLANNED (Breakdown)",
          "planned": "PLANNED (Maintenance)"
        },
        "duration": "Calculated Duration",
        "hours": "HOURS",
        "prod_impact": "Operational Downtime (Production Impact)",
        "btn_commit": "Commit Changes",
        "messages": {
          "recording": "Recording downtime...",
          "success": "Downtime recorded successfully",
          "validation_error": "Format Error: Check all fields",
          "server_error": "Server Error: 500"
        },
        "history": {
          "title": "Asset Downtime History",
          "subtitle": "Tracking Performance for Asset",
          "no_records": "No downtime events recorded for this asset.",
          "duration_hrs": "Duration (Hrs)",
          "type_reason": "Type/Reason",
          "impact": "Impact",
          "reported_by": "Reported By",
          "still_down": "STILL DOWN",
          "prod_loss": "Prod. Loss",
          "technical": "Technical",
          "active_down": "Active Downtime",
          "resolved": "Resolved"
        }
      },
      "incidents": {
        "list": {
          "title": "Incidents Registry",
          "new": "NEW INCIDENT"
        },
        "fields": {
          "ticket_id": "Ticket ID",
          "priority": "Priority",
          "reported_by": "Reported By"
        },
        "details": {
          "ticket": "Incident Ticket",
          "general": "General Description",
          "detailed": "Detailed Details",
          "context": "Context & Status",
          "linked_asset": "Linked Asset",
          "workorder": "Workorder",
          "delete_warn": "You are about to permanently delete Incident {{ticket}}. This action cannot be undone!"
        },
        "lookup": {
          "asset": "Select Linked Asset",
          "loc": "Select Location"
        }
      },
      "tools": {
        "list": {
          "title": "Tool Master",
          "new": "NEW TOOL"
        },
        "fields": {
          "toolnum": "Tool Number",
          "type": "Type",
          "is_stocked": "Is Stocked?"
        },
        "tabs": {
          "tool": "TOOL",
          "stores": "STORES",
          "vendors": "VENDORS",
          "specs": "SPECS",
          "quals": "QUALS"
        },
        "sections": {
          "config": "Tool Configuration",
          "inventory": "Inventory & Stock Balances",
          "vendors": "PROCUREMENT & SUPPLIER HISTORY",
          "quals": "Required Qualifications"
        },
        "fields": {
          "toolnum": "Tool Number",
          "type": "Tool Type",
          "issueunit": "Issue Unit",
          "is_stocked": "Is Stocked Tool?",
          "rotating": "Rotating Item?",
          "calib_req": "Calibration Required?",
          "mfg": "Manufacturer",
          "model": "Model Num",
          "class": "Classification",
          "active_vendors": "ACTIVE VENDORS"
        },
        "actions": {
          "add_store": "Add to Storeroom",
          "add_qual": "Add Qualification"
        },
        "tables": {
          "storeroom": "Storeroom",
          "balance": "Balance",
          "attr": "Attribute",
          "value": "Value",
          "uom": "UOM",
          "qual": "Qualification",
          "vendor_id": "Vendor (Comp Num)",
          "vendor_name": "Supplier Name",
          "unitcost": "Unit Cost",
          "qty": "Qty",
          "po": "Reference PO"
        },
        "placeholders": {
          "toolid": "ENTER TOOL ID...",
          "reg_supplier": "REGISTERED SUPPLIER",
          "adj": "STOCK ADJ"
        },
        "lookup": {
          "type": "Tool Type",
          "unit": "Issue Units",
          "attr": "Attributes"
        },
        "messages": {
          "req_fields": "Tool Number and Description are required!",
          "delete_warn": "You won't be able to revert this!",
          "class_loaded": "Classification & Attributes Loaded",
          "stocked_note": "Note: Stocked tools are managed through storerooms and require an inventory record to track balances.",
          "no_stock": "No items in stock"
        }
      },
      "inventory": {
        "list": {
          "title": "Inventory Registry"
        },
        "fields": {
          "itemnum": "Item #",
          "location": "Storeroom",
          "balance": "Balance",
          "avgcost": "Avg Cost"
        },
        "details": {
          "profile": "Inventory Profile",
          "reorder_logic": "Reorder Logic",
          "reorder_pt": "Reorder Point",
          "eoq": "Economic Order Qty",
          "critical_lvl": "Critical Level",
          "critical_desc": "Auto-generate PR when balance hits reorder point.",
          "current_stock": "Current Stock Level",
          "avail_qty": "Available Quantity",
          "reserved_qty": "Reserved Qty",
          "held_wo": "Held for Work Orders",
          "avg_cost": "Average Unit Cost",
          "avg_cost_desc": "Weighted average of all receipts",
          "total_val": "Total Stock Value",
          "total_val_desc": "Current Balance × Avg Cost",
          "last_cost": "Last Receipt Cost",
          "last_cost_desc": "Cost from the most recent PO",
          "val_method": "Inventory Valuation Method",
          "avg_method": "AVERAGE COSTING",
          "val_desc1": "This item uses the",
          "val_desc2": "method. the unit cost is recalculated automatically upon every purchase order receipt to reflect market price fluctuations."
        },
        "tabs": {
          "balances": "Balances",
          "trans": "Transaction History",
          "costs": "Costs"
        },
        "actions": {
          "adjustment": "Stock Adjustment"
        },
        "tables": {
          "qty": "Quantity",
          "actual_cost": "Actual Cost",
          "reference": "Reference"
        },
        "messages": {
          "no_trans": "No Transaction History Found"
        },
        "trans_types": {
          "receipt": "RECEIPT",
          "issue": "ISSUE",
          "transfer": "TRANSFER",
          "adjustment": "ADJUSTMENT"
        }
      },
      "storerooms": {
        "list": {
          "title": "Storerooms",
          "new": "NEW STOREROOM"
        },
        "fields": {
          "location": "Storeroom",
          "isdefault": "Is Default?",
          "inventory": "Inventory",
        },
        "details": {
          "profile": "Storeroom",
          "record": "Storeroom Record",
          "gen_settings": "General Settings",
          "filtered_by": "Filtered by {{org}}",
          "select_org_first": "Select Org first",
          "gl_accounts": "GL Accounts",
          "inv_control": "Inventory Control",
          "inv_control_desc": "All material issues and receipts for this storeroom will be balanced against these accounts.",
          "items_stocked": "Items Stocked"
        },
        "tabs": {
          "main": "MAIN",
          "inventory": "INVENTORY"
        },
        "fields": {
          "location": "Location ID",
          "isdefault": "Default Storeroom?",
          "useinpo": "Use in PO?",
          "invowner": "Inventory Owner",
          "controlacc": "Control Account",
          "shrinkacc": "Shrinkage Account",
          "glaccount": "Default GL Account",
          "default": "DEFAULT"
        },
        "lookup": {
          "person": "Select Person"
        },
        "tables": {
          "itemnum": "Item Num",
          "uom": "UOM",
          "curbal": "Current Bal",
          "reserved": "Reserved Qty"
        },
        "messages": {
          "req_fields": "Location ID is required!",
          "req_org_site": "Org and Site are required!",
          "delete_warn": "You are about to delete Storeroom {{store}}. This action cannot be undone!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Failure Codes Library",
          "new": "New Failure Class"
        },
        "details": {
          "profile": "Failure Class"
        },
        "fields": {
          "class": "Failure Class",
          "code": "Code",
          "desc_tech": "Description / Technical Name"
        },
        "tables": {
          "problems": "Problems (The Issue)",
          "causes": "Causes (Root Reason)",
          "remedies": "Remedies (The Action)"
        },
        "placeholders": {
          "class": "E.G. PUMP-FAIL",
          "desc_tech": "Provide a detailed description of this failure hierarchy...",
          "code": "Enter Code...",
          "desc": "Technical Description..."
        },
        "messages": {
          "req_class": "Failure Class Code is required!",
          "delete_warn": "You are about to delete Failure Class {{class}}. This action cannot be undone!"
        }
      },
      "sla": {
        "list": {
          "title": "SERVICE LEVEL AGREEMENTS (SLA)",
          "new": "CREATE NEW SLA"
        },
        "header": {
          "slanum": "SLA Number",
          "ranking": "Ranking"
        }
      },
      "scheduler": {
        "title": "Dispatching & Scheduling",
        "ai_optimize": "AI AUTO-OPTIMIZE",
        "publish": "PUBLISH SCHEDULE",
        "kpi_scheduled": "Scheduled Work",
        "kpi_issues": "Scheduling Issues",
        "kpi_utilization": "Total Resources",
        "kpi_emergencies": "Emergencies",
        "no_data": "No Scheduled Work Orders",
        "no_resources": "No resource capacity data.",
        "fetch_error": "Failed to load scheduling data.",
        "optimizing": "AI is leveling resource load...",
        "optimize_fail": "AI Optimization failed."
      },
      "features": {
        "title": "Linear Feature Catalog",
        "feature_id": "Feature Code",
        "description": "Description",
        "type": "Feature Type",
        "point": "Point (e.g. Valve)",
        "linear": "Linear Segment (e.g. Material)",
        "error_in_use": "Cannot delete: Feature is in use on an active pipeline."
      },
      "audit": {
        "title": "Audit Trail Explorer",
        "history_for": "History for",
        "retrieving": "Retrieving Audit Records...",
        "no_records": "No audit trails found for this record"
      },

    }
  },
  ar: {
    translation: {
      "welcome": "مرحباً بك",
      "go_to_app": "اذهب إلى التطبيق",
      "dashboard_title": "تقارير الأداء العام",
      "assets": "الأصول",
      "work_orders": "أوامر العمل",
      "username": "معرف المستخدم",
      "password": "كلمة المرور",
      "login_btn": "تسجيل الدخول",
      "forgot_pwd": "نسيت كلمة المرور؟",
      "vendors_title": "سجل الموردين",
      "new_vendor": "مورد جديد",
      "search_placeholder": "بحث بالمعرف، الاسم أو الضريبي...",
      "comp_id": "معرف الشركة",
      "comp_name": "اسم الشركة",
      "type": "النوع",
      "currency": "العملة",
      brand: { name: "تيكنورا EAM", tagline: "امتياز الأصول", version: "تيكنورا v1.0.4" },
      search: { placeholder: "البحث في الوحدات..." },
      menu: {
        settings: "الإعدادات", organization: "المؤسسات", domains: "النطاقات", field_config: "إعدادات الحقول", classifications: "التصنيفات", importer: "المستورد العالمي", cobie: "مدير COBie", workflow: "محرك المهام", scripts: "سكربتات الإجراءات",
        analytics: "التحليلات", dashboards: "لوحات الأداء", report_designer: "مصمم التقارير", report_wizard: "معالج التقارير",
        assets: "الأصول", asset_registry: "سجل الأصول", locations: "المواقع", categories: "فئات الأصول", meters: "العدادات", failure_codes: "أكواد الأعطال",
        work_management: "إدارة العمل", wo_tracking: "تتبع أوامر العمل", labor_reporting: "الجدولة",
        resources: "الموارد", crafts: "الحرف", labor: "العمالة", person: "الأشخاص",
        service_desk: "مكتب الخدمة", service_requests: "طلبات الخدمة", incidents: "سجل الحوادث",
        procurement: "المشتريات", po: "أوامر الشراء", pr: "طلبات الشراء", rfq: "طلب عروض أسعار", receiving: "الاستلام", vendors: "الموردين",
        contracts: "العقود", contracts_master: "سجل العقود", sla: "اتفاقية مستوى الخدمة",
        inventory: "المخزون", item_master: "سجل الأصناف", tools: "الأدوات", balances: "أرصدة المخزون", transfers: "الصرف والتحويل", storerooms: "المخازن",
        planning: "التخطيط", pm_schedules: "جداول الصيانة الوقائية", safety_plans: "خطط السلامة", hazards: "المخاطر", precautions: "الاحتياطات", tagouts: "بطاقات العزل", job_plans: "خطط العمل",
        security: "الأمن", user_list: "قائمة المستخدمين", groups: "مجموعات الصلاحيات", "recent": "مؤخراً"
      },
      user_settings: { title: "إعدادات المستخدم", default_info: "المعلومات الافتراضية", personal_info: "المعلومات الشخصية", password_info: "معلومات كلمة المرور", sign_out: "تسجيل الخروج", system_info: "معلومات النظام" },
      notifications: { title: "المهام الواردة", new_alerts: "جديد", empty: "صندوق الوارد فارغ", view_all: "عرض جميع الأنشطة" },
      sidebar: { 
        queries: "الاستعلامات المتاحة", all_assets: "جميع الأصول", operating_assets: "الأصول التشغيلية", critical_assets: "الأصول الحرجة", my_bookmarks: "إشاراتي المرجعية", common_actions: "إجراءات عامة", new: "جديد", move_assets: "نقل الأصول", print_barcodes: "طباعة الباركود", create_report: "إنشاء تقرير", wo_queries: "استعلامات أوامر العمل", all_wo: "جميع الأوامر", waiting_approval: "بانتظار الاعتماد", wip: "قيد التنفيذ", completed_today: "أنجزت اليوم", bulk_approve: "اعتماد جماعي", record_actions: "إجراءات السجل", save: "حفظ", delete: "حذف", workflow_status: "سير العمل / الحالة", change_status: "تغيير الحالة", view_history: "عرض السجل", item_ops: "عمليات الصنف", add_to_storeroom: "إضافة للمخزن", inv_ops: "عمليات المخزون", reorder: "إعادة طلب", tax_ops: "عمليات الضريبة", tax_category: "فئة الضريبة", create_po: "إنشاء أمر شراء", settings_group: "الإعدادات", system_settings: "إعدادات النظام", email_settings: "إعدادات البريد", asset_ops: "عمليات الأصول", meter_readings: "قراءات العدادات", hist_readings: "القراءات التاريخية", report_downtime: "تبليغ توقف", downtime_hist: "سجل التوقفات", move_mod_asset: "نقل/تعديل أصل", asset_move_hist: "سجل نقل الأصول", create_related: "إنشاء مرتبط", create_incident: "إنشاء حادثة", view_inc_hist: "سجل الحوادث", create_wo: "إنشاء أمر عمل", sr: "طلب خدمة", apply_sla: "تطبيق اتفاقية SLA", approve_wo: "اعتماد الأمر", start_work: "بدء العمل", complete_work: "إكمال العمل", close_wo: "إغلاق الأمر", analytics: "عرض وتحليل", wf_history: "سجل سير العمل", history_log: "سجل العمليات", wo_costs: "تكاليف الأمر", purchase_info: "معلومات الشراء", all_records: "جميع السجلات", find_nav: "البحث في القائمة", more_actions: "إجراءات إضافية", settings: "الإعدادات", export_data: "تصدير البيانات", audit_log: "سجل المراجعة", share_app: "مشاركة التطبيق"
      }, "Receiving": "الاستلام",
      apps: {
        ORGANIZATION: "المؤسسات", ASSET: "الأصول", LOCATION: "المواقع", WORKORDER: "أوامر العمل", INVENTORY: "المخزون", CLASSIFICATION: "التصنيفات", VENDOR: "الموردين", METER: "العدادات", DOMAINS: "النطاقات", CRAFTS: "الحرف", STOREROOMS: "المخازن", ITEMS: "سجل الأصناف", INVENTORYUSAGE: "حركة المخزون", MR: "طلبات المواد", PR: "طلبات الشراء", PO: "أوامر الشراء", LABOR: "العمالة", PM: "الصيانة الوقائية", SAFETY: "خطط السلامة", HAZARD: "المخاطر", TAGOUT: "بطاقات العزل", PRECUTION: "الاحتياطات", SR: "طلبات الخدمة", INCIDENT: "الحوادث", ASSET_CATEGORIES: "فئات الأصول", FAILURECLASS: "أكواد الأعطال", RFQ: "طلبات العروض", CONTRACT: "العقود", SLA: "اتفاقية مستوى الخدمة", FAILURE_CODES: "أكواد الأعطال", REPORTLIST: "تقارير",
        "TAGOUTS": "بطاقات العزل", "JOB_PLAN": "خطط العمل", "USER": "المستخدمين", "ROLE": "الصلاحيات (الأدوار)", "TOOLS": "الأدوات", "PRECAUTIONS": "الاحتياطات", "RECEIVING": "الاستلام", "USER": "المستخدمين", "INCIDENTS": "الحوادث"
      },
      dashboard: { tab_bi: "لوحة مؤشرات الأداء", tab_inbox: "صندوق مهام سير العمل", advanced_analytics: "التحليلات المتقدمة (أباتشي سوبرسيت)", workflow_center: "مركز تنفيذ سير العمل", active_tasks: "المهام النشطة", history_tasks: "سجل المهام", no_data: "لم يتم العثور على بيانات في هذا القسم", take_action: "اتخاذ إجراء", previous: "السابق", next: "التالي", showing: "عرض", of: "من", actual: "الفعلي", target: "المستهدف", kpi_graph: "رسم بياني KPI" },
        login: {
        id_placeholder: "أدخل المعرف الخاص بك",
        error_msg: "خطأ في اسم المستخدم أو كلمة السر",
        server_error: "فشل الاتصال بالسيرفر",
        just_smart: "ذكاء في الإدارة"
      },
      organizations: { title: "المؤسسات", org_id: "المؤسسة", description: "الوصف", active: "نشط؟" },
      org_detail: {
        org_label: "المؤسسة", tabs: { organization: "المؤسسة", sites: "المواقع", map: "خريطة الموقع" },
        fields: { currency1: "العملة الأساسية 1", currency2: "العملة الأساسية 2", item_set: "مجموعة الأصناف", company_set: "مجموعة الشركات", item_status: "حالة الصنف الافتراضية", active: "نشط؟" },
        descs: { currency1: "العملة الرئيسية", currency2: "العملة الثانوية", item_set: "مجموعة الأصناف", company_set: "مجموعة الشركات" },
        lookups: { currency: "العملات", item_set: "مجموعات الأصناف", company_set: "مجموعات الشركات", status: "الحالات", governorate: "المحافظات" },
        sites: { management: "إدارة المواقع", new_row: "صف جديد", of: "من", site_id: "الموقع", description: "الوصف", active: "نشط؟", action: "إجراء", site_details: "تفاصيل الموقع", state: "الولاية / المحافظة", contact: "المسؤول الرئيسي", fin_info: "المعلومات المالية / الميزانية", yearly_budget: "الميزانية السنوية", monthly_budget: "الميزانية الشهرية", utilization: "استهلاك العام الحالي", fin_health: "الوضع المالي مستقر لهذا الموقع." },
        toasts: { id_required: "معرف المؤسسة مطلوب!", saving: "جاري حفظ التغييرات...", success: "تم حفظ المؤسسة والمواقع بنجاح!", fail: "فشل الحفظ" }
      },
      domains: { title: "النطاقات", find_placeholder: "ابحث عن نطاق...", new_domain: "نطاق جديد", domain_id: "النطاق", description: "الوصف", type: "النوع", values: "القيم" ,
        save_btn: "حفظ النطاق", desc_placeholder: "وصف النطاق", synonym_values: "قيم المرادفات", new_row: "صف جديد",
        internal_val: "القيمة الداخلية (Value)", external_desc: "الوصف الخارجي (Description)", default: "افتراضي؟", action: "إجراء",
        no_values: "لا توجد قيم محددة لهذا النطاق. اضغط على 'صف جديد' للإضافة.",
        toasts: { loading: "جاري تحميل بيانات النطاق...", load_fail: "فشل تحميل البيانات", id_required: "معرف النطاق مطلوب!", saving: "جاري حفظ النطاق...", save_success: "تم الحفظ بنجاح!", save_fail: "فشل الحفظ" }
      },
      classifications: { parent: "التصنيف الأب", order: "الترتيب", hierarchy: "هيكل التصنيف", hierarchy: "الهيكل الشجري", parent: "التصنيف الأب", order: "الترتيب", gen_desc: "توليد الوصف تلقائياً؟", upload_img: "تحميل صورة", 
        use_with: "يستخدم مع كائنات", obj_name: "اسم الكائن", top_level: "مستوى علوي؟", attributes: "خصائص التصنيف", attr_id: "معرف الخاصية", section: "القسم", uom: "وحدة القياس",
        lookups: { select_parent: "اختر التصنيف الأب", select_attr: "اختر الخاصية", select_type: "اختر نوع البيانات", select_domain: "اختر النطاق", select_uom: "اختر الوحدة" }
      },
      bim: {
        title: "مدمج نماذج البناء (BIM)", subtitle: "ربط متقدم لنماذج Revit مع بيانات COBie",
        waiting_translation: "بانتظار معالجة النموذج...",
        tabs: { "3d": "عرض ثلاثي الأبعاد", data: "جدول البيانات" },
        preview_table_title: "معاينة مكونات COBie",
        controls: { destination: "الوجهة", select_site: "اختر الموقع", uploads: "تحميل الملفات", select_cobie: "اختر ملف COBie", upload_revit: "تحميل ملفات Revit", models_ready: "نماذج جاهزة", preview_list: "نماذج المعاينة", finalizing: "جاري المزامنة النهائية...", commit: "اعتماد دمج BIM" },
        table: { asset_name: "اسم الأصل", location: "المكان / المساحة" },
        toasts: { load_org_fail: "فشل تحميل المؤسسات", analyzing_excel: "جاري تحليل بيانات الجدول...", excel_ready: "معاينة الإكسل جاهزة", preview_fail: "فشل المعاينة", uploading: "جاري رفع", models: "نماذج", models_ready: "النماذج جاهزة للمعاينة", upload_fail: "فشل الرفع", select_required: "يجب اختيار الموقع وملف COBie", finalizing_sync: "المزامنة النهائية: ربط الأصول بالنماذج...", integration_success: "تم دمج BIM-COBie بنجاح!", import_fail: "فشل الاستيراد", upload_first: "قم برفع ملف COBie لمعاينة الأصول..." }
      },
      importer: {
        title: "محمل البيانات العالمي", target_table: "الجدول المستهدف", download_template: "تحميل النموذج", 
        upload_instruction: "اختر ملف إكسل للرفع", field_mapping: "مطابقة الحقول", excel: "إكسل", ignore: "تجاهل",
        preview_title: "معاينة (أول 10 صفوف)", execute_btn: "بدء عملية الاستيراد الآن",
        toasts: { template_downloaded: "تم تحميل النموذج!", template_fail: "فشل تحميل النموذج", analyzing: "جاري تحليل الملف...", preview_ready: "المعاينة جاهزة", upload_fail: "فشل رفع الملف", no_file: "يرجى اختيار ملف أولاً", processing: "جاري معالجة الاستيراد الرئيسي...", import_complete: "تمت عملية الاستيراد بنجاح!", import_fail: "فشل الاستيراد" }
      },
      workflow: {
        title: "محرك المهام", subtitle: "مركز التحكم في الأتمتة", export_btn: "تصدير CSV", new_process: "مسار جديد", loading: "جاري تحميل العمليات...", unnamed: "عملية بدون اسم", no_desc: "لا يوجد وصف متوفر.", linked_to: "مرتبط بـ", create_path: "إنشاء مسار جديد",
        table: { id: "المعرف", name: "اسم العملية", app: "التطبيق", status: "الحالة", created: "تاريخ الإنشاء" },
        tooltips: { edit: "تعديل المنطق", settings: "الإعدادات العامة", delete: "حذف العملية" },
        toasts: { fetch_fail: "فشل جلب العمليات", no_data: "لا توجد بيانات للتصدير" },
        designer_title: "مصمم منطق سير العمل (Loopback مفعل)", publish_btn: "نشر العملية", loading_designer: "إعادة بناء مسار المنطق...", logic_palette: "لوحة المنطق", config_title: "الإعدادات", node_label: "التسمية", assign_roles: "تعيين الأدوار", post_action: "سكريبتات ما بعد الإجراء", select_lookup: "اختر من القائمة", script_hint: "* يمكن الفصل بين السكريبتات بفاصلة.", status_auto: "تغيير الحالة تلقائياً", trigger: "المشغل", target_status: "الحالة المستهدفة", cond_expr: "تعبير الشرط (بايثون)", escalation: "التصعيد (بالساعات)", select_node: "اختر عقدة لتعديلها",
        options: { no_change: "بدون تغيير الحالة", change_status: "تغيير الحالة", select_status: "اختر الحالة" },
        lookups: { select_roles: "بحث في الأدوار", select_scripts: "بحث في السكريبتات" },
        swal: { publish_title: "نشر سير العمل؟", publish_text: "سيتم مزامنة خطوات المحرك مع قاعدة البيانات.", confirm_publish: "نعم، انشر الآن", delete_title: "حذف المنطق؟", delete_text: "هل أنت متأكد من حذف", confirm_delete: "نعم، احذف كل شيء" },
        toasts: { id_required: "يرجى إدخال اسم العملية", saving: "جاري المزامنة...", save_success: "تمت المزامنة بنجاح! 🚀", save_fail: "فشلت المزامنة", purging: "جاري الحذف...", delete_success: "تم الحذف نهائياً", delete_fail: "فشل الحذف" }
      },
      field_config: { title: "إعدادات الربط الديناميكي للميتا", table_name: "اسم الجدول", field_name: "اسم الحقل (Backend)", current_mappings: "الارتباطات الحالية لجدول:", field: "الحقل", linked_domain: "النطاق المرتبط" },
      scripts: {
        title: "سكريبتات الإجراءات", subtitle: "إدارة قوالب الأتمتة والمنطق", new_btn: "إنشاء سكريبت جديد", search_placeholder: "ابحث بالاسم أو الكائن المستهدف...",
        table: { name: "اسم السكريبت", object: "الكائن المستهدف", created: "تاريخ الإنشاء" },
        toasts: { fetch_fail: "فشل تحميل السكريبتات" }
      },
      studio: {
        schema_explorer: "مستكشف النماذج", target_context: "سياق الكائن المستهدف", name_placeholder: "أعطِ السكريبت اسماً...", engine_info: "المحرك: بايثون 3.10 / CPYTHON", console_title: "كونسول تنفيذ النظام", clear_console: "مسح الكونسول", field_from: "حقل من", access_col: "الوصول لعمود قاعدة البيانات: ", db_model: "نموذج قاعدة بيانات",
        btns: { compile: "تحليل الكود", compiling: "جاري التحليل...", save_deploy: "حفظ ونشر" },
        toasts: { preserved: "تم حفظ السكريبت ونشره!", compiled: "تم التحليل بنجاح!" },
        console: { init: "تم تشغيل الاستوديو. جاري مزامنة النماذج...", schema_sync: "تمت مزامنة قاموس النماذج بنجاح.", schema_fail: "فشلت مزامنة القاموس.", saved_prefix: "تم حفظ السكريبت", error_op: "حدث خطأ أثناء عملية الحفظ.", compiling: "بدء التحليل والتحقق من القواعد...", build_finish: "انتهى البناء: 0 أخطاء، 0 تحذيرات.", syntax_error: "تم اكتشاف خطأ في القواعد.", build_fail: "فشل البناء", analyzing: "جاري تنفيذ تحليل القواعد..." }
      },
      reports: {
        title: "قوالب التقارير", new_btn: "إنشاء تقرير جديد", search_placeholder: "البحث عن التقارير...",
        table: { name: "اسم التقرير", ref_obj: "الكائن المرجعي", updated: "آخر تحديث" },
        swal: { delete_title: "هل أنت متأكد من حذف قالب التقرير؟", delete_text: "لن تتمكن من استعادة هذا القالب بعد الحذف.", confirm_delete: "نعم، احذفه" },
        toasts: { load_fail: "فشل تحميل التقارير", clone_success: "تم استنساخ التقرير بنجاح", clone_fail: "فشل الاستنساخ", delete_success: "تم حذف القالب بنجاح", delete_fail: "فشل حذف القالب", save_success: "تم حفظ المنظومة بنجاح", save_fail: "خطأ في عملية الحفظ" },
        designer: {
          title: "محرك التقارير الاحترافي", live_preview: "معاينة مباشرة", publish: "نشر القالب", model_select: "اختيار النموذج", data_explorer: "مستكشف البيانات", components: "المكونات", page_break: "فاصل صفحة", is_summary: "تقرير ملخص؟", user_params: "باراميترز المستخدم", add_param: "إضافة حقل إدخال", master_info: "المعلومات الرئيسية", relational_data: "البيانات المرتبطة", detail_tables: "جداول التفاصيل",
          tabs: { body: "محتوى التقرير", header: "رأس الصفحة", footer: "تذييل الصفحة", css: "تنسيقات CSS" },
          fields: { wonum: "رقم أمر العمل",  assetnum: "رقم الأصل", desc: "الوصف", status: "الحالة", asset: "اسم الأصل", location: "الموقع", tasks_table: "جدول المهام", mat_table: "جدول المواد", asset_basic: "معلومات الأصل", inv_basic: "معلومات المخزون", vend_basic: "معلومات المورد" }
        },
      },
      assets: {
        map: { title: "موقع الأصل", address: "العنوان", coordinates: "الإحداثيات الجغرافية", no_location: "لم يتم تحديد موقع جغرافي لهذا الأصل.", "gps_location": "الموقع الجغرافي (GPS)","gps_coordinates": "إحداثيات GPS" },
        list: { new_asset: "إضافة أصل جديد", system_title: "نظام إدارة الأصول", all_orgs: "كل المنظمات", all_sites: "كل المواقع", db_total: "إجمالي القاعدة:", display_page: "الصفحة المعروضة:", all: "الكل", col_site: "الموقع", col_org: "المنظمة", navigate_hint: "استخدم الأسهم للتنقل" },
        modal: { migration_title: "نقل جماعي ضخم للأصول", caution_prefix: "تنبيه: أنت على وشك نقل", caution_suffix: "أصول مختارة. سيتم تحديث الموقع الجغرافي والارتباط المالي فوراً.", dest_label: "موقع الوجهة الجديد", placeholder: "اختر الموقع...", abort: "إلغاء العملية", execute: "تنفيذ النقل الجماعي" },
        headers: { asset_num: "رقم الأصل", desc: "الوصف", status: "الحالة", downtime: "إجمالي وقت التوقف", site: "الموقع" },
        tabs: { details: "بيانات الأصل", spare_parts: "قطع الغيار", safety: "الأمان والسلامة", meters: "العدادات", specs: "المواصفات الفنية", history: "تاريخ العمل", map: "الخريطة", bim: "نموذج 3D", ai: "تحليل الذكاء الاصطناعي", eval: "تقييم الأداء", attachments: "المرفقات" },
        sections: { "linear_details": "تفاصيل المرجع الخطي", general: "معلومات عامة", details: "تفاصيل إضافية", finance: "العناوين والبيانات المالية", image: "صورة الأصل", audit: "معلومات التدقيق", bim_info: "بيانات النمذجة", reliability: "تحليل الاعتمادية" },
        fields: { "is_linear": "هل الأصل خطي؟", "start_measure": "نقطة البداية", "end_measure": "نقطة النهاية", "measure_unit": "وحدة القياس", "direction": "اتجاه التدفق", type: "نوع الأصل", location: "الموقع", parent: "الأصل الأب", category: "فئة الأصل", is_running: "هل الأصل يعمل؟", serial: "الرقم التسلسلي", item: "القطعة الدوارة", failure: "فئة الأعطال", safety_plan: "خطة السلامة", vendor: "المورد", price: "سعر الشراء", replace: "تكلفة الاستبدال", priority: "الأولوية", ytd_cost: "تكاليف السنة المالية" },
        meters: { seq: "التسلسل", name: "العداد", reading: "آخر قراءة", date: "تاريخ القراءة", inspector: "المفتش", remarks: "ملاحظات" },
        ai: { title: "تحليل ذكاء الأصول", run: "بدء التشخيص", summary: "الملخص الفني", recommend: "التوصيات", telemetry: "تحليل تيار البيانات..." },
        spare_fields: { item: "القطعة الدوارة", qty: "الكمية", issued: "الكمية المنصرفة", remarks: "ملاحظات", item_details: "تفاصيل القطعة" },
        safety: {
          plan_card: "خطط السلامة المرتبطة", active_plan: "خطة السلامة النشطة", no_plan: "لا توجد خطة مرتبطة", link_plan: "ربط خطة سلامة", change_plan: "تغيير الخطة", hazard_title: "المخاطر الخاصة بالأصل", hazard_num: "رقم الخطر", hazard_type: "النوع / الأولوية", no_hazards: "لا توجد مخاطر مرتبطة بهذا الأصل", add_hazard: "إضافة خطر", loto_title: "عزل الطاقة (LOTO)", tag_id: "رقم العزل", req_state: "الحالة المطلوبة", no_loto: "لم يتم تحديد نقاط عزل طاقة", add_loto: "إضافة نقطة عزل", applying_proto: "جاري تطبيق بروتوكول السلامة..."
        },
        meters: { title: "العدادات المرتبطة", details_title: "تفاصيل العداد", seq: "التسلسل", meter_name: "اسم العداد", meter_type: "نوع العداد", uom: "وحدة القياس", active_status: "نشط؟", last_reading: "آخر قراءة", last_date: "تاريخ القراءة", inspector: "المفتش", remarks: "ملاحظات", new_meter: "عداد جديد" },
        specs: { classification: "التصنيف", select_class: "اختر التصنيف...", tech_specs: "المواصفات الفنية", attribute: "الخاصية", value: "القيمة", uom: "وحدة القياس", data_type: "نوع البيانات", attr_details: "تفاصيل الخاصية", select_val: "اختر القيمة"},
        history: {
          title: "أوامر العمل السابقة",
          wo_num: "رقم الأمر",
          finish_date: "تاريخ الانتهاء",
          no_history: "لا توجد أوامر عمل سابقة لهذا الأصل.",
          fetching: "جاري جلب السجل التاريخي...",
          wo_type: "نوع الأمر"
        },
        bim: {
          model_status: "حالة النموذج",
          linked: "مرتبط ونشط",
          not_linked: "غير مرتبط",
          upload_revit: "رفع ملف ريفيت (.rvt)",
          urn_label: "رمز URN الخاص بالنموذج",
          "show_3d": "عرض التوأم الرقمي (3D)", "show_data": "عرض بيانات COBie" 
        },
        ai: {
          title: "ذكاء الأصول",
          sub_title: "محلل الذكاء الاصطناعي",
          tagline: "التشخيص التنبؤي لإنترنت الأشياء الصناعي",
          run_btn: "تشغيل التشخيص",
          analyzing: "جاري تحليل تدفق البيانات...",
          health_score: "مؤشر الحالة",
          thermal: "تنبيه حراري",
          vibration: "تنبيه الاهتزاز",
          tech_summary: "الملخص الفني",
          recommendations: "التوصيات",
          sensors_chart: "المستشعرات مقابل الحدود الحرجة",
          init_prompt: "اضغط على تشغيل التشخيص لبدء تحليل الذكاء الاصطناعي",
          critical: "حرج",
          normal: "طبيعي",
          stable: "مستقر",
          detected: "مكتشف",
          predictive_trajectory: "مسار التنبؤ بحدوث الأعطال", est_failure: "العطل المتوقع", "loading_pred": "جاري توليد نموذج التنبؤ..."
        },
        "features": {
          "feature_id": "كود المعلم",
          "label": "المسمى",
          "start": "نقطة البداية",
          "end": "نقطة النهاية (فارغ = نقطي)",
          "value": "القيمة (مثال: 500mm)",
          "details": "تفاصيل المعلم",
          "y_offset": "الإزاحة الأفقية (يمين/يسار)",
          "z_offset": "الإزاحة الرأسية (عمق/ارتفاع)"
        },
      },
      common: { "days": "أيام", "weeks": "أسابيع", "months": "أشهر", "years": "سنوات", "daysList": {"saturday": "السبت", "sunday": "الأحد", "monday": "الإثنين", "tuesday": "الثلاثاء", "wednesday": "الأربعاء", "thursday": "الخميس", "friday": "الجمعة" }, "select": "اختر", "search": "بحث", "pending": "قيد الانتظار", "pendingSelection": "--- بانتظار الاختيار ---", confirm: "تأكيد", save_settings: "حفظ الإعدادات الذكية", selected: "تم اختيارها", bulk_move: "نقل جماعي للأصول", change_status: "تغيير الحالة", cancel: "إعادة ضبط الفلاتر", save: "حفظ", cancel: "إلغاء", delete: "حذف", back: "رجوع", record: "سجل", total: "إجمالي", print: "طباعة", active: "نشط", critical: "حرج", warning: "تحذير", healthy: "سليم", of: "من", new_row: "سطر جديد", select_spare: "اختر قطع الغيار", "filter": "تصفية..." , copy: "نسخة", cancel: "إلغاء", clone: "استنساخ", back: "عودة", save: "حفظ", cancel: "إلغاء", delete: "حذف", back: "رجوع", record: "سجل", total: "إجمالي", print: "طباعة", active: "نشط", critical: "حرج", warning: "تحذير", healthy: "سليم", "new_row": "سطر جديد", "save_success": "تم الحفظ بنجاح", "save_fail": "فشل الحفظ",
    "delete": "حذف", "delete_success": "تم الحذف بنجاح", "delete_fail": "فشل الحذف", "are_you_sure": "هل أنت متأكد؟", "cancel": "إلغاء", "confirm": "تأكيد",
    "first": "الأول", "last": "الأخير", "next": "التالي", "prev": "السابق", "sar": "ر.س", "all": "الكل", "attachments": "المرفقات", "history": "السجل",    "change_status": "تغيير الحالة", "totalRecords": "إجمالي السجلات", "readOnly": "(للقراءة فقط)", "noDescription": "لا يوجد وصف", "recordLocked": "السجل مغلق ولا يمكن تعديله.", "descRequired": "الوصف مطلوب!", "actionDenied": "إجراء مرفوض", "cantDeleteStatus": "لا يمكن حذف سجل بحالة: {{status}}", active: "نشط", inactive: "غير نشط", yes: "نعم", no: "لا", "main": "البيانات الأساسية","save": "حفظ",
     "change_status": "تغيير الحالة", "history": "السجل", "delete": "حذف", "org": "المؤسسة", "site": "الموقع", "new_row": "صف جديد", "location": "الموقع", "asset": "الأصل", "no_records": "لا توجد سجلات", "saving": "جاري الحفظ...", "save_success": "تم الحفظ بنجاح!", "save_fail": "فشل الحفظ", "are_you_sure": "هل أنت متأكد؟", "yes_delete": "نعم، احذف!", "cancel": "إلغاء", "delete_success": "تم الحذف بنجاح", "delete_fail": "فشل الحذف: ", "clear_filters": "مسح الفلاتر", "all": "الكل", "syncing": "جاري المزامنة...", "showing": "عرض", "total": "الإجمالي", "created_by": "تم الإنشاء بواسطة", "changed_date": "تاريخ التعديل"},       
     toasts: { save_success: "تم الحفظ بنجاح", save_fail: "فشل الحفظ", load_fail: "فشل تحميل البيانات", delete_success: "تم الحذف بنجاح" },
      swal: { delete_title: "هل أنت متأكد؟", delete_text: "أنت على وشك حذف الأصل:", confirm_delete: "نعم، احذف السجل" },
      "ai_settings": {
        "title": "إعدادات مهندس الذكاء الاصطناعي",
        "sub_title": "AI Predictive Maintenance Engine",
        "enable_label": "تفعيل الصيانة التنبؤية الذاتية",
        "enable_sub": "قرار آلي بفتح أمر شغل عند الخطر",
        "target_lang": "لغة التقارير والمهام المكتوبة",
        "threshold": "حد الثقة الأدنى للقرار التلقائي",
        "auto_tasks": "توليد قائمة المهام (WOTasks)",
        "task_desc": "كتابة خطوات العمل آلياً في جدول المهام",
        "max_tasks": "أقصى عدد خطوات لكل أمر شغل",
        "section": "الموضوع",
        "technicalDetails": "التفاصيل"
      },
      "export_technical_report": "تصدير التقرير الفني (PDF)",
      "availability": "معدل الإتاحة",
      "mtbf": "متوسط الوقت بين الأعطال",
      "mttr": "متوسط وقت الإصلاح",
      "hrs": "ساعة",
      "reliability_score": "مؤشر الاعتمادية",
      "score": "نقطة",
      "downtime_history_trend": "منحنى التوقفات التاريخي (آخر 10 أحداث)",
      "values_in_hours": "القيم بالساعات",
      "timeline_event_date": "الخط الزمني (تاريخ الحدث)",
      "downtime_hours": "وقت التوقف (ساعات)",
      "no_downtime_records": "لا توجد سجلات توقف مسجلة لهذا الأصل حتى الآن.",
      "reliability_analysis": "تحليل الاعتمادية",
      "total_failures": "إجمالي الأعطال",
      "total_down_time": "إجمالي وقت التوقف",
      "last_calculation": "آخر تحديث للبيانات",
      "maintenance_strategy_note": "ملاحظة استراتيجية الصيانة",
      "high_mttr_detected": "متوسط وقت إصلاح (MTTR) مرتفع. التوصية: مراجعة توافر قطع الغيار والتدريب الفني لفئة هذا الأصل.",
      "critical_availability": "مستوى إتاحة حرج. يُنصح بزيادة وتيرة الصيانة الوقائية أو التخطيط لعمرة شاملة.",
      "nominal_performance": "أداء الأصل ضمن المعدلات الطبيعية. استمر في جدول الصيانة الوقائية القياسي.",
      "current_load_factor": "عامل الحمل الحالي",
      "optimal": "مثالي",
      statusModal: {
        "loadError": "فشل تحميل الحالات",
        "selectFirst": "يرجى اختيار حالة أولاً",
        "updating": "جاري تحديث الحالة...",
        "success": "تم تحديث الحالة بنجاح",
        "failed": "فشل التحديث",
        "changeStatus": "تغيير حالة:",
        "currentStatus": "الحالة الحالية",
        "availableStatuses": "الحالات المتاحة",
        "loading": "جاري التحميل...",
        "chooseStatus": "اختر الحالة...",
        "memo": "المبرر / ملاحظات",
        "enterNotes": "أدخل ملاحظاتك هنا...",
        "cancel": "إلغاء",
        "update": "تحديث"
      },
      attachmentsModal: {
        "loadError": "خطأ في تحميل الملفات",
        "uploadSuccess": "تم إرفاق الملف بنجاح",
        "uploadFailed": "فشل الرفع",
        "deleteConfirmTitle": "هل أنت متأكد؟",
        "deleteConfirmText": "أنت على وشك حذف '{{name}}' نهائياً. سيتم إزالة الملف من خوادمنا.",
        "btnYesDelete": "نعم، احذف الملف!",
        "btnCancel": "إلغاء",
        "processingDelete": "جاري الحذف...",
        "deletedTitle": "تم الحذف!",
        "deletedText": "تمت إزالة المرفق بنجاح.",
        "deleteFailed": "فشل الحذف",
        "headerTitle": "مكتبة المرفقات",
        "linkingTo": "مرتبط بـ:",
        "filesFound": "الملفات الموجودة:",
        "uploadBtn": "رفع مستند جديد",
        "thName": "الاسم",
        "thOwner": "المالك",
        "thStatus": "الحالة",
        "thActions": "إجراءات",
        "statusPrivate": "خاص",
        "statusPublic": "عام",
        "noDocs": "لا توجد مستندات مرتبطة حتى الآن"
      },
      enterMeters: {
        "noMeters": "لا توجد عدادات مرتبطة بالأصل:",
        "saving": "جاري حفظ القراءات...",
        "enterAtLeastOne": "الرجاء إدخال قراءة جديدة واحدة على الأقل",
        "saveSuccess": "تم حفظ جميع القراءات بنجاح!",
        "saveFailed": "فشل حفظ القراءات",
        "title": "إدخال قراءات العداد | الأصل:",
        "titleLoc": "إدخال قراءات العداد | الموقع:",
        "thIdentification": "تعريف العداد",
        "thNewReading": "* القراءة الجديدة",
        "thReadingDate": "* تاريخ القراءة",
        "thMeterType": "نوع العداد",
        "thLastRecorded": "آخر قراءة مسجلة",
        "noDescription": "لا يوجد وصف",
        "enterValue": "أدخل القيمة...",
        "notAvailable": "غير متوفر",
        "operator": "المُشغل:",
        "btnCancel": "إلغاء",
        "btnUpdate": "تحديث القراءات"
      },
      emailSettings: {
        "loadFailed": "فشل تحميل الإعدادات",
        "saveSuccess": "تم حفظ إعدادات البريد بنجاح!",
        "saveFailed": "فشل حفظ الإعدادات",
        "connecting": "جاري الاتصال بخادم SMTP...",
        "connFailed": "فشل الاتصال!",
        "title": "إعدادات SMTP",
        "subtitle": "إعدادات خادم البريد",
        "outgoingTitle": "البريد الصادر (SMTP - لإرسال التقارير والطلبات)",
        "incomingTitle": "البريد الوارد (IMAP - رادار المشتريات)",
        "lblHost": "مضيف SMTP",
        "lblPort": "منفذ SMTP",
        "lblUser": "اسم المستخدم / البريد الإلكتروني (SMTP)",
        "lblPass": "كلمة مرور SMTP",
        "lblSender": "البريد الإلكتروني للمرسل (عناوين المرسل)",
        "lblImapHost": "خادم الاستقبال (IMAP Host)",
        "lblImapPort": "منفذ الاستقبال (Port)",
        "enableImap": "تفعيل رادار المشتريات (Inbox Monitoring)",
        "imapDesc": "السماح للنظام بقراءة البريد الوارد وتحليل عروض الأسعار أوتوماتيكياً.",
        "gmailNote": "بالنسبة لـ Gmail، استخدم 'كلمة مرور التطبيق' من أمان Google. لن تعمل كلمات مرور الحساب مع تفعيل المصادقة الثنائية (2FA).",
        "btnTest": "اختبار",
        "btnCancel": "إلغاء",
        "btnSave": "حفظ الإعدادات"
      },
      locationDetails: {
        "noBimModel": "لا يوجد نموذج 3D مرتبط بهذا الموقع",
        "noBimLinked": "هذا الموقع غير مرتبط بـ BIM",
        "locMandatory": "حقل الموقع إلزامي!",
        "saving": "جاري حفظ التغييرات...",
        "saveSuccess": "تم حفظ الموقع بنجاح",
        "saveFailed": "فشل الحفظ:",
        "deleteTitle": "هل أنت متأكد؟",
        "deleteText": "أنت على وشك حذف الموقع {{id}}. لا يمكن التراجع عن هذا الإجراء!",
        "btnYesDelete": "نعم، احذفه!",
        "btnCancel": "إلغاء",
        "deleting": "جاري حذف الموقع...",
        "deleteSuccess": "تم حذف الموقع بنجاح",
        "deleteFailed": "فشل الحذف!",
        "uploadingRevit": "جاري رفع وترجمة نموذج Revit...",
        "revitSuccess": "تم ربط النموذج بنجاح!",
        "uploadFailed": "فشل الرفع:",
        "loadingCtx": "جاري تحميل سياق الموقع...",
        "tooltipChangeStatus": "تغيير الحالة",
        "tooltipStatusHistory": "سجل الحالة",
        "tooltipDelete": "حذف",
        "btnSave": "حفظ",
        "lblLocation": "الموقع",
        "lblDescription": "الوصف",
        "btnRevitLinked": "مرتبط بـ Revit",
        "tabLocation": "الموقع",
        "tabAssets": "الأصول",
        "tabSpecs": "المواصفات",
        "tabSafety": "السلامة",
        "tabMeters": "العدادات",
        "tab3D": "عرض 3D",
        "tabHistory": "السجل",
        "secIdentity": "هوية الموقع",
        "lblStatus": "الحالة",
        "lblType": "النوع",
        "lblParentLoc": "الموقع الأصل",
        "lblSiteID": "رقم الموقع",
        "secGeoInfo": "معلومات الموقع الجغرافي والعنوان",
        "lblServiceAddr": "عنوان الخدمة",
        "lblBimSpaceId": "معرف مساحة BIM",
        "lblGisCoords": "إحداثيات GIS",
        "secRefImage": "صورة مرجعية",
        "btnUploadPhoto": "رفع صورة",
        "thAssetNum": "رقم الأصل",
        "thStatus": "الحالة",
        "lblClass": "التصنيف",
        "thAttr": "الخاصية",
        "thDesc": "الوصف",
        "thValue": "القيمة",
        "titleHazards": "المخاطر المُبلغ عنها في هذا الموقع",
        "btnAddHazard": "إضافة خطر",
        "lblSelectHazards": "تحديد المخاطر",
        "thHazard": "الخطر",
        "thPrecaution": "الاحتياطات",
        "titleLocMeters": "عدادات الموقع",
        "showingMeters": "عرض {{current}} من {{total}}",
        "noMetersDef": "لا توجد عدادات معرفة",
        "thSeq": "م",
        "thMeterNum": "رقم العداد",
        "thType": "النوع",
        "thUOM": "وحدة القياس",
        "thActive": "نشط",
        "newMeter": "عداد_جديد",
        "clickNewRow": "انقر على 'سطر جديد' لإضافة عداد لهذا الموقع",
        "titleMeterConfig": "إعداد تفاصيل العداد",
        "newEntry": "إدخال جديد",
        "lblMeterNum": "* رقم العداد",
        "lblMeterType": "نوع العداد",
        "lblUOM": "وحدة القياس",
        "lblMeterActive": "العداد نشط",
        "lblLastReading": "آخر قراءة",
        "lblReadingDate": "تاريخ القراءة",
        "lblInspector": "مفتش العداد",
        "lblRemarks": "ملاحظات / تعليقات",
        "placeholderRemarks": "أدخل الملاحظات الفنية حول هذا العداد...",
        "btnAddMeterRow": "إضافة سطر عداد جديد",
        "titleModelStatus": "حالة النموذج",
        "statusLinked": "مرتبط ونشط",
        "statusNotLinked": "غير مرتبط",
        "btnUploadRevit": "رفع نموذج Revit (.rvt)",
        "titleHistory": "سجل المعاملات وسجل التدقيق",
        "lblChangedBy": "تم التعديل بواسطة:",
        "failedFetchAttr": "فشل جلب الخصائص"
      },
      "locationList": {
        "loadFailed": "فشل تحميل المواقع من خادم تكنويا.",
        "title": "مواقع",
        "searchPlaceholder": "بحث شامل...",
        "btnClearAll": "مسح الكل",
        "btnExport": "تصدير",
        "btnNewLocation": "موقع جديد",
        "thLocationId": "رقم الموقع",
        "thDescription": "الوصف",
        "thType": "النوع",
        "thStatus": "الحالة",
        "thSite": "الموقع (Site)",
        "optAll": "الكل",
        "optOperating": "قيد التشغيل",
        "optDecommissioned": "خارج الخدمة",
        "fetchingData": "جاري جلب البيانات من الخادم...",
        "noRecords": "لم يتم العثور على سجلات مطابقة.",
        "recordsFound": "السجلات الموجودة:",
        "page": "الصفحة:"
      },
      "universalLookup": {
        "selectValue": "اختر القيمة:",
        "total": "الإجمالي",
        "searchPlaceholder": "ابحث بالكود أو الوصف...",
        "valueCode": "القيمة / الكود",
        "description": "الوصف",
        "site": "الموقع (Site)",
        "synchronizing": "جاري المزامنة...",
        "noRecords": "لم يتم العثور على سجلات مطابقة.",
        "loadingMore": "جاري تحميل المزيد من السجلات...",
        "results": "النتائج:",
        "cancel": "إلغاء"
      },
      "statusHistory": {
        "title": "سجل تتبع الحالة",
        "loading": "جاري تحميل السجل...",
        "noRecords": "لم يتم تسجيل أي تغييرات في الحالة لهذا العنصر.",
        "initial": "مبدئي",
        "btnClose": "إغلاق"
      },
      "personalInfo": {
        "updateSuccess": "تم تحديث الملف الشخصي بنجاح",
        "sessionExpired": "انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى",
        "updateFailed": "فشل التحديث",
        "title": "المعلومات الشخصية والإعدادات الافتراضية",
        "lblDisplayName": "الاسم الكامل",
        "lblEmail": "البريد الإلكتروني",
        "lblDefaultOrg": "المؤسسة الافتراضية",
        "selectOrg": "اختر المؤسسة...",
        "lblDefaultSite": "الموقع الافتراضي",
        "selectSite": "اختر الموقع...",
        "lblDefaultLang": "اللغة الافتراضية",
        "btnCancel": "إلغاء",
        "btnSave": "تطبيق وحفظ التغييرات",
        "securityTitle": "الأمان والمصادقة الثنائية",
        "enable2FA": "تفعيل المصادقة الثنائية (2FA)",
        "googleAuth": "تطبيق Google Authenticator",
        "emailOTP": "رمز التحقق عبر البريد",
        "configure2FA": "إعداد المصادقة الثنائية",
        "scanQR": "قم بمسح رمز الاستجابة السريعة (QR) باستخدام تطبيق Google Authenticator، ثم أدخل الرمز المكون من 6 أرقام أدناه للتحقق.",
        "btnVerify": "تأكيد",
        "setupSuccess": "تم إعداد المصادقة الثنائية بنجاح!",
        "invalidCode": "رمز التحقق غير صحيح",
        "failedQR": "فشل في إنشاء رمز الاستجابة السريعة"
      },
      "appSettings": {
        "savingSettings": "جاري حفظ الإعدادات...",
        "saveSuccess": "تم تحديث الإعدادات بنجاح!",
        "saveFailed": "فشل حفظ الإعدادات.",
        "title": "تكوين المؤسسة",
        "org": "المؤسسة",
        "tabs": {
          "WORKORDER": "أوامر العمل",
          "ASSET": "سجل الأصول",
          "INVENTORY": "المستودعات والمخزون",
          "PURCHASE": "المشتريات",
          "PR": "طلبات الشراء (PR)",
          "JP": "خطط العمل (JP)",
          "PM": "الصيانة الوقائية (PM)",
          "MR": "طلبات المواد (MR)",
          "SR": "طلبات الخدمة (SR)"
        },
        "systemRules": "قواعد نظام {{tab}}",
        "prefix": "بادئة التسلسل",
        "preview": "معاينة",
        "seed": "القيمة الابتدائية (Seed)",
        "valuationStrategy": "استراتيجية التقييم",
        "movingAvg": "المتوسط المتحرك (موصى به)",
        "fifo": "ما يدخل أولاً يخرج أولاً (FIFO)",
        "lifo": "ما يدخل أخيراً يخرج أولاً (LIFO)",
        "allowNegative": "السماح بالرصيد السالب",
        "negativeWarning": "تحذير: يؤثر على الدقة المالية",
        "encrypting": "جاري التشفير والإرسال...",
        "auditLogged": "يتم تسجيل جميع التغييرات في سجل التدقيق",
        "btnCancel": "إلغاء",
        "btnSave": "حفظ سياسة النظام"
      },
      "workflowAction": {
        "successMove": "تم توجيه سير العمل بنجاح! 🚀",
        "failedMove": "فشل تنفيذ الإجراء",
        "btnRoute": "توجيه سير العمل",
        "modalTitle": "إجراء سير العمل",
        "assignedAs": "معين لك بصفتك:",
        "defaultInstruction": "يرجى المراجعة واتخاذ الإجراء اللازم.",
        "lblChoosePath": "اختر المسار",
        "valSelectPath": "يرجى اختيار المسار",
        "optApprove": "موافقة / تقدم للأمام",
        "optReject": "رفض / إرجاع",
        "lblMemo": "ملاحظات / تعليقات الإجراء",
        "placeholderMemo": "أضف تعليقاتك هنا...",
        "btnCancel": "إلغاء",
        "btnComplete": "إكمال الخطوة"
      },
      "meterHistory": {
        "title": "السجل التاريخي لقراءات العداد",
        "lblAsset": "الأصل",
        "fetching": "جاري جلب الأرشيف...",
        "noRecords": "لم يتم العثور على قراءات تاريخية لهذا الأصل.",
        "thMeterName": "اسم العداد",
        "thReadingVal": "قيمة القراءة",
        "thReadingDate": "تاريخ القراءة",
        "thEnteredBy": "أُدخلت بواسطة",
        "thEntryDate": "تاريخ الإدخال",
        "btnClose": "إغلاق السجل",
        "lblLocation": "الموقع",
        "noRecordsLoc": "لم يتم العثور على قراءات تاريخية لهذا الموقع."
      },
      "rpt_print": "طباعة التقارير",
      "no_templates": "لا توجد قوالب متاحة",
      "wo": {
        "tabs": { "workOrder": "أمر الشغل", "plans": "الخطط", "assignments": "التكليفات", "actuals": "التنفيذ الفعلي", "safety": "السلامة والأمان", "failure": "تقرير الأعطال" },
        "subTabs": { "tasks": "المهام", "labor": "العمالة", "materials": "المواد", "tools": "الأدوات", "services": "الخدمات" },
        "headers": { "workOrder": "أمر الشغل", "status": "الحالة", "totalCost": "إجمالي التكلفة", "activeSla": "مراقبة اتفاقية الخدمة النشطة", "targetRes": "الحل المستهدف", "targetResp": "الاستجابة المستهدفة", "trackingTitle": "تتبع أوامر الشغل", "globalView": "عرض المؤسسة (كل المواقع)", "site": "الموقع", "selected": "المحدد" },
        "sections": { "assetDetails": "تفاصيل الأصل", "scheduling": "معلومات الجدولة", "responsibility": "المسؤولية", "laborAssign": "تكليفات وجدولة العمالة", "totalAssign": "إجمالي التكليفات" },
        "fields": { "description": "الوصف", "location": "الموقع", "asset": "الأصل", "workType": "نوع العمل", "safetyCode": "كود السلامة", "supervisor": "المشرف", "failureClass": "فئة العطل", "targStart": "تاريخ البدء المستهدف", "targFinish": "تاريخ الانتهاء المستهدف", "schedStart": "تاريخ البدء المجدول", "schedFinish": "تاريخ الانتهاء المجدول", "earlyStart": "لا يبدأ قبل", "lateFinish": "لا ينتهي بعد", "actStart": "البدء الفعلي", "actFinish": "الانتهاء الفعلي", "duration": "المدة", "timeRemaining": "الوقت المتبقي", "predecessors": "المهام السابقة", "includeTasks": "تضمين المهام في الجدول؟", "site": "الموقع", "organization": "المؤسسة", "priorityHigh": "الأولوية: عالية (مستوى 1)" },
        "actions": { "routeWorkflow": "توجيه مسار العمل", "wfHistory": "سجل المسار", "changeStatus": "تغيير الحالة", "attachments": "المرفقات", "printWO": "طباعة أمر الشغل", "printSafety": "طباعة ورقة السلامة", "history": "سجل الحالة", "newTask": "مهمة جديدة", "selectLoc": "اختر الموقع", "selectAsset": "اختر الأصل", "selectType": "اختر النوع", "selectSafety": "اختر خطة السلامة", "selectSup": "اختر المشرف", "selectFail": "اختر فئة العطل", "selectCraft": "اختر المهنة", "selectLabor": "اختر العامل", "selectItem": "اختر الصنف", "selectStore": "اختر المخزن", "selectTool": "اختر الأداة", "addLabor": "إضافة عمالة", "addMaterial": "إضافة مادة", "addTool": "إضافة أداة", "addService": "إضافة خدمة", "newAssign": "تكليف جديد", "compAssign": "إنهاء التكليف", "createMR": "إنشاء طلب مواد", "yesCreate": "نعم، أنشئ طلباً جديداً", "yesChange": "نعم، قم بالتغيير", "approve": "اعتماد", "cancel": "إلغاء", "startWork": "بدء العمل", "close": "إغلاق", "complete": "إكمال", "selectProblem": "اختر المشكلة", "selectCause": "اختر السبب", "selectRemedy": "اختر العلاج", "newWO": "أمر شغل جديد" },
        "tables": { "sequence": "التسلسل", "taskDesc": "وصف المهمة", "estDur": "المدة المقدرة", "status": "الحالة", "craft": "المهنة", "labor": "العامل", "qty": "الكمية", "hrs": "الساعات", "rate": "المعدل", "lineCost": "تكلفة السطر", "lineType": "نوع السطر", "itemNum": "رقم الصنف", "description": "الوصف", "unitCost": "تكلفة الوحدة", "storeroom": "المخزن", "item": "صنف", "material": "مادة", "toolNum": "رقم الأداة", "serviceDesc": "وصف الخدمة", "vendor": "المورد", "cost": "التكلفة", "start": "البدء", "finish": "الانتهاء", "failCode": "كود العطل" },
        "footer": { "totalLabor": "إجمالي العمالة", "totalMaterial": "إجمالي المواد", "assigned": "المحجوز (تقديري)", "toolsServ": "أدوات وخدمات", "totalActual": "إجمالي التكلفة الفعلية", "loaded": "المحمل", "total": "الإجمالي", "page": "صفحة", "of": "من" },
        "safety": { "hazardsTitle": "المخاطر والاحتياطات المطلوبة", "hazardCode": "كود الخطر", "hazardDesc": "وصف الخطر", "precautions": "الاحتياطات / الإجراءات المطلوبة", "noHazards": "لا توجد مخاطر محددة لأمر الشغل هذا.", "lotoTitle": "العزل / وضع العلامات (خطوات العزل)", "step": "الخطوة", "tagNum": "رقم العلامة", "isoDesc": "وصف العزل", "reqState": "الحالة المطلوبة", "completed": "مكتمل؟", "noLoto": "لا توجد خطوات عزل مطلوبة." },
        "failure": { "title": "تحليل الأعطال والأسباب الجذرية", "currClass": "فئة العطل الحالية", "notDefined": "غير معرف", "problems": "المشاكل (القضية)", "causes": "الأسباب (السبب الجذري)", "remedies": "العلاج (الإجراء)", "records": "سجلات" },
        "placeholders": { "desc": "أدخل وصف أمر الشغل...", "taskDesc": "وصف المهمة...", "searchWO": "ابحث عن أمر شغل..." },
        "messages": { "loadError": "خطأ في تحميل أمر الشغل", "taskStatusLocal": "تم تحديث حالة المهمة محلياً", "selectItemStore": "يرجى اختيار الصنف والمخزن أولاً", "duplicateReqTitle": "طلب صنف متكرر", "duplicateReqText": "يوجد طلب مواد مفتوح للصنف {{item}}. هل تريد إنشاء آخر؟", "creatingMR": "جاري إنشاء طلب المواد...", "mrCreated": "تم إنشاء الطلب {{num}} بنجاح", "mrFail": "فشل إنشاء طلب المواد", "confirmStatusChange": "هل أنت متأكد من تغيير حالة أمر الشغل {{wonum}} إلى {{status}}؟", "statusSuccess": "تم تغيير الحالة بنجاح", "statusFail": "فشل في تغيير الحالة", "saving": "جاري حفظ أمر الشغل...", "deleteConfirm": "أنت على وشك حذف أمر الشغل {{wonum}}. لا يمكن التراجع عن هذا الإجراء!", "saveBeforeSLA": "يرجى حفظ أمر الشغل أولاً قبل تطبيق اتفاقية الخدمة", "slaExists": "تم تطبيق اتفاقية الخدمة مسبقاً!", "matchingSLA": "جاري مطابقة اتفاقيات مستوى الخدمة...", "slaApplied": "تم تطبيق اتفاقية الخدمة بنجاح", "noMatchingSLA": "لم يتم العثور على اتفاقية خدمة مطابقة", "slaError": "خطأ في الاتصال بمحرك اتفاقيات الخدمة", "failureTreeLoaded": "تم تطبيق أكواد الأعطال الافتراضية لـ {{class}}", "zeroBalance": "تحذير: الرصيد صفر للصنف في {{store}}", "balanceOk": "تم جلب السعر: {{cost}} - الرصيد: {{bal}}", "storeError": "فشل في الاتصال بالمخزن", "assetLinked": "تم ربط الأصل: {{asset}}", "openAssignError": "لا يمكن الإغلاق: يوجد {{count}} تكليفات عمالة لم تكتمل.", "budgetExceeded": "تجاوز الميزانية!", "assignComplete": "تم إكمال التكليف بنجاح", "actionNotAllowed": "لا يمكن إجراء هذه العملية في حالة {{status}}", "locked": "مغلق", "cantChangeCancel": "الطلبات الملغاة لا يمكن تغيير حالتها", "printFail": "فشل إنشاء ملف PDF", "wfRouted": "تم توجيه المسار بنجاح! 🚀", "wfFail": "فشل في توجيه المسار", "taskStatusChanged": "تم تغيير حالة المهمة {{task}} إلى {{status}}", "noLaborAssign": "لم يتم تعيين عمالة لأمر الشغل هذا بعد.", "updateTaskProg": "تحديث تقدم المهام المخطط لها", "noMaterials": "لم يتم الإبلاغ عن مواد بعد. انقر على الزر أدناه للإضافة.", "linkedMRs": "طلبات المواد المرتبطة (تتبع الحالة)", "sessionExpired": "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.", "fetchError": "خطأ في جلب البيانات", "loadingWOs": "جاري تحميل أوامر الشغل...", "syncing": "جاري مزامنة الدفعة التالية...", "stocknobalance": "⚠️ تحذير: الصنف رصيده (صفر) في مخزن"},
        "linearDefect": {
          "title": "موقع العطل الخطي",
          "startMeasure": "بداية القياس",
          "endMeasure": "نهاية القياس (اختياري)",
          "unit": "الوحدة",
          "yOffset": "الإزاحة الجانبية (متر)"
        },
        "costs": {
          "title": "تكاليف أمر الشغل",
          "estimated": "التكاليف التقديرية",
          "actual": "التكاليف الفعلية",
          "labor": "العمالة",
          "materials": "المواد",
          "tools": "الأدوات",
          "services": "الخدمات",
          "total": "الإجمالي",
          "variance": "الفرق (الفعلي - التقديري)",
          "calculating": "جاري حساب التكاليف...",
          "no_data": "لا توجد بيانات متاحة."
        },
        "purchase_info": {
          "title": "معلومات المشتريات المرتبطة",
          "mr_title": "طلبات المواد (MR)",
          "pr_title": "طلبات الشراء (PR)",
          "po_title": "أوامر الشراء (PO)",
          "mr_num": "رقم الطلب",
          "pr_num": "رقم الـ PR",
          "po_num": "رقم الـ PO",
          "vendor": "المورد",
          "status": "الحالة",
          "req_date": "تاريخ الاحتياج",
          "total_cost": "التكلفة الإجمالية",
          "fetching": "جاري جلب البيانات...",
          "no_records": "لا توجد سجلات مرتبطة."
        },
    
      },
      "pm": {
        "tabs": { "pm": "بيانات الصيانة", "frequency": "التكرار", "sequence": "التسلسل", "seasonaldates": "المواسم", "forecast": "التوقعات" },
        "sections": { "assetLoc": "الأصل والموقع الجغرافي", "defaults": "إعدادات التوليد والأفراد", "compliance": "بيانات الامتثال", "siteContext": "معلومات الموقع", "timeBased": "إعدادات التكرار الزمني", "meters": "قراءات العدادات", "sequences": "تسلسل خطط العمل", "seasonal": "جدول أيام العمل المسموحة", "projections": "سجل التوقعات للصيانة" },
        "fields": { "pmNum": "رقم الصيانة", "description": "وصف الصيانة", "status": "حالة السجل", "site": "موقع المؤسسة", "asset": "هوية الأصل", "location": "الموقع المخصص", "route": "المسار المخصص", "counter": "العداد الحالي", "jpnum": "خطة العمل", "worktype": "نوع العمل", "supervisor": "مشرف الصيانة", "glaccount": "الحساب المالي", "woStatus": "حالة الأمر الافتراضية", "priority": "الأولوية", "lastStart": "تاريخ بدء آخر دورة", "lastComp": "تاريخ انتهاء آخر دورة", "nextDue": "تاريخ الاستحقاق القادم", "forecastFlag": "مؤشر التوقع", "org": "المؤسسة", "freqInt": "فترة التكرار", "freqUnit": "وحدة التكرار", "targStart": "وقت البدء المستهدف" },
        "actions": { "forecast": "توليد التوقعات", "savePM": "حفظ", "addMeter": "إضافة عداد", "addStep": "إضافة خطوة", "newPM": "سجل صيانة جديد" },
        "tables": { "meterName": "اسم العداد", "freq": "التكرار", "nextProj": "التوقع القادم", "seq": "التسلسل", "jpnum": "خطة العمل", "fcDate": "تاريخ التوقع", "targetJp": "الخطة المستهدفة", "estCost": "التكلفة التقديرية", "status": "الحالة", "woNum": "رقم أمر الشغل", "generated": "مُولد", "projected": "متوقع" },
        "messages": { "executingForecast": "جاري تشغيل محرك التوقعات...", "forecastSuccess": "تم توليد التوقعات بنجاح", "forecastFail": "فشل حساب التوقعات", "seasonalInfo": "الأيام المحددة تمثل أيام التنفيذ المسموحة. إذا استحق الموعد في يوم غير محدد، سيتخطاه النظام لليوم التالي المسموح.", "noMeters": "لم يتم تعريف أي عدادات لهذا السجل", "noSeq": "التسلسل الدائري معطل", "noForecasts": "لا توجد توقعات متاحة بعد.", "showingProjections": "عرض {{count}} توقعات في الصفحة", "fetchListError": "فشل تحميل سجلات الصيانة الوقائية", "syncingList": "جاري مزامنة سجلات الصيانة مع الخادم...", "noRecords": "لم يتم العثور على سجلات صيانة تطابق معاييرك." },
        "placeholders": { "desc": "اكتب وصف الصيانة هنا...", "globalSearch": "البحث الذكي الشامل (رقم الصيانة، الأصل، الوصف)..." },
        "headers": {"masterDir": "الدليل الرئيسي للصيانة الوقائية"},
        "footer": {"dbTotal": "إجمالي قاعدة البيانات:", "currentPage": "الصفحة الحالية:", "useNavArrows": "استخدم أسهم التنقل"}
      },
      "workflowHistory": {
        "title": "سجل مسار العمل (Audit Trail)",
        "trackingId": "رقم التتبع:",
        "fetching": "جاري جلب السجلات...",
        "currentTask": "المهمة النشطة حالياً",
        "since": "منذ:",
        "by": "بواسطة",
        "noHistory": "لم يتم تسجيل أي أحداث لهذه المعاملة بعد",
        "closeBtn": "إغلاق السجل"
      },
      "pr": {
        "headers": { "prList": "طلبات الشراء" },
        "actions": { "newPR": "طلب جديد", "clearFilters": "مسح الفلاتر", "routeWf": "توجيه المسار" },
        "tabs": { "pr": "طلب الشراء", "prlines": "بنود الطلب" },
        "sections": { "general": "معلومات عامة", "financial": "الملخص المالي" },
        "fields": { "prNum": "رقم الطلب", "requestedBy": "مقدم الطلب", "reqDate": "تاريخ الاحتياج", "refMr": "طلب المواد المرجعي", "vendor": "المورد", "glAccount": "الحساب المالي" },
        "financial": { "subtotal": "الإجمالي الفرعي", "taxTotal": "إجمالي الضريبة", "grandTotal": "المبلغ الإجمالي" },
        "tables": { "prNum": "رقم الطلب", "description": "الوصف", "status": "الحالة", "totalCost": "التكلفة", "reqDate": "التاريخ", "site": "الموقع", "itemNum": "رقم الصنف", "itemType": "نوع الصنف", "qty": "الكمية", "unitCost": "سعر الوحدة", "tax": "الضريبة", "lineTotal": "الإجمالي للسطر", "taxCat": "فئة الضريبة" },
        "messages": { "loadFailed": "فشل تحميل طلبات الشراء", "syncing": "جاري مزامنة السجلات...", "noData": "لا توجد بيانات", "noLines": "لم يتم إضافة بنود للطلب بعد.", "fetchingMRLines": "جاري جلب بنود طلب المواد: {{mrnum}}...", "loadedMRLines": "تم جلب {{count}} بند بنجاح", "noMRLines": "لا توجد بنود في هذا الطلب", "failedMRLines": "فشل جلب بنود طلب المواد" },
        "swal": { "lockedTitle": "مغلق", "cantDeleteStatus": "لا يمكن الحذف في حالة: {{status}}", "cantChangeCancel": "الطلبات الملغاة لا يمكن تغيير حالتها", "deleteWarnText": "سيتم حذف طلب الشراء وجميع بنوده نهائياً." },
        "placeholders": { "desc": "اكتب وصف الطلب هنا...", "globalSearch": "بحث ذكي شامل..." },
        "footer": { "showing": "عرض", "totalRecords": "إجمالي السجلات" }
      },
      "po": {
        "headers": { "poList": "أوامر الشراء" },
        "actions": { "newPO": "أمر جديد", "clearFilters": "مسح الفلاتر", "routeWf": "توجيه المسار", "addManualRow": "إضافة سطر يدوي", "wfHistory": "مسار العمل الزمني" },
        "tabs": { "po": "أمر الشراء", "polines": "بنود الأمر" },
        "sections": { "general": "معلومات عامة", "financial": "الملخص المالي", "lines": "بنود أمر الشراء" },
        "fields": { "poNum": "رقم الأمر", "requestedBy": "مقدم الطلب", "orderDate": "تاريخ الأمر", "refPr": "طلب الشراء المرجعي", "vendor": "المورد", "glAccount": "الحساب المالي" },
        "financial": { "subtotal": "الإجمالي الفرعي", "taxTotal": "إجمالي الضريبة", "grandTotal": "المبلغ الإجمالي" },
        "tables": { "poNum": "رقم الأمر", "totalCost": "التكلفة", "orderDate": "تاريخ الأمر", "itemNum": "رقم الصنف", "itemType": "نوع الصنف", "unitCost": "سعر الوحدة", "tax": "الضريبة", "lineTotal": "إجمالي السطر", "taxCat": "فئة الضريبة" },
        "messages": { "loadFailed": "فشل تحميل أوامر الشراء", "syncing": "جاري مزامنة السجلات...", "noData": "لا توجد أوامر تطابق بحثك", "noLines": "لم يتم إضافة بنود. يمكنك إضافتها يدوياً أو سحبها من طلب.", "vendorRequired": "حقل المورد إلزامي قبل الحفظ أو تغيير الحالة.", "fetchingLines": "جاري جلب بنود المرجع: {{num}}...", "loadedLines": "تم جلب {{count}} بند بنجاح", "noLinesFound": "هذا المستند المرجعي لا يحتوي على بنود", "failedLines": "فشل جلب البنود المرجعية", "cantChangeCancel": "الطلبات الملغاة لا يمكن تغيير حالتها", "cantDeleteStatus": "لا يمكن الحذف في حالة: {{status}}" },
        "swal": { "deleteWarnText": "سيتم حذف أمر الشراء وجميع بنوده نهائياً." },
        "placeholders": { "desc": "اكتب وصف الأمر هنا...", "globalSearch": "بحث ذكي شامل..." },
        "footer": { "showing": "عرض" }
      },
      "mr": {
        "headers": { "mrList": "طلبات المواد" },
        "actions": { "newMR": "طلب مواد جديد", "clearFilters": "مسح الفلاتر", "routeWf": "توجيه المسار", "createUsage": "صرف مخزني", "createUsageDesc": "إنشاء إذن صرف/تحويل", "createPR": "طلب شراء", "createPRDesc": "إنشاء طلب شراء مرتبط", "addMaterial": "إضافة مادة" },
        "tabs": { "mr": "بيانات الطلب", "mrlines": "بنود المواد" },
        "sections": { "general": "معلومات عامة", "financial": "الملخص المالي", "mrItems": "بنود طلب المواد", "financialCharging": "تفاصيل التحميل المالي (التكلفة)" },
        "fields": { "mrNum": "رقم الطلب", "requestedBy": "مقدم الطلب", "reqDate": "تاريخ الاحتياج", "refMr": "طلب مرجعي", "vendor": "المورد", "glAccount": "الحساب المالي", "targetStore": "المخزن المستهدف", "chargeLoc": "تحميل على موقع", "chargeAsset": "تحميل على أصل", "chargeWO": "تحميل على أمر شغل" },
        "financial": { "subtotal": "الإجمالي الفرعي", "taxTotal": "إجمالي الضريبة", "grandTotal": "المبلغ الإجمالي" },
        "tables": { "mrNum": "رقم الطلب", "description": "الوصف", "status": "الحالة", "totalCost": "التكلفة", "enteredDate": "تاريخ الإدخال", "site": "الموقع", "itemNum": "رقم الصنف", "itemType": "نوع الصنف", "qty": "الكمية", "unitCost": "سعر الوحدة", "tax": "الضريبة", "lineTotal": "الإجمالي للسطر", "taxCat": "فئة الضريبة", "stockItem": "صنف مخزني", "qtyReq": "الكمية المطلوبة", "estUnitCost": "التكلفة التقديرية" },
        "messages": { "generating": "جاري إنشاء {{docType}}...", "generatedSuccess": "تم إنشاء {{docType}} رقم {{docnum}} بنجاح!", "generateFail": "فشل إنشاء {{docType}}", "storeRequired": "المخزن المستهدف مطلوب!", "dateRequired": "تاريخ الاحتياج مطلوب!", "loadFailed": "فشل تحميل طلبات المواد", "syncing": "جاري مزامنة السجلات...", "noData": "لا توجد بيانات", "noLines": "لم يتم إضافة بنود للطلب بعد.", "fetchingMRLines": "جاري جلب بنود الطلب: {{mrnum}}...", "loadedMRLines": "تم جلب {{count}} بند بنجاح", "noMRLines": "لا توجد بنود في هذا الطلب", "failedMRLines": "فشل جلب بنود الطلب" },
        "swal": { "lockedTitle": "مغلق", "cantDeleteStatus": "لا يمكن الحذف في حالة: {{status}}", "cantChangeCancel": "الطلبات الملغاة لا يمكن تغيير حالتها", "deleteWarnText": "سيتم حذف طلب المواد وجميع بنوده نهائياً." },
        "placeholders": { "desc": "اكتب وصف الطلب هنا...", "globalSearch": "بحث ذكي شامل...", "chooseLoc": "اختر موقع", "selectAsset": "اختر أصل", "chargeWO": "حمل على أمر شغل" },
        "footer": { "showing": "عرض", "totalRecords": "إجمالي السجلات" },
        "lookups": { "storerooms": "المخازن", "inventory": "بحث المخزون", "locations": "مواقع العمل", "assets": "سجل الأصول", "workorders": "أوامر الشغل" },
      },
      "contract": {
        "headers": { "masterNode": "سجل العقود الرئيسي" },
        "placeholders": { "globalSearch": "البحث الشامل (رقم العقد، المورد، الوصف)...", "desc": "أدخل ملخص العقد...", "termDesc": "اكتب تفاصيل الشرط..." },
        "actions": { "newContract": "عقد جديد", "save": "حفظ العقد", "addTerm": "إضافة شرط", "addLine": "إضافة بند", "wfHistory": "مسار العمل الزمني" },
        "tabs": { "general": "عام", "slaperformance": "اتفاقية مستوى الخدمة (SLA)", "termslegal": "الشروط والأحكام", "contractlines": "بنود العقد" },
        "sections": { "identity": "هوية العقد وصلاحيته", "communication": "مركز الاتصال", "auditInfo": "معلومات السجل", "masterSLA": "ربط اتفاقية الخدمة (SLA)", "slaBenchmarks": "مؤشرات مستوى الخدمة", "termsList": "الشروط والأحكام القانونية", "lines": "نطاق العمل / بنود التوريد" },
        "options": { "supply": "عقد توريد", "labor": "عقد عمالة / خدمات", "lease": "عقد إيجار", "allTypes": "كل الأنواع", "allStatus": "كل الحالات", "general": "عام", "payment": "شروط الدفع", "termination": "إنهاء العقد", "warranty": "الضمان", "liability": "المسؤولية القانونية" },
        "fields": { "contractNum": "رقم العقد", "vendorRef": "المورد", "startDate": "تاريخ البدء", "endDate": "تاريخ الانتهاء", "contractValue": "قيمة العقد", "currency": "العملة", "contactPerson": "مسؤول الاتصال", "vendorEmail": "البريد الإلكتروني للمورد", "slaRef": "مرجع الـ SLA", "respTime": "وقت الاستجابة (ساعات)", "resTime": "وقت الحل (ساعات)", "uptime": "معدل التوافر المستهدف (%)", "penalty": "غرامة التأخير (للساعة)", "grandTotal": "إجمالي قيمة العقد المحسوبة" },
        "tables": { "contractNum": "رقم العقد", "grandTotal": "الإجمالي", "clauseType": "فئة الشرط", "clauseDesc": "تفاصيل الشرط القانوني", "lineDesc": "وصف الخدمة / البند", "rate": "السعر (للوحدة)", "lineTotal": "الإجمالي" },
        "messages": { "fetchError": "فشل جلب سجلات العقود", "syncing": "جاري مزامنة السجلات...", "noData": "لم يتم العثور على بيانات", "descMandatory": "الوصف إلزامي", "vendorSelected": "تم اختيار المورد {{name}}", "noTerms": "لا توجد شروط قانونية محددة لهذا العقد", "noLines": "لم يتم تعريف أي بنود عمل أو توريد", "slaHint": "ربط SLA يطبق قواعدها تلقائياً على أي أمر شغل أو أمر شراء مرتبط بهذا العقد." },
        "swal": { "deleteTitle": "حذف نهائي؟", "deleteText": "سيتم مسح العقد وجميع الشروط والبنود المرتبطة به نهائياً." },
        "footer": { "masterRecords": "السجلات الرئيسية:", "currentPage": "الصفحة الحالية:" }
      },
      "rfq": {
        "headers": { "rfqList": "إدارة طلبات عروض الأسعار" },
        "tabs": { "rfq": "طلب التسعير", "rfqlines": "بنود الطلب", "quotations": "عروض الأسعار" },
        "sections": { "general": "معلومات عامة", "financial": "الملخص المالي" },
        "fields": { "requestedBy": "مقدم الطلب", "reqDate": "تاريخ الاحتياج", "refPr": "طلب الشراء المرجعي", "vendor": "المورد", "vendorEmail": "بريد المورد", "glAccount": "الحساب المالي" },
        "financial": { "subtotal": "الإجمالي الفرعي", "taxTotal": "إجمالي الضريبة", "grandTotal": "المبلغ الإجمالي" },
        "tables": { "rfqNum": "رقم الطلب", "totalCost": "التكلفة", "itemNum": "رقم الصنف", "itemType": "نوع الصنف", "unitCost": "سعر الوحدة", "tax": "الضريبة", "taxCat": "فئة الضريبة" },
        "options": { "awarded": "تمت الترسية" },
        "actions": { "newRFQ": "طلب جديد", "sendEmail": "إرسال بريد", "wfHistory": "تاريخ المسار", "award": "ترسية وإنشاء أمر شراء" },
        "messages": { "loadFailed": "فشل تحميل طلبات عروض الأسعار", "syncing": "جاري مزامنة السجلات...", "noData": "لا توجد سجلات لعرضها", "noLines": "لم يتم إضافة بنود لهذا الطلب", "pullingPR": "جاري سحب البنود من طلب الشراء: {{prnum}}...", "prImported": "تم استيراد البنود!", "prFailed": "فشل استيراد البنود", "noEmail": "البريد الإلكتروني للمورد مفقود!", "sending": "جاري الإرسال...", "sendSuccess": "تم إرسال البريد بنجاح!", "sendFailed": "فشل إرسال البريد", "quotesHint": "ستظهر عروض الأسعار الواردة من الموردين هنا تلقائياً بمجرد معالجة ردهم على البريد الإلكتروني.", "noQuotes": "لم يتم استلام أي عروض أسعار بعد.", "awarding": "جاري الترسية وتوليد أمر الشراء...", "awardSuccess": "تمت ترسية العطاء بنجاح!", "poCreated": "تم إنشاء أمر الشراء", "awardFailed": "فشلت عملية الترسية" },
        "swal": { "sendTitle": "إرسال الطلب؟", "sendText": "هل تريد إرسال طلب التسعير بالبريد إلى {{vendor}}؟", "awardTitle": "ترسية العطاء؟", "awardText": "سيتم تعليم هذا العرض كفائز وإنشاء أمر شراء (PO) أوتوماتيكياً." },
        "footer": { "showing": "عرض" }
      },
      "itemList": {
        "headers": { "master": "سجل الأصناف الرئيسي" },
        "actions": { "newItem": "صنف جديد" },
        "tables": { "item": "الصنف", "rotating": "دوار؟" },
        "messages": { "syncFailed": "فشل المزامنة مع قاعدة البيانات", "syncing": "جاري مزامنة السجلات...", "noData": "لا توجد أصناف تطابق بحثك" },
        "footer": { "totalItems": "إجمالي الأصناف:", "page": "صفحة" }
      },
      "itemDetails": {
        "tabs": { "item": "بيانات الصنف", "inventory": "المخزون", "vendors": "الموردين", "specs": "المواصفات", "assembly": "التجميع (BOM)" },
        "sections": { "config": "تكوين الصنف", "units": "الوحدات والتتبع", "bomList": "قائمة المكونات (BOM)", "supplierHistory": "سجل المشتريات والموردين" },
        "actions": { "save": "حفظ الصنف", "addStore": "إضافة للمخزن", "newSpec": "مواصفة جديدة", "addComponent": "إضافة مكون" },
        "fields": { "itemSet": "مجموعة الأصناف", "rotating": "دوار؟ (مرتبط بالأصول)", "lotControl": "تحكم بالدفعات (Lot)؟", "inspectionReq": "يتطلب فحص جودة؟", "orderUnit": "وحدة الطلب", "issueUnit": "وحدة الصرف", "condition": "تفعيل الحالة؟", "sparepart": "إضافة كقطعة غيار؟", "classification": "التصنيف" },
        "tables": { "store": "المخزن", "avgCost": "متوسط التكلفة", "balance": "الرصيد", "attribute": "الخاصية", "value": "القيمة", "uom": "الوحدة", "subItem": "الصنف الفرعي", "remarks": "ملاحظات", "vendor": "رقم المورد", "supplierName": "اسم المورد", "unitCost": "سعر الوحدة", "refPO": "أمر الشراء المرجعي", "activeVendors": "الموردين النشطين" },
        "messages": { "reqFields": "رقم الصنف والوصف حقول إلزامية!", "fetchingAttributes": "جاري جلب الخصائص...", "attributesLoaded": "تم تحميل التصنيف والخصائص", "failedAttributes": "فشل في تحميل الخصائص", "stockMsgTitle": "رسالة المخزون", "stockMsgDesc": "تحديث هذه الوحدات سيؤثر على جميع مخازن المواقع المرتبطة.", "noInventory": "لا توجد سجلات مخزون لهذا الصنف.", "noSpecs": "لا توجد مواصفات فنية محددة.", "noBom": "لا توجد مكونات تجميع (BOM) محددة.", "noVendors": "لم يتم العثور على سجلات مشتريات أو موردين." },
        "swal": { "deleteText": "أنت على وشك حذف الصنف {{num}}. لا يمكن التراجع عن هذا الإجراء!" }
      },
      "changePassword": {
        "title": "تغيير كلمة المرور",
        "currentPwd": "كلمة المرور الحالية",
        "newPwd": "كلمة المرور الجديدة",
        "confirmPwd": "تأكيد كلمة المرور الجديدة",
        "securityTitle": "التحقق الأمني",
        "googleAuthMsg": "أدخل الرمز المكون من 6 أرقام من تطبيق Google Authenticator لتأكيد التغيير.",
        "emailOtpMsg": "تم إرسال رمز التحقق (OTP) إلى بريدك الإلكتروني.",
        "btnCancel": "إلغاء",
        "btnUpdate": "تحديث كلمة المرور",
        "btnVerify": "تأكيد وتغيير",
        "btnBack": "رجوع",
        "errMismatch": "كلمتا المرور الجديدتان غير متطابقتين!",
        "errLength": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
        "msgVerifyReq": "يرجى التحقق من هويتك للمتابعة.",
        "msgSuccess": "تم تغيير كلمة المرور بنجاح!",
        "errFailed": "فشل في تغيير كلمة المرور."
      },
      "userDetails": {
        "titleNew": "مستخدم جديد",
        "titleEdit": "الأمان / المستخدمين",
        "btnSave": "حفظ المستخدم",
        "saving": "جاري الحفظ...",
        "secIdent": "بيانات المستخدم الأساسية",
        "lblLoginId": "معرف تسجيل الدخول",
        "lblFullName": "الاسم بالكامل",
        "lblDisplayName": "الاسم المعروض",
        "lblEmail": "البريد الإلكتروني",
        "lblPassword": "كلمة المرور",
        "lblActive": "حالة الحساب (نشط)",
        "secAccess": "الأمان والتحكم في الوصول",
        "lblPrimaryRole": "صلاحية الدور الأساسي",
        "lblSecRoles": "صلاحيات الأدوار الإضافية",
        "lblDefOrg": "المؤسسة الافتراضية",
        "lblDefSite": "الموقع الافتراضي",
        "secDelegation": "تفويض الأعمال (الإنابة)",
        "lblDelegateTo": "تفويض العمل إلى",
        "lblStartDate": "تاريخ ووقت البدء",
        "lblEndDate": "تاريخ ووقت الانتهاء"
      },
      "receivingDetails": {
        "errLoadLines": "فشل في تحميل بنود أمر الشراء",
        "errMissingDist": "يرجى تحديد المستودع والكمية لجميع البنود",
        "errInspMandatory": "قرار الفحص الفني إلزامي لهذا الصنف",
        "errRejectExceeds": "تأكد من الكميات المرفوضة (لا يمكن أن تتجاوز الكمية الواصلة)",
        "msgSuccess": "تم تنفيذ العملية بنجاح!",
        "msgAutoClosed": "تم الإغلاق التلقائي لـ: ",
        "swalAssignTitle": "تعيين المستودع",
        "swalAssignText": "الصنف {{item}} غير معين حالياً للمستودع {{loc}}. هل تريد تعيينه الآن وإكمال الاستلام؟",
        "swalAssignBtn": "نعم، قم بالتعيين والاستلام",
        "errUnexpected": "حدث خطأ غير متوقع أثناء الاستلام",
        "hubTitle": "مركز الاستلام الجماعي",
        "poRef": "مرجع أمر الشراء: ",
        "btnExecuting": "جاري التنفيذ...",
        "btnConfirm": "تأكيد الاستلام",
        "tblItemsPending": "الأصناف المعلقة للاستلام",
        "colItemDetails": "تفاصيل الصنف",
        "colBalance": "الرصيد المتبقي",
        "lblQualityCheck": "مطلوب فحص جودة",
        "lblUnits": "وحدة",
        "msgNoPending": "لا توجد أصناف معلقة",
        "lblLandedCost": "التكلفة الإضافية (الشحن والجمارك)",
        "lblBaseCost": "التكلفة الأساسية للوحدة",
        "lblStoreMatrix": "جدول التوزيع على المستودعات",
        "btnSplitStore": "تقسيم الكمية",
        "colStoreroom": "المستودع",
        "colArrived": "الكمية المستلمة",
        "colRejected": "الكمية المرفوضة",
        "plcClickSearch": "اضغط للبحث <-",
        "lookupSelectStore": "اختر المستودع",
        "lblQcMatrix": "لوحة قرار فحص الجودة",
        "optSelectDecision": "-- إلزامي: حدد قرار الفحص --",
        "optPassed": "مقبول بالكامل (تم الاجتياز)",
        "optFailed": "مرفوض بالكامل (إرجاع للمورد)",
        "optPartial": "قبول جزئي (سيتم مراجعة حقل المرفوض)",
        "lblInvValuation": "تقييم المخزون (متوسط التكلفة للوحدة)",
        "lblNetArrived": "صافي الكمية المقبولة",
        "msgSelectLine": "اختر أحد بنود أمر الشراء للبدء في المعالجة"
      },
      "userList": {
        "title": "أمان المستخدمين",
        "plcSearch": "ابحث عن مستخدم أو بريد إلكتروني...",
        "btnNewUser": "مستخدم جديد",
        "colUserId": "معرف المستخدم",
        "colFullName": "الاسم بالكامل",
        "colRole": "الصلاحية",
        "colSite": "الموقع",
        "colStatus": "الحالة",
        "colEmail": "البريد الإلكتروني",
        "msgSyncing": "جاري مزامنة بيانات الأمان...",
        "lblNoRole": "بدون صلاحية",
        "lblAll": "الكل",
        "lblTotalUsers": "إجمالي المستخدمين:",
        "lblPage": "صفحة",
        "errLoadUsers": "خطأ في تحميل المستخدمين"
      },
      "crafts": {
        "headers": {
          "craftList": "دليل الحرف والمهن"
        },
        "actions": {
          "newCraft": "حرفة جديدة"
        },
        "tables": {
          "craftCode": "كود الحرفة",
          "description": "الوصف",
          "stdRate": "الأجر القياسي/ساعة",
          "site": "الموقع",
          "org": "المؤسسة"
        },
        "messages": {
          "loadFailed": "فشل في تحميل بيانات الحرف"
        },
        "headers": {
          "craftList": "دليل الحرف والمهن"
        },
        "tabs": {
          "skills": "مهارات ومستويات الحرفة"
        },
        "sections": {
          "costing": "التكاليف",
          "control": "التحكم"
        },
        "actions": {
          "newCraft": "حرفة جديدة",
          "addSkill": "إضافة مستوى مهارة"
        },
        "tables": {
          "craftCode": "كود الحرفة",
          "description": "الوصف",
          "stdRate": "الأجر القياسي/ساعة",
          "site": "الموقع",
          "org": "المؤسسة"
        },
        "fields": {
          "stdHourlyRate": "الأجر القياسي للساعة",
          "skillLevel": "مستوى المهارة (مثال: خبير، مبتدئ)",
          "hourlyRate": "أجر الساعة"
        },
        "placeholders": {
          "enterLevel": "أدخل المستوى..."
        },
        "messages": {
          "loadFailed": "فشل في تحميل بيانات الحرف",
          "autoCalc": "محسوب تلقائياً من إجمالي أجور المهارات",
          "noSkills": "لم يتم تعريف أي مهارات حتى الآن"
        }
      },
      "persons": {
        "headers": {
          "directory": "دليل الأشخاص"
        },
        "actions": {
          "newPerson": "شخص جديد", "addContact": "إضافة جهة اتصال"
        },
        "tables": {
          "personId": "معرف الشخص",
          "name": "الاسم المعروض",
          "site": "الموقع",
          "email": "البريد الإلكتروني",
          "phone": "الهاتف"
        },
        "messages": {
          "loadFailed": "فشل في تحميل قائمة الأشخاص"
        },
        "tabs": {
          "profile": "الملف الشخصي",
          "contact": "جهات الاتصال",
          "access": "صلاحيات النظام"
        },
        "sections": {
          "personalInfo": "البيانات الشخصية",
          "statusControl": "الحالة والتحكم",
          "contactsDirectory": "جهات الاتصال المرتبطة"
        },
        "fields": {
          "location": "الموقع",
          "firstName": "الاسم الأول",
          "lastName": "اسم العائلة",
          "title": "المسمى الوظيفي",
          "department": "القسم",
          "currentStatus": "الحالة الحالية",
          "contactName": "اسم جهة الاتصال",
          "position": "المنصب",
          "email": "البريد الإلكتروني",
          "phone": "الهاتف الأرضي",
          "mobile": "الجوال",
          "primary": "رئيسي",
          "address": "العنوان",
          "city": "المدينة",
          "country": "الدولة",
        },
        "messages": {
          "noContacts": "لم يتم إضافة أي جهات اتصال",
          "accessControlled": "يتم التحكم في صلاحيات النظام عبر شاشة أمان المستخدمين"
        }
      },
      "jp": {
        "list": {
          "title": "دليل خطط العمل",
          "new_plan": "خطة جديدة",
          "filter_jp": "تصفية الخطط...",
          "search_desc": "بحث في الوصف...",
          "filter_site": "الموقع...",
          "no_records": "لا توجد خطط عمل",
          "fetch_error": "فشل تحميل خطط العمل"
        },
        "fields": {
          "jpnum": "رقم الخطة",
          "description": "الوصف",
          "status": "الحالة",
          "revision": "المراجعة",
          "site": "الموقع"
        },
        "details": {
          "load_error": "فشل تحميل خطة العمل",
          "delete_warn": "أنت على وشك حذف خطة العمل {{jpnum}}. لا يمكن التراجع عن هذا الإجراء!"
        },
        "tabs": {
          "job_plan": "خطة العمل",
          "plans": "الخطط",
          "assets": "الأصول"
        },
        "subtabs": {
          "tasks": "المهام",
          "labor": "العمالة",
          "materials": "المواد",
          "tools": "الأدوات"
        },
        "sections": {
          "details": "تفاصيل الخطة",
          "responsibility": "المسؤولية",
          "woassets": "أصول العمل وخطط السلامة"
        },
        "fields": {
          "jpnum": "رقم الخطة",
          "status": "الحالة",
          "description": "الوصف",
          "template_type": "نوع القالب",
          "duration": "المدة (ساعات)",
          "supervisor": "المشرف",
          "class": "هيكل التصنيف",
          "safety_plan": "خطة السلامة",
          "revision": "المراجعة"
        },
        "table": {
          "seq": "التسلسل",
          "duration": "المدة",
          "craft": "المهنة",
          "labor": "العامل",
          "qty": "الكمية",
          "hours": "الساعات",
          "rate": "المعدل",
          "item": "العنصر",
          "unitcost": "تكلفة الوحدة",
          "tool": "الأداة"
        }
      },
      "meters": {
        "list": {
          "title": "تعريفات العدادات",
          "search": "تصفية بالرقم أو الاسم...",
          "new_meter": "عداد جديد",
          "no_records": "لا توجد عدادات مطابقة"
        },
        "fields": {
          "meter_num": "رقم العداد",
          "meter_name": "اسم العداد",
          "type": "النوع",
          "uom": "وحدة القياس",
          "active": "نشط؟",
          "remarks": "ملاحظات",
          "last_reading": "آخر قراءة",
          "last_date": "تاريخ آخر قراءة",
          "rollovers": "إجمالي مرات التصفير"
        },
        "tabs": {
          "meter": "تفاصيل العداد",
          "where_used": "أين يستخدم"
        },
        "sections": {
          "info": "معلومات العداد",
          "additional": "تفاصيل إضافية",
          "stats": "إحصائيات العداد"
        },
        "where_used": {
          "linked_assets": "الأصول المرتبطة",
          "linked_locations": "المواقع المرتبطة",
          "linked_items": "العناصر المرتبطة",
          "searching": "🔍 جاري البحث في النظام...",
          "no_assoc": "لا توجد ارتباطات في هذه الفئة.",
          "asset_num": "رقم الأصل",
          "site": "الموقع",
          "status": "الحالة",
          "location": "المكان",
          "item_num": "رقم العنصر",
          "category": "الفئة"
        }
      },
      "asset_categories": {
        "list": {
          "title": "فئات الأصول",
          "search": "البحث في الفئات...",
          "new_category": "فئة جديدة",
          "no_records": "لا توجد فئات مطابقة"
        },
        "fields": {
          "category_id": "كود الفئة",
          "description": "الوصف",
          "dep_method": "طريقة الإهلاك",
          "life": "العمر (سنوات)"
        }
      },
      "export": {
        "loading": "جاري استخراج البيانات...",
        "success": "تم التصدير بنجاح!",
        "error": "حدث خطأ أثناء تصدير البيانات."
      },
      "labor": {
        "list": {
          "title": "سجل العمالة",
          "new": "عامل جديد",
          "total": "إجمالي العمالة",
          "unique_crafts": "الحرف بالصفحة",
          "no_records": "لا توجد سجلات عمالة مطابقة لبحثك."
        },
        "tabs": {
          "main": "الأساسية",
          "person": "الشخص",
          "crafts": "المهن",
          "log": "السجل"
        },
        "sections": {
          "basic": "المعلومات الأساسية",
          "status": "الحالة والمنظمة",
          "additional_crafts": "المهن الإضافية والمهارات المتخصصة"
        },
        "fields": {
          "personid": "المرجع الشخصي",
          "primary_craft": "الحرفة الأساسية",
          "actual_rate": "الأجر الفعلي (بالساعة)",
          "skill": "مستوى المهارة",
          "rate": "أجر الساعة",
          "primary": "أساسي؟",
          "laborcode": "كود العامل",
          "fullname": "الاسم الكامل",
          "craft": "الحرفة / التخصص"
        },
        "actions": {
          "add_craft": "إضافة حرفة"
        },
        "lookup": {
          "person": "اختر الشخص",
          "craft": "اختر الحرفة",
          "skill": "اختر مستوى المهارة"
        },
        "messages": {
          "no_crafts": "لا توجد ارتباطات مهنية"
        },
        "details": {
          "delete_warn": "لن تتمكن من استعادة هذا السجل!"
        }
      },
      "sr": {
        "list": {
          "title": "تتبع طلبات الخدمة",
          "new": "طلب جديد"
        },
        "messages": {
          "no_records": "لا توجد طلبات خدمة مطابقة"
        },
        "tabs": {
          "main": "طلب الخدمة",
          "related": "السجلات المرتبطة"
        },
        "sections": {
          "requester": "مقدم الطلب وبيانات الاتصال",
          "problem": "مواصفات المشكلة",
          "logistics": "الخدمات اللوجستية والأولوية"
        },
        "fields": {
          "srnum": "رقم الطلب",
          "description": "الوصف",
          "reportedby": "مُقدم الطلب",
          "reportdate": "تاريخ التقديم",
          "priority": "الأولوية",        
          "phone": "الهاتف",
          "email": "البريد الإلكتروني",
          "asset": "الأصل",
          "location": "الموقع",
          "long_desc": "وصف المشكلة بالتفصيل",
          "priority_1": "1 - طارئ (فوري)",
          "priority_2": "2 - عالي (نفس اليوم)",
          "priority_3": "3 - متوسط (72 ساعة)",
          "priority_4": "4 - منخفض (مجدول)"
        },
        "lookup": {
          "person": "اختر الشخص",
          "asset": "اختر الأصل",
          "location": "اختر الموقع"
        },
        "details": {
          "delete_new_only": "يمكن حذف الطلبات الجديدة (NEW) فقط",
          "delete_warn": "سيتم حذف طلب الخدمة هذا نهائياً.",
          "wf_tip": "مسار العمل التلقائي: بعد الحفظ، استخدم زر 'توجيه مسار العمل' لإرسال هذا الطلب للمراجعة الفنية.",
          "wo_tip": "تلميح: يمكنك إنشاء أمر عمل من هذا الطلب عبر إجراءات مسار العمل أو سكريبت 'إنشاء أمر عمل'."
        },
        "related": {
          "title": "أوامر العمل المرتبطة بالطلب:",
          "wonum": "رقم أمر العمل",
          "worktype": "نوع العمل",
          "no_wo": "لم يتم إنشاء أي أوامر عمل لهذا الطلب بعد.",
          "go_to_wo": "الذهاب لأمر العمل"
        }
      },
      "invusage": {
        "list": {
          "title": "سجل استخدام المخزون",
          "new": "إنشاء حركة جديدة"
        },
        "types": {
          "all": "الكل",
          "issue": "صرف",
          "transfer": "تحويل",
          "return": "إرجاع"
        },
        "tabs": {
          "lines": "سطور الاستهلاك",
          "log": "سجل الحركة"
        },
        "details": {
          "summary": "ملخص السطور",
          "transfer_dest": "تفاصيل جهة التحويل",
          "financial": "التحميل المالي والمرجع"
        },
        "actions": {
          "add_item": "إضافة صنف",
          "add_part": "إضافة قطعة",
          "select_mr": "اختيار طلب صرف"
        },
        "fields": {
          "stock_item": "صنف المخزون",
          "issueunit": "وحدة الصرف",
          "qty": "الكمية",
          "unitcost": "تكلفة الوحدة",
          "linecost": "إجمالي قيمة السطر",
          "target_bin": "الرف المستهدف في",
          "target_loc": "الموقع المستهدف",
          "assetnum": "رقم الأصل",
          "wonum": "مرجع أمر الشغل",
          "glaccount": "حساب الخصم (GL)",
          "usagenum": "رقم الحركة",
          "type": "النوع",
          "fromstore": "من مخزن",
          "lines": "السطور",
          "enterby": "مُدخل بواسطة"
        },
        "placeholders": {
          "select_item": "اختر الصنف...",
          "dest_bin": "أدخل الرف المستهدف...",
          "choose_loc": "اختر الموقع",
          "select_asset": "اختر الأصل",
          "charge_wo": "تحميل على أمر شغل"
        },
        "lookup": {
          "store": "المخازن",
          "dest_store": "مخازن الوجهة",
          "mr": "اختر طلب صرف معتمد",
          "item": "بحث المخزون",
          "loc": "مواقع النظام",
          "asset": "سجل الأصول",
          "wo": "أوامر الشغل"
        },
        "messages": {
          "req_fromstore": "يرجى اختيار المخزن أولاً!",
          "mr_loaded": "تم تحميل الأصناف من طلب الصرف:",
          "mr_fail": "فشل تحميل أصناف طلب الصرف",
          "insufficient_title": "رصيد غير كافٍ!",
          "available": "المتاح",
          "create_pr": "إنشاء طلب شراء (PR)؟",
          "btn_create_pr": "إنشاء طلب شراء",
          "processing": "جاري معالجة تسويات المخزون...",
          "inventory_updated": "تم تحديث مستويات المخزون بنجاح",
          "cant_delete_comp": "لا يمكن حذف حركة مكتملة!",
          "delete_warn": "سيتم حذف حركة المسودة هذه نهائياً.",
          "req_fields": "الوصف والمخزن حقول مطلوبة!",
          "req_transfer": "مخزن الوجهة مطلوب في حركات التحويل!",
          "locked_title": "السجل مقفل",
          "locked_text": "هذه الحركة مكتملة ولا يمكن تعديلها أو التراجع عنها.",
          "cant_save_comp": "لا يمكن حفظ التعديلات على سجل مكتمل",
          "balance_move": "ملاحظة: سيتم نقل الرصيد إلى",
          "upon_comp": "عند الاكتمال."
        }
      },
      "downtime": {
        "title": "الإبلاغ عن توقف الأصل",
        "subtitle": "نظام إدارة الأصول",
        "asset": "الأصل",
        "status": "تسجيل التوقف",
        "start": "تاريخ ووقت البدء",
        "end": "تاريخ الانتهاء (اختياري)",
        "type": "نوع التوقف",
        "types": {
          "unplanned": "غير مخطط (عطل)",
          "planned": "مخطط (صيانة دورية)"
        },
        "duration": "المدة المحسوبة",
        "hours": "ساعة",
        "prod_impact": "توقف تشغيلي (تأثير على الإنتاج)",
        "btn_commit": "حفظ التغييرات",
        "messages": {
          "recording": "جاري تسجيل التوقف...",
          "success": "تم تسجيل التوقف بنجاح",
          "validation_error": "خطأ في التنسيق: تأكد من جميع الحقول",
          "server_error": "خطأ في الخادم: 500"
        },
        "history": {
          "title": "سجل توقف الأصل",
          "subtitle": "تتبع أداء الأصل",
          "no_records": "لا توجد أحداث توقف مسجلة لهذا الأصل.",
          "duration_hrs": "المدة (ساعات)",
          "type_reason": "النوع/السبب",
          "impact": "التأثير",
          "reported_by": "أبلغ بواسطة",
          "still_down": "لا يزال متوقفاً",
          "prod_loss": "خسارة إنتاج",
          "technical": "عطل فني",
          "active_down": "توقف نشط",
          "resolved": "تم الحل"
        }
      },
      "incidents": {
        "list": {
          "title": "سجل البلاغات والأحداث",
          "new": "بلاغ جديد"
        },
        "fields": {
          "ticket_id": "رقم البلاغ",
          "priority": "الأولوية",
          "reported_by": "أُبلغ بواسطة"
        },
        "details": {
          "ticket": "تذكرة البلاغ",
          "general": "الوصف العام",
          "detailed": "التفاصيل الدقيقة",
          "context": "السياق والحالة",
          "linked_asset": "الأصل المرتبط",
          "workorder": "أمر الشغل",
          "delete_warn": "أنت على وشك حذف البلاغ رقم {{ticket}} نهائياً. لا يمكن التراجع عن هذا الإجراء!"
        },
        "lookup": {
          "asset": "اختر الأصل المرتبط",
          "loc": "اختر الموقع"
        }
      },
      "tools": {
        "list": {
          "title": "سجل الأدوات",
          "new": "أداة جديدة"
        },
        "fields": {
          "toolnum": "رقم الأداة",
          "type": "النوع",
          "is_stocked": "مخزنة؟"
        },
        "tabs": {
          "tool": "الأداة",
          "stores": "المخازن",
          "vendors": "الموردين",
          "specs": "المواصفات",
          "quals": "المؤهلات"
        },
        "sections": {
          "config": "إعدادات الأداة",
          "inventory": "أرصدة المخزون",
          "vendors": "سجل المشتريات والموردين",
          "quals": "المؤهلات المطلوبة"
        },
        "fields": {
          "toolnum": "رقم الأداة",
          "type": "نوع الأداة",
          "issueunit": "وحدة الصرف",
          "is_stocked": "أداة مخزنة؟",
          "rotating": "عنصر دوار؟",
          "calib_req": "تتطلب معايرة؟",
          "mfg": "الشركة المصنعة",
          "model": "رقم الموديل",
          "class": "التصنيف",
          "active_vendors": "الموردين النشطين"
        },
        "actions": {
          "add_store": "إضافة لمخزن",
          "add_qual": "إضافة مؤهل"
        },
        "tables": {
          "storeroom": "المخزن",
          "balance": "الرصيد",
          "attr": "السمة",
          "value": "القيمة",
          "uom": "وحدة القياس",
          "qual": "المؤهل",
          "vendor_id": "رقم المورد",
          "vendor_name": "اسم المورد",
          "unitcost": "تكلفة الوحدة",
          "qty": "الكمية",
          "po": "أمر الشراء"
        },
        "placeholders": {
          "toolid": "أدخل رقم الأداة...",
          "reg_supplier": "مورد مسجل",
          "adj": "تعديل مخزون"
        },
        "lookup": {
          "type": "أنواع الأدوات",
          "unit": "وحدات الصرف",
          "attr": "السمات"
        },
        "messages": {
          "req_fields": "رقم الأداة والوصف حقول مطلوبة!",
          "delete_warn": "لن تتمكن من التراجع عن هذا الإجراء!",
          "class_loaded": "تم تحميل التصنيف والسمات",
          "stocked_note": "ملاحظة: تتم إدارة الأدوات المخزنة عبر المخازن وتتطلب سجل مخزون لتتبع الأرصدة.",
          "no_stock": "لا توجد أرصدة"
        }
      },
      "inventory": {
        "list": {
          "title": "سجل المخزون"
        },
        "fields": {
          "itemnum": "رقم الصنف",
          "location": "المخزن",
          "balance": "الرصيد",
          "avgcost": "متوسط التكلفة"
        },
        "details": {
          "profile": "ملف المخزون",
          "reorder_logic": "منطق إعادة الطلب",
          "reorder_pt": "نقطة إعادة الطلب",
          "eoq": "الكمية الاقتصادية للطلب",
          "critical_lvl": "المستوى الحرج",
          "critical_desc": "يتم إنشاء طلب شراء (PR) تلقائياً عندما يصل الرصيد لنقطة إعادة الطلب.",
          "current_stock": "مستوى المخزون الحالي",
          "avail_qty": "الكمية المتاحة",
          "reserved_qty": "الكمية المحجوزة",
          "held_wo": "محتجزة لأوامر الشغل",
          "avg_cost": "متوسط تكلفة الوحدة",
          "avg_cost_desc": "المتوسط المرجح لجميع الاستلامات",
          "total_val": "إجمالي قيمة المخزون",
          "total_val_desc": "الرصيد الحالي × متوسط التكلفة",
          "last_cost": "تكلفة آخر استلام",
          "last_cost_desc": "التكلفة من أحدث أمر شراء",
          "val_method": "طريقة تقييم المخزون",
          "avg_method": "متوسط التكلفة",
          "val_desc1": "يستخدم هذا الصنف طريقة",
          "val_desc2": ". يتم إعادة حساب تكلفة الوحدة تلقائياً عند كل استلام لأمر شراء لتعكس تقلبات أسعار السوق."
        },
        "tabs": {
          "balances": "الأرصدة",
          "trans": "سجل الحركات",
          "costs": "التكاليف"
        },
        "actions": {
          "adjustment": "تسوية المخزون"
        },
        "tables": {
          "qty": "الكمية",
          "actual_cost": "التكلفة الفعلية",
          "reference": "المرجع"
        },
        "messages": {
          "no_trans": "لا يوجد سجل حركات"
        },
        "trans_types": {
          "receipt": "استلام",
          "issue": "صرف",
          "transfer": "تحويل",
          "adjustment": "تسوية"
        }
      },
      "storerooms": {
        "list": {
          "title": "المخازن",
          "new": "مخزن جديد"
        },
        "fields": {
          "location": "المخزن",
          "isdefault": "افتراضي؟",
          "inventory": "المخزون",
          
        },
        "details": {
          "profile": "المخزن",
          "record": "سجل المخزن",
          "gen_settings": "الإعدادات العامة",
          "filtered_by": "مفلتر بـ {{org}}",
          "select_org_first": "اختر المؤسسة أولاً",
          "gl_accounts": "الحسابات المالية (GL)",
          "inv_control": "مراقبة المخزون",
          "inv_control_desc": "سيتم موازنة جميع عمليات صرف واستلام المواد لهذا المخزن مقابل هذه الحسابات.",
          "items_stocked": "الأصناف المخزنة"
        },
        "tabs": {
          "main": "الرئيسية",
          "inventory": "المخزون"
        },
        "fields": {
          "location": "رقم المخزن",
          "isdefault": "مخزن افتراضي؟",
          "useinpo": "يستخدم في طلبات الشراء؟",
          "invowner": "أمين المخزن",
          "controlacc": "حساب المراقبة",
          "shrinkacc": "حساب العجز/الزيادة",
          "glaccount": "الحساب الافتراضي",
          "default": "افتراضي"
        },
        "lookup": {
          "person": "اختر شخص"
        },
        "tables": {
          "itemnum": "رقم الصنف",
          "uom": "الوحدة",
          "curbal": "الرصيد الحالي",
          "reserved": "الكمية المحجوزة"
        },
        "messages": {
          "req_fields": "رقم المخزن مطلوب!",
          "req_org_site": "المؤسسة والموقع مطلوبان!",
          "delete_warn": "أنت على وشك حذف المخزن {{store}}. لا يمكن التراجع عن هذا الإجراء!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "مكتبة أكواد الأعطال",
          "new": "فئة أعطال جديدة"
        },
        "details": {
          "profile": "فئة الأعطال"
        },
        "fields": {
          "class": "فئة العطل",
          "code": "الكود",
          "desc_tech": "الوصف / الاسم الفني"
        },
        "tables": {
          "problems": "المشكلات (طبيعة العطل)",
          "causes": "الأسباب (السبب الجذري)",
          "remedies": "الحلول (الإجراء المتبع)"
        },
        "placeholders": {
          "class": "مثال: PUMP-FAIL",
          "desc_tech": "أدخل وصفاً تفصيلياً لهرمية الأعطال هذه...",
          "code": "أدخل الكود...",
          "desc": "الوصف الفني..."
        },
        "messages": {
          "req_class": "كود فئة العطل مطلوب!",
          "delete_warn": "أنت على وشك حذف فئة الأعطال {{class}}. لا يمكن التراجع عن هذا الإجراء!"
        }
      },
      "sla": {
        "list": {
          "title": "اتفاقية مستوى الخدمة",
          "new": "إنشاء اتفاقية مستوى خدمة جديدة"
        },
        "header": {
          "slanum": "معرف",
          "ranking": "ترتيب"
        }
      },
      "scheduler": {
        "title": "الجدولة وتوزيع المهام",
        "ai_optimize": "تحسين آلي بالذكاء الاصطناعي",
        "publish": "نشر الجدول",
        "kpi_scheduled": "الأعمال المجدولة",
        "kpi_issues": "مشاكل الجدولة",
        "kpi_utilization": "إجمالي الموارد",
        "kpi_emergencies": "حالات الطوارئ",
        "no_data": "لا توجد أوامر شغل مجدولة.",
        "no_resources": "لا توجد بيانات لسعة الموارد.",
        "fetch_error": "فشل في تحميل بيانات الجدولة.",
        "optimizing": "الذكاء الاصطناعي يقوم بتسوية أحمال الموارد...",
        "optimize_fail": "فشل تحسين الذكاء الاصطناعي."
      },
      "features": {
        "title": "كتالوج المعالم الخطية",
        "feature_id": "كود المعلم",
        "description": "الوصف",
        "type": "نوع المعلم",
        "point": "نقطي (مثل: محبس)",
        "linear": "ممتد (مثل: نوع مادة الماسورة)",
        "error_in_use": "لا يمكن الحذف: هذا المعلم مستخدم حالياً على خط أنابيب."
      },
      "audit": {
        "title": "مستكشف سجلات التدقيق",
        "history_for": "السجل التاريخي لـ",
        "retrieving": "جاري استرجاع سجلات التدقيق...",
        "no_records": "لا توجد سجلات تدقيق مرتبطة بهذا العنصر"
      },

    }
  },
  // 🇫🇷 Français
  fr: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "Excellence des Actifs", version: "Teknova v1.0.4" },
      search: { placeholder: "Rechercher des modules..." },
      menu: {
        settings: "Paramètres", organization: "Organisation", domains: "Domaines", field_config: "Config des Champs", classifications: "Classifications", importer: "Importateur Universel", cobie: "Gestionnaire COBie", workflow: "Moteur de Workflow", scripts: "Scripts d'Action",
        analytics: "Analytique", dashboards: "Tableaux de Bord BI", report_designer: "Concepteur de Rapports", report_wizard: "Assistant de Rapports",
        assets: "Actifs", asset_registry: "Registre des Actifs", locations: "Emplacements", categories: "Catégories d'Actifs", meters: "Compteurs", failure_codes: "Codes de Panne",
        work_management: "Gestion du Travail", wo_tracking: "Suivi des Bons de Travail", labor_reporting: "Planificatrice",
        resources: "Ressources", crafts: "Métiers", labor: "Main-d'œuvre", person: "Personne",
        service_desk: "Centre de Services", service_requests: "Demandes de Service", incidents: "Registre d'Incidents",
        procurement: "Achats", po: "Commandes d'Achat", pr: "Demandes d'Achat", rfq: "Demande de Prix", receiving: "Réception", vendors: "Fournisseurs",
        contracts: "Contrats", contracts_master: "Registre des Contrats", sla: "SLA",
        inventory: "Inventaire", item_master: "Registre des Articles", tools: "Outils", balances: "Stocks", transfers: "Transferts", storerooms: "Magasins",
        planning: "Planification", pm_schedules: "Calendriers PM", safety_plans: "Plans de Sécurité", hazards: "Dangers", precautions: "Précautions", tagouts: "Étiquetage", job_plans: "Plans de Travail",
        security: "Sécurité", user_list: "Liste des Utilisateurs", groups: "Groupes de Sécurité", "recent": "Visités Récemment"
      },
      user_settings: { title: "Paramètres utilisateur", default_info: "Informations par défaut", personal_info: "Informations personnelles", password_info: "Mot de passe", sign_out: "Déconnexion", system_info: "Informations système" },
      notifications: { title: "Tâches reçues", new_alerts: "Nouveau", empty: "Boîte de réception propre", view_all: "Voir toutes les activités" },
      sidebar: { queries: "Requêtes", all_assets: "Tous les Actifs", operating_assets: "Actifs Opérationnels", critical_assets: "Actifs Critiques", my_bookmarks: "Mes Signets", common_actions: "Actions Communes", new: "Nouveau", move_assets: "Déplacer Actifs", print_barcodes: "Imprimer Codes", create_report: "Créer Rapport", wo_queries: "Requêtes BT", all_wo: "Tous les Bons", waiting_approval: "Attente Approbation", wip: "En Cours", completed_today: "Terminé Aujourd'hui", bulk_approve: "Approbation Groupée", record_actions: "Actions Fiche", save: "Enregistrer", delete: "Supprimer", workflow_status: "Workflow / État", change_status: "Changer État", view_history: "Voir Historique", item_ops: "Opérations Article", add_to_storeroom: "Ajouter au Magasin", inv_ops: "Opérations Stock", reorder: "Réapprovisionner", tax_ops: "Taxes", tax_category: "Catégorie Taxe", create_po: "Créer BC", settings_group: "Paramètres", system_settings: "Paramètres Système", email_settings: "Paramètres Email", asset_ops: "Opérations Actif", meter_readings: "Lectures Compteur", hist_readings: "Hist. Lectures", report_downtime: "Signaler Arrêt", downtime_hist: "Hist. Arrêts", move_mod_asset: "Déplacer/Modif", asset_move_hist: "Hist. Déplacements", create_related: "Créer Lié", create_incident: "Créer Incident", view_inc_hist: "Hist. Incidents", create_wo: "Créer BT", sr: "Demande Service", apply_sla: "Appliquer SLA", approve_wo: "Approuver BT", start_work: "Commencer", complete_work: "Terminer", close_wo: "Clôturer BT", analytics: "Analytique", wf_history: "Hist. Workflow", history_log: "Journal", wo_costs: "Coûts BT", purchase_info: "Infos Achat", all_records: "Tous Dossiers", find_nav: "Trouver Item", more_actions: "Plus d'Actions", settings: "Paramètres", export_data: "Exporter", audit_log: "Audit", share_app: "Partager" },
      apps: {
        ORGANIZATION: "Organisations", ASSET: "Actifs", LOCATION: "Emplacements", WORKORDER: "Bons de Travail", INVENTORY: "Inventaire", CLASSIFICATION: "Classifications", VENDOR: "Fournisseurs", METER: "Compteurs", DOMAINS: "Domaines", CRAFTS: "Métiers", STOREROOMS: "Magasins", ITEMS: "Articles", INVENTORYUSAGE: "Usage Stock", MR: "Demandes Mat.", PR: "Demandes d'Achat", PO: "Commandes", LABOR: "Main-d'œuvre", PM: "Calendriers PM", SAFETY: "Plans Sécurité", HAZARD: "Dangers", TAGOUT: "Étiquetage", PRECUTION: "Précautions", SR: "Demandes Service", INCIDENTS: "Incidents", ASSET_CATEGORIES: "Catégories d'Actifs", FAILURECLASS: "Codes de Panne", RFQ: "Appel d'Offres", CONTRACT: "Contrats", SLA: "Accord de niveau de service", FAILURE_CODES: "Codes d'erreur",
        "VENDORS": "Fournisseurs", "TAGOUTS": "Consignations", "PRECAUTIONS": "Précautions", "INCIDENTS": "Incidents", "JOBPLAN": "Gammes Opératoires", "ROLE": "Rôles", "TOOLS": "Outils", "USER": "Utilisateurs",
      },
      dashboard: { tab_bi: "Modèle KPI", tab_inbox: "Boîte de Workflow", advanced_analytics: "Analyses Avancées", workflow_center: "Centre d'Exécution", active_tasks: "Tâches Actives", history_tasks: "Historique", no_data: "Aucune donnée trouvée", take_action: "Agir", previous: "Précédent", next: "Suivant", showing: "Affichage", of: "sur", actual: "Réel", target: "Cible", kpi_graph: "Graphique KPI" },
      username: "Identifiant",
      password: "Mot de passe",
      login_btn: "Se connecter",
      forgot_pwd: "Mot de passe oublié?",
      login: {
        id_placeholder: "Entrez votre identifiant",
        error_msg: "Identifiant ou mot de passe invalide",
        server_error: "Échec de la connexion au serveur",
        just_smart: "Simplement Intelligent"
      },
      organizations: { title: "Organisations", org_id: "Organisation", description: "Description", active: "Actif?" },
      org_detail: { org_label: "Organisation", tabs: { organization: "Organisation", sites: "Sites", map: "Geolocation Map" }, fields: { currency1: "Devise de Base 1", currency2: "Devise de Base 2", item_set: "Lot d'Articles", company_set: "Lot de Sociétés", item_status: "Statut par Défaut", active: "Actif?" }, descs: { currency1: "Devise Principale", currency2: "Devise Secondaire", item_set: "LOT ARTICLES", company_set: "LOT SOCIÉTÉS" }, lookups: { currency: "Devise", item_set: "Lot Articles", company_set: "Lot Sociétés", status: "Statut", governorate: "Gouvernorat" }, sites: { management: "Gestion des Sites", new_row: "Nouvelle Ligne", of: "de", site_id: "ID Site", description: "Description", active: "Actif?", action: "Action", site_details: "Détails du Site", state: "État / Gouvernorat", contact: "Contact Principal", fin_info: "Infos Financières", yearly_budget: "Budget Annuel", monthly_budget: "Budget Mensuel", utilization: "Utilisation Annuelle", fin_health: "Santé financière stable." }, toasts: { id_required: "ID requis!", saving: "Enregistrement...", success: "Enregistré avec succès!", fail: "Échec" } },
      domains: { title: "Domaines", find_placeholder: "Rechercher...", new_domain: "Nouveau Domaine", domain_id: "Domaine", description: "Description", type: "Type", values: "Valeurs" ,
        save_btn: "Enregistrer", desc_placeholder: "Description du domaine", synonym_values: "Valeurs Synonymes", new_row: "Nouvelle ligne", internal_val: "Valeur interne", external_desc: "Description externe", default: "Par défaut?", action: "Action", no_values: "Aucune valeur définie.", toasts: { loading: "Chargement...", load_fail: "Échec du chargement", id_required: "ID requis!", saving: "Enregistrement...", save_success: "Enregistré!", save_fail: "Échec" } },
      classifications: { parent: "Classification Parente", order: "Ordre", hierarchy: "Structure", hierarchy: "Chemin de hiérarchie", parent: "Classification parente", gen_desc: "Générer la description?", use_with: "Utiliser avec des objets", attributes: "Attributs", attr_id: "ID d'attribut", section: "Section", uom: "unité de mesure" },
      bim: { title: "Intégrateur BIM Pro", subtitle: "Mappage Revit vers COBie avancé", waiting_translation: "En attente de traduction du modèle...", tabs: { "3d": "Vue 3D", data: "Table de données" }, preview_table_title: "Aperçu des composants COBie", controls: { destination: "Destination", select_site: "Sélectionner le site", uploads: "Chargements", select_cobie: "Choisir COBie", upload_revit: "Charger Revit", models_ready: "Modèles prêts", preview_list: "Liste d'aperçu", finalizing: "Synchronisation...", commit: "Valider l'intégration BIM" }, table: { asset_name: "Nom de l'actif", location: "Espace / Lieu" } },
      importer: { title: "Chargeur de données universel", target_table: "Table cible", download_template: "Télécharger le modèle", upload_instruction: "Sélectionnez le fichier Excel", field_mapping: "Mappage des champs", excel: "Excel", ignore: "Ignorer", preview_title: "Aperçu", execute_btn: "EXÉCUTER L'IMPORTATION" },
      workflow: { title: "Moteur de Workflow", subtitle: "Centre d'automatisation", export_btn: "Exporter CSV", new_process: "Nouveau Processus", loading: "Chargement...", unnamed: "Processus sans nom", linked_to: "Lié à", create_path: "Créer un chemin", 
        designer_title: "Concepteur de Logique (Loopback Activé)", publish_btn: "PUBLIER", loading_designer: "Reconstruction du chemin...", logic_palette: "Palette Logique", config_title: "Configuration", node_label: "Étiquette", assign_roles: "Assigner des rôles",  post_action: "Scripts post-action", select_lookup: "CHOISIR DANS LA LISTE", script_hint: "* Plusieurs scripts séparés par des virgules.", status_auto: "Action d'état auto", trigger: "Déclencheur", target_status: "État cible", cond_expr: "Expression conditionnelle (Python)", escalation: "Escalade (Heures)", select_node: "Sélectionnez un nœud", 
        options: {no_change: "PAS DE CHANGEMENT", change_status: "CHANGER L'ÉTAT", select_status: "CHOISIR L'ÉTAT" },
        lookups: {select_roles: "Chercher des rôles", select_scripts: "Chercher des scripts" },
        swal: { publish_title: "Publier le workflow?", publish_text: "Cela synchronisera les étapes avec la base de données.", confirm_publish: "Oui, publier maintenant", delete_title: "Purger la logique?", delete_text: "Êtes-vous sûr de vouloir supprimer", confirm_delete: "Oui, tout supprimer" },
        toasts: {id_required: "Nom du processus requis", saving: "Synchronisation...", save_success: "Workflow synchronisé! 🚀", save_fail: "Échec de synchronisation", purging: "Suppression...", delete_success: "Workflow supprimé", delete_fail: "Échec de suppression", fetch_fail: "Échec du chargement" } 
      },
      field_config: { title: "Mappage des champs de métadonnées", table_name: "NOM DE LA TABLE", field_name: "NOM DU CHAMP", current_mappings: "MAPPAGES ACTUELS POUR", field: "Champ", linked_domain: "Domaine lié" },
      scripts: {
        title: "SCRIPTS D'ACTION",
        subtitle: "Gérer l'automatisation et les modèles de logique",
        new_btn: "CRÉER UN NOUVEAU SCRIPT",
        search_placeholder: "Rechercher par nom ou objet...",
        table: {
          name: "Nom du script",
          object: "Objet cible",
          created: "Créé le"
        },
        toasts: {
          fetch_fail: "Échec du chargement des scripts"
        },
        safety: { plan_card: "Plans de sécurité associés", active_plan: "Plan de sécurité actif", no_plan: "AUCUN PLAN LIÉ", link_plan: "Lier un plan", change_plan: "Changer le plan", hazard_title: "Risques spécifiques à l'actif", hazard_num: "Risque", hazard_type: "Type / Priorité", no_hazards: "Aucun risque lié.", add_hazard: "Ajouter un risque", loto_title: "Verrouillage / Étiquetage (LOTO)", tag_id: "ID d'étiquetage", req_state: "État requis", no_loto: "Aucun point d'isolation défini.", add_loto: "Ajouter un point d'isolation", applying_proto: "Application du protocole..." }
      },
      studio: { schema_explorer: "EXPLORATEUR DE SCHÉMA", target_context: "Contexte de l'objet cible", name_placeholder: "Nommez votre script...", engine_info: "MOTEUR: PYTHON 3.10", console_title: "Console d'exécution", clear_console: "Effacer la console", field_from: "Champ de", access_col: "Accès à la colonne: ", db_model: "Modèle de base de données", btns: { compile: "COMPILER", compiling: "COMPILATION...", save_deploy: "SAUVEGARDER" }, toasts: { preserved: "Script enregistré!", compiled: "Analyse réussie!" }, console: { init: "Studio initialisé...", schema_sync: "Schéma synchronisé.", schema_fail: "Échec du schéma.", saved_prefix: "Script sauvegardé", error_op: "Erreur de sauvegarde.", compiling: "Analyse en cours...", build_finish: "Construction terminée.", syntax_error: "Erreur de syntaxe.", build_fail: "Échec de construction", analyzing: "Analyse syntaxique..." } },
      reports: { title: "Modèles de rapports", new_btn: "Nouveau rapport", search_placeholder: "Rechercher...", table: { name: "Nom du rapport", ref_obj: "Objet de référence", updated: "Mis à jour" },
        designer: {
          title: "CONCEPTEUR DE RAPPORTS", live_preview: "Aperçu en direct", publish: "Publier le modèle", model_select: "Sélection du modèle", data_explorer: "Explorateur de données", components: "Composants",
          page_break: "Saut de page", is_summary: "Rapport sommaire?", user_params: "Paramètres utilisateur", add_param: "Ajouter un champ", master_info: "Infos Maître", relational_data: "Données liées", detail_tables: "Tables de détails",
          tabs: { body: "Contenu", header: "En-tête", footer: "Pied de page", css: "CSS Global" },
          fields: { wonum: "Numéro de l'OT", assetnum: "Numéro d'immobilisation", desc: "Description", status: "État", asset: "Nom de l'actif", location: "ID Localisation", tasks_table: "Table des tâches", mat_table: "Matériaux prévus", asset_basic: "Infos Actif", inv_basic: "Infos Inventaire", vend_basic: "Infos Fournisseur" }
        },
        toasts: { load_fail: "Échec du chargement", save_success: "Modèle enregistré! 🚀", save_fail: "Échec de l'enregistrement", clone_success: "Rapport cloné" }
      }, 
      assets: { 
        map: {"gps_location": "Emplacement Géographique (GPS)", "gps_coordinates": "Coordonnées GPS"},
        list: { system_title: "Gestion des actifs", new_asset: "Nouvel actif", all_orgs: "Toutes les org", all_sites: "Tous les sites", db_total: "Total base:", display_page: "Page:", navigate_hint: "Utilisez les flèches pour naviguer", col_site: "Site", col_org: "Org" }, 
        modal: { migration_title: "Migration massive", caution_prefix: "Attention: vous déplacez", caution_suffix: "actifs.", dest_label: "Nouvelle destination", placeholder: "CHOISIR LIEU...", abort: "Abandonner", execute: "Exécuter" },
        headers: { asset_num: "Numéro de l'actif", desc: "Description", status: "État", downtime: "Temps d'arrêt total", site: "Site" },
        tabs: { details: "Détails de l'actif", spare_parts: "Pièces de rechange", safety: "Sécurité", meters: "Compteurs", specs: "Spécifications", history: "Historique de travail", map: "Géomap", bim: "Vue 3D", ai: "Analyse IA", eval: "Évaluation", attachments: "Pièces jointes" },
        sections: { "linear_details": "Détails de référence linéaire", general: "Informations générales", details: "Détails", finance: "Adresse et finance", image: "Image de l'actif", audit: "Info d'audit", bim_info: "Info BIM", reliability: "Analyse de fiabilité" },
        fields: { "is_linear": "Est-ce un actif linéaire ?", "start_measure": "Mesure de début", "end_measure": "Mesure de fin", "measure_unit": "Unité de mesure", "direction": "Direction du flux", type: "Type d'actif", location: "Emplacement", parent: "Actif parent", category: "Catégorie d'actif", is_running: "Actif opérationnel ?", serial: "Numéro de série", item: "Article rotatif", failure: "Classe de défaillance", safety_plan: "Plan de sécurité", vendor: "Fournisseur", price: "Prix d'achat", replace: "Coût de remplacement", priority: "Priorité", ytd_cost: "Coût cumulé annuel" },
        meters: { seq: "Séquence", name: "Compteur", reading: "Dernière lecture", date: "Date de lecture", inspector: "Inspecteur", remarks: "Remarques" },
        ai: { title: "Intelligence de l'actif", run: "Lancer le diagnostic", summary: "Résumé technique", recommend: "Recommandations", telemetry: "Analyse de la télémétrie..." },
        spare_fields: { item: "Article rotatif", qty: "Quantité", issued: "Qté émise", remarks: "Remarques", item_details: "Détails de l'article" },
        safety: { plan_card: "Plans de sécurité associés", active_plan: "Plan de sécurité actif", no_plan: "AUCUN PLAN LIÉ", link_plan: "Lier un plan", change_plan: "Changer le plan", hazard_title: "Risques spécifiques à l'actif", hazard_num: "Risque", hazard_type: "Type / Priorité", no_hazards: "Aucun risque lié.", add_hazard: "Ajouter un risque", loto_title: "Verrouillage / Étiquetage (LOTO)", tag_id: "ID d'étiquetage", req_state: "État requis", no_loto: "Aucun point d'isolation défini.", add_loto: "Ajouter un point d'isolation", applying_proto: "Application du protocole..." },
        meters: { title: "Compteurs associés", details_title: "Détails du compteur", seq: "Séquence", meter_name: "Nom du compteur", meter_type: "Type de compteur", uom: "Unité de mesure", active_status: "Actif?", last_reading: "Dernière lecture", last_date: "Date de lecture", inspector: "Inspecteur", remarks: "Remarques", new_meter: "Nouveau compteur" },
        specs: { classification: "Classification", select_class: "Sélectionner la classification...", tech_specs: "Spécifications techniques", attribute: "Attribut", value: "Valeur", uom: "UOM", data_type: "Type de données", attr_details: "Détails de l'attribut", select_val: "Sélectionner la valeur" },
        history: { title: "Historique des bons de travail", wo_num: "N° BT", finish_date: "Date de fin", no_history: "Aucun historique trouvé.", fetching: "Récupération de l'historique...", wo_type: "Type" },
        bim: { model_status: "État du modèle", linked: "LIÉ & ACTIF", not_linked: "NON LIÉ", upload_revit: "Télécharger Revit (.rvt)", urn_label: "URN du modèle", "show_3d": "Voir le Jumeau Numérique (3D)", "not_linked": "Non lié au modèle 3D" },
        ai: { title: "INTELLIGENCE DES ACTIFS", sub_title: "Analyseur IA", tagline: "Diagnostics prédictifs IoT industriels", run_btn: "LANCER LE DIAGNOSTIC", analyzing: "ANALYSE DU FLUX DE TÉLÉMÉTRIE...", health_score: "Score de santé", thermal: "Alerte thermique", vibration: "Alerte de vibration", tech_summary: "RÉSUMÉ TECHNIQUE", recommendations: "RECOMMANDATIONS", sensors_chart: "Capteurs vs Limites critiques", init_prompt: "Cliquez sur LANCER LE DIAGNOSTIC pour initialiser l'analyse IA", critical: "CRITIQUE", normal: "NORMAL", stable: "STABLE", detected: "DÉTECTÉ", "predictive_trajectory": "Trajectoire de défaillance prédictive", "est_failure": "Défaillance estimée", "loading_pred": "Génération du modèle de prévision..." },
        "features": {
          "feature_id": "ID Caractéristique",
          "label": "Étiquette",
          "start": "Mesure Initiale",
          "end": "Mesure Finale (Vide = Point)",
          "value": "Valeur (ex. 500mm)",
          "details": "Détails de la Caractéristique",
          "y_offset": "Décalage Y (Droite/Gauche)",
          "z_offset": "Décalage Z (Profondeur/Hauteur)"
        },

      }, 
        common: { "days": "Jours", "weeks": "Semaines", "months": "Mois", "years": "Années", "daysList": {"saturday": "Samedi", "sunday": "Dimanche", "monday": "Lundi", "tuesday": "Mardi", "wednesday": "Mercredi", "thursday": "Jeudi", "friday": "Vendredi"}, "select": "Sélectionner", "search": "Rechercher", "pending": "En attente", "pendingSelection": "--- SÉLECTION EN ATTENTE ---","save_settings": "Enregistrer la configuration IA", selected: "Actifs sélectionnés", bulk_move: "Migration massive", change_status: "Changer statut", cancel: "Réinitialiser", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", back: "Retour", record: "Enregistrement", total: "Total", print: "Imprimer", of: "de", active: "Actif", critical: "Critique", warning: "Avertissement", healthy: "Sain", new_row: "Nouvelle ligne", "filter": "Filtrer...", "save_success": "Enregistré avec succès", "save_fail": "Échec de l'enregistrement", "delete": "Supprimer",     "delete_success": "Supprimé avec succès", "delete_fail": "Échec de la suppression", "are_you_sure": "Êtes-vous sûr(e) ?", "cancel": "Annuler", "confirm": "Confirmer", "first": "Premier", "last": "Dernier", "next": "Suivant", "prev": "Précédent", "sar": "SAR", "all": "TOUT", "attachments": "Pièces jointes",    "history": "Historique", "change_status": "Changer le statut", "totalRecords": "Total des enregistrements", "readOnly": "(LECTURE SEULE)", "noDescription": "Aucune description", "recordLocked": "L'enregistrement est verrouillé et ne peut pas être modifié.", "descRequired": "La description est requise !", "actionDenied": "Action refusée", "cantDeleteStatus": "Impossible de supprimer avec le statut : {{status}}", yes: "Oui", no: "Non", copy: "Copie", cancel: "Annuler", clone: "Cloner", back: "Retour", "main": "Détails Principaux", "save": "ENREGISTRER",
                  "change_status": "Changer le Statut", "history": "Historique", "delete": "Supprimer", "org": "Organisation", "site": "Site", "new_row": "NOUVELLE LIGNE", "location": "Emplacement", "asset": "Actif", "no_records": "Aucun enregistrement trouvé", "saving": "Enregistrement...", "save_success": "Enregistré avec succès !", "save_fail": "Échec de l'enregistrement", "are_you_sure": "Êtes-vous sûr(e) ?", "yes_delete": "Oui, supprimer !", "cancel": "Annuler", "delete_success": "Supprimé avec succès", "delete_fail": "Échec de la suppression : ", "clear_filters": "EFFACER LES FILTRES", "all": "TOUT", "syncing": "Synchronisation...", "showing": "Affichage", "total": "Total", "created_by": "Créé Par", "changed_date": "Date de Modification"}, 
        toasts: { save_success: "Enregistré avec succès", save_fail: "Échec de l'enregistrement", load_fail: "Échec du chargement des données", delete_success: "Supprimé avec succès" },
        swal: { delete_title: "Êtes-vous sûr ?", delete_text: "Vous allez supprimer l'actif :", confirm_delete: "Oui, supprimer l'enregistrement" },
        "ai_settings": {
          "title": "Paramètres de l'ingénieur IA",
          "sub_title": "Moteur de maintenance prédictive IA",
          "enable_label": "Activer la maintenance prédictive automatique",
          "enable_sub": "Créer auto. les BT selon l'analyse IA",
          "target_lang": "Langue des rapports et des tâches",
          "threshold": "Seuil de confiance pour la décision",
          "auto_tasks": "Générer auto. les tâches de travail (WOTasks)",
          "task_desc": "Écrire les étapes du travail auto. dans le tableau des tâches",
          "max_tasks": "Nombre max d'étapes par bon de travail",
          "section": "Section",
          "technicalDetails": "Détails Techniques"
        },
        "export_technical_report": "EXPORTER LE RAPPORT TECHNIQUE (PDF)",
        "availability": "Disponibilité",
        "mtbf": "MTBF",
        "mttr": "MTTR",
        "hrs": "H",
        "reliability_score": "Score de Fiabilité",
        "score": "Score",
        "downtime_history_trend": "Tendance de l'Historique des Temps d'Arrêt",
        "values_in_hours": "Valeurs en Heures",
        "timeline_event_date": "Chronologie (Date de l'Événement)",
        "downtime_hours": "Temps d'Arrêt (Heures)",
        "no_downtime_records": "Aucun enregistrement de temps d'arrêt trouvé pour cet actif.",
        "reliability_analysis": "Analyse de Fiabilité",
        "total_failures": "Pannes Totales",
        "total_down_time": "Temps d'Arrêt Total",
        "last_calculation": "Dernier Calcul",
        "maintenance_strategy_note": "Note de Stratégie de Maintenance",
        "high_mttr_detected": "MTTR élevé détecté. Recommandation : Évaluer la disponibilité des pièces de rechange.",
        "critical_availability": "Niveau de disponibilité critique. Envisagez d'augmenter la fréquence de maintenance.",
        "nominal_performance": "Les performances de l'actif sont nominales. Poursuivre le programme standard.",
        "current_load_factor": "Facteur de Charge Actuel",
        "optimal": "Optimal",
        statusModal: {
          "loadError": "Impossible de charger les statuts",
          "selectFirst": "Veuillez d'abord sélectionner un statut",
          "updating": "Mise à jour du statut...",
          "success": "Statut mis à jour",
          "failed": "Échec de la mise à jour",
          "changeStatus": "Changer le statut :",
          "currentStatus": "Statut actuel",
          "availableStatuses": "Statuts disponibles",
          "loading": "Chargement...",
          "chooseStatus": "Choisir le statut...",
          "memo": "Justification / Mémo",
          "enterNotes": "Saisissez vos notes...",
          "cancel": "Annuler",
          "update": "Mettre à jour"
        },
        attachmentsModal: {
        "loadError": "Erreur de chargement des fichiers",
        "uploadSuccess": "Fichier joint avec succès",
        "uploadFailed": "Échec du téléchargement",
        "deleteConfirmTitle": "ÊTES-VOUS SÛR(E) ?",
        "deleteConfirmText": "Vous êtes sur le point de supprimer définitivement '{{name}}'. Cela supprimera le fichier de nos serveurs.",
        "btnYesDelete": "OUI, SUPPRIMER !",
        "btnCancel": "ANNULER",
        "processingDelete": "Suppression en cours...",
        "deletedTitle": "SUPPRIMÉ !",
        "deletedText": "La pièce jointe a été supprimée avec succès.",
        "deleteFailed": "Échec de la suppression",
        "headerTitle": "Bibliothèque de pièces jointes",
        "linkingTo": "Lié à :",
        "filesFound": "FICHIERS TROUVÉS :",
        "uploadBtn": "TÉLÉCHARGER UN NOUVEAU DOCUMENT",
        "thName": "Nom",
        "thOwner": "Propriétaire",
        "thStatus": "Statut",
        "thActions": "Actions",
        "statusPrivate": "Privé",
        "statusPublic": "Public",
        "noDocs": "Aucun document lié pour le moment"
      },
      enterMeters: {
        "noMeters": "Aucun compteur lié à l'actif :",
        "saving": "Enregistrement des relevés...",
        "enterAtLeastOne": "Veuillez entrer au moins un nouveau relevé",
        "saveSuccess": "Tous les relevés ont été enregistrés avec succès !",
        "saveFailed": "Échec de l'enregistrement des relevés",
        "title": "Saisir les Relevés du Compteur | Actif :",
        "titleLoc": "Saisir les Relevés du Compteur | Emplacement :",
        "thIdentification": "Identification du Compteur",
        "thNewReading": "* Nouveau Relevé",
        "thReadingDate": "* Date du Relevé",
        "thMeterType": "Type de Compteur",
        "thLastRecorded": "Dernier Enregistrement",
        "noDescription": "Aucune description",
        "enterValue": "Entrer la valeur...",
        "notAvailable": "N/A",
        "operator": "Opérateur :",
        "btnCancel": "Annuler",
        "btnUpdate": "Mettre à jour les relevés"
      },
      emailSettings: {
        "loadFailed": "Échec du chargement des paramètres",
        "saveSuccess": "Paramètres de messagerie enregistrés avec succès !",
        "saveFailed": "Échec de l'enregistrement des paramètres",
        "connecting": "Connexion au serveur SMTP...",
        "connFailed": "Échec de la connexion !",
        "title": "Configuration SMTP",
        "subtitle": "Paramètres du serveur de messagerie",
        "outgoingTitle": "Courrier Sortant (SMTP - Envoi)",
        "incomingTitle": "Courrier Entrant (IMAP - Surveillance)",
        "lblHost": "Hôte SMTP",
        "lblPort": "Port SMTP",
        "lblUser": "Nom d'utilisateur / E-mail SMTP",
        "lblPass": "Mot de passe SMTP",
        "lblSender": "E-mail de l'expéditeur du système (De)",
        "lblImapHost": "Hôte IMAP",
        "lblImapPort": "Port IMAP",
        "enableImap": "Activer la surveillance de la boîte de réception (Radar RFQ)",
        "gmailNote": "Pour Gmail, utilisez un « Mot de passe d'application » de Google Security. Les mots de passe de compte ne fonctionneront pas avec l'A2F activée.",
        "btnTest": "TESTER",
        "btnCancel": "ANNULER",
        "btnSave": "ENREGISTRER LA CONFIGURATION"
      },
      locationDetails: {
        "noBimModel": "Aucun modèle 3D lié à cet emplacement",
        "noBimLinked": "Cet emplacement n'est pas lié au BIM",
        "locMandatory": "L'emplacement est un champ obligatoire !",
        "saving": "Enregistrement des modifications...",
        "saveSuccess": "Emplacement enregistré avec succès",
        "saveFailed": "Échec de l'enregistrement :",
        "deleteTitle": "Êtes-vous sûr(e) ?",
        "deleteText": "Vous êtes sur le point de supprimer l'emplacement {{id}}. Cette action est irréversible !",
        "btnYesDelete": "Oui, supprimer !",
        "btnCancel": "Annuler",
        "deleting": "Suppression de l'emplacement...",
        "deleteSuccess": "Emplacement supprimé avec succès",
        "deleteFailed": "Échec de la suppression !",
        "uploadingRevit": "Téléchargement et traduction du modèle Revit...",
        "revitSuccess": "Modèle lié avec succès !",
        "uploadFailed": "Échec du téléchargement :",
        "loadingCtx": "CHARGEMENT DU CONTEXTE DE L'EMPLACEMENT...",
        "tooltipChangeStatus": "Changer le statut",
        "tooltipStatusHistory": "Historique des statuts",
        "tooltipDelete": "Supprimer",
        "btnSave": "ENREGISTRER",
        "lblLocation": "Emplacement",
        "lblDescription": "Description",
        "btnRevitLinked": "Revit lié",
        "tabLocation": "Emplacement",
        "tabAssets": "Actifs",
        "tabSpecs": "Spécifications",
        "tabSafety": "Sécurité",
        "tabMeters": "Compteurs",
        "tab3D": "Vue 3D",
        "tabHistory": "Historique",
        "secIdentity": "Identité de l'emplacement",
        "lblStatus": "Statut",
        "lblType": "Type",
        "lblParentLoc": "Emplacement parent",
        "lblSiteID": "ID du site",
        "secGeoInfo": "Informations géographiques et adresse",
        "lblServiceAddr": "Adresse de service",
        "lblBimSpaceId": "ID de l'espace BIM",
        "lblGisCoords": "Coordonnées SIG",
        "secRefImage": "Image de référence",
        "btnUploadPhoto": "Télécharger une photo",
        "thAssetNum": "N° de l'actif",
        "thStatus": "Statut",
        "lblClass": "Classification",
        "thAttr": "Attribut",
        "thDesc": "Description",
        "thValue": "Valeur",
        "titleHazards": "Dangers signalés à cet emplacement",
        "btnAddHazard": "Ajouter un danger",
        "lblSelectHazards": "Sélectionner des dangers",
        "thHazard": "Danger",
        "thPrecaution": "Précaution",
        "titleLocMeters": "Compteurs de l'emplacement",
        "showingMeters": "Affichage de {{current}} sur {{total}}",
        "noMetersDef": "Aucun compteur défini",
        "thSeq": "Séquence",
        "thMeterNum": "N° du compteur",
        "thType": "Type",
        "thUOM": "UDM",
        "thActive": "Actif",
        "newMeter": "NOUVEAU_COMPTEUR",
        "clickNewRow": "Cliquez sur « Nouvelle ligne » pour ajouter un compteur",
        "titleMeterConfig": "Configuration des détails du compteur",
        "newEntry": "Nouvelle entrée",
        "lblMeterNum": "* Numéro du compteur",
        "lblMeterType": "Type de compteur",
        "lblUOM": "Unité de mesure",
        "lblMeterActive": "Le compteur est actif",
        "lblLastReading": "Dernier relevé",
        "lblReadingDate": "Date du relevé",
        "lblInspector": "Inspecteur du compteur",
        "lblRemarks": "Remarques / Commentaires",
        "placeholderRemarks": "Saisissez des notes techniques sur ce compteur...",
        "btnAddMeterRow": "Ajouter une nouvelle ligne de compteur",
        "titleModelStatus": "Statut du modèle",
        "statusLinked": "LIÉ ET ACTIF",
        "statusNotLinked": "NON LIÉ",
        "btnUploadRevit": "Télécharger Revit (.rvt)",
        "titleHistory": "Historique des transactions et journal d'audit",
        "lblChangedBy": "Modifié par :",
        "failedFetchAttr": "Échec de la récupération des attributs"
      },
      "locationList": {
        "loadFailed": "Échec du chargement des emplacements depuis le serveur Teknoia.",
        "title": "Emplacements",
        "searchPlaceholder": "Recherche globale...",
        "btnClearAll": "Tout effacer",
        "btnExport": "Exporter",
        "btnNewLocation": "Nouvel emplacement",
        "thLocationId": "ID d'emplacement",
        "thDescription": "Description",
        "thType": "Type",
        "thStatus": "Statut",
        "thSite": "Site",
        "optAll": "TOUS",
        "optOperating": "EN SERVICE",
        "optDecommissioned": "HORS SERVICE",
        "fetchingData": "Récupération des données du serveur...",
        "noRecords": "Aucun enregistrement correspondant trouvé.",
        "recordsFound": "Enregistrements trouvés :",
        "page": "Page :"
      },
      "universalLookup": {
        "selectValue": "Sélectionnez la valeur :",
        "total": "Total",
        "searchPlaceholder": "Recherche par code ou description...",
        "valueCode": "Valeur / Code",
        "description": "Description",
        "site": "Site",
        "synchronizing": "Synchronisation en cours...",
        "noRecords": "Aucun enregistrement correspondant trouvé.",
        "loadingMore": "Chargement d'autres enregistrements...",
        "results": "Résultats :",
        "cancel": "Annuler"
      },
      "statusHistory": {
        "title": "Piste d'audit des statuts",
        "loading": "CHARGEMENT DE L'HISTORIQUE...",
        "noRecords": "Aucun changement de statut enregistré pour cet élément.",
        "initial": "INITIAL",
        "btnClose": "Fermer"
      },
      "personalInfo": {
        "updateSuccess": "Profil mis à jour avec succès",
        "sessionExpired": "Session expirée, veuillez vous reconnecter",
        "updateFailed": "Échec de la mise à jour",
        "title": "Informations personnelles et valeurs par défaut",
        "lblDisplayName": "Nom d'affichage complet",
        "lblEmail": "Adresse e-mail",
        "lblDefaultOrg": "Organisation par défaut",
        "selectOrg": "Sélectionner une organisation...",
        "lblDefaultSite": "Site par défaut",
        "selectSite": "Sélectionner un site...",
        "lblDefaultLang": "Langue par défaut",
        "btnCancel": "Annuler",
        "btnSave": "Appliquer et enregistrer",
        "securityTitle": "Sécurité et 2FA",
        "enable2FA": "Activer l'authentification à deux facteurs (2FA)",
        "googleAuth": "Google Authenticator",
        "emailOTP": "Code OTP par Email",
        "configure2FA": "Configurer la 2FA",
        "scanQR": "Scannez ce code QR avec Google Authenticator, puis entrez le code à 6 chiffres ci-dessous pour vérifier.",
        "btnVerify": "Vérifier",
        "setupSuccess": "Configuration 2FA réussie !",
        "invalidCode": "Code de vérification invalide",
        "failedQR": "Échec de la génération du code QR"
      },
      "appSettings": {
        "savingSettings": "Enregistrement des paramètres...",
        "saveSuccess": "Paramètres mis à jour avec succès !",
        "saveFailed": "Échec de l'enregistrement des paramètres.",
        "title": "Configuration de l'entreprise",
        "org": "Organisation",
        "tabs": {
          "WORKORDER": "Bons de travail",
          "ASSET": "Registre des actifs",
          "INVENTORY": "Entrepôt et stocks",
          "PURCHASE": "Achats",
          "PR": "DA",
          "JP": "GT",
          "PM": "MP",
          "MR": "DM",
          "SR": "DS"
        },
        "systemRules": "Règles système : {{tab}}",
        "prefix": "Préfixe de séquence",
        "preview": "Aperçu",
        "seed": "Valeur de départ (Graine)",
        "valuationStrategy": "Stratégie de valorisation",
        "movingAvg": "Moyenne mobile (Recommandé)",
        "fifo": "Premier entré, premier sorti (FIFO)",
        "lifo": "Dernier entré, premier sorti (LIFO)",
        "allowNegative": "Autoriser le solde négatif",
        "negativeWarning": "Avertissement : Affecte la précision financière",
        "encrypting": "Cryptage et transmission...",
        "auditLogged": "Toutes les modifications sont enregistrées dans la piste d'audit",
        "btnCancel": "Annuler",
        "btnSave": "Enregistrer la politique système"
      },
      "workflowAction": {
        "successMove": "Flux de travail acheminé avec succès ! 🚀",
        "failedMove": "Échec de l'action",
        "btnRoute": "Acheminer le flux",
        "modalTitle": "ACTION DU FLUX DE TRAVAIL",
        "assignedAs": "Assigné à vous en tant que :",
        "defaultInstruction": "Veuillez vérifier et agir.",
        "lblChoosePath": "Choisir le chemin",
        "valSelectPath": "Veuillez sélectionner un chemin",
        "optApprove": "APPROUVER / AVANCER",
        "optReject": "REJETER / RETOURNER",
        "lblMemo": "Mémo d'action / Commentaires",
        "placeholderMemo": "Ajoutez vos commentaires ici...",
        "btnCancel": "Annuler",
        "btnComplete": "TERMINER L'ÉTAPE"
      },
      "meterHistory": {
        "title": "Historique des relevés de compteurs",
        "lblAsset": "Actif",
        "fetching": "Récupération des archives...",
        "noRecords": "Aucun relevé historique trouvé pour cet actif.",
        "thMeterName": "Nom du compteur",
        "thReadingVal": "Valeur du relevé",
        "thReadingDate": "Date du relevé",
        "thEnteredBy": "Saisi par",
        "thEntryDate": "Date de saisie",
        "btnClose": "Fermer l'historique",
        "lblLocation": "Emplacement",
        "noRecordsLoc": "Aucun relevé historique trouvé pour cet emplacement.",
      },
      "rpt_print": "Rapports imprimés",
      "no_templates": "Aucun modèle disponible",
      "wo": {
        "tabs": { "workOrder": "Ordre de travail", "plans": "Plans", "assignments": "Affectations", "actuals": "Réalisations", "safety": "Sécurité", "failure": "Rapport de panne" },
        "subTabs": { "tasks": "Tâches", "labor": "Main d'œuvre", "materials": "Matériaux", "tools": "Outils", "services": "Services" },
        "headers": { "workOrder": "Ordre de travail", "status": "Statut", "totalCost": "Coût total", "activeSla": "SUIVI SLA ACTIF", "targetRes": "RÉSOLUTION CIBLE", "targetResp": "RÉPONSE CIBLE", "trackingTitle": "Suivi des ordres de travail", "globalView": "Vue globale de l'org.", "site": "Site", "selected": "Sélectionné" },
        "sections": { "assetDetails": "Détails de l'actif", "scheduling": "Planification", "responsibility": "Responsabilité", "laborAssign": "Affectations", "totalAssign": "Total des affectations" },
        "fields": { "description": "Description", "location": "Emplacement", "asset": "Actif", "workType": "Type de travail", "safetyCode": "Code de sécurité", "supervisor": "Superviseur", "failureClass": "Classe de panne", "targStart": "Début cible", "targFinish": "Fin cible", "schedStart": "Début planifié", "schedFinish": "Fin planifiée", "earlyStart": "Ne pas commencer avant", "lateFinish": "Ne pas terminer après", "actStart": "Début réel", "actFinish": "Fin réelle", "duration": "Durée", "timeRemaining": "Temps restant", "predecessors": "Prédécesseurs", "includeTasks": "Inclure les tâches?", "site": "Site", "organization": "Organisation", "priorityHigh": "Priorité : Élevée" },
        "actions": { "routeWorkflow": "Acheminer le flux", "wfHistory": "Historique du flux", "changeStatus": "Changer le statut", "attachments": "Pièces jointes", "printWO": "Imprimer OT", "printSafety": "Fiche de sécurité", "history": "Historique", "newTask": "Nouvelle tâche", "selectLoc": "Choisir emplacement", "selectAsset": "Choisir actif", "selectType": "Choisir type", "selectSafety": "Choisir plan sécu.", "selectSup": "Choisir superviseur", "selectFail": "Choisir classe panne", "selectCraft": "Choisir métier", "selectLabor": "Choisir main d'œuvre", "selectItem": "Choisir article", "selectStore": "Choisir magasin", "selectTool": "Choisir outil", "addLabor": "Ajouter main d'œuvre", "addMaterial": "Ajouter matériel", "addTool": "Ajouter outil", "addService": "Ajouter service", "newAssign": "Nouvelle affectation", "compAssign": "Terminer l'affectation", "createMR": "Créer demande de matériel", "yesCreate": "Oui, créer", "yesChange": "Oui, modifier", "approve": "Approuver", "cancel": "Annuler", "startWork": "Commencer", "close": "Fermer", "complete": "Terminer", "selectProblem": "Choisir problème", "selectCause": "Choisir cause", "selectRemedy": "Choisir remède", "newWO": "Nouvel ordre de travail" },
        "tables": { "sequence": "Séquence", "taskDesc": "Desc. de tâche", "estDur": "Durée est.", "status": "Statut", "craft": "Métier", "labor": "Main d'œuvre", "qty": "Qté", "hrs": "Hres", "rate": "Taux", "lineCost": "Coût de ligne", "lineType": "Type de ligne", "itemNum": "Article #", "description": "Description", "unitCost": "Coût unitaire", "storeroom": "Magasin", "item": "Article", "material": "Matériel", "toolNum": "Outil #", "serviceDesc": "Desc. du service", "vendor": "Fournisseur", "cost": "Coût", "start": "Début", "finish": "Fin", "failCode": "Code panne" },
        "footer": { "totalLabor": "Total Main d'œuvre", "totalMaterial": "Total Matériel", "assigned": "Affecté (Est.)", "toolsServ": "Outils & Serv.", "totalActual": "Coût Total Réel", "loaded": "Chargé", "total": "Total", "page": "Page", "of": "sur" },
        "safety": { "hazardsTitle": "Dangers et précautions", "hazardCode": "Code de danger", "hazardDesc": "Desc. de danger", "precautions": "Précautions requises", "noHazards": "Aucun danger identifié.", "lotoTitle": "Verrouillage/Étiquetage (LOTO)", "step": "Étape", "tagNum": "Num. d'étiquette", "isoDesc": "Desc. d'isolement", "reqState": "État requis", "completed": "Terminé?", "noLoto": "Aucune étape d'isolement requise." },
        "failure": { "title": "Analyse des pannes", "currClass": "Classe actuelle", "notDefined": "NON DÉFINI", "problems": "PROBLÈMES", "causes": "CAUSES", "remedies": "REMÈDES", "records": "ENREGISTREMENTS" },
        "placeholders": { "desc": "Entrez la description...", "taskDesc": "DESCRIPTION TÂCHE...", "searchWO": "Rechercher un ordre de travail..." },
        "messages": { "loadError": "Erreur de chargement", "taskStatusLocal": "Statut de la tâche mis à jour", "selectItemStore": "Sélectionnez un article et un magasin", "duplicateReqTitle": "Demande en double", "duplicateReqText": "Une demande existe pour {{item}}. Créer une autre?", "creatingMR": "Création en cours...", "mrCreated": "Demande {{num}} créée", "mrFail": "Échec de création", "confirmStatusChange": "Changer le statut de {{wonum}} en {{status}}?", "statusSuccess": "Statut modifié", "statusFail": "Échec de modification", "saving": "Enregistrement...", "deleteConfirm": "Supprimer {{wonum}}? Action irréversible!", "saveBeforeSLA": "Enregistrez d'abord l'OT", "slaExists": "SLA déjà appliqué!", "matchingSLA": "Recherche de SLA...", "slaApplied": "SLA appliqué avec succès", "noMatchingSLA": "Aucun SLA correspondant", "slaError": "Erreur du moteur SLA", "failureTreeLoaded": "Codes de panne appliqués", "zeroBalance": "Avertissement: Solde nul pour l'article dans {{store}}", "balanceOk": "Prix récupéré: {{cost}} - Solde: {{bal}}", "storeError": "Échec de connexion au magasin", "assetLinked": "Actif lié: {{asset}}", "openAssignError": "Impossible de fermer: {{count}} affectations incomplètes.", "budgetExceeded": "Budget dépassé!", "assignComplete": "Affectation terminée", "actionNotAllowed": "Action non autorisée pour le statut {{status}}", "locked": "Verrouillé", "cantChangeCancel": "Les demandes annulées ne peuvent changer de statut", "printFail": "Échec de création du PDF", "wfRouted": "Flux acheminé avec succès! 🚀", "wfFail": "Échec d'acheminement", "taskStatusChanged": "Tâche {{task}} changée en {{status}}", "noLaborAssign": "Aucune main d'œuvre affectée.", "updateTaskProg": "Mettre à jour l'avancement", "noMaterials": "Aucun matériel. Cliquez pour ajouter.", "linkedMRs": "Demandes liées (Suivi)", "sessionExpired": "Session expirée. Veuillez vous reconnecter.", "fetchError": "Erreur de récupération des données", "loadingWOs": "Chargement des ordres de travail...", "syncing": "Synchronisation du lot suivant...", "stocknobalance": "⚠️ Attention : Cet article n'est plus en stock." },
        "linearDefect": {
          "title": "Emplacement du Défaut Linéaire",
          "startMeasure": "Mesure de début",
          "endMeasure": "Mesure de fin (Optionnel)",
          "unit": "Unité",
          "yOffset": "Décalage Y (m)"
        },
        "costs": {
          "title": "Coûts de l'Ordre de Travail",
          "estimated": "Coûts Estimés",
          "actual": "Coûts Réels",
          "labor": "Main-d'œuvre",
          "materials": "Matériaux",
          "tools": "Outils",
          "services": "Services",
          "total": "Total",
          "variance": "Écart (Réel - Est)",
          "calculating": "Calcul en cours...",
          "no_data": "Aucune donnée disponible."
        },
        "purchase_info": {
          "title": "Infos d'Achat Associées",
          "mr_title": "Demandes de Matériel (MR)",
          "pr_title": "Demandes d'Achat (PR)",
          "po_title": "Bons de Commande (PO)",
          "mr_num": "N° MR",
          "pr_num": "N° PR",
          "po_num": "N° PO",
          "vendor": "Fournisseur",
          "status": "Statut",
          "req_date": "Date Requise",
          "total_cost": "Coût Total",
          "fetching": "Récupération des données...",
          "no_records": "Aucun enregistrement trouvé."
        },
    
      },
      "pm": {
        "tabs": { "pm": "MP", "frequency": "Fréquence", "sequence": "Séquence", "seasonaldates": "Saison", "forecast": "Prévisions" },
        "sections": { "assetLoc": "Actif & Emplacement", "defaults": "Paramètres par défaut", "compliance": "Conformité", "siteContext": "Info Site", "timeBased": "Intervalle temporel", "meters": "Compteurs", "sequences": "Séquences de plans", "seasonal": "Calendrier hebdomadaire", "projections": "Logs de prévisions", "mrItems": "Articles de la demande de matériel", "financialCharging": "Détails d'imputation financière" },
        "fields": { "pmNum": "Numéro MP", "description": "Description", "status": "Statut", "site": "Site", "asset": "Actif", "location": "Emplacement", "route": "Itinéraire", "counter": "Compteur", "jpnum": "Plan de travail", "worktype": "Type de travail", "supervisor": "Superviseur", "glaccount": "Compte GL", "woStatus": "Statut par défaut", "priority": "Priorité", "lastStart": "Dernier début", "lastComp": "Dernière fin", "nextDue": "Prochaine échéance", "forecastFlag": "Indicateur prév.", "org": "Org.", "freqInt": "Intervalle", "freqUnit": "Unité", "targStart": "Heure cible", "targetStore": "Magasin cible", "chargeLoc": "Imputer à l'emplacement", "chargeAsset": "Imputer à l'actif", "chargeWO": "Imputer au BT" }, 
        "actions": { "forecast": "PRÉVOIR", "savePM": "SAUVEGARDER", "addMeter": "AJOUTER", "addStep": "AJOUTER ÉTAPE", "newPM": "Nouveau MP" },
        "tables": { "meterName": "Nom Compteur", "freq": "Fréq.", "nextProj": "Prochaine Prév.", "seq": "Séquence", "jpnum": "Plan assigné", "fcDate": "Date", "targetJp": "Plan Cible", "estCost": "Coût Est.", "status": "Statut", "woNum": "Numéro OT", "generated": "GÉNÉRÉ", "projected": "PROJETÉ", "stockItem": "Article en stock", "qtyReq": "Qté demandée", "estUnitCost": "Coût unit. est." },
        "messages": { "generating": "Génération de {{docType}}...", "generatedSuccess": "{{docType}} {{docnum}} généré avec succès !", "generateFail": "Échec de la génération de {{docType}}", "storeRequired": "Le magasin est requis !", "dateRequired": "La date requise est requise !", "executingForecast": "Génération en cours...", "forecastSuccess": "Succès", "forecastFail": "Échec", "seasonalInfo": "Jours cochés = autorisés.", "noMeters": "Aucun compteur défini", "noSeq": "Séquence désactivée", "noForecasts": "Aucune prévision.", "showingProjections": "Affichage de {{count}} prévisions", "fetchListError": "Échec de récupération des MP", "syncingList": "Synchronisation avec le serveur...", "noRecords": "Aucun MP trouvé." },
        "placeholders": { "desc": "Saisir la description...", "globalSearch": "Recherche globale intelligente...", "chooseLoc": "CHOISIR EMPLACEMENT", "selectAsset": "SÉLECTIONNER ACTIF", "chargeWO": "IMPUTER AU BT" },
        "lookups": { "storerooms": "Magasins", "inventory": "Recherche d'inventaire", "locations": "Emplacements du site", "assets": "Registre des actifs", "workorders": "Bons de travail" },
        "headers": { "masterDir": "Répertoire principal MP" },
        "footer": { "dbTotal": "Total base de données:", "currentPage": "Page actuelle:", "useNavArrows": "Utilisez les flèches" },
      },
      "workflowHistory": {
        "title": "Historique du flux d'approbation",
        "trackingId": "ID de suivi :",
        "fetching": "Récupération des données...",
        "currentTask": "Tâche active en cours",
        "since": "Depuis :",
        "by": "par",
        "noHistory": "Aucun historique pour cette transaction",
        "closeBtn": "Fermer l'historique"
      },
      "pr": {
        "headers": { "prList": "Demandes d'Achat" },
        "actions": { "newPR": "NOUVELLE DA", "clearFilters": "EFFACER FILTRES", "routeWf": "ACHEMINER FLUX" },
        "tabs": { "pr": "DA", "prlines": "Lignes de DA" },
        "sections": { "general": "Informations générales", "financial": "Résumé financier" },
        "fields": { "prNum": "N° DA", "requestedBy": "Demandé par", "reqDate": "Date requise", "refMr": "DM de référence", "vendor": "Fournisseur", "glAccount": "Compte GL" },
        "financial": { "subtotal": "Sous-total", "taxTotal": "Total des taxes", "grandTotal": "Total général" },
        "tables": { "prNum": "N° DA", "description": "Description", "status": "Statut", "totalCost": "Coût Total", "reqDate": "Date Dem.", "site": "Site", "itemNum": "Article #", "itemType": "Type", "qty": "Qté", "unitCost": "Coût Unit.", "tax": "Taxe", "lineTotal": "Total Ligne", "taxCat": "Cat. Taxe" },
        "messages": { "loadFailed": "Échec du chargement des demandes", "syncing": "Synchronisation...", "noData": "Aucune donnée trouvée", "noLines": "Aucune ligne ajoutée.", "fetchingMRLines": "Récupération des lignes pour DM: {{mrnum}}...", "loadedMRLines": "{{count}} lignes chargées", "noMRLines": "Cette DM n'a aucune ligne", "failedMRLines": "Échec du chargement des lignes de DM" },
        "swal": { "lockedTitle": "Verrouillé", "cantDeleteStatus": "Impossible de supprimer avec le statut : {{status}}", "cantChangeCancel": "Les demandes annulées ne peuvent changer de statut", "deleteWarnText": "Cela supprimera définitivement la DA et ses lignes." },
        "placeholders": { "desc": "Saisir la description...", "globalSearch": "Recherche globale intelligente..." },
        "footer": { "showing": "Affichage", "totalRecords": "Total" }
      },
      "po": {
        "headers": { "poList": "Commandes d'Achat" },
        "actions": { "newPO": "NOUVELLE CMD", "clearFilters": "EFFACER FILTRES", "routeWf": "ACHEMINER FLUX", "addManualRow": "AJOUTER LIGNE MANUELLE", "wfHistory": "Historique Workflow" },
        "tabs": { "po": "Commande", "polines": "Lignes de Cmd" },
        "sections": { "general": "Informations générales", "financial": "Résumé financier", "lines": "Lignes de Commande" },
        "fields": { "poNum": "N° Commande", "requestedBy": "Demandé par", "orderDate": "Date de Cmd", "refPr": "DA de référence", "vendor": "Fournisseur", "glAccount": "Compte GL" },
        "financial": { "subtotal": "Sous-total net", "taxTotal": "Montant Taxe", "grandTotal": "Total général" },
        "tables": { "poNum": "N° Commande", "totalCost": "Coût Total", "orderDate": "Date de Cmd", "itemNum": "Article #", "itemType": "Type", "unitCost": "Coût Unit.", "tax": "Taxe", "lineTotal": "Total Ligne", "taxCat": "Cat. Taxe" },
        "messages": { "loadFailed": "Échec du chargement des commandes", "syncing": "Synchronisation...", "noData": "Aucune commande trouvée", "noLines": "Aucune ligne ajoutée.", "vendorRequired": "Le fournisseur est obligatoire pour sauvegarder.", "fetchingLines": "Récupération des lignes: {{num}}...", "loadedLines": "{{count}} lignes chargées", "noLinesFound": "Ce document n'a aucune ligne", "failedLines": "Échec du chargement des lignes", "cantChangeCancel": "Les requêtes annulées ne peuvent changer de statut", "cantDeleteStatus": "Impossible de supprimer avec le statut : {{status}}" },
        "swal": { "deleteWarnText": "Cela supprimera définitivement la commande et ses lignes." },
        "placeholders": { "desc": "Saisir la description...", "globalSearch": "Recherche globale intelligente..." },
        "footer": { "showing": "Affichage" }
      },
      "mr": {
        "headers": { "mrList": "Demandes de Matériel" },
        "actions": { "newMR": "NOUVELLE DM", "clearFilters": "EFFACER FILTRES", "routeWf": "ACHEMINER FLUX" },
        "tabs": { "mr": "Infos DM", "mrlines": "Lignes de DM" },
        "sections": { "general": "Informations générales", "financial": "Résumé financier" },
        "fields": { "mrNum": "N° DM", "requestedBy": "Demandé par", "reqDate": "Date requise", "refMr": "DM de référence", "vendor": "Fournisseur", "glAccount": "Compte GL" },
        "financial": { "subtotal": "Sous-total", "taxTotal": "Total des taxes", "grandTotal": "Total général" },
        "tables": { "mrNum": "N° DM", "description": "Description", "status": "Statut", "totalCost": "Coût Total", "enteredDate": "Date Saisie", "site": "Site", "itemNum": "Article #", "itemType": "Type", "qty": "Qté", "unitCost": "Coût Unit.", "tax": "Taxe", "lineTotal": "Total Ligne", "taxCat": "Cat. Taxe" },
        "messages": { "loadFailed": "Échec du chargement des demandes", "syncing": "Synchronisation...", "noData": "Aucune donnée trouvée", "noLines": "Aucune ligne ajoutée.", "fetchingMRLines": "Récupération des lignes: {{mrnum}}...", "loadedMRLines": "{{count}} lignes chargées", "noMRLines": "Cette DM n'a aucune ligne", "failedMRLines": "Échec du chargement des lignes" },
        "swal": { "lockedTitle": "Verrouillé", "cantDeleteStatus": "Impossible de supprimer avec le statut : {{status}}", "cantChangeCancel": "Les demandes annulées ne peuvent changer de statut", "deleteWarnText": "Cela supprimera définitivement la Demande et ses lignes." },
        "placeholders": { "desc": "Saisir la description...", "globalSearch": "Recherche globale..." },
        "footer": { "showing": "Affichage", "totalRecords": "Total" }
      },
      "contract": {
        "headers": { "masterNode": "Nœud Principal des Contrats" },
        "placeholders": { "globalSearch": "Recherche globale...", "desc": "Entrez le résumé...", "termDesc": "Détails de la clause..." },
        "actions": { "newContract": "NOUVEAU CONTRAT", "save": "ENREGISTRER", "addTerm": "AJOUTER CLAUSE", "addLine": "AJOUTER LIGNE", "wfHistory": "Historique Workflow" },
        "tabs": { "general": "Général", "slaperformance": "SLA (Performance)", "termslegal": "Termes et Légal", "contractlines": "Lignes de Contrat" },
        "sections": { "identity": "Identité et Validité", "communication": "Centre de communication", "auditInfo": "Infos d'audit", "masterSLA": "Lien SLA", "slaBenchmarks": "Benchmarks SLA", "termsList": "Clauses Légales", "lines": "Portée / Lignes" },
        "options": { "supply": "Fourniture", "labor": "Main-d'œuvre/Service", "lease": "Location", "allTypes": "TOUS TYPES", "allStatus": "TOUS STATUTS", "general": "GÉNÉRAL", "payment": "PAIEMENT", "termination": "RÉSILIATION", "warranty": "GARANTIE", "liability": "RESPONSABILITÉ" },
        "fields": { "contractNum": "N° Contrat", "vendorRef": "Fournisseur", "startDate": "Date de début", "endDate": "Date de fin", "contractValue": "Valeur du contrat", "currency": "Devise", "contactPerson": "Personne de contact", "vendorEmail": "Email Fournisseur", "slaRef": "Référence SLA", "respTime": "Temps réponse (H)", "resTime": "Temps résolution (H)", "uptime": "Cible dispo (%)", "penalty": "Pénalité (par H)", "grandTotal": "Total calculé" },
        "tables": { "contractNum": "N° Contrat", "grandTotal": "Total", "clauseType": "Type Clause", "clauseDesc": "Description Clause", "lineDesc": "Description Ligne", "rate": "Taux", "lineTotal": "Total Ligne" },
        "messages": { "fetchError": "Échec de synchronisation", "syncing": "Synchronisation...", "noData": "Aucun contrat trouvé", "descMandatory": "La description est obligatoire", "vendorSelected": "Fournisseur {{name}} sélectionné", "noTerms": "Aucune clause définie", "noLines": "Aucune ligne définie", "slaHint": "Le lien avec un SLA applique ses règles globalement." },
        "swal": { "deleteTitle": "Suppression définitive?", "deleteText": "Cela effacera définitivement le contrat et toutes ses lignes." },
        "footer": { "masterRecords": "Enregistrements:", "currentPage": "Page Actuelle:" }
      },
      "rfq": {
        "headers": { "rfqList": "Gestion des DP" },
        "tabs": { "rfq": "DP", "rfqlines": "Lignes DP", "quotations": "Devis" },
        "sections": { "general": "Infos générales", "financial": "Résumé financier" },
        "fields": { "requestedBy": "Demandé par", "reqDate": "Date requise", "refPr": "DA Réf", "vendor": "Fournisseur", "vendorEmail": "Email Fournisseur", "glAccount": "Compte GL" },
        "financial": { "subtotal": "Sous-total", "taxTotal": "Total Taxes", "grandTotal": "Total" },
        "tables": { "rfqNum": "N° DP", "totalCost": "Coût Total", "itemNum": "Article #", "itemType": "Type", "unitCost": "Coût Unit.", "tax": "Taxe", "taxCat": "Cat. Taxe" },
        "options": { "awarded": "ATTRIBUÉ" },
        "actions": { "newRFQ": "NOUVELLE DP", "sendEmail": "ENVOYER EMAIL", "wfHistory": "Hist. Workflow", "award": "ATTRIBUER ET CRÉER BC" },
        "messages": { "loadFailed": "Échec du chargement", "syncing": "Synchronisation...", "noData": "Aucun enregistrement", "noLines": "Aucune ligne", "pullingPR": "Importation de DA...", "prImported": "Lignes importées!", "prFailed": "Échec d'importation", "noEmail": "Email manquant!", "sending": "Envoi...", "sendSuccess": "Email envoyé!", "sendFailed": "Échec de l'envoi", "quotesHint": "Les devis entrants apparaîtront ici auto.", "noQuotes": "Aucun devis reçu.", "awarding": "Attribution...", "awardSuccess": "Devis attribué!", "poCreated": "BC généré", "awardFailed": "Échec de l'attribution" },
        "swal": { "sendTitle": "Envoyer DP?", "sendText": "Envoyer cette demande à {{vendor}}?", "awardTitle": "Attribuer le devis?", "awardText": "Ceci créera une Commande d'Achat automatiquement." },
        "footer": { "showing": "Affichage" }
      },
      "itemList": {
        "headers": { "master": "Registre des Articles" },
        "actions": { "newItem": "Nouvel Article" },
        "tables": { "item": "Article", "rotating": "Rotatif ?" },
        "messages": { "syncFailed": "Échec de synchronisation", "syncing": "Synchronisation...", "noData": "Aucun article trouvé" },
        "footer": { "totalItems": "Total d'articles :", "page": "PAGE" }
      },
      "itemDetails": {
        "tabs": { "item": "ARTICLE", "inventory": "STOCKS", "vendors": "FOURNISSEURS", "specs": "SPÉCS", "assembly": "ASSEMBLAGE" },
        "sections": { "config": "Configuration Article", "units": "Unités & Suivi", "bomList": "Nomenclature (BOM)", "supplierHistory": "Historique Fournisseurs" },
        "actions": { "save": "SAUVEGARDER", "addStore": "AJOUTER MAGASIN", "newSpec": "NOUVELLE SPÉC", "addComponent": "AJOUTER COMPOSANT" },
        "fields": { "itemSet": "Lot d'Articles", "rotating": "Rotatif ?", "lotControl": "Contrôle de Lot ?", "inspectionReq": "Inspection Requise ?", "orderUnit": "Unité Cde", "issueUnit": "Unité Sortie", "condition": "Condition Activée ?", "sparepart": "Pièce de Rechange ?", "classification": "Classification" },
        "tables": { "store": "Magasin", "avgCost": "Coût Moyen", "balance": "Solde", "attribute": "Attribut", "value": "Valeur", "uom": "UDM", "subItem": "Sous-Article", "remarks": "Remarques", "vendor": "Code Fournisseur", "supplierName": "Nom Fournisseur", "unitCost": "Coût Unit.", "refPO": "BC Référence", "activeVendors": "FOURNISSEURS ACTIFS" },
        "messages": { "reqFields": "Numéro et Description requis!", "fetchingAttributes": "Récupération des attributs...", "attributesLoaded": "Attributs chargés", "failedAttributes": "Échec du chargement", "stockMsgTitle": "MESSAGE STOCK", "stockMsgDesc": "Modifier ces unités impactera tous les magasins.", "noInventory": "Aucun stock pour cet article.", "noSpecs": "Aucune spécification.", "noBom": "Aucune nomenclature définie.", "noVendors": "Aucun historique fournisseur." },
        "swal": { "deleteText": "Vous allez supprimer l'article {{num}}. Action irréversible !" }
      },
      "changePassword": {
        "title": "Changer le mot de passe",
        "currentPwd": "Mot de passe actuel",
        "newPwd": "Nouveau mot de passe",
        "confirmPwd": "Confirmer le nouveau mot de passe",
        "securityTitle": "Vérification de sécurité",
        "googleAuthMsg": "Entrez le code à 6 chiffres de Google Authenticator pour confirmer ce changement.",
        "emailOtpMsg": "Un code OTP a été envoyé à votre e-mail.",
        "btnCancel": "Annuler",
        "btnUpdate": "Mettre à jour",
        "btnVerify": "Vérifier et changer",
        "btnBack": "Retour",
        "errMismatch": "Les nouveaux mots de passe ne correspondent pas !",
        "errLength": "Le mot de passe doit comporter au moins 6 caractères.",
        "msgVerifyReq": "Veuillez vérifier votre identité pour continuer.",
        "msgSuccess": "Mot de passe modifié avec succès !",
        "errFailed": "Échec de la modification du mot de passe."
      },
      "userDetails": {
        "titleNew": "NOUVEL UTILISATEUR",
        "titleEdit": "SÉCURITÉ / UTILISATEURS",
        "btnSave": "ENREGISTRER",
        "saving": "ENREGISTREMENT...",
        "secIdent": "Identification de l'utilisateur",
        "lblLoginId": "Identifiant de connexion",
        "lblFullName": "Nom complet",
        "lblDisplayName": "Nom d'affichage",
        "lblEmail": "Adresse e-mail",
        "lblPassword": "Mot de passe",
        "lblActive": "Statut actif",
        "secAccess": "Sécurité et contrôle d'accès",
        "lblPrimaryRole": "Rôle de sécurité principal",
        "lblSecRoles": "Rôles secondaires (Supplémentaires)",
        "lblDefOrg": "Organisation par défaut",
        "lblDefSite": "Site par défaut",
        "secDelegation": "Délégation de travail",
        "lblDelegateTo": "Déléguer le travail à",
        "lblStartDate": "Date et heure de début",
        "lblEndDate": "Date et heure de fin"
      },
      "receivingDetails": {
        "errLoadLines": "Échec du chargement des lignes de la commande",
        "errMissingDist": "Veuillez spécifier le magasin et la quantité pour toutes les lignes",
        "errInspMandatory": "La décision d'inspection est OBLIGATOIRE pour cet article",
        "errRejectExceeds": "Vérifiez les quantités rejetées (ne peuvent dépasser la qté arrivée)",
        "msgSuccess": "Transaction traitée avec succès !",
        "msgAutoClosed": "Fermeture automatique : ",
        "swalAssignTitle": "Affectation de magasin",
        "swalAssignText": "L'article {{item}} n'est pas affecté au magasin {{loc}}. L'affecter maintenant et terminer la réception ?",
        "swalAssignBtn": "Oui, Affecter et Terminer",
        "errUnexpected": "Une erreur inattendue s'est produite lors de la réception",
        "hubTitle": "Centre de Réception Global",
        "poRef": "RÉFÉRENCE BC : ",
        "btnExecuting": "EXÉCUTION...",
        "btnConfirm": "CONFIRMER LA RÉCEPTION",
        "tblItemsPending": "Articles en attente de réception",
        "colItemDetails": "Détails de l'article",
        "colBalance": "Solde",
        "lblQualityCheck": "CONTRÔLE QUALITÉ REQUIS",
        "lblUnits": "Unités",
        "msgNoPending": "Aucun article en attente trouvé",
        "lblLandedCost": "Coût de revient (Frais supplémentaires)",
        "lblBaseCost": "Coût unitaire de base BC",
        "lblStoreMatrix": "Matrice de distribution",
        "btnSplitStore": "Fractionner",
        "colStoreroom": "Magasin",
        "colArrived": "Arrivé",
        "colRejected": "Rejeté",
        "plcClickSearch": "Cliquez pour chercher ->",
        "lookupSelectStore": "Sélectionner un magasin",
        "lblQcMatrix": "Matrice de décision de contrôle qualité",
        "optSelectDecision": "-- Requis : Sélectionner une décision --",
        "optPassed": "ENTIÈREMENT ACCEPTÉ",
        "optFailed": "ENTIÈREMENT REJETÉ (RETOUR FOURNISSEUR)",
        "optPartial": "ACCEPTATION PARTIELLE (VOIR CHAMP REJETÉ)",
        "lblInvValuation": "Évaluation des stocks (Coût unitaire moyen)",
        "lblNetArrived": "Stock net arrivé",
        "msgSelectLine": "Sélectionnez une ligne de commande active pour commencer le traitement"
      },
      "userList": {
        "title": "SÉCURITÉ UTILISATEUR",
        "plcSearch": "Rechercher Utilisateur ou Email...",
        "btnNewUser": "NOUVEL UTILISATEUR",
        "colUserId": "ID UTILISATEUR",
        "colFullName": "NOM COMPLET",
        "colRole": "RÔLE",
        "colSite": "SITE",
        "colStatus": "STATUT",
        "colEmail": "EMAIL",
        "msgSyncing": "Synchronisation de la sécurité...",
        "lblNoRole": "AUCUN RÔLE",
        "lblAll": "TOUS",
        "lblTotalUsers": "TOTAL UTILISATEURS :",
        "lblPage": "PAGE",
        "errLoadUsers": "Erreur lors du chargement des utilisateurs"
      },
      "crafts": {
        "headers": {
          "craftList": "Catalogue des Métiers"
        },
        "actions": {
          "newCraft": "Nouveau Métier"
        },
        "tables": {
          "craftCode": "Code Métier",
          "description": "Description",
          "stdRate": "Taux Std/Heure",
          "site": "Site",
          "org": "Organisation"
        },
        "messages": {
          "loadFailed": "Échec du chargement des métiers"
        },
        "headers": {
          "craftList": "Catalogue des Métiers"
        },
        "tabs": {
          "skills": "Compétences et Niveaux"
        },
        "sections": {
          "costing": "Évaluation des coûts",
          "control": "Contrôle"
        },
        "actions": {
          "newCraft": "Nouveau Métier",
          "addSkill": "Ajouter un niveau"
        },
        "tables": {
          "craftCode": "Code Métier",
          "description": "Description",
          "stdRate": "Taux Std/Heure",
          "site": "Site",
          "org": "Organisation"
        },
        "fields": {
          "stdHourlyRate": "Taux horaire standard",
          "skillLevel": "Niveau de compétence (ex. Expert, Junior)",
          "hourlyRate": "Taux horaire"
        },
        "placeholders": {
          "enterLevel": "ENTRER LE NIVEAU..."
        },
        "messages": {
          "loadFailed": "Échec du chargement des métiers",
          "autoCalc": "Calculé automatiquement à partir de la somme des compétences",
          "noSkills": "Aucune compétence définie pour le moment"
        }
      },
      "persons": {
        "headers": {
          "directory": "Annuaire du Personnel"
        },
        "actions": {
          "newPerson": "Nouvelle Personne"
        },
        "tables": {
          "personId": "ID Personne",
          "name": "Nom d'affichage",
          "site": "Site",
          "email": "Email",
          "phone": "Téléphone"
        },
        "messages": {
          "loadFailed": "Échec du chargement de la liste du personnel"
        },
        "headers": {
          "directory": "Annuaire du Personnel"
        },
        "tabs": {
          "profile": "Infos du Profil",
          "contact": "Annuaire des Contacts",
          "access": "Accès Système"
        },
        "sections": {
          "personalInfo": "Informations Personnelles",
          "statusControl": "Statut et Contrôle",
          "contactsDirectory": "Contacts Associés"
        },
        "tables": {
          "personId": "ID Personne",
          "name": "Nom d'affichage",
          "site": "Site",
          "email": "Email",
          "phone": "Téléphone"
        },
        "fields": {
          "location": "Emplacement",
          "firstName": "Prénom",
          "lastName": "Nom de famille",
          "title": "Titre du poste",
          "department": "Département",
          "currentStatus": "Statut Actuel",
          "contactName": "Nom du Contact",
          "position": "Fonction",
          "email": "Adresse Email",
          "phone": "Téléphone",
          "mobile": "Mobile",
          "primary": "Principal",
          "address": "Adresse",
          "city": "Ville",
          "country": "Pays",
        },
        "actions": {
          "newPerson": "Nouvelle Personne",
          "addContact": "Ajouter un Contact"
        },
        "messages": {
          "loadFailed": "Échec du chargement de la liste du personnel",
          "noContacts": "Aucun contact ajouté pour le moment",
          "accessControlled": "L'accès au système est contrôlé par le module de sécurité des utilisateurs"
        }
      },
      "jp": {
        "list": {
          "title": "Répertoire des Plans de Travail",
          "new_plan": "NOUVEAU PLAN",
          "filter_jp": "Filtrer les plans...",
          "search_desc": "Rechercher une description...",
          "filter_site": "Site...",
          "no_records": "Aucun plan de travail trouvé",
          "fetch_error": "Échec du chargement des plans"
        },
        "fields": {
          "jpnum": "N° de Plan",
          "description": "Description",
          "status": "Statut",
          "revision": "Révision",
          "site": "Site"
        },
        "details": {
          "load_error": "Échec du chargement du plan de travail",
          "delete_warn": "Vous êtes sur le point de supprimer le plan de travail {{jpnum}}. Cette action est irréversible !"
        },
        "tabs": {
          "job_plan": "Plan de Travail",
          "plans": "Plans",
          "assets": "Actifs"
        },
        "subtabs": {
          "tasks": "Tâches",
          "labor": "Main-d'œuvre",
          "materials": "Matériaux",
          "tools": "Outils"
        },
        "sections": {
          "details": "Détails du Plan",
          "responsibility": "Responsabilité",
          "woassets": "Actifs de Travail et Sécurité"
        },
        "fields": {
          "jpnum": "N° de Plan",
          "status": "Statut",
          "description": "Description",
          "template_type": "Type de Modèle",
          "duration": "Durée (H)",
          "supervisor": "Superviseur",
          "class": "Structure de Classe",
          "safety_plan": "Plan de Sécurité",
          "revision": "Révision"
        },
        "table": {
          "seq": "Séquence",
          "duration": "Durée",
          "craft": "Métier",
          "labor": "Employé",
          "qty": "Qté",
          "hours": "Heures",
          "rate": "Taux",
          "item": "Article",
          "unitcost": "Coût Unitaire",
          "tool": "Outil"
        }
      },
      "meters": {
        "list": {
          "title": "Définitions des Compteurs",
          "search": "Filtrer par Num ou Nom...",
          "new_meter": "NOUVEAU COMPTEUR",
          "no_records": "Aucun compteur trouvé"
        },
        "fields": {
          "meter_num": "N° Compteur",
          "meter_name": "Nom du Compteur",
          "type": "Type",
          "uom": "Unité"
        },
        "tabs": {
          "meter": "Détails du Compteur",
          "where_used": "Où Utilisé"
        },
        "sections": {
          "info": "Informations du Compteur",
          "additional": "Détails Supplémentaires",
          "stats": "Statistiques"
        },
        "fields": {
          "active": "Actif ?",
          "remarks": "Remarques",
          "last_reading": "DERNIÈRE LECTURE",
          "last_date": "DATE DERNIÈRE LECTURE",
          "rollovers": "RÉINITIALISATIONS"
        },
        "where_used": {
          "linked_assets": "Actifs Liés",
          "linked_locations": "Emplacements Liés",
          "linked_items": "Articles Liés",
          "searching": "🔍 Recherche dans le système...",
          "no_assoc": "Aucune association trouvée.",
          "asset_num": "N° Actif",
          "site": "Site",
          "status": "Statut",
          "location": "Emplacement",
          "item_num": "N° Article",
          "category": "Catégorie"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Catégories d'Actifs",
          "search": "Rechercher des catégories...",
          "new_category": "NOUVELLE CATÉGORIE",
          "no_records": "Aucune catégorie trouvée"
        },
        "fields": {
          "category_id": "Code Catégorie",
          "description": "Description",
          "dep_method": "Méthode d'Amort.",
          "life": "Durée (Ans)"
        }
      },
      "export": {
        "loading": "Extraction des données...",
        "success": "Exportation réussie !",
        "error": "Erreur lors de l'exportation des données."
      },
      "labor": {
        "list": {
          "title": "Registre de la Main-d'œuvre",
          "new": "NOUVEAU TRAVAILLEUR",
          "total": "Main-d'œuvre Totale",
          "unique_crafts": "Métiers de la Page",
          "no_records": "Aucun travailleur trouvé."
        },
        "tabs": {
          "main": "PRINCIPAL",
          "person": "PERSONNE",
          "crafts": "MÉTIERS",
          "log": "HISTORIQUE"
        },
        "sections": {
          "basic": "Informations de Base",
          "status": "Statut et Organisation",
          "additional_crafts": "Métiers Supplémentaires et Compétences"
        },
        "fields": {
          "personid": "Réf. Personne",
          "primary_craft": "Métier Principal",
          "actual_rate": "Taux Réel (Horaire)",
          "skill": "Niveau de Compétence",
          "rate": "Taux Horaire",
          "primary": "Principal ?",
          "laborcode": "Code Travailleur",
          "fullname": "Nom Complet",
          "craft": "Métier"
        },
        "actions": {
          "add_craft": "AJOUTER MÉTIER"
        },
        "lookup": {
          "person": "Sélectionner Personne",
          "craft": "Sélectionner Métier",
          "skill": "Sélectionner Compétence"
        },
        "messages": {
          "no_crafts": "Aucune association de métier trouvée"
        },
        "details": {
          "delete_warn": "Vous ne pourrez pas récupérer cet enregistrement !"
        }
      },
      "sr": {
        "list": {
          "title": "Suivi des Demandes de Service",
          "new": "NOUVELLE DEMANDE"
        },
        "messages": {
          "no_records": "Aucune demande de service trouvée"
        },
        "tabs": {
          "main": "Demande de Service",
          "related": "Dossiers Liés"
        },
        "sections": {
          "requester": "Demandeur & Contact",
          "problem": "Spécifications du Problème",
          "logistics": "Logistique & Priorité"
        },
        "fields": {
          "phone": "Téléphone",
          "email": "E-mail",
          "asset": "Actif",
          "location": "Emplacement",
          "long_desc": "Description Détaillée du Problème",
          "priority_1": "1 - URGENCE (IMMÉDIAT)",
          "priority_2": "2 - ÉLEVÉE (MÊME JOUR)",
          "priority_3": "3 - MOYENNE (72 HEURES)",
          "priority_4": "4 - FAIBLE (PLANIFIÉ)",
          "srnum": "Numéro DS",
          "description": "Description",
          "reportedby": "Signalé Par",
          "reportdate": "Date de Signalement",
          "priority": "Priorité"
        },
        "lookup": {
          "person": "Sélectionner Personne",
          "asset": "Sélectionner Actif",
          "location": "Sélectionner Emplacement"
        },
        "details": {
          "delete_new_only": "Seules les NOUVELLES demandes peuvent être supprimées",
          "delete_warn": "Cela supprimera définitivement cette demande de service.",
          "wf_tip": "Flux de travail : Après l'enregistrement, utilisez le bouton 'Acheminer le Flux' pour envoyer cette demande à l'examen technique.",
          "wo_tip": "Astuce : Vous pouvez générer un Ordre de Travail depuis cette demande via les actions du flux de travail."
        },
        "related": {
          "title": "Ordres de Travail liés pour la DS :",
          "wonum": "Numéro OT",
          "worktype": "Type de Travail",
          "no_wo": "Aucun ordre de travail n'a encore été créé pour cette DS.",
          "go_to_wo": "Aller à l'Ordre de Travail"
        }
      },
      "invusage": {
        "list": {
          "title": "Historique d'Utilisation du Stock",
          "new": "Nouvelle Transaction"
        },
        "types": {
          "all": "TOUT",
          "issue": "ÉMISSION",
          "transfer": "TRANSFERT",
          "return": "RETOUR"
        },
        "tabs": {
          "lines": "LIGNES D'UTILISATION",
          "log": "JOURNAL DES TRANSACTIONS"
        },
        "details": {
          "summary": "Résumé des Lignes",
          "transfer_dest": "Détails de Destination du Transfert",
          "financial": "Facturation Financière & Référence"
        },
        "actions": {
          "add_item": "Ajouter Article",
          "add_part": "Ajouter Pièce",
          "select_mr": "SÉLECTIONNER DM"
        },
        "fields": {
          "stock_item": "Article en Stock",
          "issueunit": "Unité de Sortie",
          "qty": "Quantité",
          "unitcost": "Coût Unitaire",
          "linecost": "Valeur Totale Ligne",
          "target_bin": "Bac Cible dans",
          "target_loc": "Emplacement Cible",
          "assetnum": "Numéro d'Actif",
          "wonum": "Référence OT",
          "glaccount": "Compte GL Débit",
          "usagenum": "ID d'Utilisation",
          "type": "Type",
          "fromstore": "Du Magasin",
          "lines": "Lignes",
          "enterby": "Saisi par"
        },
        "placeholders": {
          "select_item": "SÉLECTIONNER ARTICLE...",
          "dest_bin": "ENTRER BAC DESTINATION...",
          "choose_loc": "CHOISIR EMPLACEMENT",
          "select_asset": "SÉLECTIONNER ACTIF",
          "charge_wo": "FACTURER À L'OT"
        },
        "lookup": {
          "store": "Magasins",
          "dest_store": "Magasins de Destination",
          "mr": "Sélectionner DM Approuvée",
          "item": "Recherche Stock",
          "loc": "Emplacements",
          "asset": "Registre des Actifs",
          "wo": "Ordres de Travail"
        },
        "messages": {
          "req_fromstore": "Veuillez d'abord sélectionner un Magasin !",
          "mr_loaded": "Articles chargés depuis la DM :",
          "mr_fail": "Échec du chargement des articles de la DM",
          "insufficient_title": "Stock Insuffisant !",
          "available": "Disponible",
          "create_pr": "Créer DA ?",
          "btn_create_pr": "Créer DA",
          "processing": "Traitement des ajustements de stock...",
          "inventory_updated": "Niveaux de stock mis à jour avec succès",
          "cant_delete_comp": "Impossible de supprimer une transaction terminée !",
          "delete_warn": "Cela supprimera définitivement le brouillon.",
          "req_fields": "La description et le magasin sont obligatoires !",
          "req_transfer": "Le magasin de destination est requis pour les transferts !",
          "locked_title": "Enregistrement Verrouillé",
          "locked_text": "Cette transaction est TERMINÉE et ne peut être modifiée.",
          "cant_save_comp": "Impossible de sauvegarder un enregistrement terminé",
          "balance_move": "Remarque : Le solde sera déplacé vers",
          "upon_comp": "à l'achèvement."
        }
      },
      "downtime": {
        "title": "Signaler Temps d'Arrêt",
        "subtitle": "Système de Gestion des Actifs",
        "asset": "Actif",
        "status": "Enregistrement Hors Ligne",
        "start": "Date et Heure de Début",
        "end": "Date de Fin (Optionnel)",
        "type": "Type d'Arrêt",
        "types": {
          "unplanned": "NON PLANIFIÉ (Panne)",
          "planned": "PLANIFIÉ (Maintenance)"
        },
        "duration": "Durée Calculée",
        "hours": "HEURES",
        "prod_impact": "Arrêt Opérationnel (Impact Production)",
        "btn_commit": "Valider Modifications",
        "messages": {
          "recording": "Enregistrement de l'arrêt...",
          "success": "Temps d'arrêt enregistré avec succès",
          "validation_error": "Erreur de format : Vérifiez tous les champs",
          "server_error": "Erreur Serveur : 500"
        },
        "history": {
          "title": "Historique des arrêts de l'actif",
          "subtitle": "Suivi des performances pour l'actif",
          "no_records": "Aucun événement d'arrêt enregistré pour cet actif.",
          "duration_hrs": "Durée (Hrs)",
          "type_reason": "Type/Raison",
          "impact": "Impact",
          "reported_by": "Signalé Par",
          "still_down": "TOUJOURS À L'ARRÊT",
          "prod_loss": "Perte Prod.",
          "technical": "Technique",
          "active_down": "Arrêt Actif",
          "resolved": "Résolu"
        }
      },
      "incidents": {
        "list": {
          "title": "Registre des Incidents",
          "new": "NOUVEL INCIDENT"
        },
        "fields": {
          "ticket_id": "ID Ticket",
          "priority": "Priorité",
          "reported_by": "Signalé Par"
        },
        "details": {
          "ticket": "Ticket d'Incident",
          "general": "Description Générale",
          "detailed": "Détails Détaillés",
          "context": "Contexte & Statut",
          "linked_asset": "Actif Lié",
          "workorder": "Ordre de Travail",
          "delete_warn": "Vous êtes sur le point de supprimer définitivement l'incident {{ticket}}. Cette action est irréversible !"
        },
        "lookup": {
          "asset": "Sélectionner Actif Lié",
          "loc": "Sélectionner Emplacement"
        }
      },
      "tools": {
        "list": {
          "title": "Registre des Outils",
          "new": "NOUVEL OUTIL"
        },
        "fields": {
          "toolnum": "Numéro d'Outil",
          "type": "Type",
          "is_stocked": "Stocké ?"
        },
        "tabs": {
          "tool": "OUTIL",
          "stores": "MAGASINS",
          "vendors": "FOURNISSEURS",
          "specs": "SPÉCS",
          "quals": "QUALS"
        },
        "sections": {
          "config": "Configuration de l'outil",
          "inventory": "Inventaire et soldes de stock",
          "vendors": "HISTORIQUE DES ACHATS ET FOURNISSEURS",
          "quals": "Qualifications requises"
        },
        "fields": {
          "toolnum": "Numéro d'outil",
          "type": "Type d'outil",
          "issueunit": "Unité de sortie",
          "is_stocked": "Outil stocké ?",
          "rotating": "Article tournant ?",
          "calib_req": "Étalonnage requis ?",
          "mfg": "Fabricant",
          "model": "N° de modèle",
          "class": "Classification",
          "active_vendors": "FOURNISSEURS ACTIFS"
        },
        "actions": {
          "add_store": "Ajouter au magasin",
          "add_qual": "Ajouter Qualification"
        },
        "tables": {
          "storeroom": "Magasin",
          "balance": "Solde",
          "attr": "Attribut",
          "value": "Valeur",
          "uom": "UOM",
          "qual": "Qualification",
          "vendor_id": "Fournisseur (N° Comp)",
          "vendor_name": "Nom du fournisseur",
          "unitcost": "Coût unitaire",
          "qty": "Qté",
          "po": "BC de référence"
        },
        "placeholders": {
          "toolid": "ENTRER L'ID DE L'OUTIL...",
          "reg_supplier": "FOURNISSEUR ENREGISTRÉ",
          "adj": "AJUSTEMENT STOCK"
        },
        "lookup": {
          "type": "Type d'outil",
          "unit": "Unités de sortie",
          "attr": "Attributs"
        },
        "messages": {
          "req_fields": "Le numéro d'outil et la description sont obligatoires !",
          "delete_warn": "Vous ne pourrez pas annuler cela !",
          "class_loaded": "Classification et attributs chargés",
          "stocked_note": "Remarque : Les outils stockés sont gérés via des magasins et nécessitent un enregistrement d'inventaire pour suivre les soldes.",
          "no_stock": "Aucun article en stock"
        }
      },
      "inventory": {
        "list": {
          "title": "Registre d'Inventaire"
        },
        "fields": {
          "itemnum": "N° Article",
          "location": "Magasin",
          "balance": "Solde",
          "avgcost": "Coût Moyen"
        },
        "details": {
          "profile": "Profil d'Inventaire",
          "reorder_logic": "Logique de Réapprovisionnement",
          "reorder_pt": "Point de Commande",
          "eoq": "Quantité Économique de Commande",
          "critical_lvl": "Niveau Critique",
          "critical_desc": "Générer automatiquement une DA lorsque le solde atteint le point de commande.",
          "current_stock": "Niveau de Stock Actuel",
          "avail_qty": "Quantité Disponible",
          "reserved_qty": "Qté Réservée",
          "held_wo": "Retenue pour Ordres de Travail",
          "avg_cost": "Coût Unitaire Moyen",
          "avg_cost_desc": "Moyenne pondérée de toutes les réceptions",
          "total_val": "Valeur Totale du Stock",
          "total_val_desc": "Solde Actuel × Coût Moyen",
          "last_cost": "Coût de la Dernière Réception",
          "last_cost_desc": "Coût du dernier BC",
          "val_method": "Méthode de Valorisation des Stocks",
          "avg_method": "COÛT MOYEN",
          "val_desc1": "Cet article utilise la méthode du",
          "val_desc2": ". Le coût unitaire est recalculé automatiquement à chaque réception de commande pour refléter les fluctuations du marché."
        },
        "tabs": {
          "balances": "Soldes",
          "trans": "Historique des Transactions",
          "costs": "Coûts"
        },
        "actions": {
          "adjustment": "Ajustement de Stock"
        },
        "tables": {
          "qty": "Quantité",
          "actual_cost": "Coût Réel",
          "reference": "Référence"
        },
        "messages": {
          "no_trans": "Aucun Historique de Transaction Trouvé"
        },
        "trans_types": {
          "receipt": "RÉCEPTION",
          "issue": "SORTIE",
          "transfer": "TRANSFERT",
          "adjustment": "AJUSTEMENT"
        }
      },
      "storerooms": {
        "list": {
          "title": "Magasins",
          "new": "NOUVEAU MAGASIN"
        },
        "fields": {
          "location": "Magasin",
          "isdefault": "Par Défaut ?",
          "inventory": "Inventaire",
        },
        "details": {
          "profile": "Magasin",
          "record": "Dossier du Magasin",
          "gen_settings": "Paramètres Généraux",
          "filtered_by": "Filtré par {{org}}",
          "select_org_first": "Sélectionnez d'abord l'org",
          "gl_accounts": "Comptes GL",
          "inv_control": "Contrôle des Stocks",
          "inv_control_desc": "Toutes les sorties et réceptions de matériel pour ce magasin seront équilibrées par rapport à ces comptes.",
          "items_stocked": "Articles Stockés"
        },
        "tabs": {
          "main": "PRINCIPAL",
          "inventory": "INVENTAIRE"
        },
        "fields": {
          "location": "ID Emplacement",
          "isdefault": "Magasin par défaut ?",
          "useinpo": "Utiliser dans les BC ?",
          "invowner": "Propriétaire du Stock",
          "controlacc": "Compte de Contrôle",
          "shrinkacc": "Compte de Perte/Gain",
          "glaccount": "Compte GL par Défaut",
          "default": "DÉFAUT"
        },
        "lookup": {
          "person": "Sélectionner une Personne"
        },
        "tables": {
          "itemnum": "N° Article",
          "uom": "UOM",
          "curbal": "Solde Actuel",
          "reserved": "Qté Réservée"
        },
        "messages": {
          "req_fields": "L'ID de l'emplacement est obligatoire !",
          "req_org_site": "L'Org et le Site sont obligatoires !",
          "delete_warn": "Vous êtes sur le point de supprimer le magasin {{store}}. Cette action est irréversible !"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Bibliothèque des Codes de Panne",
          "new": "Nouvelle Classe de Panne"
        },
        "details": {
          "profile": "Classe de Panne"
        },
        "fields": {
          "class": "Classe de Panne",
          "code": "Code",
          "desc_tech": "Description / Nom Technique"
        },
        "tables": {
          "problems": "Problèmes (Le Défaut)",
          "causes": "Causes (Cause Fondamentale)",
          "remedies": "Remèdes (L'Action)"
        },
        "placeholders": {
          "class": "EX. PUMP-FAIL",
          "desc_tech": "Fournissez une description détaillée de cette hiérarchie de pannes...",
          "code": "Entrez le Code...",
          "desc": "Description Technique..."
        },
        "messages": {
          "req_class": "Le code de la classe de panne est obligatoire !",
          "delete_warn": "Vous êtes sur le point de supprimer la classe de panne {{class}}. Cette action est irréversible !"
        }
      },
      "scheduler": {
        "title": "Répartition et Planification",
        "ai_optimize": "OPTIMISATION AUTO IA",
        "publish": "PUBLIER LE PLANNING",
        "kpi_scheduled": "Travaux Planifiés",
        "kpi_issues": "Problèmes de Planification",
        "kpi_utilization": "Ressources Totales",
        "kpi_emergencies": "Urgences",
        "no_data": "Aucun ordre de travail planifié.",
        "no_resources": "Aucune donnée de capacité des ressources.",
        "fetch_error": "Échec du chargement des données de planification.",
        "optimizing": "L'IA équilibre la charge des ressources...",
        "optimize_fail": "L'optimisation IA a échoué."
      },
      "features": {
        "title": "Catalogue des Caractéristiques Linéaires",
        "feature_id": "Code de Caractéristique",
        "description": "Description",
        "type": "Type de Caractéristique",
        "point": "Point (ex: Vanne)",
        "linear": "Linéaire (ex: Matériau)",
        "error_in_use": "Suppression impossible : caractéristique en cours d'utilisation."
      },
      "audit": {
        "title": "Explorateur de Piste d'Audit",
        "history_for": "Historique pour",
        "retrieving": "Récupération des enregistrements d'audit...",
        "no_records": "Aucune piste d'audit trouvée pour cet enregistrement"
      },

    }
  },
  // 🇩🇪 Deutsch
  de: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "Asset Exzellenz", version: "Teknova v1.0.4" },
      search: { placeholder: "Module suchen..." },
      menu: {
        settings: "Einstellungen", organization: "Organisation", domains: "Domänen", field_config: "Feldkonfiguration", classifications: "Klassifizierungen", importer: "Universal-Importer", cobie: "COBie Manager", workflow: "Workflow-Engine", scripts: "Aktionsskripte",
        analytics: "Analytik", dashboards: "BI-Dashboards", report_designer: "Berichtsdesigner", report_wizard: "Bericht-Assistent",
        assets: "Anlagen", asset_registry: "Anlagenregister", locations: "Standorte", categories: "Anlagenkategorien", meters: "Zähler", failure_codes: "Fehlercodes",
        work_management: "Arbeitsmanagement", wo_tracking: "Arbeitsauftragsverfolgung", labor_reporting: "Terminplaner",
        resources: "Ressourcen", crafts: "Gewerke", labor: "Arbeitskräfte", person: "Person",
        service_desk: "Service-Desk", service_requests: "Serviceanfragen", incidents: "Vorfallsregister",
        procurement: "Beschaffung", po: "Bestellungen", pr: "Kaufanfragen", rfq: "Angebotsanfrage", receiving: "Wareneingang", vendors: "Lieferanten",
        contracts: "Verträge", contracts_master: "Vertragsmaster", sla: "SLA",
        inventory: "Lagerbestand", item_master: "Artikelstamm", tools: "Werkzeuge", balances: "Lagerbestände", transfers: "Umlagerungen", storerooms: "Lagerräume",
        planning: "Planung", pm_schedules: "Wartungspläne", safety_plans: "Sicherheitspläne", hazards: "Gefahren", precautions: "Vorsichtsmaßnahmen", tagouts: "Absperrungen", job_plans: "Arbeitspläne",
        security: "Sicherheit", user_list: "Benutzerliste", groups: "Sicherheitsgruppen", "recent": "Zuletzt Besucht"
      },
      user_settings: { title: "Benutzereinstellungen", default_info: "Standardinformationen", personal_info: "Persönliche Daten", password_info: "Passwortinformationen", sign_out: "Abmelden", system_info: "Systeminformationen" },
      notifications: { title: "Posteingangsaufgaben", new_alerts: "Neu", empty: "Ihr Posteingang ist leer", view_all: "Alle Aktivitäten anzeigen" },
      sidebar: { queries: "Abfragen", all_assets: "Alle Anlagen", operating_assets: "Betriebsanlagen", critical_assets: "Kritische Anlagen", my_bookmarks: "Meine Lesezeichen", common_actions: "Aktionen", new: "Neu", move_assets: "Anlagen verschieben", print_barcodes: "Barcodes drucken", create_report: "Bericht erstellen", wo_queries: "AA-Abfragen", all_wo: "Alle Aufträge", waiting_approval: "Wartet auf Freigabe", wip: "In Arbeit", completed_today: "Heute abgeschlossen", bulk_approve: "Massenfreigabe", record_actions: "Datensatzaktionen", save: "Speichern", delete: "Löschen", workflow_status: "Workflow / Status", change_status: "Status ändern", view_history: "Historie anzeigen", item_ops: "Artikelaktionen", add_to_storeroom: "Zum Lager hinzufügen", inv_ops: "Lageraktionen", reorder: "Nachbestellen", tax_ops: "Steueraktionen", tax_category: "Steuerkategorie", create_po: "Bestellung erstellen", settings_group: "Einstellungen", system_settings: "Systemeinstellungen", email_settings: "E-Mail-Einstellungen", asset_ops: "Anlagenaktionen", meter_readings: "Zählerstände", hist_readings: "Historische Stände", report_downtime: "Ausfall melden", downtime_hist: "Ausfallhistorie", move_mod_asset: "Verschieben/Ändern", asset_move_hist: "Verschiebehistorie", create_related: "Verknüpftes erstellen", create_incident: "Vorfall erstellen", view_inc_hist: "Vorfallhistorie", create_wo: "AA erstellen", sr: "Serviceanfrage", apply_sla: "SLA anwenden", approve_wo: "AA freigeben", start_work: "Arbeit starten", complete_work: "Arbeit abschließen", close_wo: "AA schließen", analytics: "Analytik", wf_history: "Workflow-Historie", history_log: "Protokoll", wo_costs: "AA-Kosten", purchase_info: "Einkaufsinfos", all_records: "Alle Datensätze", find_nav: "Menü suchen", more_actions: "Weitere Aktionen", settings: "Einstellungen", export_data: "Exportieren", audit_log: "Audit-Log", share_app: "App teilen" },
      apps: {
        ORGANIZATION: "Organisationen", ASSET: "Anlagen", LOCATION: "Standorte", WORKORDER: "Arbeitsaufträge", INVENTORY: "Lagerbestand", CLASSIFICATION: "Klassifizierungen", VENDOR: "Lieferanten", METER: "Zähler", DOMAINS: "Domänen", CRAFTS: "Gewerke", STOREROOMS: "Lagerräume", ITEMS: "Artikelstamm", INVENTORYUSAGE: "Lagerverbrauch", MR: "Materialanfragen", PR: "Kaufanfragen", PO: "Bestellungen", LABOR: "Personal", PM: "Wartungspläne", SAFETY: "Sicherheitspläne", HAZARD: "Gefahren", TAGOUT: "Absperrungen", PRECUTION: "Vorsichtsmaßnahmen", SR: "Serviceanfragen", INCIDENT: "Vorfälle", ASSET_CATEGORIES: "Anlagenkategorien", FAILURECLASS: "Fehlercodes", RFQ: "Angebotsanfragen", CONTRACT: "Verträge", SLA: "Service-Level-Vereinbarung", FAILURE_CODES: "Fehlercodes",
        "VENDORS": "Lieferanten", "TAGOUTS": "Freischaltungen", "PRECAUTIONS": "Vorsichtsmaßnahmen", "INCIDENTS": "Vorfälle","JOBPLAN": "Arbeitspläne", "ROLE": "Rollen", "TOOLS": "Werkzeuge", "USER": "Benutzer",
      },
      dashboard: { tab_bi: "KPI-Vorlage", tab_inbox: "Workflow-Posteingang", advanced_analytics: "Erweiterte Analysen", workflow_center: "Ausführungszentrum", active_tasks: "Aktive Aufgaben", history_tasks: "Verlauf", no_data: "Keine Daten gefunden", take_action: "Handeln", previous: "Zurück", next: "Weiter", showing: "Anzeigen", of: "von", actual: "Ist", target: "Ziel", kpi_graph: "KPI-Grafik" },
      username: "Benutzer-ID",
      password: "Passwort",
      login_btn: "Anmelden",
      forgot_pwd: "Passwort vergessen?",
      login: {
        id_placeholder: "Geben Sie Ihre ID ein",
        error_msg: "Ungültige ID oder Passwort",
        server_error: "Serververbindung fehlgeschlagen",
        just_smart: "Einfach Intelligent"
      },
      organizations: { title: "Organisationen", org_id: "Organisation", description: "Beschreibung", active: "Aktiv?" },
      org_detail: { org_label: "Organisation", tabs: { organization: "Organisation", sites: "Standorte", map: "Karte" }, fields: { currency1: "Basiswährung 1", currency2: "Basiswährung 2", item_set: "Artikelsatz", company_set: "Firmen-Set", item_status: "Standardstatus", active: "Aktiv?" }, descs: { currency1: "Hauptwährung", currency2: "Zweitwährung", item_set: "ARTIKELSATZ", company_set: "FIRMEN-SET" }, lookups: { currency: "Währung", item_set: "Artikelsatz", company_set: "Firmen-Set", status: "Status", governorate: "Gouvernement" }, sites: { management: "Standortverwaltung", new_row: "Neue Zeile", of: "von", site_id: "Standort-ID", description: "Beschreibung", active: "Aktiv?", action: "Aktion", site_details: "Standortdetails", state: "Staat / Bezirk", contact: "Hauptkontakt", fin_info: "Finanzinformationen", yearly_budget: "Jahresbudget", monthly_budget: "Monatsbudget", utilization: "Auslastung", fin_health: "Finanzlage stabil." }, toasts: { id_required: "ID erforderlich!", saving: "Speichern...", success: "Erfolgreich gespeichert!", fail: "Fehlgeschlagen" } },
      domains: { title: "Domänen", find_placeholder: "Domäne suchen...", new_domain: "Neue Domäne", domain_id: "Domäne", description: "Beschreibung", type: "Typ", values: "Werte" ,
        save_btn: "Speichern", desc_placeholder: "Domänenbeschreibung", synonym_values: "Synonymwerte", new_row: "Neue Zeile", internal_val: "Interner Wert", external_desc: "Externe Beschreibung", default: "Standard?", action: "Aktion", no_values: "Keine Werte definiert.", toasts: { loading: "Laden...", load_fail: "Fehler beim Laden", id_required: "ID erforderlich!", saving: "Speichern...", save_success: "Gespeichert!", save_fail: "Fehler" } },
      classifications: { parent: "Übergeordnete Klasse", order: "Reihenfolge", hierarchy: "Struktur", hierarchy: "Hierarchiepfad", parent: "Übergeordnete Klasse", gen_desc: "Beschreibung generieren?", use_with: "Mit Objekten verwenden", attributes: "Attribute", attr_id: "Attribut-ID", section: "Sektion", uom: "Maßeinheit" },
      bim: { title: "BIM Integrator Pro", subtitle: "Erweitertes Revit-zu-COBie-Mapping", waiting_translation: "Warten auf Modellübersetzung...", tabs: { "3d": "3D-Viewer", data: "Datentabelle" }, preview_table_title: "COBie-Komponentenvorschau", controls: { destination: "Zielort", select_site: "Standort wählen", uploads: "Datei-Uploads", select_cobie: "COBie-Datei wählen", upload_revit: "Revit-Dateien hochladen", models_ready: "Modelle bereit", preview_list: "Vorschaumodelle", finalizing: "Synchronisierung...", commit: "BIM-Integration bestätigen" }, table: { asset_name: "Anlagenname", location: "Raum / Standort" } },
      importer: { title: "Universeller Datenlader", target_table: "Zieltabelle", download_template: "Vorlage herunterladen", upload_instruction: "Excel-Datei auswählen", field_mapping: "Feldzuordnung", excel: "Excel", ignore: "Ignorieren", preview_title: "Vorschau", execute_btn: "IMPORT AUSFÜHREN" },
      workflow: { title: "Workflow-Engine", subtitle: "Automatisierungs-Kontrollzentrum", export_btn: "CSV exportieren", new_process: "Neuer Prozess", loading: "Prozesse werden geladen...", unnamed: "Unbenannter Prozess", no_desc: "Keine Beschreibung vorhanden.", linked_to: "Verknüpft mit", create_path: "Neuen Pfad erstellen",
                  table: { id: "ID", name: "Prozessname", app: "App", status: "Status", created: "Erstellt am" },
                  tooltips: { edit: "Logik bearbeiten", settings: "Globale Einstellungen", delete: "Prozess löschen" },
                  toasts: { fetch_fail: "Fehler beim Abrufen der Workflows", no_data: "Keine zu exportierenden Daten" },
                  designer_title: "Workflow-Logik-Designer (Loopback aktiviert)", publish_btn: "VERÖFFENTLICHEN", loading_designer: "Logikpfad wird rekonstruiert...", logic_palette: "Logikpalette", config_title: "Konfiguration", node_label: "Bezeichnung", assign_roles: "Rollen zuweisen", post_action: "Nachbearbeitungsskripte", select_lookup: "AUS DEM LOOKUP AUSWÄHLEN", script_hint: "* Mehrere Skripte können durch Kommas getrennt werden.", status_auto: "Automatische Statusaktion", trigger: "Trigger", target_status: "Zielstatus", cond_expr: "Bedingter Ausdruck (Python)", escalation: "Eskalation (Stunden)", select_node: "Knoten zum Bearbeiten auswählen",
                  options: { no_change: "KEINE STATUSÄNDERUNG", change_status: "STATUS ÄNDERN", select_status: "STATUS AUSWÄHLEN" },
                  lookups: { select_roles: "Rollen nachschlagen", select_scripts: "Skripte auswählen" },
                  swal: { publish_title: "Workflow veröffentlichen?", publish_text: "Dadurch werden die Engine-Schritte mit der Datenbank synchronisiert.", confirm_publish: "Ja, jetzt veröffentlichen", delete_title: "Logik löschen?", delete_text: "Sind Sie sicher, dass Sie löschen möchten?", confirm_delete: "Ja, alles löschen" },
                  toasts: { id_required: "Bitte geben Sie einen Prozessnamen ein", saving: "Workflow wird synchronisiert...", save_success: "Workflow-Logik synchronisiert! 🚀", save_fail: "Synchronisierung fehlgeschlagen", purging: "Workflow wird gelöscht...", delete_success: "Workflow endgültig gelöscht", delete_fail: "Löschen fehlgeschlagen"}
      },
      field_config: { title: "Metadaten-Feldzuordnung", table_name: "TABELLENNAME", field_name: "FELDNAME", current_mappings: "AKTUELLE ZUORDNUNGEN FÜR", field: "Feld", linked_domain: "Verknüpfte Domäne" },
      scripts: {
        title: "AKTIONSSKRIPTE",
        subtitle: "Automatisierungs- und Logikvorlagen verwalten",
        new_btn: "NEUES SKRIPT ERSTELLEN",
        search_placeholder: "Nach Name oder Objekt suchen...",
        table: {
          name: "Skriptname",
          object: "Zielobjekt",
          created: "Erstellt am"
        },
        toasts: {
          fetch_fail: "Fehler beim Laden der Skripte"
        }
      },
      studio: { schema_explorer: "SCHEMA-EXPLORER", target_context: "Zielobjekt-Kontext", name_placeholder: "Skriptnamen eingeben...", engine_info: "ENGINE: PYTHON 3.10", console_title: "Ausführungskonsole", clear_console: "Konsole leeren", field_from: "Feld von", access_col: "Spaltenzugriff: ", db_model: "Datenbankmodell", btns: { compile: "KOMPILIEREN", compiling: "KOMPILIERUNG...", save_deploy: "SPEICHERN" }, toasts: { preserved: "Skript gespeichert!", compiled: "Analyse erfolgreich!" }, console: { init: "Studio initialisiert...", schema_sync: "Schema synchronisiert.", schema_fail: "Schema fehlgeschlagen.", saved_prefix: "Skript gespeichert", error_op: "Fehler beim Speichern.", compiling: "Analyse läuft...", build_finish: "Build abgeschlossen.", syntax_error: "Syntaxfehler.", build_fail: "Build fehlgeschlagen", analyzing: "Syntaxanalyse..." } },
      reports: { title: "Berichtsvorlagen", new_btn: "Neuen Bericht erstellen", search_placeholder: "Suchen...", table: { name: "Berichtsname", ref_obj: "Referenzobjekt", updated: "Aktualisiert" }, 
          toasts: { load_fail: "Fehler beim Laden", clone_success: "Bericht geklont",  save_success: "Vorlage gespeichert! 🚀", save_fail: "Speichern fehlgeschlagen" },
          designer: {
              title: "BERICHTS-DESIGNER PRO", live_preview: "Live-Vorschau", publish: "Vorlage veröffentlichen", model_select: "Modellauswahl", data_explorer: "Daten-Explorer", components: "Komponenten",
              page_break: "Seitenumbruch", is_summary: "Zusammenfassender Bericht?", user_params: "Benutzerparameter", add_param: "Eingabefeld hinzufügen", master_info: "Hauptinformationen",
              relational_data: "Verknüpfte Daten", detail_tables: "Detailtabellen", tabs: { body: "Inhalt", header: "Kopfzeile", footer: "Fußzeile", css: "Globales CSS" },
              fields: { wonum: "Auftragsnummer", assetnum: "Anlagennummer", desc: "Beschreibung", status: "Status", asset: "Anlagenname", location: "Standort-ID", tasks_table: "Aufgabentabelle", mat_table: "Geplante Materialien", asset_basic: "Anlagen-Basisinfo", inv_basic: "Inventar-Basisinfo", vend_basic: "Lieferanten-Basisinfo" }
            },
        
        }, 
      assets: { 
        map: {"gps_location": "Geografischer Standort (GPS)", "gps_coordinates": "GPS-Koordinaten"},
        list: { system_title: "Anlagenmanagement", new_asset: "Neue Anlage", all_orgs: "Alle Org", all_sites: "Alle Standorte", db_total: "Gesamt:", display_page: "Seite:", navigate_hint: "Verwenden Sie die Pfeile zur Navigation.", col_site: "Standort", col_org: "Org"}, 
        modal: { migration_title: "Massive Migration", caution_prefix: "Vorsicht: Sie verschieben", caution_suffix: "Anlagen.", dest_label: "Neuer Standort", placeholder: "STANDORT WÄHLEN...", abort: "Abbrechen", execute: "Ausführen" },
        headers: { asset_num: "Anlagennummer", desc: "Beschreibung", status: "Status", downtime: "Gesamte Ausfallzeit", site: "Standort" },
        tabs: { details: "Anlagendetails", spare_parts: "Ersatzteile", safety: "Sicherheit", meters: "Zähler", specs: "Spezifikationen", history: "Arbeitshistorie", map: "Geokarte", bim: "3D-Ansicht", ai: "KI-Analyse", eval: "Bewertung", attachments: "Anhänge" },
        sections: { "linear_details": "Lineare Referenzdetails", general: "Allgemeine Informationen", details: "Details", finance: "Adresse & Finanzen", image: "Anlagenbild", audit: "Audit-Info", bim_info: "BIM-Info", reliability: "Zuverlässigkeitsanalyse" },
        fields: { "is_linear": "Ist es ein lineares Anlagegut?", "start_measure": "Startmaß", "end_measure": "Endmaß", "measure_unit": "Maßeinheit", "direction": "Flussrichtung", type: "Anlagentyp", location: "Standort", parent: "Übergeordnete Anlage", category: "Anlagenkategorie", is_running: "Anlage in Betrieb?", serial: "Seriennummer", item: "Rotierendes Teil", failure: "Fehlerklasse", safety_plan: "Sicherheitsplan", vendor: "Lieferant", price: "Kaufpreis", replace: "Wiederbeschaffungswert", priority: "Priorität", ytd_cost: "Jahreskosten" },
        meters: { seq: "Sequenz", name: "Zähler", reading: "Letzte Ablesung", date: "Ablesedatum", inspector: "Inspektor", remarks: "Bemerkungen" },
        ai: { title: "Anlagen-Intelligenz", run: "Diagnose ausführen", summary: "Technische Zusammenfassung", recommend: "Empfehlungen", telemetry: "Telemetrie wird analysiert..." },
        spare_fields: { item: "Rotierendes Teil", qty: "Menge", issued: "Ausgegebene Menge", remarks: "Bemerkungen", item_details: "Artikeldetails" },
        safety: { plan_card: "Zugehörige Sicherheitspläne", active_plan: "Aktiver Sicherheitsplan", no_plan: "KEIN PLAN VERKNÜPFT", link_plan: "Plan verknüpfen", change_plan: "Plan ändern", hazard_title: "Anlagenspezifische Gefahren", hazard_num: "Gefahr", hazard_type: "Typ / Priorität", no_hazards: "Keine Gefahren verknüpft.", add_hazard: "Gefahr hinzufügen", loto_title: "Lock Out / Tag Out (LOTO)", tag_id: "Tag Out ID", req_state: "Erforderlicher Zustand", no_loto: "Keine Isolationspunkte definiert.", add_loto: "Isolationspunkt hinzufügen", applying_proto: "Sicherheitsprotokoll wird angewendet..." },
        meters: { title: "Zugehörige Zähler", details_title: "Zählerdetails", seq: "Sequenz", meter_name: "Zählername", meter_type: "Zählertyp", uom: "Maßeinheit", active_status: "Aktiv?", last_reading: "Letzte Ablesung", last_date: "Ablesedatum", inspector: "Inspektor", remarks: "Bemerkungen", new_meter: "Neuer Zähler" },
        specs: { classification: "Klassifizierung", select_class: "Klassifizierung auswählen...", tech_specs: "Technische Spezifikationen", attribute: "Attribut", value: "Wert", uom: "Maßeinheit", data_type: "Datentyp", attr_details: "Attributdetails", select_val: "Wert auswählen" },
        history: { title: "Arbeitsauftragshistorie", wo_num: "Auftrags-Nr.", finish_date: "Abschlussdatum", no_history: "Keine Historie gefunden.", fetching: "Historie wird geladen...", wo_type: "Typ" },
        bim: { model_status: "Modellstatus", linked: "VERKNÜPFT & AKTIV", not_linked: "NICHT VERKNÜPFT", upload_revit: "Revit hochladen (.rvt)", urn_label: "Modell-URN", "show_3d": "Digitalen Zwilling anzeigen (3D)", "not_linked": "Nicht mit 3D-Modell verknüpft" },
        ai: { title: "ANLAGEN-INTELLIGENZ", sub_title: "KI-Analysator", tagline: "Industrielle IoT-Prädiktive Diagnostik", run_btn: "DIAGNOSE STARTEN", analyzing: "TELEMETRIESTROM WIRD ANALYSIERT...", health_score: "Gesundheitsindex", thermal: "Thermischer Alarm", vibration: "Vibrationsalarm", tech_summary: "TECHNISCHE ZUSAMMENFASSUNG", recommendations: "EMPFEHLUNGEN", sensors_chart: "Sensoren vs. kritische Grenzwerte", init_prompt: "Klicken Sie auf DIAGNOSE STARTEN, um die KI-Analyse zu initialisieren", critical: "KRITISCH", normal: "NORMAL", stable: "STABIL", detected: "ERKANNT", "predictive_trajectory": "Prädiktive Ausfallkurve", "est_failure": "Erwarteter Ausfall", "loading_pred": "Prognosemodell wird erstellt..." },
        "features": {
          "feature_id": "Merkmal-ID",
          "label": "Bezeichnung",
          "start": "Startmaß",
          "end": "Endmaß (Leer = Punkt)",
          "value": "Wert (z.B. 500mm)",
          "details": "Merkmalsdetails",
          "y_offset": "Y-Versatz (Rechts/Links)",
          "z_offset": "Z-Versatz (Tiefe/Höhe)"
        },
    

      }, 
      common: { "days": "Tage", "weeks": "Wochen", "months": "Monate", "years": "Jahre", "daysList": { "saturday": "Samstag", "sunday": "Sonntag", "monday": "Montag", "tuesday": "Dienstag", "wednesday": "Mittwoch", "thursday": "Donnerstag", "friday": "Freitag"}, "select": "Auswählen", "search": "Suchen", "pending": "Ausstehend", "pendingSelection": "--- AUSWAHL AUSSTEHEND ---",confirm: "Bestätigung", save_settings: "KI-Konfiguration speichern", selected: "Anlagen ausgewählt", bulk_move: "Massive Migration", change_status: "Status ändern", cancel: "Zurücksetzen", save: "Speichern", cancel: "Abbrechen", delete: "Löschen", back: "Zurück", record: "Datensatz", total: "Gesamt", print: "Drucken", active: "Aktiv", critical: "Kritisch", warning: "Warnung", healthy: "Gesund", new_row: "Neue Zeile", of: "von", new_row: "Neue Zeile", "filter": "Filtern...", "save_success": "Erfolgreich gespeichert", "save_fail": "Speichern fehlgeschlagen",     "delete": "Löschen", "delete_success": "Erfolgreich gelöscht", "delete_fail": "Löschen fehlgeschlagen", "are_you_sure": "Sind Sie sicher?", "cancel": "Abbrechen", "confirm": "Bestätigen", "first": "Erste", "last": "Letzte", "next": "Nächste", "prev": "Vorherige", "sar": "SAR", "all": "ALLE", "attachments": "Anhänge",
    "history": "Verlauf", "change_status": "Status ändern", "totalRecords": "Gesamtdatensätze", "readOnly": "(SCHREIBGESCHÜTZT)", "noDescription": "Keine Beschreibung", "recordLocked": "Datensatz ist gesperrt und kann nicht geändert werden.", "descRequired": "Beschreibung ist erforderlich!", "actionDenied": "Aktion verweigert", "cantDeleteStatus": "Datensatz mit Status {{status}} kann nicht gelöscht werden", copy: "Kopie", cancel: "Abbrechen", clone: "Klonen", back: "zurück", yes: "Ja", no: "Nein", "main": "Hauptdetails", "save": "SPEICHERN",
    "change_status": "Status ändern", "history": "Historie", "delete": "Löschen", "org": "Organisation", "site": "Standort", "new_row": "NEUE ZEILE", "location": "Ort", "asset": "Anlage", "no_records": "Keine Datensätze gefunden", "saving": "Speichern...", "save_success": "Erfolgreich gespeichert!", "save_fail": "Speichern fehlgeschlagen", "are_you_sure": "Sind Sie sicher?", "yes_delete": "Ja, löschen!", "cancel": "Abbrechen", "delete_success": "Erfolgreich gelöscht", "delete_fail": "Löschen fehlgeschlagen: ", "clear_filters": "FILTER LÖSCHEN", "all": "ALLE", "syncing": "Synchronisiere...", "showing": "Anzeige", "total": "Gesamt", "created_by": "Erstellt von", "changed_date": "Änderungsdatum"},      toasts: { save_success: "Erfolgreich gespeichert", save_fail: "Speichern fehlgeschlagen", load_fail: "Datenladen fehlgeschlagen", delete_success: "Erfolgreich gelöscht" },
      swal: { delete_title: "Sind Sie sicher?", delete_text: "Sie sind dabei, die Anlage zu löschen:", confirm_delete: "Ja, Datensatz löschen" },
      "ai_settings": {
        "title": "KI-Ingenieur-Einstellungen",
        "sub_title": "KI-Vorausschauende Wartungs-Engine",
        "enable_label": "Automatische vorausschauende Wartung aktivieren",
        "enable_sub": "Automatische Erstellung von AU basierend auf KI-Analyse",
        "target_lang": "Sprache für Berichte und Aufgaben",
        "threshold": "Konfidenzschwellenwert für Entscheidungen",
        "auto_tasks": "Arbeitsaufgaben automatisch generieren (WOTasks)",
        "task_desc": "Arbeitsschritte automatisch in Aufgabentabelle schreiben",
        "max_tasks": "Max. Schritte pro Arbeitsauftrag",
        "section": "Abschnitt",
        "technicalDetails": "Technische Details"
      },
      "export_technical_report": "TECHNISCHEN BERICHT EXPORTIEREN (PDF)",
      "availability": "Verfügbarkeit",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "hrs": "STD",
      "reliability_score": "Zuverlässigkeitsbewertung",
      "score": "Punkte",
      "downtime_history_trend": "Ausfallzeiten-Verlaufstrend (Letzte 10 Ereignisse)",
      "values_in_hours": "Werte in Stunden",
      "timeline_event_date": "Zeitachse (Ereignisdatum)",
      "downtime_hours": "Ausfallzeit (Stunden)",
      "no_downtime_records": "Bisher keine Ausfallzeiten für diese Anlage gefunden.",
      "reliability_analysis": "Zuverlässigkeitsanalyse",
      "total_failures": "Gesamtausfälle",
      "total_down_time": "Gesamtausfallzeit",
      "last_calculation": "Letzte Berechnung",
      "maintenance_strategy_note": "Hinweis zur Wartungsstrategie",
      "high_mttr_detected": "Hohe MTTR erkannt. Empfehlung: Ersatzteilverfügbarkeit und technische Schulung für diese Anlagenkategorie bewerten.",
      "critical_availability": "Kritisches Verfügbarkeitsniveau. Erwägen Sie eine Erhöhung der PM-Frequenz oder geplante Überholungen.",
      "nominal_performance": "Anlagenleistung liegt innerhalb der nominalen Parameter. Standard-PM-Zeitplan fortsetzen.",
      "current_load_factor": "Aktueller Auslastungsfaktor",
      "optimal": "Optimal",
      statusModal: {
        "loadError": "Status konnte nicht geladen werden",
        "selectFirst": "Bitte wählen Sie zuerst einen Status",
        "updating": "Status wird aktualisiert...",
        "success": "Status aktualisiert",
        "failed": "Aktualisierung fehlgeschlagen",
        "changeStatus": "Status ändern:",
        "currentStatus": "Aktueller Status",
        "availableStatuses": "Verfügbare Status",
        "loading": "Wird geladen...",
        "chooseStatus": "Status wählen...",
        "memo": "Begründung / Notiz",
        "enterNotes": "Geben Sie Ihre Notizen ein...",
        "cancel": "Abbrechen",
        "update": "Aktualisieren"
      },
      attachmentsModal: {
        "loadError": "Fehler beim Laden von Dateien",
        "uploadSuccess": "Datei erfolgreich angehängt",
        "uploadFailed": "Hochladen fehlgeschlagen",
        "deleteConfirmTitle": "SIND SIE SICHER?",
        "deleteConfirmText": "Sie sind im Begriff, '{{name}}' dauerhaft zu löschen. Dadurch wird die Datei von unseren Servern entfernt.",
        "btnYesDelete": "JA, LÖSCHEN!",
        "btnCancel": "ABBRECHEN",
        "processingDelete": "Löschvorgang läuft...",
        "deletedTitle": "GELÖSCHT!",
        "deletedText": "Der Anhang wurde erfolgreich entfernt.",
        "deleteFailed": "Löschen fehlgeschlagen",
        "headerTitle": "Anlagenbibliothek",
        "linkingTo": "Verknüpft mit:",
        "filesFound": "GEFUNDENE DATEIEN:",
        "uploadBtn": "NEUES DOKUMENT HOCHLADEN",
        "thName": "Name",
        "thOwner": "Besitzer",
        "thStatus": "Status",
        "thActions": "Aktionen",
        "statusPrivate": "Privat",
        "statusPublic": "Öffentlich",
        "noDocs": "Noch keine Dokumente verknüpft"
      },
      enterMeters: {
        "noMeters": "Keine Zähler mit Anlage verknüpft:",
        "saving": "Zählerstände werden gespeichert...",
        "enterAtLeastOne": "Bitte geben Sie mindestens einen neuen Zählerstand ein",
        "saveSuccess": "Alle Zählerstände erfolgreich gespeichert!",
        "saveFailed": "Speichern der Zählerstände fehlgeschlagen",
        "title": "Zählerstände eingeben | Anlage:",
        "titleLoc": "Zählerstände eingeben | Standort:",
        "thIdentification": "Zähleridentifikation",
        "thNewReading": "* Neuer Zählerstand",
        "thReadingDate": "* Ablesedatum",
        "thMeterType": "Zählertyp",
        "thLastRecorded": "Zuletzt erfasst",
        "noDescription": "Keine Beschreibung",
        "enterValue": "Wert eingeben...",
        "notAvailable": "K.A.",
        "operator": "Bediener:",
        "btnCancel": "Abbrechen",
        "btnUpdate": "Zählerstände aktualisieren"
      },
      emailSettings: {
        "loadFailed": "Fehler beim Laden der Einstellungen",
        "saveSuccess": "E-Mail-Einstellungen erfolgreich gespeichert!",
        "saveFailed": "Fehler beim Speichern der Einstellungen",
        "connecting": "Verbinde mit SMTP-Server...",
        "connFailed": "Verbindung fehlgeschlagen!",
        "title": "SMTP-Konfiguration",
        "subtitle": "E-Mail-Server-Einstellungen",
        "outgoingTitle": "Postausgang (SMTP - Senden)",
        "incomingTitle": "Posteingang (IMAP - Überwachung)",
        "lblHost": "SMTP-Host",
        "lblPort": "SMTP-Port",
        "lblUser": "SMTP-Benutzername / E-Mail",
        "lblPass": "SMTP-Passwort",
        "lblSender": "System-Absender-E-Mail (Von)",
        "lblImapHost": "IMAP-Host",
        "lblImapPort": "IMAP-Port",
        "enableImap": "Posteingangsüberwachung aktivieren (RFQ-Radar)",
        "imapDesc": "Lieferantenangebote automatisch aus dem Posteingang abrufen und parsen.",
        "gmailNote": "Verwenden Sie für Gmail ein 'App-Passwort' von Google Security. Kontopasswörter funktionieren bei aktivierter 2FA nicht.",
        "btnTest": "TESTEN",
        "btnCancel": "ABBRECHEN",
        "btnSave": "KONFIGURATION SPEICHERN"
      },
      locationDetails: {
        "noBimModel": "Kein 3D-Modell mit diesem Standort verknüpft",
        "noBimLinked": "Dieser Standort ist nicht mit BIM verknüpft",
        "locMandatory": "Standort ist ein Pflichtfeld!",
        "saving": "Änderungen werden gespeichert...",
        "saveSuccess": "Standort erfolgreich gespeichert",
        "saveFailed": "Speichern fehlgeschlagen:",
        "deleteTitle": "Sind Sie sicher?",
        "deleteText": "Sie sind im Begriff, den Standort {{id}} zu löschen. Diese Aktion kann nicht rückgängig gemacht werden!",
        "btnYesDelete": "Ja, löschen!",
        "btnCancel": "Abbrechen",
        "deleting": "Standort wird gelöscht...",
        "deleteSuccess": "Standort erfolgreich gelöscht",
        "deleteFailed": "Löschen fehlgeschlagen!",
        "uploadingRevit": "Revit-Modell wird hochgeladen und übersetzt...",
        "revitSuccess": "Modell erfolgreich verknüpft!",
        "uploadFailed": "Hochladen fehlgeschlagen:",
        "loadingCtx": "STANDORTKONTEXT WIRD GELADEN...",
        "tooltipChangeStatus": "Status ändern",
        "tooltipStatusHistory": "Statusverlauf",
        "tooltipDelete": "Löschen",
        "btnSave": "SPEICHERN",
        "lblLocation": "Standort",
        "lblDescription": "Beschreibung",
        "btnRevitLinked": "Revit verknüpft",
        "tabLocation": "Standort",
        "tabAssets": "Anlagen",
        "tabSpecs": "Spezifikationen",
        "tabSafety": "Sicherheit",
        "tabMeters": "Zähler",
        "tab3D": "3D-Ansicht",
        "tabHistory": "Verlauf",
        "secIdentity": "Standortidentität",
        "lblStatus": "Status",
        "lblType": "Typ",
        "lblParentLoc": "Übergeordneter Standort",
        "lblSiteID": "Standort-ID",
        "secGeoInfo": "Geografische und Adressinformationen",
        "lblServiceAddr": "Serviceadresse",
        "lblBimSpaceId": "BIM-Raum-ID",
        "lblGisCoords": "GIS-Koordinaten",
        "secRefImage": "Referenzbild",
        "btnUploadPhoto": "Foto hochladen",
        "thAssetNum": "Anlagennr.",
        "thStatus": "Status",
        "lblClass": "Klassifizierung",
        "thAttr": "Attribut",
        "thDesc": "Beschreibung",
        "thValue": "Wert",
        "titleHazards": "Gemeldete Gefahren an diesem Standort",
        "btnAddHazard": "Gefahr hinzufügen",
        "lblSelectHazards": "Gefahren auswählen",
        "thHazard": "Gefahr",
        "thPrecaution": "Vorsichtsmaßnahme",
        "titleLocMeters": "Standortzähler",
        "showingMeters": "Zeige {{current}} von {{total}}",
        "noMetersDef": "Keine Zähler definiert",
        "thSeq": "Seq",
        "thMeterNum": "Zählernummer",
        "thType": "Typ",
        "thUOM": "ME",
        "thActive": "Aktiv",
        "newMeter": "NEUER_ZÄHLER",
        "clickNewRow": "Klicken Sie auf 'Neue Zeile', um einen Zähler hinzuzufügen",
        "titleMeterConfig": "Zählerdetailkonfiguration",
        "newEntry": "Neuer Eintrag",
        "lblMeterNum": "* Zählernummer",
        "lblMeterType": "Zählertyp",
        "lblUOM": "Maßeinheit",
        "lblMeterActive": "Zähler ist aktiv",
        "lblLastReading": "Letzter Zählerstand",
        "lblReadingDate": "Ablesedatum",
        "lblInspector": "Zählerprüfer",
        "lblRemarks": "Bemerkungen / Kommentare",
        "placeholderRemarks": "Geben Sie technische Hinweise zu diesem Zähler ein...",
        "btnAddMeterRow": "Neue Zählerzeile hinzufügen",
        "titleModelStatus": "Modellstatus",
        "statusLinked": "VERKNÜPFT & AKTIV",
        "statusNotLinked": "NICHT VERKNÜPFT",
        "btnUploadRevit": "Revit hochladen (.rvt)",
        "titleHistory": "Transaktionsverlauf & Audit-Protokoll",
        "lblChangedBy": "Geändert von:",
        "failedFetchAttr": "Fehler beim Abrufen der Attribute"
      },
      "locationList": {
        "loadFailed": "Standorte konnten nicht vom Teknoia-Server geladen werden.",
        "title": "Teknoia Standorte",
        "searchPlaceholder": "Globale Suche...",
        "btnClearAll": "Alles löschen",
        "btnExport": "Exportieren",
        "btnNewLocation": "Neuer Standort",
        "thLocationId": "Standort-ID",
        "thDescription": "Beschreibung",
        "thType": "Typ",
        "thStatus": "Status",
        "thSite": "Standort (Site)",
        "optAll": "ALLE",
        "optOperating": "IN BETRIEB",
        "optDecommissioned": "AUSSER BETRIEB",
        "fetchingData": "Daten werden vom Server abgerufen...",
        "noRecords": "Keine passenden Datensätze gefunden.",
        "recordsFound": "Gefundene Datensätze:",
        "page": "Seite:"
      },
      "universalLookup": {
        "selectValue": "Wert auswählen:",
        "total": "Gesamt",
        "searchPlaceholder": "Nach Code oder Beschreibung suchen...",
        "valueCode": "Wert / Code",
        "description": "Beschreibung",
        "site": "Standort (Site)",
        "synchronizing": "Synchronisieren...",
        "noRecords": "Keine passenden Datensätze gefunden.",
        "loadingMore": "Weitere Datensätze werden geladen...",
        "results": "Ergebnisse:",
        "cancel": "Abbrechen"
      },
      "statusHistory": {
        "title": "Status-Audit-Trail",
        "loading": "VERLAUF WIRD GELADEN...",
        "noRecords": "Für dieses Element wurden keine Statusänderungen aufgezeichnet.",
        "initial": "ANFÄNGLICH",
        "btnClose": "Schließen"
      },
      "personalInfo": {
        "updateSuccess": "Profil erfolgreich aktualisiert",
        "sessionExpired": "Sitzung abgelaufen, bitte erneut anmelden",
        "updateFailed": "Aktualisierung fehlgeschlagen",
        "title": "Persönliche Informationen & Standardwerte",
        "lblDisplayName": "Vollständiger Anzeigename",
        "lblEmail": "E-Mail-Adresse",
        "lblDefaultOrg": "Standardorganisation",
        "selectOrg": "Organisation auswählen...",
        "lblDefaultSite": "Standardstandort",
        "selectSite": "Standort auswählen...",
        "lblDefaultLang": "Standardsprache",
        "btnCancel": "Abbrechen",
        "btnSave": "Übernehmen & Speichern",
        "securityTitle": "Sicherheit & 2FA",
        "enable2FA": "Zwei-Faktor-Authentifizierung (2FA) aktivieren",
        "googleAuth": "Google Authenticator",
        "emailOTP": "E-Mail-OTP",
        "configure2FA": "2FA konfigurieren",
        "scanQR": "Scannen Sie diesen QR-Code mit dem Google Authenticator oder Authy und geben Sie unten den 6-stelligen Code zur Bestätigung ein.",
        "btnVerify": "Bestätigen",
        "setupSuccess": "2FA-Einrichtung erfolgreich!",
        "invalidCode": "Ungültiger Bestätigungscode",
        "failedQR": "QR-Code konnte nicht generiert werden"
      },
      "appSettings": {
        "savingSettings": "Einstellungen werden gespeichert...",
        "saveSuccess": "Einstellungen erfolgreich aktualisiert!",
        "saveFailed": "Fehler beim Speichern der Einstellungen.",
        "title": "Unternehmenskonfiguration",
        "org": "Organisation",
        "tabs": {
          "WORKORDER": "Arbeitsaufträge",
          "ASSET": "Anlagenregister",
          "INVENTORY": "Lager & Bestand",
          "PURCHASE": "Beschaffung",
          "PR": "BANF",
          "JP": "Arbeitsplan",
          "PM": "Vorbeugende Instandhaltung",
          "MR": "Materialanforderung",
          "SR": "Serviceanforderung"
        },
        "systemRules": "Systemregeln: {{tab}}",
        "prefix": "Sequenzpräfix",
        "preview": "Vorschau",
        "seed": "Startwert (Seed)",
        "valuationStrategy": "Bewertungsstrategie",
        "movingAvg": "Gleitender Durchschnitt (Empfohlen)",
        "fifo": "First-In, First-Out (FIFO)",
        "lifo": "Last-In, First-Out (LIFO)",
        "allowNegative": "Negativen Saldo zulassen",
        "negativeWarning": "Warnung: Beeinträchtigt die finanzielle Genauigkeit",
        "encrypting": "Verschlüsseln & Übertragen...",
        "auditLogged": "Alle Änderungen werden im Audit-Trail protokolliert",
        "btnCancel": "Abbrechen",
        "btnSave": "Systemrichtlinie speichern"
      },
      "workflowAction": {
        "successMove": "Workflow erfolgreich weitergeleitet! 🚀",
        "failedMove": "Aktion fehlgeschlagen",
        "btnRoute": "Workflow weiterleiten",
        "modalTitle": "WORKFLOW-AKTION",
        "assignedAs": "Ihnen zugewiesen als:",
        "defaultInstruction": "Bitte prüfen und handeln.",
        "lblChoosePath": "Pfad wählen",
        "valSelectPath": "Bitte wählen Sie einen Pfad",
        "optApprove": "GENEHMIGEN / WEITER",
        "optReject": "ABLEHNEN / ZURÜCK",
        "lblMemo": "Aktions-Memo / Kommentare",
        "placeholderMemo": "Fügen Sie hier Ihre Kommentare hinzu...",
        "btnCancel": "Abbrechen",
        "btnComplete": "SCHRITT ABSCHLIESSEN"
      },
      "meterHistory": {
        "title": "Historische Zählerstände",
        "lblAsset": "Anlage",
        "fetching": "Archive werden abgerufen...",
        "noRecords": "Keine historischen Zählerstände für diese Anlage gefunden.",
        "thMeterName": "Zählername",
        "thReadingVal": "Zählerstand",
        "thReadingDate": "Ablesedatum",
        "thEnteredBy": "Erfasst von",
        "thEntryDate": "Erfassungsdatum",
        "btnClose": "Verlauf schließen",
        "noRecordsLoc": "Keine historischen Zählerstände für diesen Standort gefunden.",
        "lblLocation": "Standort",
      },
      "rpt_print": "Berichte drucken",
      "no_templates": "Keine Vorlagen verfügbar",
      "wo": {
        "tabs": { "workOrder": "Arbeitsauftrag", "plans": "Pläne", "assignments": "Zuweisungen", "actuals": "Ist-Werte", "safety": "Sicherheit", "failure": "Fehlerbericht" },
        "subTabs": { "tasks": "Aufgaben", "labor": "Arbeit", "materials": "Materialien", "tools": "Werkzeuge", "services": "Dienstleistungen" },
        "headers": { "workOrder": "Arbeitsauftrag", "status": "Status", "totalCost": "Gesamtkosten", "activeSla": "AKTIVE SLA-ÜBERWACHUNG", "targetRes": "ZIEL-LÖSUNG", "targetResp": "ZIEL-ANTWORT", "trackingTitle": "Arbeitsauftragsverfolgung", "globalView": "Globale Org-Ansicht", "site": "Standort", "selected": "Ausgewählt" },
        "sections": { "assetDetails": "Anlagendetails", "scheduling": "Planungsinformationen", "responsibility": "Verantwortlichkeit", "laborAssign": "Arbeitszuweisungen", "totalAssign": "Gesamte Zuweisungen" },
        "fields": { "description": "Beschreibung", "location": "Standort", "asset": "Anlage", "workType": "Arbeitstyp", "safetyCode": "Sicherheitscode", "supervisor": "Vorgesetzter", "failureClass": "Fehlerklasse", "targStart": "Ziel-Start", "targFinish": "Ziel-Ende", "schedStart": "Geplanter Start", "schedFinish": "Geplantes Ende", "earlyStart": "Frühester Start", "lateFinish": "Spätestes Ende", "actStart": "Tatsächlicher Start", "actFinish": "Tatsächliches Ende", "duration": "Dauer", "timeRemaining": "Verbleibende Zeit", "predecessors": "Vorgänger", "includeTasks": "Aufgaben in Zeitplan aufnehmen?", "site": "Standort", "organization": "Organisation", "priorityHigh": "Priorität: Hoch" },
        "actions": { "routeWorkflow": "Workflow weiterleiten", "wfHistory": "Workflow-Verlauf", "changeStatus": "Status ändern", "attachments": "Anhänge", "printWO": "Auftrag drucken", "printSafety": "Sicherheitsblatt", "history": "Verlauf", "newTask": "Neue Aufgabe", "selectLoc": "Standort wählen", "selectAsset": "Anlage wählen", "selectType": "Typ wählen", "selectSafety": "Sicherheitsplan wählen", "selectSup": "Vorgesetzten wählen", "selectFail": "Fehlerklasse wählen", "selectCraft": "Gewerk wählen", "selectLabor": "Arbeitskraft wählen", "selectItem": "Artikel wählen", "selectStore": "Lager wählen", "selectTool": "Werkzeug wählen", "addLabor": "Arbeit hinzufügen", "addMaterial": "Material hinzufügen", "addTool": "Werkzeug hinzufügen", "addService": "Dienstleistung hinzufügen", "newAssign": "Neue Zuweisung", "compAssign": "Zuweisung abschließen", "createMR": "Materialanforderung erstellen", "yesCreate": "Ja, erstellen", "yesChange": "Ja, ändern", "approve": "Genehmigen", "cancel": "Abbrechen", "startWork": "Starten", "close": "Schließen", "complete": "Abschließen", "selectProblem": "Problem wählen", "selectCause": "Ursache wählen", "selectRemedy": "Lösung wählen" },
        "tables": { "sequence": "Seq", "taskDesc": "Aufgabenbeschreibung", "estDur": "Geschätzte Dauer", "status": "Status", "craft": "Gewerk", "labor": "Arbeitskraft", "qty": "Menge", "hrs": "Std.", "rate": "Satz", "lineCost": "Zeilenkosten", "lineType": "Zeilentyp", "itemNum": "Artikel-Nr.", "description": "Beschreibung", "unitCost": "Stückkosten", "storeroom": "Lagerraum", "item": "Artikel", "material": "Material", "toolNum": "Werkzeug-Nr.", "serviceDesc": "Dienstleistungsbeschreibung", "vendor": "Lieferant", "cost": "Kosten", "start": "Start", "finish": "Ende", "failCode": "Fehlercode" },
        "footer": { "totalLabor": "Gesamtarbeit", "totalMaterial": "Gesamtmaterial", "assigned": "Zugewiesen (Geschätzt)", "toolsServ": "Werkzeuge & Dienstl.", "totalActual": "Tatsächliche Gesamtkosten" },
        "safety": { "hazardsTitle": "Gefahren und Vorsichtsmaßnahmen", "hazardCode": "Gefahrencode", "hazardDesc": "Gefahrenbeschreibung", "precautions": "Erforderliche Vorsichtsmaßnahmen", "noHazards": "Keine Gefahren identifiziert.", "lotoTitle": "Lock Out / Tag Out (Isolationsschritte)", "step": "Schritt", "tagNum": "Tag-Nr.", "isoDesc": "Isolationsbeschreibung", "reqState": "Erforderlicher Status", "completed": "Abgeschlossen?", "noLoto": "Keine Isolationsschritte erforderlich." },
        "failure": { "title": "Fehleranalyse", "currClass": "Aktuelle Fehlerklasse", "notDefined": "NICHT DEFINIERT", "problems": "PROBLEME", "causes": "URSACHEN", "remedies": "LÖSUNGEN", "records": "DATENSÄTZE" },
        "placeholders": { "desc": "Beschreibung eingeben...", "taskDesc": "AUFGABENBESCHREIBUNG..." },
        "messages": { "loadError": "Fehler beim Laden", "taskStatusLocal": "Aufgabenstatus lokal aktualisiert", "selectItemStore": "Bitte Artikel und Lager wählen", "duplicateReqTitle": "Duplizierte Anfrage", "duplicateReqText": "Anfrage für {{item}} existiert. Noch eine erstellen?", "creatingMR": "Anforderung wird erstellt...", "mrCreated": "Anforderung {{num}} erstellt", "mrFail": "Erstellung fehlgeschlagen", "confirmStatusChange": "Status von {{wonum}} in {{status}} ändern?", "statusSuccess": "Status geändert", "statusFail": "Fehler beim Ändern", "saving": "Wird gespeichert...", "deleteConfirm": "{{wonum}} löschen? Aktion kann nicht rückgängig gemacht werden!", "saveBeforeSLA": "Bitte Auftrag zuerst speichern", "slaExists": "SLA bereits angewendet!", "matchingSLA": "Suche nach SLA...", "slaApplied": "SLA erfolgreich angewendet", "noMatchingSLA": "Kein passendes SLA gefunden", "slaError": "Fehler bei SLA-Engine", "failureTreeLoaded": "Standard-Fehlercodes angewendet", "zeroBalance": "Warnung: Bestand null für Artikel in {{store}}", "balanceOk": "Preis abgerufen: {{cost}} - Bestand: {{bal}}", "storeError": "Fehler bei Verbindung mit Lager", "assetLinked": "Anlage verknüpft: {{asset}}", "openAssignError": "Kann nicht geschlossen werden: {{count}} Zuweisungen unvollständig.", "budgetExceeded": "Budget überschritten!", "assignComplete": "Zuweisung abgeschlossen", "actionNotAllowed": "Aktion für Status {{status}} nicht zulässig", "locked": "Gesperrt", "cantChangeCancel": "Stornierte Anfragen können den Status nicht ändern", "printFail": "Fehler beim Erstellen der PDF-Datei", "wfRouted": "Workflow erfolgreich weitergeleitet! 🚀", "wfFail": "Fehler bei Workflow-Weiterleitung", "taskStatusChanged": "Aufgabe {{task}} auf {{status}} geändert", "noLaborAssign": "Noch keine Arbeitskräfte zugewiesen.", "updateTaskProg": "Fortschritt der Aufgaben aktualisieren", "noMaterials": "Keine Materialien. Klicken Sie zum Hinzufügen.", "linkedMRs": "Verknüpfte Materialanforderungen",  "stocknobalance": "⚠️ Warnung: Dieser Artikel hat einen Lagerbestand von Null."},
        "linearDefect": {
          "title": "Position des linearen Defekts",
          "startMeasure": "Startmaß",
          "endMeasure": "Endmaß (Optional)",
          "unit": "Einheit",
          "yOffset": "Y-Versatz (m)"
        },
        "costs": {
          "title": "Arbeitsauftragskosten",
          "estimated": "Geschätzte Kosten",
          "actual": "Tatsächliche Kosten",
          "labor": "Arbeit",
          "materials": "Materialien",
          "tools": "Werkzeuge",
          "services": "Dienstleistungen",
          "total": "Gesamt",
          "variance": "Abweichung (Tatsächlich - Geschätzt)",
          "calculating": "Berechnung...",
          "no_data": "Keine Daten verfügbar."
        },
        "purchase_info": {
          "title": "Zugehörige Kaufinformationen",
          "mr_title": "Materialanforderungen (MR)",
          "pr_title": "Bestellanforderungen (PR)",
          "po_title": "Bestellungen (PO)",
          "mr_num": "MR-Nr",
          "pr_num": "PR-Nr",
          "po_num": "PO-Nr",
          "vendor": "Lieferant",
          "status": "Status",
          "req_date": "Erforderliches Datum",
          "total_cost": "Gesamtkosten",
          "fetching": "Daten werden abgerufen...",
          "no_records": "Keine Datensätze gefunden."
        },
    
      },
      "pm": {
        "tabs": { "pm": "PM", "frequency": "Häufigkeit", "sequence": "Sequenz", "seasonaldates": "Saisonale Daten", "forecast": "Prognose" },
        "sections": { "assetLoc": "Anlage & Standort", "defaults": "Standardwerte", "compliance": "Konformität", "siteContext": "Standortinfo", "timeBased": "Zeitbasiertes Intervall", "meters": "Zähler", "sequences": "Arbeitsplan-Sequenzen", "seasonal": "Wochenplan", "projections": "Prognoseprotokolle" },
        "fields": { "pmNum": "PM Nummer", "description": "Beschreibung", "status": "Status", "site": "Standort", "asset": "Anlage", "location": "Ort", "route": "Route", "counter": "Zähler", "jpnum": "Arbeitsplan", "worktype": "Arbeitstyp", "supervisor": "Vorgesetzter", "glaccount": "Konto", "woStatus": "Standardstatus", "priority": "Priorität", "lastStart": "Letzter Start", "lastComp": "Letztes Ende", "nextDue": "Nächste Fälligkeit", "forecastFlag": "Prognose-Flag", "org": "Organisation", "freqInt": "Intervall", "freqUnit": "Einheit", "targStart": "Zielzeit" },
        "actions": { "forecast": "PROGNOSE", "savePM": "SPEICHERN", "addMeter": "ZÄHLER HINZUFÜGEN", "addStep": "SCHRITT HINZUFÜGEN", "newPM": "Neuer PM-Datensatz"},
        "tables": { "meterName": "Zählername", "freq": "Häufig.", "nextProj": "Nächste Progn.", "seq": "Sequenz", "jpnum": "Arbeitsplan", "fcDate": "Datum", "targetJp": "Zielplan", "estCost": "Geschätzte Kosten", "status": "Status", "woNum": "Auftrags-Nr.", "generated": "GENERIERT", "projected": "GEPLANT" },
        "messages": { "executingForecast": "Wird berechnet...", "forecastSuccess": "Erfolg", "forecastFail": "Fehler", "seasonalInfo": "Markierte Tage = erlaubt.", "noMeters": "Keine Zähler.", "noSeq": "Sequenz deaktiviert.", "noForecasts": "Keine Prognosen.", "showingProjections": "Zeige {{count}} Ergebnisse", "fetchListError": "Laden der PM-Datensätze fehlgeschlagen", "syncingList": "Synchronisieren mit Server...", "noRecords": "Keine Datensätze gefunden." },
        "placeholders": { "desc": "Beschreibung eingeben...", "globalSearch": "Globale smarte Suche..." },
        "headers": { "masterDir": "PM-Stammverzeichnis" },
        "footer": { "dbTotal": "Gesamt in Datenbank:", "currentPage": "Aktuelle Seite:", "useNavArrows": "Navigationspfeile nutzen" },
      },
      "workflowHistory": {
        "title": "Workflow-Protokoll",
        "trackingId": "Tracking-ID:",
        "fetching": "Datensätze werden abgerufen...",
        "currentTask": "Aktuelle aktive Aufgabe",
        "since": "Seit:",
        "by": "von",
        "noHistory": "Noch kein Verlauf für diese Transaktion aufgezeichnet",
        "closeBtn": "Verlauf schließen"
      },
      "pr": {
        "headers": { "prList": "Kaufanfragen" },
        "actions": { "newPR": "NEUE ANFRAGE", "clearFilters": "FILTER LÖSCHEN", "routeWf": "WORKFLOW WEITERLEITEN" },
        "tabs": { "pr": "Kaufanfrage", "prlines": "Anfragezeilen" },
        "sections": { "general": "Allgemeine Informationen", "financial": "Finanzielle Zusammenfassung" },
        "fields": { "prNum": "Anfrage-Nr.", "requestedBy": "Angefordert von", "reqDate": "Bedarfsdatum", "refMr": "Referenz-Materialanfrage", "vendor": "Lieferant", "glAccount": "Sachkonto" },
        "financial": { "subtotal": "Zwischensumme", "taxTotal": "Steuersumme", "grandTotal": "Gesamtsumme" },
        "tables": { "prNum": "Anfrage-Nr.", "description": "Beschreibung", "status": "Status", "totalCost": "Gesamtkosten", "reqDate": "Anfragedatum", "site": "Standort", "itemNum": "Artikel-Nr.", "itemType": "Typ", "qty": "Menge", "unitCost": "Stückpreis", "tax": "Steuer", "lineTotal": "Zeilensumme", "taxCat": "Steuerkat." },
        "messages": { "loadFailed": "Kaufanfragen konnten nicht geladen werden", "syncing": "Synchronisieren...", "noData": "Keine Daten gefunden", "noLines": "Noch keine Zeilen hinzugefügt.", "fetchingMRLines": "Lade Zeilen für Materialanfrage: {{mrnum}}...", "loadedMRLines": "{{count}} Zeilen geladen", "noMRLines": "Diese Materialanfrage hat keine Zeilen", "failedMRLines": "Fehler beim Laden der Zeilen" },
        "swal": { "lockedTitle": "Gesperrt", "cantDeleteStatus": "Löschen mit Status {{status}} nicht möglich", "cantChangeCancel": "Stornierte Anfragen können den Status nicht ändern", "deleteWarnText": "Dadurch wird die Kaufanfrage und alle Zeilen dauerhaft gelöscht." },
        "placeholders": { "desc": "Beschreibung eingeben...", "globalSearch": "Globale smarte Suche..." },
        "footer": { "showing": "Zeige", "totalRecords": "Gesamtdatensätze" }
      },
      "po": {
        "headers": { "poList": "Bestellungen" },
        "actions": { "newPO": "NEUE BESTELLUNG", "clearFilters": "FILTER LÖSCHEN", "routeWf": "WORKFLOW WEITERLEITEN", "addManualRow": "MANUELLE ZEILE", "wfHistory": "Workflow-Zeitleiste" },
        "tabs": { "po": "Bestellung", "polines": "Bestellzeilen" },
        "sections": { "general": "Allgemeine Informationen", "financial": "Finanzielle Zusammenfassung", "lines": "Bestellpositionen" },
        "fields": { "poNum": "Bestell-Nr.", "requestedBy": "Angefordert von", "orderDate": "Bestelldatum", "refPr": "Referenz-BANF", "vendor": "Lieferant", "glAccount": "Sachkonto" },
        "financial": { "subtotal": "Zwischensumme", "taxTotal": "Steuerbetrag", "grandTotal": "Gesamtsumme" },
        "tables": { "poNum": "Bestell-Nr.", "totalCost": "Gesamtkosten", "orderDate": "Bestelldatum", "itemNum": "Artikel-Nr.", "itemType": "Typ", "unitCost": "Stückpreis", "tax": "Steuer", "lineTotal": "Zeilensumme", "taxCat": "Steuerkat." },
        "messages": { "loadFailed": "Bestellungen konnten nicht geladen werden", "syncing": "Synchronisieren...", "noData": "Keine passenden Bestellungen gefunden", "noLines": "Noch keine Zeilen hinzugefügt.", "vendorRequired": "Lieferant ist zwingend erforderlich.", "fetchingLines": "Lade Zeilen für: {{num}}...", "loadedLines": "{{count}} Zeilen geladen", "noLinesFound": "Dieses Dokument hat keine Zeilen", "failedLines": "Fehler beim Laden der Zeilen", "cantChangeCancel": "Stornierte Anfragen können den Status nicht ändern", "cantDeleteStatus": "Löschen mit Status {{status}} nicht möglich" },
        "swal": { "deleteWarnText": "Dadurch wird die Bestellung und alle Zeilen dauerhaft gelöscht." },
        "placeholders": { "desc": "Beschreibung eingeben...", "globalSearch": "Globale smarte Suche..." },
        "footer": { "showing": "Zeige" }
      },
      "mr": {
        "headers": { "mrList": "Materialanforderungen" },
        "actions": { "newMR": "NEUE ANFORDERUNG", "clearFilters": "FILTER LÖSCHEN", "routeWf": "WORKFLOW WEITERLEITEN" },
        "tabs": { "mr": "MA-Info", "mrlines": "Anforderungszeilen" },
        "sections": { "general": "Allgemeine Informationen", "financial": "Finanzielle Zusammenfassung", "createUsage": "VERBRAUCH ERSTELLEN", "createUsageDesc": "Ausgabe-/Umlagerungsdatensatz erstellen", "createPR": "KAUFANFRAGE ERSTELLEN", "createPRDesc": "Kaufanfrage erstellen", "addMaterial": "Material hinzufügen", "mrItems": "Materialanforderungspositionen", "financialCharging": "Finanzielle Belastungsdetails" },
        "fields": { "mrNum": "MA-Nr.", "requestedBy": "Angefordert von", "reqDate": "Bedarfsdatum", "refMr": "Referenz-MA", "vendor": "Lieferant", "glAccount": "Sachkonto", "targetStore": "Ziellager", "chargeLoc": "Belasteter Standort", "chargeAsset": "Belastete Anlage", "chargeWO": "Belasteter AA" },
        "financial": { "subtotal": "Zwischensumme", "taxTotal": "Steuersumme", "grandTotal": "Gesamtsumme" },
        "tables": { "mrNum": "MA-Nr.", "description": "Beschreibung", "status": "Status", "totalCost": "Gesamtkosten", "enteredDate": "Erfassungsdatum", "site": "Standort", "itemNum": "Artikel-Nr.", "itemType": "Typ", "qty": "Menge", "unitCost": "Stückpreis", "tax": "Steuer", "lineTotal": "Zeilensumme", "taxCat": "Steuerkat.", "stockItem": "Lagerartikel", "qtyReq": "Angeford. Menge", "estUnitCost": "Geschätzte Stückkosten" },
        "messages": { "loadFailed": "Anforderungen konnten nicht geladen werden", "syncing": "Synchronisieren...", "noData": "Keine Daten gefunden", "noLines": "Noch keine Zeilen hinzugefügt.", "fetchingMRLines": "Lade Zeilen: {{mrnum}}...", "loadedMRLines": "{{count}} Zeilen geladen", "noMRLines": "Diese MA hat keine Zeilen", "failedMRLines": "Fehler beim Laden der Zeilen", "generating": "Erstelle {{docType}}...", "generatedSuccess": "{{docType}} {{docnum}} erfolgreich erstellt!", "generateFail": "Erstellen von {{docType}} fehlgeschlagen", "storeRequired": "Lager ist erforderlich!", "dateRequired": "Bedarfsdatum ist erforderlich!" },
        "swal": { "lockedTitle": "Gesperrt", "cantDeleteStatus": "Löschen mit Status {{status}} nicht möglich", "cantChangeCancel": "Stornierte Anforderungen können den Status nicht ändern", "deleteWarnText": "Dadurch wird die Anforderung und alle Zeilen dauerhaft gelöscht." },
        "placeholders": { "desc": "Beschreibung eingeben...", "globalSearch": "Globale Suche...", "chooseLoc": "STANDORT WÄHLEN", "selectAsset": "ANLAGE WÄHLEN", "chargeWO": "AUF AA BELASTEN" },
        "lookups": { "storerooms": "Lagerräume", "inventory": "Lagerbestandssuche", "locations": "Standorte", "assets": "Anlagenregister", "workorders": "Arbeitsaufträge" },
        "footer": { "showing": "Zeige", "totalRecords": "Gesamt" }
      },
      "contract": {
        "headers": { "masterNode": "Vertrags-Masterknoten" },
        "placeholders": { "globalSearch": "Globale Suche...", "desc": "Zusammenfassung eingeben...", "termDesc": "Klauseldetails schreiben..." },
        "actions": { "newContract": "NEUER VERTRAG", "save": "SPEICHERN", "addTerm": "KLAUSEL HINZUFÜGEN", "addLine": "ZEILE HINZUFÜGEN", "wfHistory": "Workflow-Zeitleiste" },
        "tabs": { "general": "Allgemein", "slaperformance": "SLA (Leistung)", "termslegal": "Bedingungen & Recht", "contractlines": "Vertragszeilen" },
        "sections": { "identity": "Identität & Gültigkeit", "communication": "Kommunikation", "auditInfo": "Audit-Info", "masterSLA": "SLA-Verknüpfung", "slaBenchmarks": "SLA-Kennzahlen", "termsList": "Rechtsklauseln", "lines": "Umfang / Zeilen" },
        "options": { "supply": "Liefervertrag", "labor": "Arbeits-/Dienstvertrag", "lease": "Mietvertrag", "allTypes": "ALLE TYPEN", "allStatus": "ALLE STATUS", "general": "ALLGEMEIN", "payment": "ZAHLUNG", "termination": "KÜNDIGUNG", "warranty": "GARANTIE", "liability": "HAFTUNG" },
        "fields": { "contractNum": "Vertrags-Nr.", "vendorRef": "Lieferant", "startDate": "Startdatum", "endDate": "Enddatum", "contractValue": "Vertragswert", "currency": "Währung", "contactPerson": "Kontaktperson", "vendorEmail": "Lieferanten-E-Mail", "slaRef": "SLA-Referenz", "respTime": "Reaktionszeit (Std)", "resTime": "Lösungszeit (Std)", "uptime": "Verfügbarkeit (%)", "penalty": "Strafe (pro Std)", "grandTotal": "Berechnete Gesamtsumme" },
        "tables": { "contractNum": "Vertrags-Nr.", "grandTotal": "Gesamtsumme", "clauseType": "Klausel-Kategorie", "clauseDesc": "Klausel-Details", "lineDesc": "Zeilenbeschreibung", "rate": "Rate", "lineTotal": "Zeilensumme" },
        "messages": { "fetchError": "Synchronisierung fehlgeschlagen", "syncing": "Synchronisieren...", "noData": "Keine Verträge gefunden", "descMandatory": "Beschreibung ist obligatorisch", "vendorSelected": "Lieferant {{name}} ausgewählt", "noTerms": "Keine Rechtsklauseln definiert", "noLines": "Keine Zeilen definiert", "slaHint": "Durch die Verknüpfung einer SLA werden die Regeln global angewendet." },
        "swal": { "deleteTitle": "Endgültige Löschung?", "deleteText": "Dadurch wird der Vertrag und alle zugehörigen Daten dauerhaft gelöscht." },
        "footer": { "masterRecords": "Stammdatensätze:", "currentPage": "Aktuelle Seite:" }
      },
      "rfq": {
        "headers": { "rfqList": "Angebotsanfragen" },
        "tabs": { "rfq": "Anfrage", "rfqlines": "Zeilen", "quotations": "Angebote" },
        "sections": { "general": "Allgemein", "financial": "Finanzen" },
        "fields": { "requestedBy": "Angefordert von", "reqDate": "Bedarfsdatum", "refPr": "Referenz-BANF", "vendor": "Lieferant", "vendorEmail": "E-Mail", "glAccount": "Sachkonto" },
        "financial": { "subtotal": "Zwischensumme", "taxTotal": "Steuern", "grandTotal": "Gesamtsumme" },
        "tables": { "rfqNum": "Anfrage-Nr.", "totalCost": "Gesamtkosten", "itemNum": "Artikel-Nr.", "itemType": "Typ", "unitCost": "Stückpreis", "tax": "Steuer", "taxCat": "Steuerkat." },
        "options": { "awarded": "VERGEBEN" },
        "actions": { "newRFQ": "NEUE ANFRAGE", "sendEmail": "E-MAIL SENDEN", "wfHistory": "WF-Historie", "award": "VERGEBEN & BESTELLUNG ERSTELLEN" },
        "messages": { "loadFailed": "Ladefehler", "syncing": "Synchronisieren...", "noData": "Keine Daten", "noLines": "Keine Zeilen", "pullingPR": "Lade BANF...", "prImported": "Zeilen importiert!", "prFailed": "Import fehlgeschlagen", "noEmail": "E-Mail fehlt!", "sending": "PDF wird erstellt & gesendet...", "sendSuccess": "E-Mail gesendet!", "sendFailed": "Senden fehlgeschlagen", "quotesHint": "Eingehende Angebote erscheinen hier automatisch.", "noQuotes": "Noch keine Angebote erhalten.", "awarding": "Vergabe läuft...", "awardSuccess": "Angebot vergeben!", "poCreated": "Bestellung erstellt", "awardFailed": "Vergabe fehlgeschlagen" },
        "swal": { "sendTitle": "Anfrage senden?", "sendText": "An {{vendor}} senden?", "awardTitle": "Angebot vergeben?", "awardText": "Dadurch wird automatisch eine Bestellung generiert." },
        "footer": { "showing": "Zeige" }
      },
      "itemList": {
        "headers": { "master": "Artikelstamm" },
        "actions": { "newItem": "Neuer Artikel" },
        "tables": { "item": "Artikel", "rotating": "Rotierend?" },
        "messages": { "syncFailed": "Synchronisierung fehlgeschlagen", "syncing": "Synchronisieren...", "noData": "Keine Artikel gefunden" },
        "footer": { "totalItems": "Gesamte Artikel:", "page": "SEITE" }
      },
      "itemDetails": {
        "tabs": { "item": "ARTIKEL", "inventory": "BESTAND", "vendors": "LIEFERANTEN", "specs": "SPEZ", "assembly": "BAUGRUPPE" },
        "sections": { "config": "Artikelkonfiguration", "units": "Einheiten & Tracking", "bomList": "Stückliste (BOM)", "supplierHistory": "Lieferantenhistorie" },
        "actions": { "save": "SPEICHERN", "addStore": "ZUM LAGER", "newSpec": "NEUE SPEZ", "addComponent": "KOMPONENTE" },
        "fields": { "itemSet": "Artikelsatz", "rotating": "Rotierend?", "lotControl": "Chargenkontrolle?", "inspectionReq": "Prüfung?", "orderUnit": "Bestelleinheit", "issueUnit": "Ausgabeeinheit", "condition": "Zustand?", "sparepart": "Ersatzteil?", "classification": "Klassifizierung" },
        "tables": { "store": "Lager", "avgCost": "Ø-Kosten", "balance": "Bestand", "attribute": "Attribut", "value": "Wert", "uom": "ME", "subItem": "Unterartikel", "remarks": "Bemerkungen", "vendor": "Lieferanten-Nr.", "supplierName": "Lieferantenname", "unitCost": "Stückkosten", "refPO": "Referenz-Bestellung", "activeVendors": "AKTIVE LIEFERANTEN" },
        "messages": { "reqFields": "Nummer & Beschreibung erforderlich!", "fetchingAttributes": "Lade Attribute...", "attributesLoaded": "Attribute geladen", "failedAttributes": "Laden fehlgeschlagen", "stockMsgTitle": "LAGERHINWEIS", "stockMsgDesc": "Änderung der Einheiten wirkt sich auf alle Lager aus.", "noInventory": "Kein Bestand.", "noSpecs": "Keine Spezifikationen.", "noBom": "Keine Stückliste (BOM).", "noVendors": "Keine Lieferanten." },
        "swal": { "deleteText": "Artikel {{num}} wird dauerhaft gelöscht!" }
      },
      "changePassword": {
        "title": "Passwort ändern",
        "currentPwd": "Aktuelles Passwort",
        "newPwd": "Neues Passwort",
        "confirmPwd": "Neues Passwort bestätigen",
        "securityTitle": "Sicherheitsüberprüfung",
        "googleAuthMsg": "Geben Sie den 6-stelligen Code aus dem Google Authenticator ein, um diese Änderung zu bestätigen.",
        "emailOtpMsg": "Ein OTP-Code wurde an Ihre E-Mail gesendet.",
        "btnCancel": "Abbrechen",
        "btnUpdate": "Passwort aktualisieren",
        "btnVerify": "Überprüfen & Ändern",
        "btnBack": "Zurück",
        "errMismatch": "Die neuen Passwörter stimmen nicht überein!",
        "errLength": "Das Passwort muss mindestens 6 Zeichen lang sein.",
        "msgVerifyReq": "Bitte bestätigen Sie Ihre Identität, um fortzufahren.",
        "msgSuccess": "Passwort erfolgreich geändert!",
        "errFailed": "Fehler beim Ändern des Passworts."
      },
      "userDetails": {
        "titleNew": "NEUER BENUTZER",
        "titleEdit": "SICHERHEIT / BENUTZER",
        "btnSave": "BENUTZER SPEICHERN",
        "saving": "SPEICHERN...",
        "secIdent": "Benutzeridentifikation",
        "lblLoginId": "Anmelde-ID",
        "lblFullName": "Vollständiger Name",
        "lblDisplayName": "Anzeigename",
        "lblEmail": "E-Mail-Adresse",
        "lblPassword": "Passwort",
        "lblActive": "Aktiver Status",
        "secAccess": "Sicherheit & Zugriffskontrolle",
        "lblPrimaryRole": "Hauptsicherheitsrolle",
        "lblSecRoles": "Sekundäre Rollen (Zusätzlich)",
        "lblDefOrg": "Standardorganisation",
        "lblDefSite": "Standardstandort",
        "secDelegation": "Arbeitsdelegation",
        "lblDelegateTo": "Arbeit delegieren an",
        "lblStartDate": "Startdatum & Uhrzeit",
        "lblEndDate": "Enddatum & Uhrzeit"
      },
      "receivingDetails": {
        "errLoadLines": "Bestellzeilen konnten nicht geladen werden",
        "errMissingDist": "Bitte geben Sie für alle Zeilen das Lager und die Menge an",
        "errInspMandatory": "Prüfentscheidung ist ZWINGEND ERFORDERLICH für diesen Artikel",
        "errRejectExceeds": "Abgelehnte Mengen prüfen (darf angekommene Menge nicht überschreiten)",
        "msgSuccess": "Transaktion erfolgreich verarbeitet!",
        "msgAutoClosed": "Automatisch geschlossen: ",
        "swalAssignTitle": "Lagerzuordnung",
        "swalAssignText": "Artikel {{item}} ist derzeit nicht dem Lager {{loc}} zugeordnet. Jetzt zuordnen und Wareneingang abschließen?",
        "swalAssignBtn": "Ja, Zuordnen & Abschließen",
        "errUnexpected": "Unerwarteter Fehler beim Wareneingang",
        "hubTitle": "Masseneingangs-Hub",
        "poRef": "BESTELLREFERENZ: ",
        "btnExecuting": "WIRD AUSGEFÜHRT...",
        "btnConfirm": "WARENEINGANG BESTÄTIGEN",
        "tblItemsPending": "Ausstehende Artikel",
        "colItemDetails": "Artikeldetails",
        "colBalance": "Saldo",
        "lblQualityCheck": "QUALITÄTSPRÜFUNG ERFORDERLICH",
        "lblUnits": "Einheiten",
        "msgNoPending": "Keine ausstehenden Artikel gefunden",
        "lblLandedCost": "Einstandskosten (Zusatzkosten gesamt)",
        "lblBaseCost": "Basis-Stückkosten Bestellung",
        "lblStoreMatrix": "Lager-Verteilungsmatrix",
        "btnSplitStore": "Lager Aufteilen",
        "colStoreroom": "Lager",
        "colArrived": "Angekommen",
        "colRejected": "Abgelehnt",
        "plcClickSearch": "Klicken zum Suchen ->",
        "lookupSelectStore": "Lager auswählen",
        "lblQcMatrix": "Qualitätskontrolle Entscheidungsmatrix",
        "optSelectDecision": "-- Erforderlich: Entscheidung auswählen --",
        "optPassed": "VOLLSTÄNDIG BESTANDEN (ALLES AKZEPTIEREN)",
        "optFailed": "VOLLSTÄNDIG ABGELEHNT (ZURÜCK AN LIEFERANT)",
        "optPartial": "TEILWEISE AKZEPTIERT (SIEHE FELD ABGELEHNT)",
        "lblInvValuation": "Bestandsbewertung (Durchschn. Stückkosten)",
        "lblNetArrived": "Netto-Bestandseingang",
        "msgSelectLine": "Wählen Sie eine aktive Bestellzeile aus, um mit der Verarbeitung zu beginnen"
      },
      "userList": {
        "title": "BENUTZERSICHERHEIT",
        "plcSearch": "Benutzer oder E-Mail suchen...",
        "btnNewUser": "NEUER BENUTZER",
        "colUserId": "BENUTZER-ID",
        "colFullName": "VOLLSTÄNDIGER NAME",
        "colRole": "ROLLE",
        "colSite": "STANDORT",
        "colStatus": "STATUS",
        "colEmail": "E-MAIL",
        "msgSyncing": "Sicherheit wird synchronisiert...",
        "lblNoRole": "KEINE ROLLE",
        "lblAll": "ALLE",
        "lblTotalUsers": "GESAMT BENUTZER:",
        "lblPage": "SEITE",
        "errLoadUsers": "Fehler beim Laden der Benutzer"
      },
      "crafts": {
        "headers": {
          "craftList": "Gewerke-Katalog"
        },
        "actions": {
          "newCraft": "Neues Gewerk"
        },
        "tables": {
          "craftCode": "Gewerk-Code",
          "description": "Beschreibung",
          "stdRate": "Std-Satz/Stunde",
          "site": "Standort",
          "org": "Organisation"
        },
        "messages": {
          "loadFailed": "Fehler beim Laden der Gewerke"
        },
        "headers": {
          "craftList": "Gewerke-Katalog"
        },
        "tabs": {
          "skills": "Gewerksfähigkeiten & Niveaus"
        },
        "sections": {
          "costing": "Kalkulation",
          "control": "Kontrolle"
        },
        "actions": {
          "newCraft": "Neues Gewerk",
          "addSkill": "Qualifikationsniveau hinzufügen"
        },
        "tables": {
          "craftCode": "Gewerk-Code",
          "description": "Beschreibung",
          "stdRate": "Std-Satz/Stunde",
          "site": "Standort",
          "org": "Organisation"
        },
        "fields": {
          "stdHourlyRate": "Standard-Stundensatz",
          "skillLevel": "Qualifikationsniveau (z. B. Experte, Junior)",
          "hourlyRate": "Stundensatz"
        },
        "placeholders": {
          "enterLevel": "NIVEAU EINGEBEN..."
        },
        "messages": {
          "loadFailed": "Fehler beim Laden der Gewerke",
          "autoCalc": "Wird automatisch aus der Summe der Fähigkeiten berechnet",
          "noSkills": "Noch keine Fähigkeiten definiert"
        }
      },
      "persons": {
        "headers": {
          "directory": "Personenverzeichnis"
        },
        "actions": {
          "newPerson": "Neue Person"
        },
        "tables": {
          "personId": "Personen-ID",
          "name": "Anzeigename",
          "site": "Standort",
          "email": "E-Mail",
          "phone": "Telefon"
        },
        "messages": {
          "loadFailed": "Fehler beim Laden der Personenliste"
        },
        "headers": {
          "directory": "Personenverzeichnis"
        },
        "tabs": {
          "profile": "Profilinfo",
          "contact": "Kontaktverzeichnis",
          "access": "Systemzugriff"
        },
        "sections": {
          "personalInfo": "Persönliche Informationen",
          "statusControl": "Status & Kontrolle",
          "contactsDirectory": "Verbundene Kontakte"
        },
        "tables": {
          "personId": "Personen-ID",
          "name": "Anzeigename",
          "site": "Standort",
          "email": "E-Mail",
          "phone": "Telefon"
        },
        "fields": {
          "location": "Standort",
          "firstName": "Vorname",
          "lastName": "Nachname",
          "title": "Berufsbezeichnung",
          "department": "Abteilung",
          "currentStatus": "Aktueller Status",
          "contactName": "Kontaktname",
          "position": "Position",
          "email": "E-Mail-Adresse",
          "phone": "Telefon",
          "mobile": "Mobil",
          "primary": "Primär",
          "address": "Adresse",
          "city": "Stadt",
          "country": "Land",
        },
        "actions": {
          "newPerson": "Neue Person",
          "addContact": "Kontakt hinzufügen"
        },
        "messages": {
          "loadFailed": "Fehler beim Laden der Personenliste",
          "noContacts": "Noch keine Kontakte hinzugefügt",
          "accessControlled": "Der Systemzugriff wird über das Benutzersicherheitsmodul gesteuert"
        }
      },
      "jp": {
        "list": {
          "title": "Arbeitsplan-Verzeichnis",
          "new_plan": "NEUER PLAN",
          "filter_jp": "Pläne filtern...",
          "search_desc": "Beschreibung suchen...",
          "filter_site": "Standort...",
          "no_records": "Keine Arbeitspläne gefunden",
          "fetch_error": "Arbeitspläne konnten nicht geladen werden"
        },
        "fields": {
          "jpnum": "Plan-Nr.",
          "description": "Beschreibung",
          "status": "Status",
          "revision": "Revision",
          "site": "Standort"
        },
        "details": {
          "load_error": "Arbeitsplan konnte nicht geladen werden",
          "delete_warn": "Sie sind im Begriff, den Arbeitsplan {{jpnum}} zu löschen. Dies kann nicht rückgängig gemacht werden!"
        },
        "tabs": {
          "job_plan": "Arbeitsplan",
          "plans": "Pläne",
          "assets": "Anlagen"
        },
        "subtabs": {
          "tasks": "Aufgaben",
          "labor": "Arbeit",
          "materials": "Materialien",
          "tools": "Werkzeuge"
        },
        "sections": {
          "details": "Plandetails",
          "responsibility": "Verantwortlichkeit",
          "woassets": "Arbeitsanlagen und Sicherheitspläne"
        },
        "fields": {
          "jpnum": "Plan-Nr.",
          "status": "Status",
          "description": "Beschreibung",
          "template_type": "Vorlagentyp",
          "duration": "Dauer (Std)",
          "supervisor": "Vorgesetzter",
          "class": "Klassenstruktur",
          "safety_plan": "Sicherheitsplan",
          "revision": "Revision"
        },
        "table": {
          "seq": "Seq",
          "duration": "Dauer",
          "craft": "Gewerk",
          "labor": "Arbeiter",
          "qty": "Menge",
          "hours": "Stunden",
          "rate": "Satz",
          "item": "Artikel",
          "unitcost": "Stückkosten",
          "tool": "Werkzeug"
        }
      },
      "meters": {
        "list": {
          "title": "Zählerdefinitionen",
          "search": "Nach Nr. oder Name filtern...",
          "new_meter": "NEUER ZÄHLER",
          "no_records": "Keine Zähler gefunden"
        },
        "fields": {
          "meter_num": "Zähler-Nr.",
          "meter_name": "Zählername",
          "type": "Typ",
          "uom": "Einheit",
          "active": "Aktiv?",
          "remarks": "Bemerkungen",
          "last_reading": "LETZTE ABLESUNG",
          "last_date": "DATUM DER LETZTEN ABLESUNG",
          "rollovers": "GESAMTE ÜBERLÄUFE"
        },
        "tabs": {
          "meter": "Zählerdetails",
          "where_used": "Verwendungsort"
        },
        "sections": {
          "info": "Zählerinformationen",
          "additional": "Zusätzliche Details",
          "stats": "Zählerstatistiken"
        },
        "where_used": {
          "linked_assets": "Verknüpfte Anlagen",
          "linked_locations": "Verknüpfte Standorte",
          "linked_items": "Verknüpfte Artikel",
          "searching": "🔍 Suche im System...",
          "no_assoc": "Keine Verknüpfungen gefunden.",
          "asset_num": "Anlagen-Nr.",
          "site": "Standort",
          "status": "Status",
          "location": "Standort",
          "item_num": "Artikel-Nr.",
          "category": "Kategorie"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Anlagenkategorien",
          "search": "Kategorien suchen...",
          "new_category": "NEUE KATEGORIE",
          "no_records": "Keine Kategorien gefunden"
        },
        "fields": {
          "category_id": "Kategorie-Code",
          "description": "Beschreibung",
          "dep_method": "Abschreib.-Meth.",
          "life": "Nutz. (Jahre)"
        }
      },
      "export": {
        "loading": "Daten werden extrahiert...",
        "success": "Erfolgreich exportiert!",
        "error": "Fehler beim Exportieren der Daten."
      },
      "labor": {
        "list": {
          "title": "Arbeitskräfte-Register",
          "new": "NEUE ARBEITSKRAFT",
          "total": "Gesamte Arbeitskräfte",
          "unique_crafts": "Gewerke der Seite",
          "no_records": "Keine Arbeitskräfte gefunden."
        },
        "tabs": {
          "main": "HAUPT",
          "person": "PERSON",
          "crafts": "GEWERKE",
          "log": "PROTOKOLL"
        },
        "sections": {
          "basic": "Grundinformationen",
          "status": "Status & Organisation",
          "additional_crafts": "Zusätzliche Gewerke & Fähigkeiten"
        },
        "fields": {
          "personid": "Personenreferenz",
          "primary_craft": "Hauptgewerk",
          "actual_rate": "Tatsächlicher Satz (Stündlich)",
          "skill": "Qualifikationsniveau",
          "rate": "Stundensatz",
          "primary": "Primär?",
          "laborcode": "Arbeitskraft-Code",
          "fullname": "Vollständiger Name",
          "craft": "Gewerk"
        },
        "actions": {
          "add_craft": "GEWERK HINZUFÜGEN"
        },
        "lookup": {
          "person": "Person wählen",
          "craft": "Gewerk wählen",
          "skill": "Qualifikation wählen"
        },
        "messages": {
          "no_crafts": "Keine Gewerke-Zuordnungen gefunden"
        },
        "details": {
          "delete_warn": "Sie können diesen Datensatz nicht wiederherstellen!"
        }
      },
      "sr": {
        "list": {
          "title": "Serviceanfragen-Tracking",
          "new": "NEUE ANFRAGE"
        },
        "fields": {
          "srnum": "SA-Nummer",
          "description": "Beschreibung",
          "reportedby": "Gemeldet von",
          "reportdate": "Meldedatum",
          "priority": "Priorität"
        },
        "messages": {
          "no_records": "Keine Serviceanfragen gefunden"
        },
        "tabs": {
          "main": "Serviceanfrage",
          "related": "Zugehörige Datensätze"
        },
        "sections": {
          "requester": "Anfragender & Kontakt",
          "problem": "Problemspezifikationen",
          "logistics": "Logistik & Priorität"
        },
        "fields": {
          "phone": "Telefon",
          "email": "E-Mail",
          "asset": "Anlage",
          "location": "Standort",
          "long_desc": "Ausführliche Problembeschreibung",
          "priority_1": "1 - NOTFALL (SOFORT)",
          "priority_2": "2 - HOCH (AM SELBEN TAG)",
          "priority_3": "3 - MITTEL (72 STUNDEN)",
          "priority_4": "4 - NIEDRIG (GEPLANT)"
        },
        "lookup": {
          "person": "Person wählen",
          "asset": "Anlage wählen",
          "location": "Standort wählen"
        },
        "details": {
          "delete_new_only": "Nur NEUE Anfragen können gelöscht werden",
          "delete_warn": "Dadurch wird diese Serviceanfrage dauerhaft gelöscht.",
          "wf_tip": "Automatisierter Workflow: Verwenden Sie nach dem Speichern 'Workflow weiterleiten'.",
          "wo_tip": "Tipp: Sie können aus dieser SA einen Arbeitsauftrag generieren."
        },
        "related": {
          "title": "Verknüpfte Arbeitsaufträge für SA:",
          "wonum": "AA-Nummer",
          "worktype": "Arbeitsart",
          "no_wo": "Für diese SA wurden noch keine Arbeitsaufträge erstellt.",
          "go_to_wo": "Zum Arbeitsauftrag"
        }
      },
      "invusage": {
        "list": {
          "title": "Bestandsnutzungsverlauf",
          "new": "Neue Transaktion"
        },
        "types": {
          "all": "ALLE",
          "issue": "AUSGABE",
          "transfer": "TRANSFER",
          "return": "RÜCKGABE"
        },
        "tabs": {
          "lines": "NUTZUNGSZEILEN",
          "log": "TRANSAKTIONSPROTOKOLL"
        },
        "details": {
          "summary": "Zeilenzusammenfassung",
          "transfer_dest": "Zielort-Details für Transfer",
          "financial": "Finanzielle Belastung & Referenz"
        },
        "actions": {
          "add_item": "Artikel Hinzufügen",
          "add_part": "Teil Hinzufügen",
          "select_mr": "MATERIALANFORDERUNG WÄHLEN"
        },
        "fields": {
          "stock_item": "Lagerartikel",
          "issueunit": "Ausgabeeinheit",
          "qty": "Menge",
          "unitcost": "Stückkosten",
          "linecost": "Gesamtzeilenwert",
          "target_bin": "Zielbehälter in",
          "target_loc": "Zielstandort",
          "assetnum": "Anlagennummer",
          "wonum": "Arbeitsauftrags-Referenz",
          "glaccount": "Soll-Konto (GL)",
          "usagenum": "Nutzungs-ID",
          "type": "Typ",
          "fromstore": "Von Lager",
          "lines": "Zeilen",
          "enterby": "Eingegeben von"
        },
        "placeholders": {
          "select_item": "ARTIKEL WÄHLEN...",
          "dest_bin": "ZIELBEHÄLTER EINGEBEN...",
          "choose_loc": "STANDORT WÄHLEN",
          "select_asset": "ANLAGE WÄHLEN",
          "charge_wo": "AUF AA VERBUCHEN"
        },
        "lookup": {
          "store": "Lagerräume",
          "dest_store": "Ziellager",
          "mr": "Genehmigte Materialanforderung wählen",
          "item": "Lagerbestand-Suche",
          "loc": "Standorte",
          "asset": "Anlagenregister",
          "wo": "Arbeitsaufträge"
        },
        "messages": {
          "req_fromstore": "Bitte zuerst ein Lager auswählen!",
          "mr_loaded": "Artikel aus Materialanforderung geladen:",
          "mr_fail": "Laden der Materialanforderung fehlgeschlagen",
          "insufficient_title": "Unzureichender Bestand!",
          "available": "Verfügbar",
          "create_pr": "Bestellanforderung (BANF) erstellen?",
          "btn_create_pr": "BANF erstellen",
          "processing": "Bestandsanpassungen werden verarbeitet...",
          "inventory_updated": "Bestände erfolgreich aktualisiert",
          "cant_delete_comp": "Abgeschlossene Transaktion kann nicht gelöscht werden!",
          "delete_warn": "Dies wird den Entwurf dauerhaft löschen.",
          "req_fields": "Beschreibung und Lager sind erforderlich!",
          "req_transfer": "Ziel-Lager ist für Transfers erforderlich!",
          "locked_title": "Datensatz gesperrt",
          "locked_text": "Diese Transaktion ist ABGESCHLOSSEN und kann nicht geändert werden.",
          "cant_save_comp": "Änderungen an abgeschlossenem Datensatz können nicht gespeichert werden",
          "balance_move": "Hinweis: Saldo wird verschoben nach",
          "upon_comp": "bei Abschluss."
        }
      },
      "downtime": {
        "title": "Anlagenstillstand Melden",
        "subtitle": "Anlagenmanagementsystem",
        "asset": "Anlage",
        "status": "Offline-Aufzeichnung",
        "start": "Startdatum & -zeit",
        "end": "Enddatum (Optional)",
        "type": "Stillstandsart",
        "types": {
          "unplanned": "UNGEPLANT (Ausfall)",
          "planned": "GEPLANT (Wartung)"
        },
        "duration": "Berechnete Dauer",
        "hours": "STUNDEN",
        "prod_impact": "Betriebsstillstand (Produktionsauswirkung)",
        "btn_commit": "Änderungen Übernehmen",
        "messages": {
          "recording": "Stillstand wird erfasst...",
          "success": "Stillstand erfolgreich erfasst",
          "validation_error": "Formatfehler: Alle Felder prüfen",
          "server_error": "Serverfehler: 500"
        },
        "history": {
          "title": "Anlagenstillstandshistorie",
          "subtitle": "Leistungsverfolgung für Anlage",
          "no_records": "Keine Stillstandsereignisse für diese Anlage erfasst.",
          "duration_hrs": "Dauer (Std)",
          "type_reason": "Typ/Grund",
          "impact": "Auswirkung",
          "reported_by": "Gemeldet von",
          "still_down": "NOCH AUSGEFALLEN",
          "prod_loss": "Prod.-Verlust",
          "technical": "Technisch",
          "active_down": "Aktiver Stillstand",
          "resolved": "Behoben"
        }
      },
      "incidents": {
        "list": {
          "title": "Vorfallregister",
          "new": "NEUER VORFALL"
        },
        "fields": {
          "ticket_id": "Ticket-ID",
          "priority": "Priorität",
          "reported_by": "Gemeldet von"
        },
        "details": {
          "ticket": "Vorfall-Ticket",
          "general": "Allgemeine Beschreibung",
          "detailed": "Detaillierte Details",
          "context": "Kontext & Status",
          "linked_asset": "Verknüpfte Anlage",
          "workorder": "Arbeitsauftrag",
          "delete_warn": "Sie sind im Begriff, Vorfall {{ticket}} dauerhaft zu löschen. Diese Aktion kann nicht rückgängig gemacht werden!"
        },
        "lookup": {
          "asset": "Verknüpfte Anlage wählen",
          "loc": "Standort wählen"
        }
      },
      "tools": {
        "list": {
          "title": "Werkzeugstamm",
          "new": "NEUES WERKZEUG"
        },
        "fields": {
          "toolnum": "Werkzeugnummer",
          "type": "Typ",
          "is_stocked": "Auf Lager?"
        },
        "tabs": {
          "tool": "WERKZEUG",
          "stores": "LAGER",
          "vendors": "LIEFERANTEN",
          "specs": "SPEZ",
          "quals": "QUALIFIKATIONEN"
        },
        "sections": {
          "config": "Werkzeugkonfiguration",
          "inventory": "Bestand & Lagerbestände",
          "vendors": "BESCHAFFUNGS- & LIEFERANTENHISTORIE",
          "quals": "Erforderliche Qualifikationen"
        },
        "fields": {
          "toolnum": "Werkzeugnummer",
          "type": "Werkzeugtyp",
          "issueunit": "Ausgabeeinheit",
          "is_stocked": "Ist Lagerwerkzeug?",
          "rotating": "Rotierender Artikel?",
          "calib_req": "Kalibrierung erforderlich?",
          "mfg": "Hersteller",
          "model": "Modellnr.",
          "class": "Klassifizierung",
          "active_vendors": "AKTIVE LIEFERANTEN"
        },
        "actions": {
          "add_store": "Zum Lager hinzufügen",
          "add_qual": "Qualifikation hinzufügen"
        },
        "tables": {
          "storeroom": "Lagerraum",
          "balance": "Bestand",
          "attr": "Attribut",
          "value": "Wert",
          "uom": "ME",
          "qual": "Qualifikation",
          "vendor_id": "Lieferant (Firmennr.)",
          "vendor_name": "Lieferantenname",
          "unitcost": "Stückkosten",
          "qty": "Menge",
          "po": "Referenz-BA"
        },
        "placeholders": {
          "toolid": "WERKZEUG-ID EINGEBEN...",
          "reg_supplier": "REGISTRIERTER LIEFERANT",
          "adj": "BESTANDSKORREKTUR"
        },
        "lookup": {
          "type": "Werkzeugtyp",
          "unit": "Ausgabeeinheiten",
          "attr": "Attribute"
        },
        "messages": {
          "req_fields": "Werkzeugnummer und Beschreibung sind erforderlich!",
          "delete_warn": "Dies kann nicht rückgängig gemacht werden!",
          "class_loaded": "Klassifizierung & Attribute geladen",
          "stocked_note": "Hinweis: Lagerwerkzeuge werden über Lagerräume verwaltet und erfordern einen Bestandsdatensatz zur Verfolgung der Bestände.",
          "no_stock": "Keine Artikel auf Lager"
        }
      },
      "inventory": {
        "list": {
          "title": "Bestandsregister"
        },
        "fields": {
          "itemnum": "Artikelnr.",
          "location": "Lagerraum",
          "balance": "Bestand",
          "avgcost": "Ø Kosten"
        },
        "details": {
          "profile": "Bestandsprofil",
          "reorder_logic": "Nachbestelllogik",
          "reorder_pt": "Meldebestand",
          "eoq": "Wirtschaftliche Bestellmenge",
          "critical_lvl": "Kritisches Niveau",
          "critical_desc": "Automatische BANF-Erstellung, wenn der Bestand den Meldebestand erreicht.",
          "current_stock": "Aktueller Lagerbestand",
          "avail_qty": "Verfügbare Menge",
          "reserved_qty": "Reservierte Menge",
          "held_wo": "Reserviert für Arbeitsaufträge",
          "avg_cost": "Durchschnittliche Stückkosten",
          "avg_cost_desc": "Gewichteter Durchschnitt aller Wareneingänge",
          "total_val": "Gesamtlagerwert",
          "total_val_desc": "Aktueller Bestand × Ø Kosten",
          "last_cost": "Letzte Eingangskosten",
          "last_cost_desc": "Kosten aus der letzten Bestellung",
          "val_method": "Bestandsbewertungsmethode",
          "avg_method": "DURCHSCHNITTSKOSTEN",
          "val_desc1": "Dieser Artikel verwendet die",
          "val_desc2": "-Methode. Die Stückkosten werden bei jedem Wareneingang automatisch neu berechnet, um Marktschwankungen widerzuspiegeln."
        },
        "tabs": {
          "balances": "Bestände",
          "trans": "Transaktionsverlauf",
          "costs": "Kosten"
        },
        "actions": {
          "adjustment": "Bestandskorrektur"
        },
        "tables": {
          "qty": "Menge",
          "actual_cost": "Tatsächliche Kosten",
          "reference": "Referenz"
        },
        "messages": {
          "no_trans": "Kein Transaktionsverlauf gefunden"
        },
        "trans_types": {
          "receipt": "WARENEINGANG",
          "issue": "AUSGABE",
          "transfer": "UMBUCHUNG",
          "adjustment": "KORREKTUR"
        }
      },
      "storerooms": {
        "list": {
          "title": "Lagerräume",
          "new": "NEUER LAGERRAUM"
        },
        "fields": {
          "location": "Lagerraum",
          "isdefault": "Ist Standard?",
          "inventory": "Bestand",
        },
        "details": {
          "profile": "Lagerraum",
          "record": "Lagerraum-Datensatz",
          "gen_settings": "Allgemeine Einstellungen",
          "filtered_by": "Gefiltert nach {{org}}",
          "select_org_first": "Zuerst Org auswählen",
          "gl_accounts": "Sachkonten (GL)",
          "inv_control": "Bestandskontrolle",
          "inv_control_desc": "Alle Materialausgaben und -eingänge für diesen Lagerraum werden gegen diese Konten ausgeglichen.",
          "items_stocked": "Gelagerte Artikel"
        },
        "tabs": {
          "main": "HAUPT",
          "inventory": "BESTAND"
        },
        "fields": {
          "location": "Standort-ID",
          "isdefault": "Standard-Lagerraum?",
          "useinpo": "In Bestellung verwenden?",
          "invowner": "Bestandseigentümer",
          "controlacc": "Kontrollkonto",
          "shrinkacc": "Schwundkonto",
          "glaccount": "Standard-Sachkonto",
          "default": "STANDARD"
        },
        "lookup": {
          "person": "Person auswählen"
        },
        "tables": {
          "itemnum": "Artikelnr.",
          "uom": "ME",
          "curbal": "Aktueller Bestand",
          "reserved": "Reservierte Menge"
        },
        "messages": {
          "req_fields": "Standort-ID ist erforderlich!",
          "req_org_site": "Organisation und Standort sind erforderlich!",
          "delete_warn": "Sie sind dabei, den Lagerraum {{store}} zu löschen. Diese Aktion kann nicht rückgängig gemacht werden!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Fehlercode-Bibliothek",
          "new": "Neue Fehlerklasse"
        },
        "details": {
          "profile": "Fehlerklasse"
        },
        "fields": {
          "class": "Fehlerklasse",
          "code": "Code",
          "desc_tech": "Beschreibung / Technischer Name"
        },
        "tables": {
          "problems": "Probleme (Das Problem)",
          "causes": "Ursachen (Grundursache)",
          "remedies": "Abhilfen (Die Maßnahme)"
        },
        "placeholders": {
          "class": "Z.B. PUMP-FAIL",
          "desc_tech": "Geben Sie eine detaillierte Beschreibung dieser Fehlerhierarchie ein...",
          "code": "Code eingeben...",
          "desc": "Technische Beschreibung..."
        },
        "messages": {
          "req_class": "Fehlerklassencode ist erforderlich!",
          "delete_warn": "Sie sind dabei, die Fehlerklasse {{class}} zu löschen. Diese Aktion kann nicht rückgängig gemacht werden!"
        }
      },
      "scheduler": {
        "title": "Disposition & Einsatzplanung",
        "ai_optimize": "KI-AUTO-OPTIMIERUNG",
        "publish": "ZEITPLAN VERÖFFENTLICHEN",
        "kpi_scheduled": "Geplante Arbeiten",
        "kpi_issues": "Planungsprobleme",
        "kpi_utilization": "Gesamte Ressourcen",
        "kpi_emergencies": "Notfälle",
        "no_data": "Keine geplanten Arbeitsaufträge.",
        "no_resources": "Keine Ressourcenkapazitätsdaten.",
        "fetch_error": "Planungsdaten konnten nicht geladen werden.",
        "optimizing": "KI gleicht Ressourcenbelastung aus...",
        "optimize_fail": "KI-Optimierung fehlgeschlagen."
      },
      "features": {
        "title": "Katalog Linearer Merkmale",
        "feature_id": "Merkmalscode",
        "description": "Beschreibung",
        "type": "Merkmalstyp",
        "point": "Punkt (z.B. Ventil)",
        "linear": "Linear (z.B. Material)",
        "error_in_use": "Löschen nicht möglich: Merkmal wird auf einer Pipeline verwendet."
      },
      "audit": {
        "title": "Audit-Trail-Explorer",
        "history_for": "Verlauf für",
        "retrieving": "Audit-Datensätze werden abgerufen...",
        "no_records": "Keine Audit-Trails für diesen Datensatz gefunden"
      },

    }
  },
  // 🇮🇹 Italiano
  it: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "Eccellenza delle Risorse", version: "Teknova v1.0.4" },
      search: { placeholder: "Cerca moduli..." },
      menu: {
        settings: "Impostazioni", organization: "Organizzazione", domains: "Domini", field_config: "Configurazione Campi", classifications: "Classificazioni", importer: "Importatore Universale", cobie: "Gestore COBie", workflow: "Motore Workflow", scripts: "Script di Azione",
        analytics: "Analitica", dashboards: "Dashboard BI", report_designer: "Progettista Rapporti", report_wizard: "Creazione Rapporti",
        assets: "Risorse", asset_registry: "Registro Risorse", locations: "Ubicazioni", categories: "Categorie Risorse", meters: "Contatori", failure_codes: "Codici Guasto",
        work_management: "Gestione Lavoro", wo_tracking: "Monitoraggio Ordini", labor_reporting: "Pianificatore",
        resources: "Risorse Umane", crafts: "Mestieri", labor: "Manodopera", person: "Persona",
        service_desk: "Service Desk", service_requests: "Richieste di Servizio", incidents: "Registro Incidenti",
        procurement: "Approvvigionamento", po: "Ordini di Acquisto", pr: "Richieste di Acquisto", rfq: "Richiesta Quotazione", receiving: "Ricezione", vendors: "Fornitori",
        contracts: "Contratti", contracts_master: "Registro Contratti", sla: "SLA",
        inventory: "Inventario", item_master: "Registro Articoli", tools: "Strumenti", balances: "Saldi Inventario", transfers: "Trasferimenti", storerooms: "Magazzini",
        planning: "Pianificazione", pm_schedules: "Piani PM", safety_plans: "Piani Sicurezza", hazards: "Pericoli", precautions: "Precauzioni", tagouts: "Isolamenti", job_plans: "Piani di Lavoro",
        security: "Sicurezza", user_list: "Lista Utenti", groups: "Gruppi di Sicurezza", "recent": "Visitati di Recente"
      },
      user_settings: { title: "Impostazioni utente", default_info: "Informazioni predefinite", personal_info: "Informazioni personali", password_info: "Informazioni sulla password", sign_out: "Disconnetti", system_info: "Informazioni di Sistema" },
      notifications: { title: "Attività in entrata", new_alerts: "Nuovo", empty: "La tua casella è vuota", view_all: "Visualizza tutte le attività" },
      sidebar: { queries: "Query Disponibili", all_assets: "Tutte le Risorse", operating_assets: "Risorse Operative", critical_assets: "Risorse Critiche", my_bookmarks: "Miei Preferiti", common_actions: "Azioni Comuni", new: "Nuovo", move_assets: "Sposta Risorse", print_barcodes: "Stampa Barcode", create_report: "Crea Report", wo_queries: "Query OdL", all_wo: "Tutti gli Ordini", waiting_approval: "In Attesa Approvazione", wip: "In Corso", completed_today: "Completati Oggi", bulk_approve: "Approvazione Massiva", record_actions: "Azioni Record", save: "Salva", delete: "Elimina", workflow_status: "Workflow / Stato", change_status: "Cambia Stato", view_history: "Vedi Cronologia", item_ops: "Operazioni Articolo", add_to_storeroom: "Aggiungi a Magazzino", inv_ops: "Operazioni Inventario", reorder: "Riordina", tax_ops: "Operazioni Fiscali", tax_category: "Categoria Tasse", create_po: "Crea Ordine", settings_group: "Impostazioni", system_settings: "Impostazioni Sistema", email_settings: "Impostazioni Email", asset_ops: "Operazioni Risorsa", meter_readings: "Letture Contatore", hist_readings: "Letture Storiche", report_downtime: "Segnala Fermo", downtime_hist: "Storico Fermi", move_mod_asset: "Sposta/Modifica", asset_move_hist: "Storico Spostamenti", create_related: "Crea Correlati", create_incident: "Crea Incidente", view_inc_hist: "Storico Incidenti", create_wo: "Crea OdL", sr: "Richiesta Servizio", apply_sla: "Applica SLA", approve_wo: "Approva OdL", start_work: "Inizia Lavoro", complete_work: "Completa Lavoro", close_wo: "Chiudi OdL", analytics: "Analitica", wf_history: "Cronologia Workflow", history_log: "Log Operazioni", wo_costs: "Costi OdL", purchase_info: "Info Acquisto", all_records: "Tutti i Record", find_nav: "Cerca Voce", more_actions: "Altre Azioni", settings: "Impostazioni", export_data: "Esporta", audit_log: "Audit Log", share_app: "Condividi" },
      apps: {
        ORGANIZATION: "Organizzazioni", ASSET: "Risorse", LOCATION: "Ubicazioni", WORKORDER: "Ordini di Lavoro", INVENTORY: "Inventario", CLASSIFICATION: "Classificazioni", VENDOR: "Fornitori", METER: "Contatori", DOMAINS: "Domini", CRAFTS: "Mestieri", STOREROOMS: "Magazzini", ITEMS: "Articoli", INVENTORYUSAGE: "Uso Inventario", MR: "Richieste Mat.", PR: "Richieste Acquisto", PO: "Ordini Acquisto", LABOR: "Manodopera", PM: "Piani PM", SAFETY: "Piani Sicurezza", HAZARD: "Pericoli", TAGOUT: "Isolamenti", PRECUTION: "Precauzioni", SR: "Richieste Servizio", INCIDENT: "Incidenti", ASSET_CATEGORIES: "Categorie Risorse", FAILURECLASS: "Codici Guasto", RFQ: "Quotazioni", CONTRACT: "Contratti", SLA: "Accordo sul livello di servizio", FAILURE_CODES: "Codici di errore",
        "VENDORS": "Fornitori", "TAGOUTS": "Lockout/Tagout", "PRECAUTIONS": "Precauzioni", "INCIDENTS": "Incidenti", "JOBPLAN": "Piani di Lavoro", "ROLE": "Ruoli", "TOOLS": "Strumenti", "USER": "Utenti",
      },
      dashboard: { tab_bi: "Modello KPI", tab_inbox: "Inbox Workflow", advanced_analytics: "Analisi Avanzata", workflow_center: "Centro Esecuzione", active_tasks: "Attività Attive", history_tasks: "Cronologia", no_data: "Nessun dato trovato", take_action: "Agisci", previous: "Precedente", next: "Successivo", showing: "Visualizzazione", of: "di", actual: "Effettivo", target: "Obiettivo", kpi_graph: "Grafico KPI" },
      username: "ID Utente",
      password: "Password",
      login_btn: "Accedi",
      forgot_pwd: "Password dimenticata?",
      login: {
        id_placeholder: "Inserisci il tuo ID",
        error_msg: "ID o password non validi",
        server_error: "Connessione al server non riuscita",
        just_smart: "Semplicemente Intelligente"
      },
      organizations: { title: "Organizzazioni", org_id: "Organizzazione", description: "Descrizione", active: "Attivo?" },
      org_detail: { org_label: "Organizzazione", tabs: { organization: "Organizzazione", sites: "Sedi", map: "Mappa" }, fields: { currency1: "Valuta Base 1", currency2: "Valuta Base 2", item_set: "Set Articoli", company_set: "Set Aziende", item_status: "Stato Predefinito", active: "Attivo?" }, descs: { currency1: "Valuta Primaria", currency2: "Valuta Secondaria", item_set: "SET ARTICOLI", company_set: "SET AZIENDE" }, lookups: { currency: "Valuta", item_set: "Set Articoli", company_set: "Set Aziende", status: "Stato", governorate: "Provincia" }, sites: { management: "Gestione Sedi", new_row: "Nuova Riga", of: "di", site_id: "ID Sede", description: "Descrizione", active: "Attivo?", action: "Azione", site_details: "Dettagli Sede", state: "Stato / Provincia", contact: "Contatto Primario", fin_info: "Informazioni Finanziarie", yearly_budget: "Budget Annuale", monthly_budget: "Budget Mensile", utilization: "Utilizzo Annuo", fin_health: "Situazione finanziaria stabile." }, toasts: { id_required: "ID richiesto!", saving: "Salvataggio...", success: "Salvato con successo!", fail: "Errore" } },
      domains: { title: "Domini", find_placeholder: "Cerca Dominio...", new_domain: "Nuovo Dominio", domain_id: "Dominio", description: "Descrizione", type: "Tipo", values: "Valori" , 
        save_btn: "Salva", desc_placeholder: "Descrizione dominio", synonym_values: "Valori Sinonimi", new_row: "Nuova riga", internal_val: "Valore interno", external_desc: "Descrizione esterna", default: "Predefinito?", action: "Azione", no_values: "Nessun valore definito.", toasts: { loading: "Caricamento...", load_fail: "Caricamento fallito", id_required: "ID richiesto!", saving: "Salvataggio...", save_success: "Salvato!", save_fail: "Errore" } },
      classifications: { parent: "Classificazione Superiore", order: "Ordine", hierarchy: "Struttura", hierarchy: "Percorso gerarchia", parent: "Classificazione superiore", gen_desc: "Genera descrizione?", use_with: "Usa con oggetti", attributes: "Attributi", attr_id: "ID attributo", section: "Sezione", uom: "unità di misura" },
      bim: { title: "Integratore BIM Pro", subtitle: "Mappatura avanzata Revit a COBie", waiting_translation: "In attesa di traduzione del modello...", tabs: { "3d": "Visualizzatore 3D", data: "Tabella dati" }, preview_table_title: "Anteprima componenti COBie", controls: { destination: "Destinazione", select_site: "Seleziona sito", uploads: "Caricamento file", select_cobie: "Seleziona file COBie", upload_revit: "Carica file Revit", models_ready: "Modelli pronti", preview_list: "Anteprima modelli", finalizing: "Sincronizzazione...", commit: "Conferma integrazione BIM" }, table: { asset_name: "Nome risorsa", location: "Spazio / Posizione" } },
      importer: { title: "Caricatore dati universale", target_table: "Tabella di destinazione", download_template: "Scarica modello", upload_instruction: "Seleziona file Excel", field_mapping: "Mappatura campi", excel: "Excel", ignore: "Ignora", preview_title: "Anteprima", execute_btn: "ESEGUI IMPORTAZIONE" },
      workflow: { title: "Motore Workflow", subtitle: "Centro di automazione", export_btn: "Esporta CSV", new_process: "Nuovo Processo", loading: "Caricamento...", unnamed: "Processo senza nome", linked_to: "Collegato a", create_path: "Crea nuovo percorso",
                  designer_title: "Progettista Logica Workflow (Loopback Abilitato)",
          publish_btn: "PUBBLICA", loading_designer: "Ricostruzione percorso logico...", logic_palette: "Palette Logica", config_title: "Configurazione", node_label: "Etichetta", assign_roles: "Assegna ruoli",
          post_action: "Script post-azione", select_lookup: "SELEZIONA DA LOOKUP", script_hint: "* Più script possono essere separati da virgole.", status_auto: "Azione stato automatica", trigger: "Trigger",
          target_status: "Stato di destinazione", cond_expr: "Espressione condizionale (Python)", escalation: "Escalation (Ore)", select_node: "Seleziona un nodo da modificare",
          options: { no_change: "NESSUN CAMBIO STATO", change_status: "CAMBIA STATO", select_status: "SELEZIONA STATO" },
          lookups: {select_roles: "Cerca ruoli", select_scripts: "Cerca script" },
          swal: {publish_title: "Pubblicare il workflow?", publish_text: "Sincronizzerà i passaggi con il database.", confirm_publish: "Sì, pubblica ora", delete_title: "Eliminare la logica?", delete_text: "Sei sicuro di voler eliminare", confirm_delete: "Sì, elimina tutto" },
          toasts: { id_required: "Nome processo richiesto", saving: "Sincronizzazione...", save_success: "Workflow sincronizzato! 🚀", save_fail: "Sincronizzazione fallita", purging: "Eliminazione...", delete_success: "Workflow eliminato", delete_fail: "Eliminazione fallita", fetch_fail: "Caricamento fallito" }
      },
      field_config: { title: "Mappatura campi metadati", table_name: "NOME TABELLA", field_name: "NOME CAMPO", current_mappings: "MAPPATURE ATTUALI PER", field: "Campo", linked_domain: "Dominio collegato" },
      scripts: {
        title: "SCRIPT DI AZIONE",
        subtitle: "Gestisci l'automazione e i modelli logici",
        new_btn: "CREA NUOVO SCRIPT",
        search_placeholder: "Cerca per nome o oggetto...",
        table: {
          name: "Nome script",
          object: "Oggetto di destinazione",
          created: "Creato il"
        },
        toasts: {
          fetch_fail: "Caricamento script fallito"
        }
      },
      studio: { schema_explorer: "ESPLORATORE SCHEMA", target_context: "Contesto oggetto target", name_placeholder: "Nome dello script...", engine_info: "MOTORE: PYTHON 3.10", console_title: "Console di esecuzione", clear_console: "Pulisci console", field_from: "Campo da", access_col: "Accesso colonna: ", db_model: "Modello database", btns: { compile: "COMPILA", compiling: "COMPILAZIONE...", save_deploy: "SALVA" }, toasts: { preserved: "Script salvato!", compiled: "Analisi riuscita!" }, console: { init: "Studio inizializzato...", schema_sync: "Schema sincronizzato.", schema_fail: "Schema fallito.", saved_prefix: "Script salvato", error_op: "Errore di salvataggio.", compiling: "Analisi in corso...", build_finish: "Build terminata.", syntax_error: "Errore sintassi.", build_fail: "Build fallita", analyzing: "Analisi sintattica..." } },
      reports: { title: "Modelli di rapporto", new_btn: "Nuovo rapporto", search_placeholder: "Cerca...", table: { name: "Nome rapporto", ref_obj: "Oggetto di riferimento", updated: "Aggiornato" }, 
          toasts: { load_fail: "Caricamento fallito", clone_success: "Rapporto clonato", save_success: "Modello salvato! 🚀", save_fail: "Salvataggio fallito" },
          designer: {
              title: "MOTORE REPORT PRO", live_preview: "Anteprima live", publish: "Pubblica modello", model_select: "Selezione modello", data_explorer: "Esplora dati", components: "Componenti", page_break: "Interruzione pagina",
              is_summary: "Rapporto sintetico?", user_params: "Parametri utente", add_param: "Aggiungi campo", master_info: "Info principali", relational_data: "Dati relazionali", detail_tables: "Tabelle dettagli",
              tabs: { body: "Contenuto", header: "Intestazione", footer: "Piè di pagina", css: "CSS globale" },
              fields: { wonum: "Numero OdL", assetnum: "Numero Risorsa", desc: "Descrizione", status: "Stato", asset: "Nome risorsa", location: "ID Posizione", tasks_table: "Tabella attività", mat_table: "Materiali pianificati", asset_basic: "Info base risorsa", inv_basic: "Info base magazzino", vend_basic: "Info base fornitore" }
            },   
        }, 
      assets: { 
        map: {"gps_location": "Posizione Geografica (GPS)", "gps_coordinates": "Coordinate GPS"},
        list: { system_title: "Gestione Asset", new_asset: "Nuovo asset", all_orgs: "Tutte le org", all_sites: "Tutti i siti", db_total: "Totale:", display_page: "Pagina:", navigate_hint: "Utilizza le frecce per navigare", col_site: "Sito", col_org: "Org" }, 
        modal: { migration_title: "Migrazione di massa", caution_prefix: "Attenzione: stai spostando", caution_suffix: "asset.", dest_label: "Nuova destinazione", placeholder: "SELEZIONA...", abort: "Annulla", execute: "Esegui" },
        headers: { asset_num: "Numero Asset", desc: "Descrizione", status: "Stato", downtime: "Tempo di inattività totale", site: "Sito" },
        tabs: { details: "Dettagli Asset", spare_parts: "Parti di ricambio", safety: "Sicurezza", meters: "Contatori", specs: "Specifiche", history: "Cronologia lavoro", map: "Mappa", bim: "Vista 3D", ai: "Analisi IA", eval: "Valutazione", attachments: "Allegati" },
        sections: { "linear_details": "Dettagli di riferimento lineare", general: "Informazioni generali", details: "Dettagli", finance: "Indirizzo e finanza", image: "Immagine Asset", audit: "Info audit", bim_info: "Info BIM", reliability: "Analisi affidabilità" },
        fields: { "is_linear": "È un asset lineare?", "start_measure": "Misura iniziale", "end_measure": "Misura finale", "measure_unit": "Unità di misura", "direction": "Direzione del flusso", type: "Tipo Asset", location: "Posizione", parent: "Asset genitore", category: "Categoria Asset", is_running: "Asset operativo?", serial: "Numero di serie", item: "Articolo rotante", failure: "Classe guasto", safety_plan: "Piano di sicurezza", vendor: "Fornitore", price: "Prezzo d'acquisto", replace: "Costo sostituzione", priority: "Priorità", ytd_cost: "Costo annuale (YTD)" },
        meters: { seq: "Sequenza", name: "Contatore", reading: "Ultima lettura", date: "Data lettura", inspector: "Ispettore", remarks: "Note" },
        ai: { title: "Intelligenza Asset", run: "Esegui diagnostica", summary: "Riepilogo tecnico", recommend: "Raccomandazioni", telemetry: "Analisi telemetria in corso..." },
        spare_fields: { item: "Articolo rotante", qty: "Quantità", issued: "Qtà emessa", remarks: "Note", item_details: "Dettagli articolo" },
        safety: { plan_card: "Piani di sicurezza associati", active_plan: "Piano di sicurezza attivo", no_plan: "NESSUN PIANO COLLEGATO", link_plan: "Collega piano", change_plan: "Cambia piano", hazard_title: "Rischi specifici dell'asset", hazard_num: "Rischio", hazard_type: "Tipo / Priorità", no_hazards: "Nessun rischio collegato.", add_hazard: "Aggiungi rischio", loto_title: "Blocco / Etichettatura (LOTO)", tag_id: "ID Etichettatura", req_state: "Stato richiesto", no_loto: "Nessun punto di isolamento definito.", add_loto: "Aggiungi punto di isolamento", applying_proto: "Applicazione protocollo..." }, 
        meters: { title: "Contatori associati", details_title: "Dettagli contatore", seq: "Sequenza", meter_name: "Nome contatore", meter_type: "Tipo contatore", uom: "Unità di misura", active_status: "Attivo?", last_reading: "Ultima lettura", last_date: "Data lettura", inspector: "Ispettore", remarks: "Note", new_meter: "Nuovo contatore" },
        specs: { classification: "Classificazione", select_class: "Seleziona classificazione...", tech_specs: "Specifiche tecniche", attribute: "Attributo", value: "Valore", uom: "UOM", data_type: "Tipo di dato", attr_details: "Dettagli attributo", select_val: "Seleziona valore" },
        history: { title: "Cronologia ordini di lavoro", wo_num: "N° OdL", finish_date: "Data fine", no_history: "Nessuna cronologia trovata.", fetching: "Caricamento cronologia...", wo_type: "Tipo" },
        bim: { model_status: "Stato modello", linked: "COLLEGATO & ATTIVO", not_linked: "NON COLLEGATO", upload_revit: "Carica Revit (.rvt)", urn_label: "URN Modello", "show_3d": "Visualizza Gemello Digitale (3D)", "not_linked": "Non collegato al modello 3D" },
        ai: { title: "INTELLIGENZA DEGLI ASSET", sub_title: "Analizzatore IA", tagline: "Diagnostica predittiva IoT industriale", run_btn: "ESEGUI DIAGNOSTICA", analyzing: "ANALISI FLUSSO TELEMETRICO...", health_score: "Punteggio salute", thermal: "Allerta termica", vibration: "Allerta vibrazioni", tech_summary: "RIEPILOGO TECNICO", recommendations: "RACCOMANDAZIONI", sensors_chart: "Sensori vs Limiti critici", init_prompt: "Clicca su ESEGUI DIAGNOSTICA per avviare l'analisi IA", critical: "CRITICO", normal: "NORMALE", stable: "STABILE", detected: "RILEVATO", "predictive_trajectory": "Traiettoria di guasto predittiva", "est_failure": "Guasto stimato", "loading_pred": "Generazione modello di previsione..." },
        "features": {
          "feature_id": "ID Funzionalità",
          "label": "Etichetta",
          "start": "Misura Iniziale",
          "end": "Misura Finale (Vuoto = Punto)",
          "value": "Valore (es. 500mm)",
          "details": "Dettagli Funzionalità",
          "y_offset": "Offset Y (Destra/Sinistra)",
          "z_offset": "Offset Z (Profondità/Altezza)"
        },
    

      }, 
      common: { "days": "Giorni", "weeks": "Settimane", "months": "Mesi", "years": "Anni", "daysList": {"saturday": "Sabato", "sunday": "Domenica", "monday": "Lunedì", "tuesday": "Martedì", "wednesday": "Mercoledì", "thursday": "Giovedì", "friday": "Venerdì"}, "select": "Seleziona", "search": "Cerca", "pending": "In attesa", "pendingSelection": "--- IN ATTESA DI SELEZIONE ---",confirm: "conferma", save_settings: "Salva configurazione IA", selected: "Asset selezionati", bulk_move: "Migrazione di massa", change_status: "Cambia stato", cancel: "Resetta", save: "Salva", cancel: "Annulla", delete: "Elimina", back: "Indietro", record: "Record", total: "Totale", print: "Stampa", active: "Attivo", critical: "Critico", warning: "Avviso", healthy: "Sano", of: "di", new_row: "Nuova riga", "filter": "Filtra...", "save_success": "Salvato con successo", "save_fail": "Salvataggio fallito", "delete": "Elimina", "delete_success": "Eliminato con successo", "delete_fail": "Eliminazione fallita", "are_you_sure": "Sei sicuro?", "cancel": "Annulla", "confirm": "Conferma", "first": "Primo", "last": "Ultimo", "next": "Successivo", "prev": "Precedente", "sar": "SAR", "all": "TUTTI", "attachments": "Allegati", "history": "Cronologia", "change_status": "Cambia stato",  "totalRecords": "Record Totali", "readOnly": "(SOLO LETTURA)", "noDescription": "Nessuna descrizione", "recordLocked": "Il record è bloccato e non può essere modificato.", "descRequired": "La descrizione è obbligatoria!", "actionDenied": "Azione negata", "cantDeleteStatus": "Impossibile eliminare un record con stato: {{status}}", copy: "Copia", cancel: "Annulla", clone: "Clona", back: "Torna", "main": "Dettagli Principali", "save": "SALVA", "change_status": "Cambia Stato", "history": "Cronologia", "delete": "Elimina", "org": "Organizzazione", "site": "Sito", "new_row": "NUOVA RIGA", "location": "Posizione", "asset": "Asset", "no_records": "Nessun record trovato", "saving": "Salvataggio...", "save_success": "Salvato con successo!", "save_fail": "Salvataggio fallito", "are_you_sure": "Sei sicuro?", "yes_delete": "Sì, elimina!", "cancel": "Annulla", "delete_success": "Eliminato con successo", "delete_fail": "Eliminazione fallita: ", "clear_filters": "CANCELLA FILTRI", "all": "TUTTI", "syncing": "Sincronizzazione...", "showing": "Mostra", "total": "Totale", "created_by": "Creato Da", "changed_date": "Data Modifica"},
      toasts: { save_success: "Salvato con successo", save_fail: "Salvataggio fallito", load_fail: "Caricamento dati fallito", delete_success: "Eliminato con successo" },
      swal: { delete_title: "Sei sicuro?", delete_text: "Stai per eliminare l'asset:", confirm_delete: "Sì, elimina il record" },
      "ai_settings": {
        "title": "Impostazioni ingegnere IA",
        "sub_title": "Motore di manutenzione predittiva IA",
        "enable_label": "Attiva manutenzione predittiva automatica",
        "enable_sub": "Crea OdL automatico basato sull'analisi IA",
        "target_lang": "Lingua dei rapporti e delle attività",
        "threshold": "Soglia di confidenza per la decisione",
        "auto_tasks": "Genera automaticamente le attività di lavoro (WOTasks)",
        "task_desc": "Scrivere le fasi del lavoro automaticamente nella tabella delle attività",
        "max_tasks": "Numero massimo di fasi per ordine di lavoro",
        "section": "Sezione",
        "technicalDetails": "Dettagli Tecnici"
      },
      "export_technical_report": "ESPORTA RAPPORTO TECNICO (PDF)",
      "availability": "Disponibilità",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "hrs": "ORE",
      "reliability_score": "Punteggio di Affidabilità",
      "score": "Punteggio",
      "downtime_history_trend": "Tendenza Storica Tempi di Inattività (Ultimi 10 Eventi)",
      "values_in_hours": "Valori in Ore",
      "timeline_event_date": "Cronologia (Data Evento)",
      "downtime_hours": "Tempo di Inattività (Ore)",
      "no_downtime_records": "Nessun record di inattività trovato per questo asset finora.",
      "reliability_analysis": "Analisi di Affidabilità",
      "total_failures": "Guasti Totali",
      "total_down_time": "Tempo di Inattività Totale",
      "last_calculation": "Ultimo Calcolo",
      "maintenance_strategy_note": "Nota Strategia di Manutenzione",
      "high_mttr_detected": "Rilevato MTTR elevato. Raccomandazione: valutare la disponibilità dei ricambi e la formazione tecnica per questa categoria di asset.",
      "critical_availability": "Livello di disponibilità critico. Considerare l'aumento della frequenza della manutenzione preventiva o revisioni programmate.",
      "nominal_performance": "Le prestazioni dell'asset rientrano nei parametri nominali. Continuare con il programma standard.",
      "current_load_factor": "Fattore di Carico Attuale",
      "optimal": "Ottimale",
      statusModal: {
        "loadError": "Impossibile caricare gli stati",
        "selectFirst": "Seleziona prima uno stato",
        "updating": "Aggiornamento stato...",
        "success": "Stato aggiornato",
        "failed": "Aggiornamento non riuscito",
        "changeStatus": "Cambia stato:",
        "currentStatus": "Stato attuale",
        "availableStatuses": "Stati disponibili",
        "loading": "Caricamento...",
        "chooseStatus": "Scegli stato...",
        "memo": "Giustificazione / Memo",
        "enterNotes": "Inserisci le tue note...",
        "cancel": "Annulla",
        "update": "Aggiorna"
      },
      attachmentsModal: {
        "loadError": "Errore di caricamento file",
        "uploadSuccess": "File allegato con successo",
        "uploadFailed": "Caricamento fallito",
        "deleteConfirmTitle": "SEI SICURO?",
        "deleteConfirmText": "Stai per eliminare definitivamente '{{name}}'. Questo rimuoverà il file dai nostri server.",
        "btnYesDelete": "SÌ, ELIMINA!",
        "btnCancel": "ANNULLA",
        "processingDelete": "Elaborazione eliminazione...",
        "deletedTitle": "ELIMINATO!",
        "deletedText": "L'allegato è stato rimosso con successo.",
        "deleteFailed": "Eliminazione fallita",
        "headerTitle": "Libreria allegati",
        "linkingTo": "Collegato a:",
        "filesFound": "FILE TROVATI:",
        "uploadBtn": "CARICA NUOVO DOCUMENTO",
        "thName": "Nome",
        "thOwner": "Proprietario",
        "thStatus": "Stato",
        "thActions": "Azioni",
        "statusPrivate": "Privato",
        "statusPublic": "Pubblico",
        "noDocs": "Nessun documento ancora collegato"
      },
      enterMeters: {
        "noMeters": "Nessun contatore collegato all'asset:",
        "saving": "Salvataggio letture...",
        "enterAtLeastOne": "Inserisci almeno una nuova lettura",
        "saveSuccess": "Tutte le letture salvate con successo!",
        "saveFailed": "Salvataggio letture fallito",
        "title": "Inserisci Letture Contatore | Asset:",
        "titleLoc": "Inserisci Letture Contatore | Posizione:",
        "thIdentification": "Identificazione Contatore",
        "thNewReading": "* Nuova Lettura",
        "thReadingDate": "* Data Lettura",
        "thMeterType": "Tipo di Contatore",
        "thLastRecorded": "Ultima Registrazione",
        "noDescription": "Nessuna descrizione",
        "enterValue": "Inserisci valore...",
        "notAvailable": "N/D",
        "operator": "Operatore:",
        "btnCancel": "Annulla",
        "btnUpdate": "Aggiorna Letture"
      },
      emailSettings: {
        "loadFailed": "Impossibile caricare le impostazioni",
        "saveSuccess": "Impostazioni e-mail salvate con successo!",
        "saveFailed": "Impossibile salvare le impostazioni",
        "connecting": "Connessione al server SMTP...",
        "connFailed": "Connessione Fallita!",
        "title": "Configurazione SMTP",
        "subtitle": "Impostazioni server di posta",
        "outgoingTitle": "Posta in Uscita (SMTP - Invio)",
        "incomingTitle": "Posta in Arrivo (IMAP - Monitoraggio)",
        "lblHost": "Host SMTP",
        "lblPort": "Porta SMTP",
        "lblUser": "Nome utente / E-mail SMTP",
        "lblPass": "Password SMTP",
        "lblSender": "E-mail mittente di sistema (Da)",
        "lblImapHost": "Host IMAP",
        "lblImapPort": "Porta IMAP",
        "enableImap": "Abilita monitoraggio posta in arrivo (Radar RFQ)",
        "imapDesc": "Recupera e analizza automaticamente i preventivi dei fornitori dalla casella di posta.",
        "gmailNote": "Per Gmail, usa una 'Password per le app' da Sicurezza di Google. Le password degli account non funzioneranno con la 2FA abilitata.",
        "btnTest": "TEST",
        "btnCancel": "ANNULLA",
        "btnSave": "SALVA CONFIGURAZIONE"
      },
      locationDetails: {
        "noBimModel": "Nessun modello 3D collegato a questa posizione",
        "noBimLinked": "Questa posizione non è collegata a BIM",
        "locMandatory": "La posizione è un campo obbligatorio!",
        "saving": "Salvataggio modifiche...",
        "saveSuccess": "Posizione salvata con successo",
        "saveFailed": "Salvataggio non riuscito:",
        "deleteTitle": "Sei sicuro?",
        "deleteText": "Stai per eliminare la Posizione {{id}}. Questa azione non può essere annullata!",
        "btnYesDelete": "Sì, elimina!",
        "btnCancel": "Annulla",
        "deleting": "Eliminazione posizione...",
        "deleteSuccess": "Posizione eliminata con successo",
        "deleteFailed": "Eliminazione non riuscita!",
        "uploadingRevit": "Caricamento e traduzione modello Revit...",
        "revitSuccess": "Modello collegato con successo!",
        "uploadFailed": "Caricamento non riuscito:",
        "loadingCtx": "CARICAMENTO CONTESTO POSIZIONE...",
        "tooltipChangeStatus": "Cambia stato",
        "tooltipStatusHistory": "Cronologia stato",
        "tooltipDelete": "Elimina",
        "btnSave": "SALVA",
        "lblLocation": "Posizione",
        "lblDescription": "Descrizione",
        "btnRevitLinked": "Revit collegato",
        "tabLocation": "Posizione",
        "tabAssets": "Asset",
        "tabSpecs": "Specifiche",
        "tabSafety": "Sicurezza",
        "tabMeters": "Contatori",
        "tab3D": "Vista 3D",
        "tabHistory": "Cronologia",
        "secIdentity": "Identità posizione",
        "lblStatus": "Stato",
        "lblType": "Tipo",
        "lblParentLoc": "Posizione padre",
        "lblSiteID": "ID sito",
        "secGeoInfo": "Informazioni geografiche e indirizzo",
        "lblServiceAddr": "Indirizzo di servizio",
        "lblBimSpaceId": "ID spazio BIM",
        "lblGisCoords": "Coordinate GIS",
        "secRefImage": "Immagine di riferimento",
        "btnUploadPhoto": "Carica foto",
        "thAssetNum": "Num Asset",
        "thStatus": "Stato",
        "lblClass": "Classificazione",
        "thAttr": "Attributo",
        "thDesc": "Descrizione",
        "thValue": "Valore",
        "titleHazards": "Pericoli segnalati in questa posizione",
        "btnAddHazard": "Aggiungi pericolo",
        "lblSelectHazards": "Seleziona pericoli",
        "thHazard": "Pericolo",
        "thPrecaution": "Precauzione",
        "titleLocMeters": "Contatori posizione",
        "showingMeters": "Visualizzazione {{current}} di {{total}}",
        "noMetersDef": "Nessun contatore definito",
        "thSeq": "Seq",
        "thMeterNum": "Num contatore",
        "thType": "Tipo",
        "thUOM": "UdM",
        "thActive": "Attivo",
        "newMeter": "NUOVO_CONTATORE",
        "clickNewRow": "Fai clic su 'Nuova riga' per aggiungere un contatore",
        "titleMeterConfig": "Configurazione dettagli contatore",
        "newEntry": "Nuova voce",
        "lblMeterNum": "* Numero contatore",
        "lblMeterType": "Tipo di contatore",
        "lblUOM": "Unità di misura",
        "lblMeterActive": "Il contatore è attivo",
        "lblLastReading": "Ultima lettura",
        "lblReadingDate": "Data lettura",
        "lblInspector": "Ispettore contatore",
        "lblRemarks": "Osservazioni / Commenti",
        "placeholderRemarks": "Inserisci note tecniche su questo contatore...",
        "btnAddMeterRow": "Aggiungi nuova riga contatore",
        "titleModelStatus": "Stato modello",
        "statusLinked": "COLLEGATO E ATTIVO",
        "statusNotLinked": "NON COLLEGATO",
        "btnUploadRevit": "Carica Revit (.rvt)",
        "titleHistory": "Cronologia transazioni e registro di controllo",
        "lblChangedBy": "Modificato da:",
        "failedFetchAttr": "Recupero attributi fallito"
      },
      "locationList": {
        "loadFailed": "Impossibile caricare le posizioni dal server Teknoia.",
        "title": "Posizioni",
        "searchPlaceholder": "Ricerca globale...",
        "btnClearAll": "Cancella tutto",
        "btnExport": "Esporta",
        "btnNewLocation": "Nuova posizione",
        "thLocationId": "ID Posizione",
        "thDescription": "Descrizione",
        "thType": "Tipo",
        "thStatus": "Stato",
        "thSite": "Sito",
        "optAll": "TUTTI",
        "optOperating": "OPERATIVO",
        "optDecommissioned": "DISMESSO",
        "fetchingData": "Recupero dati dal server...",
        "noRecords": "Nessun record corrispondente trovato.",
        "recordsFound": "Record trovati:",
        "page": "Pagina:"
      },
      "universalLookup": {
        "selectValue": "Seleziona Valore:",
        "total": "Totale",
        "searchPlaceholder": "Cerca per codice o descrizione...",
        "valueCode": "Valore / Codice",
        "description": "Descrizione",
        "site": "Sito",
        "synchronizing": "Sincronizzazione...",
        "noRecords": "Nessun record corrispondente trovato.",
        "loadingMore": "Caricamento di altri record...",
        "results": "Risultati:",
        "cancel": "Annulla"
      },
      "statusHistory": {
        "title": "Registro di controllo stato",
        "loading": "CARICAMENTO CRONOLOGIA...",
        "noRecords": "Nessuna modifica di stato registrata per questo elemento.",
        "initial": "INIZIALE",
        "btnClose": "Chiudi"
      },
      "personalInfo": {
        "updateSuccess": "Profilo aggiornato con successo",
        "sessionExpired": "Sessione scaduta, effettua di nuovo il login",
        "updateFailed": "Aggiornamento fallito",
        "title": "Informazioni personali e predefiniti",
        "lblDisplayName": "Nome completo",
        "lblEmail": "Indirizzo E-mail",
        "lblDefaultOrg": "Organizzazione predefinita",
        "selectOrg": "Seleziona organizzazione...",
        "lblDefaultSite": "Sito predefinito",
        "selectSite": "Seleziona sito...",
        "lblDefaultLang": "Lingua predefinita",
        "btnCancel": "Annulla",
        "btnSave": "Applica e salva",
        "securityTitle": "Sicurezza e 2FA",
        "enable2FA": "Abilita l'autenticazione a due fattori (2FA)",
        "googleAuth": "Google Authenticator",
        "emailOTP": "OTP via Email",
        "configure2FA": "Configura 2FA",
        "scanQR": "Scansiona questo codice QR usando Google Authenticator o Authy, quindi inserisci il codice a 6 cifre qui sotto per verificare.",
        "btnVerify": "Verifica",
        "setupSuccess": "Configurazione 2FA completata con successo!",
        "invalidCode": "Codice di verifica non valido",
        "failedQR": "Impossibile generare il codice QR"
      },
      "appSettings": {
        "savingSettings": "Salvataggio impostazioni...",
        "saveSuccess": "Impostazioni aggiornate con successo!",
        "saveFailed": "Salvataggio impostazioni fallito.",
        "title": "Configurazione aziendale",
        "org": "Organizzazione",
        "tabs": {
          "WORKORDER": "Ordini di lavoro",
          "ASSET": "Registro asset",
          "INVENTORY": "Magazzino e scorte",
          "PURCHASE": "Approvvigionamento",
          "PR": "RdA",
          "JP": "Piani di Lavoro",
          "PM": "Manutenzione Preventiva",
          "MR": "Richiesta Materiali",
          "SR": "Richiesta di Servizio"
        },
        "systemRules": "Regole di sistema {{tab}}",
        "prefix": "Prefisso sequenza",
        "preview": "Anteprima",
        "seed": "Valore iniziale (Seme)",
        "valuationStrategy": "Strategia di valutazione",
        "movingAvg": "Media mobile (Consigliata)",
        "fifo": "First-In, First-Out (FIFO)",
        "lifo": "Last-In, First-Out (LIFO)",
        "allowNegative": "Consenti saldo negativo",
        "negativeWarning": "Avvertenza: influisce sull'accuratezza finanziaria",
        "encrypting": "Crittografia e trasmissione...",
        "auditLogged": "Tutte le modifiche sono registrate nel registro di controllo",
        "btnCancel": "Annulla",
        "btnSave": "Salva policy di sistema"
      },
      "workflowAction": {
        "successMove": "Flusso di lavoro instradato con successo! 🚀",
        "failedMove": "Azione non riuscita",
        "btnRoute": "Instrada flusso",
        "modalTitle": "AZIONE FLUSSO DI LAVORO",
        "assignedAs": "Assegnato a te come:",
        "defaultInstruction": "Rivedi e agisci.",
        "lblChoosePath": "Scegli percorso",
        "valSelectPath": "Seleziona un percorso",
        "optApprove": "APPROVA / AVANTI",
        "optReject": "RIFIUTA / INDIETRO",
        "lblMemo": "Memo azione / Commenti",
        "placeholderMemo": "Aggiungi qui i tuoi commenti...",
        "btnCancel": "Annulla",
        "btnComplete": "COMPLETA PASSAGGIO"
      },
      "meterHistory": {
        "title": "Letture Storiche Contatore",
        "lblAsset": "Asset",
        "fetching": "Recupero archivi...",
        "noRecords": "Nessuna lettura storica trovata per questo asset.",
        "thMeterName": "Nome Contatore",
        "thReadingVal": "Valore Lettura",
        "thReadingDate": "Data Lettura",
        "thEnteredBy": "Inserito da",
        "thEntryDate": "Data Inserimento",
        "btnClose": "Chiudi Cronologia",
        "lblLocation": "Posizione",
        "noRecordsLoc": "Nessuna lettura storica trovata per questa posizione.",
      },
      "rpt_print": "Stampa i report",
      "no_templates": "Nessun modello disponibile",
      "wo": {
        "tabs": { "workOrder": "Ordine di lavoro", "plans": "Piani", "assignments": "Assegnazioni", "actuals": "Effettivi", "safety": "Sicurezza", "failure": "Segnalazione guasti" },
        "subTabs": { "tasks": "Attività", "labor": "Manodopera", "materials": "Materiali", "tools": "Strumenti", "services": "Servizi" },
        "headers": { "workOrder": "Ordine di lavoro", "status": "Stato", "totalCost": "Costo totale", "activeSla": "MONITORAGGIO SLA", "targetRes": "RISOLUZIONE OBIETTIVO", "targetResp": "RISPOSTA OBIETTIVO" },
        "sections": { "assetDetails": "Dettagli Asset", "scheduling": "Programmazione", "responsibility": "Responsabilità", "laborAssign": "Assegnazioni", "totalAssign": "Assegnazioni totali" },
        "fields": { "description": "Descrizione", "location": "Posizione", "asset": "Asset", "workType": "Tipo lavoro", "safetyCode": "Codice sicurezza", "supervisor": "Supervisore", "failureClass": "Classe guasto", "targStart": "Inizio obiettivo", "targFinish": "Fine obiettivo", "schedStart": "Inizio programmato", "schedFinish": "Fine programmata", "earlyStart": "Non iniziare prima di", "lateFinish": "Non finire dopo", "actStart": "Inizio effettivo", "actFinish": "Fine effettiva", "duration": "Durata", "timeRemaining": "Tempo rimanente", "predecessors": "Predecessori", "includeTasks": "Includere attività?", "site": "Sito", "organization": "Organizzazione", "priorityHigh": "Priorità: Alta" },
        "actions": { "routeWorkflow": "Invia Workflow", "wfHistory": "Cronologia", "changeStatus": "Cambia stato", "attachments": "Allegati", "printWO": "Stampa OdL", "printSafety": "Scheda sicurezza", "history": "Storico", "newTask": "Nuova attività", "selectLoc": "Seleziona posizione", "selectAsset": "Seleziona asset", "selectType": "Seleziona tipo", "selectSafety": "Seleziona piano", "selectSup": "Seleziona supervisore", "selectFail": "Seleziona classe", "selectCraft": "Seleziona mestiere", "selectLabor": "Seleziona manodopera", "selectItem": "Seleziona articolo", "selectStore": "Seleziona magazzino", "selectTool": "Seleziona strumento", "addLabor": "Aggiungi manodopera", "addMaterial": "Aggiungi materiale", "addTool": "Aggiungi strumento", "addService": "Aggiungi servizio", "newAssign": "Nuova assegnazione", "compAssign": "Completa assegnazione", "createMR": "Crea richiesta materiale", "yesCreate": "Sì, crea", "yesChange": "Sì, cambia", "approve": "Approva", "cancel": "Annulla", "startWork": "Inizia", "close": "Chiudi", "complete": "Completa", "selectProblem": "Seleziona problema", "selectCause": "Seleziona causa", "selectRemedy": "Seleziona rimedio" },
        "tables": { "sequence": "Seq", "taskDesc": "Desc. attività", "estDur": "Durata st.", "status": "Stato", "craft": "Mestiere", "labor": "Manodopera", "qty": "Qtà", "hrs": "Ore", "rate": "Tariffa", "lineCost": "Costo riga", "lineType": "Tipo riga", "itemNum": "Articolo #", "description": "Descrizione", "unitCost": "Costo unitario", "storeroom": "Magazzino", "item": "Articolo", "material": "Materiale", "toolNum": "Strum. #", "serviceDesc": "Desc. servizio", "vendor": "Fornitore", "cost": "Costo", "start": "Inizio", "finish": "Fine", "failCode": "Codice guasto" },
        "footer": { "totalLabor": "Totale manodopera", "totalMaterial": "Totale materiali", "assigned": "Assegnato (Stima)", "toolsServ": "Strumenti e serv.", "totalActual": "Costo totale effettivo" },
        "safety": { "hazardsTitle": "Rischi e precauzioni", "hazardCode": "Codice rischio", "hazardDesc": "Descrizione rischio", "precautions": "Precauzioni richieste", "noHazards": "Nessun rischio identificato.", "lotoTitle": "Lock Out / Tag Out", "step": "Fase", "tagNum": "Etichetta n.", "isoDesc": "Desc. isolamento", "reqState": "Stato richiesto", "completed": "Completato?", "noLoto": "Nessun isolamento richiesto." },
        "failure": { "title": "Analisi guasti", "currClass": "Classe corrente", "notDefined": "NON DEFINITO", "problems": "PROBLEMI", "causes": "CAUSE", "remedies": "RIMEDI", "records": "RECORD" },
        "placeholders": { "desc": "Inserisci descrizione...", "taskDesc": "DESCRIZIONE ATTIVITÀ..." },
        "messages": { "loadError": "Errore caricamento", "taskStatusLocal": "Stato attività aggiornato", "selectItemStore": "Seleziona articolo e magazzino", "duplicateReqTitle": "Richiesta duplicata", "duplicateReqText": "Esiste già una richiesta per {{item}}. Crearne un'altra?", "creatingMR": "Creazione...", "mrCreated": "Richiesta {{num}} creata", "mrFail": "Creazione fallita", "confirmStatusChange": "Cambiare lo stato di {{wonum}} in {{status}}?", "statusSuccess": "Stato modificato", "statusFail": "Modifica fallita", "saving": "Salvataggio...", "deleteConfirm": "Eliminare {{wonum}}? L'azione è irreversibile!", "saveBeforeSLA": "Salvare l'OdL prima", "slaExists": "SLA già applicato!", "matchingSLA": "Ricerca SLA...", "slaApplied": "SLA applicato con successo", "noMatchingSLA": "Nessun SLA trovato", "slaError": "Errore motore SLA", "failureTreeLoaded": "Codici guasto applicati", "zeroBalance": "Attenzione: Saldo zero per {{store}}", "balanceOk": "Prezzo: {{cost}} - Saldo: {{bal}}", "storeError": "Errore magazzino", "assetLinked": "Asset collegato: {{asset}}", "openAssignError": "Impossibile chiudere: {{count}} assegnazioni incomplete.", "budgetExceeded": "Budget superato!", "assignComplete": "Assegnazione completata", "actionNotAllowed": "Azione non permessa per {{status}}", "locked": "Bloccato", "cantChangeCancel": "Le richieste annullate non possono cambiare stato", "printFail": "Creazione PDF fallita", "wfRouted": "Workflow inviato con successo! 🚀", "wfFail": "Invio fallito", "taskStatusChanged": "Stato attività {{task}} cambiato in {{status}}", "noLaborAssign": "Nessuna manodopera assegnata.", "updateTaskProg": "Aggiorna l'avanzamento", "noMaterials": "Nessun materiale. Clicca per aggiungere.", "linkedMRs": "Richieste materiale collegate", "stocknobalance": "⚠️ Attenzione: questo articolo ha un saldo (zero) in magazzino" },
        "linearDefect": {
          "title": "Posizione del Difetto Lineare",
          "startMeasure": "Misura Iniziale",
          "endMeasure": "Misura Finale (Opzionale)",
          "unit": "Unità",
          "yOffset": "Offset Y (m)"
        },
        "costs": {
          "title": "Costi Ordine di Lavoro",
          "estimated": "Costi Stimati",
          "actual": "Costi Effettivi",
          "labor": "Manodopera",
          "materials": "Materiali",
          "tools": "Strumenti",
          "services": "Servizi",
          "total": "Totale",
          "variance": "Varianza (Effettivo - Stimato)",
          "calculating": "Calcolo in corso...",
          "no_data": "Nessun dato disponibile."
        },
        "purchase_info": {
          "title": "Informazioni di Acquisto Correlate",
          "mr_title": "Richieste Materiale (MR)",
          "pr_title": "Richieste di Acquisto (PR)",
          "po_title": "Ordini di Acquisto (PO)",
          "mr_num": "N. MR",
          "pr_num": "N. PR",
          "po_num": "N. PO",
          "vendor": "Fornitore",
          "status": "Stato",
          "req_date": "Data Richiesta",
          "total_cost": "Costo Totale",
          "fetching": "Recupero dati...",
          "no_records": "Nessun record trovato."
        },
    
      },
      "pm": {
        "tabs": { "pm": "PM", "frequency": "Frequenza", "sequence": "Sequenza", "seasonaldates": "Date Stagionali", "forecast": "Previsione" },
        "sections": { "assetLoc": "Asset e Posizione", "defaults": "Impostazioni Predefinite", "compliance": "Conformità", "siteContext": "Info Sito", "timeBased": "Intervallo di Tempo", "meters": "Contatori", "sequences": "Sequenze Piani", "seasonal": "Programma Settimanale", "projections": "Log Previsioni" },
        "fields": { "pmNum": "Numero PM", "description": "Descrizione", "status": "Stato", "site": "Sito", "asset": "Asset", "location": "Posizione", "route": "Percorso", "counter": "Contatore", "jpnum": "Piano Lavoro", "worktype": "Tipo Lavoro", "supervisor": "Supervisore", "glaccount": "Conto GL", "woStatus": "Stato Default", "priority": "Priorità", "lastStart": "Ultimo Inizio", "lastComp": "Ultima Fine", "nextDue": "Prossima Scadenza", "forecastFlag": "Flag Previsione", "org": "Org", "freqInt": "Intervallo", "freqUnit": "Unità", "targStart": "Ora Inizio" },
        "actions": { "forecast": "PREVEDI", "savePM": "SALVA", "addMeter": "AGGIUNGI CONTATORE", "addStep": "AGGIUNGI FASE", "newPM": "Nuovo record PM" },
        "tables": { "meterName": "Contatore", "freq": "Freq.", "nextProj": "Prossima Prev.", "seq": "Sequenza", "jpnum": "Piano Lavoro", "fcDate": "Data", "targetJp": "Piano Obiettivo", "estCost": "Costo Est.", "status": "Stato", "woNum": "Num OdL", "generated": "GENERATO", "projected": "PREVISTO" },
        "messages": { "executingForecast": "Calcolo...", "forecastSuccess": "Successo", "forecastFail": "Errore", "seasonalInfo": "I giorni spuntati sono consentiti.", "noMeters": "Nessun contatore.", "noSeq": "Sequenza disabilitata.", "noForecasts": "Nessuna previsione.", "showingProjections": "Mostrando {{count}} record", "fetchListError": "Impossibile caricare i record PM", "syncingList": "Sincronizzazione con il server...", "noRecords": "Nessun record trovato." },
        "placeholders": { "desc": "Inserisci descrizione...", "globalSearch": "Ricerca globale intelligente..." },
        "headers": { "masterDir": "Elenco principale PM" },
        "footer": { "dbTotal": "Totale database:", "currentPage": "Pagina attuale:", "useNavArrows": "Usa le frecce" }
      },
      "workflowHistory": {
        "title": "Cronologia Workflow",
        "trackingId": "ID Tracciamento:",
        "fetching": "Recupero record...",
        "currentTask": "Attività Attuale",
        "since": "Dal:",
        "by": "da",
        "noHistory": "Nessuna cronologia registrata per questa transazione",
        "closeBtn": "Chiudi Cronologia"
      },
      "pr": {
        "headers": { "prList": "Kaufanfragen" },
        "actions": { "newPR": "NEUE ANFRAGE", "clearFilters": "FILTER LÖSCHEN", "routeWf": "WORKFLOW WEITERLEITEN" },
        "tabs": { "pr": "Kaufanfrage", "prlines": "Anfragezeilen" },
        "sections": { "general": "Allgemeine Informationen", "financial": "Finanzielle Zusammenfassung" },
        "fields": { "prNum": "Anfrage-Nr.", "requestedBy": "Angefordert von", "reqDate": "Bedarfsdatum", "refMr": "Referenz-Materialanfrage", "vendor": "Lieferant", "glAccount": "Sachkonto" },
        "financial": { "subtotal": "Zwischensumme", "taxTotal": "Steuersumme", "grandTotal": "Gesamtsumme" },
        "tables": { "prNum": "Anfrage-Nr.", "description": "Beschreibung", "status": "Status", "totalCost": "Gesamtkosten", "reqDate": "Anfragedatum", "site": "Standort", "itemNum": "Artikel-Nr.", "itemType": "Typ", "qty": "Menge", "unitCost": "Stückpreis", "tax": "Steuer", "lineTotal": "Zeilensumme", "taxCat": "Steuerkat." },
        "messages": { "loadFailed": "Kaufanfragen konnten nicht geladen werden", "syncing": "Synchronisieren...", "noData": "Keine Daten gefunden", "noLines": "Noch keine Zeilen hinzugefügt.", "fetchingMRLines": "Lade Zeilen für Materialanfrage: {{mrnum}}...", "loadedMRLines": "{{count}} Zeilen geladen", "noMRLines": "Diese Materialanfrage hat keine Zeilen", "failedMRLines": "Fehler beim Laden der Zeilen" },
        "swal": { "lockedTitle": "Gesperrt", "cantDeleteStatus": "Löschen mit Status {{status}} nicht möglich", "cantChangeCancel": "Stornierte Anfragen können den Status nicht ändern", "deleteWarnText": "Dadurch wird die Kaufanfrage und alle Zeilen dauerhaft gelöscht." },
        "placeholders": { "desc": "Beschreibung eingeben...", "globalSearch": "Globale smarte Suche..." },
        "footer": { "showing": "Zeige", "totalRecords": "Gesamtdatensätze" }
      },
      "po": {
        "headers": { "poList": "Ordini di Acquisto" },
        "actions": { "newPO": "NUOVO ORDINE", "clearFilters": "CANCELLA FILTRI", "routeWf": "INVIA WORKFLOW", "addManualRow": "AGGIUNGI RIGA", "wfHistory": "Cronologia Workflow" },
        "tabs": { "po": "Ordine", "polines": "Righe Ordine" },
        "sections": { "general": "Informazioni Generali", "financial": "Riepilogo Finanziario", "lines": "Righe Ordine di Acquisto" },
        "fields": { "poNum": "Num Ordine", "requestedBy": "Richiesto da", "orderDate": "Data Ordine", "refPr": "Rif. RdA", "vendor": "Fornitore", "glAccount": "Conto GL" },
        "financial": { "subtotal": "Subtotale", "taxTotal": "Ammontare Tasse", "grandTotal": "Totale Generale" },
        "tables": { "poNum": "Num Ordine", "totalCost": "Costo Totale", "orderDate": "Data Ordine", "itemNum": "Articolo #", "itemType": "Tipo", "unitCost": "Costo Unit.", "tax": "Tassa", "lineTotal": "Totale Riga", "taxCat": "Cat. Tasse" },
        "messages": { "loadFailed": "Impossibile caricare gli ordini", "syncing": "Sincronizzazione...", "noData": "Nessun ordine corrispondente trovato", "noLines": "Nessuna riga aggiunta.", "vendorRequired": "Il fornitore è obbligatorio per salvare.", "fetchingLines": "Recupero righe per: {{num}}...", "loadedLines": "{{count}} righe caricate con successo", "noLinesFound": "Questo documento non ha righe", "failedLines": "Errore caricamento righe", "cantChangeCancel": "Le richieste annullate non possono cambiare stato", "cantDeleteStatus": "Impossibile eliminare con stato: {{status}}" },
        "swal": { "deleteWarnText": "Questo eliminerà permanentemente l'Ordine e le sue righe." },
        "placeholders": { "desc": "Inserisci descrizione...", "globalSearch": "Ricerca globale intelligente..." },
        "footer": { "showing": "Mostrando" }
      },
      "mr": {
        "headers": { "mrList": "Richieste Materiali" },
        "actions": { "newMR": "NUOVA RICHIESTA", "clearFilters": "CANCELLA FILTRI", "routeWf": "INVIA WORKFLOW","createUsage": "CREA UTILIZZO", "createUsageDesc": "Crea Record Emissione/Trasferimento", "createPR": "CREA RDA", "createPRDesc": "Crea Richiesta di Acquisto", "addMaterial": "Aggiungi Materiale"},
        "tabs": { "mr": "Info", "mrlines": "Righe" },
        "sections": { "general": "Informazioni Generali", "financial": "Riepilogo Finanziario", "mrItems": "Articoli Richiesta Materiale", "financialCharging": "Dettagli Addebito Finanziario" },
        "fields": { "mrNum": "Num Richiesta", "requestedBy": "Richiesto da", "reqDate": "Data Richiesta", "refMr": "Rif. Richiesta", "vendor": "Fornitore", "glAccount": "Conto GL", "targetStore": "Magazzino Dest.", "chargeLoc": "Addebito Posizione", "chargeAsset": "Addebito Asset", "chargeWO": "Addebito OdL" },
        "financial": { "subtotal": "Subtotale", "taxTotal": "Totale Tasse", "grandTotal": "Totale" },
        "tables": { "mrNum": "Num Richiesta", "description": "Descrizione", "status": "Stato", "totalCost": "Costo Totale", "enteredDate": "Data Inserimento", "site": "Sito", "itemNum": "Articolo #", "itemType": "Tipo", "qty": "Qtà", "unitCost": "Costo", "tax": "Tassa", "lineTotal": "Totale Riga", "taxCat": "Cat. Tasse", "stockItem": "Articolo a Magazzino", "qtyReq": "Qtà Richiesta", "estUnitCost": "Costo Unit. Stimato" },
        "messages": { "loadFailed": "Impossibile caricare le richieste", "syncing": "Sincronizzazione...", "noData": "Nessun dato trovato", "noLines": "Nessuna riga aggiunta.", "fetchingMRLines": "Recupero righe: {{mrnum}}...", "loadedMRLines": "{{count}} righe caricate", "noMRLines": "Nessuna riga trovata", "failedMRLines": "Errore caricamento righe", "generating": "Generazione {{docType}} in corso...", "generatedSuccess": "{{docType}} {{docnum}} generato con successo!", "generateFail": "Generazione di {{docType}} fallita", "storeRequired": "Il magazzino è obbligatorio!", "dateRequired": "La Data Richiesta è obbligatoria!" }, 
        "swal": { "lockedTitle": "Bloccato", "cantDeleteStatus": "Impossibile eliminare con stato: {{status}}", "cantChangeCancel": "Le richieste annullate non possono cambiare stato", "deleteWarnText": "Questo eliminerà permanentemente la Richiesta e le sue righe." },
        "placeholders": { "desc": "Inserisci descrizione...", "globalSearch": "Ricerca globale...", "chooseLoc": "SCEGLI POSIZIONE", "selectAsset": "SELEZIONA ASSET", "chargeWO": "ADDEBITA SU ODL" },
        "lookups": { "storerooms": "Magazzini", "inventory": "Ricerca Inventario", "locations": "Posizioni", "assets": "Registro Asset", "workorders": "Ordini di Lavoro" },
        "footer": { "showing": "Mostrando", "totalRecords": "Totale" }
      },
      "contract": {
        "headers": { "masterNode": "Nodo Contratti" },
        "placeholders": { "globalSearch": "Ricerca globale...", "desc": "Inserisci sintesi...", "termDesc": "Dettagli clausola..." },
        "actions": { "newContract": "NUOVO CONTRATTO", "save": "SALVA", "addTerm": "AGGIUNGI CLAUSOLA", "addLine": "AGGIUNGI RIGA", "wfHistory": "Cronologia Workflow" },
        "tabs": { "general": "Generale", "slaperformance": "SLA (Prestazioni)", "termslegal": "Termini e Legale", "contractlines": "Righe Contratto" },
        "sections": { "identity": "Identità e Validità", "communication": "Centro Comunicazione", "auditInfo": "Info Audit", "masterSLA": "Link SLA", "slaBenchmarks": "Metriche SLA", "termsList": "Clausole Legali", "lines": "Scopo del Lavoro / Righe" },
        "options": { "supply": "Fornitura", "labor": "Lavoro/Servizio", "lease": "Locazione", "allTypes": "TUTTI I TIPI", "allStatus": "TUTTI GLI STATI", "general": "GENERALE", "payment": "PAGAMENTO", "termination": "RISOLUZIONE", "warranty": "GARANZIA", "liability": "RESPONSABILITÀ" },
        "fields": { "contractNum": "Num Contratto", "vendorRef": "Fornitore", "startDate": "Data Inizio", "endDate": "Data Fine", "contractValue": "Valore Contratto", "currency": "Valuta", "contactPerson": "Persona di Contatto", "vendorEmail": "Email Fornitore", "slaRef": "Rif. SLA", "respTime": "Tempo Risposta (Ore)", "resTime": "Tempo Risoluzione (Ore)", "uptime": "Obiettivo Disponibilità (%)", "penalty": "Penalità (per Ora)", "grandTotal": "Totale Calcolato" },
        "tables": { "contractNum": "Num Contratto", "grandTotal": "Totale", "clauseType": "Cat. Clausola", "clauseDesc": "Dettagli Condizione", "lineDesc": "Descrizione Riga", "rate": "Tariffa", "lineTotal": "Totale Riga" },
        "messages": { "fetchError": "Sincronizzazione fallita", "syncing": "Sincronizzazione...", "noData": "Nessun contratto trovato", "descMandatory": "La descrizione è obbligatoria", "vendorSelected": "Fornitore {{name}} selezionato", "noTerms": "Nessuna clausola definita", "noLines": "Nessuna riga definita", "slaHint": "Collegare un SLA applica le sue regole globalmente." },
        "swal": { "deleteTitle": "Eliminazione definitiva?", "deleteText": "Questo eliminerà permanentemente il contratto e le sue righe." },
        "footer": { "masterRecords": "Record Principali:", "currentPage": "Pagina Attuale:" }
      },
      "rfq": {
        "headers": { "rfqList": "Gestione RdO" },
        "tabs": { "rfq": "RdO", "rfqlines": "Righe RdO", "quotations": "Preventivi" },
        "sections": { "general": "Informazioni Generali", "financial": "Riepilogo Finanziario" },
        "fields": { "requestedBy": "Richiesto da", "reqDate": "Data Richiesta", "refPr": "RdA di Riferimento", "vendor": "Fornitore", "vendorEmail": "Email Fornitore", "glAccount": "Conto GL" },
        "financial": { "subtotal": "Subtotale", "taxTotal": "Totale Tasse", "grandTotal": "Totale Generale" },
        "tables": { "rfqNum": "Num RdO", "totalCost": "Costo Totale", "itemNum": "Articolo #", "itemType": "Tipo", "unitCost": "Costo Unit.", "tax": "Tassa", "taxCat": "Cat. Tasse" },
        "options": { "awarded": "AGGIUDICATO" },
        "actions": { "newRFQ": "NUOVA RdO", "sendEmail": "INVIA EMAIL", "wfHistory": "Cronologia WF", "award": "AGGIUDICA E CREA ORDINE" },
        "messages": { "loadFailed": "Caricamento fallito", "syncing": "Sincronizzazione...", "noData": "Nessun record", "noLines": "Nessuna riga definita", "pullingPR": "Importazione RdA...", "prImported": "Righe importate!", "prFailed": "Importazione fallita", "noEmail": "Email mancante!", "sending": "Creazione PDF e invio...", "sendSuccess": "Email inviata!", "sendFailed": "Invio fallito", "quotesHint": "I preventivi in arrivo appariranno qui automaticamente.", "noQuotes": "Nessun preventivo ricevuto.", "awarding": "Aggiudicazione in corso...", "awardSuccess": "Preventivo aggiudicato!", "poCreated": "Ordine creato", "awardFailed": "Aggiudicazione fallita" },
        "swal": { "sendTitle": "Inviare RdO?", "sendText": "Vuoi inviare questa richiesta a {{vendor}}?", "awardTitle": "Aggiudicare preventivo?", "awardText": "Questo genererà automaticamente un Ordine di Acquisto." },
        "footer": { "showing": "Mostrando" }
      },
      "itemList": {
        "headers": { "master": "Anagrafica Articoli" },
        "actions": { "newItem": "Nuovo Articolo" },
        "tables": { "item": "Articolo", "rotating": "Rotante?" },
        "messages": { "syncFailed": "Sincronizzazione fallita", "syncing": "Sincronizzazione...", "noData": "Nessun articolo trovato" },
        "footer": { "totalItems": "Totale Articoli:", "page": "PAGINA" }
      },
      "itemDetails": {
        "tabs": { "item": "ARTICOLO", "inventory": "INVENTARIO", "vendors": "FORNITORI", "specs": "SPECIFICHE", "assembly": "ASSEMBLAGGIO" },
        "sections": { "config": "Configurazione Articolo", "units": "Unità e Tracciamento", "bomList": "Distinta Base (BOM)", "supplierHistory": "Cronologia Acquisti e Fornitori" },
        "actions": { "save": "SALVA", "addStore": "AGGIUNGI A MAGAZZINO", "newSpec": "NUOVA SPECIFICA", "addComponent": "AGGIUNGI COMPONENTE" },
        "fields": { "itemSet": "Set Articoli", "rotating": "Rotante?", "lotControl": "Controllo Lotto?", "inspectionReq": "Ispezione Richiesta?", "orderUnit": "Unità Ordine", "issueUnit": "Unità Uscita", "condition": "Condizione Attiva?", "sparepart": "Parte di Ricambio?", "classification": "Classificazione" },
        "tables": { "store": "Magazzino", "avgCost": "Costo Medio", "balance": "Saldo", "attribute": "Attributo", "value": "Valore", "uom": "UdM", "subItem": "Sotto-Articolo", "remarks": "Note", "vendor": "Cod Fornitore", "supplierName": "Nome Fornitore", "unitCost": "Costo Unit.", "refPO": "OdA Riferimento", "activeVendors": "FORNITORI ATTIVI" },
        "messages": { "reqFields": "Numero Articolo e Descrizione obbligatori!", "fetchingAttributes": "Recupero attributi...", "attributesLoaded": "Attributi caricati", "failedAttributes": "Errore caricamento attributi", "stockMsgTitle": "MESSAGGIO STOCK", "stockMsgDesc": "L'aggiornamento di queste unità avrà impatto su tutti i magazzini.", "noInventory": "Nessun record di inventario.", "noSpecs": "Nessuna specifica.", "noBom": "Nessuna distinta base (BOM).", "noVendors": "Nessun record di acquisto trovato." },
        "swal": { "deleteText": "Stai per eliminare l'articolo {{num}}. L'azione è irreversibile!" }
      },
      "changePassword": {
        "title": "Cambia password",
        "currentPwd": "Password attuale",
        "newPwd": "Nuova password",
        "confirmPwd": "Conferma nuova password",
        "securityTitle": "Verifica di sicurezza",
        "googleAuthMsg": "Inserisci il codice a 6 cifre da Google Authenticator per confermare questa modifica.",
        "emailOtpMsg": "Un codice OTP è stato inviato alla tua email.",
        "btnCancel": "Annulla",
        "btnUpdate": "Aggiorna password",
        "btnVerify": "Verifica e cambia",
        "btnBack": "Indietro",
        "errMismatch": "Le nuove password non corrispondono!",
        "errLength": "La password deve contenere almeno 6 caratteri.",
        "msgVerifyReq": "Verifica la tua identità per continuare.",
        "msgSuccess": "Password cambiata con successo!",
        "errFailed": "Impossibile cambiare la password."
      },
      "userDetails": {
        "titleNew": "NUOVO UTENTE",
        "titleEdit": "SICUREZZA / UTENTI",
        "btnSave": "SALVA UTENTE",
        "saving": "SALVATAGGIO...",
        "secIdent": "Identificazione utente",
        "lblLoginId": "ID di accesso",
        "lblFullName": "Nome completo",
        "lblDisplayName": "Nome visualizzato",
        "lblEmail": "Indirizzo email",
        "lblPassword": "Password",
        "lblActive": "Stato attivo",
        "secAccess": "Sicurezza e controllo accessi",
        "lblPrimaryRole": "Ruolo di sicurezza principale",
        "lblSecRoles": "Ruoli secondari (Aggiuntivi)",
        "lblDefOrg": "Organizzazione predefinita",
        "lblDefSite": "Sito predefinito",
        "secDelegation": "Delega del lavoro",
        "lblDelegateTo": "Delega lavoro a",
        "lblStartDate": "Data e ora di inizio",
        "lblEndDate": "Data e ora di fine"
      },
      "receivingDetails": {
        "errLoadLines": "Impossibile caricare le righe dell'OdA",
        "errMissingDist": "Specificare il magazzino e la quantità per tutte le righe",
        "errInspMandatory": "La decisione di ispezione è OBBLIGATORIA per questo articolo",
        "errRejectExceeds": "Controlla le quantità rifiutate (non possono superare la qtà arrivata)",
        "msgSuccess": "Transazione elaborata con successo!",
        "msgAutoClosed": "Chiuso automaticamente: ",
        "swalAssignTitle": "Assegnazione Magazzino",
        "swalAssignText": "L'articolo {{item}} non è attualmente assegnato a {{loc}}. Assegnarlo ora e completare la ricezione?",
        "swalAssignBtn": "Sì, Assegna e Completa",
        "errUnexpected": "Errore imprevisto durante la ricezione",
        "hubTitle": "Hub di Ricezione Massiva",
        "poRef": "RIFERIMENTO ODA: ",
        "btnExecuting": "ESECUZIONE...",
        "btnConfirm": "CONFERMA RICEZIONE",
        "tblItemsPending": "Articoli in attesa di ricezione",
        "colItemDetails": "Dettagli Articolo",
        "colBalance": "Saldo",
        "lblQualityCheck": "CONTROLLO QUALITÀ RICHIESTO",
        "lblUnits": "Unità",
        "msgNoPending": "Nessun articolo in attesa trovato",
        "lblLandedCost": "Costo sbarcato (Totale oneri extra)",
        "lblBaseCost": "Costo unitario base OdA",
        "lblStoreMatrix": "Matrice di distribuzione magazzino",
        "btnSplitStore": "Dividi",
        "colStoreroom": "Magazzino",
        "colArrived": "Arrivato",
        "colRejected": "Rifiutato",
        "plcClickSearch": "Clicca per cercare ->",
        "lookupSelectStore": "Seleziona Magazzino",
        "lblQcMatrix": "Matrice di decisione controllo qualità",
        "optSelectDecision": "-- Obbligatorio: Seleziona Decisione --",
        "optPassed": "COMPLETAMENTE SUPERATO (ACCETTA TUTTO)",
        "optFailed": "COMPLETAMENTE RIFIUTATO (RESO AL FORNITORE)",
        "optPartial": "ACCETTAZIONE PARZIALE (VEDI CAMPO RIFIUTATO)",
        "lblInvValuation": "Valutazione inventario (Costo unitario medio)",
        "lblNetArrived": "Stock netto arrivato",
        "msgSelectLine": "Seleziona una riga OdA attiva per iniziare l'elaborazione"
      },
      "userList": {
        "title": "SICUREZZA UTENTI",
        "plcSearch": "Cerca Utente o Email...",
        "btnNewUser": "NUOVO UTENTE",
        "colUserId": "ID UTENTE",
        "colFullName": "NOME COMPLETO",
        "colRole": "RUOLO",
        "colSite": "SITO",
        "colStatus": "STATO",
        "colEmail": "EMAIL",
        "msgSyncing": "Sincronizzazione Sicurezza...",
        "lblNoRole": "NESSUN RUOLO",
        "lblAll": "TUTTI",
        "lblTotalUsers": "TOTALE UTENTI:",
        "lblPage": "PAGINA",
        "errLoadUsers": "Errore nel caricamento degli utenti"
      },
      "crafts": {
        "headers": {
          "craftList": "Catalogo Mestieri"
        },
        "actions": {
          "newCraft": "Nuovo Mestiere"
        },
        "tables": {
          "craftCode": "Codice Mestiere",
          "description": "Descrizione",
          "stdRate": "Tariffa Std/Ora",
          "site": "Sito",
          "org": "Organizzazione"
        },
        "messages": {
          "loadFailed": "Impossibile caricare i mestieri"
        },
        "headers": {
          "craftList": "Catalogo Mestieri"
        },
        "tabs": {
          "skills": "Competenze e Livelli"
        },
        "sections": {
          "costing": "Costi",
          "control": "Controllo"
        },
        "actions": {
          "newCraft": "Nuovo Mestiere",
          "addSkill": "Aggiungi livello di competenza"
        },
        "tables": {
          "craftCode": "Codice Mestiere",
          "description": "Descrizione",
          "stdRate": "Tariffa Std/Ora",
          "site": "Sito",
          "org": "Organizzazione"
        },
        "fields": {
          "stdHourlyRate": "Tariffa oraria standard",
          "skillLevel": "Livello di competenza (es. Esperto, Junior)",
          "hourlyRate": "Tariffa oraria"
        },
        "placeholders": {
          "enterLevel": "INSERISCI LIVELLO..."
        },
        "messages": {
          "loadFailed": "Impossibile caricare i mestieri",
          "autoCalc": "Calcolato automaticamente dalla somma delle competenze",
          "noSkills": "Nessuna competenza ancora definita"
        }
      },
      "persons": {
        "headers": {
          "directory": "Elenco Persone"
        },
        "actions": {
          "newPerson": "Nuova Persona"
        },
        "tables": {
          "personId": "ID Persona",
          "name": "Nome Visualizzato",
          "site": "Sito",
          "email": "Email",
          "phone": "Telefono"
        },
        "messages": {
          "loadFailed": "Impossibile caricare l'elenco delle persone"
        },
        "headers": {
          "directory": "Elenco Persone"
        },
        "tabs": {
          "profile": "Info Profilo",
          "contact": "Rubrica Contatti",
          "access": "Accesso al Sistema"
        },
        "sections": {
          "personalInfo": "Informazioni Personali",
          "statusControl": "Stato e Controllo",
          "contactsDirectory": "Contatti Correlati"
        },
        "tables": {
          "personId": "ID Persona",
          "name": "Nome Visualizzato",
          "site": "Sito",
          "email": "Email",
          "phone": "Telefono"
        },
        "fields": {
          "location": "Posizione",
          "firstName": "Nome",
          "lastName": "Cognome",
          "title": "Titolo di Lavoro",
          "department": "Dipartimento",
          "currentStatus": "Stato Attuale",
          "contactName": "Nome Contatto",
          "position": "Posizione",
          "email": "Indirizzo Email",
          "phone": "Telefono",
          "mobile": "Cellulare",
          "primary": "Primario",
          "address": "Indirizzo",
          "city": "Città",
          "country": "Paese",
        },
        "actions": {
          "newPerson": "Nuova Persona",
          "addContact": "Aggiungi Contatto"
        },
        "messages": {
          "loadFailed": "Impossibile caricare l'elenco delle persone",
          "noContacts": "Nessun contatto ancora aggiunto",
          "accessControlled": "L'accesso al sistema è controllato dal modulo Sicurezza Utenti"
        }
      },
      "jp": {
        "list": {
          "title": "Elenco Piani di Lavoro",
          "new_plan": "NUOVO PIANO",
          "filter_jp": "Filtra piani...",
          "search_desc": "Cerca descrizione...",
          "filter_site": "Sito...",
          "no_records": "Nessun piano di lavoro trovato",
          "fetch_error": "Impossibile caricare i piani di lavoro"
        },
        "fields": {
          "jpnum": "N. Piano",
          "description": "Descrizione",
          "status": "Stato",
          "revision": "Revisione",
          "site": "Sito"
        },
        "details": {
          "load_error": "Impossibile caricare il Piano di Lavoro",
          "delete_warn": "Stai per eliminare il piano di lavoro {{jpnum}}. Questa azione non può essere annullata!"
        },
        "tabs": {
          "job_plan": "Piano di Lavoro",
          "plans": "Piani",
          "assets": "Asset"
        },
        "subtabs": {
          "tasks": "Attività",
          "labor": "Manodopera",
          "materials": "Materiali",
          "tools": "Strumenti"
        },
        "sections": {
          "details": "Dettagli Piano",
          "responsibility": "Responsabilità",
          "woassets": "Asset di Lavoro e Piani di Sicurezza"
        },
        "fields": {
          "jpnum": "N. Piano",
          "status": "Stato",
          "description": "Descrizione",
          "template_type": "Tipo Modello",
          "duration": "Durata (Ore)",
          "supervisor": "Supervisore",
          "class": "Struttura Classe",
          "safety_plan": "Piano di Sicurezza",
          "revision": "Revisione"
        },
        "table": {
          "seq": "Seq",
          "duration": "Durata",
          "craft": "Mestiere",
          "labor": "Lavoratore",
          "qty": "Qtà",
          "hours": "Ore",
          "rate": "Tariffa",
          "item": "Articolo",
          "unitcost": "Costo Unitario",
          "tool": "Strumento"
        }
      },
      "meters": {
        "list": {
          "title": "Definizioni Contatori",
          "search": "Filtra per Num o Nome...",
          "new_meter": "NUOVO CONTATORE",
          "no_records": "Nessun contatore trovato"
        },
        "fields": {
          "meter_num": "N. Contatore",
          "meter_name": "Nome Contatore",
          "type": "Tipo",
          "uom": "UdM",
          "active": "Attivo?",
          "remarks": "Note",
          "last_reading": "ULTIMA LETTURA",
          "last_date": "DATA ULTIMA LETTURA",
          "rollovers": "AZZERAMENTI TOTALI"
        },
        "tabs": {
          "meter": "Dettagli Contatore",
          "where_used": "Dove Utilizzato"
        },
        "sections": {
          "info": "Informazioni Contatore",
          "additional": "Dettagli Aggiuntivi",
          "stats": "Statistiche"
        },
        "where_used": {
          "linked_assets": "Asset Collegati",
          "linked_locations": "Posizioni Collegate",
          "linked_items": "Articoli Collegati",
          "searching": "🔍 Ricerca nel sistema...",
          "no_assoc": "Nessuna associazione trovata.",
          "asset_num": "N. Asset",
          "site": "Sito",
          "status": "Stato",
          "location": "Posizione",
          "item_num": "N. Articolo",
          "category": "Categoria"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Categorie Asset",
          "search": "Cerca Categorie...",
          "new_category": "NUOVA CATEGORIA",
          "no_records": "Nessuna categoria trovata"
        },
        "fields": {
          "category_id": "Codice Categoria",
          "description": "Descrizione",
          "dep_method": "Metodo Ammort.",
          "life": "Vita (Anni)"
        }
      },
      "export": {
        "loading": "Estrazione dati in corso...",
        "success": "Esportazione completata!",
        "error": "Errore durante l'esportazione dei dati."
      },
      "labor": {
        "list": {
          "title": "Registro Manodopera",
          "new": "NUOVO LAVORATORE",
          "total": "Manodopera Totale",
          "unique_crafts": "Mestieri della Pagina",
          "no_records": "Nessun lavoratore trovato."
        },
        "tabs": {
          "main": "PRINCIPALE",
          "person": "PERSONA",
          "crafts": "MESTIERI",
          "log": "LOG"
        },
        "sections": {
          "basic": "Informazioni di Base",
          "status": "Stato & Organizzazione",
          "additional_crafts": "Mestieri Aggiuntivi & Competenze"
        },
        "fields": {
          "personid": "Rif. Persona",
          "primary_craft": "Mestiere Principale",
          "actual_rate": "Tariffa Reale (Oraria)",
          "skill": "Livello Competenze",
          "rate": "Tariffa Oraria",
          "primary": "Primario?",
          "laborcode": "Cod. Lavoratore",
          "fullname": "Nome Completo",
          "craft": "Mestiere"
        },
        "actions": {
          "add_craft": "AGGIUNGI MESTIERE"
        },
        "lookup": {
          "person": "Seleziona Persona",
          "craft": "Seleziona Mestiere",
          "skill": "Seleziona Competenza"
        },
        "messages": {
          "no_crafts": "Nessuna associazione di mestiere trovata"
        },
        "details": {
          "delete_warn": "Non sarai in grado di recuperare questo record!"
        }
      },
      "sr": {
        "list": {
          "title": "Tracciamento Richieste di Servizio",
          "new": "NUOVA RICHIESTA"
        },
        "fields": {
          "srnum": "Numero RS",
          "description": "Descrizione",
          "reportedby": "Segnalato da",
          "reportdate": "Data Segnalazione",
          "priority": "Priorità"
        },
        "messages": {
          "no_records": "Nessuna richiesta di servizio trovata"
        },
        "tabs": {
          "main": "Richiesta di Servizio",
          "related": "Record Correlati"
        },
        "sections": {
          "requester": "Richiedente & Contatto",
          "problem": "Specifiche del Problema",
          "logistics": "Logistica & Priorità"
        },
        "fields": {
          "phone": "Telefono",
          "email": "E-mail",
          "asset": "Asset",
          "location": "Posizione",
          "long_desc": "Descrizione Dettagliata del Problema",
          "priority_1": "1 - EMERGENZA (IMMEDIATA)",
          "priority_2": "2 - ALTA (STESSO GIORNO)",
          "priority_3": "3 - MEDIA (72 ORE)",
          "priority_4": "4 - BASSA (PIANIFICATA)"
        },
        "lookup": {
          "person": "Seleziona Persona",
          "asset": "Seleziona Asset",
          "location": "Seleziona Posizione"
        },
        "details": {
          "delete_new_only": "Solo le NUOVE richieste possono essere eliminate",
          "delete_warn": "Questo eliminerà definitivamente questa Richiesta di Servizio.",
          "wf_tip": "Flusso di lavoro automatico: Dopo il salvataggio, usa il pulsante 'Invia Flusso di Lavoro' per la revisione tecnica.",
          "wo_tip": "Suggerimento: Puoi generare un Ordine di Lavoro da questa RS tramite le azioni del flusso di lavoro o lo script automatico."
        },
        "related": {
          "title": "Ordini di Lavoro collegati per la RS:",
          "wonum": "Numero OL",
          "worktype": "Tipo di Lavoro",
          "no_wo": "Nessun Ordine di Lavoro è stato ancora creato per questa RS.",
          "go_to_wo": "Vai all'Ordine di Lavoro"
        }
      },
      "invusage": {
        "list": {
          "title": "Storico Utilizzo Inventario",
          "new": "Nuova Transazione"
        },
        "types": {
          "all": "TUTTI",
          "issue": "EMISSIONE",
          "transfer": "TRASFERIMENTO",
          "return": "RESO"
        },
        "tabs": {
          "lines": "RIGHE UTILIZZO",
          "log": "LOG TRANSAZIONI"
        },
        "details": {
          "summary": "Riepilogo Righe",
          "transfer_dest": "Dettagli Destinazione Trasferimento",
          "financial": "Addebito Finanziario e Riferimento"
        },
        "actions": {
          "add_item": "Aggiungi Articolo",
          "add_part": "Aggiungi Parte",
          "select_mr": "SELEZIONA R.M."
        },
        "fields": {
          "stock_item": "Articolo di Magazzino",
          "issueunit": "Unità Uscita",
          "qty": "Quantità",
          "unitcost": "Costo Unitario",
          "linecost": "Valore Totale Riga",
          "target_bin": "Cestino Dest. in",
          "target_loc": "Posizione Dest.",
          "assetnum": "Numero Asset",
          "wonum": "Riferimento Ordine Lavoro",
          "glaccount": "Conto CoGe Addebito",
          "usagenum": "ID Utilizzo",
          "type": "Tipo",
          "fromstore": "Dal Magazzino",
          "lines": "Righe",
          "enterby": "Inserito da"
        },
        "placeholders": {
          "select_item": "SELEZIONA ARTICOLO...",
          "dest_bin": "INSERISCI CESTINO DEST...",
          "choose_loc": "SCEGLI POSIZIONE",
          "select_asset": "SELEZIONA ASSET",
          "charge_wo": "ADDEBITA SU O.L."
        },
        "lookup": {
          "store": "Magazzini",
          "dest_store": "Magazzini Destinazione",
          "mr": "Seleziona R.M. Approvata",
          "item": "Ricerca Magazzino",
          "loc": "Posizioni",
          "asset": "Registro Asset",
          "wo": "Ordini di Lavoro"
        },
        "messages": {
          "req_fromstore": "Selezionare prima un Magazzino!",
          "mr_loaded": "Articoli caricati dalla R.M.:",
          "mr_fail": "Impossibile caricare gli articoli R.M.",
          "insufficient_title": "Scorta Insufficiente!",
          "available": "Disponibile",
          "create_pr": "Creare R.d.A.?",
          "btn_create_pr": "Crea R.d.A.",
          "processing": "Elaborazione rettifiche inventario...",
          "inventory_updated": "Livelli inventario aggiornati con successo",
          "cant_delete_comp": "Impossibile eliminare una transazione completata!",
          "delete_warn": "Questo eliminerà definitivamente la bozza.",
          "req_fields": "Descrizione e Magazzino sono obbligatori!",
          "req_transfer": "Magazzino Dest. è obbligatorio per i trasferimenti!",
          "locked_title": "Record Bloccato",
          "locked_text": "Questa transazione è COMPLETATA e non può essere modificata.",
          "cant_save_comp": "Impossibile salvare modifiche su record completato",
          "balance_move": "Nota: Il saldo verrà spostato in",
          "upon_comp": "al completamento."
        }
      },
      "downtime": {
        "title": "Segnala Fermo Macchina",
        "subtitle": "Sistema Gestione Asset",
        "asset": "Asset",
        "status": "Registrazione Offline",
        "start": "Data e Ora Inizio",
        "end": "Data Fine (Opzionale)",
        "type": "Tipo di Fermo",
        "types": {
          "unplanned": "NON PIANIFICATO (Guasto)",
          "planned": "PIANIFICATO (Manutenzione)"
        },
        "duration": "Durata Calcolata",
        "hours": "ORE",
        "prod_impact": "Fermo Operativo (Impatto Produzione)",
        "btn_commit": "Conferma Modifiche",
        "messages": {
          "recording": "Registrazione fermo...",
          "success": "Fermo macchina registrato con successo",
          "validation_error": "Errore formato: Controlla tutti i campi",
          "server_error": "Errore Server: 500"
        },
        "history": {
          "title": "Storico Fermo Asset",
          "subtitle": "Tracciamento Prestazioni per Asset",
          "no_records": "Nessun evento di fermo registrato per questo asset.",
          "duration_hrs": "Durata (Ore)",
          "type_reason": "Tipo/Motivo",
          "impact": "Impatto",
          "reported_by": "Segnalato da",
          "still_down": "ANCORA FERMO",
          "prod_loss": "Perdita Prod.",
          "technical": "Tecnico",
          "active_down": "Fermo Attivo",
          "resolved": "Risolto"
        }
      },
      "incidents": {
        "list": {
          "title": "Registro Incidenti",
          "new": "NUOVO INCIDENTE"
        },
        "fields": {
          "ticket_id": "ID Ticket",
          "priority": "Priorità",
          "reported_by": "Segnalato da"
        },
        "details": {
          "ticket": "Ticket Incidente",
          "general": "Descrizione Generale",
          "detailed": "Dettagli Dettagliati",
          "context": "Contesto e Stato",
          "linked_asset": "Asset Collegato",
          "workorder": "Ordine di Lavoro",
          "delete_warn": "Stai per eliminare definitivamente l'incidente {{ticket}}. Questa azione non può essere annullata!"
        },
        "lookup": {
          "asset": "Seleziona Asset Collegato",
          "loc": "Seleziona Posizione"
        }
      },
      "tools": {
        "list": {
          "title": "Registro Attrezzi",
          "new": "NUOVO ATTREZZO"
        },
        "fields": {
          "toolnum": "Numero Attrezzo",
          "type": "Tipo",
          "is_stocked": "In Stock?"
        },
        "tabs": {
          "tool": "ATTREZZO",
          "stores": "MAGAZZINI",
          "vendors": "FORNITORI",
          "specs": "SPECIFICHE",
          "quals": "QUALIFICHE"
        },
        "sections": {
          "config": "Configurazione Attrezzo",
          "inventory": "Inventario e Giacenze",
          "vendors": "STORICO ACQUISTI E FORNITORI",
          "quals": "Qualifiche Richieste"
        },
        "fields": {
          "toolnum": "Numero Attrezzo",
          "type": "Tipo Attrezzo",
          "issueunit": "Unità Uscita",
          "is_stocked": "Attrezzo a magazzino?",
          "rotating": "Articolo Rotante?",
          "calib_req": "Calibrazione Richiesta?",
          "mfg": "Produttore",
          "model": "Numero Modello",
          "class": "Classificazione",
          "active_vendors": "FORNITORI ATTIVI"
        },
        "actions": {
          "add_store": "Aggiungi al Magazzino",
          "add_qual": "Aggiungi Qualifica"
        },
        "tables": {
          "storeroom": "Magazzino",
          "balance": "Saldo",
          "attr": "Attributo",
          "value": "Valore",
          "uom": "UOM",
          "qual": "Qualifica",
          "vendor_id": "Fornitore (Num Comp)",
          "vendor_name": "Nome Fornitore",
          "unitcost": "Costo Unitario",
          "qty": "Qtà",
          "po": "OdA di Riferimento"
        },
        "placeholders": {
          "toolid": "INSERISCI ID ATTREZZO...",
          "reg_supplier": "FORNITORE REGISTRATO",
          "adj": "RETTIFICA STOCK"
        },
        "lookup": {
          "type": "Tipo Attrezzo",
          "unit": "Unità Uscita",
          "attr": "Attributi"
        },
        "messages": {
          "req_fields": "Il numero dell'attrezzo e la descrizione sono obbligatori!",
          "delete_warn": "Non potrai annullare questa operazione!",
          "class_loaded": "Classificazione e attributi caricati",
          "stocked_note": "Nota: Gli attrezzi a magazzino sono gestiti tramite i magazzini e richiedono un record di inventario per tracciare i saldi.",
          "no_stock": "Nessun articolo in magazzino"
        }
      },
      "inventory": {
        "list": {
          "title": "Registro Inventario"
        },
        "fields": {
          "itemnum": "N. Articolo",
          "location": "Magazzino",
          "balance": "Giacenza",
          "avgcost": "Costo Medio"
        },
        "details": {
          "profile": "Profilo Inventario",
          "reorder_logic": "Logica di Riordino",
          "reorder_pt": "Punto di Riordino",
          "eoq": "Quantità Economica d'Ordine",
          "critical_lvl": "Livello Critico",
          "critical_desc": "Genera automaticamente RdA quando il saldo raggiunge il punto di riordino.",
          "current_stock": "Livello Stock Attuale",
          "avail_qty": "Quantità Disponibile",
          "reserved_qty": "Qtà Riservata",
          "held_wo": "Trattenuta per Ordini di Lavoro",
          "avg_cost": "Costo Unitario Medio",
          "avg_cost_desc": "Media ponderata di tutti gli incassi",
          "total_val": "Valore Totale Stock",
          "total_val_desc": "Saldo Attuale × Costo Medio",
          "last_cost": "Costo Ultimo Ricevimento",
          "last_cost_desc": "Costo dell'ultimo OdA",
          "val_method": "Metodo di Valutazione Inventario",
          "avg_method": "COSTO MEDIO",
          "val_desc1": "Questo articolo utilizza il metodo del",
          "val_desc2": ". Il costo unitario viene ricalcolato automaticamente ad ogni ricevimento di ordine per riflettere le fluttuazioni di mercato."
        },
        "tabs": {
          "balances": "Saldi",
          "trans": "Storico Transazioni",
          "costs": "Costi"
        },
        "actions": {
          "adjustment": "Rettifica Stock"
        },
        "tables": {
          "qty": "Quantità",
          "actual_cost": "Costo Reale",
          "reference": "Riferimento"
        },
        "messages": {
          "no_trans": "Nessuno Storico Transazioni Trovato"
        },
        "trans_types": {
          "receipt": "RICEVIMENTO",
          "issue": "USCITA",
          "transfer": "TRASFERIMENTO",
          "adjustment": "RETTIFICA"
        }
      },
      "storerooms": {
        "list": {
          "title": "Magazzini",
          "new": "NUOVO MAGAZZINO"
        },
        "fields": {
          "location": "Magazzino",
          "isdefault": "Predefinito?",
          "inventory": "Inventario",
        },
        "details": {
          "profile": "Magazzino",
          "record": "Record Magazzino",
          "gen_settings": "Impostazioni Generali",
          "filtered_by": "Filtrato per {{org}}",
          "select_org_first": "Seleziona prima l'Org",
          "gl_accounts": "Conti GL",
          "inv_control": "Controllo Inventario",
          "inv_control_desc": "Tutte le uscite e i ricevimenti di materiale per questo magazzino saranno bilanciati su questi conti.",
          "items_stocked": "Articoli in Stock"
        },
        "tabs": {
          "main": "PRINCIPALE",
          "inventory": "INVENTARIO"
        },
        "fields": {
          "location": "ID Posizione",
          "isdefault": "Magazzino Predefinito?",
          "useinpo": "Usa negli OdA?",
          "invowner": "Proprietario Inventario",
          "controlacc": "Conto di Controllo",
          "shrinkacc": "Conto Ammanco",
          "glaccount": "Conto GL Predefinito",
          "default": "PREDEFINITO"
        },
        "lookup": {
          "person": "Seleziona Persona"
        },
        "tables": {
          "itemnum": "Num Articolo",
          "uom": "UOM",
          "curbal": "Saldo Attuale",
          "reserved": "Qtà Riservata"
        },
        "messages": {
          "req_fields": "L'ID della posizione è obbligatorio!",
          "req_org_site": "Org e Sito sono obbligatori!",
          "delete_warn": "Stai per eliminare il magazzino {{store}}. Questa azione non può essere annullata!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Libreria Codici di Guasto",
          "new": "Nuova Classe di Guasto"
        },
        "details": {
          "profile": "Classe di Guasto"
        },
        "fields": {
          "class": "Classe di Guasto",
          "code": "Codice",
          "desc_tech": "Descrizione / Nome Tecnico"
        },
        "tables": {
          "problems": "Problemi (Il Problema)",
          "causes": "Cause (Causa Radice)",
          "remedies": "Rimedi (L'Azione)"
        },
        "placeholders": {
          "class": "ES. PUMP-FAIL",
          "desc_tech": "Fornisci una descrizione dettagliata di questa gerarchia di guasti...",
          "code": "Inserisci Codice...",
          "desc": "Descrizione Tecnica..."
        },
        "messages": {
          "req_class": "Il codice della classe di guasto è obbligatorio!",
          "delete_warn": "Stai per eliminare la classe di guasto {{class}}. Questa azione non può essere annullata!"
        }
      },
      "scheduler": {
        "title": "Distribuzione e Pianificazione",
        "ai_optimize": "OTTIMIZZAZIONE AUTO IA",
        "publish": "PUBBLICA PIANIFICAZIONE",
        "kpi_scheduled": "Lavori Pianificati",
        "kpi_issues": "Problemi di Pianificazione",
        "kpi_utilization": "Risorse Totali",
        "kpi_emergencies": "Emergenze",
        "no_data": "Nessun ordine di lavoro pianificato.",
        "no_resources": "Nessun dato sulla capacità delle risorse.",
        "fetch_error": "Impossibile caricare i dati di pianificazione.",
        "optimizing": "L'IA sta bilanciando il carico delle risorse...",
        "optimize_fail": "Ottimizzazione IA fallita."
      },
      "features": {
        "title": "Catalogo Funzionalità Lineari",
        "feature_id": "Codice Funzionalità",
        "description": "Descrizione",
        "type": "Tipo Funzionalità",
        "point": "Punto (es. Valvola)",
        "linear": "Lineare (es. Materiale)",
        "error_in_use": "Impossibile eliminare: la funzionalità è in uso su una tubazione."
      },
      "audit": {
        "title": "Esploratore Audit Trail",
        "history_for": "Cronologia per",
        "retrieving": "Recupero dei record di audit...",
        "no_records": "Nessun audit trail trovato per questo record"
      },

    }
  },
  // 🇪🇸 Español
  es: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "Excelencia de Activos", version: "Teknova v1.0.4" },
      search: { placeholder: "Buscar módulos..." },
      menu: {
        settings: "Configuración", organization: "Organización", domains: "Dominios", field_config: "Config de Campos", classifications: "Clasificaciones", importer: "Importador Universal", cobie: "Gestor COBie", workflow: "Motor de Flujo", scripts: "Scripts de Acción",
        analytics: "Analítica", dashboards: "Paneles BI", report_designer: "Diseñador de Informes", report_wizard: "Asistente de Informes",
        assets: "Activos", asset_registry: "Registro de Activos", locations: "Ubicaciones", categories: "Categorías de Activos", meters: "Medidores", failure_codes: "Códigos de Falla",
        work_management: "Gestión de Trabajo", wo_tracking: "Seguimiento de Órdenes", labor_reporting: "Planificador",
        resources: "Recursos", crafts: "Oficios", labor: "Mano de Obra", person: "Persona",
        service_desk: "Mesa de Servicio", service_requests: "Solicitudes de Servicio", incidents: "Registro de Incidentes",
        procurement: "Adquisiciones", po: "Órdenes de Compra", pr: "Solicitudes de Compra", rfq: "Cotizaciones", receiving: "Recepción", vendors: "Proveedores",
        contracts: "Contratos", contracts_master: "Maestro de Contratos", sla: "SLA",
        inventory: "Inventario", item_master: "Maestro de Artículos", tools: "Herramientas", balances: "Saldos de Inventario", transfers: "Transferencias", storerooms: "Almacenes",
        planning: "Planificación", pm_schedules: "Programas PM", safety_plans: "Planes de Seguridad", hazards: "Peligros", precautions: "Precauciones", tagouts: "Bloqueos", job_plans: "Planes de Trabajo",
        security: "Seguridad", user_list: "Lista de Usuarios", groups: "Grupos de Seguridad", "recent": "Visitado Recientemente"
      },
      user_settings: { title: "Ajustes de usuario", default_info: "Información predeterminada", personal_info: "Información personal", password_info: "Información de contraseña", sign_out: "Cerrar sesión", system_info: "Información de Sistema" },
      notifications: { title: "Tareas recibidas", new_alerts: "Nuevo", empty: "Tu bandeja está limpia", view_all: "Ver todas las actividades" },
      sidebar: { queries: "Consultas Disponibles", all_assets: "Todos los Activos", operating_assets: "Activos Operativos", critical_assets: "Activos Críticos", my_bookmarks: "Marcadores", common_actions: "Acciones Comunes", new: "Nuevo", move_assets: "Mover Activos", print_barcodes: "Imprimir Barcodes", create_report: "Crear Reporte", wo_queries: "Consultas OT", all_wo: "Todas las OT", waiting_approval: "Esperando Aprobación", wip: "En Progreso", completed_today: "Completado Hoy", bulk_approve: "Aprobar en Lote", record_actions: "Acciones de Registro", save: "Guardar", delete: "Eliminar", workflow_status: "Flujo / Estado", change_status: "Cambiar Estado", view_history: "Ver Historial", item_ops: "Operaciones de Artículo", add_to_storeroom: "Agregar a Almacén", inv_ops: "Operaciones Stock", reorder: "Reordenar", tax_ops: "Operaciones Impuestos", tax_category: "Categoría Impuestos", create_po: "Crear OC", settings_group: "Ajustes", system_settings: "Ajustes Sistema", email_settings: "Ajustes Email", asset_ops: "Operaciones Activo", meter_readings: "Lecturas Medidor", hist_readings: "Lecturas Históricas", report_downtime: "Reportar Parada", downtime_hist: "Historial Paradas", move_mod_asset: "Mover/Modificar", asset_move_hist: "Historial Movimientos", create_related: "Crear Relacionado", create_incident: "Crear Incidente", view_inc_hist: "Historial Incidentes", create_wo: "Crear OT", sr: "Solicitud Servicio", apply_sla: "Aplicar SLA", approve_wo: "Aprobar OT", start_work: "Iniciar Trabajo", complete_work: "Completar Trabajo", close_wo: "Cerrar OT", analytics: "Analítica", wf_history: "Historial Flujo", history_log: "Log", wo_costs: "Costos OT", purchase_info: "Info Compra", all_records: "Todos Registros", find_nav: "Buscar Item", more_actions: "Más Acciones", settings: "Ajustes", export_data: "Exportar", audit_log: "Audit Log", share_app: "Compartir" },
      apps: {
        ORGANIZATION: "Organizaciones", ASSET: "Activos", LOCATION: "Ubicaciones", WORKORDER: "Órdenes de Trabajo", INVENTORY: "Inventario", CLASSIFICATION: "Clasificaciones", VENDOR: "Proveedores", METER: "Medidores", DOMAINS: "Dominios", CRAFTS: "Oficios", STOREROOMS: "Almacenes", ITEMS: "Maestro Artículos", INVENTORYUSAGE: "Uso Inventario", MR: "Solicitud Mat.", PR: "Solicitud Compra", PO: "Pedidos Compra", LABOR: "Mano de Obra", PM: "Programas PM", SAFETY: "Planes Seguridad", HAZARD: "Peligros", TAGOUT: "Bloqueos", PRECUTION: "Precauciones", SR: "Solicitud Servicio", INCIDENT: "Incidentes", ASSET_CATEGORIES: "Categorías Activos", FAILURECLASS: "Fallas", RFQ: "Cotizaciones", CONTRACT: "Contratos", SLA: "Acuerdo de Nivel de Servicio", FAILURE_CODES: "Códigos de error",
        "VENDORS": "Proveedores", "TAGOUTS": "Bloqueos", "PRECAUTIONS": "Precauciones", "JOBPLAN": "Planes de Trabajo", "ROLE": "Roles", "TOOLS": "Herramientas", "USER": "Usuarios"
      },
      dashboard: { tab_bi: "Plantilla KPI", tab_inbox: "Bandeja de Workflow", advanced_analytics: "Analítica Avanzada", workflow_center: "Centro de Ejecución", active_tasks: "Tareas Activas", history_tasks: "Historial", no_data: "No hay datos", take_action: "Actuar", previous: "Anterior", next: "Siguiente", showing: "Mostrando", of: "de", actual: "Real", target: "Objetivo", kpi_graph: "Gráfico KPI" },
      username: "ID de Usuario",
      password: "Contraseña",
      login_btn: "Iniciar Sesión",
      forgot_pwd: "¿Olvidó su contraseña?",
      login: {
        id_placeholder: "Ingrese su ID",
        error_msg: "ID o contraseña inválidos",
        server_error: "Error de conexión al servidor",
        just_smart: "Simplemente Inteligente"
      },
      organizations: { title: "Organizaciones", org_id: "Organización", description: "Descripción", active: "¿Activo?" },
      org_detail: { org_label: "Organización", tabs: { organization: "Organización", sites: "Sitios", map: "Mapa" }, fields: { currency1: "Moneda Base 1", currency2: "Moneda Base 2", item_set: "Conjunto Artículos", company_set: "Conjunto Empresas", item_status: "Estado Inicial", active: "¿Activo?" }, descs: { currency1: "Moneda Primaria", currency2: "Moneda Secundaria", item_set: "CONJUNTO ART", company_set: "CONJUNTO EMP" }, lookups: { currency: "Moneda", item_set: "Conjunto Art", company_set: "Conjunto Emp", status: "Estado", governorate: "Provincia" }, sites: { management: "Gestión Sitios", new_row: "Nueva Fila", of: "de", site_id: "ID Sitio", description: "Descripción", active: "¿Activo?", action: "Acción", site_details: "Detalles Sitio", state: "Estado / Provincia", contact: "Contacto Primario", fin_info: "Información Financiera", yearly_budget: "Presupuesto Anual", monthly_budget: "Presupuesto Mensual", utilization: "Utilización", fin_health: "Salud financiera estable." }, toasts: { id_required: "ID requerido!", saving: "Guardando...", success: "¡Guardado con éxito!", fail: "Error al guardar" } },
      domains: { title: "Dominios", find_placeholder: "Buscar Dominio...", new_domain: "Nuevo Dominio", domain_id: "Dominio", description: "Descripción", type: "Tipo", values: "Valores" ,
        save_btn: "Guardar", desc_placeholder: "Descripción del dominio", synonym_values: "Valores Sinónimos", new_row: "Nueva fila", internal_val: "Valor interno", external_desc: "Descripción externa", default: "¿Predeterminado?", action: "Acción", no_values: "No hay valores definidos.", toasts: { loading: "Cargando...", load_fail: "Error al cargar", id_required: "ID requerido!", saving: "Guardando...", save_success: "¡Guardado!", save_fail: "Error" } },
      classifications: { parent: "Clasificación Superior", order: "Orden", hierarchy: "Estructura", hierarchy: "Ruta de jerarquía", parent: "Clasificación superior", gen_desc: "¿Generar descripción?", use_with: "Usar con objetos", attributes: "Atributos", attr_id: "ID de atributo", section: "Sección", uom: "unidad de medida" },
      bim: { title: "Integrador BIM Pro", subtitle: "Mapeo avanzado de Revit a COBie", waiting_translation: "Esperando traducción del modelo...", tabs: { "3d": "Visor 3D", data: "Tabla de datos" }, preview_table_title: "Vista previa de componentes COBie", controls: { destination: "Destino", select_site: "Seleccionar sitio", uploads: "Carga de archivos", select_cobie: "Seleccionar COBie", upload_revit: "Cargar Revit", models_ready: "Modelos listos", preview_list: "Modelos de vista previa", finalizing: "Finalizando...", commit: "Confirmar integración BIM" }, table: { asset_name: "Nombre del activo", location: "Espacio / Ubicación" } },
      importer: { title: "Cargador de datos universal", target_table: "Tabla de destino", download_template: "Descargar plantilla", upload_instruction: "Seleccionar archivo Excel", field_mapping: "Mapeo de campos", excel: "Excel", ignore: "Ignorar", preview_title: "Vista previa", execute_btn: "EJECUTAR IMPORTACIÓN" },
      workflow: { title: "Motor de Flujo", subtitle: "Centro de automatización", export_btn: "Exportar CSV", new_process: "Nuevo Proceso", loading: "Cargando...", unnamed: "Proceso sin nombre", linked_to: "Vinculado a", create_path: "Crear nuevo camino",
                designer_title: "Diseñador de Lógica (Loopback Activado)", publish_btn: "PUBLICAR", loading_designer: "Reconstruyendo ruta lógica...", logic_palette: "Paleta Lógica", config_title: "Configuración", node_label: "Etiqueta", assign_roles: "Asignar roles", post_action: "Scripts post-acción", select_lookup: "SELECCIONAR DE BÚSQUEDA", script_hint: "* Múltiples scripts separados por comas.", status_auto: "Auto-acción de estado", trigger: "Disparador", target_status: "Estado objetivo", cond_expr: "Expresión condicional (Python)", escalation: "Escalación (Horas)", select_node: "Seleccionar nodo para editar", options: {no_change: "SIN CAMBIO DE ESTADO", change_status: "CAMBIAR ESTADO", select_status: "SELECCIONAR ESTADO"},
        lookups: { select_roles: "Buscar roles", select_scripts: "Buscar scripts"},
        swal: { publish_title: "¿Publicar flujo de trabajo?", publish_text: "Sincronizará los pasos con la base de datos.", confirm_publish: "Sí, publicar ahora", delete_title: "¿Purgar lógica?", delete_text: "¿Está seguro de eliminar", confirm_delete: "Sí, eliminar todo"},
        toasts: { id_required: "Nombre del proceso requerido", saving: "Sincronizando...", save_success: "¡Flujo sincronizado! 🚀", save_fail: "Sincronización fallida", purging: "Eliminando...", delete_success: "Flujo eliminado permanentemente", delete_fail: "Fallo al eliminar", fetch_fail: "Fallo al cargar" }
      },
      field_config: { title: "Mapeo de campos de metadatos", table_name: "NOMBRE DE TABLA", field_name: "NOMBRE DE CAMPO", current_mappings: "MAPEOS ACTUALES PARA", field: "Campo", linked_domain: "Dominio vinculado" },
      scripts: {
        title: "SCRIPTS DE ACCIÓN",
        subtitle: "Gestionar plantillas de automatización y lógica",
        new_btn: "CREAR NUEVO SCRIPT",
        search_placeholder: "Buscar por nombre u objeto...",
        table: {
          name: "Nombre del script",
          object: "Objeto de destino",
          created: "Creado el"
        },
        toasts: {
          fetch_fail: "Error al cargar los scripts"
        },
        
      },
      studio: { schema_explorer: "EXPLORADOR DE ESQUEMA", target_context: "Contexto del objeto", name_placeholder: "Nombre del script...", engine_info: "MOTOR: PYTHON 3.10", console_title: "Consola de ejecución", clear_console: "Limpiar consola", field_from: "Campo de", access_col: "Acceso a columna: ", db_model: "Modelo de datos", btns: { compile: "COMPILAR", compiling: "COMPILANDO...", save_deploy: "GUARDAR" }, toasts: { preserved: "Script guardado!", compiled: "Análisis exitoso!" }, console: { init: "Studio inicializado...", schema_sync: "Esquema sincronizado.", schema_fail: "Esquema fallido.", saved_prefix: "Script guardado", error_op: "Error al guardar.", compiling: "Analizando...", build_finish: "Construcción finalizada.", syntax_error: "Error de sintaxis.", build_fail: "Fallo de construcción", analyzing: "Análisis sintáctico..." } },
      reports: { title: "Plantillas de informes", new_btn: "Crear nuevo informe", search_placeholder: "Buscar...", table: { name: "Nombre del informe", ref_obj: "Objeto de referencia", updated: "Actualizado" }, 
          toasts: { load_fail: "Fallo al cargar", clone_success: "Informe clonado", save_success: "¡Plantilla guardada! 🚀", save_fail: "Error al guardar" },
          designer: {
                title: "DISEÑADOR DE REPORTES", live_preview: "Vista previa", publish: "Publicar plantilla", model_select: "Selección de modelo", data_explorer: "Explorador de datos", components: "Componentes",
                page_break: "Salto de página", is_summary: "¿Reporte resumido?", user_params: "Parámetros de usuario", add_param: "Añadir campo", master_info: "Información maestra", relational_data: "Datos relacionados",
                detail_tables: "Tablas de detalles", tabs: { body: "Contenido", header: "Encabezado", footer: "Pie de página", css: "CSS Global" },
                fields: { wonum: "Número de OT", assetnum: "Número del activo", desc: "Descripción", status: "Estado", asset: "Nombre del activo", location: "ID Ubicación", tasks_table: "Tabla de tareas", mat_table: "Materiales previstos", asset_basic: "Info básica activo", inv_basic: "Info básica inventario", vend_basic: "Info básica proveedor" }
              },
        }, 
      assets: { 
        map: { "gps_location": "Ubicación Geográfica (GPS)", "gps_coordinates": "Coordenadas GPS"},
        list: { system_title: "Gestión de Activos", new_asset: "Nuevo activo", all_orgs: "Todas las org", all_sites: "Todos los sitios", db_total: "Total:", display_page: "Página:", navigate_hint: "Utilice las flechas para navegar.", col_site: "Sitio", col_org: "Org"}, 
        modal: { migration_title: "Migración masiva", caution_prefix: "Precaución: va a mover", caution_suffix: "activos.", dest_label: "Nueva ubicación", placeholder: "SELECCIONAR...", abort: "Abortar", execute: "Ejecutar" },
        headers: { asset_num: "Número de activo", desc: "Descripción", status: "Estado", downtime: "Tiempo de inactividad total", site: "Sitio" },
        tabs: { details: "Detalles del activo", spare_parts: "Repuestos", safety: "Seguridad", meters: "Medidores", specs: "Especificaciones", history: "Historial de trabajo", map: "Mapa", bim: "Vista 3D", ai: "Análisis IA", eval: "Evaluación", attachments: "Adjuntos" },
        sections: { "linear_details": "Detalles de referencia lineal", general: "Información general", details: "Detalles", finance: "Dirección y finanzas", image: "Imagen del activo", audit: "Info de auditoría", bim_info: "Info BIM", reliability: "Análisis de fiabilidad" },
        fields: { "is_linear": "¿Es activo lineal?", "start_measure": "Medida inicial", "end_measure": "Medida final", "measure_unit": "Unidad de medida", "direction": "Dirección de flujo", type: "Tipo de activo", location: "Ubicación", parent: "Activo padre", category: "Categoría de activo", is_running: "¿Activo en marcha?", serial: "Número de serie", item: "Artículo rotativo", failure: "Clase de falla", safety_plan: "Plan de seguridad", vendor: "Proveedor", price: "Precio de compra", replace: "Costo de reemplazo", priority: "Prioridad", ytd_cost: "Costo acumulado anual" },
        meters: { seq: "Secuencia", name: "Medidor", reading: "Última lectura", date: "Fecha de lectura", inspector: "Inspector", remarks: "Observaciones" },
        ai: { title: "Inteligencia de activos", run: "Ejecutar diagnóstico", summary: "Resumen técnico", recommend: "Recomendaciones", telemetry: "Analizando telemetría..." },
        spare_fields: { item: "Artículo rotativo", qty: "Cantidad", issued: "Cant. emitida", remarks: "Observaciones", item_details: "Detalles del artículo" },
        safety: { plan_card: "Planes de seguridad asociados", active_plan: "Plan de seguridad activo", no_plan: "SIN PLAN VINCULADO", link_plan: "Vincular plan", change_plan: "Cambiar plan", hazard_title: "Riesgos específicos del activo", hazard_num: "Riesgo", hazard_type: "Tipo / Prioridad", no_hazards: "No hay riesgos vinculados.", add_hazard: "Añadir riesgo", loto_title: "Bloqueo / Etiquetado (LOTO)", tag_id: "ID de etiquetado", req_state: "Estado requerido", no_loto: "No hay puntos de aislamiento definidos.", add_loto: "Añadir punto de aislamiento", applying_proto: "Aplicando protocolo..." },
        meters: { title: "Medidores asociados", details_title: "Detalles del medidor", seq: "Secuencia", meter_name: "Nombre del medidor", meter_type: "Tipo de medidor", uom: "Unidad de medida", active_status: "¿Activo?", last_reading: "Última lectura", last_date: "Fecha de lectura", inspector: "Inspector", remarks: "Observaciones", new_meter: "Nuevo medidor" },
        specs: { classification: "Clasificación", select_class: "Seleccionar clasificación...", tech_specs: "Especificaciones técnicas", attribute: "Atributo", value: "Valor", uom: "UOM", data_type: "Tipo de dato", attr_details: "Detalles del atributo", select_val: "Seleccionar valor" },
        history: { title: "Historial de órdenes de trabajo", wo_num: "Nº OT", finish_date: "Fecha final", no_history: "No se encontró historial.", fetching: "Cargando historial...", wo_type: "Tipo" },
        bim: { model_status: "Estado del modelo", linked: "VINCULADO Y ACTIVO", not_linked: "NO VINCULADO", upload_revit: "Subir Revit (.rvt)", urn_label: "URN del modelo", "show_3d": "Ver Gemelo Digital (3D)", "not_linked": "No vinculado al modelo 3D" },
        ai: { title: "INTELIGENCIA DE ACTIVOS", sub_title: "Analizador de IA", tagline: "Diagnósticos predictivos de IoT industrial", run_btn: "EJECUTAR DIAGNÓSTICO", analyzing: "ANALIZANDO FLUJO DE TELEMETRÍA...", health_score: "Puntuación de salud", thermal: "Alerta térmica", vibration: "Alerta de vibración", tech_summary: "RESUMEN TÉCNICO", recommendations: "RECOMENDACIONES", sensors_chart: "Sensores vs. Límites críticos", init_prompt: "Haga clic en EJECUTAR DIAGNÓSTICO para iniciar el análisis de IA", critical: "CRÍTICO", normal: "NORMAL", stable: "ESTABLE", detected: "DETECTADO", "predictive_trajectory": "Trayectoria de falla predictiva", "est_failure": "Falla estimada", "loading_pred": "Generando modelo de pronóstico..." },
        "features": {
          "feature_id": "ID de Característica",
          "label": "Etiqueta",
          "start": "Medida Inicial",
          "end": "Medida Final (Vacío = Punto)",
          "value": "Valor (ej. 500mm)",
          "details": "Detalles de la Característica",
          "y_offset": "Desplazamiento Y (Der/Izq)",
          "z_offset": "Desplazamiento Z (Profundidad/Altura)"
        },
    

      }, 
      common: { "days": "Días", "weeks": "Semanas", "months": "Meses", "years": "Años", "daysList": { "saturday": "Sábado", "sunday": "Domingo", "monday": "Lunes", "tuesday": "Martes", "wednesday": "Miércoles", "thursday": "Jueves", "friday": "Viernes"}, "select": "Seleccionar", "search": "Buscar", "pending": "Pendiente", "pendingSelection": "--- SELECCIÓN PENDIENTE ---",confirm: "confirmación", save_settings: "Guardar configuración de IA", selected: "Activos seleccionados", bulk_move: "Migración masiva", change_status: "Cambiar estado", cancel: "Restablecer", save: "Guardar", cancel: "Cancelar", delete: "Eliminar", back: "Atrás", record: "Registro", total: "Total", print: "Imprimir", active: "Activo", critical: "Crítico", warning: "Advertencia", healthy: "Saludable", of: "de", new_row: "Nueva fila", "filter": "Filtrar...", "save_success": "Guardado con éxito", "save_fail": "Fallo al guardar", "delete": "Eliminar", "delete_success": "Eliminado con éxito", "delete_fail": "Fallo al eliminar", "are_you_sure": "¿Estás seguro?", "cancel": "Cancelar", "confirm": "Confirmar", "first": "Primero", "last": "Último", "next": "Siguiente", "prev": "Anterior", "sar": "SAR", "all": "TODO", "attachments": "Adjuntos", "history": "Historial", "change_status": "Cambiar estado", "totalRecords": "Registros Totales", "readOnly": "(SOLO LECTURA)", "noDescription": "Sin descripción", "recordLocked": "El registro está bloqueado y no se puede modificar.", "descRequired": "¡Se requiere descripción!", "actionDenied": "Acción denegada", "cantDeleteStatus": "No se puede eliminar un registro con estado: {{status}}", copy: "Copia", cancel: "Cancelar", clone: "Clonar", back: "De vuelta", yes: "Sí", no: "No", "main": "Detalles Principales", "save": "GUARDAR", "change_status": "Cambiar Estado", "history": "Historial", "delete": "Eliminar", "org": "Organización", "site": "Sitio", "new_row": "NUEVA FILA", "location": "Ubicación", "asset": "Activo", "no_records": "No se encontraron registros", "saving": "Guardando...", "save_success": "¡Guardado Exitosamente!", "save_fail": "Error al guardar", "are_you_sure": "¿Está seguro?", "yes_delete": "¡Sí, eliminar!", "cancel": "Cancelar", "delete_success": "Eliminado exitosamente", "delete_fail": "Error al eliminar: ", "clear_filters": "BORRAR FILTROS", "all": "TODOS", "syncing": "Sincronizando...", "showing": "Mostrando", "total": "Total", "created_by": "Creado Por", "changed_date": "Fecha de Modificación"}, 
      toasts: { save_success: "Guardado con éxito", save_fail: "Error al guardar", load_fail: "Error al cargar datos", delete_success: "Eliminado con éxito" },
      swal: { delete_title: "¿Está seguro?", delete_text: "Está a punto de eliminar el activo:", confirm_delete: "Sí, eliminar registro" },
      "ai_settings": {
        "title": "Ajustes del ingeniero de IA",
        "sub_title": "Motor de mantenimiento predictivo de IA",
        "enable_label": "Activar mantenimiento predictivo automático",
        "enable_sub": "Crear OT automática basada en el análisis de IA",
        "target_lang": "Idioma de informes y tareas",
        "threshold": "Umbral de confianza para la decisión",
        "auto_tasks": "Generar automáticamente tareas de trabajo (WOTasks)",
        "task_desc": "Escribir pasos de trabajo automáticamente en la tabla de tareas",
        "max_tasks": "Pasos máximos por orden de trabajo",
        "section": "Sección",
        "technicalDetails": "Detalles Técnicos"
      },
      "export_technical_report": "EXPORTAR INFORME TÉCNICO (PDF)",
      "availability": "Disponibilidad",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "hrs": "HRS",
      "reliability_score": "Puntuación de Confiabilidad",
      "score": "Puntuación",
      "downtime_history_trend": "Tendencia de Tiempo de Inactividad",
      "values_in_hours": "Valores en Horas",
      "timeline_event_date": "Línea de Tiempo (Fecha)",
      "downtime_hours": "Tiempo de Inactividad (Horas)",
      "no_downtime_records": "No hay registros de tiempo de inactividad para este activo.",
      "reliability_analysis": "Análisis de Confiabilidad",
      "total_failures": "Fallas Totales",
      "total_down_time": "Tiempo de Inactividad Total",
      "last_calculation": "Último Cálculo",
      "maintenance_strategy_note": "Nota de Estrategia de Mantenimiento",
      "high_mttr_detected": "MTTR alto detectado. Recomendación: Evaluar repuestos y capacitación.",
      "critical_availability": "Nivel de disponibilidad crítico. Considere aumentar la frecuencia de PM.",
      "nominal_performance": "El rendimiento es nominal. Continúe con el programa estándar.",
      "current_load_factor": "Factor de Carga Actual",
      "optimal": "Óptimo",
      statusModal: {
        "loadError": "No se pudieron cargar los estados",
        "selectFirst": "Seleccione un estado primero",
        "updating": "Actualizando estado...",
        "success": "Estado actualizado",
        "failed": "Error al actualizar",
        "changeStatus": "Cambiar estado:",
        "currentStatus": "Estado actual",
        "availableStatuses": "Estados disponibles",
        "loading": "Cargando...",
        "chooseStatus": "Elegir estado...",
        "memo": "Justificación / Nota",
        "enterNotes": "Ingrese sus notas...",
        "cancel": "Cancelar",
        "update": "Actualizar"
      },
      attachmentsModal: {
        "loadError": "Error al cargar archivos",
        "uploadSuccess": "Archivo adjuntado con éxito",
        "uploadFailed": "Error de subida",
        "deleteConfirmTitle": "¿ESTÁS SEGURO?",
        "deleteConfirmText": "Estás a punto de eliminar permanentemente '{{name}}'. Esto eliminará el archivo de nuestros servidores.",
        "btnYesDelete": "¡SÍ, ELIMINAR!",
        "btnCancel": "CANCELAR",
        "processingDelete": "Procesando eliminación...",
        "deletedTitle": "¡ELIMINADO!",
        "deletedText": "El archivo adjunto se ha eliminado correctamente.",
        "deleteFailed": "Error al eliminar",
        "headerTitle": "Biblioteca de adjuntos",
        "linkingTo": "Vinculado a:",
        "filesFound": "ARCHIVOS ENCONTRADOS:",
        "uploadBtn": "SUBIR NUEVO DOCUMENTO",
        "thName": "Nombre",
        "thOwner": "Propietario",
        "thStatus": "Estado",
        "thActions": "Acciones",
        "statusPrivate": "Privado",
        "statusPublic": "Público",
        "noDocs": "Aún no hay documentos vinculados"
      },
      enterMeters: {
        "noMeters": "No hay medidores vinculados al activo:",
        "saving": "Guardando lecturas...",
        "enterAtLeastOne": "Por favor, introduzca al menos una nueva lectura",
        "saveSuccess": "¡Todas las lecturas guardadas con éxito!",
        "saveFailed": "Error al guardar las lecturas",
        "title": "Ingresar Lecturas del Medidor | Activo:",
        "titleLoc": "Ingresar Lecturas del Medidor | Ubicación:",
        "thIdentification": "Identificación del Medidor",
        "thNewReading": "* Nueva Lectura",
        "thReadingDate": "* Fecha de Lectura",
        "thMeterType": "Tipo de Medidor",
        "thLastRecorded": "Último Registro",
        "noDescription": "Sin descripción",
        "enterValue": "Ingrese el valor...",
        "notAvailable": "N/A",
        "operator": "Operador:",
        "btnCancel": "Cancelar",
        "btnUpdate": "Actualizar Lecturas"
      },
      emailSettings: {
        "loadFailed": "Error al cargar la configuración",
        "saveSuccess": "¡Configuración de correo guardada con éxito!",
        "saveFailed": "Error al guardar la configuración",
        "connecting": "Conectando al servidor SMTP...",
        "connFailed": "¡Conexión fallida!",
        "title": "Configuración SMTP",
        "subtitle": "Configuración del servidor de correo",
        "lblHost": "Host SMTP",
        "lblPort": "Puerto SMTP",
        "lblUser": "Usuario / Correo SMTP",
        "lblPass": "Contraseña SMTP",
        "lblSender": "Correo del remitente del sistema (De)",
        "gmailNote": "Para Gmail, use una 'Contraseña de aplicación' de Google Security. Las contraseñas de cuenta no funcionarán con 2FA habilitado.",
        "btnTest": "PROBAR",
        "btnCancel": "CANCELAR",
        "btnSave": "GUARDAR CONFIGURACIÓN"
      },
      locationDetails: {
        "noBimModel": "No hay modelo 3D vinculado a esta ubicación",
        "noBimLinked": "Esta ubicación no está vinculada a BIM",
        "locMandatory": "¡La ubicación es un campo obligatorio!",
        "saving": "Guardando cambios...",
        "saveSuccess": "Ubicación guardada con éxito",
        "saveFailed": "Error al guardar:",
        "deleteTitle": "¿Estás seguro?",
        "deleteText": "Estás a punto de eliminar la Ubicación {{id}}. ¡Esta acción no se puede deshacer!",
        "btnYesDelete": "¡Sí, eliminar!",
        "btnCancel": "Cancelar",
        "deleting": "Eliminando ubicación...",
        "deleteSuccess": "Ubicación eliminada con éxito",
        "deleteFailed": "¡Error al eliminar!",
        "uploadingRevit": "Subiendo y traduciendo el modelo de Revit...",
        "revitSuccess": "¡Modelo vinculado con éxito!",
        "uploadFailed": "Error de subida:",
        "loadingCtx": "CARGANDO CONTEXTO DE LA UBICACIÓN...",
        "tooltipChangeStatus": "Cambiar estado",
        "tooltipStatusHistory": "Historial de estado",
        "tooltipDelete": "Eliminar",
        "btnSave": "GUARDAR",
        "lblLocation": "Ubicación",
        "lblDescription": "Descripción",
        "btnRevitLinked": "Revit vinculado",
        "tabLocation": "Ubicación",
        "tabAssets": "Activos",
        "tabSpecs": "Especificaciones",
        "tabSafety": "Seguridad",
        "tabMeters": "Medidores",
        "tab3D": "Vista 3D",
        "tabHistory": "Historial",
        "secIdentity": "Identidad de la ubicación",
        "lblStatus": "Estado",
        "lblType": "Tipo",
        "lblParentLoc": "Ubicación principal",
        "lblSiteID": "ID del sitio",
        "secGeoInfo": "Información geográfica y de dirección",
        "lblServiceAddr": "Dirección de servicio",
        "lblBimSpaceId": "ID de espacio BIM",
        "lblGisCoords": "Coordenadas SIG",
        "secRefImage": "Imagen de referencia",
        "btnUploadPhoto": "Subir foto",
        "thAssetNum": "Núm de activo",
        "thStatus": "Estado",
        "lblClass": "Clasificación",
        "thAttr": "Atributo",
        "thDesc": "Descripción",
        "thValue": "Valor",
        "titleHazards": "Peligros reportados en esta ubicación",
        "btnAddHazard": "Agregar peligro",
        "lblSelectHazards": "Seleccionar peligros",
        "thHazard": "Peligro",
        "thPrecaution": "Precaución",
        "titleLocMeters": "Medidores de la ubicación",
        "showingMeters": "Mostrando {{current}} de {{total}}",
        "noMetersDef": "No hay medidores definidos",
        "thSeq": "Sec",
        "thMeterNum": "Núm Medidor",
        "thType": "Tipo",
        "thUOM": "UdM",
        "thActive": "Activo",
        "newMeter": "NUEVO_MEDIDOR",
        "clickNewRow": "Haga clic en 'Nueva fila' para agregar un medidor",
        "titleMeterConfig": "Configuración de detalles del medidor",
        "newEntry": "Nueva entrada",
        "lblMeterNum": "* Número de medidor",
        "lblMeterType": "Tipo de medidor",
        "lblUOM": "Unidad de medida",
        "lblMeterActive": "El medidor está activo",
        "lblLastReading": "Última lectura",
        "lblReadingDate": "Fecha de lectura",
        "lblInspector": "Inspector de medidor",
        "lblRemarks": "Observaciones / Comentarios",
        "placeholderRemarks": "Ingrese notas técnicas sobre este medidor...",
        "btnAddMeterRow": "Agregar nueva fila de medidor",
        "titleModelStatus": "Estado del modelo",
        "statusLinked": "VINCULADO Y ACTIVO",
        "statusNotLinked": "NO VINCULADO",
        "btnUploadRevit": "Subir Revit (.rvt)",
        "titleHistory": "Historial de transacciones y registro de auditoría",
        "lblChangedBy": "Cambiado por:",
        "failedFetchAttr": "Error al obtener atributos"
      },
      "locationList": {
        "loadFailed": "Error al cargar las ubicaciones desde el servidor.",
        "title": "Ubicaciones",
        "searchPlaceholder": "Búsqueda global...",
        "btnClearAll": "Borrar todo",
        "btnExport": "Exportar",
        "btnNewLocation": "Nueva ubicación",
        "thLocationId": "ID de Ubicación",
        "thDescription": "Descripción",
        "thType": "Tipo",
        "thStatus": "Estado",
        "thSite": "Sitio",
        "optAll": "TODOS",
        "optOperating": "EN OPERACIÓN",
        "optDecommissioned": "DESMANTELADO",
        "fetchingData": "Obteniendo datos del servidor...",
        "noRecords": "No se encontraron registros coincidentes.",
        "recordsFound": "Registros encontrados:",
        "page": "Página:"
      },
      "universalLookup": {
        "selectValue": "Seleccionar valor:",
        "total": "Total",
        "searchPlaceholder": "Buscar por código o descripción...",
        "valueCode": "Valor / Código",
        "description": "Descripción",
        "site": "Sitio",
        "synchronizing": "Sincronizando...",
        "noRecords": "No se encontraron registros coincidentes.",
        "loadingMore": "Cargando más registros...",
        "results": "Resultados:",
        "cancel": "Cancelar"
      },
      "statusHistory": {
        "title": "Registro de auditoría de estado",
        "loading": "CARGANDO HISTORIAL...",
        "noRecords": "No hay cambios de estado registrados para este elemento.",
        "initial": "INICIAL",
        "btnClose": "Cerrar"
      },
      "personalInfo": {
        "updateSuccess": "Perfil actualizado con éxito",
        "sessionExpired": "Sesión expirada, por favor inicie sesión de nuevo",
        "updateFailed": "Error al actualizar",
        "title": "Información personal y valores predeterminados",
        "lblDisplayName": "Nombre para mostrar",
        "lblEmail": "Correo electrónico",
        "lblDefaultOrg": "Organización predeterminada",
        "selectOrg": "Seleccionar organización...",
        "lblDefaultSite": "Sitio predeterminado",
        "selectSite": "Seleccionar sitio...",
        "lblDefaultLang": "Idioma predeterminado",
        "btnCancel": "Cancelar",
        "btnSave": "Aplicar y guardar cambios",
        "securityTitle": "Seguridad y 2FA",
        "enable2FA": "Habilitar autenticación de dos factores (2FA)",
        "googleAuth": "Google Authenticator",
        "emailOTP": "OTP por correo",
        "configure2FA": "Configurar 2FA",
        "scanQR": "Escanee este código QR con Google Authenticator y luego ingrese el código de 6 dígitos a continuación para verificar.",
        "btnVerify": "Verificar",
        "setupSuccess": "¡Configuración de 2FA exitosa!",
        "invalidCode": "Código de verificación inválido",
        "failedQR": "Error al generar el código QR"
      },
      "appSettings": {
        "savingSettings": "Guardando configuración...",
        "saveSuccess": "¡Configuración actualizada con éxito!",
        "saveFailed": "Error al guardar la configuración.",
        "title": "Configuración empresarial",
        "org": "Organización",
        "tabs": {
          "WORKORDER": "Órdenes de trabajo",
          "ASSET": "Registro de activos",
          "INVENTORY": "Almacén y existencias",
          "PURCHASE": "Adquisiciones",
          "PR": "Solicitud de Compra",
          "JP": "Plan de Trabajo",
          "PM": "Mantenimiento Preventivo",
          "MR": "Solicitud de Material",
          "SR": "Solicitud de Servicio"
        },
        "systemRules": "Reglas del sistema: {{tab}}",
        "prefix": "Prefijo de secuencia",
        "preview": "Vista previa",
        "seed": "Valor inicial (Semilla)",
        "valuationStrategy": "Estrategia de valoración",
        "movingAvg": "Promedio móvil (Recomendado)",
        "fifo": "Primero en entrar, primero en salir (FIFO)",
        "lifo": "Último en entrar, primero en salir (LIFO)",
        "allowNegative": "Permitir saldo negativo",
        "negativeWarning": "Advertencia: Afecta la precisión financiera",
        "encrypting": "Cifrando y transmitiendo...",
        "auditLogged": "Todos los cambios se registran en el historial de auditoría",
        "btnCancel": "Cancelar",
        "btnSave": "Guardar política del sistema"
      },
      "workflowAction": {
        "successMove": "¡Flujo de trabajo enrutado con éxito! 🚀",
        "failedMove": "Acción fallida",
        "btnRoute": "Enrutar flujo",
        "modalTitle": "ACCIÓN DE FLUJO DE TRABAJO",
        "assignedAs": "Asignado a usted como:",
        "defaultInstruction": "Por favor, revise y tome acción.",
        "lblChoosePath": "Elegir ruta",
        "valSelectPath": "Por favor, seleccione una ruta",
        "optApprove": "APROBAR / AVANZAR",
        "optReject": "RECHAZAR / DEVOLVER",
        "lblMemo": "Nota de acción / Comentarios",
        "placeholderMemo": "Agregue sus comentarios aquí...",
        "btnCancel": "Cancelar",
        "btnComplete": "COMPLETAR PASO"
      },
      "meterHistory": {
        "title": "Historial de lecturas de medidores",
        "lblAsset": "Activo",
        "fetching": "Obteniendo archivos...",
        "noRecords": "No se encontraron lecturas históricas para este activo.",
        "thMeterName": "Nombre del medidor",
        "thReadingVal": "Valor de lectura",
        "thReadingDate": "Fecha de lectura",
        "thEnteredBy": "Ingresado por",
        "thEntryDate": "Fecha de ingreso",
        "btnClose": "Cerrar historial",
        "lblLocation": "Ubicación",
        "noRecordsLoc": "No se encontraron lecturas históricas para esta ubicación.",
      },
      rpt_print: "Imprimir informes",
      "no_templates": "No hay plantillas disponibles",
      "wo": {
        "tabs": { "workOrder": "Orden de Trabajo", "plans": "Planes", "assignments": "Asignaciones", "actuals": "Reales", "safety": "Seguridad", "failure": "Reporte de Fallas" },
        "subTabs": { "tasks": "Tareas", "labor": "Mano de obra", "materials": "Materiales", "tools": "Herramientas", "services": "Servicios" },
        "headers": { "workOrder": "Orden de Trabajo", "status": "Estado", "totalCost": "Costo Total", "activeSla": "MONITOREO SLA ACTIVO", "targetRes": "RESOLUCIÓN OBJETIVO", "targetResp": "RESPUESTA OBJETIVO" },
        "sections": { "assetDetails": "Detalles del Activo", "scheduling": "Programación", "responsibility": "Responsabilidad", "laborAssign": "Asignaciones", "totalAssign": "Asignaciones Totales" },
        "fields": { "description": "Descripción", "location": "Ubicación", "asset": "Activo", "workType": "Tipo de Trabajo", "safetyCode": "Código de Seg.", "supervisor": "Supervisor", "failureClass": "Clase de Falla", "targStart": "Inicio Objetivo", "targFinish": "Fin Objetivo", "schedStart": "Inicio Programado", "schedFinish": "Fin Programado", "earlyStart": "No empezar antes de", "lateFinish": "No terminar después de", "actStart": "Inicio Real", "actFinish": "Fin Real", "duration": "Duración", "timeRemaining": "Tiempo Restante", "predecessors": "Predecesores", "includeTasks": "¿Incluir tareas en la programación?", "site": "Sitio", "organization": "Organización", "priorityHigh": "Prioridad: Alta" },
        "actions": { "routeWorkflow": "Enrutar Flujo", "wfHistory": "Historial de Flujo", "changeStatus": "Cambiar Estado", "attachments": "Adjuntos", "printWO": "Imprimir OT", "printSafety": "Hoja de Seguridad", "history": "Historial", "newTask": "Nueva Tarea", "selectLoc": "Seleccionar Ubicación", "selectAsset": "Seleccionar Activo", "selectType": "Seleccionar Tipo", "selectSafety": "Seleccionar Plan de Seg.", "selectSup": "Seleccionar Supervisor", "selectFail": "Seleccionar Clase Falla", "selectCraft": "Seleccionar Oficio", "selectLabor": "Seleccionar Mano de Obra", "selectItem": "Seleccionar Artículo", "selectStore": "Seleccionar Almacén", "selectTool": "Seleccionar Herramienta", "addLabor": "Agregar Mano de Obra", "addMaterial": "Agregar Material", "addTool": "Agregar Herramienta", "addService": "Agregar Servicio", "newAssign": "Nueva Asignación", "compAssign": "Completar Asignación", "createMR": "Crear Solicitud Material", "yesCreate": "Sí, crear", "yesChange": "Sí, cambiar", "approve": "Aprobar", "cancel": "Cancelar", "startWork": "Iniciar", "close": "Cerrar", "complete": "Completar", "selectProblem": "Seleccionar Problema", "selectCause": "Seleccionar Causa", "selectRemedy": "Seleccionar Remedio" },
        "tables": { "sequence": "Sec.", "taskDesc": "Desc. de Tarea", "estDur": "Dur. Est.", "status": "Estado", "craft": "Oficio", "labor": "Mano de Obra", "qty": "Cant.", "hrs": "Hrs", "rate": "Tarifa", "lineCost": "Costo Línea", "lineType": "Tipo Línea", "itemNum": "Artículo #", "description": "Descripción", "unitCost": "Costo Unit.", "storeroom": "Almacén", "item": "Artículo", "material": "Material", "toolNum": "Herr. #", "serviceDesc": "Desc. Servicio", "vendor": "Proveedor", "cost": "Costo", "start": "Inicio", "finish": "Fin", "failCode": "Código Falla" },
        "footer": { "totalLabor": "Total Mano Obra", "totalMaterial": "Total Material", "assigned": "Asignado (Est.)", "toolsServ": "Herr. y Serv.", "totalActual": "Costo Total Real" },
        "safety": { "hazardsTitle": "Peligros y Precauciones", "hazardCode": "Código de Peligro", "hazardDesc": "Desc. de Peligro", "precautions": "Precauciones Requeridas", "noHazards": "Sin peligros identificados.", "lotoTitle": "Bloqueo / Etiquetado (LOTO)", "step": "Paso", "tagNum": "Núm. Etiqueta", "isoDesc": "Desc. de Aislamiento", "reqState": "Estado Requerido", "completed": "¿Completado?", "noLoto": "Sin pasos de aislamiento requeridos." },
        "failure": { "title": "Análisis de Fallas", "currClass": "Clase Actual", "notDefined": "NO DEFINIDO", "problems": "PROBLEMAS", "causes": "CAUSAS", "remedies": "REMEDIOS", "records": "REGISTROS" },
        "placeholders": { "desc": "Ingrese descripción...", "taskDesc": "DESCRIPCIÓN DE TAREA..." },
        "messages": { "loadError": "Error al cargar", "taskStatusLocal": "Estado de tarea actualizado", "selectItemStore": "Seleccione artículo y almacén", "duplicateReqTitle": "Solicitud duplicada", "duplicateReqText": "Existe una solicitud para {{item}}. ¿Crear otra?", "creatingMR": "Creando solicitud...", "mrCreated": "Solicitud {{num}} creada", "mrFail": "Fallo al crear solicitud", "confirmStatusChange": "¿Cambiar el estado de {{wonum}} a {{status}}?", "statusSuccess": "Estado modificado", "statusFail": "Fallo al cambiar estado", "saving": "Guardando...", "deleteConfirm": "¿Eliminar {{wonum}}? ¡Acción irreversible!", "saveBeforeSLA": "Guarde la OT primero", "slaExists": "¡SLA ya aplicado!", "matchingSLA": "Buscando SLA...", "slaApplied": "SLA aplicado con éxito", "noMatchingSLA": "Sin SLA coincidente", "slaError": "Error del motor SLA", "failureTreeLoaded": "Códigos de falla aplicados", "zeroBalance": "Advertencia: Saldo cero para el artículo en {{store}}", "balanceOk": "Precio obtenido: {{cost}} - Saldo: {{bal}}", "storeError": "Fallo al conectar con almacén", "assetLinked": "Activo vinculado: {{asset}}", "openAssignError": "No se puede cerrar: {{count}} asignaciones incompletas.", "budgetExceeded": "¡Presupuesto excedido!", "assignComplete": "Asignación completada", "actionNotAllowed": "Acción no permitida para el estado {{status}}", "locked": "Bloqueado", "cantChangeCancel": "Las solicitudes canceladas no cambian de estado", "printFail": "Fallo al crear PDF", "wfRouted": "¡Flujo enrutado con éxito! 🚀", "wfFail": "Fallo al enrutar flujo", "taskStatusChanged": "Tarea {{task}} cambiada a {{status}}", "noLaborAssign": "Sin mano de obra asignada.", "updateTaskProg": "Actualizar progreso de tareas", "noMaterials": "Sin materiales. Haga clic para agregar.", "linkedMRs": "Solicitudes de Material Vinculadas", "stocknobalance": "⚠️ Advertencia: Este artículo tiene un saldo (cero) en el almacén." },
        "linearDefect": {
          "title": "Ubicación del Defecto Lineal",
          "startMeasure": "Medida Inicial",
          "endMeasure": "Medida Final (Opcional)",
          "unit": "Unidad",
          "yOffset": "Desplazamiento Y (m)"
        },
        "costs": {
          "title": "Costos de la Orden de Trabajo",
          "estimated": "Costos Estimados",
          "actual": "Costos Reales",
          "labor": "Mano de obra",
          "materials": "Materiales",
          "tools": "Herramientas",
          "services": "Servicios",
          "total": "Total",
          "variance": "Variación (Real - Est)",
          "calculating": "Calculando...",
          "no_data": "No hay datos disponibles."
        },
        "purchase_info": {
          "title": "Info. de Compra Relacionada",
          "mr_title": "Solicitudes de Material (MR)",
          "pr_title": "Solicitudes de Compra (PR)",
          "po_title": "Órdenes de Compra (PO)",
          "mr_num": "N° MR",
          "pr_num": "N° PR",
          "po_num": "N° PO",
          "vendor": "Proveedor",
          "status": "Estado",
          "req_date": "Fecha Requerida",
          "total_cost": "Costo Total",
          "fetching": "Obteniendo datos...",
          "no_records": "No se encontraron registros."
        },
    
      },
      "pm": {
        "tabs": { "pm": "MP", "frequency": "Frecuencia", "sequence": "Secuencia", "seasonaldates": "Fechas Estacionales", "forecast": "Pronóstico" },
        "sections": { "assetLoc": "Activo y Ubicación", "defaults": "Valores por defecto", "compliance": "Cumplimiento", "siteContext": "Info Sitio", "timeBased": "Intervalo basado en tiempo", "meters": "Medidores", "sequences": "Secuencias de planes", "seasonal": "Horario Semanal", "projections": "Registros de Proyección" },
        "fields": { "pmNum": "Número MP", "description": "Descripción", "status": "Estado", "site": "Sitio", "asset": "Activo", "location": "Ubicación", "route": "Ruta", "counter": "Contador", "jpnum": "Plan de Trabajo", "worktype": "Tipo Trabajo", "supervisor": "Supervisor", "glaccount": "Cuenta GL", "woStatus": "Estado por Defecto", "priority": "Prioridad", "lastStart": "Último Inicio", "lastComp": "Último Fin", "nextDue": "Próximo Vencimiento", "forecastFlag": "Bandera Pronóstico", "org": "Org", "freqInt": "Intervalo", "freqUnit": "Unidad", "targStart": "Hora Objetivo" },
        "actions": { "forecast": "PRONOSTICAR", "savePM": "GUARDAR", "addMeter": "AÑADIR MEDIDOR", "addStep": "AÑADIR PASO", "newPM": "Nuevo Registro MP" },
        "tables": { "meterName": "Medidor", "freq": "Frec.", "nextProj": "Próxima Proy.", "seq": "Secuencia", "jpnum": "Plan de Trabajo", "fcDate": "Fecha", "targetJp": "Plan Objetivo", "estCost": "Costo Est.", "status": "Estado", "woNum": "Num OT", "generated": "GENERADO", "projected": "PROYECTADO" },
        "messages": { "executingForecast": "Calculando...", "forecastSuccess": "Éxito", "forecastFail": "Fallo", "seasonalInfo": "Días marcados = permitidos.", "noMeters": "Sin medidores.", "noSeq": "Secuencia desactivada.", "noForecasts": "Sin pronósticos.", "showingProjections": "Mostrando {{count}} resultados", "fetchListError": "Error al cargar registros MP", "syncingList": "Sincronizando con el servidor...", "noRecords": "No se encontraron registros." },
        "placeholders": { "desc": "Ingrese descripción...", "globalSearch": "Búsqueda global inteligente..." },
        "headers": { "masterDir": "Directorio Maestro de MP" },
        "footer": { "dbTotal": "Total en base de datos:", "currentPage": "Página actual:", "useNavArrows": "Use flechas de navegación" }
      },
      "workflowHistory": {
        "title": "Historial de Flujo",
        "trackingId": "ID de Seguimiento:",
        "fetching": "Obteniendo registros...",
        "currentTask": "Tarea Activa Actual",
        "since": "Desde:",
        "by": "por",
        "noHistory": "Sin historial registrado para esta transacción",
        "closeBtn": "Cerrar Historial"
      },
      "pr": {
        "headers": { "prList": "Solicitudes de Compra" },
        "actions": { "newPR": "NUEVA SOLICITUD", "clearFilters": "BORRAR FILTROS", "routeWf": "ENRUTAR FLUJO" },
        "tabs": { "pr": "Solicitud", "prlines": "Líneas de Solicitud" },
        "sections": { "general": "Información General", "financial": "Resumen Financiero" },
        "fields": { "prNum": "Nº Solicitud", "requestedBy": "Solicitado por", "reqDate": "Fecha Requerida", "refMr": "SM de Referencia", "vendor": "Proveedor", "glAccount": "Cuenta GL" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Total Impuestos", "grandTotal": "Total General" },
        "tables": { "prNum": "Nº Solicitud", "description": "Descripción", "status": "Estado", "totalCost": "Costo Total", "reqDate": "Fecha Req.", "site": "Sitio", "itemNum": "Artículo #", "itemType": "Tipo", "qty": "Cant.", "unitCost": "Costo Unit.", "tax": "Impuesto", "lineTotal": "Total Línea", "taxCat": "Cat. Impuesto" },
        "messages": { "loadFailed": "Error al cargar solicitudes", "syncing": "Sincronizando...", "noData": "No hay datos que coincidan", "noLines": "Aún no se agregaron líneas.", "fetchingMRLines": "Obteniendo líneas de SM: {{mrnum}}...", "loadedMRLines": "{{count}} líneas cargadas", "noMRLines": "Esta SM no tiene líneas", "failedMRLines": "Error al cargar líneas de SM" },
        "swal": { "lockedTitle": "Bloqueado", "cantDeleteStatus": "No se puede eliminar con estado: {{status}}", "cantChangeCancel": "Las solicitudes canceladas no cambian de estado", "deleteWarnText": "Esto eliminará permanentemente la Solicitud y sus líneas." },
        "placeholders": { "desc": "Ingrese descripción...", "globalSearch": "Búsqueda global inteligente..." },
        "footer": { "showing": "Mostrando", "totalRecords": "Registros Totales" }
      },
      "po": {
        "headers": { "poList": "Órdenes de Compra" },
        "actions": { "newPO": "NUEVA ORDEN", "clearFilters": "BORRAR FILTROS", "routeWf": "ENRUTAR FLUJO", "addManualRow": "AÑADIR LÍNEA MANUAL", "wfHistory": "Cronología Workflow" },
        "tabs": { "po": "Orden de Compra", "polines": "Líneas de Orden" },
        "sections": { "general": "Información General", "financial": "Resumen Financiero", "lines": "Líneas de la Orden" },
        "fields": { "poNum": "Nº Orden", "requestedBy": "Solicitado por", "orderDate": "Fecha Orden", "refPr": "SC de Referencia", "vendor": "Proveedor", "glAccount": "Cuenta GL" },
        "financial": { "subtotal": "Subtotal (Neto)", "taxTotal": "Monto Impuesto", "grandTotal": "Total General" },
        "tables": { "poNum": "Nº Orden", "totalCost": "Costo Total", "orderDate": "Fecha Orden", "itemNum": "Artículo #", "itemType": "Tipo", "unitCost": "Costo Unit.", "tax": "Impuesto", "lineTotal": "Total Línea", "taxCat": "Cat. Impuesto" },
        "messages": { "loadFailed": "Error al cargar órdenes de compra", "syncing": "Sincronizando...", "noData": "No hay órdenes que coincidan", "noLines": "Aún no se agregaron líneas.", "vendorRequired": "El proveedor es obligatorio para guardar.", "fetchingLines": "Obteniendo líneas de: {{num}}...", "loadedLines": "{{count}} líneas cargadas con éxito", "noLinesFound": "Este documento no tiene líneas", "failedLines": "Error al cargar líneas", "cantChangeCancel": "Las solicitudes canceladas no cambian de estado", "cantDeleteStatus": "No se puede eliminar con estado: {{status}}" },
        "swal": { "deleteWarnText": "Esto eliminará permanentemente la orden y sus líneas." },
        "placeholders": { "desc": "Ingrese descripción...", "globalSearch": "Búsqueda global inteligente..." },
        "footer": { "showing": "Mostrando" }
      },
      "mr": {
        "headers": { "mrList": "Solicitudes de Material" },
        "actions": { "newMR": "NUEVA SM", "clearFilters": "BORRAR FILTROS", "routeWf": "ENRUTAR FLUJO", "createUsage": "CREAR USO", "createUsageDesc": "Crear registro de emisión/transferencia", "createPR": "CREAR SC", "createPRDesc": "Crear solicitud de compra", "addMaterial": "Añadir material" },
        "tabs": { "mr": "Info SM", "mrlines": "Líneas de SM" },
        "sections": { "general": "Información General", "financial": "Resumen Financiero", "mrItems": "Artículos de solicitud de material", "financialCharging": "Detalles de cargo financiero" },
        "fields": { "mrNum": "Nº SM", "requestedBy": "Solicitado por", "reqDate": "Fecha Requerida", "refMr": "SM de Referencia", "vendor": "Proveedor", "glAccount": "Cuenta GL", "targetStore": "Almacén destino", "chargeLoc": "Cargar a Ubic.", "chargeAsset": "Cargar a Activo", "chargeWO": "Cargar a OT" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Total Impuestos", "grandTotal": "Total General" },
        "tables": { "mrNum": "Nº SM", "description": "Descripción", "status": "Estado", "totalCost": "Costo Total", "enteredDate": "Fecha Ingreso", "site": "Sitio", "itemNum": "Artículo #", "itemType": "Tipo", "qty": "Cant.", "unitCost": "Costo Unit.", "tax": "Impuesto", "lineTotal": "Total Línea", "taxCat": "Cat. Impuesto", "stockItem": "Artículo de stock", "qtyReq": "Cant. Solicitada", "estUnitCost": "Costo unit. est." },
        "messages": { "loadFailed": "Error al cargar solicitudes", "syncing": "Sincronizando...", "noData": "No hay datos", "noLines": "Aún no se agregaron líneas.", "fetchingMRLines": "Obteniendo líneas: {{mrnum}}...", "loadedMRLines": "{{count}} líneas cargadas", "noMRLines": "Esta SM no tiene líneas", "failedMRLines": "Error al cargar líneas", "generating": "Generando {{docType}}...", "generatedSuccess": "¡{{docType}} {{docnum}} generado con éxito!", "generateFail": "Error al generar {{docType}}", "storeRequired": "¡Se requiere el almacén!", "dateRequired": "¡Se requiere la fecha!" },
        "swal": { "lockedTitle": "Bloqueado", "cantDeleteStatus": "No se puede eliminar con estado: {{status}}", "cantChangeCancel": "Las solicitudes canceladas no cambian de estado", "deleteWarnText": "Esto eliminará permanentemente la Solicitud y sus líneas." },
        "placeholders": { "desc": "Ingrese descripción...", "globalSearch": "Búsqueda global...", "chooseLoc": "ELEGIR UBICACIÓN", "selectAsset": "SELECCIONAR ACTIVO", "chargeWO": "CARGAR A OT" },
        "lookups": { "storerooms": "Almacenes", "inventory": "Búsqueda de inventario", "locations": "Ubicaciones", "assets": "Registro de activos", "workorders": "Órdenes de trabajo" },
        "footer": { "showing": "Mostrando", "totalRecords": "Total" }
      },
      "contract": {
        "headers": { "masterNode": "Nodo Maestro de Contratos" },
        "placeholders": { "globalSearch": "Búsqueda global...", "desc": "Ingrese resumen...", "termDesc": "Detalles de la cláusula..." },
        "actions": { "newContract": "NUEVO CONTRATO", "save": "GUARDAR", "addTerm": "AÑADIR CLÁUSULA", "addLine": "AÑADIR LÍNEA", "wfHistory": "Cronología Workflow" },
        "tabs": { "general": "General", "slaperformance": "SLA (Rendimiento)", "termslegal": "Términos y Legal", "contractlines": "Líneas de Contrato" },
        "sections": { "identity": "Identidad y Validez", "communication": "Centro de Comunicación", "auditInfo": "Info de Auditoría", "masterSLA": "Enlace SLA", "slaBenchmarks": "Métricas SLA", "termsList": "Cláusulas Legales", "lines": "Alcance / Líneas" },
        "options": { "supply": "Suministro", "labor": "Mano de obra/Servicio", "lease": "Arrendamiento", "allTypes": "TODOS TIPOS", "allStatus": "TODOS ESTADOS", "general": "GENERAL", "payment": "PAGO", "termination": "TERMINACIÓN", "warranty": "GARANTÍA", "liability": "RESPONSABILIDAD" },
        "fields": { "contractNum": "Nº Contrato", "vendorRef": "Proveedor", "startDate": "Fecha Inicio", "endDate": "Fecha Fin", "contractValue": "Valor Contrato", "currency": "Moneda", "contactPerson": "Persona Contacto", "vendorEmail": "Email Proveedor", "slaRef": "Referencia SLA", "respTime": "T. Respuesta (Hrs)", "resTime": "T. Resolución (Hrs)", "uptime": "Disponibilidad (%)", "penalty": "Penalización (x Hr)", "grandTotal": "Total Calculado" },
        "tables": { "contractNum": "Nº Contrato", "grandTotal": "Total", "clauseType": "Tipo Cláusula", "clauseDesc": "Detalles Condición", "lineDesc": "Descripción Línea", "rate": "Tarifa", "lineTotal": "Total Línea" },
        "messages": { "fetchError": "Error de sincronización", "syncing": "Sincronizando...", "noData": "No se encontraron contratos", "descMandatory": "La descripción es obligatoria", "vendorSelected": "Proveedor {{name}} seleccionado", "noTerms": "No hay cláusulas definidas", "noLines": "No hay líneas definidas", "slaHint": "Vincular un SLA aplica sus reglas globalmente." },
        "swal": { "deleteTitle": "¿Eliminación Final?", "deleteText": "Esto borrará permanentemente el contrato y todas sus líneas." },
        "footer": { "masterRecords": "Registros:", "currentPage": "Página Actual:" }
      },
      "rfq": {
        "headers": { "rfqList": "Gestión de Cotizaciones" },
        "tabs": { "rfq": "Solicitud", "rfqlines": "Líneas", "quotations": "Cotizaciones" },
        "sections": { "general": "Información General", "financial": "Resumen Financiero" },
        "fields": { "requestedBy": "Solicitado por", "reqDate": "Fecha Requerida", "refPr": "SC de Referencia", "vendor": "Proveedor", "vendorEmail": "Email Proveedor", "glAccount": "Cuenta GL" },
        "financial": { "subtotal": "Subtotal", "taxTotal": "Total Impuestos", "grandTotal": "Total General" },
        "tables": { "rfqNum": "Nº Solicitud", "totalCost": "Costo Total", "itemNum": "Artículo #", "itemType": "Tipo", "unitCost": "Costo Unit.", "tax": "Impuesto", "taxCat": "Cat. Impuesto" },
        "options": { "awarded": "ADJUDICADO" },
        "actions": { "newRFQ": "NUEVA COTIZACIÓN", "sendEmail": "ENVIAR EMAIL", "wfHistory": "Historial WF", "award": "ADJUDICAR Y CREAR OC" },
        "messages": { "loadFailed": "Error al cargar", "syncing": "Sincronizando...", "noData": "Sin datos", "noLines": "Sin líneas definidas", "pullingPR": "Obteniendo SC...", "prImported": "Líneas importadas!", "prFailed": "Error al importar", "noEmail": "¡Falta el email!", "sending": "Generando PDF y enviando...", "sendSuccess": "¡Email enviado!", "sendFailed": "Error de envío", "quotesHint": "Las cotizaciones entrantes aparecerán aquí.", "noQuotes": "Sin cotizaciones recibidas.", "awarding": "Adjudicando...", "awardSuccess": "¡Cotización adjudicada!", "poCreated": "OC Generada", "awardFailed": "Error al adjudicar" },
        "swal": { "sendTitle": "¿Enviar Solicitud?", "sendText": "¿Enviar a {{vendor}}?", "awardTitle": "¿Adjudicar?", "awardText": "Esto generará una Orden de Compra automáticamente." },
        "footer": { "showing": "Mostrando" }
      },
      "itemList": {
        "headers": { "master": "Maestro de Artículos" },
        "actions": { "newItem": "Nuevo Artículo" },
        "tables": { "item": "Artículo", "rotating": "¿Rotativo?" },
        "messages": { "syncFailed": "Error al sincronizar datos", "syncing": "Sincronizando...", "noData": "No hay artículos que coincidan" },
        "footer": { "totalItems": "Total de Artículos:", "page": "PÁGINA" }
      },
      "itemDetails": {
        "tabs": { "item": "ARTÍCULO", "inventory": "INVENTARIO", "vendors": "PROVEEDORES", "specs": "ESPEC.", "assembly": "ENSAMBLAJE" },
        "sections": { "config": "Config. de Artículo", "units": "Unidades y Seguimiento", "bomList": "Lista de Materiales (BOM)", "supplierHistory": "Historial de Proveedores" },
        "actions": { "save": "GUARDAR", "addStore": "AÑADIR A ALMACÉN", "newSpec": "NUEVA ESPEC.", "addComponent": "AÑADIR COMPONENTE" },
        "fields": { "itemSet": "Conjunto", "rotating": "¿Rotativo?", "lotControl": "¿Control de Lote?", "inspectionReq": "¿Requiere Inspección?", "orderUnit": "Unidad de Pedido", "issueUnit": "Unidad de Salida", "condition": "¿Condición?", "sparepart": "¿Es Repuesto?", "classification": "Clasificación" },
        "tables": { "store": "Almacén", "avgCost": "Costo Prom.", "balance": "Saldo", "attribute": "Atributo", "value": "Valor", "uom": "UDM", "subItem": "Subartículo", "remarks": "Notas", "vendor": "Cód. Proveedor", "supplierName": "Nombre Proveedor", "unitCost": "Costo Unit.", "refPO": "OC de Referencia", "activeVendors": "PROVEEDORES ACTIVOS" },
        "messages": { "reqFields": "¡Número y Descripción obligatorios!", "fetchingAttributes": "Obteniendo atributos...", "attributesLoaded": "Atributos cargados", "failedAttributes": "Error al cargar", "stockMsgTitle": "MENSAJE DE STOCK", "stockMsgDesc": "Cambiar estas unidades afectará a todos los almacenes.", "noInventory": "Sin registros de inventario.", "noSpecs": "Sin especificaciones.", "noBom": "Sin lista de materiales (BOM).", "noVendors": "Sin historial de proveedores." },
        "swal": { "deleteText": "Va a eliminar el artículo {{num}}. ¡Irreversible!" }
      },
      "changePassword": {
        "title": "Cambiar contraseña",
        "currentPwd": "Contraseña actual",
        "newPwd": "Nueva contraseña",
        "confirmPwd": "Confirmar nueva contraseña",
        "securityTitle": "Verificación de seguridad",
        "googleAuthMsg": "Ingrese el código de 6 dígitos de Google Authenticator para confirmar este cambio.",
        "emailOtpMsg": "Se ha enviado un código OTP a su correo electrónico.",
        "btnCancel": "Cancelar",
        "btnUpdate": "Actualizar contraseña",
        "btnVerify": "Verificar y cambiar",
        "btnBack": "Volver",
        "errMismatch": "¡Las nuevas contraseñas no coinciden!",
        "errLength": "La contraseña debe tener al menos 6 caracteres.",
        "msgVerifyReq": "Por favor verifique su identidad para continuar.",
        "msgSuccess": "¡Contraseña cambiada con éxito!",
        "errFailed": "Error al cambiar la contraseña."
      },
      "userDetails": {
        "titleNew": "NUEVO USUARIO",
        "titleEdit": "SEGURIDAD / USUARIOS",
        "btnSave": "GUARDAR USUARIO",
        "saving": "GUARDANDO...",
        "secIdent": "Identificación del usuario",
        "lblLoginId": "ID de inicio de sesión",
        "lblFullName": "Nombre completo",
        "lblDisplayName": "Nombre para mostrar",
        "lblEmail": "Correo electrónico",
        "lblPassword": "Contraseña",
        "lblActive": "Estado activo",
        "secAccess": "Seguridad y control de acceso",
        "lblPrimaryRole": "Rol de seguridad principal",
        "lblSecRoles": "Roles secundarios (Adicionales)",
        "lblDefOrg": "Organización predeterminada",
        "lblDefSite": "Sitio predeterminado",
        "secDelegation": "Delegación de trabajo",
        "lblDelegateTo": "Delegar trabajo a",
        "lblStartDate": "Fecha y hora de inicio",
        "lblEndDate": "Fecha y hora de finalización"
      },
            "receivingDetails": {
        "errLoadLines": "Error al cargar líneas de OC",
        "errMissingDist": "Especifique el almacén y la cantidad para todas las líneas",
        "errInspMandatory": "La decisión de inspección es OBLIGATORIA para este artículo",
        "errRejectExceeds": "Compruebe las cantidades rechazadas (no pueden exceder la cantidad llegada)",
        "msgSuccess": "¡Transacción procesada exitosamente!",
        "msgAutoClosed": "Cerrado automáticamente: ",
        "swalAssignTitle": "Asignación de Almacén",
        "swalAssignText": "El artículo {{item}} no está asignado a {{loc}}. ¿Asignarlo ahora y completar la recepción?",
        "swalAssignBtn": "Sí, Asignar y Completar",
        "errUnexpected": "Error inesperado durante la recepción",
        "hubTitle": "Centro de Recepción Masiva",
        "poRef": "REFERENCIA OC: ",
        "btnExecuting": "EJECUTANDO...",
        "btnConfirm": "CONFIRMAR RECEPCIÓN",
        "tblItemsPending": "Artículos Pendientes de Recepción",
        "colItemDetails": "Detalles del Artículo",
        "colBalance": "Saldo",
        "lblQualityCheck": "CONTROL DE CALIDAD REQUERIDO",
        "lblUnits": "Unidades",
        "msgNoPending": "No se encontraron artículos pendientes",
        "lblLandedCost": "Costo de Entrega (Cargos Extra Totales)",
        "lblBaseCost": "Costo Unitario Base OC",
        "lblStoreMatrix": "Matriz de Distribución de Almacén",
        "btnSplitStore": "Dividir",
        "colStoreroom": "Almacén",
        "colArrived": "Llegado",
        "colRejected": "Rechazado",
        "plcClickSearch": "Haga clic para buscar ->",
        "lookupSelectStore": "Seleccionar Almacén",
        "lblQcMatrix": "Matriz de Decisión de Control de Calidad",
        "optSelectDecision": "-- Requerido: Seleccionar Decisión --",
        "optPassed": "TOTALMENTE APROBADO (ACEPTAR TODO)",
        "optFailed": "TOTALMENTE RECHAZADO (DEVOLVER AL PROVEEDOR)",
        "optPartial": "ACEPTACIÓN PARCIAL (VER CAMPO RECHAZADO)",
        "lblInvValuation": "Valoración de Inventario (Costo Unitario Promedio)",
        "lblNetArrived": "Stock Neto Llegado",
        "msgSelectLine": "Seleccione una línea de OC activa para comenzar"
      },
      "userList": {
        "title": "SEGURIDAD DE USUARIOS",
        "plcSearch": "Buscar Usuario o Correo...",
        "btnNewUser": "NUEVO USUARIO",
        "colUserId": "ID USUARIO",
        "colFullName": "NOMBRE COMPLETO",
        "colRole": "ROL",
        "colSite": "SITIO",
        "colStatus": "ESTADO",
        "colEmail": "CORREO",
        "msgSyncing": "Sincronizando Seguridad...",
        "lblNoRole": "SIN ROL",
        "lblAll": "TODOS",
        "lblTotalUsers": "TOTAL USUARIOS:",
        "lblPage": "PÁGINA",
        "errLoadUsers": "Error al cargar usuarios"
      },
      "crafts": {
        "headers": {
          "craftList": "Catálogo de Especialidades"
        },
        "actions": {
          "newCraft": "Nueva Especialidad"
        },
        "tables": {
          "craftCode": "Código de Especialidad",
          "description": "Descripción",
          "stdRate": "Tarifa Est./Hora",
          "site": "Sitio",
          "org": "Organización"
        },
        "messages": {
          "loadFailed": "Error al cargar las especialidades"
        },
        "headers": {
          "craftList": "Catálogo de Especialidades"
        },
        "tabs": {
          "skills": "Habilidades y Niveles"
        },
        "sections": {
          "costing": "Costos",
          "control": "Control"
        },
        "actions": {
          "newCraft": "Nueva Especialidad",
          "addSkill": "Agregar nivel de habilidad"
        },
        "tables": {
          "craftCode": "Código de Especialidad",
          "description": "Descripción",
          "stdRate": "Tarifa Est./Hora",
          "site": "Sitio",
          "org": "Organización"
        },
        "fields": {
          "stdHourlyRate": "Tarifa por hora estándar",
          "skillLevel": "Nivel de habilidad (ej. Experto, Junior)",
          "hourlyRate": "Tarifa por hora"
        },
        "placeholders": {
          "enterLevel": "INGRESAR NIVEL..."
        },
        "messages": {
          "loadFailed": "Error al cargar las especialidades",
          "autoCalc": "Calculado automáticamente a partir de la suma de habilidades",
          "noSkills": "Aún no se han definido habilidades"
        }
      },
      "persons": {
        "headers": {
          "directory": "Directorio de Personas"
        },
        "actions": {
          "newPerson": "Nueva Persona"
        },
        "tables": {
          "personId": "ID de Persona",
          "name": "Nombre para mostrar",
          "site": "Sitio",
          "email": "Correo",
          "phone": "Teléfono"
        },
        "messages": {
          "loadFailed": "Error al cargar la lista de personas"
        },
        "headers": {
          "directory": "Directorio de Personas"
        },
        "tabs": {
          "profile": "Info de Perfil",
          "contact": "Directorio de Contactos",
          "access": "Acceso al Sistema"
        },
        "sections": {
          "personalInfo": "Información Personal",
          "statusControl": "Estado y Control",
          "contactsDirectory": "Contactos Relacionados"
        },
        "tables": {
          "personId": "ID de Persona",
          "name": "Nombre para mostrar",
          "site": "Sitio",
          "email": "Correo",
          "phone": "Teléfono"
        },
        "fields": {
          "location": "Ubicación",
          "firstName": "Nombre",
          "lastName": "Apellido",
          "title": "Cargo",
          "department": "Departamento",
          "currentStatus": "Estado Actual",
          "contactName": "Nombre de Contacto",
          "position": "Cargo / Posición",
          "email": "Correo Electrónico",
          "phone": "Teléfono",
          "mobile": "Móvil",
          "primary": "Principal",
          "address": "Dirección",
          "city": "Ciudad",
          "country": "País",
        },
        "actions": {
          "newPerson": "Nueva Persona",
          "addContact": "Agregar Contacto"
        },
        "messages": {
          "loadFailed": "Error al cargar la lista de personas",
          "noContacts": "Aún no se han agregado contactos",
          "accessControlled": "El acceso al sistema está controlado por el módulo de Seguridad de Usuarios"
        }
      },
      "jp": {
        "list": {
          "title": "Directorio de Planes de Trabajo",
          "new_plan": "NUEVO PLAN",
          "filter_jp": "Filtrar planes...",
          "search_desc": "Buscar descripción...",
          "filter_site": "Sitio...",
          "no_records": "No se encontraron planes de trabajo",
          "fetch_error": "Error al cargar los planes"
        },
        "fields": {
          "jpnum": "N.º de Plan",
          "description": "Descripción",
          "status": "Estado",
          "revision": "Revisión",
          "site": "Sitio"
        },
        "details": {
          "load_error": "Error al cargar el Plan de Trabajo",
          "delete_warn": "Está a punto de eliminar el plan de trabajo {{jpnum}}. ¡Esta acción no se puede deshacer!"
        },
        "tabs": {
          "job_plan": "Plan de Trabajo",
          "plans": "Planes",
          "assets": "Activos"
        },
        "subtabs": {
          "tasks": "Tareas",
          "labor": "Mano de obra",
          "materials": "Materiales",
          "tools": "Herramientas"
        },
        "sections": {
          "details": "Detalles del Plan",
          "responsibility": "Responsabilidad",
          "woassets": "Activos de Trabajo y Seguridad"
        },
        "fields": {
          "jpnum": "N.º Plan",
          "status": "Estado",
          "description": "Descripción",
          "template_type": "Tipo de Plantilla",
          "duration": "Duración (Hrs)",
          "supervisor": "Supervisor",
          "class": "Estructura de Clase",
          "safety_plan": "Plan de Seguridad",
          "revision": "Revisión"
        },
        "table": {
          "seq": "Sec",
          "duration": "Duración",
          "craft": "Oficio",
          "labor": "Trabajador",
          "qty": "Cant",
          "hours": "Horas",
          "rate": "Tarifa",
          "item": "Artículo",
          "unitcost": "Costo Unitario",
          "tool": "Herramienta"
        }
      },
      "meters": {
        "list": {
          "title": "Definiciones de Medidores",
          "search": "Filtrar por Núm o Nombre...",
          "new_meter": "NUEVO MEDIDOR",
          "no_records": "No se encontraron medidores"
        },
        "fields": {
          "meter_num": "N.º Medidor",
          "meter_name": "Nombre de Medidor",
          "type": "Tipo",
          "uom": "UdM",
          "active": "¿Activo?",
          "remarks": "Notas",
          "last_reading": "ÚLTIMA LECTURA",
          "last_date": "FECHA DE ÚLTIMA LECTURA",
          "rollovers": "REINICIOS TOTALES"
        },
        "tabs": {
          "meter": "Detalles del Medidor",
          "where_used": "Dónde se Usa"
        },
        "sections": {
          "info": "Información del Medidor",
          "additional": "Detalles Adicionales",
          "stats": "Estadísticas"
        },
        "where_used": {
          "linked_assets": "Activos Vinculados",
          "linked_locations": "Ubicaciones Vinculadas",
          "linked_items": "Artículos Vinculados",
          "searching": "🔍 Buscando en el sistema...",
          "no_assoc": "No se encontraron asociaciones.",
          "asset_num": "N.º Activo",
          "site": "Sitio",
          "status": "Estado",
          "location": "Ubicación",
          "item_num": "N.º Artículo",
          "category": "Categoría"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Categorías de Activos",
          "search": "Buscar Categorías...",
          "new_category": "NUEVA CATEGORÍA",
          "no_records": "No se encontraron categorías"
        },
        "fields": {
          "category_id": "Código Categoría",
          "description": "Descripción",
          "dep_method": "Método Deprec.",
          "life": "Vida (Años)"
        }
      },
      "export": {
        "loading": "Extrayendo datos...",
        "success": "¡Exportado con éxito!",
        "error": "Error al exportar datos."
      },
      "labor": {
        "list": {
          "title": "Registro de Mano de Obra",
          "new": "NUEVO TRABAJADOR",
          "total": "Mano de Obra Total",
          "unique_crafts": "Oficios de la Página",
          "no_records": "No se encontraron trabajadores."
        },
        "tabs": {
          "main": "PRINCIPAL",
          "person": "PERSONA",
          "crafts": "OFICIOS",
          "log": "REGISTRO"
        },
        "sections": {
          "basic": "Información Básica",
          "status": "Estado y Organización",
          "additional_crafts": "Oficios Adicionales y Habilidades"
        },
        "fields": {
          "personid": "Ref. Persona",
          "primary_craft": "Oficio Principal",
          "actual_rate": "Tarifa Real (Por hora)",
          "skill": "Nivel de Habilidad",
          "rate": "Tarifa por Hora",
          "primary": "¿Principal?",
          "laborcode": "Cód. Trabajador",
          "fullname": "Nombre Completo",
          "craft": "Oficio"
        },
        "actions": {
          "add_craft": "AÑADIR OFICIO"
        },
        "lookup": {
          "person": "Seleccionar Persona",
          "craft": "Seleccionar Oficio",
          "skill": "Seleccionar Habilidad"
        },
        "messages": {
          "no_crafts": "No se encontraron asociaciones de oficio"
        },
        "details": {
          "delete_warn": "¡No podrá recuperar este registro!"
        }
      },
      "sr": {
        "list": {
          "title": "Seguimiento de Solicitudes de Servicio",
          "new": "NUEVA SOLICITUD"
        },
        "fields": {
          "srnum": "Número de SS",
          "description": "Descripción",
          "reportedby": "Reportado Por",
          "reportdate": "Fecha de Reporte",
          "priority": "Prioridad"
        },
        "messages": {
          "no_records": "No se encontraron solicitudes de servicio"
        },
        "tabs": {
          "main": "Solicitud de Servicio",
          "related": "Registros Relacionados"
        },
        "sections": {
          "requester": "Solicitante y Contacto",
          "problem": "Especificaciones del Problema",
          "logistics": "Logística y Prioridad"
        },
        "fields": {
          "phone": "Teléfono",
          "email": "Correo Electrónico",
          "asset": "Activo",
          "location": "Ubicación",
          "long_desc": "Descripción Detallada del Problema",
          "priority_1": "1 - EMERGENCIA (INMEDIATA)",
          "priority_2": "2 - ALTA (MISMO DÍA)",
          "priority_3": "3 - MEDIA (72 HORAS)",
          "priority_4": "4 - BAJA (PLANIFICADA)"
        },
        "lookup": {
          "person": "Seleccionar Persona",
          "asset": "Seleccionar Activo",
          "location": "Seleccionar Ubicación"
        },
        "details": {
          "delete_new_only": "Solo se pueden eliminar solicitudes NUEVAS",
          "delete_warn": "Esto eliminará permanentemente esta Solicitud de Servicio.",
          "wf_tip": "Flujo de trabajo automático: Después de guardar, use el botón 'Enrutar Flujo de Trabajo' para enviar esta solicitud a revisión técnica.",
          "wo_tip": "Consejo: Puede generar una Orden de Trabajo desde esta SS a través de las acciones del flujo de trabajo o el script automatizado."
        },
        "related": {
          "title": "Órdenes de Trabajo vinculadas para SS:",
          "wonum": "Número de OT",
          "worktype": "Tipo de Trabajo",
          "no_wo": "Aún no se han creado Órdenes de Trabajo para esta SS.",
          "go_to_wo": "Ir a la Orden de Trabajo"
        }
      },
      "invusage": {
        "list": {
          "title": "Historial de Uso de Inventario",
          "new": "Nueva Transacción"
        },
        "types": {
          "all": "TODO",
          "issue": "EMISIÓN",
          "transfer": "TRANSFERENCIA",
          "return": "DEVOLUCIÓN"
        },
        "tabs": {
          "lines": "LÍNEAS DE USO",
          "log": "REGISTRO DE TRANSACCIÓN"
        },
        "details": {
          "summary": "Resumen de Líneas",
          "transfer_dest": "Detalles de Destino de Transferencia",
          "financial": "Cargo Financiero y Referencia"
        },
        "actions": {
          "add_item": "Añadir Artículo",
          "add_part": "Añadir Pieza",
          "select_mr": "SELECCIONAR S.M."
        },
        "fields": {
          "stock_item": "Artículo de Inventario",
          "issueunit": "Unidad de Emisión",
          "qty": "Cantidad",
          "unitcost": "Costo Unitario",
          "linecost": "Valor Total de Línea",
          "target_bin": "Ubicación Destino en",
          "target_loc": "Locación Destino",
          "assetnum": "Número de Activo",
          "wonum": "Referencia de Orden de Trabajo",
          "glaccount": "Cuenta de Cargo (GL)",
          "usagenum": "ID de Uso",
          "type": "Tipo",
          "fromstore": "Desde Almacén",
          "lines": "Líneas",
          "enterby": "Ingresado por"
        },
        "placeholders": {
          "select_item": "SELECCIONE ARTÍCULO...",
          "dest_bin": "INGRESE UBICACIÓN DESTINO...",
          "choose_loc": "ELEGIR UBICACIÓN",
          "select_asset": "SELECCIONE ACTIVO",
          "charge_wo": "CARGAR A OT"
        },
        "lookup": {
          "store": "Almacenes",
          "dest_store": "Almacenes de Destino",
          "mr": "Seleccione S.M. Aprobada",
          "item": "Búsqueda de Inventario",
          "loc": "Ubicaciones",
          "asset": "Registro de Activos",
          "wo": "Órdenes de Trabajo"
        },
        "messages": {
          "req_fromstore": "¡Por favor seleccione un Almacén primero!",
          "mr_loaded": "Artículos cargados de S.M.:",
          "mr_fail": "Error al cargar artículos de S.M.",
          "insufficient_title": "¡Stock Insuficiente!",
          "available": "Disponible",
          "create_pr": "¿Crear Solicitud de Compra?",
          "btn_create_pr": "Crear SC",
          "processing": "Procesando Ajustes de Inventario...",
          "inventory_updated": "Niveles de inventario actualizados con éxito",
          "cant_delete_comp": "¡No se puede eliminar una transacción completada!",
          "delete_warn": "Esto eliminará permanentemente el borrador.",
          "req_fields": "¡Descripción y Almacén son obligatorios!",
          "req_transfer": "¡Almacén Destino es obligatorio para transferencias!",
          "locked_title": "Registro Bloqueado",
          "locked_text": "Esta transacción está COMPLETADA y no puede modificarse.",
          "cant_save_comp": "No se pueden guardar cambios en un registro completado",
          "balance_move": "Nota: El saldo se moverá a",
          "upon_comp": "al finalizar."
        }
      },
      "downtime": {
        "title": "Reportar Tiempo de Inactividad",
        "subtitle": "Sistema de Gestión de Activos",
        "asset": "Activo",
        "status": "Registro Fuera de Línea",
        "start": "Fecha y Hora de Inicio",
        "end": "Fecha de Fin (Opcional)",
        "type": "Tipo de Inactividad",
        "types": {
          "unplanned": "NO PLANIFICADO (Avería)",
          "planned": "PLANIFICADO (Mantenimiento)"
        },
        "duration": "Duración Calculada",
        "hours": "HORAS",
        "prod_impact": "Inactividad Operativa (Impacto en Producción)",
        "btn_commit": "Confirmar Cambios",
        "messages": {
          "recording": "Registrando tiempo de inactividad...",
          "success": "Tiempo de inactividad registrado con éxito",
          "validation_error": "Error de formato: Revise todos los campos",
          "server_error": "Error del Servidor: 500"
        },
        "history": {
          "title": "Historial de Inactividad de Activos",
          "subtitle": "Seguimiento de Rendimiento para Activo",
          "no_records": "No hay eventos de inactividad registrados para este activo.",
          "duration_hrs": "Duración (Hrs)",
          "type_reason": "Tipo/Motivo",
          "impact": "Impacto",
          "reported_by": "Reportado Por",
          "still_down": "AÚN INACTIVO",
          "prod_loss": "Pérdida Prod.",
          "technical": "Técnico",
          "active_down": "Inactividad Activa",
          "resolved": "Resuelto"
        }
      },
      "incidents": {
        "list": {
          "title": "Registro de Incidentes",
          "new": "NUEVO INCIDENTE"
        },
        "fields": {
          "ticket_id": "ID Ticket",
          "priority": "Prioridad",
          "reported_by": "Reportado Por"
        },
        "details": {
          "ticket": "Ticket de Incidente",
          "general": "Descripción General",
          "detailed": "Detalles Detallados",
          "context": "Contexto y Estado",
          "linked_asset": "Activo Vinculado",
          "workorder": "Orden de Trabajo",
          "delete_warn": "Está a punto de eliminar permanentemente el Incidente {{ticket}}. ¡Esta acción no se puede deshacer!"
        },
        "lookup": {
          "asset": "Seleccionar Activo Vinculado",
          "loc": "Seleccionar Ubicación"
        }
      },
      "tools": {
        "list": {
          "title": "Registro de Herramientas",
          "new": "NUEVA HERRAMIENTA"
        },
        "fields": {
          "toolnum": "Número de Herramienta",
          "type": "Tipo",
          "is_stocked": "¿Almacenado?"
        },
        "tabs": {
          "tool": "HERRAMIENTA",
          "stores": "ALMACENES",
          "vendors": "PROVEEDORES",
          "specs": "ESPECIFICACIONES",
          "quals": "CUALIFICACIONES"
        },
        "sections": {
          "config": "Configuración de la herramienta",
          "inventory": "Inventario y Saldos de Stock",
          "vendors": "HISTORIAL DE COMPRAS Y PROVEEDORES",
          "quals": "Cualificaciones Requeridas"
        },
        "fields": {
          "toolnum": "Número de Herramienta",
          "type": "Tipo de Herramienta",
          "issueunit": "Unidad de Emisión",
          "is_stocked": "¿Herramienta Almacenada?",
          "rotating": "¿Artículo Rotativo?",
          "calib_req": "¿Calibración Requerida?",
          "mfg": "Fabricante",
          "model": "Número de Modelo",
          "class": "Clasificación",
          "active_vendors": "PROVEEDORES ACTIVOS"
        },
        "actions": {
          "add_store": "Añadir a Almacén",
          "add_qual": "Añadir Cualificación"
        },
        "tables": {
          "storeroom": "Almacén",
          "balance": "Saldo",
          "attr": "Atributo",
          "value": "Valor",
          "uom": "UdM",
          "qual": "Cualificación",
          "vendor_id": "Proveedor (Núm Comp)",
          "vendor_name": "Nombre del Proveedor",
          "unitcost": "Costo Unitario",
          "qty": "Cantidad",
          "po": "OC de Referencia"
        },
        "placeholders": {
          "toolid": "INGRESAR ID DE HERRAMIENTA...",
          "reg_supplier": "PROVEEDOR REGISTRADO",
          "adj": "AJUSTE DE STOCK"
        },
        "lookup": {
          "type": "Tipo de Herramienta",
          "unit": "Unidades de Emisión",
          "attr": "Atributos"
        },
        "messages": {
          "req_fields": "¡El Número de Herramienta y la Descripción son obligatorios!",
          "delete_warn": "¡No podrá revertir esto!",
          "class_loaded": "Clasificación y atributos cargados",
          "stocked_note": "Nota: Las herramientas almacenadas se gestionan a través de almacenes y requieren un registro de inventario para rastrear los saldos.",
          "no_stock": "No hay artículos en stock"
        }
      },
      "inventory": {
        "list": {
          "title": "Registro de Inventario"
        },
        "fields": {
          "itemnum": "N° Artículo",
          "location": "Almacén",
          "balance": "Saldo",
          "avgcost": "Costo Prom."
        },
        "details": {
          "profile": "Perfil de Inventario",
          "reorder_logic": "Lógica de Reabastecimiento",
          "reorder_pt": "Punto de Pedido",
          "eoq": "Cantidad Económica de Pedido",
          "critical_lvl": "Nivel Crítico",
          "critical_desc": "Generar SC automáticamente cuando el saldo alcanza el punto de pedido.",
          "current_stock": "Nivel de Stock Actual",
          "avail_qty": "Cantidad Disponible",
          "reserved_qty": "Cant. Reservada",
          "held_wo": "Retenido para Órdenes de Trabajo",
          "avg_cost": "Costo Unitario Promedio",
          "avg_cost_desc": "Promedio ponderado de todos los recibos",
          "total_val": "Valor Total del Stock",
          "total_val_desc": "Saldo Actual × Costo Promedio",
          "last_cost": "Costo del Último Recibo",
          "last_cost_desc": "Costo de la OC más reciente",
          "val_method": "Método de Valoración de Inventario",
          "avg_method": "COSTO PROMEDIO",
          "val_desc1": "Este artículo utiliza el método de",
          "val_desc2": ". El costo unitario se recalcula automáticamente en cada recibo de orden de compra para reflejar las fluctuaciones del mercado."
        },
        "tabs": {
          "balances": "Saldos",
          "trans": "Historial de Transacciones",
          "costs": "Costos"
        },
        "actions": {
          "adjustment": "Ajuste de Stock"
        },
        "tables": {
          "qty": "Cantidad",
          "actual_cost": "Costo Real",
          "reference": "Referencia"
        },
        "messages": {
          "no_trans": "No se encontró historial de transacciones"
        },
        "trans_types": {
          "receipt": "RECIBO",
          "issue": "EMISIÓN",
          "transfer": "TRANSFERENCIA",
          "adjustment": "AJUSTE"
        }
      },
      "storerooms": {
        "list": {
          "title": "Almacenes",
          "new": "NUEVO ALMACÉN"
        },
        "fields": {
          "location": "Almacén",
          "isdefault": "¿Es Predeterminado?",
          "inventory": "Inventario",
        },
        "details": {
          "profile": "Almacén",
          "record": "Registro de Almacén",
          "gen_settings": "Configuración General",
          "filtered_by": "Filtrado por {{org}}",
          "select_org_first": "Seleccione Org primero",
          "gl_accounts": "Cuentas GL",
          "inv_control": "Control de Inventario",
          "inv_control_desc": "Todas las emisiones y recibos de material para este almacén se equilibrarán con estas cuentas.",
          "items_stocked": "Artículos Almacenados"
        },
        "tabs": {
          "main": "PRINCIPAL",
          "inventory": "INVENTARIO"
        },
        "fields": {
          "location": "ID de Ubicación",
          "isdefault": "¿Almacén Predeterminado?",
          "useinpo": "¿Usar en OC?",
          "invowner": "Propietario del Inventario",
          "controlacc": "Cuenta de Control",
          "shrinkacc": "Cuenta de Merma",
          "glaccount": "Cuenta GL Predeterminada",
          "default": "PREDETERMINADO"
        },
        "lookup": {
          "person": "Seleccionar Persona"
        },
        "tables": {
          "itemnum": "Núm Artículo",
          "uom": "UdM",
          "curbal": "Saldo Actual",
          "reserved": "Cant Reservada"
        },
        "messages": {
          "req_fields": "¡El ID de ubicación es obligatorio!",
          "req_org_site": "¡Org y Sitio son obligatorios!",
          "delete_warn": "Está a punto de eliminar el Almacén {{store}}. ¡Esta acción no se puede deshacer!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Libreria Codici di Guasto",
          "new": "Nuova Classe di Guasto"
        },
        "details": {
          "profile": "Classe di Guasto"
        },
        "fields": {
          "class": "Classe di Guasto",
          "code": "Codice",
          "desc_tech": "Descrizione / Nome Tecnico"
        },
        "tables": {
          "problems": "Problemi (Il Problema)",
          "causes": "Cause (Causa Radice)",
          "remedies": "Rimedi (L'Azione)"
        },
        "placeholders": {
          "class": "ES. PUMP-FAIL",
          "desc_tech": "Fornisci una descrizione dettagliata di questa gerarchia di guasti...",
          "code": "Inserisci Codice...",
          "desc": "Descrizione Tecnica..."
        },
        "messages": {
          "req_class": "Il codice della classe di guasto è obbligatorio!",
          "delete_warn": "Stai per eliminare la classe di guasto {{class}}. Questa azione non può essere annullata!"
        }
      },
      "scheduler": {
        "title": "Despacho y Programación",
        "ai_optimize": "AUTO-OPTIMIZACIÓN IA",
        "publish": "PUBLICAR PROGRAMACIÓN",
        "kpi_scheduled": "Trabajo Programado",
        "kpi_issues": "Problemas de Programación",
        "kpi_utilization": "Recursos Totales",
        "kpi_emergencies": "Emergencias",
        "no_data": "No hay órdenes de trabajo programadas.",
        "no_resources": "No hay datos de capacidad de recursos.",
        "fetch_error": "Error al cargar los datos de programación.",
        "optimizing": "La IA está nivelando la carga de recursos...",
        "optimize_fail": "La optimización de IA falló."
      },
      "features": {
        "title": "Catálogo de Funciones Lineales",
        "feature_id": "Código de Función",
        "description": "Descripción",
        "type": "Tipo de Función",
        "point": "Punto (ej. Válvula)",
        "linear": "Lineal (ej. Material)",
        "error_in_use": "No se puede eliminar: la función está en uso en una tubería."
      },
      "audit": {
        "title": "Explorador de Pistas de Auditoría",
        "history_for": "Historial para",
        "retrieving": "Recuperando registros de auditoría...",
        "no_records": "No se encontraron pistas de auditoría para este registro"
      },

    }
  },
  // 🇨🇳 中文 (Chinese Simplified)
  zh: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "卓越资产管理", version: "Teknora v1.0.4" },
      search: { placeholder: "搜索模块..." },
      menu: {
        settings: "设置", organization: "组织", domains: "域", field_config: "字段配置", classifications: "分类", importer: "通用导入器", cobie: "COBie 管理器", workflow: "工作流引擎", scripts: "操作脚本",
        analytics: "分析", dashboards: "BI 仪表板", report_designer: "报告设计器", report_wizard: "报告向导",
        assets: "资产", asset_registry: "资产登记", locations: "位置", categories: "资产类别", meters: "仪表", failure_codes: "故障代码",
        work_management: "工作管理", wo_tracking: "工单跟踪", labor_reporting: "调度器",
        resources: "资源", crafts: "工种", labor: "人工", person: "人员",
        service_desk: "服务台", service_requests: "服务请求", incidents: "事件登记",
        procurement: "采购", po: "采购订单", pr: "采购申请", rfq: "询价单", receiving: "接收", vendors: "供应商",
        contracts: "合同", contracts_master: "合同主表", sla: "服务水平协议",
        inventory: "库存", item_master: "物料主表", tools: "工具", balances: "库存余额", transfers: "出库与转移", storerooms: "库房",
        planning: "计划", pm_schedules: "预防性维护计划", safety_plans: "安全计划", hazards: "危险", precautions: "预防措施", tagouts: "挂牌锁定", job_plans: "作业计划",
        security: "安全", user_list: "用户列表", groups: "安全组", "recent": "最近访问"
      },
      user_settings: { title: "用户设置", default_info: "默认信息", personal_info: "个人信息", password_info: "密码信息", sign_out: "退出登录", system_info: "系统信息" },
      notifications: { title: "收件箱任务", new_alerts: "新", empty: "收件箱已清空", view_all: "查看所有活动" },
      sidebar: { queries: "可用查询", all_assets: "所有资产", operating_assets: "运行中资产", critical_assets: "关键资产", my_bookmarks: "我的书签", common_actions: "常用操作", new: "新建", move_assets: "资产移动", print_barcodes: "打印条码", create_report: "创建报告", wo_queries: "工单查询", all_wo: "所有工单", waiting_approval: "待审批", wip: "进行中", completed_today: "今日完成", bulk_approve: "批量审批", record_actions: "记录操作", save: "保存", delete: "删除", workflow_status: "工作流/状态", change_status: "更改状态", view_history: "查看历史", item_ops: "物料操作", add_to_storeroom: "添加到库房", inv_ops: "库存操作", reorder: "重订购", tax_ops: "税务操作", tax_category: "税务类别", create_po: "创建采购单", settings_group: "设置", system_settings: "系统设置", email_settings: "邮件设置", asset_ops: "资产操作", meter_readings: "仪表读数", hist_readings: "历史读数", report_downtime: "停机报告", downtime_hist: "停机历史", move_mod_asset: "移动/修改资产", asset_move_hist: "资产移动历史", create_related: "创建关联", create_incident: "创建事件", view_inc_hist: "事件历史", create_wo: "创建工单", sr: "服务请求", apply_sla: "应用SLA", approve_wo: "审批工单", start_work: "开始工作", complete_work: "完成工作", close_wo: "关闭工单", analytics: "分析", wf_history: "查看工作流历史", history_log: "历史日志", wo_costs: "工单成本", purchase_info: "采购信息", all_records: "所有记录", find_nav: "查找项目", more_actions: "更多操作", settings: "设置", export_data: "导出数据", audit_log: "审计日志", share_app: "分享应用" },
      apps: {
        ORGANIZATION: "组织", ASSET: "资产", LOCATION: "位置", WORKORDER: "工单", INVENTORY: "库存", CLASSIFICATION: "分类", VENDOR: "供应商", METER: "仪表", DOMAINS: "域", CRAFTS: "工种", STOREROOMS: "库房", ITEMS: "物料主表", INVENTORYUSAGE: "库存使用", MR: "物料请求", PR: "采购申请", PO: "采购订单", LABOR: "人工", PM: "维护计划", SAFETY: "安全计划", HAZARD: "危险", TAGOUT: "挂牌锁定", PRECUTION: "预防措施", SR: "服务请求", INCIDENT: "事件", ASSET_CATEGORIES: "资产类别", FAILURECLASS: "故障代码", RFQ: "询价单", CONTRACT: "合同", SLA: "服务级别协议", FAILURE_CODES: "故障代码",
        "VENDORS": "供应商", "TAGOUTS": "挂牌", "PRECAUTIONS": "预防措施", "INCIDENTS": "事件", "JOBPLAN": "作业计划", "ROLES": "角色", "TOOLS": "工具", "ROLE": "角色", "USER": "用户",
      },
      dashboard: { tab_bi: "KPI 模板", tab_inbox: "工作流收件箱", advanced_analytics: "高级分析", workflow_center: "执行中心", active_tasks: "待办任务", history_tasks: "历史任务", no_data: "未找到数据", take_action: "处理", previous: "上一页", next: "下一页", showing: "显示", of: "共", actual: "实际", target: "目标", kpi_graph: "KPI 图表" },
      username: "用户 ID",
      password: "密码",
      login_btn: "登录",
      forgot_pwd: "忘记密码？",
      login: {
        id_placeholder: "输入您的 ID",
        error_msg: "ID 或密码无效",
        server_error: "服务器连接失败",
        just_smart: "智能管理"
      },
      organizations: { title: "组织", org_id: "组织 ID", description: "描述", active: "激活？" },
      org_detail: { org_label: "组织", tabs: { organization: "组织", sites: "地点", map: "地图" }, fields: { currency1: "本位币 1", currency2: "本位币 2", item_set: "物料集", company_set: "公司集", item_status: "默认物料状态", active: "激活？" }, descs: { currency1: "主要货币", currency2: "次要货币", item_set: "物料集", company_set: "公司集" }, lookups: { currency: "货币", item_set: "物料集", company_set: "公司集", status: "状态", governorate: "省份" }, sites: { management: "地点管理", new_row: "新建行", of: "共", site_id: "地点 ID", description: "描述", active: "激活？", action: "操作", site_details: "地点详情", state: "省/州", contact: "主要联系人", fin_info: "财务/预算信息", yearly_budget: "年度预算", monthly_budget: "月度预算", utilization: "年度使用率", fin_health: "财务状况稳定。" }, toasts: { id_required: "组织 ID 必填！", saving: "正在保存...", success: "保存成功！", fail: "保存失败" } },
      domains: { title: "域", find_placeholder: "查找域...", new_domain: "新建域", domain_id: "域 ID", description: "描述", type: "类型", values: "值" ,
        save_btn: "保存", desc_placeholder: "域描述", synonym_values: "同义词值", new_row: "新建行", internal_val: "内部值", external_desc: "外部描述", default: "默认？", action: "操作", no_values: "未定义值。", toasts: { loading: "加载中...", load_fail: "加载失败", id_required: "必须填写 ID！", saving: "正在保存...", save_success: "保存成功！", save_fail: "保存失败" } },
      classifications: { parent: "上级分类", order: "排序", hierarchy: "分类结构", hierarchy: "层次路径", parent: "父级分类", gen_desc: "生成描述？", use_with: "用于对象", attributes: "属性", attr_id: "属性 ID", section: "部分", uom: "计量单位" },
      bim: { title: "BIM 专业集成器", subtitle: "高级 Revit 到 COBie 映射", waiting_translation: "正在等待模型转换...", tabs: { "3d": "3D 查看器", data: "数据表" }, preview_table_title: "COBie 组件预览", controls: { destination: "目标", select_site: "选择地点", uploads: "文件上传", select_cobie: "选择 COBie 文件", upload_revit: "上传 Revit 文件", models_ready: "模型就绪", preview_list: "预览模型", finalizing: "正在同步...", commit: "提交 BIM 集成" }, table: { asset_name: "资产名称", location: "空间 / 位置" } },
      importer: { title: "通用数据加载器", target_table: "目标表", download_template: "下载模板", upload_instruction: "选择要上传的 Excel 文件", field_mapping: "字段映射", excel: "Excel", ignore: "忽略", preview_title: "预览", execute_btn: "执行导入过程" },
      workflow: { title: "工作流引擎", subtitle: "自动化控制中心", export_btn: "导出 CSV", new_process: "新流程", loading: "加载中...", unnamed: "未命名流程", linked_to: "链接到", create_path: "创建新路径",
                  designer_title: "工作流逻辑设计器 (已启用回环)", publish_btn: "发布", loading_designer: "正在重建逻辑路径...", logic_palette: "逻辑调色板", config_title: "配置", node_label: "标签", assign_roles: "分配角色",
      post_action: "动作后脚本", select_lookup: "从查找中选择", script_hint: "* 多个脚本可以用逗号分隔。", status_auto: "状态自动操作", trigger: "触发器", target_status: "目标状态", cond_expr: "条件表达式 (Python)", escalation: "升级（小时）",
      table: {id: "身分证", name: "进程名称"},
      select_node: "选择要编辑的节点", options: {no_change: "无状态更改", change_status: "更改状态", select_status: "选择状态" }, lookups: {select_roles: "查找角色", select_scripts: "选择脚本" }, swal: { publish_title: "发布工作流？", publish_text: "这将与数据库同步引擎步骤。", confirm_publish: "是的，现在发布", delete_title: "清除逻辑？", delete_text: "您确定要删除吗", confirm_delete: "是的，删除所有内容" },
      toasts: { id_required: "请输入流程名称", saving: "正在同步工作流...", save_success: "工作流逻辑已同步！ 🚀", save_fail: "同步失败", purging: "正在清除工作流...", delete_success: "工作流已永久删除", delete_fail: "删除失败", fetch_fail: "加载工作流数据失败"}
      },
      field_config: { title: "元数据字段映射", table_name: "表名", field_name: "字段名", current_mappings: "当前映射：", field: "字段", linked_domain: "关联域" },
      scripts: {
        title: "动作脚本",
        subtitle: "管理自动化与逻辑模板",
        new_btn: "创建新脚本",
        search_placeholder: "按名称或对象搜索...",
        table: {
          name: "脚本名称",
          object: "目标对象",
          created: "创建日期"
        },
        toasts: {
          fetch_fail: "加载脚本失败"
        }
      },
      studio: { schema_explorer: "架构浏览器", target_context: "目标对象上下文", name_placeholder: "给脚本起个名字...", engine_info: "引擎：PYTHON 3.10", console_title: "系统执行控制台", clear_console: "清除控制台", field_from: "字段来自", access_col: "访问数据库列：", db_model: "数据库模型", btns: { compile: "编译", compiling: "正在编译...", save_deploy: "保存并部署" }, toasts: { preserved: "脚本已保存！", compiled: "分析成功！" }, console: { init: "工作室初始化...", schema_sync: "架构同步成功。", schema_fail: "架构同步失败。", saved_prefix: "脚本保存成功", error_op: "保存出错。", compiling: "开始编译...", build_finish: "构建完成。", syntax_error: "语法错误。", build_fail: "构建失败", analyzing: "语法分析中..." } },
      reports: { title: "报告模板", new_btn: "创建新报告", search_placeholder: "搜索...", table: { name: "报告名称", ref_obj: "参考对象", updated: "最后更新" }, 
          toasts: { load_fail: "加载失败", clone_success: "报告已克隆", save_success: "模板已保存并发布！ 🚀", save_fail: "保存失败" },
          designer: {
                  title: "专业报告设计引擎", live_preview: "实时预览", publish: "发布模板", model_select: "模型选择", data_explorer: "数据资源管理器", components: "组件", page_break: "分页符", is_summary: "汇总报告？", user_params: "用户参数",
                  add_param: "添加输入字段", master_info: "主信息", relational_data: "关系数据", detail_tables: "明细表", tabs: { body: "正文内容", header: "页眉", footer: "页脚", css: "全局 CSS" },
                  fields: { wonum: "工单号", assetnum:"資產編號", desc: "描述", status: "状态", asset: "资产名称", location: "位置 ID", tasks_table: "任务表", mat_table: "计划物料", asset_basic: "资产基础信息", inv_basic: "库存基础信息", vend_basic: "供应商基础信息" }
                },
        },
      assets: { 
        map: {"gps_location": "地理位置 (GPS)", "gps_coordinates": "GPS 坐标"},
        list: { system_title: "资产管理系统", new_asset: "新增资产", all_orgs: "所有组织", all_sites: "所有站点", db_total: "总计:", display_page: "页码:", navigate_hint: "使用箭頭進行導航", col_site: "站点", col_org: "组织"  }, 
        modal: { migration_title: "批量资产迁移", caution_prefix: "警告：您即将迁移", caution_suffix: "个资产。", dest_label: "新目标位置", placeholder: "选择位置...", abort: "中止", execute: "执行迁移" },
        headers: { asset_num: "资产编号", desc: "描述", status: "状态", downtime: "总停机时间", site: "站点" },
        tabs: { details: "资产详情", spare_parts: "备件", safety: "安全", meters: "仪表", specs: "规格", history: "工作历史", map: "地图", bim: "3D视图", ai: "人工智能分析", eval: "评估", attachments: "附件" },
        sections: { "linear_details": "线性参考详细信息", general: "常规信息", details: "详情", finance: "地址与财务", image: "资产图片", audit: "审计信息", bim_info: "BIM信息", reliability: "可靠性分析" },
        fields: { "is_linear": "是否为线性资产？", "start_measure": "起始测量", "end_measure": "结束测量", "measure_unit": "测量单位", "direction": "流向", type: "资产类型", location: "位置", parent: "父资产", category: "资产类别", is_running: "资产运行中？", serial: "序列号", item: "旋转备件", failure: "故障等级", safety_plan: "安全计划", vendor: "供应商", price: "采购价格", replace: "更换成本", priority: "优先级", ytd_cost: "本年度成本" },
        meters: { seq: "序列", name: "仪表", reading: "最后读数", date: "读数日期", inspector: "检查员", remarks: "备注" },
        ai: { title: "资产智能", run: "运行诊断", summary: "技术摘要", recommend: "建议", telemetry: "正在分析遥测数据..." },
        spare_fields: { item: "旋转备件", qty: "数量", issued: "已发数量", remarks: "备注", item_details: "项目详情" },
        safety: { plan_card: "关联安全计划", active_plan: "活跃安全计划", no_plan: "未关联计划", link_plan: "关联安全计划", change_plan: "更改计划", hazard_title: "资产特定危险", hazard_num: "危险", hazard_type: "类型 / 优先级", no_hazards: "没有与此资产关联的特定危险。", add_hazard: "添加危险", loto_title: "锁定/挂牌 (LOTO)", tag_id: "挂牌 ID", req_state: "所需状态", no_loto: "未定义隔离点。", add_loto: "添加隔离点", applying_proto: "正在应用安全协议..." },
        meters: { title: "关联仪表", details_title: "仪表详情", seq: "序列", meter_name: "仪表名称", meter_type: "仪表类型", uom: "计量单位", active_status: "激活？", last_reading: "最后读数", last_date: "读数日期", inspector: "检查员", remarks: "备注", new_meter: "新仪表" },
        specs: { classification: "分类", select_class: "选择分类...", tech_specs: "技术规格", attribute: "属性", value: "值", uom: "计量单位", data_type: "数据类型", attr_details: "属性详情", select_val: "选择值" },
        history: { title: "历史工单", wo_num: "工单号", finish_date: "完成日期", no_history: "未找到此资产的历史工单。", fetching: "正在获取历史记录...", wo_type: "类型" },
        bim: { model_status: "模型状态", linked: "已关联并激活", not_linked: "未关联", upload_revit: "上传 Revit (.rvt)", urn_label: "模型 URN", "show_3d": "查看数字孪生 (3D)", "not_linked": "未链接到3D模型" },
        ai: { title: "资产智能", sub_title: "人工智能分析器", tagline: "工业物联网预测性诊断", run_btn: "运行诊断", analyzing: "正在分析遥测流...", health_score: "健康评分", thermal: "热警报", vibration: "振动警报", tech_summary: "技术摘要", recommendations: "建议", sensors_chart: "传感器 vs 临界限制", init_prompt: "点击运行诊断以初始化人工智能分析", critical: "关键", normal: "正常", stable: "稳定", detected: "检测到", "predictive_trajectory": "予測故障トラジェクトリ", "est_failure": "推定故障", "loading_pred": "予測モデルを生成中..." },
        "features": {
          "feature_id": "要素 ID",
          "label": "标签",
          "start": "起始测量",
          "end": "结束测量 (空 = 点)",
          "value": "值 (如 500mm)",
          "details": "要素详细信息",
          "y_offset": "Y轴偏移 (右/左)",
          "z_offset": "Z轴偏移 (深度/高度)"
        },
    

      }, 
      common: { "days": "天", "weeks": "周", "months": "月", "years": "年", "daysList": { "saturday": "星期六", "sunday": "星期日", "monday": "星期一", "tuesday": "星期二", "wednesday": "星期三", "thursday": "星期四", "friday": "星期五" }, "select": "选择", "search": "搜索", "pending": "待处理", "pendingSelection": "--- 等待选择 ---",confirm: "确认", save_settings: "保存人工智能配置", selected: "已选资产", bulk_move: "批量迁移", change_status: "更改状态", cancel: "重置", save: "保存", cancel: "取消", delete: "删除", back: "返回", record: "记录", total: "总计", print: "打印", active: "激活", critical: "关键", warning: "警告", healthy: "健康", of: "之", new_row: "新行", "filter": "筛选...", "save_success": "保存成功", "save_fail": "保存失败", "delete": "删除", "delete_success": "删除成功",    "delete_fail": "删除失败", "are_you_sure": "您确定吗？", "cancel": "取消", "confirm": "确认", "first": "第一页", "last": "最后一页", "next": "下一页", "prev": "上一页", "sar": "SAR", "all": "全部", "attachments": "附件", "history": "历史记录", "change_status": "更改状态", "totalRecords": "总记录数", "readOnly": "(只读)", "noDescription": "无描述", "recordLocked": "记录已被锁定，无法修改。", "descRequired": "描述是必填项！", "actionDenied": "操作被拒绝", "cantDeleteStatus": "无法删除状态为 {{status}} 的记录", copy: "副本", cancel: "取消", clone: "克隆", back: "返回", yes: "是", no: "否", "main": "主要信息", "save": "保存", "change_status": "更改状态", "history": "历史记录", "delete": "删除", "org": "组织", "site": "站点", "new_row": "新增行", "location": "位置", "asset": "资产", "no_records": "未找到记录", "saving": "保存中...", "save_success": "保存成功！", "save_fail": "保存失败", "are_you_sure": "您确定吗？", "yes_delete": "是的，删除！", "cancel": "取消", "delete_success": "删除成功", "delete_fail": "删除失败：", "clear_filters": "清除筛选", "all": "全部", "syncing": "同步中...", "showing": "显示", "total": "总计", "created_by": "创建者", "changed_date": "修改日期"},
      toasts: { save_success: "保存成功", save_fail: "保存失败", load_fail: "数据加载失败", delete_success: "删除成功" },
      swal: { delete_title: "您确定吗？", delete_text: "您即将删除资产：", confirm_delete: "是的，删除记录" },
      "ai_settings": {
        "title": "人工智能工程师设置",
        "sub_title": "人工智能预测性维护引擎",
        "enable_label": "启用自动预测性维护",
        "enable_sub": "基于人工智能分析自动创建工单",
        "target_lang": "报告和任务语言",
        "threshold": "决策置信度阈值",
        "auto_tasks": "自动生成工作任务 (WOTasks)",
        "task_desc": "在任务表中自动编写工作步骤",
        "max_tasks": "每张工单的最大步骤数",
        "section": "部分",
        "technicalDetails": "技术细节"
      },
      "export_technical_report": "导出技术报告 (PDF)",
      "availability": "可用性",
      "mtbf": "平均故障间隔时间",
      "mttr": "平均修复时间",
      "hrs": "小时",
      "reliability_score": "可靠性评分",
      "score": "分数",
      "downtime_history_trend": "停机历史趋势 (最近10次事件)",
      "values_in_hours": "数值单位：小时",
      "timeline_event_date": "时间轴 (事件日期)",
      "downtime_hours": "停机时间 (小时)",
      "no_downtime_records": "目前没有找到该资产的停机记录。",
      "reliability_analysis": "可靠性分析",
      "total_failures": "总故障数",
      "total_down_time": "总停机时间",
      "last_calculation": "最后计算时间",
      "maintenance_strategy_note": "维护策略说明",
      "high_mttr_detected": "检测到高 MTTR。建议：评估此资产类别的备件可用性和技术培训。",
      "critical_availability": "可用性处于临界水平。请考虑增加预防性维护频率或计划大修。",
      "nominal_performance": "资产性能处于标称参数范围内。继续执行标准预防性维护计划。",
      "current_load_factor": "当前负载系数",
      "optimal": "最佳",
      statusModal: {
        "loadError": "无法加载状态",
        "selectFirst": "请先选择状态",
        "updating": "正在更新状态...",
        "success": "状态已更新",
        "failed": "更新失败",
        "changeStatus": "更改状态：",
        "currentStatus": "当前状态",
        "availableStatuses": "可用状态",
        "loading": "加载中...",
        "chooseStatus": "选择状态...",
        "memo": "理由 / 备注",
        "enterNotes": "输入您的备注...",
        "cancel": "取消",
        "update": "更新"
      },
      attachmentsModal: {
        "loadError": "加载文件时出错",
        "uploadSuccess": "文件附加成功",
        "uploadFailed": "上传失败",
        "deleteConfirmTitle": "您确定吗？",
        "deleteConfirmText": "您即将永久删除 '{{name}}'。这将从我们的服务器中删除该文件。",
        "btnYesDelete": "是的，删除它！",
        "btnCancel": "取消",
        "processingDelete": "正在处理删除...",
        "deletedTitle": "已删除！",
        "deletedText": "附件已成功移除。",
        "deleteFailed": "删除失败",
        "headerTitle": "附件库",
        "linkingTo": "链接到：",
        "filesFound": "找到的文件：",
        "uploadBtn": "上传新文档",
        "thName": "名称",
        "thOwner": "所有者",
        "thStatus": "状态",
        "thActions": "操作",
        "statusPrivate": "私有",
        "statusPublic": "公开",
        "noDocs": "尚未链接任何文档"
      },
      enterMeters: {
        "noMeters": "没有与资产关联的仪表：",
        "saving": "正在保存读数...",
        "enterAtLeastOne": "请输入至少一个新读数",
        "saveSuccess": "所有读数保存成功！",
        "saveFailed": "保存读数失败",
        "title": "输入仪表读数 | 资产：",
        "titleLoc": "输入仪表读数 | 位置：",
        "thIdentification": "仪表标识",
        "thNewReading": "* 新读数",
        "thReadingDate": "* 读数日期",
        "thMeterType": "仪表类型",
        "thLastRecorded": "最后记录",
        "noDescription": "无描述",
        "enterValue": "输入值...",
        "notAvailable": "无",
        "operator": "操作员：",
        "btnCancel": "取消",
        "btnUpdate": "更新读数"
      },
      emailSettings: {
        "loadFailed": "加载设置失败",
        "saveSuccess": "邮件设置保存成功！",
        "saveFailed": "保存设置失败",
        "connecting": "正在连接到SMTP服务器...",
        "connFailed": "连接失败！",
        "title": "SMTP 配置",
        "subtitle": "邮件服务器设置",
        "outgoingTitle": "发件箱 (SMTP - 发送)",
        "incomingTitle": "收件箱 (IMAP - 监控)",
        "lblHost": "SMTP 主机",
        "lblPort": "SMTP 端口",
        "lblUser": "SMTP 用户名/电子邮件",
        "lblPass": "SMTP 密码",
        "lblSender": "系统发件人邮箱 (发件人)",
        "lblImapHost": "IMAP 主机",
        "lblImapPort": "IMAP 端口",
        "enableImap": "启用收件箱监控 (RFQ 雷达)",
        "imapDesc": "自动从收件箱获取并解析供应商报价。",
        "gmailNote": "对于Gmail，请使用Google安全中的“应用密码”。启用2FA时，帐户密码将不起作用。",
        "btnTest": "测试",
        "btnCancel": "取消",
        "btnSave": "保存配置"
      },
      locationDetails: {
        "noBimModel": "此位置未链接 3D 模型",
        "noBimLinked": "此位置未链接到 BIM",
        "locMandatory": "位置是必填字段！",
        "saving": "正在保存更改...",
        "saveSuccess": "位置保存成功",
        "saveFailed": "保存失败：",
        "deleteTitle": "您确定吗？",
        "deleteText": "您即将删除位置 {{id}}。此操作无法撤消！",
        "btnYesDelete": "是的，删除它！",
        "btnCancel": "取消",
        "deleting": "正在删除位置...",
        "deleteSuccess": "位置删除成功",
        "deleteFailed": "删除失败！",
        "uploadingRevit": "正在上传和转换 Revit 模型...",
        "revitSuccess": "模型链接成功！",
        "uploadFailed": "上传失败：",
        "loadingCtx": "正在加载位置上下文...",
        "tooltipChangeStatus": "更改状态",
        "tooltipStatusHistory": "状态历史记录",
        "tooltipDelete": "删除",
        "btnSave": "保存",
        "lblLocation": "位置",
        "lblDescription": "描述",
        "btnRevitLinked": "已链接 Revit",
        "tabLocation": "位置",
        "tabAssets": "资产",
        "tabSpecs": "规格",
        "tabSafety": "安全",
        "tabMeters": "仪表",
        "tab3D": "3D 视图",
        "tabHistory": "历史记录",
        "secIdentity": "位置标识",
        "lblStatus": "状态",
        "lblType": "类型",
        "lblParentLoc": "父位置",
        "lblSiteID": "站点 ID",
        "secGeoInfo": "地理和地址信息",
        "lblServiceAddr": "服务地址",
        "lblBimSpaceId": "BIM 空间 ID",
        "lblGisCoords": "GIS 坐标",
        "secRefImage": "参考图片",
        "btnUploadPhoto": "上传照片",
        "thAssetNum": "资产编号",
        "thStatus": "状态",
        "lblClass": "分类",
        "thAttr": "属性",
        "thDesc": "描述",
        "thValue": "值",
        "titleHazards": "该位置报告的危险",
        "btnAddHazard": "添加危险",
        "lblSelectHazards": "选择危险",
        "thHazard": "危险",
        "thPrecaution": "预防措施",
        "titleLocMeters": "位置仪表",
        "showingMeters": "显示 {{current}} / {{total}}",
        "noMetersDef": "未定义仪表",
        "thSeq": "序号",
        "thMeterNum": "仪表编号",
        "thType": "类型",
        "thUOM": "测量单位",
        "thActive": "活动",
        "newMeter": "新仪表",
        "clickNewRow": "点击“新行”向此位置添加仪表",
        "titleMeterConfig": "仪表详细信息配置",
        "newEntry": "新条目",
        "lblMeterNum": "* 仪表编号",
        "lblMeterType": "仪表类型",
        "lblUOM": "测量单位",
        "lblMeterActive": "仪表处于活动状态",
        "lblLastReading": "最后读数",
        "lblReadingDate": "读数日期",
        "lblInspector": "仪表检查员",
        "lblRemarks": "备注/评论",
        "placeholderRemarks": "输入有关此仪表的技术说明...",
        "btnAddMeterRow": "添加新仪表行",
        "titleModelStatus": "模型状态",
        "statusLinked": "已链接且活动",
        "statusNotLinked": "未链接",
        "btnUploadRevit": "上传 Revit (.rvt)",
        "titleHistory": "交易历史和审计日志",
        "lblChangedBy": "更改者：",
        "failedFetchAttr": "获取属性失败"
      },
      "locationList": {
        "loadFailed": "无法从  服务器加载位置。",
        "title": "位置",
        "searchPlaceholder": "全局搜索...",
        "btnClearAll": "全部清除",
        "btnExport": "导出",
        "btnNewLocation": "新位置",
        "thLocationId": "位置 ID",
        "thDescription": "描述",
        "thType": "类型",
        "thStatus": "状态",
        "thSite": "站点",
        "optAll": "全部",
        "optOperating": "运行中",
        "optDecommissioned": "已退役",
        "fetchingData": "正在从服务器获取数据...",
        "noRecords": "未找到匹配的记录。",
        "recordsFound": "找到记录：",
        "page": "页码："
      },
      "universalLookup": {
        "selectValue": "选择值：",
        "total": "总计",
        "searchPlaceholder": "按代码或描述搜索...",
        "valueCode": "值/代码",
        "description": "描述",
        "site": "站点",
        "synchronizing": "正在同步...",
        "noRecords": "未找到匹配的记录。",
        "loadingMore": "正在加载更多记录...",
        "results": "结果：",
        "cancel": "取消"
      },
      "statusHistory": {
        "title": "状态审计跟踪",
        "loading": "正在加载历史记录...",
        "noRecords": "没有记录此项目的状态更改。",
        "initial": "初始",
        "btnClose": "关闭"
      },
      "personalInfo": {
        "updateSuccess": "个人资料更新成功",
        "sessionExpired": "会话已过期，请重新登录",
        "updateFailed": "更新失败",
        "title": "个人信息和默认设置",
        "lblDisplayName": "完整显示名称",
        "lblEmail": "电子邮件地址",
        "lblDefaultOrg": "默认组织",
        "selectOrg": "选择组织...",
        "lblDefaultSite": "默认站点",
        "selectSite": "选择站点...",
        "lblDefaultLang": "默认语言",
        "btnCancel": "取消",
        "btnSave": "应用并保存更改",
        "securityTitle": "安全与双重身份验证 (2FA)",
        "enable2FA": "启用双重身份验证 (2FA)",
        "googleAuth": "谷歌身份验证器 (Google Authenticator)",
        "emailOTP": "电子邮件验证码 (Email OTP)",
        "configure2FA": "配置 2FA 设置",
        "scanQR": "请使用 Google Authenticator 或 Authy 扫描此二维码，然后在下方输入6位验证码进行验证。",
        "btnVerify": "验证",
        "setupSuccess": "2FA 设置成功！",
        "invalidCode": "验证码无效",
        "failedQR": "生成二维码失败"
      },
      "appSettings": {
        "savingSettings": "正在保存设置...",
        "saveSuccess": "设置更新成功！",
        "saveFailed": "保存设置失败。",
        "title": "企业配置",
        "org": "组织",
        "tabs": {
          "WORKORDER": "工单",
          "ASSET": "资产登记",
          "INVENTORY": "仓库与库存",
          "PURCHASE": "采购",
          "PR": "采购申请",
          "JP": "作业计划",
          "PM": "预防性维护",
          "MR": "物料申请",
          "SR": "服务申请"
        },
        "systemRules": "{{tab}} 系统规则",
        "prefix": "序列前缀",
        "preview": "预览",
        "seed": "起始值 (Seed)",
        "valuationStrategy": "估值策略",
        "movingAvg": "移动平均 (推荐)",
        "fifo": "先进先出 (FIFO)",
        "lifo": "后进先出 (LIFO)",
        "allowNegative": "允许负余额",
        "negativeWarning": "警告：影响财务准确性",
        "encrypting": "加密与传输中...",
        "auditLogged": "所有更改均记录在审计跟踪中",
        "btnCancel": "取消",
        "btnSave": "保存系统策略"
      },
      "workflowAction": {
        "successMove": "工作流已成功推进！ 🚀",
        "failedMove": "操作失败",
        "btnRoute": "路由工作流",
        "modalTitle": "工作流操作",
        "assignedAs": "分配给您的角色：",
        "defaultInstruction": "请查看并采取操作。",
        "lblChoosePath": "选择路径",
        "valSelectPath": "请选择一条路径",
        "optApprove": "批准 / 前进",
        "optReject": "拒绝 / 退回",
        "lblMemo": "操作备忘录 / 评论",
        "placeholderMemo": "在此处添加您的评论...",
        "btnCancel": "取消",
        "btnComplete": "完成步骤"
      },
      "meterHistory": {
        "title": "历史仪表读数",
        "lblAsset": "资产",
        "fetching": "正在获取档案...",
        "noRecords": "未找到此资产的历史读数。",
        "thMeterName": "仪表名称",
        "thReadingVal": "读数值",
        "thReadingDate": "读数日期",
        "thEnteredBy": "输入者",
        "thEntryDate": "输入日期",
        "btnClose": "关闭历史记录",
        "lblLocation": "位置",
        "noRecordsLoc": "未找到此位置的历史读数。",
      },
      rpt_print: "列印報告",
      no_templates: "暫無模板可用",
      "wo": {
        "tabs": { "workOrder": "工单", "plans": "计划", "assignments": "分配", "actuals": "实际", "safety": "安全", "failure": "故障报告" },
        "subTabs": { "tasks": "任务", "labor": "劳动力", "materials": "物料", "tools": "工具", "services": "服务" },
        "headers": { "workOrder": "工单", "status": "状态", "totalCost": "总成本", "activeSla": "SLA 监控中", "targetRes": "目标解决时间", "targetResp": "目标响应时间" },
        "sections": { "assetDetails": "资产详情", "scheduling": "排程信息", "responsibility": "责任归属", "laborAssign": "劳动力分配", "totalAssign": "分配总数" },
        "fields": { "description": "描述", "location": "位置", "asset": "资产", "workType": "工作类型", "safetyCode": "安全代码", "supervisor": "主管", "failureClass": "故障分类", "targStart": "目标开始时间", "targFinish": "目标结束时间", "schedStart": "计划开始时间", "schedFinish": "计划结束时间", "earlyStart": "最早开始时间", "lateFinish": "最晚结束时间", "actStart": "实际开始时间", "actFinish": "实际结束时间", "duration": "持续时间", "timeRemaining": "剩余时间", "predecessors": "前置任务", "includeTasks": "包含任务到日程中？", "site": "地点", "organization": "组织", "priorityHigh": "优先级：高" },
        "actions": { "routeWorkflow": "路由工作流", "wfHistory": "工作流历史", "changeStatus": "更改状态", "attachments": "附件", "printWO": "打印工单", "printSafety": "打印安全表", "history": "历史记录", "newTask": "新任务", "selectLoc": "选择位置", "selectAsset": "选择资产", "selectType": "选择类型", "selectSafety": "选择安全计划", "selectSup": "选择主管", "selectFail": "选择故障分类", "selectCraft": "选择工种", "selectLabor": "选择人员", "selectItem": "选择物品", "selectStore": "选择库房", "selectTool": "选择工具", "addLabor": "添加人员", "addMaterial": "添加物料", "addTool": "添加工具", "addService": "添加服务", "newAssign": "新分配", "compAssign": "完成分配", "createMR": "创建物料申请", "yesCreate": "是，创建", "yesChange": "是，更改", "approve": "批准", "cancel": "取消", "startWork": "开始工作", "close": "关闭", "complete": "完成", "selectProblem": "选择问题", "selectCause": "选择原因", "selectRemedy": "选择解决措施" },
        "tables": { "sequence": "序号", "taskDesc": "任务描述", "estDur": "预估时长", "status": "状态", "craft": "工种", "labor": "人员", "qty": "数量", "hrs": "小时", "rate": "费率", "lineCost": "行成本", "lineType": "行类型", "itemNum": "物品编号", "description": "描述", "unitCost": "单价", "storeroom": "库房", "item": "物品", "material": "物料", "toolNum": "工具编号", "serviceDesc": "服务描述", "vendor": "供应商", "cost": "成本", "start": "开始", "finish": "结束", "failCode": "故障代码" },
        "footer": { "totalLabor": "劳动力总计", "totalMaterial": "物料总计", "assigned": "已分配（预估）", "toolsServ": "工具与服务", "totalActual": "实际总成本" },
        "safety": { "hazardsTitle": "危险与防范措施", "hazardCode": "危险代码", "hazardDesc": "危险描述", "precautions": "要求采取的措施", "noHazards": "此工单未发现危险。", "lotoTitle": "挂牌/上锁（隔离步骤）", "step": "步骤", "tagNum": "标签编号", "isoDesc": "隔离描述", "reqState": "要求状态", "completed": "已完成？", "noLoto": "无需隔离步骤。" },
        "failure": { "title": "故障分析", "currClass": "当前故障分类", "notDefined": "未定义", "problems": "问题", "causes": "原因", "remedies": "解决措施", "records": "记录" },
        "placeholders": { "desc": "输入描述...", "taskDesc": "任务描述..." },
        "messages": { "loadError": "加载失败", "taskStatusLocal": "任务状态已更新", "selectItemStore": "请选择物品和库房", "duplicateReqTitle": "重复申请", "duplicateReqText": "{{item}} 已有申请。是否再建一个？", "creatingMR": "正在创建申请...", "mrCreated": "申请 {{num}} 创建成功", "mrFail": "创建申请失败", "confirmStatusChange": "确定将 {{wonum}} 的状态更改为 {{status}} 吗？", "statusSuccess": "状态已更改", "statusFail": "更改状态失败", "saving": "正在保存...", "deleteConfirm": "删除 {{wonum}}？此操作无法撤销！", "saveBeforeSLA": "应用 SLA 之前请先保存工单", "slaExists": "已应用 SLA！", "matchingSLA": "正在匹配 SLA...", "slaApplied": "SLA 应用成功", "noMatchingSLA": "未找到匹配的 SLA", "slaError": "SLA 引擎错误", "failureTreeLoaded": "已应用故障代码", "zeroBalance": "警告：{{store}} 中余额为零", "balanceOk": "获取价格：{{cost}} - 余额：{{bal}}", "storeError": "连接库房失败", "assetLinked": "已链接资产：{{asset}}", "openAssignError": "无法关闭：{{count}} 个分配未完成。", "budgetExceeded": "超出预算！", "assignComplete": "分配已完成", "actionNotAllowed": "{{status}} 状态下不允许此操作", "locked": "已锁定", "cantChangeCancel": "已取消的请求无法更改状态", "printFail": "创建 PDF 失败", "wfRouted": "工作流路由成功！🚀", "wfFail": "工作流路由失败", "taskStatusChanged": "任务 {{task}} 状态已更改为 {{status}}", "noLaborAssign": "尚未分配人员。", "updateTaskProg": "更新任务进度", "noMaterials": "尚未报告物料。点击添加。", "linkedMRs": "链接的物料申请", "stocknobalance": "⚠️警告：此商品在仓库中的余额为零" },
        "linearDefect": {
          "title": "线性缺陷位置",
          "startMeasure": "起始测量",
          "endMeasure": "结束测量 (可选)",
          "unit": "单位",
          "yOffset": "Y 轴偏移 (m)"
        },
        "costs": {
          "title": "工单成本",
          "estimated": "估算成本",
          "actual": "实际成本",
          "labor": "人工",
          "materials": "材料",
          "tools": "工具",
          "services": "服务",
          "total": "总计",
          "variance": "差异 (实际 - 估算)",
          "calculating": "计算中...",
          "no_data": "暂无数据。"
        },
        "purchase_info": {
          "title": "相关采购信息",
          "mr_title": "领料单 (MR)",
          "pr_title": "请购单 (PR)",
          "po_title": "采购订单 (PO)",
          "mr_num": "MR 编号",
          "pr_num": "PR 编号",
          "po_num": "PO 编号",
          "vendor": "供应商",
          "status": "状态",
          "req_date": "需求日期",
          "total_cost": "总成本",
          "fetching": "数据获取中...",
          "no_records": "未找到记录。"
        },
    
      },
      "pm": {
        "tabs": { "pm": "预防性维护", "frequency": "频率", "sequence": "序列", "seasonaldates": "季节性日期", "forecast": "预测" },
        "sections": { "assetLoc": "资产与位置", "defaults": "默认设置", "compliance": "合规元数据", "siteContext": "站点信息", "timeBased": "基于时间的间隔", "meters": "仪表读数", "sequences": "作业计划序列", "seasonal": "每周活动窗口", "projections": "维护预测日志" },
        "fields": { "pmNum": "PM 编号", "description": "描述", "status": "状态", "site": "地点", "asset": "资产", "location": "位置", "route": "路线", "counter": "当前计数器", "jpnum": "作业计划", "worktype": "工作类型", "supervisor": "主管", "glaccount": "总账科目", "woStatus": "默认状态", "priority": "优先级", "lastStart": "上次开始", "lastComp": "上次完成", "nextDue": "下次到期", "forecastFlag": "预测标志", "org": "组织", "freqInt": "频率间隔", "freqUnit": "频率单位", "targStart": "目标开始时间" },
        "actions": { "forecast": "预测", "savePM": "保存", "addMeter": "添加仪表", "addStep": "添加步骤", "newPM": "新 PM 记录" },
        "tables": { "meterName": "仪表名称", "freq": "频率", "nextProj": "下次预测", "seq": "序列", "jpnum": "作业计划", "fcDate": "预测日期", "targetJp": "目标计划", "estCost": "估算成本", "status": "状态", "woNum": "工单号", "generated": "已生成", "projected": "预计" },
        "messages": { "executingForecast": "正在计算...", "forecastSuccess": "预测成功", "forecastFail": "预测失败", "seasonalInfo": "选中的日期为允许执行的日期。", "noMeters": "未定义仪表。", "noSeq": "循环序列已禁用。", "noForecasts": "暂无预测。", "showingProjections": "显示 {{count}} 条记录", "fetchListError": "加载 PM 记录失败", "syncingList": "正在与服务器同步...", "noRecords": "未找到匹配的记录。" },
        "placeholders": { "desc": "输入描述...", "globalSearch": "全局智能搜索..." },
        "headers": { "masterDir": "PM 主目录" },
        "footer": { "dbTotal": "数据库总计:", "currentPage": "当前页面:", "useNavArrows": "使用导航箭头" }
      },
      "workflowHistory": {
        "title": "工作流审计跟踪",
        "trackingId": "跟踪 ID:",
        "fetching": "正在获取记录...",
        "currentTask": "当前活动任务",
        "since": "自:",
        "by": "由",
        "noHistory": "此交易尚无历史记录",
        "closeBtn": "关闭历史记录"
      },
      "pr": {
        "headers": { "prList": "采购申请" },
        "actions": { "newPR": "新建申请", "clearFilters": "清除筛选", "routeWf": "路由工作流" },
        "tabs": { "pr": "采购申请", "prlines": "申请行" },
        "sections": { "general": "常规信息", "financial": "财务摘要" },
        "fields": { "prNum": "申请编号", "requestedBy": "申请人", "reqDate": "需求日期", "refMr": "参考物料申请", "vendor": "供应商", "glAccount": "总账科目" },
        "financial": { "subtotal": "小计", "taxTotal": "税额总计", "grandTotal": "总计" },
        "tables": { "prNum": "申请编号", "description": "描述", "status": "状态", "totalCost": "总成本", "reqDate": "申请日期", "site": "站点", "itemNum": "物品编号", "itemType": "类型", "qty": "数量", "unitCost": "单价", "tax": "税率", "lineTotal": "行总计", "taxCat": "税务类别" },
        "messages": { "loadFailed": "无法加载采购申请", "syncing": "同步记录中...", "noData": "没有匹配的数据", "noLines": "尚未添加申请行。", "fetchingMRLines": "正在获取物料申请行：{{mrnum}}...", "loadedMRLines": "已加载 {{count}} 行", "noMRLines": "此物料申请没有行", "failedMRLines": "加载物料申请行失败" },
        "swal": { "lockedTitle": "已锁定", "cantDeleteStatus": "无法删除状态为 {{status}} 的记录", "cantChangeCancel": "已取消的请求无法更改状态", "deleteWarnText": "这将永久删除采购申请及其所有行。" },
        "placeholders": { "desc": "输入描述...", "globalSearch": "全局智能搜索..." },
        "footer": { "showing": "显示", "totalRecords": "总记录数" }
      },
      "po": {
        "headers": { "poList": "采购订单" },
        "actions": { "newPO": "新建订单", "clearFilters": "清除筛选", "routeWf": "路由工作流", "addManualRow": "手动添加行", "wfHistory": "工作流时间线" },
        "tabs": { "po": "采购订单", "polines": "订单行" },
        "sections": { "general": "常规信息", "financial": "财务摘要", "lines": "采购订单行" },
        "fields": { "poNum": "订单号", "requestedBy": "申请人", "orderDate": "订单日期", "refPr": "参考采购申请", "vendor": "供应商", "glAccount": "总账科目" },
        "financial": { "subtotal": "小计 (净额)", "taxTotal": "税额", "grandTotal": "总计" },
        "tables": { "poNum": "订单号", "totalCost": "总成本", "orderDate": "订单日期", "itemNum": "物品编号", "itemType": "类型", "unitCost": "单价", "tax": "税率", "lineTotal": "行总计", "taxCat": "税务类别" },
        "messages": { "loadFailed": "无法加载采购订单", "syncing": "同步记录中...", "noData": "没有匹配的订单", "noLines": "尚未添加任何行。", "vendorRequired": "供应商为必填项。", "fetchingLines": "正在获取行: {{num}}...", "loadedLines": "成功加载 {{count}} 行", "noLinesFound": "此文档没有行", "failedLines": "加载行失败", "cantChangeCancel": "已取消的请求无法更改状态", "cantDeleteStatus": "无法删除状态为 {{status}} 的记录" },
        "swal": { "deleteWarnText": "这将永久删除采购订单及其所有行。" },
        "placeholders": { "desc": "输入描述...", "globalSearch": "全局智能搜索..." },
        "footer": { "showing": "显示" }
      },
      "mr": {
        "headers": { "mrList": "物料申请" },
        "actions": { "newMR": "新建申请", "clearFilters": "清除筛选", "routeWf": "路由工作流", "createUsage": "创建领用", "createUsageDesc": "创建发放/转移记录", "createPR": "创建采购申请", "createPRDesc": "创建采购申请", "addMaterial": "添加物料" },
        "tabs": { "mr": "申请信息", "mrlines": "申请行" },
        "sections": { "general": "常规信息", "financial": "财务摘要", "mrItems": "物料申请行", "financialCharging": "财务费用详情" }, 
        "fields": { "mrNum": "申请编号", "requestedBy": "申请人", "reqDate": "需求日期", "refMr": "参考申请", "vendor": "供应商", "glAccount": "总账科目", "targetStore": "目标库房", "chargeLoc": "费用位置", "chargeAsset": "费用资产", "chargeWO": "费用工单" },
        "financial": { "subtotal": "小计", "taxTotal": "税额总计", "grandTotal": "总计" },
        "tables": { "mrNum": "申请编号", "description": "描述", "status": "状态", "totalCost": "总成本", "enteredDate": "输入日期", "site": "站点", "itemNum": "物品编号", "itemType": "类型", "qty": "数量", "unitCost": "单价", "tax": "税率", "lineTotal": "行总计", "taxCat": "税务类别", "stockItem": "库存物料", "qtyReq": "申请数量", "estUnitCost": "预估单价" },
        "messages": { "loadFailed": "无法加载物料申请", "syncing": "同步中...", "noData": "没有匹配的数据", "noLines": "尚未添加申请行。", "fetchingMRLines": "正在获取申请行：{{mrnum}}...", "loadedMRLines": "已加载 {{count}} 行", "noMRLines": "此申请没有行", "failedMRLines": "加载申请行失败", "generating": "正在生成 {{docType}}...", "generatedSuccess": "{{docType}} {{docnum}} 生成成功！", "generateFail": "生成 {{docType}} 失败", "storeRequired": "必须选择库房！", "dateRequired": "必须填写需求日期！" },
        "swal": { "lockedTitle": "已锁定", "cantDeleteStatus": "无法删除状态为 {{status}} 的记录", "cantChangeCancel": "已取消的请求无法更改状态", "deleteWarnText": "这将永久删除申请及其所有行。" },
        "placeholders": { "desc": "输入描述...", "globalSearch": "全局智能搜索...", "chooseLoc": "选择位置", "selectAsset": "选择资产", "chargeWO": "计入工单" },
        "lookups": { "storerooms": "库房", "inventory": "库存查找", "locations": "站点位置", "assets": "资产登记", "workorders": "工单" },
        "footer": { "showing": "显示", "totalRecords": "总记录数" }
      },
      "contract": {
        "headers": { "masterNode": "合同主节点" },
        "placeholders": { "globalSearch": "全局搜索...", "desc": "输入合同摘要...", "termDesc": "输入条款细节..." },
        "actions": { "newContract": "新建合同", "save": "保存合同", "addTerm": "添加条款", "addLine": "添加行", "wfHistory": "工作流时间线" },
        "tabs": { "general": "常规", "slaperformance": "SLA (性能)", "termslegal": "条款与法律", "contractlines": "合同行" },
        "sections": { "identity": "身份与有效期", "communication": "通信中心", "auditInfo": "审计信息", "masterSLA": "SLA 链接", "slaBenchmarks": "SLA 基准", "termsList": "法律条款", "lines": "工作范围 / 行项目" },
        "options": { "supply": "供应合同", "labor": "劳务/服务合同", "lease": "租赁协议", "allTypes": "所有类型", "allStatus": "所有状态", "general": "通用", "payment": "付款", "termination": "终止", "warranty": "保修", "liability": "责任" },
        "fields": { "contractNum": "合同编号", "vendorRef": "供应商参考", "startDate": "开始日期", "endDate": "结束日期", "contractValue": "合同价值", "currency": "货币", "contactPerson": "联系人", "vendorEmail": "供应商邮箱", "slaRef": "SLA 参考", "respTime": "响应时间 (小时)", "resTime": "解决时间 (小时)", "uptime": "可用性目标 (%)", "penalty": "罚款 (每小时)", "grandTotal": "计算总额" },
        "tables": { "contractNum": "合同编号", "grandTotal": "总计", "clauseType": "条款类别", "clauseDesc": "条款详细信息", "lineDesc": "行描述", "rate": "费率", "lineTotal": "行总计" },
        "messages": { "fetchError": "同步失败", "syncing": "同步中...", "noData": "未找到合同", "descMandatory": "描述为必填项", "vendorSelected": "已选择供应商 {{name}}", "noTerms": "未定义条款", "noLines": "未定义行项目", "slaHint": "链接 SLA 会将其规则全局应用于相关工单或采购单。" },
        "swal": { "deleteTitle": "最终删除？", "deleteText": "这将永久删除主合同及其所有行。" },
        "footer": { "masterRecords": "主记录:", "currentPage": "当前页面:" }
      },
      "rfq": {
        "headers": { "rfqList": "询价单管理" },
        "tabs": { "rfq": "询价单", "rfqlines": "询价单行", "quotations": "报价" },
        "sections": { "general": "常规信息", "financial": "财务摘要" },
        "fields": { "requestedBy": "申请人", "reqDate": "需求日期", "refPr": "参考采购申请", "vendor": "供应商", "vendorEmail": "供应商邮箱", "glAccount": "总账科目" },
        "financial": { "subtotal": "小计", "taxTotal": "税额", "grandTotal": "总计" },
        "tables": { "rfqNum": "询价单编号", "totalCost": "总成本", "itemNum": "物品编号", "itemType": "类型", "unitCost": "单价", "tax": "税率", "taxCat": "税务类别" },
        "options": { "awarded": "已中标" },
        "actions": { "newRFQ": "新建询价单", "sendEmail": "发送邮件", "wfHistory": "工作流历史", "award": "授予并创建采购订单" },
        "messages": { "loadFailed": "加载失败", "syncing": "同步中...", "noData": "无数据", "noLines": "未定义行项目", "pullingPR": "提取采购申请行...", "prImported": "已导入！", "prFailed": "导入失败", "noEmail": "缺少邮箱！", "sending": "正在生成 PDF 并发送邮件...", "sendSuccess": "发送成功！", "sendFailed": "发送失败", "quotesHint": "供应商的报价将自动显示在此处。", "noQuotes": "尚未收到报价。", "awarding": "正在授予报价...", "awardSuccess": "报价已成功授予！", "poCreated": "已生成采购订单", "awardFailed": "授予失败" },
        "swal": { "sendTitle": "发送询价单？", "sendText": "是否通过电子邮件将此请求发送给 {{vendor}}？", "awardTitle": "授予报价？", "awardText": "这将其标记为中标，并自动生成采购订单。" },
        "footer": { "showing": "显示" }
      },
      "itemList": {
        "headers": { "master": "物料主表" },
        "actions": { "newItem": "新建物料" },
        "tables": { "item": "物料", "rotating": "可周转？" },
        "messages": { "syncFailed": "同步主数据失败", "syncing": "正在同步记录...", "noData": "没有匹配的物料" },
        "footer": { "totalItems": "物料总数：", "page": "页码" }
      },
      "itemDetails": {
        "tabs": { "item": "物料", "inventory": "库存", "vendors": "供应商", "specs": "规格", "assembly": "装配 (BOM)" },
        "sections": { "config": "物料配置", "units": "单位与追踪", "bomList": "BOM 列表", "supplierHistory": "采购与供应商历史" },
        "actions": { "save": "保存物料", "addStore": "添加到库房", "newSpec": "新规格", "addComponent": "添加组件" },
        "fields": { "itemSet": "物料集", "rotating": "周转？", "lotControl": "批次控制？", "inspectionReq": "需要检验？", "orderUnit": "订购单位", "issueUnit": "发放单位", "condition": "启用状况？", "sparepart": "作为备件？", "classification": "分类" },
        "tables": { "store": "库房", "avgCost": "平均成本", "balance": "余额", "attribute": "属性", "value": "值", "uom": "单位", "subItem": "子物料", "remarks": "备注", "vendor": "供应商代码", "supplierName": "供应商名称", "unitCost": "单价", "refPO": "参考订单", "activeVendors": "活跃供应商" },
        "messages": { "reqFields": "物料编号和描述为必填项！", "fetchingAttributes": "正在获取属性...", "attributesLoaded": "分类与属性已加载", "failedAttributes": "加载属性失败", "stockMsgTitle": "库存提示", "stockMsgDesc": "更新这些单位将影响所有站点的库房。", "noInventory": "没有此物料的库存记录。", "noSpecs": "未定义规格。", "noBom": "未定义 BOM。", "noVendors": "未找到采购记录。" },
        "swal": { "deleteText": "您即将删除物料 {{num}}。此操作无法撤销！" }
      },
      "changePassword": {
        "title": "更改密码",
        "currentPwd": "当前密码",
        "newPwd": "新密码",
        "confirmPwd": "确认新密码",
        "securityTitle": "安全验证",
        "googleAuthMsg": "输入来自 Google 身份验证器的 6 位代码以确认此更改。",
        "emailOtpMsg": "OTP 验证码已发送至您的电子邮箱。",
        "btnCancel": "取消",
        "btnUpdate": "更新密码",
        "btnVerify": "验证并更改",
        "btnBack": "返回",
        "errMismatch": "新密码不匹配！",
        "errLength": "密码长度至少为 6 个字符。",
        "msgVerifyReq": "请验证您的身份以继续。",
        "msgSuccess": "密码更改成功！",
        "errFailed": "更改密码失败。"
      },
      "userDetails": {
        "titleNew": "新用户",
        "titleEdit": "安全 / 用户",
        "btnSave": "保存用户",
        "saving": "保存中...",
        "secIdent": "用户身份信息",
        "lblLoginId": "登录 ID",
        "lblFullName": "全名",
        "lblDisplayName": "显示名称",
        "lblEmail": "电子邮件地址",
        "lblPassword": "密码",
        "lblActive": "激活状态",
        "secAccess": "安全与访问控制",
        "lblPrimaryRole": "主要安全角色",
        "lblSecRoles": "次要角色 (附加)",
        "lblDefOrg": "默认组织",
        "lblDefSite": "默认站点",
        "secDelegation": "工作委托",
        "lblDelegateTo": "委托工作给",
        "lblStartDate": "开始日期与时间",
        "lblEndDate": "结束日期与时间"
      },
      "receivingDetails": {
        "errLoadLines": "加载采购订单行失败",
        "errMissingDist": "请为所有行指定库房和数量",
        "errInspMandatory": "此项目必须进行检验决策",
        "errRejectExceeds": "请检查拒绝数量（不能超过到达数量）",
        "msgSuccess": "交易处理成功！",
        "msgAutoClosed": "自动关闭：",
        "swalAssignTitle": "库房分配",
        "swalAssignText": "项目 {{item}} 当前未分配到 {{loc}}。是否立即分配并完成接收？",
        "swalAssignBtn": "是，分配并完成",
        "errUnexpected": "接收过程中发生意外错误",
        "hubTitle": "批量接收中心",
        "poRef": "采购订单参考：",
        "btnExecuting": "执行中...",
        "btnConfirm": "确认接收",
        "tblItemsPending": "待接收项目",
        "colItemDetails": "项目详情",
        "colBalance": "余额",
        "lblQualityCheck": "需要质量检查",
        "lblUnits": "单位",
        "msgNoPending": "未找到待处理项目",
        "lblLandedCost": "到岸成本（总额外费用）",
        "lblBaseCost": "基础采购订单单位成本",
        "lblStoreMatrix": "库房分配矩阵",
        "btnSplitStore": "拆分库房",
        "colStoreroom": "库房",
        "colArrived": "已到达",
        "colRejected": "已拒绝",
        "plcClickSearch": "点击搜索 ->",
        "lookupSelectStore": "选择库房",
        "lblQcMatrix": "质量控制决策矩阵",
        "optSelectDecision": "-- 必填：选择决策 --",
        "optPassed": "全部通过（接受所有）",
        "optFailed": "全部拒绝（退回供应商）",
        "optPartial": "部分接受（检查拒绝字段）",
        "lblInvValuation": "库存估值（平均单位成本）",
        "lblNetArrived": "净到达库存",
        "msgSelectLine": "选择活动的采购订单行以开始处理"
      },
      "userList": {
        "title": "用户安全",
        "plcSearch": "搜索用户或电子邮件...",
        "btnNewUser": "新用户",
        "colUserId": "用户 ID",
        "colFullName": "全名",
        "colRole": "角色",
        "colSite": "站点",
        "colStatus": "状态",
        "colEmail": "电子邮件",
        "msgSyncing": "正在同步安全信息...",
        "lblNoRole": "无角色",
        "lblAll": "全部",
        "lblTotalUsers": "总用户数：",
        "lblPage": "页码",
        "errLoadUsers": "加载用户出错"
      },
      "crafts": {
        "headers": {
          "craftList": "工种目录"
        },
        "actions": {
          "newCraft": "新工种"
        },
        "tables": {
          "craftCode": "工种代码",
          "description": "描述",
          "stdRate": "标准费率/小时",
          "site": "站点",
          "org": "组织"
        },
        "messages": {
          "loadFailed": "加载工种失败"
        },
        "headers": {
          "craftList": "工种目录"
        },
        "tabs": {
          "skills": "工种技能与级别"
        },
        "sections": {
          "costing": "成本核算",
          "control": "控制"
        },
        "actions": {
          "newCraft": "新工种",
          "addSkill": "添加技能级别"
        },
        "tables": {
          "craftCode": "工种代码",
          "description": "描述",
          "stdRate": "标准费率/小时",
          "site": "站点",
          "org": "组织"
        },
        "fields": {
          "stdHourlyRate": "标准小时费率",
          "skillLevel": "技能级别（例如：专家、初级）",
          "hourlyRate": "小时费率"
        },
        "placeholders": {
          "enterLevel": "输入级别..."
        },
        "messages": {
          "loadFailed": "加载工种失败",
          "autoCalc": "根据技能总和自动计算",
          "noSkills": "尚未定义技能"
        }
      },
      "persons": {
        "headers": {
          "directory": "人员名录"
        },
        "actions": {
          "newPerson": "新增人员"
        },
        "tables": {
          "personId": "人员 ID",
          "name": "显示名称",
          "site": "站点",
          "email": "电子邮件",
          "phone": "电话"
        },
        "messages": {
          "loadFailed": "加载人员列表失败"
        },
        "headers": {
          "directory": "人员名录"
        },
        "tabs": {
          "profile": "个人资料",
          "contact": "联系人目录",
          "access": "系统访问"
        },
        "sections": {
          "personalInfo": "个人信息",
          "statusControl": "状态与控制",
          "contactsDirectory": "相关联系人"
        },
        "tables": {
          "personId": "人员 ID",
          "name": "显示名称",
          "site": "站点",
          "email": "电子邮件",
          "phone": "电话"
        },
        "fields": {
          "location": "位置",
          "firstName": "名字",
          "lastName": "姓氏",
          "title": "职位",
          "department": "部门",
          "currentStatus": "当前状态",
          "contactName": "联系人姓名",
          "position": "职务",
          "email": "电子邮件地址",
          "phone": "电话",
          "mobile": "手机",
          "primary": "主要",
          "address": "地址",
          "city": "城市",
          "country": "国家",
        },
        "actions": {
          "newPerson": "新增人员",
          "addContact": "添加联系人"
        },
        "messages": {
          "loadFailed": "加载人员列表失败",
          "noContacts": "尚未添加任何联系人",
          "accessControlled": "系统访问权限由用户安全模块控制"
        }
      },
      "jp": {
        "list": {
          "title": "工作计划目录",
          "new_plan": "新建计划",
          "filter_jp": "筛选计划...",
          "search_desc": "搜索描述...",
          "filter_site": "站点...",
          "no_records": "未找到工作计划",
          "fetch_error": "加载工作计划失败"
        },
        "fields": {
          "jpnum": "计划编号",
          "description": "描述",
          "status": "状态",
          "revision": "修订版",
          "site": "站点"
        },
        "details": {
          "load_error": "加载工作计划失败",
          "delete_warn": "您即将删除工作计划 {{jpnum}}。此操作无法撤销！"
        },
        "tabs": {
          "job_plan": "工作计划",
          "plans": "计划详情",
          "assets": "资产"
        },
        "subtabs": {
          "tasks": "任务",
          "labor": "人工",
          "materials": "物料",
          "tools": "工具"
        },
        "sections": {
          "details": "计划详细信息",
          "responsibility": "责任归属",
          "woassets": "工作资产与安全计划"
        },
        "fields": {
          "jpnum": "计划编号",
          "status": "状态",
          "description": "描述",
          "template_type": "模板类型",
          "duration": "时长（小时）",
          "supervisor": "主管",
          "class": "分类结构",
          "safety_plan": "安全计划",
          "revision": "修订版"
        },
        "table": {
          "seq": "序号",
          "duration": "时长",
          "craft": "工种",
          "labor": "员工",
          "qty": "数量",
          "hours": "工时",
          "rate": "费率",
          "item": "项目",
          "unitcost": "单位成本",
          "tool": "工具"
        }
      },
      "meters": {
        "list": {
          "title": "仪表定义",
          "search": "按编号或名称过滤...",
          "new_meter": "新建仪表",
          "no_records": "未找到仪表"
        },
        "fields": {
          "meter_num": "仪表编号",
          "meter_name": "仪表名称",
          "type": "类型",
          "uom": "单位",
          "active": "激活?",
          "remarks": "备注",
          "last_reading": "最后读数",
          "last_date": "最后读数日期",
          "rollovers": "翻转总数"
        },
        "tabs": {
          "meter": "仪表详情",
          "where_used": "使用位置"
        },
        "sections": {
          "info": "仪表信息",
          "additional": "附加详情",
          "stats": "仪表统计"
        },
        "where_used": {
          "linked_assets": "关联资产",
          "linked_locations": "关联位置",
          "linked_items": "关联项目",
          "searching": "🔍 正在系统中搜索...",
          "no_assoc": "在此类别中未找到关联。",
          "asset_num": "资产编号",
          "site": "站点",
          "status": "状态",
          "location": "位置",
          "item_num": "项目编号",
          "category": "类别"
        }
      },
      "asset_categories": {
        "list": {
          "title": "资产类别",
          "search": "搜索类别...",
          "new_category": "新建类别",
          "no_records": "未找到类别"
        },
        "fields": {
          "category_id": "类别代码",
          "description": "描述",
          "dep_method": "折旧方法",
          "life": "使用年限(年)"
        }
      },
      "export": {
        "loading": "正在提取数据...",
        "success": "导出成功！",
        "error": "导出数据时出错。"
      },
      "labor": {
        "list": {
          "title": "劳动力登记",
          "new": "新建劳动力",
          "total": "劳动力总数",
          "unique_crafts": "本页工种",
          "no_records": "未找到匹配的劳动力记录。"
        },
        "tabs": {
          "main": "主要",
          "person": "人员",
          "crafts": "工种",
          "log": "日志"
        },
        "sections": {
          "basic": "基本信息",
          "status": "状态与组织",
          "additional_crafts": "附加工种与专业技能"
        },
        "fields": {
          "personid": "人员参考",
          "primary_craft": "主要工种",
          "actual_rate": "实际费率（每小时）",
          "skill": "技能等级",
          "rate": "小时费率",
          "primary": "主要？",
          "laborcode": "劳动力代码",
          "fullname": "全名",
          "craft": "工种 / 行业"
        },
        "actions": {
          "add_craft": "添加工种"
        },
        "lookup": {
          "person": "选择人员",
          "craft": "选择工种",
          "skill": "选择技能"
        },
        "messages": {
          "no_crafts": "未找到工种关联"
        },
        "details": {
          "delete_warn": "您将无法恢复此记录！"
        }
      },
      "sr": {
        "list": {
          "title": "服务请求跟踪",
          "new": "新建请求"
        },
        "fields": {
          "srnum": "请求编号",
          "description": "描述",
          "reportedby": "报告人",
          "reportdate": "报告日期",
          "priority": "优先级"
        },
        "messages": {
          "no_records": "未找到服务请求"
        },
        "tabs": {
          "main": "服务请求",
          "related": "相关记录"
        },
        "sections": {
          "requester": "请求人与联系方式",
          "problem": "问题规格",
          "logistics": "物流与优先级"
        },
        "fields": {
          "phone": "电话",
          "email": "电子邮件",
          "asset": "资产",
          "location": "位置",
          "long_desc": "问题详细描述",
          "priority_1": "1 - 紧急 (立即)",
          "priority_2": "2 - 高 (当天)",
          "priority_3": "3 - 中 (72小时)",
          "priority_4": "4 - 低 (计划内)"
        },
        "lookup": {
          "person": "选择人员",
          "asset": "选择资产",
          "location": "选择位置"
        },
        "details": {
          "delete_new_only": "只能删除新建 (NEW) 的请求",
          "delete_warn": "这将永久删除此服务请求。",
          "wf_tip": "自动化工作流：保存后，使用“路由工作流”按钮将此请求发送以进行技术审查。",
          "wo_tip": "提示：您可以通过工作流操作或“创建工单”自动化脚本从该 SR 生成工单。"
        },
        "related": {
          "title": "SR 关联的工单：",
          "wonum": "工单编号",
          "worktype": "工作类型",
          "no_wo": "尚未为此 SR 创建工单。",
          "go_to_wo": "转到工单"
        }
      },
      "invusage": {
        "list": {
          "title": "库存使用历史",
          "new": "新建交易"
        },
        "types": {
          "all": "全部",
          "issue": "发放",
          "transfer": "转移",
          "return": "退回"
        },
        "tabs": {
          "lines": "使用行",
          "log": "交易日志"
        },
        "details": {
          "summary": "行摘要",
          "transfer_dest": "转移目标详情",
          "financial": "财务记账与参考"
        },
        "actions": {
          "add_item": "添加项目",
          "add_part": "添加零件",
          "select_mr": "选择物资申请"
        },
        "fields": {
          "stock_item": "库存项目",
          "issueunit": "发放单位",
          "qty": "数量",
          "unitcost": "单位成本",
          "linecost": "总行价值",
          "target_bin": "目标货位",
          "target_loc": "目标位置",
          "assetnum": "资产编号",
          "wonum": "工单参考",
          "glaccount": "借方总账科目",
          "usagenum": "使用ID",
          "type": "类型",
          "fromstore": "来源仓库",
          "lines": "行数",
          "enterby": "录入人"
        },
        "placeholders": {
          "select_item": "选择项目...",
          "dest_bin": "输入目标货位...",
          "choose_loc": "选择位置",
          "select_asset": "选择资产",
          "charge_wo": "记入工单"
        },
        "lookup": {
          "store": "仓库",
          "dest_store": "目标仓库",
          "mr": "选择已批准物资申请",
          "item": "库存查询",
          "loc": "站点位置",
          "asset": "资产登记",
          "wo": "工单"
        },
        "messages": {
          "req_fromstore": "请先选择一个仓库！",
          "mr_loaded": "从物资申请加载的项目：",
          "mr_fail": "加载物资申请项目失败",
          "insufficient_title": "库存不足！",
          "available": "可用",
          "create_pr": "创建采购申请 (PR)？",
          "btn_create_pr": "创建 PR",
          "processing": "正在处理库存调整...",
          "inventory_updated": "库存水平已成功更新",
          "cant_delete_comp": "无法删除已完成的交易！",
          "delete_warn": "这将永久删除草稿交易。",
          "req_fields": "描述和仓库是必填项！",
          "req_transfer": "转移操作需要目标仓库！",
          "locked_title": "记录已锁定",
          "locked_text": "此交易已完成，不能修改或撤销。",
          "cant_save_comp": "无法保存对已完成记录的更改",
          "balance_move": "注意：余额将在完成时移至",
          "upon_comp": "。"
        }
      },
      "downtime": {
        "title": "报告资产停机",
        "subtitle": "资产管理系统",
        "asset": "资产",
        "status": "离线记录",
        "start": "开始日期和时间",
        "end": "结束日期 (可选)",
        "type": "停机类型",
        "types": {
          "unplanned": "非计划 (故障)",
          "planned": "计划内 (维护)"
        },
        "duration": "计算持续时间",
        "hours": "小时",
        "prod_impact": "运营停机 (生产影响)",
        "btn_commit": "提交更改",
        "messages": {
          "recording": "正在记录停机时间...",
          "success": "停机记录成功",
          "validation_error": "格式错误：请检查所有字段",
          "server_error": "服务器错误：500"
        },
        "history": {
          "title": "资产停机历史记录",
          "subtitle": "资产性能跟踪",
          "no_records": "没有记录该资产的停机事件。",
          "duration_hrs": "持续时间 (小时)",
          "type_reason": "类型/原因",
          "impact": "影响",
          "reported_by": "报告人",
          "still_down": "仍在停机",
          "prod_loss": "生产损失",
          "technical": "技术",
          "active_down": "活动停机",
          "resolved": "已解决"
        }
      },
      "incidents": {
        "list": {
          "title": "事件登记簿",
          "new": "新建事件"
        },
        "fields": {
          "ticket_id": "工单编号",
          "priority": "优先级",
          "reported_by": "报告人"
        },
        "details": {
          "ticket": "事件工单",
          "general": "一般描述",
          "detailed": "详细信息",
          "context": "上下文与状态",
          "linked_asset": "关联资产",
          "workorder": "工单",
          "delete_warn": "您即将永久删除事件 {{ticket}}。此操作无法撤销！"
        },
        "lookup": {
          "asset": "选择关联资产",
          "loc": "选择位置"
        }
      },
      "tools": {
        "list": {
          "title": "工具主数据",
          "new": "新工具"
        },
        "fields": {
          "toolnum": "工具编号",
          "type": "类型",
          "is_stocked": "是否库存？"
        },
        "tabs": {
          "tool": "工具",
          "stores": "仓库",
          "vendors": "供应商",
          "specs": "规格",
          "quals": "资质"
        },
        "sections": {
          "config": "工具配置",
          "inventory": "库存与结余",
          "vendors": "采购与供应商历史记录",
          "quals": "所需资质"
        },
        "fields": {
          "toolnum": "工具编号",
          "type": "工具类型",
          "issueunit": "发放单位",
          "is_stocked": "是否库存工具？",
          "rotating": "轮换项目？",
          "calib_req": "是否需要校准？",
          "mfg": "制造商",
          "model": "型号",
          "class": "分类",
          "active_vendors": "活跃供应商"
        },
        "actions": {
          "add_store": "添加到仓库",
          "add_qual": "添加资质"
        },
        "tables": {
          "storeroom": "仓库",
          "balance": "结余",
          "attr": "属性",
          "value": "值",
          "uom": "单位",
          "qual": "资质",
          "vendor_id": "供应商 (公司编号)",
          "vendor_name": "供应商名称",
          "unitcost": "单位成本",
          "qty": "数量",
          "po": "关联采购订单"
        },
        "placeholders": {
          "toolid": "输入工具 ID...",
          "reg_supplier": "已注册供应商",
          "adj": "库存调整"
        },
        "lookup": {
          "type": "工具类型",
          "unit": "发放单位",
          "attr": "属性"
        },
        "messages": {
          "req_fields": "工具编号和描述是必填项！",
          "delete_warn": "您将无法撤销此操作！",
          "class_loaded": "分类和属性已加载",
          "stocked_note": "注意：库存工具通过仓库进行管理，需要库存记录来跟踪结余。",
          "no_stock": "库存中没有项目"
        }
      },
      "inventory": {
        "list": {
          "title": "库存登记簿"
        },
        "fields": {
          "itemnum": "项目编号",
          "location": "仓库",
          "balance": "结余",
          "avgcost": "平均成本"
        },
        "details": {
          "profile": "库存配置文件",
          "reorder_logic": "补货逻辑",
          "reorder_pt": "订货点",
          "eoq": "经济订货量",
          "critical_lvl": "临界水平",
          "critical_desc": "当结余达到订货点时自动生成采购申请 (PR)。",
          "current_stock": "当前库存水平",
          "avail_qty": "可用数量",
          "reserved_qty": "预留数量",
          "held_wo": "为工单保留",
          "avg_cost": "平均单位成本",
          "avg_cost_desc": "所有收货的加权平均值",
          "total_val": "总库存价值",
          "total_val_desc": "当前结余 × 平均成本",
          "last_cost": "上次收货成本",
          "last_cost_desc": "最近采购订单的成本",
          "val_method": "库存计价方法",
          "avg_method": "平均成本法",
          "val_desc1": "该项目使用",
          "val_desc2": "。单位成本在每次采购订单收货时自动重新计算，以反映市场价格波动。"
        },
        "tabs": {
          "balances": "结余",
          "trans": "交易历史记录",
          "costs": "成本"
        },
        "actions": {
          "adjustment": "库存调整"
        },
        "tables": {
          "qty": "数量",
          "actual_cost": "实际成本",
          "reference": "参考"
        },
        "messages": {
          "no_trans": "未找到交易历史记录"
        },
        "trans_types": {
          "receipt": "收货",
          "issue": "发放",
          "transfer": "转移",
          "adjustment": "调整"
        }
      },
      "storerooms": {
        "list": {
          "title": "仓库",
          "new": "新建仓库"
        },
        "fields": {
          "location": "仓库",
          "isdefault": "是否默认？",
          "inventory": "库存",
        },
        "details": {
          "profile": "仓库",
          "record": "仓库记录",
          "gen_settings": "常规设置",
          "filtered_by": "按 {{org}} 过滤",
          "select_org_first": "请先选择组织",
          "gl_accounts": "总账科目",
          "inv_control": "库存控制",
          "inv_control_desc": "此仓库的所有物料发放和接收都将与这些科目进行平衡。",
          "items_stocked": "库存项目"
        },
        "tabs": {
          "main": "主要",
          "inventory": "库存"
        },
        "fields": {
          "location": "位置 ID",
          "isdefault": "默认仓库？",
          "useinpo": "在采购订单中使用？",
          "invowner": "库存所有者",
          "controlacc": "控制科目",
          "shrinkacc": "损耗科目",
          "glaccount": "默认总账科目",
          "default": "默认"          
        },
        "lookup": {
          "person": "选择人员"
        },
        "tables": {
          "itemnum": "项目编号",
          "uom": "单位",
          "curbal": "当前结余",
          "reserved": "预留数量"
        },
        "messages": {
          "req_fields": "位置 ID 是必填项！",
          "req_org_site": "组织和站点是必填项！",
          "delete_warn": "您即将删除仓库 {{store}}。此操作无法撤销！"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Biblioteca de Códigos de Falla",
          "new": "Nueva Clase de Falla"
        },
        "details": {
          "profile": "Clase de Falla"
        },
        "fields": {
          "class": "Clase de Falla",
          "code": "Código",
          "desc_tech": "Descripción / Nombre Técnico"
        },
        "tables": {
          "problems": "Problemas (El Problema)",
          "causes": "Causas (Causa Raíz)",
          "remedies": "Remedios (La Acción)"
        },
        "placeholders": {
          "class": "EJ. PUMP-FAIL",
          "desc_tech": "Proporcione una descripción detallada de esta jerarquía de fallas...",
          "code": "Ingresar Código...",
          "desc": "Descripción Técnica..."
        },
        "messages": {
          "req_class": "¡El código de clase de falla es obligatorio!",
          "delete_warn": "Está a punto de eliminar la Clase de Falla {{class}}. ¡Esta acción no se puede deshacer!"
        }
      },
      "scheduler": {
        "title": "派工与调度",
        "ai_optimize": "AI 自动优化",
        "publish": "发布日程",
        "kpi_scheduled": "已排程工作",
        "kpi_issues": "调度问题",
        "kpi_utilization": "总资源",
        "kpi_emergencies": "紧急事件",
        "no_data": "没有已排程的工作订单。",
        "no_resources": "没有资源能力数据。",
        "fetch_error": "无法加载调度数据。",
        "optimizing": "AI 正在平衡资源负载...",
        "optimize_fail": "AI 优化失败。"
      },
      "features": {
        "title": "线性要素目录",
        "feature_id": "要素代码",
        "description": "描述",
        "type": "要素类型",
        "point": "点 (例如：阀门)",
        "linear": "线性 (例如：材质)",
        "error_in_use": "无法删除：该要素正在管道上使用。"
      },
      "audit": {
        "title": "审计轨迹浏览器",
        "history_for": "历史记录：",
        "retrieving": "正在检索审计记录...",
        "no_records": "未找到此记录的审计轨迹"
      },

    }
  },
  // 🇯🇵 日本語 (Japanese)
  ja: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "アセット・エクセレンス", version: "Teknora v1.0.4" },
      search: { placeholder: "モジュールを検索..." },
      menu: {
        settings: "設定", organization: "組織", domains: "ドメイン", field_config: "フィールド設定", classifications: "分類", importer: "ユニバーサル・インポーター", cobie: "COBie マネージャー", workflow: "ワークフロー・エンジン", scripts: "アクションスクリプト",
        analytics: "分析", dashboards: "BI ダッシュボード", report_designer: "レポート・デザイナー", report_wizard: "レポート・ウィザード",
        assets: "資産", asset_registry: "資産登録", locations: "ロケーション", categories: "資産カテゴリ", meters: "メーター", failure_codes: "故障コード",
        work_management: "作業管理", wo_tracking: "作業オーダー追跡", labor_reporting: "スケジューラ",
        resources: "リソース", crafts: "職種", labor: "労務", person: "個人",
        service_desk: "サービスデスク", service_requests: "サービスリクエスト", incidents: "インシデント登録",
        procurement: "購買", po: "購買オーダー", pr: "購買リクエスト", rfq: "見積依頼", receiving: "受領", vendors: "ベンダー",
        contracts: "契約", contracts_master: "契約マスタ", sla: "SLA",
        inventory: "在庫", item_master: "アイテムマスタ", tools: "ツール", balances: "在庫残高", transfers: "出庫・移動", storerooms: "倉庫",
        planning: "計画", pm_schedules: "PMスケジュール", safety_plans: "安全計画", hazards: "ハザード", precautions: "注意事項", tagouts: "タグアウト", job_plans: "作業計画",
        security: "セキュリティ", user_list: "ユーザーリスト", groups: "セキュリティグループ", "recent": "最近の表示"
      },
      user_settings: { title: "ユーザー設定", default_info: "デフォルト情報", personal_info: "個人情報", password_info: "パスワード情報", sign_out: "サインアウト", system_info: "システム情報" },
      notifications: { title: "受信タスク", new_alerts: "新規", empty: "受信トレイは空です", view_all: "すべてのアクティビティを表示" },
      sidebar: { queries: "利用可能なクエリ", all_assets: "すべての資産", operating_assets: "稼働資産", critical_assets: "重要資産", my_bookmarks: "ブックマーク", common_actions: "共通アクション", new: "新規", move_assets: "資産移動", print_barcodes: "バーコード印刷", create_report: "レポート作成", wo_queries: "作業クエリ", all_wo: "全作業オーダー", waiting_approval: "承認待ち", wip: "作業中", completed_today: "本日完了", bulk_approve: "一括承認", record_actions: "レコード操作", save: "保存", delete: "削除", workflow_status: "ワークフロー/ステータス", change_status: "ステータス変更", view_history: "履歴表示", item_ops: "アイテム操作", add_to_storeroom: "倉庫に追加", inv_ops: "在庫操作", reorder: "再注文", tax_ops: "税務操作", tax_category: "税区分", create_po: "注文書作成", settings_group: "設定", system_settings: "システム設定", email_settings: "メール設定", asset_ops: "資産操作", meter_readings: "メーター検針", hist_readings: "検針履歴", report_downtime: "ダウンタイム報告", downtime_hist: "ダウンタイム履歴", move_mod_asset: "資産移動/修正", asset_move_hist: "資産移動履歴", create_related: "関連作成", create_incident: "事件作成", view_inc_hist: "事件履歴", create_wo: "作業オーダー作成", sr: "サービス依頼", apply_sla: "SLA適用", approve_wo: "作業オーダー承認", start_work: "開始", complete_work: "完了", close_wo: "閉鎖", analytics: "分析", wf_history: "ワークフロー履歴", history_log: "操作ログ", wo_costs: "コスト", purchase_info: "購買情報", all_records: "全レコード", find_nav: "項目検索", more_actions: "その他のアクション", settings: "設定", export_data: "データ出力", audit_log: "監査ログ", share_app: "アプリ共有" },
      apps: {
        ORGANIZATION: "組織", ASSET: "資産", LOCATION: "ロケーション", WORKORDER: "作業オーダー", INVENTORY: "在庫", CLASSIFICATION: "分類", VENDOR: "ベンダー", METER: "メーター", DOMAINS: "ドメイン", CRAFTS: "職種", STOREROOMS: "倉庫", ITEMS: "アイテムマスタ", INVENTORYUSAGE: "在庫使用", MR: "資材依頼", PR: "購入依頼", PO: "注文書", LABOR: "労務", PM: "PMスケジュール", SAFETY: "安全計画", HAZARD: "ハザード", TAGOUT: "タグアウト", PRECUTION: "注意事項", SR: "サービス依頼", INCIDENT: "インシデント", ASSET_CATEGORIES: "資産カテゴリ", FAILURECLASS: "故障コード", RFQ: "見積依頼", CONTRACT: "契約", SLA: "サービスレベル契約", FAILURE_CODES: "故障コード",
        "VENDORS": "ベンダー", "TAGOUTS": "タグアウト", "PRECAUTIONS": "注意事項", "INCIDENTS": "インシデント", "JOBPLAN": "作業計画", "ROLE": "ロール", "TOOLS": "ツール", "USER": "ユーザー"
      },
      dashboard: { tab_bi: "KPI テンプレート", tab_inbox: "ワークフロー受信トレイ", advanced_analytics: "高度な分析", workflow_center: "実行センター", active_tasks: "アクティブなタスク", history_tasks: "履歴", no_data: "データなし", take_action: "アクション", previous: "前へ", next: "次へ", showing: "表示", of: "/", actual: "実績", target: "目標", kpi_graph: "KPI グラフ" },
      username: "ユーザーID",
      password: "パスワード",
      login_btn: "サインイン",
      forgot_pwd: "パスワードを忘れた場合",
      login: {
        id_placeholder: "IDを入力してください",
        error_msg: "IDまたはパスワードが無効です",
        server_error: "サーバーへの接続に失敗しました",
        just_smart: "ジャスト・スマート"
      },
      organizations: { title: "組織", org_id: "組織", description: "説明", active: "有効？" },
      org_detail: { org_label: "組織", tabs: { organization: "組織", sites: "サイト", map: "地图" }, fields: { currency1: "基本通貨 1", currency2: "基本通貨 2", item_set: "アイテムセット", company_set: "会社セット", item_status: "デフォルト状態", active: "有効？" }, descs: { currency1: "主要通貨", currency2: "補助通貨", item_set: "アイテムセット", company_set: "会社セット" }, lookups: { currency: "通貨", item_set: "アイテムセット", company_set: "会社セット", status: "ステータス", governorate: "県" }, sites: { management: "サイト管理", new_row: "新規行", of: "/", site_id: "サイトID", description: "説明", active: "有効？", action: "操作", site_details: "サイト詳細", state: "都道府県", contact: "主連絡先", fin_info: "財務/予算情報", yearly_budget: "年間予算", monthly_budget: "月間予算", utilization: "年間利用率", fin_health: "財務状況は安定しています。" }, toasts: { id_required: "組織IDが必要です！", saving: "保存中...", success: "正常に保存されました！", fail: "保存失敗" } },
      domains: { title: "ドメイン", find_placeholder: "ドメインを検索...", new_domain: "新規ドメイン", domain_id: "ドメイン", description: "説明", type: "タイプ", values: "値" ,
        save_btn: "保存", desc_placeholder: "ドメインの説明", synonym_values: "同義語の値", new_row: "新規行", internal_val: "内部値", external_desc: "外部説明", default: "デフォルト？", action: "操作", no_values: "値が定義されていません。", toasts: { loading: "読み込み中...", load_fail: "読み込み失敗", id_required: "IDが必要です！", saving: "保存中...", save_success: "保存完了！", save_fail: "保存失敗" } },
      classifications: { parent: "親分類", order: "順序", hierarchy: "分類構造", hierarchy: "階層パス", parent: "親分類", gen_desc: "説明を生成しますか？", use_with: "オブジェクトで使用", attributes: "属性", attr_id: "属性ID", section: "セクション", uom: "測定単位" },
      bim: { title: "BIM インテグレーター Pro", subtitle: "高度な Revit から COBie へのマッピング", waiting_translation: "モデル変換を待機中...", tabs: { "3d": "3Dビューア", data: "データテーブル" }, preview_table_title: "COBieコンポーネントプレビュー", controls: { destination: "送信先", select_site: "サイトを選択", uploads: "ファイルアップロード", select_cobie: "COBieファイルを選択", upload_revit: "Revitファイルをアップロード", models_ready: "モデル準備完了", preview_list: "プレビューモデル", finalizing: "最終同期中...", commit: "BIM統合を確定" }, table: { asset_name: "資産名", location: "スペース / 場所" } },
      importer: { title: "ユニバーサルデータローダー", target_table: "ターゲットテーブル", download_template: "テンプレートをダウンロード", upload_instruction: "Excelファイルを選択", field_mapping: "フィールドマッピング", excel: "Excel", ignore: "無視", preview_title: "プレビュー", execute_btn: "インポートを実行" },
      workflow: { title: "ワークフローエンジン", subtitle: "自動化コントロールセンター", export_btn: "CSV出力", new_process: "新規プロセス", loading: "読み込み中...", unnamed: "未設定のプロセス", linked_to: "リンク先", create_path: "新規パス作成", 
                  designer_title: "ワークフロー設計者 (ループバック有効)", publish_btn: "公開", loading_designer: "ロジックパスを再構築中...", logic_palette: "ロジックパレット", config_title: "設定", node_label: "ラベル", assign_roles: "ロールの割り当て", post_action: "アクション後スクリプト",
        select_lookup: "検索から選択", script_hint: "* 複数のスクリプトはカンマで区切ることができます。", status_auto: "ステータス自動変更", trigger: "トリガー", target_status: "ターゲットステータス", cond_expr: "条件式 (Python)", escalation: "エスカレーション（時間）", select_node: "編集するノードを選択", options: {no_change: "ステータス変更なし", change_status: "ステータスを変更", select_status: "ステータスを選択" }, 
        table: {id: "身元", name: "プロセス名", app: "アプリ", status: "状態"},
        lookups: {select_roles: "ロールを検索", select_scripts: "スクリプトを選択" },
        swal: {publish_title: "ワークフローを公開しますか？", publish_text: "エンジンのステップをデータベースと同期します。", confirm_publish: "はい、今すぐ公開", delete_title: "ロジックを消去しますか？", delete_text: "本当に削除しますか：", confirm_delete: "はい、すべて削除" },
        toasts: { id_required: "プロセス名を入力してください", saving: "ワークフローを同期中...", save_success: "同期完了！ 🚀", save_fail: "同期失敗", purging: "ワークフローを消去中...", delete_success: "ワークフローが完全に削除されました", delete_fail: "削除失敗", fetch_fail: "データの読み込み失敗" }
      },
      field_config: { title: "メタデータフィールドマッピング", table_name: "テーブル名", field_name: "フィールド名", current_mappings: "現在のマッピング：", field: "フィールド", linked_domain: "関連ドメイン" },
      scripts: {
        title: "アクションスクリプト",
        subtitle: "自動化とロジックテンプレートの管理",
        new_btn: "新規スクリプト作成",
        search_placeholder: "名前またはオブジェクトで検索...",
        table: {
          name: "スクリプト名",
          object: "対象オブジェクト",
          created: "作成日"
        },
        toasts: {
          fetch_fail: "スクリプトの読み込みに失敗しました"
        }
      },
      studio: { schema_explorer: "スキーマエクスプローラー", target_context: "対象オブジェクト", name_placeholder: "スクリプト名入力...", engine_info: "エンジン: PYTHON 3.10", console_title: "実行コンソール", clear_console: "コンソール消去", field_from: "フィールド:", access_col: "列アクセス:", db_model: "DBモデル", btns: { compile: "コンパイル", compiling: "コンパイル中...", save_deploy: "保存してデプロイ" }, toasts: { preserved: "保存完了！", compiled: "解析成功！" }, console: { init: "初期化中...", schema_sync: "同期成功。", schema_fail: "同期失敗。", saved_prefix: "保存成功", error_op: "エラー発生。", compiling: "解析開始...", build_finish: "ビルド完了。", syntax_error: "構文エラー。", build_fail: "ビルド失敗", analyzing: "構文解析中..." } },
      reports: { title: "レポートテンプレート", new_btn: "新規レポート作成", search_placeholder: "検索...", table: { name: "レポート名", ref_obj: "参照オブジェクト", updated: "最終更新" }, 
          toasts: { load_fail: "読み込み失敗", clone_success: "複製成功", save_success: "保存完了！ 🚀", save_fail: "保存失敗" },
          designer: {
                  title: "レポート設計エンジン", live_preview: "ライブプレビュー", publish: "テンプレートを公開", model_select: "モデル選択", data_explorer: "データエクスプローラー", components: "コンポーネント", page_break: "改ページ",
                  is_summary: "概要レポート？", user_params: "ユーザーパラメータ", add_param: "入力フィールド追加", master_info: "マスター情報", relational_data: "関連データ", detail_tables: "明細テーブル", tabs: { body: "本文", header: "ヘッダー", footer: "フッター", css: "グローバル CSS" },
                  fields: { wonum: "作業オーダー番号", assetnum: "資産番号", desc: "説明", status: "ステータス", asset: "資産名", location: "ロケーションID", tasks_table: "タスクテーブル", mat_table: "計画資材", asset_basic: "資産基本情報", inv_basic: "在庫基本情報", vend_basic: "仕入先基本情報" }
                },
        }, 
      assets: { 
        map: { "gps_location": "地理的位置 (GPS)", "gps_coordinates": "GPS座標"},
        list: { system_title: "資産管理システム", new_asset: "新規資産作成", all_orgs: "全組織", all_sites: "全サイト", db_total: "合計:", display_page: "ページ:", navigate_hint: "矢印を使って移動してください", col_site: "サイト", col_org: "組織" }, 
        modal: { migration_title: "大規模資産移動", caution_prefix: "注意：", caution_suffix: "個の資産を移動します。", dest_label: "新しい移動先", placeholder: "場所を選択...", abort: "中止", execute: "一括移動を実行" },
        headers: { asset_num: "資産番号", desc: "説明", status: "ステータス", downtime: "総ダウンタイム", site: "サイト" },
        tabs: { details: "資産の詳細", spare_parts: "スペアパーツ", safety: "安全", meters: "メーター", specs: "仕様", history: "作業履歴", map: "マップ", bim: "3Dビュー", ai: "AI分析", eval: "評価", attachments: "添付ファイル" },
        sections: { "linear_details": "線形参照の詳細", general: "一般情報", details: "詳細", finance: "住所と財務", image: "資産画像", audit: "監査情報", bim_info: "BIM情報", reliability: "信頼性分析" },
        fields: { "is_linear": "線形資産ですか？", "start_measure": "開始測定", "end_measure": "終了測定", "measure_unit": "測定単位", "direction": "流れの方向" ,type: "資産タイプ", location: "ロケーション", parent: "親資産", category: "資産カテゴリ", is_running: "資産は稼働中ですか？", serial: "シリアル番号", item: "回転アイテム", failure: "故障クラス", safety_plan: "安全計画", vendor: "ベンダー", price: "購入価格", replace: "交換費用", priority: "優先順位", ytd_cost: "年間累積コスト" },
        meters: { seq: "シーケンス", name: "メーター", reading: "最終読取値", date: "読取日", inspector: "検査員", remarks: "備考" },
        ai: { title: "アセット・インテリジェンス", run: "診断を実行", summary: "技術概要", recommend: "推奨事項", telemetry: "テレメトリを分析中..." },
        spare_fields: { item: "回転アイテム", qty: "数量", issued: "出庫数", remarks: "備考", item_details: "アイテムの詳細" },
        safety: { plan_card: "関連安全計画", active_plan: "有効な安全計画", no_plan: "計画未リンク", link_plan: "安全計画をリンク", change_plan: "計画の変更", hazard_title: "資産固有の危険", hazard_num: "危険", hazard_type: "タイプ / 優先度", no_hazards: "この資産にリンクされた危険はありません。", add_hazard: "危険を追加", loto_title: "ロックアウト/タグアウト (LOTO)", tag_id: "タグアウト ID", req_state: "要求される状態", no_loto: "定義された隔離ポイントはありません。", add_loto: "隔離ポイントを追加", applying_proto: "安全プロトコルを適用中..." }, 
        meters: { title: "関連メーター", details_title: "メーターの詳細", seq: "シーケンス", meter_name: "メーター名", meter_type: "メータータイプ", uom: "単位", active_status: "有効？", last_reading: "最終読取値", last_date: "読取日", inspector: "検査員", remarks: "備考", new_meter: "新規メーター" },
        specs: { classification: "分類", select_class: "分類を選択...", tech_specs: "技術仕様", attribute: "属性", value: "値", uom: "単位", data_type: "データ型", attr_details: "属性の詳細", select_val: "値を選択" },
        history: { title: "作業履歴", wo_num: "作業番号", finish_date: "完了日", no_history: "この資産の履歴は見つかりませんでした。", fetching: "履歴を取得中...", wo_type: "タイプ" },
        bim: { model_status: "モデルの状態", linked: "リンク済み＆アクティブ", not_linked: "未リンク", upload_revit: "Revitをアップロード (.rvt)", urn_label: "モデルURN", "show_3d": "デジタルツインを表示 (3D)", "not_linked": "3Dモデルにリンクされていません" },
        ai: { title: "アセット・インテリジェンス", sub_title: "AIアナライザー", tagline: "産業用IoT予測診断", run_btn: "診断実行", analyzing: "テレメトリストリームを分析中...", health_score: "ヘルススコア", thermal: "熱アラート", vibration: "振動アラート", tech_summary: "技術要約", recommendations: "推奨事項", sensors_chart: "センサー vs 限界値", init_prompt: "AI分析を開始するには「診断実行」をクリックしてください", critical: "致命的", normal: "正常", stable: "安定", detected: "検出済み", "predictive_trajectory": "予測故障トラジェクトリ", "est_failure": "推定故障", "loading_pred": "予測モデルを生成中..." },
        "features": {
          "feature_id": "フィーチャID",
          "label": "ラベル",
          "start": "開始測定",
          "end": "終了測定 (空 = ポイント)",
          "value": "値 (例: 500mm)",
          "details": "フィーチャの詳細",
          "y_offset": "Yオフセット (右/左)",
          "z_offset": "Zオフセット (深さ/高さ)"
        },
    

      }, 
      common: { copy: "コピー", cancel: "キャンセル", clone: "クローン", back: "ホームに戻る", "days": "日", "weeks": "週", "months": "月", "years": "年", "daysList": { "saturday": "土曜日", "sunday": "日曜日", "monday": "月曜日", "tuesday": "火曜日", "wednesday": "水曜日", "thursday": "木曜日", "friday": "金曜日"}, "select": "選択", "search": "検索", "pending": "保留中", "pendingSelection": "--- 選択待ち ---",confirm: "確認", save_settings: "AI設定を保存", selected: "選択された資産", bulk_move: "一括移動", change_status: "ステータス変更", cancel: "リセット", save: "保存", cancel: "キャンセル", delete: "削除", back: "戻る", record: "記録", total: "合計", print: "印刷", active: "アクティブ", critical: "重要", warning: "警告", healthy: "正常", of: "の", new_row: "新しい行", "filter": "フィルター...", "save_success": "正常に保存されました", "save_fail": "保存に失敗しました", "delete": "削除", "delete_success": "正常に削除されました", "delete_fail": "削除に失敗しました", "are_you_sure": "よろしいですか？",    "cancel": "キャンセル", "confirm": "確認", "first": "最初", "last": "最後", "next": "次へ", "prev": "前へ", "sar": "SAR", "all": "すべて", "attachments": "添付ファイル", "history": "履歴", "change_status": "ステータス変更", "totalRecords": "総レコード数", "readOnly": "(読み取り専用)", "noDescription": "説明なし", "recordLocked": "レコードはロックされており、変更できません。", "descRequired": "説明は必須です！", "actionDenied": "アクションが拒否されました", "cantDeleteStatus": "ステータス {{status}} のレコードは削除できません", yes: "はい", no: "いいえ", "main": "メイン詳細", "save": "保存", "change_status": "ステータス変更", "history": "履歴", "delete": "削除", "org": "組織", "site": "サイト", "new_row": "行を追加", "location": "場所", "asset": "資産", "no_records": "レコードが見つかりません", "saving": "保存中...", "save_success": "正常に保存されました！", "save_fail": "保存に失敗しました", "are_you_sure": "本当によろしいですか？", "yes_delete": "はい、削除します！", "cancel": "キャンセル", "delete_success": "正常に削除されました", "delete_fail": "削除に失敗しました: ", "clear_filters": "フィルターをクリア", "all": "すべて", "syncing": "同期中...", "showing": "表示中", "total": "合計", "created_by": "作成者", "changed_date": "変更日"},
      toasts: { save_success: "正常に保存されました", save_fail: "保存に失敗しました", load_fail: "データの読み込みに失敗しました", delete_success: "正常に削除されました" },
      swal: { delete_title: "確認", delete_text: "資産を削除しようとしています:", confirm_delete: "はい、レコードを削除します" },
      "ai_settings": {
        "title": "AIエンジニア設定",
        "sub_title": "AI予知保全エンジン",
        "enable_label": "自動予知保全を有効にする",
        "enable_sub": "AI分析に基づいて作業オーダーを自動作成",
        "target_lang": "レポートとタスクの言語",
        "threshold": "意思決定の信頼度しきい値",
        "auto_tasks": "作業タスクを自動生成 (WOTasks)",
        "task_desc": "タスクテーブルに作業手順を自動入力",
        "max_tasks": "作業オーダーあたりの最大手順数",
        "section": "セクション",
        "technicalDetails": "技術的な詳細"
      },
      "export_technical_report": "技術レポートのエクスポート (PDF)",
      "availability": "可用性",
      "mtbf": "平均故障間隔 (MTBF)",
      "mttr": "平均修復時間 (MTTR)",
      "hrs": "時間",
      "reliability_score": "信頼性スコア",
      "score": "スコア",
      "downtime_history_trend": "ダウンタイム履歴の傾向 (過去10回のイベント)",
      "values_in_hours": "値（時間）",
      "timeline_event_date": "タイムライン (イベント発生日)",
      "downtime_hours": "ダウンタイム (時間)",
      "no_downtime_records": "この資産のダウンタイム記録はまだありません。",
      "reliability_analysis": "信頼性分析",
      "total_failures": "総故障数",
      "total_down_time": "総ダウンタイム",
      "last_calculation": "最終計算日時",
      "maintenance_strategy_note": "保守戦略ノート",
      "high_mttr_detected": "高いMTTRが検出されました。推奨：この資産カテゴリの予備部品の在庫と技術トレーニングを評価してください。",
      "critical_availability": "可用性が危機的レベルです。予防保全の頻度を増やすか、計画的なオーバーホールを検討してください。",
      "nominal_performance": "資産のパフォーマンスは正常範囲内です。標準の予防保全スケジュールを継続してください。",
      "current_load_factor": "現在の負荷率",
      "optimal": "最適",
      statusModal: {
        "loadError": "ステータスを読み込めませんでした",
        "selectFirst": "最初にステータスを選択してください",
        "updating": "ステータスを更新中...",
        "success": "ステータスが更新されました",
        "failed": "更新に失敗しました",
        "changeStatus": "ステータスの変更:",
        "currentStatus": "現在のステータス",
        "availableStatuses": "利用可能なステータス",
        "loading": "読み込み中...",
        "chooseStatus": "ステータスを選択...",
        "memo": "理由 / メモ",
        "enterNotes": "メモを入力してください...",
        "cancel": "キャンセル",
        "update": "更新"
      },
      attachmentsModal: {
        "loadError": "ファイルの読み込みエラー",
        "uploadSuccess": "ファイルが正常に添付されました",
        "uploadFailed": "アップロードに失敗しました",
        "deleteConfirmTitle": "本当によろしいですか？",
        "deleteConfirmText": "'{{name}}' を完全に削除しようとしています。これにより、サーバーからファイルが削除されます。",
        "btnYesDelete": "はい、削除します！",
        "btnCancel": "キャンセル",
        "processingDelete": "削除処理中...",
        "deletedTitle": "削除済み！",
        "deletedText": "添付ファイルは正常に削除されました。",
        "deleteFailed": "削除に失敗しました",
        "headerTitle": "添付ファイルライブラリ",
        "linkingTo": "リンク先:",
        "filesFound": "見つかったファイル:",
        "uploadBtn": "新しいドキュメントをアップロード",
        "thName": "名前",
        "thOwner": "所有者",
        "thStatus": "ステータス",
        "thActions": "アクション",
        "statusPrivate": "非公開",
        "statusPublic": "公開",
        "noDocs": "リンクされたドキュメントはまだありません"
      },
      enterMeters: {
        "noMeters": "資産にリンクされているメーターはありません:",
        "saving": "検針値を保存中...",
        "enterAtLeastOne": "少なくとも1つの新しい検針値を入力してください",
        "saveSuccess": "すべての検針値が正常に保存されました！",
        "saveFailed": "検針値の保存に失敗しました",
        "title": "メーター検針値の入力 | 資産:",
        "titleLoc": "メーター検針値の入力 | ロケーション:",
        "thIdentification": "メーター識別",
        "thNewReading": "* 新しい検針値",
        "thReadingDate": "* 検針日",
        "thMeterType": "メータータイプ",
        "thLastRecorded": "最終記録",
        "noDescription": "説明なし",
        "enterValue": "値を入力...",
        "notAvailable": "該当なし",
        "operator": "オペレーター:",
        "btnCancel": "キャンセル",
        "btnUpdate": "検針値を更新"
      },
      emailSettings: {
        "loadFailed": "設定の読み込みに失敗しました",
        "saveSuccess": "メール設定が正常に保存されました！",
        "saveFailed": "設定の保存に失敗しました",
        "connecting": "SMTPサーバーに接続しています...",
        "connFailed": "接続に失敗しました！",
        "title": "SMTP設定",
        "subtitle": "メールサーバー設定",
        "outgoingTitle": "送信メール (SMTP - 送信)",
        "incomingTitle": "受信メール (IMAP - 監視)",
        "lblHost": "SMTPホスト",
        "lblPort": "SMTPポート",
        "lblUser": "SMTPユーザー名 / メール",
        "lblPass": "SMTPパスワード",
        "lblSender": "システム送信者メール (Fromアドレス)",
        "lblImapHost": "IMAP ホスト",
        "lblImapPort": "IMAP ポート",
        "enableImap": "受信トレイ監視を有効にする (RFQレーダー)",
        "imapDesc": "受信トレイからベンダーの見積もりを自動的に取得して解析します。",
        "gmailNote": "Gmailの場合は、Googleセキュリティの「アプリパスワード」を使用してください。2FAが有効な場合、アカウントパスワードは機能しません。",
        "btnTest": "テスト",
        "btnCancel": "キャンセル",
        "btnSave,": "設定を保存"
      },
      locationDetails: {
        "noBimModel": "このロケーションにリンクされている3Dモデルはありません",
        "noBimLinked": "このロケーションはBIMにリンクされていません",
        "locMandatory": "ロケーションは必須フィールドです！",
        "saving": "変更を保存しています...",
        "saveSuccess": "ロケーションが正常に保存されました",
        "saveFailed": "保存に失敗しました:",
        "deleteTitle": "本当によろしいですか？",
        "deleteText": "ロケーション {{id}} を削除しようとしています。この操作は元に戻せません！",
        "btnYesDelete": "はい、削除します！",
        "btnCancel": "キャンセル",
        "deleting": "ロケーションを削除しています...",
        "deleteSuccess": "ロケーションが正常に削除されました",
        "deleteFailed": "削除に失敗しました！",
        "uploadingRevit": "Revitモデルのアップロードと変換中...",
        "revitSuccess": "モデルが正常にリンクされました！",
        "uploadFailed": "アップロード失敗:",
        "loadingCtx": "ロケーションコンテキストを読み込んでいます...",
        "tooltipChangeStatus": "ステータスの変更",
        "tooltipStatusHistory": "ステータス履歴",
        "tooltipDelete": "削除",
        "btnSave": "保存",
        "lblLocation": "ロケーション",
        "lblDescription": "説明",
        "btnRevitLinked": "Revitリンク済み",
        "tabLocation": "ロケーション",
        "tabAssets": "資産",
        "tabSpecs": "仕様",
        "tabSafety": "安全",
        "tabMeters": "メーター",
        "tab3D": "3Dビュー",
        "tabHistory": "履歴",
        "secIdentity": "ロケーションの識別情報",
        "lblStatus": "ステータス",
        "lblType": "タイプ",
        "lblParentLoc": "親ロケーション",
        "lblSiteID": "サイトID",
        "secGeoInfo": "地理および住所情報",
        "lblServiceAddr": "サービスアドレス",
        "lblBimSpaceId": "BIMスペースID",
        "lblGisCoords": "GIS座標",
        "secRefImage": "参照画像",
        "btnUploadPhoto": "写真をアップロード",
        "thAssetNum": "資産番号",
        "thStatus": "ステータス",
        "lblClass": "分類",
        "thAttr": "属性",
        "thDesc": "説明",
        "thValue": "値",
        "titleHazards": "このロケーションで報告された危険",
        "btnAddHazard": "危険を追加",
        "lblSelectHazards": "危険を選択",
        "thHazard": "危険",
        "thPrecaution": "予防措置",
        "titleLocMeters": "ロケーションメーター",
        "showingMeters": "{{total}} 中 {{current}} を表示",
        "noMetersDef": "メーターが定義されていません",
        "thSeq": "連番",
        "thMeterNum": "メーター番号",
        "thType": "タイプ",
        "thUOM": "単位",
        "thActive": "アクティブ",
        "newMeter": "新規メーター",
        "clickNewRow": "メーターを追加するには「新しい行」をクリックします",
        "titleMeterConfig": "メーターの詳細設定",
        "newEntry": "新しいエントリ",
        "lblMeterNum": "* メーター番号",
        "lblMeterType": "メータータイプ",
        "lblUOM": "測定単位",
        "lblMeterActive": "メーターはアクティブです",
        "lblLastReading": "前回の検針値",
        "lblReadingDate": "検針日",
        "lblInspector": "メーター検査官",
        "lblRemarks": "備考/コメント",
        "placeholderRemarks": "このメーターに関する技術的なメモを入力してください...",
        "btnAddMeterRow": "新しいメーター行を追加",
        "titleModelStatus": "モデルステータス",
        "statusLinked": "リンク済みかつアクティブ",
        "statusNotLinked": "リンクされていません",
        "btnUploadRevit": "Revitをアップロード（.rvt）",
        "titleHistory": "トランザクション履歴と監査ログ",
        "lblChangedBy": "変更者:",
        "failedFetchAttr": "属性の取得に失敗しました"
      },
      "locationList": {
        "loadFailed": "サーバーからロケーションを読み込めませんでした。",
        "title": "ロケーション",
        "searchPlaceholder": "グローバル検索...",
        "btnClearAll": "すべてクリア",
        "btnExport": "エクスポート",
        "btnNewLocation": "新規ロケーション",
        "thLocationId": "ロケーションID",
        "thDescription": "説明",
        "thType": "タイプ",
        "thStatus": "ステータス",
        "thSite": "サイト",
        "optAll": "すべて",
        "optOperating": "稼働中",
        "optDecommissioned": "廃止",
        "fetchingData": "サーバーからデータを取得中...",
        "noRecords": "一致するレコードが見つかりません。",
        "recordsFound": "見つかったレコード:",
        "page": "ページ:"
      },
      "universalLookup": {
        "selectValue": "値を選択:",
        "total": "合計",
        "searchPlaceholder": "コードまたは説明で検索...",
        "valueCode": "値 / コード",
        "description": "説明",
        "site": "サイト",
        "synchronizing": "同期中...",
        "noRecords": "一致するレコードが見つかりません。",
        "loadingMore": "さらにレコードを読み込んでいます...",
        "results": "結果:",
        "cancel": "キャンセル"
      },
      "statusHistory": {
        "title": "ステータス監査証跡",
        "loading": "履歴を読み込んでいます...",
        "noRecords": "このアイテムのステータス変更は記録されていません。",
        "initial": "初期状態",
        "btnClose": "閉じる"
      },
      "personalInfo": {
        "updateSuccess": "プロフィールが正常に更新されました",
        "sessionExpired": "セッションの有効期限が切れました。再度ログインしてください",
        "updateFailed": "更新に失敗しました",
        "title": "個人情報とデフォルト",
        "lblDisplayName": "フル表示名",
        "lblEmail": "メールアドレス",
        "lblDefaultOrg": "デフォルト組織",
        "selectOrg": "組織を選択...",
        "lblDefaultSite": "デフォルトサイト",
        "selectSite": "サイトを選択...",
        "lblDefaultLang": "デフォルト言語",
        "btnCancel": "キャンセル",
        "btnSave": "適用して変更を保存",
        "securityTitle": "セキュリティと2FA",
        "enable2FA": "2要素認証（2FA）を有効にする",
        "googleAuth": "Google Authenticator",
        "emailOTP": "EメールOTP",
        "configure2FA": "2FAのセットアップを設定する",
        "scanQR": "Google AuthenticatorまたはAuthyを使用してこのQRコードをスキャンし、下に6桁のコードを入力して確認してください。",
        "btnVerify": "確認する",
        "setupSuccess": "2FAのセットアップが成功しました！",
        "invalidCode": "無効な確認コード",
        "failedQR": "QRコードの生成に失敗しました"
      },
      "appSettings": {
        "savingSettings": "設定を保存しています...",
        "saveSuccess": "設定が正常に更新されました！",
        "saveFailed": "設定の保存に失敗しました。",
        "title": "エンタープライズ構成",
        "org": "組織",
        "tabs": {
          "WORKORDER": "作業指示書",
          "ASSET": "資産レジストリ",
          "INVENTORY": "倉庫と在庫",
          "PURCHASE": "調達",
          "PR": "購買依頼",
          "JP": "作業計画",
          "PM": "予防保全",
          "MR": "資材要求",
          "SR": "サービス要求"
        },
        "systemRules": "{{tab}} システムルール",
        "prefix": "シーケンスプレフィックス",
        "preview": "プレビュー",
        "seed": "初期値（シード）",
        "valuationStrategy": "評価戦略",
        "movingAvg": "移動平均（推奨）",
        "fifo": "先入先出（FIFO）",
        "lifo": "後入先出（LIFO）",
        "allowNegative": "マイナス残高を許可",
        "negativeWarning": "警告: 財務の正確性に影響します",
        "encrypting": "暗号化と送信中...",
        "auditLogged": "すべての変更は監査証跡に記録されます",
        "btnCancel": "キャンセル",
        "btnSave": "システムポリシーを保存"
      },
      "workflowAction": {
        "successMove": "ワークフローが正常に進みました！ 🚀",
        "failedMove": "アクションに失敗しました",
        "btnRoute": "ワークフローをルーティング",
        "modalTitle": "ワークフローアクション",
        "assignedAs": "あなたに割り当てられた役割:",
        "defaultInstruction": "確認してアクションを実行してください。",
        "lblChoosePath": "パスを選択",
        "valSelectPath": "パスを選択してください",
        "optApprove": "承認 / 次へ進む",
        "optReject": "拒否 / 差し戻す",
        "lblMemo": "アクションメモ / コメント",
        "placeholderMemo": "ここにコメントを追加してください...",
        "btnCancel": "キャンセル",
        "btnComplete": "ステップを完了"
      },
      "meterHistory": {
        "title": "過去のメーター検針値",
        "lblAsset": "資産",
        "fetching": "アーカイブを取得中...",
        "noRecords": "この資産の過去の検針値は見つかりませんでした。",
        "thMeterName": "メーター名",
        "thReadingVal": "検針値",
        "thReadingDate": "検針日",
        "thEnteredBy": "入力者",
        "thEntryDate": "入力日",
        "btnClose": "履歴を閉じる",
        "lblLocation": "ロケーション",
        "noRecordsLoc": "このロケーションの過去の検針値は見つかりませんでした。",
      },
      rpt_print: "レポートを印刷する",
      no_templates: "テンプレートがありません",
      "wo": {
        "tabs": { "workOrder": "作業指示書", "plans": "計画", "assignments": "割り当て", "actuals": "実績", "safety": "安全", "failure": "障害報告" },
        "subTabs": { "tasks": "タスク", "labor": "労務", "materials": "資材", "tools": "ツール", "services": "サービス" },
        "headers": { "workOrder": "作業指示書", "status": "ステータス", "totalCost": "合計コスト", "activeSla": "SLA モニタリング中", "targetRes": "目標解決時間", "targetResp": "目標応答時間" },
        "sections": { "assetDetails": "資産の詳細", "scheduling": "スケジュール情報", "responsibility": "責任", "laborAssign": "労務の割り当て", "totalAssign": "合計割り当て" },
        "fields": { "description": "説明", "location": "ロケーション", "asset": "資産", "workType": "作業タイプ", "safetyCode": "安全コード", "supervisor": "監督者", "failureClass": "障害クラス", "targStart": "目標開始", "targFinish": "目標終了", "schedStart": "予定開始", "schedFinish": "予定終了", "earlyStart": "最早開始", "lateFinish": "最遅終了", "actStart": "実績開始", "actFinish": "実績終了", "duration": "期間", "timeRemaining": "残り時間", "predecessors": "先行タスク", "includeTasks": "タスクを含める？", "site": "サイト", "organization": "組織", "priorityHigh": "優先度: 高" },
        "actions": { "routeWorkflow": "ワークフローのルーティング", "wfHistory": "履歴", "changeStatus": "ステータス変更", "attachments": "添付ファイル", "printWO": "印刷", "printSafety": "安全シート印刷", "history": "ステータス履歴", "newTask": "新規タスク", "selectLoc": "ロケーションを選択", "selectAsset": "資産を選択", "selectType": "タイプを選択", "selectSafety": "安全計画を選択", "selectSup": "監督者を選択", "selectFail": "障害クラスを選択", "selectCraft": "職種を選択", "selectLabor": "作業員を選択", "selectItem": "アイテムを選択", "selectStore": "倉庫を選択", "selectTool": "ツールを選択", "addLabor": "労務を追加", "addMaterial": "資材を追加", "addTool": "ツールを追加", "addService": "サービスを追加", "newAssign": "新規割り当て", "compAssign": "割り当て完了", "createMR": "資材要求の作成", "yesCreate": "はい、作成します", "yesChange": "はい、変更します", "approve": "承認", "cancel": "キャンセル", "startWork": "作業開始", "close": "クローズ", "complete": "完了", "selectProblem": "問題を選択", "selectCause": "原因を選択", "selectRemedy": "対策を選択" },
        "tables": { "sequence": "順序", "taskDesc": "タスク説明", "estDur": "予定期間", "status": "ステータス", "craft": "職種", "labor": "作業員", "qty": "数量", "hrs": "時間", "rate": "レート", "lineCost": "ラインコスト", "lineType": "ラインタイプ", "itemNum": "アイテム番号", "description": "説明", "unitCost": "単価", "storeroom": "倉庫", "item": "アイテム", "material": "資材", "toolNum": "ツール番号", "serviceDesc": "サービス説明", "vendor": "ベンダー", "cost": "コスト", "start": "開始", "finish": "終了", "failCode": "障害コード" },
        "footer": { "totalLabor": "合計労務", "totalMaterial": "合計資材", "assigned": "割り当て (見積)", "toolsServ": "ツールとサービス", "totalActual": "合計実績コスト" },
        "safety": { "hazardsTitle": "危険と予防措置", "hazardCode": "危険コード", "hazardDesc": "危険説明", "precautions": "必要な措置", "noHazards": "危険は特定されていません。", "lotoTitle": "ロックアウト/タグアウト", "step": "ステップ", "tagNum": "タグ番号", "isoDesc": "隔離の説明", "reqState": "必要な状態", "completed": "完了？", "noLoto": "隔離ステップは不要です。" },
        "failure": { "title": "障害分析", "currClass": "現在のクラス", "notDefined": "未定義", "problems": "問題", "causes": "原因", "remedies": "対策", "records": "記録" },
        "placeholders": { "desc": "説明を入力...", "taskDesc": "タスク説明..." },
        "messages": { "loadError": "読み込みエラー", "taskStatusLocal": "タスクのステータスを更新しました", "selectItemStore": "アイテムと倉庫を選択してください", "duplicateReqTitle": "重複要求", "duplicateReqText": "{{item}}の要求が存在します。作成しますか？", "creatingMR": "作成中...", "mrCreated": "要求 {{num}} を作成しました", "mrFail": "作成に失敗しました", "confirmStatusChange": "{{wonum}}のステータスを{{status}}に変更しますか？", "statusSuccess": "ステータスを変更しました", "statusFail": "変更に失敗しました", "saving": "保存中...", "deleteConfirm": "{{wonum}}を削除します。元に戻せません！", "saveBeforeSLA": "SLAを適用する前に保存してください", "slaExists": "SLAはすでに適用されています！", "matchingSLA": "SLAを検索中...", "slaApplied": "SLAを適用しました", "noMatchingSLA": "SLAが見つかりません", "slaError": "SLAエンジンエラー", "failureTreeLoaded": "障害コードを適用しました", "zeroBalance": "警告：{{store}}の残高がゼロです", "balanceOk": "価格取得：{{cost}} - 残高：{{bal}}", "storeError": "倉庫への接続に失敗", "assetLinked": "資産をリンク：{{asset}}", "openAssignError": "未完了の割り当てが{{count}}件あります。", "budgetExceeded": "予算超過！", "assignComplete": "割り当てを完了しました", "actionNotAllowed": "{{status}}では許可されていません", "locked": "ロック中", "cantChangeCancel": "キャンセルされたリクエストは変更できません", "printFail": "PDF作成失敗", "wfRouted": "ワークフローのルーティングに成功しました！ 🚀", "wfFail": "ルーティングに失敗しました", "taskStatusChanged": "タスク {{task}} のステータスが {{status}} に変更されました", "noLaborAssign": "作業員が割り当てられていません。", "updateTaskProg": "タスクの進捗を更新する", "noMaterials": "資材はありません。クリックして追加してください。", "linkedMRs": "リンクされた資材要求", "stocknobalance": "⚠️警告：この商品は倉庫に在庫がありません（ゼロ）。" },
        "linearDefect": {
          "title": "線形欠陥位置",
          "startMeasure": "開始位置",
          "endMeasure": "終了位置（オプション）",
          "unit": "単位",
          "yOffset": "Y軸オフセット (m)"
        },
        "costs": {
          "title": "作業指示コスト",
          "estimated": "見積コスト",
          "actual": "実績コスト",
          "labor": "労務",
          "materials": "資材",
          "tools": "工具",
          "services": "サービス",
          "total": "合計",
          "variance": "差異 (実績 - 見積)",
          "calculating": "計算中...",
          "no_data": "データがありません。"
        },
        "purchase_info": {
          "title": "関連購買情報",
          "mr_title": "資材要求 (MR)",
          "pr_title": "購買要求 (PR)",
          "po_title": "発注書 (PO)",
          "mr_num": "MR番号",
          "pr_num": "PR番号",
          "po_num": "PO番号",
          "vendor": "ベンダー",
          "status": "ステータス",
          "req_date": "要求日",
          "total_cost": "総コスト",
          "fetching": "データ取得中...",
          "no_records": "レコードが見つかりません。"
        },
    
      },
      "pm": {
        "tabs": { "pm": "予防保全", "frequency": "頻度", "sequence": "シーケンス", "seasonaldates": "季節", "forecast": "予測" },
        "sections": { "assetLoc": "資産とロケーション", "defaults": "デフォルト", "compliance": "コンプライアンス", "siteContext": "サイト情報", "timeBased": "時間ベースの間隔", "meters": "メーター", "sequences": "ジョブプラン・シーケンス", "seasonal": "週間スケジュール", "projections": "予測ログ" },
        "fields": { "pmNum": "PM番号", "description": "説明", "status": "ステータス", "site": "サイト", "asset": "資産", "location": "ロケーション", "route": "ルート", "counter": "カウンター", "jpnum": "ジョブプラン", "worktype": "作業タイプ", "supervisor": "監督者", "glaccount": "GLアカウント", "woStatus": "デフォルトステータス", "priority": "優先度", "lastStart": "前回開始", "lastComp": "前回完了", "nextDue": "次回期限", "forecastFlag": "予測フラグ", "org": "組織", "freqInt": "間隔", "freqUnit": "単位", "targStart": "目標開始時間" },
        "actions": { "forecast": "予測", "savePM": "保存", "addMeter": "メーター追加", "addStep": "ステップ追加", "newPM": "新規PMレコード" },
        "tables": { "meterName": "メーター名", "freq": "頻度", "nextProj": "次回予測", "seq": "シーケンス", "jpnum": "ジョブプラン", "fcDate": "予測日", "targetJp": "目標プラン", "estCost": "見積コスト", "status": "ステータス", "woNum": "作業指示書番号", "generated": "生成済", "projected": "予測済" },
        "messages": { "executingForecast": "計算中...", "forecastSuccess": "予測成功", "forecastFail": "予測失敗", "seasonalInfo": "チェックされた日が許可されます。", "noMeters": "メーターがありません。", "noSeq": "シーケンス無効。", "noForecasts": "予測はありません。", "showingProjections": "{{count}} 件の記録を表示", "fetchListError": "PMレコードの読み込みに失敗しました", "syncingList": "サーバーと同期中...", "noRecords": "一致するレコードはありません。" },
        "placeholders": { "desc": "説明を入力...", "globalSearch": "グローバルスマート検索..." },
        "headers": { "masterDir": "PM マスターディレクトリ" },
        "footer": { "dbTotal": "データベース合計:", "currentPage": "現在のページ:", "useNavArrows": "矢印を使用してください" }
      },
      "workflowHistory": {
        "title": "ワークフロー監査証跡",
        "trackingId": "トラッキングID:",
        "fetching": "レコードを取得中...",
        "currentTask": "現在のタスク",
        "since": "開始:",
        "by": "担当",
        "noHistory": "このトランザクションの履歴はまだありません",
        "closeBtn": "履歴を閉じる"
      },
      "pr": {
        "headers": { "prList": "購買リクエスト" },
        "actions": { "newPR": "新規リクエスト", "clearFilters": "フィルターをクリア", "routeWf": "ワークフローのルーティング" },
        "tabs": { "pr": "購買リクエスト", "prlines": "リクエスト行" },
        "sections": { "general": "一般情報", "financial": "財務の概要" },
        "fields": { "prNum": "リクエスト番号", "requestedBy": "要求者", "reqDate": "要求日", "refMr": "参照資材要求", "vendor": "ベンダー", "glAccount": "GLアカウント" },
        "financial": { "subtotal": "小計", "taxTotal": "税金合計", "grandTotal": "総合計" },
        "tables": { "prNum": "リクエスト番号", "description": "説明", "status": "ステータス", "totalCost": "合計コスト", "reqDate": "要求日", "site": "サイト", "itemNum": "アイテム番号", "itemType": "タイプ", "qty": "数量", "unitCost": "単価", "tax": "税", "lineTotal": "行合計", "taxCat": "税区分" },
        "messages": { "loadFailed": "購買リクエストの読み込みに失敗しました", "syncing": "同期中...", "noData": "データがありません", "noLines": "行がまだ追加されていません。", "fetchingMRLines": "資材要求の行を取得中: {{mrnum}}...", "loadedMRLines": "{{count}}行を読み込みました", "noMRLines": "この要求には行がありません", "failedMRLines": "行の読み込みに失敗しました" },
        "swal": { "lockedTitle": "ロック中", "cantDeleteStatus": "ステータス {{status}} では削除できません", "cantChangeCancel": "キャンセルされたリクエストはステータスを変更できません", "deleteWarnText": "これにより、購買リクエストとすべての行が完全に削除されます。" },
        "placeholders": { "desc": "説明を入力...", "globalSearch": "グローバルスマート検索..." },
        "footer": { "showing": "表示中", "totalRecords": "総レコード数" }
      },
      "po": {
        "headers": { "poList": "購買オーダー" },
        "actions": { "newPO": "新規オーダー", "clearFilters": "フィルターをクリア", "routeWf": "ワークフローのルーティング", "addManualRow": "手動で行を追加", "wfHistory": "ワークフロー履歴" },
        "tabs": { "po": "購買オーダー", "polines": "オーダー行" },
        "sections": { "general": "一般情報", "financial": "財務の概要", "lines": "購買オーダー行" },
        "fields": { "poNum": "オーダー番号", "requestedBy": "要求者", "orderDate": "発注日", "refPr": "参照PR", "vendor": "ベンダー", "glAccount": "GLアカウント" },
        "financial": { "subtotal": "小計", "taxTotal": "税金合計", "grandTotal": "総合計" },
        "tables": { "poNum": "オーダー番号", "totalCost": "合計コスト", "orderDate": "発注日", "itemNum": "アイテム番号", "itemType": "タイプ", "unitCost": "単価", "tax": "税", "lineTotal": "行合計", "taxCat": "税区分" },
        "messages": { "loadFailed": "購買オーダーの読み込みに失敗しました", "syncing": "同期中...", "noData": "一致するオーダーは見つかりません", "noLines": "行がまだ追加されていません。", "vendorRequired": "保存する前にベンダーを選択してください。", "fetchingLines": "行を取得中: {{num}}...", "loadedLines": "{{count}}行を正常に読み込みました", "noLinesFound": "このドキュメントには行がありません", "failedLines": "行の読み込みに失敗しました", "cantChangeCancel": "キャンセルされたリクエストはステータスを変更できません", "cantDeleteStatus": "ステータス {{status}} では削除できません" },
        "swal": { "deleteWarnText": "これにより、購買オーダーとすべての行が完全に削除されます。" },
        "placeholders": { "desc": "説明を入力...", "globalSearch": "グローバルスマート検索..." },
        "footer": { "showing": "表示中" }
      },
      "mr": {
        "headers": { "mrList": "資材要求" },
        "actions": { "newMR": "新規要求", "clearFilters": "フィルターをクリア", "routeWf": "ワークフロー送信", "createUsage": "出庫作成", "createUsageDesc": "出庫/移動レコードの作成", "createPR": "購買要求作成", "createPRDesc": "購買リクエストの作成", "addMaterial": "資材を追加" },
        "tabs": { "mr": "要求情報", "mrlines": "要求行" },
        "sections": { "general": "一般情報", "financial": "財務の概要", "mrItems": "資材要求アイテム", "financialCharging": "財務請求の詳細" }, 
        "fields": { "mrNum": "要求番号", "requestedBy": "要求者", "reqDate": "要求日", "refMr": "参照要求", "vendor": "ベンダー", "glAccount": "GLアカウント", "targetStore": "対象倉庫", "chargeLoc": "請求ロケーション", "chargeAsset": "請求資産", "chargeWO": "請求作業オーダー" },
        "financial": { "subtotal": "小計", "taxTotal": "税金合計", "grandTotal": "総合計" },
        "tables": { "mrNum": "要求番号", "description": "説明", "status": "ステータス", "totalCost": "合計コスト", "enteredDate": "入力日", "site": "サイト", "itemNum": "アイテム番号", "itemType": "タイプ", "qty": "数量", "unitCost": "単価", "tax": "税", "lineTotal": "行合計", "taxCat": "税区分", "stockItem": "在庫アイテム", "qtyReq": "要求数量", "estUnitCost": "推定単価" },
        "messages": { "loadFailed": "資材要求の読み込みに失敗", "syncing": "同期中...", "noData": "データがありません", "noLines": "行がありません。", "fetchingMRLines": "行を取得中: {{mrnum}}...", "loadedMRLines": "{{count}}行を読み込みました", "noMRLines": "行がありません", "failedMRLines": "読み込みに失敗しました", "generating": "{{docType}} を生成中...", "generatedSuccess": "{{docType}} {{docnum}} が正常に生成されました！", "generateFail": "{{docType}} の生成に失敗しました", "storeRequired": "倉庫は必須です！", "dateRequired": "要求日は必須です！" }, 
        "swal": { "lockedTitle": "ロック中", "cantDeleteStatus": "ステータス {{status}} では削除できません", "cantChangeCancel": "キャンセルされた要求は変更できません", "deleteWarnText": "これにより完全に削除されます。" },
        "placeholders": { "desc": "説明を入力...", "globalSearch": "グローバル検索...", "chooseLoc": "ロケーションを選択", "selectAsset": "資産を選択", "chargeWO": "作業オーダーに請求" },
        "lookups": { "storerooms": "倉庫", "inventory": "在庫検索", "locations": "サイトロケーション", "assets": "資産登録", "workorders": "作業オーダー" },
        "footer": { "showing": "表示中", "totalRecords": "総数" }
      },
      "contract": {
        "headers": { "masterNode": "契約マスターノード" },
        "placeholders": { "globalSearch": "グローバル検索...", "desc": "要約を入力...", "termDesc": "条項の詳細を入力..." },
        "actions": { "newContract": "新規契約", "save": "保存", "addTerm": "条項の追加", "addLine": "行の追加", "wfHistory": "ワークフロー履歴" },
        "tabs": { "general": "一般", "slaperformance": "SLA (パフォーマンス)", "termslegal": "条件と法的", "contractlines": "契約行" },
        "sections": { "identity": "識別と有効性", "communication": "連絡先", "auditInfo": "監査情報", "masterSLA": "SLAリンク", "slaBenchmarks": "SLAベンチマーク", "termsList": "法的条項", "lines": "作業範囲 / 行アイテム" },
        "options": { "supply": "供給契約", "labor": "労務/サービス契約", "lease": "リース契約", "allTypes": "すべてのタイプ", "allStatus": "すべての状態", "general": "一般", "payment": "支払い", "termination": "終了", "warranty": "保証", "liability": "責任" },
        "fields": { "contractNum": "契約番号", "vendorRef": "ベンダー", "startDate": "開始日", "endDate": "終了日", "contractValue": "契約金額", "currency": "通貨", "contactPerson": "担当者", "vendorEmail": "ベンダーのメール", "slaRef": "SLA 参照", "respTime": "応答時間 (時間)", "resTime": "解決時間 (時間)", "uptime": "可用性目標 (%)", "penalty": "ペナルティ (時間単位)", "grandTotal": "計算された総合計" },
        "tables": { "contractNum": "契約番号", "grandTotal": "総合計", "clauseType": "条項カテゴリ", "clauseDesc": "条項の詳細", "lineDesc": "行の説明", "rate": "レート", "lineTotal": "行合計" },
        "messages": { "fetchError": "同期に失敗しました", "syncing": "同期中...", "noData": "契約が見つかりません", "descMandatory": "説明は必須です", "vendorSelected": "ベンダー {{name}} が選択されました", "noTerms": "法的条項が定義されていません", "noLines": "行アイテムが定義されていません", "slaHint": "SLAをリンクすると、そのルールがグローバルに適用されます。" },
        "swal": { "deleteTitle": "最終削除？", "deleteText": "これにより、契約とすべての行が完全に削除されます。" },
        "footer": { "masterRecords": "マスターレコード:", "currentPage": "現在のページ:" }
      },
      "rfq": {
        "headers": { "rfqList": "見積依頼管理" },
        "tabs": { "rfq": "見積依頼", "rfqlines": "見積依頼行", "quotations": "見積書" },
        "sections": { "general": "一般情報", "financial": "財務の概要" },
        "fields": { "requestedBy": "要求者", "reqDate": "要求日", "refPr": "参照購入依頼", "vendor": "ベンダー", "vendorEmail": "ベンダーメール", "glAccount": "GLアカウント" },
        "financial": { "subtotal": "小計", "taxTotal": "税金", "grandTotal": "総合計" },
        "tables": { "rfqNum": "見積依頼番号", "totalCost": "合計コスト", "itemNum": "アイテム番号", "itemType": "タイプ", "unitCost": "単価", "tax": "税", "taxCat": "税区分" },
        "options": { "awarded": "落札" },
        "actions": { "newRFQ": "新規見積依頼", "sendEmail": "メール送信", "wfHistory": "WF履歴", "award": "落札＆PO作成" },
        "messages": { "loadFailed": "読み込みに失敗しました", "syncing": "同期中...", "noData": "データがありません", "noLines": "行アイテムがありません", "pullingPR": "PR行を取得中...", "prImported": "インポート完了！", "prFailed": "インポート失敗", "noEmail": "メールアドレスがありません！", "sending": "PDF生成＆メール送信中...", "sendSuccess": "メール送信完了！", "sendFailed": "送信失敗", "quotesHint": "ベンダーからの見積もりはここに自動表示されます。", "noQuotes": "見積もりはまだありません。", "awarding": "落札処理中...", "awardSuccess": "落札完了！", "poCreated": "POが作成されました", "awardFailed": "落札失敗" },
        "swal": { "sendTitle": "メールを送信しますか？", "sendText": "{{vendor}} にメールを送信しますか？", "awardTitle": "落札しますか？", "awardText": "これにより自動的に注文書（PO）が作成されます。" },
        "footer": { "showing": "表示中" }
      },
      "itemList": {
        "headers": { "master": "アイテムマスタ" },
        "actions": { "newItem": "新規アイテム" },
        "tables": { "item": "アイテム", "rotating": "回転？" },
        "messages": { "syncFailed": "マスターデータとの同期に失敗しました", "syncing": "レコードを同期中...", "noData": "一致するアイテムはありません" },
        "footer": { "totalItems": "合計アイテム:", "page": "ページ" }
      },
      "itemDetails": {
        "tabs": { "item": "アイテム", "inventory": "在庫", "vendors": "ベンダー", "specs": "仕様", "assembly": "アセンブリ (BOM)" },
        "sections": { "config": "アイテム構成", "units": "単位と追跡", "bomList": "BOMリスト", "supplierHistory": "購買およびサプライヤー履歴" },
        "actions": { "save": "保存", "addStore": "倉庫に追加", "newSpec": "新しい仕様", "addComponent": "コンポーネント追加" },
        "fields": { "itemSet": "アイテムセット", "rotating": "回転?", "lotControl": "ロット管理?", "inspectionReq": "要検査?", "orderUnit": "発注単位", "issueUnit": "出庫単位", "condition": "状態管理?", "sparepart": "スペアパーツ?", "classification": "分類" },
        "tables": { "store": "倉庫", "avgCost": "平均コスト", "balance": "残高", "attribute": "属性", "value": "値", "uom": "単位", "subItem": "子アイテム", "remarks": "備考", "vendor": "ベンダーコード", "supplierName": "サプライヤー名", "unitCost": "単価", "refPO": "参照PO", "activeVendors": "アクティブなベンダー" },
        "messages": { "reqFields": "アイテム番号と説明は必須です！", "fetchingAttributes": "属性を取得中...", "attributesLoaded": "属性がロードされました", "failedAttributes": "ロード失敗", "stockMsgTitle": "在庫メッセージ", "stockMsgDesc": "単位を変更すると、すべての倉庫に影響します。", "noInventory": "在庫記録がありません。", "noSpecs": "仕様が未定義です。", "noBom": "BOMが定義されていません。", "noVendors": "購買記録がありません。" },
        "swal": { "deleteText": "アイテム {{num}} を削除しようとしています。元に戻せません！" }
      },
      "changePassword": {
        "title": "パスワードの変更",
        "currentPwd": "現在のパスワード",
        "newPwd": "新しいパスワード",
        "confirmPwd": "新しいパスワード（確認）",
        "securityTitle": "セキュリティ検証",
        "googleAuthMsg": "この変更を確認するには、Google Authenticator から 6 桁のコードを入力してください。",
        "emailOtpMsg": "OTP コードがメールに送信されました。",
        "btnCancel": "キャンセル",
        "btnUpdate": "パスワードを更新",
        "btnVerify": "検証して変更",
        "btnBack": "戻る",
        "errMismatch": "新しいパスワードが一致しません！",
        "errLength": "パスワードは6文字以上である必要があります。",
        "msgVerifyReq": "続行するには本人確認を行ってください。",
        "msgSuccess": "パスワードが正常に変更されました！",
        "errFailed": "パスワードの変更に失敗しました。"
      },
      "userDetails": {
        "titleNew": "新規ユーザー",
        "titleEdit": "セキュリティ / ユーザー",
        "btnSave": "ユーザーを保存",
        "saving": "保存中...",
        "secIdent": "ユーザー識別",
        "lblLoginId": "ログイン ID",
        "lblFullName": "フルネーム",
        "lblDisplayName": "表示名",
        "lblEmail": "メールアドレス",
        "lblPassword": "パスワード",
        "lblActive": "アクティブ状態",
        "secAccess": "セキュリティとアクセス制御",
        "lblPrimaryRole": "プライマリ・セキュリティ・ロール",
        "lblSecRoles": "セカンダリ・ロール（追加）",
        "lblDefOrg": "デフォルト組織",
        "lblDefSite": "デフォルトサイト",
        "secDelegation": "作業委任",
        "lblDelegateTo": "作業を委任する",
        "lblStartDate": "開始日時",
        "lblEndDate": "終了日時"
      },
      "receivingDetails": {
        "errLoadLines": "発注書の行の読み込みに失敗しました",
        "errMissingDist": "すべての行に対して倉庫と数量を指定してください",
        "errInspMandatory": "この品目の検査決定は必須です",
        "errRejectExceeds": "拒否された数量を確認してください（到着数量を超えることはできません）",
        "msgSuccess": "トランザクションが正常に処理されました！",
        "msgAutoClosed": "自動的に閉じられました：",
        "swalAssignTitle": "倉庫の割り当て",
        "swalAssignText": "品目 {{item}} は現在 {{loc}} に割り当てられていません。今すぐ割り当てて受入を完了しますか？",
        "swalAssignBtn": "はい、割り当てて完了します",
        "errUnexpected": "受入中に予期しないエラーが発生しました",
        "hubTitle": "一括受入ハブ",
        "poRef": "発注書リファレンス：",
        "btnExecuting": "実行中...",
        "btnConfirm": "受入を確認",
        "tblItemsPending": "受入保留中の品目",
        "colItemDetails": "品目詳細",
        "colBalance": "残高",
        "lblQualityCheck": "品質チェックが必要",
        "lblUnits": "単位",
        "msgNoPending": "保留中の品目が見つかりません",
        "lblLandedCost": "仕入原価（総追加費用）",
        "lblBaseCost": "基準発注書単価",
        "lblStoreMatrix": "倉庫分配マトリックス",
        "btnSplitStore": "倉庫を分割",
        "colStoreroom": "倉庫",
        "colArrived": "到着",
        "colRejected": "拒否",
        "plcClickSearch": "クリックして検索 ->",
        "lookupSelectStore": "倉庫を選択",
        "lblQcMatrix": "品質管理意思決定マトリックス",
        "optSelectDecision": "-- 必須：決定を選択してください --",
        "optPassed": "完全合格（すべて受け入れ）",
        "optFailed": "完全拒否（ベンダーに返品）",
        "optPartial": "部分受け入れ（拒否フィールドを確認）",
        "lblInvValuation": "在庫評価（平均単価）",
        "lblNetArrived": "正味到着在庫",
        "msgSelectLine": "処理を開始するには、アクティブな発注書行を選択してください"
      },
      "userList": {
        "title": "ユーザーセキュリティ",
        "plcSearch": "ユーザーまたはメールを検索...",
        "btnNewUser": "新規ユーザー",
        "colUserId": "ユーザー ID",
        "colFullName": "フルネーム",
        "colRole": "ロール",
        "colSite": "サイト",
        "colStatus": "ステータス",
        "colEmail": "メール",
        "msgSyncing": "セキュリティを同期中...",
        "lblNoRole": "ロールなし",
        "lblAll": "すべて",
        "lblTotalUsers": "総ユーザー数：",
        "lblPage": "ページ",
        "errLoadUsers": "ユーザーの読み込みエラー"
      },
      "crafts": {
        "headers": {
          "craftList": "職種カタログ"
        },
        "actions": {
          "newCraft": "新規職種"
        },
        "tables": {
          "craftCode": "職種コード",
          "description": "説明",
          "stdRate": "標準レート/時",
          "site": "サイト",
          "org": "組織"
        },
        "messages": {
          "loadFailed": "職種の読み込みに失敗しました"
        },
        "headers": {
          "craftList": "職種カタログ"
        },
        "tabs": {
          "skills": "職種のスキルとレベル"
        },
        "sections": {
          "costing": "原価計算",
          "control": "コントロール"
        },
        "actions": {
          "newCraft": "新規職種",
          "addSkill": "スキルレベルを追加"
        },
        "tables": {
          "craftCode": "職種コード",
          "description": "説明",
          "stdRate": "標準レート/時",
          "site": "サイト",
          "org": "組織"
        },
        "fields": {
          "stdHourlyRate": "標準時給",
          "skillLevel": "スキルレベル（例：エキスパート、ジュニア）",
          "hourlyRate": "時給"
        },
        "placeholders": {
          "enterLevel": "レベルを入力..."
        },
        "messages": {
          "loadFailed": "職種の読み込みに失敗しました",
          "autoCalc": "スキルの合計から自動計算されます",
          "noSkills": "スキルはまだ定義されていません"
        }
      },
      "persons": {
        "headers": {
          "directory": "人物ディレクトリ"
        },
        "actions": {
          "newPerson": "新規人物"
        },
        "tables": {
          "personId": "人物 ID",
          "name": "表示名",
          "site": "サイト",
          "email": "メール",
          "phone": "電話"
        },
        "messages": {
          "loadFailed": "人物リストの読み込みに失敗しました"
        },
        "headers": {
          "directory": "人物ディレクトリ"
        },
        "tabs": {
          "profile": "プロフィール情報",
          "contact": "連絡先ディレクトリ",
          "access": "システムアクセス"
        },
        "sections": {
          "personalInfo": "個人情報",
          "statusControl": "ステータスと制御",
          "contactsDirectory": "関連する連絡先"
        },
        "tables": {
          "personId": "人物 ID",
          "name": "表示名",
          "site": "サイト",
          "email": "メール",
          "phone": "電話"
        },
        "fields": {
          "location": "ロケーション",
          "firstName": "名",
          "lastName": "姓",
          "title": "役職",
          "department": "部署",
          "currentStatus": "現在のステータス",
          "contactName": "連絡先名",
          "position": "役職",
          "email": "メールアドレス",
          "phone": "電話番号",
          "mobile": "携帯電話",
          "primary": "プライマリ",
          "address": "住所",
          "city": "市区町村",
          "country": "国",
        },
        "actions": {
          "newPerson": "新規人物",
          "addContact": "連絡先を追加"
        },
        "messages": {
          "loadFailed": "人物リストの読み込みに失敗しました",
          "noContacts": "連絡先はまだ追加されていません",
          "accessControlled": "システムアクセスはユーザーセキュリティモジュールによって制御されます"
        }
      },
      "jp": {
        "list": {
          "title": "作業計画ディレクトリ",
          "new_plan": "新規計画",
          "filter_jp": "計画をフィルタリング...",
          "search_desc": "説明を検索...",
          "filter_site": "サイト...",
          "no_records": "作業計画が見つかりません",
          "fetch_error": "作業計画の読み込みに失敗しました"
        },
        "fields": {
          "jpnum": "計画番号",
          "description": "説明",
          "status": "ステータス",
          "revision": "リビジョン",
          "site": "サイト"
        },
        "details": {
          "load_error": "作業計画の読み込みに失敗しました",
          "delete_warn": "作業計画 {{jpnum}} を削除しようとしています。この操作は元に戻せません！"
        },
        "tabs": {
          "job_plan": "作業計画",
          "plans": "計画詳細",
          "assets": "資産"
        },
        "subtabs": {
          "tasks": "タスク",
          "labor": "労働力",
          "materials": "資材",
          "tools": "ツール"
        },
        "sections": {
          "details": "計画の詳細",
          "responsibility": "責任",
          "woassets": "作業資産と安全計画"
        },
        "fields": {
          "jpnum": "計画番号",
          "status": "ステータス",
          "description": "説明",
          "template_type": "テンプレートタイプ",
          "duration": "期間（時間）",
          "supervisor": "監督者",
          "class": "クラス階層",
          "safety_plan": "安全計画",
          "revision": "リビジョン"
        },
        "table": {
          "seq": "順序",
          "duration": "期間",
          "craft": "職種",
          "labor": "作業員",
          "qty": "数量",
          "hours": "時間",
          "rate": "単価",
          "item": "アイテム",
          "unitcost": "単価",
          "tool": "ツール"
        }
      },
      "meters": {
        "list": {
          "title": "メーター定義",
          "search": "番号または名前でフィルター...",
          "new_meter": "新規メーター",
          "no_records": "メーターが見つかりません"
        },
        "fields": {
          "meter_num": "メーター番号",
          "meter_name": "メーター名",
          "type": "タイプ",
          "uom": "単位",
          "active": "アクティブ？",
          "remarks": "備考",
          "last_reading": "最終読み取り値",
          "last_date": "最終読み取り日",
          "rollovers": "総ロールオーバー数"
        },
        "tabs": {
          "meter": "メーター詳細",
          "where_used": "使用場所"
        },
        "sections": {
          "info": "メーター情報",
          "additional": "追加詳細",
          "stats": "メーター統計"
        },
        "where_used": {
          "linked_assets": "リンクされた資産",
          "linked_locations": "リンクされた場所",
          "linked_items": "リンクされたアイテム",
          "searching": "🔍 システム全体を検索中...",
          "no_assoc": "このカテゴリに関連付けは見つかりません。",
          "asset_num": "資産番号",
          "site": "サイト",
          "status": "ステータス",
          "location": "場所",
          "item_num": "アイテム番号",
          "category": "カテゴリ"
        }
      },
      "asset_categories": {
        "list": {
          "title": "資産カテゴリ",
          "search": "カテゴリを検索...",
          "new_category": "新規カテゴリ",
          "no_records": "カテゴリが見つかりません"
        },
        "fields": {
          "category_id": "カテゴリコード",
          "description": "説明",
          "dep_method": "減価償却方法",
          "life": "耐用年数(年)"
        }
      },
      "export": {
        "loading": "データを抽出しています...",
        "success": "エクスポートに成功しました！",
        "error": "データのエクスポート中にエラーが発生しました。"
      },
      "labor": {
        "list": {
          "title": "労働力登録",
          "new": "新規労働力",
          "total": "労働力総数",
          "unique_crafts": "ページの職種",
          "no_records": "一致する労働力レコードが見つかりません。"
        },
        "tabs": {
          "main": "メイン",
          "person": "個人",
          "crafts": "職種",
          "log": "ログ"
        },
        "sections": {
          "basic": "基本情報",
          "status": "ステータスと組織",
          "additional_crafts": "追加の職種と専門スキル"
        },
        "fields": {
          "personid": "個人参照",
          "primary_craft": "主な職種",
          "actual_rate": "実際のレート（時給）",
          "skill": "スキルレベル",
          "rate": "時給",
          "primary": "プライマリ？",
          "laborcode": "労働力コード",
          "fullname": "氏名",
          "craft": "職種"
        },
        "actions": {
          "add_craft": "職種を追加"
        },
        "lookup": {
          "person": "個人を選択",
          "craft": "職種を選択",
          "skill": "スキルを選択"
        },
        "messages": {
          "no_crafts": "職種の関連付けが見つかりません"
        },
        "details": {
          "delete_warn": "このレコードは復元できなくなります！"
        }
      },
      "sr": {
        "list": {
          "title": "サービスリクエスト追跡",
          "new": "新規リクエスト"
        },
        "fields": {
          "srnum": "リクエスト番号",
          "description": "説明",
          "reportedby": "報告者",
          "reportdate": "報告日",
          "priority": "優先度"
        },
        "messages": {
          "no_records": "サービスリクエストが見つかりません"
        },
        "tabs": {
          "main": "サービスリクエスト",
          "related": "関連レコード"
        },
        "sections": {
          "requester": "依頼者と連絡先",
          "problem": "問題の仕様",
          "logistics": "ロジスティクスと優先度"
        },
        "fields": {
          "phone": "電話番号",
          "email": "メール",
          "asset": "資産",
          "location": "場所",
          "long_desc": "問題の詳細な説明",
          "priority_1": "1 - 緊急 (即時)",
          "priority_2": "2 - 高 (即日)",
          "priority_3": "3 - 中 (72時間)",
          "priority_4": "4 - 低 (計画的)"
        },
        "lookup": {
          "person": "個人を選択",
          "asset": "資産を選択",
          "location": "場所を選択"
        },
        "details": {
          "delete_new_only": "新規 (NEW) リクエストのみ削除できます",
          "delete_warn": "これにより、このサービスリクエストは完全に削除されます。",
          "wf_tip": "自動ワークフロー：保存後、「ワークフローのルーティング」ボタンを使用して、技術レビューのためにこのリクエストを送信してください。",
          "wo_tip": "ヒント：ワークフローアクションまたは「作業指示書の作成」自動化スクリプトを使用して、このSRから作業指示書を生成できます。"
        },
        "related": {
          "title": "SR のリンクされた作業指示書:",
          "wonum": "WO番号",
          "worktype": "作業タイプ",
          "no_wo": "このSRにはまだ作業指示書が作成されていません。",
          "go_to_wo": "作業指示書に移動"
        }
      },
      "invusage": {
        "list": {
          "title": "在庫使用履歴",
          "new": "新規トランザクション"
        },
        "types": {
          "all": "すべて",
          "issue": "出庫",
          "transfer": "振替",
          "return": "返品"
        },
        "tabs": {
          "lines": "使用行",
          "log": "トランザクションログ"
        },
        "details": {
          "summary": "行の概要",
          "transfer_dest": "転送先の詳細",
          "financial": "財務請求と参照"
        },
        "actions": {
          "add_item": "アイテムの追加",
          "add_part": "部品の追加",
          "select_mr": "品目要求の選択"
        },
        "fields": {
          "stock_item": "在庫アイテム",
          "issueunit": "出庫単位",
          "qty": "数量",
          "unitcost": "単価",
          "linecost": "行の合計値",
          "target_bin": "ターゲットビン",
          "target_loc": "ターゲットの場所",
          "assetnum": "資産番号",
          "wonum": "作業指示書の参照",
          "glaccount": "借方GL勘定",
          "usagenum": "使用ID",
          "type": "タイプ",
          "fromstore": "出庫元",
          "lines": "行",
          "enterby": "入力者"
        },
        "placeholders": {
          "select_item": "アイテムを選択...",
          "dest_bin": "宛先ビンを入力...",
          "choose_loc": "場所を選択",
          "select_asset": "資産を選択",
          "charge_wo": "作業指示書に請求"
        },
        "lookup": {
          "store": "保管室",
          "dest_store": "宛先保管室",
          "mr": "承認済みの品目要求を選択",
          "item": "在庫検索",
          "loc": "サイトの場所",
          "asset": "資産レジストリ",
          "wo": "作業指示書"
        },
        "messages": {
          "req_fromstore": "まず保管室を選択してください！",
          "mr_loaded": "品目要求からアイテムをロードしました:",
          "mr_fail": "品目要求アイテムのロードに失敗しました",
          "insufficient_title": "在庫不足！",
          "available": "利用可能",
          "create_pr": "購買依頼(PR)を作成しますか？",
          "btn_create_pr": "PRを作成",
          "processing": "在庫調整を処理中...",
          "inventory_updated": "在庫レベルが正常に更新されました",
          "cant_delete_comp": "完了したトランザクションは削除できません！",
          "delete_warn": "これにより、下書きトランザクションが完全に削除されます。",
          "req_fields": "説明と保管室は必須です！",
          "req_transfer": "転送には宛先保管室が必要です！",
          "locked_title": "レコードがロックされています",
          "locked_text": "このトランザクションは完了しており、変更できません。",
          "cant_save_comp": "完了したレコードに変更を保存できません",
          "balance_move": "注：残高は完了時に移動します：",
          "upon_comp": "。"
        }
      },
      "downtime": {
        "title": "資産のダウンタイム報告",
        "subtitle": "資産管理システム",
        "asset": "資産",
        "status": "オフライン記録",
        "start": "開始日時",
        "end": "終了日時（任意）",
        "type": "ダウンタイムタイプ",
        "types": {
          "unplanned": "予定外 (故障)",
          "planned": "計画的 (メンテナンス)"
        },
        "duration": "計算された期間",
        "hours": "時間",
        "prod_impact": "稼働停止（生産への影響）",
        "btn_commit": "変更を確定",
        "messages": {
          "recording": "ダウンタイムを記録しています...",
          "success": "ダウンタイムが正常に記録されました",
          "validation_error": "フォーマットエラー: 全項目を確認してください",
          "server_error": "サーバーエラー: 500"
        },
        "history": {
          "title": "資産ダウンタイム履歴",
          "subtitle": "資産のパフォーマンス追跡",
          "no_records": "この資産に記録されたダウンタイムイベントはありません。",
          "duration_hrs": "期間（時間）",
          "type_reason": "タイプ/理由",
          "impact": "影響",
          "reported_by": "報告者",
          "still_down": "まだ停止中",
          "prod_loss": "生産損失",
          "technical": "技術的",
          "active_down": "アクティブなダウンタイム",
          "resolved": "解決済み"
        }
      },
      "incidents": {
        "list": {
          "title": "インシデント登録",
          "new": "新規インシデント"
        },
        "fields": {
          "ticket_id": "チケットID",
          "priority": "優先度",
          "reported_by": "報告者"
        },
        "details": {
          "ticket": "インシデントチケット",
          "general": "一般的な説明",
          "detailed": "詳細な詳細",
          "context": "コンテキストとステータス",
          "linked_asset": "リンクされた資産",
          "workorder": "作業指示書",
          "delete_warn": "インシデント {{ticket}} を完全に削除しようとしています。この操作は元に戻せません！"
        },
        "lookup": {
          "asset": "リンクされた資産を選択",
          "loc": "場所を選択"
        }
      },
      "tools": {
        "list": {
          "title": "ツールマスター",
          "new": "新規ツール"
        },
        "fields": {
          "toolnum": "ツール番号",
          "type": "タイプ",
          "is_stocked": "在庫あり？"
        },
        "tabs": {
          "tool": "ツール",
          "stores": "保管室",
          "vendors": "ベンダー",
          "specs": "仕様",
          "quals": "資格"
        },
        "sections": {
          "config": "ツール構成",
          "inventory": "在庫と残高",
          "vendors": "調達とサプライヤーの履歴",
          "quals": "必要な資格"
        },
        "fields": {
          "toolnum": "ツール番号",
          "type": "ツールタイプ",
          "issueunit": "出庫単位",
          "is_stocked": "在庫ツールですか？",
          "rotating": "回転アイテム？",
          "calib_req": "校正が必要ですか？",
          "mfg": "メーカー",
          "model": "モデル番号",
          "class": "分類",
          "active_vendors": "アクティブなベンダー"
        },
        "actions": {
          "add_store": "保管室に追加",
          "add_qual": "資格を追加"
        },
        "tables": {
          "storeroom": "保管室",
          "balance": "残高",
          "attr": "属性",
          "value": "値",
          "uom": "単位",
          "qual": "資格",
          "vendor_id": "ベンダー (会社番号)",
          "vendor_name": "サプライヤー名",
          "unitcost": "単価",
          "qty": "数量",
          "po": "関連PO"
        },
        "placeholders": {
          "toolid": "ツールIDを入力...",
          "reg_supplier": "登録済みサプライヤー",
          "adj": "在庫調整"
        },
        "lookup": {
          "type": "ツールタイプ",
          "unit": "出庫単位",
          "attr": "属性"
        },
        "messages": {
          "req_fields": "ツール番号と説明は必須です！",
          "delete_warn": "この操作は元に戻せません！",
          "class_loaded": "分類と属性がロードされました",
          "stocked_note": "注：在庫ツールは保管室を通じて管理され、残高を追跡するための在庫レコードが必要です。",
          "no_stock": "在庫にアイテムがありません"
        }
      },
      "inventory": {
        "list": {
          "title": "在庫登録"
        },
        "fields": {
          "itemnum": "アイテム番号",
          "location": "保管室",
          "balance": "残高",
          "avgcost": "平均原価"
        },
        "details": {
          "profile": "在庫プロファイル",
          "reorder_logic": "発注ロジック",
          "reorder_pt": "発注点",
          "eoq": "経済的発注量",
          "critical_lvl": "危機的レベル",
          "critical_desc": "残高が発注点に達したときにPRを自動生成します。",
          "current_stock": "現在の在庫レベル",
          "avail_qty": "利用可能数量",
          "reserved_qty": "引当済数量",
          "held_wo": "作業指示書用に保持",
          "avg_cost": "平均単価",
          "avg_cost_desc": "すべての入庫の加重平均",
          "total_val": "総在庫価値",
          "total_val_desc": "現在の残高 × 平均原価",
          "last_cost": "最終入庫原価",
          "last_cost_desc": "最新のPOからの原価",
          "val_method": "在庫評価方法",
          "avg_method": "平均原価法",
          "val_desc1": "このアイテムは",
          "val_desc2": "を使用しています。単価は発注書の入庫ごとに自動的に再計算され、市場価格の変動を反映します。"
        },
        "tabs": {
          "balances": "残高",
          "trans": "トランザクション履歴",
          "costs": "コスト"
        },
        "actions": {
          "adjustment": "在庫調整"
        },
        "tables": {
          "qty": "数量",
          "actual_cost": "実績原価",
          "reference": "参照"
        },
        "messages": {
          "no_trans": "トランザクション履歴が見つかりません"
        },
        "trans_types": {
          "receipt": "入庫",
          "issue": "出庫",
          "transfer": "振替",
          "adjustment": "調整"
        }
      },
      "storerooms": {
        "list": {
          "title": "保管室",
          "new": "新規保管室"
        },
        "fields": {
          "location": "保管室",
          "isdefault": "デフォルトですか？",
          "inventory": "在庫",
        },
        "details": {
          "profile": "保管室",
          "record": "保管室レコード",
          "gen_settings": "一般設定",
          "filtered_by": "{{org}} でフィルタリング",
          "select_org_first": "最初に組織を選択してください",
          "gl_accounts": "GL勘定科目",
          "inv_control": "在庫管理",
          "inv_control_desc": "この保管室のすべての資材の出庫と入庫は、これらの勘定科目と照合されます。",
          "items_stocked": "在庫アイテム"
        },
        "tabs": {
          "main": "メイン",
          "inventory": "在庫"
        },
        "fields": {
          "location": "ロケーションID",
          "isdefault": "デフォルトの保管室？",
          "useinpo": "POで使用しますか？",
          "invowner": "在庫の所有者",
          "controlacc": "管理勘定",
          "shrinkacc": "減耗勘定",
          "glaccount": "デフォルトのGL勘定科目",
          "default": "デフォルト"
        },
        "lookup": {
          "person": "担当者を選択"
        },
        "tables": {
          "itemnum": "アイテム番号",
          "uom": "単位",
          "curbal": "現在の残高",
          "reserved": "引当済数量"
        },
        "messages": {
          "req_fields": "ロケーションIDは必須です！",
          "req_org_site": "組織とサイトは必須です！",
          "delete_warn": "保管室 {{store}} を削除しようとしています。この操作は元に戻せません！"
        }
      },
      "failure_codes": {
        "list": {
          "title": "故障代码库",
          "new": "新建故障类别"
        },
        "details": {
          "profile": "故障类别"
        },
        "fields": {
          "class": "故障类别",
          "code": "代码",
          "desc_tech": "描述 / 技术名称"
        },
        "tables": {
          "problems": "问题 (现象)",
          "causes": "原因 (根本原因)",
          "remedies": "补救措施 (行动)"
        },
        "placeholders": {
          "class": "例如：PUMP-FAIL",
          "desc_tech": "提供此故障层次结构的详细描述...",
          "code": "输入代码...",
          "desc": "技术描述..."
        },
        "messages": {
          "req_class": "故障类别代码是必填项！",
          "delete_warn": "您即将删除故障类别 {{class}}。此操作无法撤销！"
        }
      },
      "scheduler": {
        "title": "ディスパッチとスケジュール設定",
        "ai_optimize": "AI自動最適化",
        "publish": "スケジュールを公開",
        "kpi_scheduled": "予定された作業",
        "kpi_issues": "スケジュールの問題",
        "kpi_utilization": "総リソース",
        "kpi_emergencies": "緊急事態",
        "no_data": "スケジュールされた作業指示書はありません。",
        "no_resources": "リソースの容量データがありません。",
        "fetch_error": "スケジュールデータの読み込みに失敗しました。",
        "optimizing": "AIがリソースの負荷を平準化しています...",
        "optimize_fail": "AIの最適化に失敗しました。"
      },
      "features": {
        "title": "線形フィーチャカタログ",
        "feature_id": "フィーチャコード",
        "description": "説明",
        "type": "フィーチャタイプ",
        "point": "ポイント (例：バルブ)",
        "linear": "線形 (例：材質)",
        "error_in_use": "削除できません：このフィーチャはパイプラインで使用中です。"
      },
      "audit": {
        "title": "監査証跡エクスプローラー",
        "history_for": "履歴：",
        "retrieving": "監査レコードを取得中...",
        "no_records": "このレコードの監査証跡は見つかりません"
      },

    }
  },
  // 🇰🇷 한국어 (Korean)
 ko: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "자산의 탁월함", version: "Teknora v1.0.4" },
      search: { placeholder: "모듈 검색..." },
      menu: {
        settings: "설정", organization: "조직", domains: "도메인", field_config: "필드 구성", classifications: "분류", importer: "범용 임포터", cobie: "COBie 관리자", workflow: "워크플로우 엔진", scripts: "액션 스크립트",
        analytics: "분석", dashboards: "BI 대시보드", report_designer: "보고서 디자이너", report_wizard: "보고서 마법사",
        assets: "자산", asset_registry: "자산 등록", locations: "위치", categories: "자산 범주", meters: "미터", failure_codes: "고장 코드",
        work_management: "작업 관리", wo_tracking: "작업 오더 추적", labor_reporting: "스케줄러",
        resources: "자원", crafts: "직종", labor: "노무", person: "개인",
        service_desk: "서비스 데스크", service_requests: "서비스 요청", incidents: "인시던트 등록",
        procurement: "구매", po: "구매 오더", pr: "구매 요청", rfq: "견적 요청", receiving: "입고", vendors: "벤더",
        contracts: "계약", contracts_master: "계약 마스터", sla: "SLA",
        inventory: "재고", item_master: "품목 마스터", tools: "공구", balances: "재고 잔액", transfers: "출고 및 이동", storerooms: "창고",
        planning: "계획", pm_schedules: "PM 일정", safety_plans: "안전 계획", hazards: "위험", precautions: "예방 조치", tagouts: "태그아웃", job_plans: "작업 계획",
        security: "보안", user_list: "사용자 목록", groups: "보안 그룹", "recent": "최근 방문"
      },
      user_settings: { title: "사용자 설정", default_info: "기본 정보", personal_info: "개인 정보", password_info: "비밀번호 정보", sign_out: "로그아웃", system_info: "시스템 정보" },
      notifications: { title: "수신함 작업", new_alerts: "새로운", empty: "수신함이 비어 있습니다", view_all: "모든 활동 보기" },
      sidebar: { queries: "사용 가능한 조회", all_assets: "모든 자산", operating_assets: "운영 자산", critical_assets: "중요 자산", my_bookmarks: "내 즐겨찾기", common_actions: "공통 작업", new: "새로 만들기", move_assets: "자산 이동", print_barcodes: "바코드 출력", create_report: "보고서 생성", wo_queries: "작업 조회", all_wo: "모든 작업 오더", waiting_approval: "승인 대기", wip: "진행 중", completed_today: "오늘 완료", bulk_approve: "일괄 승인", record_actions: "레코드 작업", save: "저장", delete: "삭제", workflow_status: "워크플로우 / 상태", change_status: "상태 변경", view_history: "이력 보기", item_ops: "품목 작업", add_to_storeroom: "창고에 추가", inv_ops: "재고 작업", reorder: "재주문", tax_ops: "세무 작업", tax_category: "세금 범주", create_po: "PO 생성", settings_group: "설정", system_settings: "시스템 설정", email_settings: "이메일 설정", asset_ops: "자산 작업", meter_readings: "미터 검침", hist_readings: "이력 검침", report_downtime: "가동 중지 보고", downtime_hist: "중지 이력", move_mod_asset: "자산 이동/수정", asset_move_hist: "자산 이동 이력", create_related: "관련 생성", create_incident: "인시던트 생성", view_inc_hist: "인시던트 이력", create_wo: "작업 오더 생성", sr: "서비스 요청", apply_sla: "SLA 적용", approve_wo: "작업 오더 승인", start_work: "작업 시작", complete_work: "작업 완료", close_wo: "작업 오더 종료", analytics: "분석", wf_history: "워크플로우 이력", history_log: "로그", wo_costs: "작업 비용", purchase_info: "구매 정보", all_records: "모든 레코드", find_nav: "항목 찾기", more_actions: "추가 작업", settings: "설정", export_data: "데이터 내보내기", audit_log: "감사 로그", share_app: "앱 공유" },
      apps: {
        ORGANIZATION: "조직", ASSET: "자산", LOCATION: "위치", WORKORDER: "작업 오더", INVENTORY: "재고", CLASSIFICATION: "분류", VENDOR: "공급업체", METER: "미터", DOMAINS: "도메인", CRAFTS: "직종", STOREROOMS: "창고", ITEMS: "품목 마스터", INVENTORYUSAGE: "재고 사용", MR: "자재 요청", PR: "구매 요청", PO: "구매 오더", LABOR: "노무", PM: "PM 일정", SAFETY: "안전 계획", HAZARD: "위험", TAGOUT: "태그아웃", PRECUTION: "예방 조치", SR: "서비스 요청", INCIDENT: "인시던트", ASSET_CATEGORIES: "자산 범주", FAILURECLASS: "고장 코드", RFQ: "견적 요청", CONTRACT: "계약", SLA: "서비스 수준 계약", FAILURE_CODES: "오류 코드",
        "VENDOR": "공급업체", "TAGOUTS": "태그아웃", "PRECAUTIONS": "예방 조치", "INCIDENTS": "인시던트", "JOBPLAN": "작업 계획", "ROLE": "역할", "TOOLS": "도구", "USER": "사용자"
      },
      dashboard: { tab_bi: "KPI 템플릿", tab_inbox: "워크플로우 수신함", advanced_analytics: "고급 분석", workflow_center: "실행 센터", active_tasks: "활성 작업", history_tasks: "기록", no_data: "데이터 없음", take_action: "조치", previous: "이전", next: "다음", showing: "표시", of: "중", actual: "실제", target: "목표", kpi_graph: "KPI 그래프" },
      username: "사용자 ID",
      password: "비밀번호",
      login_btn: "로그인",
      forgot_pwd: "비밀번호를 잊으셨나요?",
      login: {
        id_placeholder: "ID를 입력하세요",
        error_msg: "ID 또는 비밀번호가 잘못되었습니다",
        server_error: "서버 연결 실패",
        just_smart: "저스트 스마트"
      },
      organizations: { title: "조직", org_id: "조직", description: "설명", active: "활성?" },
      org_detail: { org_label: "조직", tabs: { organization: "조직", sites: "사업장", map: "地图" }, fields: { currency1: "기본 통화 1", currency2: "기본 통화 2", item_set: "품목 세트", company_set: "회사 세트", item_status: "기본 품목 상태", active: "활성?" }, descs: { currency1: "주 통화", currency2: "보조 통화", item_set: "품목 세트", company_set: "회사 세트" }, lookups: { currency: "통화", item_set: "품목 세트", company_set: "회사 세트", status: "상태", governorate: "시/도" }, sites: { management: "사업장 관리", new_row: "행 추가", of: "/", site_id: "사업장 ID", description: "설명", active: "활성?", action: "동작", site_details: "사업장 상세", state: "시/도", contact: "주요 연락처", fin_info: "재무/예산 정보", yearly_budget: "연간 예산", monthly_budget: "월간 예산", utilization: "연간 가동률", fin_health: "재무 상태가 안정적입니다." }, toasts: { id_required: "조직 ID가 필요합니다!", saving: "저장 중...", success: "저장 성공!", fail: "저장 실패" } },
      domains: { title: "도메인", find_placeholder: "도메인 찾기...", new_domain: "새 도메인", domain_id: "도메인", description: "설명", type: "유형", values: "값" ,
        save_btn: "저장", desc_placeholder: "도메인 설명", synonym_values: "동의어 값", new_row: "행 추가", internal_val: "내부 값", external_desc: "외부 설명", default: "기본값?", action: "동작", no_values: "정의된 값이 없습니다.", toasts: { loading: "로딩 중...", load_fail: "로딩 실패", id_required: "ID가 필요합니다!", saving: "저장 중...", save_success: "저장 성공!", save_fail: "저장 실패" } },
      classifications: { parent: "상위 분류", order: "순서", hierarchy: "분류 구조", hierarchy: "계층 구조 경로", parent: "상위 분류", gen_desc: "설명 생성?", use_with: "개체와 함께 사용", attributes: "속성", attr_id: "속성 ID", section: "섹션", uom: "측정 단위" },
      bim: { title: "BIM 통합기 Pro", subtitle: "고급 Revit-COBie 매핑", waiting_translation: "모델 변환 대기 중...", tabs: { "3d": "3D 뷰어", data: "데이터 테이블" }, preview_table_title: "COBie 구성 요소 미리보기", controls: { destination: "대상", select_site: "사업장 선택", uploads: "파일 업로드", select_cobie: "COBie 파일 선택", upload_revit: "Revit 파일 업로드", models_ready: "모델 준비됨", preview_list: "미리보기 모델", finalizing: "최종 동기화 중...", commit: "BIM 통합 실행" }, table: { asset_name: "자산명", location: "공간 / 위치" } },
      importer: { title: "범용 데이터 로더", target_table: "대상 테이블", download_template: "템플릿 다운로드", upload_instruction: "업로드할 Excel 파일 선택", field_mapping: "필드 매핑", excel: "Excel", ignore: "무시", preview_title: "미리보기", execute_btn: "가져오기 실행" },
      workflow: { title: "워크플로우 엔진", subtitle: "자동화 제어 센터", export_btn: "CSV 내보내기", new_process: "새 프로세스", loading: "로딩 중...", unnamed: "이름 없는 프로세스", linked_to: "연결 대상", create_path: "새 경로 생성", name: "프로세스 이름",
                  designer_title: "워크플로우 디자이너 (루프백 활성)", publish_btn: "게시", loading_designer: "로직 경로 재구성 중...", logic_palette: "로직 팔레트", config_title: "구성", node_label: "레이블", assign_roles: "역할 할당", post_action: "사후 작업 스크립트", select_lookup: "검색에서 선택", script_hint: "* 여러 스크립트는 쉼표로 구분할 수 있습니다.", status_auto: "상태 자동 작업", trigger: "트리거", target_status: "대상 상태", cond_expr: "조건식 (Python)", escalation: "에스컬레이션 (시간)", select_node: "편집할 노드 선택",
          options: {no_change: "상태 변경 없음", change_status: "상태 변경", select_status: "상태 선택" },
          table: {id: "식별자", name: "프로세스 이름", app: "애플리케이션", status: "상태"},
          lookups: {select_roles: "역할 찾기", select_scripts: "스크립트 선택"},
          swal: {publish_title: "워크플로우를 게시하시겠습니까?", publish_text: "엔진 단계가 데이터베이스와 동기화됩니다.", confirm_publish: "예, 지금 게시", delete_title: "로직을 삭제하시겠습니까?", delete_text: "정말로 삭제하시겠습니까: ", confirm_delete: "예, 모두 삭제"},
          toasts: {id_required: "프로세스 이름을 입력하세요", saving: "워크플로우 동기화 중...", save_success: "로직 동기화 성공! 🚀", save_fail: "동기화 실패", purging: "워크플로우 삭제 중...", delete_success: "워크플로우가 영구 삭제되었습니다", delete_fail: "삭제 실패", fetch_fail: "데이터 로드 실패"}
      },
      field_config: { title: "메타데이터 필드 매핑", table_name: "테이블 이름", field_name: "필드 이름", current_mappings: "현재 매핑:", field: "필드", linked_domain: "연결된 도메인" },
      scripts: {
        title: "액션 스크립트",
        subtitle: "자동화 및 로직 템플릿 관리",
        new_btn: "새 스크립트 생성",
        search_placeholder: "이름 또는 개체로 검색...",
        table: {
          name: "스크립트 이름",
          object: "대상 개체",
          created: "생성일"
        },
        toasts: {
          fetch_fail: "스크립트 로드 실패"
        }
      },
      studio: { schema_explorer: "스키마 탐색기", target_context: "대상 개체 컨텍스트", name_placeholder: "스크립트 이름 지정...", engine_info: "엔진: PYTHON 3.10", console_title: "시스템 실행 콘솔", clear_console: "콘솔 지우기", field_from: "필드:", access_col: "컬럼 액세스:", db_model: "DB 모델", btns: { compile: "컴파일", compiling: "컴파일 중...", save_deploy: "저장 및 배포" }, toasts: { preserved: "저장되었습니다!", compiled: "분석 완료!" }, console: { init: "초기화 중...", schema_sync: "동기화 성공。", schema_fail: "동기화 실패。", saved_prefix: "저장 성공", error_op: "저장 오류。", compiling: "컴파일 시작...", build_finish: "빌드 완료。", syntax_error: "구문 오류。", build_fail: "빌드 실패", analyzing: "구문 분석 중..." } },
      reports: { title: "보고서 템플릿", new_btn: "새 보고서 생성", search_placeholder: "검색...", table: { name: "보고서 이름", ref_obj: "참조 개체", updated: "최종 업데이트" }, 
          toasts: { load_fail: "로드 실패", clone_success: "보고서 복제됨", save_success: "템플릿 저장 완료! 🚀", save_fail: "저장 실패" },
          designer: {
                  title: "보고서 엔진 프로", live_preview: "실시간 미리보기", publish: "템플릿 게시", model_select: "모델 선택", data_explorer: "데이터 탐색기", components: "구성 요소", page_break: "페이지 나누기", is_summary: "요약 보고서?",
                  user_params: "사용자 매개변수", add_param: "입력 필드 추가", master_info: "마스터 정보", relational_data: "관계형 데이터", detail_tables: "상세 테이블", tabs: { body: "본문", header: "헤더", footer: "푸터", css: "전역 CSS" },
                  fields: { wonum: "작업 번호", assetnum: "자산 번호", desc: "설명", status: "상태", asset: "자산명", location: "위치 ID", tasks_table: "작업 테이블", mat_table: "계획 자재", asset_basic: "자산 기본 정보", inv_basic: "재고 기본 정보", vend_basic: "공급업체 기본 정보" }
                },
        }, 
      assets: { 
        map: { "gps_location": "지리적 위치 (GPS)", "gps_coordinates": "GPS 좌표"},
        list: { system_title: "자산 관리 시스템", new_asset: "새 자산 등록", all_orgs: "모든 조직", all_sites: "모든 사이트", db_total: "총계:", display_page: "페이지:", navigate_hint: "화살표를 사용하여 이동하세요", col_site: "사이트", col_org: "조직" }, 
        modal: { migration_title: "대규모 자산 이동", caution_prefix: "주의: ", caution_suffix: "개의 자산을 이동합니다.", dest_label: "새 대상 위치", placeholder: "위치 선택...", abort: "중단", execute: "대량 이동 실행" },
        headers: { asset_num: "자산 번호", desc: "설명", status: "상태", downtime: "총 가동 중지 시간", site: "사업장" },
        tabs: { details: "자산 세부 정보", spare_parts: "예비 부품", safety: "안전", meters: "계기", specs: "사양", history: "작업 이력", map: "지도", bim: "3D 뷰", ai: "AI 분석", eval: "평가", attachments: "첨부 파일" },
        sections: { "linear_details": "선형 참조 세부 정보", general: "일반 정보", details: "세부 사항", finance: "주소 및 재무", image: "자산 이미지", audit: "감사 정보", bim_info: "BIM 정보", reliability: "신뢰성 분석" },
        fields: { "is_linear": "선형 자산입니까?", "start_measure": "시작 측정", "end_measure": "종료 측정", "measure_unit": "측정 단위", "direction": "흐름 방향", type: "자산 유형", location: "위치", parent: "상위 자산", category: "자산 범주", is_running: "자산 가동 중?", serial: "일련 번호", item: "회전 품목", failure: "고장 클래스", safety_plan: "안전 계획", vendor: "공급업체", price: "구매 가격", replace: "교체 비용", priority: "우선순위", ytd_cost: "연간 누적 비용" },
        meters: { seq: "순서", name: "계기", reading: "최종 검침", date: "검침일", inspector: "검사원", remarks: "비고" },
        ai: { title: "자산 인텔리전스", run: "진단 실행", summary: "기술 요약", recommend: "권장 사항", telemetry: "원격 측정 분석 중..." },
        spare_fields: { item: "회전 품목", qty: "수량", issued: "출고 수량", remarks: "비고", item_details: "품목 세부 정보" },
        safety: { plan_card: "관련 안전 계획", active_plan: "활성 안전 계획", no_plan: "연결된 계획 없음", link_plan: "안전 계획 연결", change_plan: "계획 변경", hazard_title: "자산별 위험", hazard_num: "위험", hazard_type: "유형 / 우선순위", no_hazards: "이 자산에 연결된 특정 위험이 없습니다.", add_hazard: "위험 추가", loto_title: "잠금/표지 (LOTO)", tag_id: "표지 ID", req_state: "필요 상태", no_loto: "정의된 격리 지점이 없습니다.", add_loto: "격리 지점 추가", applying_proto: "안전 프로토콜 적용 중..." }, 
        meters: { title: "관련 계기", details_title: "계기 세부 정보", seq: "순서", meter_name: "계기 이름", meter_type: "계기 유형", uom: "측정 단위", active_status: "활성?", last_reading: "최종 검침", last_date: "검침일", inspector: "검사원", remarks: "비고", new_meter: "새 계기" },
        specs: { classification: "분류", select_class: "분류 선택...", tech_specs: "기술 사양", attribute: "속성", value: "값", uom: "측정 단위", data_type: "데이터 유형", attr_details: "속성 세부 정보", select_val: "값 선택" },
        history: { title: "작업 오더 이력", wo_num: "작업 번호", finish_date: "완료일", no_history: "이 자산에 대한 작업 이력이 없습니다.", fetching: "이력 가져오는 중...", wo_type: "유형" },
        bim: { model_status: "모델 상태", linked: "연결됨 및 활성", not_linked: "연결되지 않음", upload_revit: "Revit 업로드 (.rvt)", urn_label: "모델 URN", "show_3d": "디지털 트윈 보기 (3D)", "not_linked": "3D 모델에 연결되지 않음" },
        ai: { title: "자산 지능", sub_title: "AI 분석기", tagline: "산업용 IoT 예측 진단", run_btn: "진단 실행", analyzing: "원격 측정 스트림 분석 중...", health_score: "상태 점수", thermal: "열 경고", vibration: "진동 경고", tech_summary: "기술 요약", recommendations: "권장 사항", sensors_chart: "센서 vs 임계 제한", init_prompt: "AI 분석을 시작하려면 진단 실행을 클릭하십시오", critical: "심각", normal: "정상", stable: "안정됨", detected: "감지됨", "predictive_trajectory": "예측 고장 궤적", "est_failure": "예상 고장", "loading_pred": "예측 모델 생성 중..." },
        "features": {
          "feature_id": "기능 ID",
          "label": "레이블",
          "start": "시작 측정",
          "end": "종료 측정 (비어 있음 = 포인트)",
          "value": "값 (예: 500mm)",
          "details": "기능 세부 정보",
          "y_offset": "Y 오프셋 (오른쪽/왼쪽)",
          "z_offset": "Z 오프셋 (깊이/높이)"
        },

      }, 
      common: { "days": "일", "weeks": "주", "months": "개월", "years": "년", "daysList": { "saturday": "토요일", "sunday": "일요일", "monday": "월요일", "tuesday": "화요일", "wednesday": "수요일", "thursday": "목요일", "friday": "금요일"}, "select": "선택", "search": "검색", "pending": "대기 중", "pendingSelection": "--- 선택 대기 중 ---",confirm: "확인", save_settings: "AI 설정 저장", selected: "선택된 자산", bulk_move: "대량 이동", change_status: "상태 변경", cancel: "초기화", save: "저장", cancel: "취소", delete: "삭제", back: "뒤로", record: "기록", total: "합계", print: "인쇄", active: "활성", critical: "위험", warning: "경고", healthy: "정상", of: "의", new_row: "새 행", "filter": "필터...", "save_success": "성공적으로 저장되었습니다", "save_fail": "저장 실패", "delete": "삭제", "delete_success": "성공적으로 삭제되었습니다", "delete_fail": "삭제 실패", "are_you_sure": "확실합니까?", "cancel": "취소", "confirm": "확인", "first": "처음", "last": "마지막", "next": "다음", "prev": "이전", "sar": "SAR", "all": "모두", "attachments": "첨부 파일", "history": "내역",    "change_status": "상태 변경", "totalRecords": "총 기록", "readOnly": "(읽기 전용)", "noDescription": "설명 없음", "recordLocked": "레코드가 잠겨 있어 수정할 수 없습니다.", "descRequired": "설명은 필수 항목입니다!", "actionDenied": "작업 거부됨", "cantDeleteStatus": "상태가 {{status}}인 레코드는 삭제할 수 없습니다", copy: "복사", cancel: "취소", clone: "복제", back: "돌아가기", yes: "예", no: "아니요", "main": "주요 세부 정보", "save": "저장", "change_status": "상태 변경", "history": "기록", "delete": "삭제", "org": "조직", "site": "사이트", "new_row": "새 행", "location": "위치", "asset": "자산", "no_records": "기록을 찾을 수 없음", "saving": "저장 중...", "save_success": "성공적으로 저장되었습니다!", "save_fail": "저장 실패", "are_you_sure": "확실합니까?", "yes_delete": "네, 삭제합니다!", "cancel": "취소", "delete_success": "성공적으로 삭제되었습니다", "delete_fail": "삭제 실패: ", "clear_filters": "필터 지우기", "all": "전체", "syncing": "동기화 중...", "showing": "표시 중", "total": "총계", "created_by": "생성자", "changed_date": "변경일"},
      toasts: { save_success: "성공적으로 저장되었습니다", save_fail: "저장 실패", load_fail: "데이터 로드 실패", delete_success: "성공적으로 삭제되었습니다" },
      swal: { delete_title: "확실합니까?", delete_text: "자산을 삭제하려고 합니다:", confirm_delete: "예, 삭제합니다" },
      "ai_settings": {
        "title": "AI 엔지니어 설정",
        "sub_title": "AI 예지 보전 엔진",
        "enable_label": "자동 예지 보전 활성화",
        "enable_sub": "AI 분석을 기반으로 작업 오더 자동 생성",
        "target_lang": "보고서 및 작업 언어",
        "threshold": "의사 결정 신뢰도 임계값",
        "auto_tasks": "작업 태스크 자동 생성 (WOTasks)",
        "task_desc": "태스크 테이블에 작업 단계를 자동으로 작성",
        "max_tasks": "작업 오더당 최대 단계 수",
        "section": "섹션",
        "technicalDetails": "기술적 세부 사항"
      },
      "export_technical_report": "기술 보고서 내보내기 (PDF)",
      "availability": "가용성",
      "mtbf": "평균 무고장 시간 (MTBF)",
      "mttr": "평균 수리 시간 (MTTR)",
      "hrs": "시간",
      "reliability_score": "신뢰성 점수",
      "score": "점수",
      "downtime_history_trend": "다운타임 이력 추세 (최근 10건)",
      "values_in_hours": "단위: 시간",
      "timeline_event_date": "타임라인 (이벤트 날짜)",
      "downtime_hours": "다운타임 (시간)",
      "no_downtime_records": "이 자산에 대한 다운타임 기록이 아직 없습니다.",
      "reliability_analysis": "신뢰성 분석",
      "total_failures": "총 고장 횟수",
      "total_down_time": "총 다운타임",
      "last_calculation": "마지막 계산",
      "maintenance_strategy_note": "유지보수 전략 노트",
      "high_mttr_detected": "높은 MTTR이 감지되었습니다. 권장 사항: 이 자산 범주에 대한 예비 부품 가용성 및 기술 교육을 평가하십시오.",
      "critical_availability": "가용성 수준이 심각합니다. 예방 정비(PM) 빈도를 높이거나 계획된 정밀 점검을 고려하십시오.",
      "nominal_performance": "자산 성능이 정상 범위 내에 있습니다. 표준 예방 정비 일정을 계속하십시오.",
      "current_load_factor": "현재 부하율",
      "optimal": "최적",
      statusModal: {
        "loadError": "상태를 로드할 수 없습니다",
        "selectFirst": "먼저 상태를 선택하십시오",
        "updating": "상태 업데이트 중...",
        "success": "상태가 업데이트되었습니다",
        "failed": "업데이트 실패",
        "changeStatus": "상태 변경:",
        "currentStatus": "현재 상태",
        "availableStatuses": "사용 가능한 상태",
        "loading": "로딩 중...",
        "chooseStatus": "상태 선택...",
        "memo": "사유 / 메모",
        "enterNotes": "메모를 입력하세요...",
        "cancel": "취소",
        "update": "업데이트"
      },
      attachmentsModal: {
        "loadError": "파일 로드 오류",
        "uploadSuccess": "파일이 성공적으로 첨부되었습니다",
        "uploadFailed": "업로드 실패",
        "deleteConfirmTitle": "확실합니까?",
        "deleteConfirmText": "'{{name}}'을(를) 영구적으로 삭제하려고 합니다. 이 작업은 서버에서 파일을 제거합니다.",
        "btnYesDelete": "예, 삭제합니다!",
        "btnCancel": "취소",
        "processingDelete": "삭제 처리 중...",
        "deletedTitle": "삭제됨!",
        "deletedText": "첨부 파일이 성공적으로 제거되었습니다.",
        "deleteFailed": "삭제 실패",
        "headerTitle": "첨부 파일 라이브러리",
        "linkingTo": "연결 위치:",
        "filesFound": "찾은 파일:",
        "uploadBtn": "새 문서 업로드",
        "thName": "이름",
        "thOwner": "소유자",
        "thStatus": "상태",
        "thActions": "작업",
        "statusPrivate": "비공개",
        "statusPublic": "공개",
        "noDocs": "아직 연결된 문서가 없습니다"
      },
      enterMeters: {
        "noMeters": "자산에 연결된 미터가 없습니다:",
        "saving": "검침 값 저장 중...",
        "enterAtLeastOne": "적어도 하나의 새로운 검침 값을 입력하십시오",
        "saveSuccess": "모든 검침 값이 성공적으로 저장되었습니다!",
        "saveFailed": "검침 값 저장 실패",
        "title": "미터 검침 값 입력 | 자산:",
        "titleLoc": "미터 검침 값 입력 | 위치:",
        "thIdentification": "미터 식별",
        "thNewReading": "* 새 검침 값",
        "thReadingDate": "* 검침 날짜",
        "thMeterType": "미터 유형",
        "thLastRecorded": "마지막 기록",
        "noDescription": "설명 없음",
        "enterValue": "값 입력...",
        "notAvailable": "해당 없음",
        "operator": "운영자:",
        "btnCancel": "취소",
        "btnUpdate": "검침 값 업데이트"
      },
      emailSettings: {
        "loadFailed": "설정을 로드하지 못했습니다",
        "saveSuccess": "메일 설정이 성공적으로 저장되었습니다!",
        "saveFailed": "설정 저장 실패",
        "connecting": "SMTP 서버에 연결 중...",
        "connFailed": "연결 실패!",
        "title": "SMTP 구성",
        "subtitle": "메일 서버 설정",
        "outgoingTitle": "보낸 편지함 (SMTP - 전송)",
        "incomingTitle": "받은 편지함 (IMAP - 모니터링)",
        "lblHost": "SMTP 호스트",
        "lblPort": "SMTP 포트",
        "lblUser": "SMTP 사용자 이름 / 이메일",
        "lblPass": "SMTP 비밀번호",
        "lblSender": "시스템 발신자 이메일 (발신자)",
        "lblImapHost": "IMAP 호스트",
        "lblImapPort": "IMAP 포트",
        "enableImap": "받은 편지함 모니터링 활성화 (RFQ 레이더)",
        "imapDesc": "받은 편지함에서 공급업체 견적을 자동으로 가져와 분석합니다.",
        "gmailNote": "Gmail의 경우 Google 보안에서 '앱 비밀번호'를 사용하세요. 2FA가 활성화된 계정 비밀번호는 작동하지 않습니다.",
        "btnTest": "테스트",
        "btnCancel": "취소",
        "btnSave": "구성 저장"
      },
      locationDetails: {
        "noBimModel": "이 위치에 연결된 3D 모델이 없습니다",
        "noBimLinked": "이 위치는 BIM에 연결되어 있지 않습니다",
        "locMandatory": "위치는 필수 필드입니다!",
        "saving": "변경 사항 저장 중...",
        "saveSuccess": "위치가 성공적으로 저장되었습니다",
        "saveFailed": "저장 실패:",
        "deleteTitle": "확실합니까?",
        "deleteText": "위치 {{id}}을(를) 삭제하려고 합니다. 이 작업은 되돌릴 수 없습니다!",
        "btnYesDelete": "예, 삭제합니다!",
        "btnCancel": "취소",
        "deleting": "위치 삭제 중...",
        "deleteSuccess": "위치가 성공적으로 삭제되었습니다",
        "deleteFailed": "삭제 실패!",
        "uploadingRevit": "Revit 모델 업로드 및 변환 중...",
        "revitSuccess": "모델이 성공적으로 연결되었습니다!",
        "uploadFailed": "업로드 실패:",
        "loadingCtx": "위치 컨텍스트 로드 중...",
        "tooltipChangeStatus": "상태 변경",
        "tooltipStatusHistory": "상태 기록",
        "tooltipDelete": "삭제",
        "btnSave": "저장",
        "lblLocation": "위치",
        "lblDescription": "설명",
        "btnRevitLinked": "Revit 연결됨",
        "tabLocation": "위치",
        "tabAssets": "자산",
        "tabSpecs": "사양",
        "tabSafety": "안전",
        "tabMeters": "미터",
        "tab3D": "3D 뷰",
        "tabHistory": "기록",
        "secIdentity": "위치 식별",
        "lblStatus": "상태",
        "lblType": "유형",
        "lblParentLoc": "상위 위치",
        "lblSiteID": "사이트 ID",
        "secGeoInfo": "지리 및 주소 정보",
        "lblServiceAddr": "서비스 주소",
        "lblBimSpaceId": "BIM 공간 ID",
        "lblGisCoords": "GIS 좌표",
        "secRefImage": "참조 이미지",
        "btnUploadPhoto": "사진 업로드",
        "thAssetNum": "자산 번호",
        "thStatus": "상태",
        "lblClass": "분류",
        "thAttr": "속성",
        "thDesc": "설명",
        "thValue": "값",
        "titleHazards": "이 위치에 보고된 위험",
        "btnAddHazard": "위험 추가",
        "lblSelectHazards": "위험 선택",
        "thHazard": "위험",
        "thPrecaution": "예방 조치",
        "titleLocMeters": "위치 미터",
        "showingMeters": "{{total}} 중 {{current}} 표시 중",
        "noMetersDef": "정의된 미터 없음",
        "thSeq": "순서",
        "thMeterNum": "미터 번호",
        "thType": "유형",
        "thUOM": "UOM",
        "thActive": "활성",
        "newMeter": "새_미터",
        "clickNewRow": "미터를 추가하려면 '새 행'을 클릭하세요",
        "titleMeterConfig": "미터 세부 정보 구성",
        "newEntry": "새 항목",
        "lblMeterNum": "* 미터 번호",
        "lblMeterType": "미터 유형",
        "lblUOM": "측정 단위",
        "lblMeterActive": "미터가 활성 상태입니다",
        "lblLastReading": "마지막 검침",
        "lblReadingDate": "검침 날짜",
        "lblInspector": "미터 검사관",
        "lblRemarks": "비고 / 의견",
        "placeholderRemarks": "이 미터에 대한 기술적 참고 사항을 입력하세요...",
        "btnAddMeterRow": "새 미터 행 추가",
        "titleModelStatus": "모델 상태",
        "statusLinked": "연결됨 및 활성",
        "statusNotLinked": "연결되지 않음",
        "btnUploadRevit": "Revit 업로드 (.rvt)",
        "titleHistory": "거래 내역 및 감사 로그",
        "lblChangedBy": "변경자:",
        "failedFetchAttr": "속성을 가져오지 못했습니다"
      },
      "locationList": {
        "loadFailed": "Teknoia 서버에서 위치를 로드하지 못했습니다.",
        "title": "Teknoia 위치",
        "searchPlaceholder": "전체 검색...",
        "btnClearAll": "모두 지우기",
        "btnExport": "내보내기",
        "btnNewLocation": "새 위치",
        "thLocationId": "위치 ID",
        "thDescription": "설명",
        "thType": "유형",
        "thStatus": "상태",
        "thSite": "사이트",
        "optAll": "모두",
        "optOperating": "운영 중",
        "optDecommissioned": "폐기됨",
        "fetchingData": "서버에서 데이터 가져오는 중...",
        "noRecords": "일치하는 레코드를 찾을 수 없습니다.",
        "recordsFound": "찾은 레코드:",
        "page": "페이지:"
      },
      "universalLookup": {
        "selectValue": "값 선택:",
        "total": "총",
        "searchPlaceholder": "코드 또는 설명으로 검색...",
        "valueCode": "값 / 코드",
        "description": "설명",
        "site": "사이트",
        "synchronizing": "동기화 중...",
        "noRecords": "일치하는 레코드를 찾을 수 없습니다.",
        "loadingMore": "더 많은 레코드 로드 중...",
        "results": "결과:",
        "cancel": "취소"
      },
      "statusHistory": {
        "title": "상태 감사 추적",
        "loading": "기록을 로드하는 중...",
        "noRecords": "이 항목에 대해 기록된 상태 변경 사항이 없습니다.",
        "initial": "초기 상태",
        "btnClose": "닫기"
      },
      "personalInfo": {
        "updateSuccess": "프로필이 성공적으로 업데이트되었습니다",
        "sessionExpired": "세션이 만료되었습니다. 다시 로그인하십시오",
        "updateFailed": "업데이트 실패",
        "title": "개인 정보 및 기본값",
        "lblDisplayName": "전체 표시 이름",
        "lblEmail": "이메일 주소",
        "lblDefaultOrg": "기본 조직",
        "selectOrg": "조직 선택...",
        "lblDefaultSite": "기본 사이트",
        "selectSite": "사이트 선택...",
        "lblDefaultLang": "기본 언어",
        "btnCancel": "취소",
        "btnSave": "적용 및 변경 사항 저장",
        "securityTitle": "보안 및 2FA",
        "enable2FA": "2단계 인증(2FA) 활성화",
        "googleAuth": "Google OTP",
        "emailOTP": "이메일 OTP",
        "configure2FA": "2FA 설정 구성",
        "scanQR": "Google Authenticator 또는 Authy를 사용하여 이 QR 코드를 스캔한 다음 아래에 6자리 코드를 입력하여 확인하세요.",
        "btnVerify": "확인",
        "setupSuccess": "2FA 설정 성공!",
        "invalidCode": "잘못된 인증 코드",
        "failedQR": "QR 코드 생성 실패"
      },
      "appSettings": {
        "savingSettings": "설정 저장 중...",
        "saveSuccess": "설정이 성공적으로 업데이트되었습니다!",
        "saveFailed": "설정 저장 실패.",
        "title": "엔터프라이즈 구성",
        "org": "조직",
        "tabs": {
          "WORKORDER": "작업 지시서",
          "ASSET": "자산 레지스트리",
          "INVENTORY": "창고 및 재고",
          "PURCHASE": "조달",
          "PR": "구매 요청(PR)",
          "JP": "작업 계획(JP)",
          "PM": "예방 정비(PM)",
          "MR": "자재 요청(MR)",
          "SR": "서비스 요청(SR)"
        },
        "systemRules": "{{tab}} 시스템 규칙",
        "prefix": "시퀀스 접두사",
        "preview": "미리보기",
        "seed": "시작 값 (시드)",
        "valuationStrategy": "평가 전략",
        "movingAvg": "이동 평균 (권장)",
        "fifo": "선입선출 (FIFO)",
        "lifo": "후입선출 (LIFO)",
        "allowNegative": "마이너스 잔액 허용",
        "negativeWarning": "경고: 재무 정확성에 영향을 미침",
        "encrypting": "암호화 및 전송 중...",
        "auditLogged": "모든 변경 사항은 감사 추적에 기록됩니다",
        "btnCancel": "취소",
        "btnSave": "시스템 정책 저장"
      },
      "workflowAction": {
        "successMove": "워크플로가 성공적으로 라우팅되었습니다! 🚀",
        "failedMove": "작업 실패",
        "btnRoute": "워크플로 라우팅",
        "modalTitle": "워크플로 작업",
        "assignedAs": "할당된 역할:",
        "defaultInstruction": "검토 후 조치를 취하십시오.",
        "lblChoosePath": "경로 선택",
        "valSelectPath": "경로를 선택하십시오",
        "optApprove": "승인 / 앞으로 이동",
        "optReject": "거부 / 반환",
        "lblMemo": "작업 메모 / 의견",
        "placeholderMemo": "여기에 의견을 추가하십시오...",
        "btnCancel": "취소",
        "btnComplete": "단계 완료"
      },
      "meterHistory": {
        "title": "과거 미터 검침",
        "lblAsset": "자산",
        "fetching": "아카이브 가져오는 중...",
        "noRecords": "이 자산에 대한 과거 검침 기록을 찾을 수 없습니다.",
        "thMeterName": "미터 이름",
        "thReadingVal": "검침 값",
        "thReadingDate": "검침 날짜",
        "thEnteredBy": "입력자",
        "thEntryDate": "입력 날짜",
        "btnClose": "기록 닫기",
        "lblLocation": "위치",
        "noRecordsLoc": "이 위치에 대한 과거 검침 기록을 찾을 수 없습니다.",
      },
      rpt_print: "보고서 인쇄",
      no_templates: "사용 가능한 템플릿이 없습니다.",
      "wo": {
        "tabs": { "workOrder": "작업 지시서", "plans": "계획", "assignments": "할당", "actuals": "실적", "safety": "안전", "failure": "고장 보고" },
        "subTabs": { "tasks": "작업", "labor": "인력", "materials": "자재", "tools": "도구", "services": "서비스" },
        "headers": { "workOrder": "작업 지시서", "status": "상태", "totalCost": "총 비용", "activeSla": "SLA 모니터링 중", "targetRes": "목표 해결", "targetResp": "목표 응답" },
        "sections": { "assetDetails": "자산 세부 정보", "scheduling": "일정 정보", "responsibility": "책임", "laborAssign": "인력 할당", "totalAssign": "총 할당" },
        "fields": { "description": "설명", "location": "위치", "asset": "자산", "workType": "작업 유형", "safetyCode": "안전 코드", "supervisor": "감독관", "failureClass": "고장 클래스", "targStart": "목표 시작", "targFinish": "목표 종료", "schedStart": "예정 시작", "schedFinish": "예정 종료", "earlyStart": "가장 빠른 시작", "lateFinish": "가장 늦은 종료", "actStart": "실제 시작", "actFinish": "실제 종료", "duration": "기간", "timeRemaining": "남은 시간", "predecessors": "선행 작업", "includeTasks": "일정에 작업 포함?", "site": "사이트", "organization": "조직", "priorityHigh": "우선순위: 높음" },
        "actions": { "routeWorkflow": "워크플로 라우팅", "wfHistory": "워크플로 내역", "changeStatus": "상태 변경", "attachments": "첨부 파일", "printWO": "작업 지시서 인쇄", "printSafety": "안전 시트 인쇄", "history": "상태 내역", "newTask": "새 작업", "selectLoc": "위치 선택", "selectAsset": "자산 선택", "selectType": "유형 선택", "selectSafety": "안전 계획 선택", "selectSup": "감독관 선택", "selectFail": "고장 클래스 선택", "selectCraft": "직종 선택", "selectLabor": "인력 선택", "selectItem": "품목 선택", "selectStore": "창고 선택", "selectTool": "도구 선택", "addLabor": "인력 추가", "addMaterial": "자재 추가", "addTool": "도구 추가", "addService": "서비스 추가", "newAssign": "새 할당", "compAssign": "할당 완료", "createMR": "자재 요청 생성", "yesCreate": "예, 생성합니다", "yesChange": "예, 변경합니다", "approve": "승인", "cancel": "취소", "startWork": "작업 시작", "close": "닫기", "complete": "완료", "selectProblem": "문제 선택", "selectCause": "원인 선택", "selectRemedy": "조치 선택" },
        "tables": { "sequence": "순서", "taskDesc": "작업 설명", "estDur": "예상 기간", "status": "상태", "craft": "직종", "labor": "인력", "qty": "수량", "hrs": "시간", "rate": "비율", "lineCost": "라인 비용", "lineType": "라인 유형", "itemNum": "품목 #", "description": "설명", "unitCost": "단가", "storeroom": "창고", "item": "품목", "material": "자재", "toolNum": "도구 #", "serviceDesc": "서비스 설명", "vendor": "공급업체", "cost": "비용", "start": "시작", "finish": "종료", "failCode": "고장 코드" },
        "footer": { "totalLabor": "총 인력", "totalMaterial": "총 자재", "assigned": "할당됨 (예상)", "toolsServ": "도구 및 서비스", "totalActual": "총 실제 비용" },
        "safety": { "hazardsTitle": "위험 및 예방 조치", "hazardCode": "위험 코드", "hazardDesc": "위험 설명", "precautions": "필요한 조치", "noHazards": "식별된 위험이 없습니다.", "lotoTitle": "록아웃 / 태그아웃", "step": "단계", "tagNum": "태그 번호", "isoDesc": "격리 설명", "reqState": "필요한 상태", "completed": "완료?", "noLoto": "격리 단계가 필요하지 않습니다." },
        "failure": { "title": "고장 분석", "currClass": "현재 클래스", "notDefined": "정의되지 않음", "problems": "문제", "causes": "원인", "remedies": "조치", "records": "기록" },
        "placeholders": { "desc": "설명 입력...", "taskDesc": "작업 설명..." },
        "messages": { "loadError": "불러오기 오류", "taskStatusLocal": "작업 상태가 업데이트되었습니다", "selectItemStore": "품목과 창고를 선택하십시오", "duplicateReqTitle": "중복 요청", "duplicateReqText": "{{item}}에 대한 요청이 있습니다. 생성하시겠습니까?", "creatingMR": "요청 생성 중...", "mrCreated": "요청 {{num}} 생성됨", "mrFail": "생성 실패", "confirmStatusChange": "{{wonum}} 상태를 {{status}}로 변경하시겠습니까?", "statusSuccess": "상태 변경됨", "statusFail": "변경 실패", "saving": "저장 중...", "deleteConfirm": "{{wonum}}을 삭제합니다. 이 작업은 취소할 수 없습니다!", "saveBeforeSLA": "SLA 적용 전에 저장하십시오", "slaExists": "SLA가 이미 적용되었습니다!", "matchingSLA": "SLA 검색 중...", "slaApplied": "SLA 적용 성공", "noMatchingSLA": "일치하는 SLA 없음", "slaError": "SLA 엔진 오류", "failureTreeLoaded": "고장 코드 적용됨", "zeroBalance": "경고: {{store}}의 잔액이 0입니다", "balanceOk": "가격 가져옴: {{cost}} - 잔액: {{bal}}", "storeError": "창고 연결 실패", "assetLinked": "자산 연결됨: {{asset}}", "openAssignError": "닫을 수 없음: {{count}}개의 할당이 미완료 상태입니다.", "budgetExceeded": "예산 초과!", "assignComplete": "할당 완료됨", "actionNotAllowed": "{{status}} 상태에서는 허용되지 않습니다", "locked": "잠김", "cantChangeCancel": "취소된 요청은 상태를 변경할 수 없습니다", "printFail": "PDF 생성 실패", "wfRouted": "워크플로 라우팅 성공! 🚀", "wfFail": "라우팅 실패", "taskStatusChanged": "작업 {{task}} 상태가 {{status}}로 변경됨", "noLaborAssign": "할당된 인력이 없습니다.", "updateTaskProg": "작업 진행률 업데이트", "noMaterials": "자재가 없습니다. 클릭하여 추가하십시오.", "linkedMRs": "연결된 자재 요청", "stocknobalance": "⚠️ 경고: 이 상품은 창고 재고가 (0)입니다." },
        "linearDefect": {
          "title": "선형 결함 위치",
          "startMeasure": "시작 측정",
          "endMeasure": "종료 측정 (선택)",
          "unit": "단위",
          "yOffset": "Y-오프셋 (m)"
        },
        "costs": {
          "title": "작업 지시 비용",
          "estimated": "예상 비용",
          "actual": "실제 비용",
          "labor": "인건비",
          "materials": "자재",
          "tools": "도구",
          "services": "서비스",
          "total": "합계",
          "variance": "차이 (실제 - 예상)",
          "calculating": "계산 중...",
          "no_data": "사용 가능한 데이터가 없습니다."
        },
        "purchase_info": {
          "title": "관련 구매 정보",
          "mr_title": "자재 요청 (MR)",
          "pr_title": "구매 요청 (PR)",
          "po_title": "구매 주문 (PO)",
          "mr_num": "MR 번호",
          "pr_num": "PR 번호",
          "po_num": "PO 번호",
          "vendor": "공급업체",
          "status": "상태",
          "req_date": "요구 날짜",
          "total_cost": "총 비용",
          "fetching": "데이터 가져오는 중...",
          "no_records": "기록이 없습니다."
        },
    
      },
      "pm": {
        "tabs": { "pm": "PM", "frequency": "빈도", "sequence": "순서", "seasonaldates": "시즌", "forecast": "예측" },
        "sections": { "assetLoc": "자산 및 위치", "defaults": "기본 설정", "compliance": "준수 데이터", "siteContext": "사이트 정보", "timeBased": "시간 기반 간격", "meters": "미터", "sequences": "작업 계획 순서", "seasonal": "주간 일정", "projections": "예측 로그" },
        "fields": { "pmNum": "PM 번호", "description": "설명", "status": "상태", "site": "사이트", "asset": "자산", "location": "위치", "route": "경로", "counter": "카운터", "jpnum": "작업 계획", "worktype": "작업 유형", "supervisor": "감독관", "glaccount": "GL 계정", "woStatus": "기본 상태", "priority": "우선순위", "lastStart": "마지막 시작", "lastComp": "마지막 완료", "nextDue": "다음 예정일", "forecastFlag": "예측 플래그", "org": "조직", "freqInt": "간격", "freqUnit": "단위", "targStart": "목표 시간" },
        "actions": { "forecast": "예측", "savePM": "저장", "addMeter": "미터 추가", "addStep": "단계 추가", "newPM": "새 PM 기록" },
        "tables": { "meterName": "미터 이름", "freq": "빈도", "nextProj": "다음 예측", "seq": "순서", "jpnum": "작업 계획", "fcDate": "날짜", "targetJp": "목표 계획", "estCost": "예상 비용", "status": "상태", "woNum": "작업 지시서 번호", "generated": "생성됨", "projected": "예상됨" },
        "messages": { "executingForecast": "계산 중...", "forecastSuccess": "성공", "forecastFail": "실패", "seasonalInfo": "선택된 요일만 허용됩니다.", "noMeters": "미터가 없습니다.", "noSeq": "순서가 비활성화되었습니다.", "noForecasts": "예측이 없습니다.", "showingProjections": "{{count}}개의 기록 표시 중", "fetchListError": "PM 기록 로드 실패", "syncingList": "서버와 동기화 중...", "noRecords": "일치하는 기록이 없습니다." },
        "placeholders": { "desc": "설명 입력...", "globalSearch": "글로벌 스마트 검색..." },
        "headers": { "masterDir": "PM 마스터 디렉토리" },
        "footer": { "dbTotal": "데이터베이스 총계:", "currentPage": "현재 페이지:", "useNavArrows": "방향키 사용" }
      },
      "workflowHistory": {
        "title": "워크플로 감사 추적",
        "trackingId": "추적 ID:",
        "fetching": "기록 가져오는 중...",
        "currentTask": "현재 활성 작업",
        "since": "이후:",
        "by": "담당",
        "noHistory": "이 트랜잭션에 대해 기록된 내역이 없습니다",
        "closeBtn": "내역 닫기"
      },
      "pr": {
        "headers": { "prList": "구매 요청" },
        "actions": { "newPR": "새 요청", "clearFilters": "필터 지우기", "routeWf": "워크플로 라우팅" },
        "tabs": { "pr": "구매 요청", "prlines": "요청 항목" },
        "sections": { "general": "일반 정보", "financial": "재무 요약" },
        "fields": { "prNum": "요청 번호", "requestedBy": "요청자", "reqDate": "필요 날짜", "refMr": "참조 자재 요청", "vendor": "공급업체", "glAccount": "GL 계정" },
        "financial": { "subtotal": "소계", "taxTotal": "총 세금", "grandTotal": "총계" },
        "tables": { "prNum": "요청 번호", "description": "설명", "status": "상태", "totalCost": "총 비용", "reqDate": "요청일", "site": "사이트", "itemNum": "품목 번호", "itemType": "유형", "qty": "수량", "unitCost": "단가", "tax": "세금", "lineTotal": "항목 합계", "taxCat": "세금 범주" },
        "messages": { "loadFailed": "구매 요청을 불러오지 못했습니다", "syncing": "기록 동기화 중...", "noData": "일치하는 데이터가 없습니다", "noLines": "아직 추가된 항목이 없습니다.", "fetchingMRLines": "자재 요청 항목 가져오는 중: {{mrnum}}...", "loadedMRLines": "{{count}}개 항목 로드됨", "noMRLines": "이 요청에는 항목이 없습니다", "failedMRLines": "항목 로드 실패" },
        "swal": { "lockedTitle": "잠김", "cantDeleteStatus": "{{status}} 상태에서는 삭제할 수 없습니다", "cantChangeCancel": "취소된 요청은 상태를 변경할 수 없습니다", "deleteWarnText": "이렇게 하면 구매 요청과 모든 항목이 영구적으로 삭제됩니다." },
        "placeholders": { "desc": "설명 입력...", "globalSearch": "글로벌 스마트 검색..." },
        "footer": { "showing": "표시 중", "totalRecords": "총 기록" }
      },
      "po": {
        "headers": { "poList": "구매 오더" },
        "actions": { "newPO": "새 오더", "clearFilters": "필터 지우기", "routeWf": "워크플로 라우팅", "addManualRow": "수동 행 추가", "wfHistory": "워크플로 타임라인" },
        "tabs": { "po": "구매 오더", "polines": "오더 항목" },
        "sections": { "general": "일반 정보", "financial": "재무 요약", "lines": "구매 오더 항목" },
        "fields": { "poNum": "오더 번호", "requestedBy": "요청자", "orderDate": "주문일", "refPr": "참조 구매 요청", "vendor": "공급업체", "glAccount": "GL 계정" },
        "financial": { "subtotal": "소계", "taxTotal": "세금 금액", "grandTotal": "총계" },
        "tables": { "poNum": "오더 번호", "totalCost": "총 비용", "orderDate": "주문일", "itemNum": "품목 번호", "itemType": "유형", "unitCost": "단가", "tax": "세금", "lineTotal": "항목 합계", "taxCat": "세금 범주" },
        "messages": { "loadFailed": "구매 오더를 불러오지 못했습니다", "syncing": "기록 동기화 중...", "noData": "일치하는 오더가 없습니다", "noLines": "아직 추가된 항목이 없습니다.", "vendorRequired": "공급업체는 필수 항목입니다.", "fetchingLines": "항목 가져오는 중: {{num}}...", "loadedLines": "{{count}}개 항목 로드 성공", "noLinesFound": "이 문서에는 항목이 없습니다", "failedLines": "항목 로드 실패", "cantChangeCancel": "취소된 요청은 상태를 변경할 수 없습니다", "cantDeleteStatus": "{{status}} 상태에서는 삭제할 수 없습니다" },
        "swal": { "deleteWarnText": "이렇게 하면 구매 오더와 모든 항목이 영구적으로 삭제됩니다." },
        "placeholders": { "desc": "설명 입력...", "globalSearch": "글로벌 스마트 검색..." },
        "footer": { "showing": "표시 중" }
      },
      "mr": {
        "headers": { "mrList": "자재 요청" },
        "actions": { "newMR": "새 요청", "clearFilters": "필터 지우기", "routeWf": "워크플로 라우팅", "createUsage": "사용 생성", "createUsageDesc": "출고/이동 레코드 생성", "createPR": "구매 요청 생성", "createPRDesc": "구매 요청(PR) 생성", "addMaterial": "자재 추가" },
        "tabs": { "mr": "요청 정보", "mrlines": "요청 항목" },
        "sections": { "general": "일반 정보", "financial": "재무 요약", "mrItems": "자재 요청 항목", "financialCharging": "재무 청구 세부 정보" }, 
        "fields": { "mrNum": "요청 번호", "requestedBy": "요청자", "reqDate": "필요 날짜", "refMr": "참조 요청", "vendor": "공급업체", "glAccount": "GL 계정", "targetStore": "대상 창고", "chargeLoc": "청구 위치", "chargeAsset": "청구 자산", "chargeWO": "청구 작업 오더" },
        "financial": { "subtotal": "소계", "taxTotal": "총 세금", "grandTotal": "총계" },
        "tables": { "mrNum": "요청 번호", "description": "설명", "status": "상태", "totalCost": "총 비용", "enteredDate": "입력일", "site": "사이트", "itemNum": "품목 번호", "itemType": "유형", "qty": "수량", "unitCost": "단가", "tax": "세금", "lineTotal": "항목 합계", "taxCat": "세금 범주", "stockItem": "재고 품목", "qtyReq": "요청 수량", "estUnitCost": "예상 단가" }, 
        "messages": { "loadFailed": "요청을 불러오지 못했습니다", "syncing": "기록 동기화 중...", "noData": "일치하는 데이터가 없습니다", "noLines": "아직 추가된 항목이 없습니다.", "fetchingMRLines": "항목 가져오는 중: {{mrnum}}...", "loadedMRLines": "{{count}}개 항목 로드됨", "noMRLines": "이 요청에는 항목이 없습니다", "failedMRLines": "항목 로드 실패", "generating": "{{docType}} 생성 중...", "generatedSuccess": "{{docType}} {{docnum}} 생성 완료!", "generateFail": "{{docType}} 생성 실패", "storeRequired": "창고는 필수 항목입니다!", "dateRequired": "필요 날짜는 필수 항목입니다!" },
        "swal": { "lockedTitle": "잠김", "cantDeleteStatus": "{{status}} 상태에서는 삭제할 수 없습니다", "cantChangeCancel": "취소된 요청은 상태를 변경할 수 없습니다", "deleteWarnText": "이렇게 하면 요청과 모든 항목이 영구적으로 삭제됩니다." },
        "placeholders": { "desc": "설명 입력...", "globalSearch": "글로벌 검색...", "chooseLoc": "위치 선택", "selectAsset": "자산 선택", "chargeWO": "작업 오더에 청구" },
        "lookups": { "storerooms": "창고", "inventory": "재고 검색", "locations": "사이트 위치", "assets": "자산 레지스트리", "workorders": "작업 오더" },
        "footer": { "showing": "표시 중", "totalRecords": "총계" }
      },
      "contract": {
        "headers": { "masterNode": "계약 마스터 노드" },
        "placeholders": { "globalSearch": "글로벌 검색...", "desc": "요약 입력...", "termDesc": "조항 세부 정보 입력..." },
        "actions": { "newContract": "새 계약", "save": "저장", "addTerm": "조항 추가", "addLine": "항목 추가", "wfHistory": "워크플로 타임라인" },
        "tabs": { "general": "일반", "slaperformance": "SLA (성과)", "termslegal": "약관 및 법률", "contractlines": "계약 항목" },
        "sections": { "identity": "신원 및 유효성", "communication": "커뮤니케이션 허브", "auditInfo": "감사 정보", "masterSLA": "SLA 링크", "slaBenchmarks": "SLA 기준", "termsList": "법적 조항", "lines": "작업 범위 / 항목" },
        "options": { "supply": "공급 계약", "labor": "노무/서비스 계약", "lease": "임대 계약", "allTypes": "모든 유형", "allStatus": "모든 상태", "general": "일반", "payment": "지불", "termination": "종료", "warranty": "보증", "liability": "책임" },
        "fields": { "contractNum": "계약 번호", "vendorRef": "공급업체", "startDate": "시작일", "endDate": "종료일", "contractValue": "계약 가치", "currency": "통화", "contactPerson": "담당자", "vendorEmail": "공급업체 이메일", "slaRef": "SLA 참조", "respTime": "응답 시간 (시간)", "resTime": "해결 시간 (시간)", "uptime": "가용성 목표 (%)", "penalty": "벌금 (시간당)", "grandTotal": "계산된 총액" },
        "tables": { "contractNum": "계약 번호", "grandTotal": "총계", "clauseType": "조항 범주", "clauseDesc": "조항 세부 정보", "lineDesc": "항목 설명", "rate": "비율", "lineTotal": "항목 합계" },
        "messages": { "fetchError": "동기화 실패", "syncing": "동기화 중...", "noData": "계약을 찾을 수 없습니다", "descMandatory": "설명은 필수 항목입니다", "vendorSelected": "공급업체 {{name}}이(가) 선택되었습니다", "noTerms": "정의된 법적 조항이 없습니다", "noLines": "정의된 항목이 없습니다", "slaHint": "SLA를 연결하면 해당 규칙이 전역적으로 적용됩니다." },
        "swal": { "deleteTitle": "최종 삭제?", "deleteText": "계약과 모든 항목이 영구적으로 삭제됩니다." },
        "footer": { "masterRecords": "마스터 레코드:", "currentPage": "현재 페이지:" }
      },
      "rfq": {
        "headers": { "rfqList": "견적 요청 관리" },
        "tabs": { "rfq": "견적 요청", "rfqlines": "요청 항목", "quotations": "견적서" },
        "sections": { "general": "일반 정보", "financial": "재무 요약" },
        "fields": { "requestedBy": "요청자", "reqDate": "필요 날짜", "refPr": "참조 구매 요청", "vendor": "공급업체", "vendorEmail": "공급업체 이메일", "glAccount": "GL 계정" },
        "financial": { "subtotal": "소계", "taxTotal": "총 세금", "grandTotal": "총계" },
        "tables": { "rfqNum": "요청 번호", "totalCost": "총 비용", "itemNum": "품목 번호", "itemType": "유형", "unitCost": "단가", "tax": "세금", "taxCat": "세금 범주" },
        "options": { "awarded": "낙찰됨" },
        "actions": { "newRFQ": "새 견적 요청", "sendEmail": "이메일 전송", "wfHistory": "WF 내역", "award": "낙찰 및 구매 오더 생성" },
        "messages": { "loadFailed": "불러오기 실패", "syncing": "동기화 중...", "noData": "데이터 없음", "noLines": "정의된 항목이 없습니다", "pullingPR": "구매 요청 항목 가져오는 중...", "prImported": "항목 가져오기 완료!", "prFailed": "가져오기 실패", "noEmail": "이메일이 누락되었습니다!", "sending": "PDF 생성 및 이메일 전송 중...", "sendSuccess": "이메일 전송 성공!", "sendFailed": "전송 실패", "quotesHint": "공급업체의 견적은 이메일 응답이 처리되면 여기에 자동으로 표시됩니다.", "noQuotes": "아직 접수된 견적이 없습니다.", "awarding": "견적 낙찰 중...", "awardSuccess": "견적이 성공적으로 낙찰되었습니다!", "poCreated": "구매 오더가 생성되었습니다", "awardFailed": "낙찰 실패" },
        "swal": { "sendTitle": "견적 요청 전송?", "sendText": "{{vendor}}에게 이 요청을 이메일로 보내시겠습니까?", "awardTitle": "견적 낙찰?", "awardText": "이 견적을 낙찰 처리하고 구매 오더를 자동으로 생성합니다." },
        "footer": { "showing": "표시 중" }
      },
      "itemList": {
        "headers": { "master": "품목 마스터" },
        "actions": { "newItem": "새 품목" },
        "tables": { "item": "품목", "rotating": "회전성?" },
        "messages": { "syncFailed": "마스터 데이터 동기화 실패", "syncing": "기록 동기화 중...", "noData": "일치하는 품목이 없습니다" },
        "footer": { "totalItems": "총 품목:", "page": "페이지" }
      },
      "itemDetails": {
        "tabs": { "item": "품목", "inventory": "재고", "vendors": "공급업체", "specs": "사양", "assembly": "조립 (BOM)" },
        "sections": { "config": "품목 구성", "units": "단위 및 추적", "bomList": "BOM 목록", "supplierHistory": "구매 및 공급업체 내역" },
        "actions": { "save": "저장", "addStore": "창고에 추가", "newSpec": "새 사양", "addComponent": "구성 요소 추가" },
        "fields": { "itemSet": "품목 세트", "rotating": "회전성?", "lotControl": "로트 관리?", "inspectionReq": "검사 필요?", "orderUnit": "주문 단위", "issueUnit": "출고 단위", "condition": "상태 활성화?", "sparepart": "예비 부품?", "classification": "분류" },
        "tables": { "store": "창고", "avgCost": "평균 비용", "balance": "잔액", "attribute": "속성", "value": "값", "uom": "단위", "subItem": "하위 품목", "remarks": "비고", "vendor": "공급업체 코드", "supplierName": "공급업체 이름", "unitCost": "단가", "refPO": "참조 PO", "activeVendors": "활성 공급업체" },
        "messages": { "reqFields": "품목 번호와 설명은 필수입니다!", "fetchingAttributes": "속성 가져오는 중...", "attributesLoaded": "속성 로드됨", "failedAttributes": "로드 실패", "stockMsgTitle": "재고 메시지", "stockMsgDesc": "이 단위를 업데이트하면 모든 창고에 영향을 미칩니다.", "noInventory": "재고 기록이 없습니다.", "noSpecs": "정의된 사양이 없습니다.", "noBom": "정의된 BOM이 없습니다.", "noVendors": "구매 기록을 찾을 수 없습니다." },
        "swal": { "deleteText": "품목 {{num}}을(를) 삭제하려고 합니다. 이 작업은 취소할 수 없습니다!" }
      },
      "changePassword": {
        "title": "비밀번호 변경",
        "currentPwd": "현재 비밀번호",
        "newPwd": "새 비밀번호",
        "confirmPwd": "새 비밀번호 확인",
        "securityTitle": "보안 인증",
        "googleAuthMsg": "이 변경 사항을 확인하려면 Google Authenticator의 6자리 코드를 입력하세요.",
        "emailOtpMsg": "OTP 코드가 이메일로 발송되었습니다.",
        "btnCancel": "취소",
        "btnUpdate": "비밀번호 업데이트",
        "btnVerify": "인증 및 변경",
        "btnBack": "뒤로 가기",
        "errMismatch": "새 비밀번호가 일치하지 않습니다!",
        "errLength": "비밀번호는 6자 이상이어야 합니다.",
        "msgVerifyReq": "계속하려면 본인 인증을 진행해 주세요.",
        "msgSuccess": "비밀번호가 성공적으로 변경되었습니다!",
        "errFailed": "비밀번호 변경에 실패했습니다."
      },
      "userDetails": {
        "titleNew": "새 사용자",
        "titleEdit": "보안 / 사용자",
        "btnSave": "사용자 저장",
        "saving": "저장 중...",
        "secIdent": "사용자 식별",
        "lblLoginId": "로그인 ID",
        "lblFullName": "성명",
        "lblDisplayName": "표시 이름",
        "lblEmail": "이메일 주소",
        "lblPassword": "비밀번호",
        "lblActive": "활성 상태",
        "secAccess": "보안 및 접근 제어",
        "lblPrimaryRole": "기본 보안 역할",
        "lblSecRoles": "보조 역할 (추가)",
        "lblDefOrg": "기본 조직",
        "lblDefSite": "기본 사이트",
        "secDelegation": "작업 위임",
        "lblDelegateTo": "작업 위임 대상",
        "lblStartDate": "시작 날짜 및 시간",
        "lblEndDate": "종료 날짜 및 시간"
      },
      "receivingDetails": {
        "errLoadLines": "구매 주문 라인을 로드하지 못했습니다.",
        "errMissingDist": "모든 라인에 대해 창고와 수량을 지정하십시오.",
        "errInspMandatory": "이 항목에 대한 검사 결정은 필수입니다.",
        "errRejectExceeds": "거부된 수량을 확인하십시오 (도착 수량을 초과할 수 없음).",
        "msgSuccess": "트랜잭션이 성공적으로 처리되었습니다!",
        "msgAutoClosed": "자동으로 닫힘: ",
        "swalAssignTitle": "창고 할당",
        "swalAssignText": "항목 {{item}} 이(가) 현재 {{loc}} 에 할당되지 않았습니다. 지금 할당하고 입고를 완료하시겠습니까?",
        "swalAssignBtn": "예, 할당 및 완료",
        "errUnexpected": "입고 중 예기치 않은 오류가 발생했습니다.",
        "hubTitle": "일괄 입고 허브",
        "poRef": "구매 주문 참조: ",
        "btnExecuting": "실행 중...",
        "btnConfirm": "입고 확인",
        "tblItemsPending": "입고 대기 중인 항목",
        "colItemDetails": "항목 세부 정보",
        "colBalance": "잔액",
        "lblQualityCheck": "품질 검사 필요",
        "lblUnits": "단위",
        "msgNoPending": "대기 중인 항목을 찾을 수 없습니다.",
        "lblLandedCost": "도착 원가 (총 추가 비용)",
        "lblBaseCost": "기본 구매 주문 단가",
        "lblStoreMatrix": "창고 분배 매트릭스",
        "btnSplitStore": "창고 분할",
        "colStoreroom": "창고",
        "colArrived": "도착",
        "colRejected": "거부됨",
        "plcClickSearch": "검색하려면 클릭 ->",
        "lookupSelectStore": "창고 선택",
        "lblQcMatrix": "품질 관리 의사 결정 매트릭스",
        "optSelectDecision": "-- 필수: 결정 선택 --",
        "optPassed": "완전 합격 (모두 수락)",
        "optFailed": "완전 거부 (공급업체로 반품)",
        "optPartial": "부분 수락 (거부된 필드 확인)",
        "lblInvValuation": "재고 평가 (평균 단가)",
        "lblNetArrived": "순 도착 재고",
        "msgSelectLine": "처리를 시작하려면 활성 구매 주문 라인을 선택하십시오."
      },
      "userList": {
        "title": "사용자 보안",
        "plcSearch": "사용자 또는 이메일 검색...",
        "btnNewUser": "새 사용자",
        "colUserId": "사용자 ID",
        "colFullName": "성명",
        "colRole": "역할",
        "colSite": "사이트",
        "colStatus": "상태",
        "colEmail": "이메일",
        "msgSyncing": "보안 정보 동기화 중...",
        "lblNoRole": "역할 없음",
        "lblAll": "전체",
        "lblTotalUsers": "총 사용자:",
        "lblPage": "페이지",
        "errLoadUsers": "사용자 로드 오류"
      },
      "crafts": {
        "headers": {
          "craftList": "직종 카탈로그"
        },
        "actions": {
          "newCraft": "새 직종"
        },
        "tables": {
          "craftCode": "직종 코드",
          "description": "설명",
          "stdRate": "표준 단가/시간",
          "site": "사이트",
          "org": "조직"
        },
        "messages": {
          "loadFailed": "직종을 로드하지 못했습니다"
        },
        "headers": {
          "craftList": "직종 카탈로그"
        },
        "tabs": {
          "skills": "직종 기술 및 레벨"
        },
        "sections": {
          "costing": "원가 계산",
          "control": "제어"
        },
        "actions": {
          "newCraft": "새 직종",
          "addSkill": "기술 레벨 추가"
        },
        "tables": {
          "craftCode": "직종 코드",
          "description": "설명",
          "stdRate": "표준 단가/시간",
          "site": "사이트",
          "org": "조직"
        },
        "fields": {
          "stdHourlyRate": "표준 시간당 단가",
          "skillLevel": "기술 레벨 (예: 전문가, 초급)",
          "hourlyRate": "시간당 단가"
        },
        "placeholders": {
          "enterLevel": "레벨 입력..."
        },
        "messages": {
          "loadFailed": "직종을 로드하지 못했습니다",
          "autoCalc": "기술 합계에서 자동으로 계산됨",
          "noSkills": "아직 정의된 기술이 없습니다"
        }
      },
      "persons": {
        "headers": {
          "directory": "인원 디렉토리"
        },
        "actions": {
          "newPerson": "새 인원"
        },
        "tables": {
          "personId": "인원 ID",
          "name": "표시 이름",
          "site": "사이트",
          "email": "이메일",
          "phone": "전화번호"
        },
        "messages": {
          "loadFailed": "인원 목록을 로드하지 못했습니다"
        },
        "headers": {
          "directory": "인원 디렉토리"
        },
        "tabs": {
          "profile": "프로필 정보",
          "contact": "연락처 디렉토리",
          "access": "시스템 액세스"
        },
        "sections": {
          "personalInfo": "개인 정보",
          "statusControl": "상태 및 제어",
          "contactsDirectory": "관련 연락처"
        },
        "tables": {
          "personId": "인원 ID",
          "name": "표시 이름",
          "site": "사이트",
          "email": "이메일",
          "phone": "전화번호"
        },
        "fields": {
          "location": "위치",
          "firstName": "이름",
          "lastName": "성",
          "title": "직함",
          "department": "부서",
          "currentStatus": "현재 상태",
          "contactName": "연락처 이름",
          "position": "직책",
          "email": "이메일 주소",
          "phone": "전화",
          "mobile": "휴대전화",
          "primary": "기본",
          "address": "주소",
          "city": "도시",
          "country": "국가",
        },
        "actions": {
          "newPerson": "새 인원",
          "addContact": "연락처 추가"
        },
        "messages": {
          "loadFailed": "인원 목록을 로드하지 못했습니다",
          "noContacts": "아직 추가된 연락처가 없습니다",
          "accessControlled": "시스템 액세스는 사용자 보안 모듈에 의해 제어됩니다"
        }
      },
      "jp": {
        "list": {
          "title": "작업 계획 디렉토리",
          "new_plan": "새 계획",
          "filter_jp": "계획 필터링...",
          "search_desc": "설명 검색...",
          "filter_site": "사이트...",
          "no_records": "작업 계획을 찾을 수 없음",
          "fetch_error": "작업 계획을 불러오지 못했습니다"
        },
        "fields": {
          "jpnum": "계획 번호",
          "description": "설명",
          "status": "상태",
          "revision": "리비전",
          "site": "사이트"
        },
        "details": {
          "load_error": "작업 계획을 불러오지 못했습니다",
          "delete_warn": "작업 계획 {{jpnum}}을(를) 삭제하려고 합니다. 이 작업은 되돌릴 수 없습니다!"
        },
        "tabs": {
          "job_plan": "작업 계획",
          "plans": "계획 상세",
          "assets": "자산"
        },
        "subtabs": {
          "tasks": "작업",
          "labor": "인력",
          "materials": "자재",
          "tools": "도구"
        },
        "sections": {
          "details": "계획 세부정보",
          "responsibility": "책임",
          "woassets": "작업 자산 및 안전 계획"
        },
        "fields": {
          "jpnum": "계획 번호",
          "status": "상태",
          "description": "설명",
          "template_type": "템플릿 유형",
          "duration": "기간(시간)",
          "supervisor": "감독관",
          "class": "클래스 구조",
          "safety_plan": "안전 계획",
          "revision": "리비전"
        },
        "table": {
          "seq": "순서",
          "duration": "기간",
          "craft": "직종",
          "labor": "작업자",
          "qty": "수량",
          "hours": "시간",
          "rate": "단가",
          "item": "품목",
          "unitcost": "단가",
          "tool": "도구"
        }
      },
      "meters": {
        "list": {
          "title": "계기 정의",
          "search": "번호 또는 이름으로 필터링...",
          "new_meter": "새 계기",
          "no_records": "계기를 찾을 수 없음"
        },
        "fields": {
          "meter_num": "계기 번호",
          "meter_name": "계기 이름",
          "type": "유형",
          "uom": "단위",
          "active": "활성?",
          "remarks": "비고",
          "last_reading": "마지막 판독값",
          "last_date": "마지막 판독일",
          "rollovers": "총 롤오버"
        },
        "tabs": {
          "meter": "계기 세부정보",
          "where_used": "사용 위치"
        },
        "sections": {
          "info": "계기 정보",
          "additional": "추가 세부정보",
          "stats": "계기 통계"
        },
        "where_used": {
          "linked_assets": "연결된 자산",
          "linked_locations": "연결된 위치",
          "linked_items": "연결된 품목",
          "searching": "🔍 시스템 검색 중...",
          "no_assoc": "이 범주에서 연관성을 찾을 수 없습니다.",
          "asset_num": "자산 번호",
          "site": "사이트",
          "status": "상태",
          "location": "위치",
          "item_num": "품목 번호",
          "category": "범주"
        }
      },     
      "asset_categories": {
        "list": {
          "title": "자산 범주",
          "search": "범주 검색...",
          "new_category": "새 범주",
          "no_records": "범주를 찾을 수 없음"
        },
        "fields": {
          "category_id": "범주 코드",
          "description": "설명",
          "dep_method": "감가상각 방법",
          "life": "수명(년)"
        }
      },
      "export": {
        "loading": "데이터 추출 중...",
        "success": "내보내기 성공!",
        "error": "데이터 내보내기 오류."
      },
      "labor": {
        "list": {
          "title": "인력 등록",
          "new": "새 인력",
          "total": "총 인력",
          "unique_crafts": "페이지 공종",
          "no_records": "일치하는 인력 기록을 찾을 수 없습니다."
        },
        "fields": {
          "laborcode": "인력 코드",
          "fullname": "성명",
          "craft": "공종"
        },
        "tabs": {
          "main": "메인",
          "person": "개인",
          "crafts": "공종",
          "log": "로그"
        },
        "sections": {
          "basic": "기본 정보",
          "status": "상태 및 조직",
          "additional_crafts": "추가 공종 및 전문 기술"
        },
        "fields": {
          "personid": "개인 참조",
          "primary_craft": "기본 공종",
          "actual_rate": "실제 요금(시간당)",
          "skill": "기술 수준",
          "rate": "시간당 요금",
          "primary": "기본?"
        },
        "actions": {
          "add_craft": "공종 추가"
        },
        "lookup": {
          "person": "사람 선택",
          "craft": "공종 선택",
          "skill": "기술 선택"
        },
        "messages": {
          "no_crafts": "공종 연관성을 찾을 수 없습니다"
        },
        "details": {
          "delete_warn": "이 기록을 복구할 수 없습니다!"
        }
      },
      "sr": {
        "list": {
          "title": "서비스 요청 추적",
          "new": "새 요청"
        },
        "fields": {
          "srnum": "SR 번호",
          "description": "설명",
          "reportedby": "보고자",
          "reportdate": "보고 날짜",
          "priority": "우선순위"
        },
        "messages": {
          "no_records": "서비스 요청을 찾을 수 없습니다"
        },
        "tabs": {
          "main": "서비스 요청",
          "related": "관련 기록"
        },
        "sections": {
          "requester": "요청자 및 연락처",
          "problem": "문제 세부사항",
          "logistics": "물류 및 우선순위"
        },
        "fields": {
          "phone": "전화번호",
          "email": "이메일",
          "asset": "자산",
          "location": "위치",
          "long_desc": "문제 상세 설명",
          "priority_1": "1 - 긴급 (즉시)",
          "priority_2": "2 - 높음 (당일)",
          "priority_3": "3 - 보통 (72시간)",
          "priority_4": "4 - 낮음 (계획됨)"
        },
        "lookup": {
          "person": "사람 선택",
          "asset": "자산 선택",
          "location": "위치 선택"
        },
        "details": {
          "delete_new_only": "새로운(NEW) 요청만 삭제할 수 있습니다",
          "delete_warn": "이 서비스 요청을 영구적으로 삭제합니다.",
          "wf_tip": "자동 워크플로우: 저장 후 '워크플로우 라우팅' 버튼을 사용하여 기술 검토를 위해 이 요청을 보내세요.",
          "wo_tip": "팁: 워크플로우 작업 또는 '작업 지시서 생성' 자동화 스크립트를 통해 이 SR에서 작업 지시서를 생성할 수 있습니다."
        },
        "related": {
          "title": "SR에 연결된 작업 지시서:",
          "wonum": "WO 번호",
          "worktype": "작업 유형",
          "no_wo": "이 SR에 대해 아직 생성된 작업 지시서가 없습니다.",
          "go_to_wo": "작업 지시서로 이동"
        }
      },
      "invusage": {
        "list": {
          "title": "재고 사용 내역",
          "new": "새 거래 생성"
        },
        "types": {
          "all": "전체",
          "issue": "발급",
          "transfer": "이전",
          "return": "반환"
        },
        "tabs": {
          "lines": "사용 라인",
          "log": "거래 로그"
        },
        "details": {
          "summary": "라인 요약",
          "transfer_dest": "이전 대상 세부 정보",
          "financial": "재무 청구 및 참조"
        },
        "actions": {
          "add_item": "항목 추가",
          "add_part": "부품 추가",
          "select_mr": "자재 요청(MR) 선택"
        },
        "fields": {
          "stock_item": "재고 항목",
          "issueunit": "발급 단위",
          "qty": "수량",
          "unitcost": "단가",
          "linecost": "총 라인 가치",
          "target_bin": "대상 보관함",
          "target_loc": "대상 위치",
          "assetnum": "자산 번호",
          "wonum": "작업 지시서 참조",
          "glaccount": "차변 GL 계정",
          "usagenum": "사용 ID",
          "type": "유형",
          "fromstore": "출고 창고",
          "lines": "품목 수",
          "enterby": "입력자"
        },
        "placeholders": {
          "select_item": "항목 선택...",
          "dest_bin": "대상 보관함 입력...",
          "choose_loc": "위치 선택",
          "select_asset": "자산 선택",
          "charge_wo": "작업 지시서에 청구"
        },
        "lookup": {
          "store": "저장실",
          "dest_store": "대상 저장실",
          "mr": "승인된 자재 요청 선택",
          "item": "재고 조회",
          "loc": "사이트 위치",
          "asset": "자산 레지스트리",
          "wo": "작업 지시서"
        },
        "messages": {
          "req_fromstore": "먼저 저장실을 선택하십시오!",
          "mr_loaded": "MR에서 항목 로드됨:",
          "mr_fail": "MR 항목 로드 실패",
          "insufficient_title": "재고 부족!",
          "available": "사용 가능",
          "create_pr": "구매 요청(PR)을 생성하시겠습니까?",
          "btn_create_pr": "PR 생성",
          "processing": "재고 조정 처리 중...",
          "inventory_updated": "재고 수준이 성공적으로 업데이트되었습니다.",
          "cant_delete_comp": "완료된 거래는 삭제할 수 없습니다!",
          "delete_warn": "이 초안 거래가 영구적으로 삭제됩니다.",
          "req_fields": "설명 및 저장실은 필수입니다!",
          "req_transfer": "이전 시 대상 저장실이 필요합니다!",
          "locked_title": "기록 잠김",
          "locked_text": "이 거래는 완료되었으며 수정할 수 없습니다.",
          "cant_save_comp": "완료된 기록에 대한 변경 사항을 저장할 수 없습니다.",
          "balance_move": "참고: 완료 시 잔액이 다음으로 이동됩니다:",
          "upon_comp": "."
        }
      },
      "downtime": {
        "title": "자산 가동 중지 보고",
        "subtitle": "자산 관리 시스템",
        "asset": "자산",
        "status": "오프라인 기록",
        "start": "시작 날짜 및 시간",
        "end": "종료 날짜 (선택 사항)",
        "type": "가동 중지 유형",
        "types": {
          "unplanned": "비계획적 (고장)",
          "planned": "계획적 (유지보수)"
        },
        "duration": "계산된 기간",
        "hours": "시간",
        "prod_impact": "운영 가동 중지 (생산 영향)",
        "btn_commit": "변경 사항 적용",
        "messages": {
          "recording": "가동 중지 시간 기록 중...",
          "success": "가동 중지 시간이 성공적으로 기록되었습니다.",
          "validation_error": "형식 오류: 모든 필드를 확인하세요",
          "server_error": "서버 오류: 500"
        },
        "history": {
          "title": "자산 가동 중지 기록",
          "subtitle": "자산 성능 추적",
          "no_records": "이 자산에 대해 기록된 가동 중지 이벤트가 없습니다.",
          "duration_hrs": "기간 (시간)",
          "type_reason": "유형/이유",
          "impact": "영향",
          "reported_by": "보고자",
          "still_down": "여전히 중지됨",
          "prod_loss": "생산 손실",
          "technical": "기술적",
          "active_down": "활성 가동 중지",
          "resolved": "해결됨"
        }
      },
      "incidents": {
        "list": {
          "title": "사고 등록부",
          "new": "새 사고 등록"
        },
        "fields": {
          "ticket_id": "티켓 ID",
          "priority": "우선순위",
          "reported_by": "보고자"
        },
        "details": {
          "ticket": "사고 티켓",
          "general": "일반 설명",
          "detailed": "상세 내용",
          "context": "컨텍스트 및 상태",
          "linked_asset": "연결된 자산",
          "workorder": "작업 지시서",
          "delete_warn": "사고 {{ticket}}을(를) 영구적으로 삭제하려고 합니다. 이 작업은 실행 취소할 수 없습니다!"
        },
        "lookup": {
          "asset": "연결된 자산 선택",
          "loc": "위치 선택"
        }
      },
      "tools": {
        "list": {
          "title": "도구 마스터",
          "new": "새 도구"
        },
        "fields": {
          "toolnum": "도구 번호",
          "type": "유형",
          "is_stocked": "재고 있음?"
        },
        "tabs": {
          "tool": "도구",
          "stores": "저장실",
          "vendors": "공급업체",
          "specs": "사양",
          "quals": "자격"
        },
        "sections": {
          "config": "도구 구성",
          "inventory": "재고 및 잔고",
          "vendors": "조달 및 공급업체 내역",
          "quals": "필수 자격"
        },
        "fields": {
          "toolnum": "도구 번호",
          "type": "도구 유형",
          "issueunit": "발급 단위",
          "is_stocked": "재고 도구입니까?",
          "rotating": "회전 항목?",
          "calib_req": "교정 필요?",
          "mfg": "제조업체",
          "model": "모델 번호",
          "class": "분류",
          "active_vendors": "활성 공급업체"
        },
        "actions": {
          "add_store": "저장실에 추가",
          "add_qual": "자격 추가"
        },
        "tables": {
          "storeroom": "저장실",
          "balance": "잔고",
          "attr": "속성",
          "value": "값",
          "uom": "단위",
          "qual": "자격",
          "vendor_id": "공급업체 (회사 번호)",
          "vendor_name": "공급업체 이름",
          "unitcost": "단가",
          "qty": "수량",
          "po": "참조 PO"
        },
        "placeholders": {
          "toolid": "도구 ID 입력...",
          "reg_supplier": "등록된 공급업체",
          "adj": "재고 조정"
        },
        "lookup": {
          "type": "도구 유형",
          "unit": "발급 단위",
          "attr": "속성"
        },
        "messages": {
          "req_fields": "도구 번호와 설명은 필수 항목입니다!",
          "delete_warn": "이 작업은 되돌릴 수 없습니다!",
          "class_loaded": "분류 및 속성 로드됨",
          "stocked_note": "참고: 재고 도구는 저장실을 통해 관리되며 잔고를 추적하기 위해 재고 레코드가 필요합니다.",
          "no_stock": "재고 항목 없음"
        }
      },
      "inventory": {
        "list": {
          "title": "재고 레지스트리"
        },
        "fields": {
          "itemnum": "품목 번호",
          "location": "저장실",
          "balance": "잔고",
          "avgcost": "평균 원가"
        },
        "details": {
          "profile": "재고 프로파일",
          "reorder_logic": "재주문 논리",
          "reorder_pt": "재주문점",
          "eoq": "경제적 주문 수량",
          "critical_lvl": "임계 수준",
          "critical_desc": "잔고가 재주문점에 도달하면 자동으로 PR을 생성합니다.",
          "current_stock": "현재 재고 수준",
          "avail_qty": "사용 가능 수량",
          "reserved_qty": "예약된 수량",
          "held_wo": "작업 지시서를 위해 보류됨",
          "avg_cost": "평균 단가",
          "avg_cost_desc": "모든 입고의 가중 평균",
          "total_val": "총 재고 가치",
          "total_val_desc": "현재 잔고 × 평균 원가",
          "last_cost": "최근 입고 원가",
          "last_cost_desc": "가장 최근 PO의 원가",
          "val_method": "재고 평가 방법",
          "avg_method": "평균 원가법",
          "val_desc1": "이 항목은",
          "val_desc2": "을(를) 사용합니다. 단가는 시장 가격 변동을 반영하기 위해 구매 주문 입고 시마다 자동으로 다시 계산됩니다."
        },
        "tabs": {
          "balances": "잔고",
          "trans": "거래 내역",
          "costs": "비용"
        },
        "actions": {
          "adjustment": "재고 조정"
        },
        "tables": {
          "qty": "수량",
          "actual_cost": "실제 비용",
          "reference": "참조"
        },
        "messages": {
          "no_trans": "거래 내역을 찾을 수 없음"
        },
        "trans_types": {
          "receipt": "입고",
          "issue": "출고",
          "transfer": "이전",
          "adjustment": "조정"
        }
      },
      "storerooms": {
        "list": {
          "title": "저장실",
          "new": "새 저장실"
        },
        "fields": {
          "location": "저장실",
          "isdefault": "기본값입니까?",
          "inventory": "재고",
        },
        "details": {
          "profile": "저장실",
          "record": "저장실 레코드",
          "gen_settings": "일반 설정",
          "filtered_by": "{{org}}로 필터링됨",
          "select_org_first": "먼저 조직을 선택하세요",
          "gl_accounts": "GL 계정",
          "inv_control": "재고 통제",
          "inv_control_desc": "이 저장실에 대한 모든 자재 출고 및 입고는 이 계정에 대해 균형이 맞춰집니다.",
          "items_stocked": "재고 품목"
        },
        "tabs": {
          "main": "기본",
          "inventory": "재고"
        },
        "fields": {
          "location": "위치 ID",
          "isdefault": "기본 저장실?",
          "useinpo": "PO에서 사용?",
          "invowner": "재고 소유자",
          "controlacc": "통제 계정",
          "shrinkacc": "감모 계정",
          "glaccount": "기본 GL 계정",
          "default": "기본값"
        },
        "lookup": {
          "person": "사람 선택"
        },
        "tables": {
          "itemnum": "품목 번호",
          "uom": "단위",
          "curbal": "현재 잔고",
          "reserved": "예약된 수량"
        },
        "messages": {
          "req_fields": "위치 ID는 필수입니다!",
          "req_org_site": "조직과 사이트는 필수입니다!",
          "delete_warn": "저장실 {{store}}을(를) 삭제하려고 합니다. 이 작업은 취소할 수 없습니다!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "障害コードライブラリ",
          "new": "新規障害クラス"
        },
        "details": {
          "profile": "障害クラス"
        },
        "fields": {
          "class": "障害クラス",
          "code": "コード",
          "desc_tech": "説明 / 技術名"
        },
        "tables": {
          "problems": "問題 (現象)",
          "causes": "原因 (根本原因)",
          "remedies": "対策 (アクション)"
        },
        "placeholders": {
          "class": "例：PUMP-FAIL",
          "desc_tech": "この障害階層の詳細な説明を入力してください...",
          "code": "コードを入力...",
          "desc": "技術的な説明..."
        },
        "messages": {
          "req_class": "障害クラスコードは必須です！",
          "delete_warn": "障害クラス {{class}} を削除しようとしています。この操作は元に戻せません！"
        }
      },
      "scheduler": {
        "title": "배차 및 일정 관리",
        "ai_optimize": "AI 자동 최적화",
        "publish": "일정 게시",
        "kpi_scheduled": "예정된 작업",
        "kpi_issues": "일정 문제",
        "kpi_utilization": "총 자원",
        "kpi_emergencies": "긴급 상황",
        "no_data": "예정된 작업 지시가 없습니다.",
        "no_resources": "자원 용량 데이터가 없습니다.",
        "fetch_error": "일정 데이터를 불러오지 못했습니다.",
        "optimizing": "AI가 자원 부하를 평준화하고 있습니다...",
        "optimize_fail": "AI 최적화에 실패했습니다."
      },
      "features": {
        "title": "선형 기능 카탈로그",
        "feature_id": "기능 코드",
        "description": "설명",
        "type": "기능 유형",
        "point": "포인트 (예: 밸브)",
        "linear": "선형 (예: 재질)",
        "error_in_use": "삭제할 수 없음: 파이프라인에서 사용 중인 기능입니다."
      },
      "audit": {
        "title": "감사 추적 탐색기",
        "history_for": "기록:",
        "retrieving": "감사 레코드 검색 중...",
        "no_records": "이 레코드에 대한 감사 추적을 찾을 수 없습니다"
      },

    }
  },
  // 🇷🇺 Русский (Russian)
  ru: {
    translation: {
      brand: { name: "TEKNORA EAM", tagline: "Превосходство Активов", version: "Teknova v1.0.4" },
      search: { placeholder: "Поиск модулей..." },
      menu: {
        settings: "Настройки", organization: "Организация", domains: "Домены", field_config: "Конфиг Полей", classifications: "Классификации", importer: "Универсальный импорт", cobie: "COBie Менеджер", workflow: "Движок Workflow", scripts: "Скрипты действий",
        analytics: "Аналитика", dashboards: "BI Дашборды", report_designer: "Дизайнер отчетов", report_wizard: "Мастер отчетов",
        assets: "Активы", asset_registry: "Реестр активов", locations: "Местоположения", categories: "Категории активов", meters: "Счетчики", failure_codes: "Коды отказов",
        work_management: "Управление работами", wo_tracking: "Трекинг заказов", labor_reporting: "планировщик",
        resources: "Ресурсы", crafts: "Профессии", labor: "Персонал", person: "Сотрудник",
        service_desk: "Сервис-деск", service_requests: "Заявки на сервис", incidents: "Реестр инцидентов",
        procurement: "Закупки", po: "Заказы на закупку", pr: "Запросы на закупку", rfq: "Запросы котировок", receiving: "Приемка", vendors: "Поставщики",
        contracts: "Контракты", contracts_master: "Мастер контрактов", sla: "SLA",
        inventory: "Склад", item_master: "Номенклатура", tools: "Инструменты", balances: "Остатки", transfers: "Выдача и перемещение", storerooms: "Склады",
        planning: "Планирование", pm_schedules: "Графики ППР", safety_plans: "Планы безопасности", hazards: "Опасности", precautions: "Меры предосторожности", tagouts: "Блокировки", job_plans: "Техкарты",
        security: "Безопасность", user_list: "Список пользователей", groups: "Группы безопасности", "recent": "Недавно просмотренные"
      },
      user_settings: { title: "Настройки пользователя", default_info: "Информация по умолчанию", personal_info: "Личная информация", password_info: "Смена пароля", sign_out: "Выйти", system_info: "Системная информация" },
      notifications: { title: "Входящие задачи", new_alerts: "Новое", empty: "Входящие пусты", view_all: "Показать все действия" },
      sidebar: { queries: "Доступные запросы", all_assets: "Все активы", operating_assets: "Рабочие активы", critical_assets: "Критические активы", my_bookmarks: "Мои закладки", common_actions: "Общие действия", new: "Новый", move_assets: "Переместить активы", print_barcodes: "Печать штрихкодов", create_report: "Создать отчет", wo_queries: "Запросы заказов", all_wo: "Все заказы", waiting_approval: "Ждет одобрения", wip: "В работе", completed_today: "Завершено сегодня", bulk_approve: "Массовое одобрение", record_actions: "Действия записи", save: "Сохранить", delete: "Удалить", workflow_status: "Процесс / Статус", change_status: "Сменить статус", view_history: "Посмотреть историю", item_ops: "Операции с ТМЦ", add_to_storeroom: "Добавить на склад", inv_ops: "Операции склада", reorder: "Перезаказ", tax_ops: "Налоги", tax_category: "Категория налога", create_po: "Создать заказ", settings_group: "Настройки", system_settings: "Настройки системы", email_settings: "Настройки почты", asset_ops: "Операции актива", meter_readings: "Показания счетчиков", hist_readings: "История показаний", report_downtime: "Сообщить о простое", downtime_hist: "История простоев", move_mod_asset: "Переместить/Изм.", asset_move_hist: "История перемещений", create_related: "Создать связь", create_incident: "Создать инцидент", view_inc_hist: "История инцидентов", create_wo: "Создать заказ", sr: "Запрос сервиса", apply_sla: "Применить SLA", approve_wo: "Одобрить заказ", start_work: "Начать работу", complete_work: "Завершить работу", close_wo: "Закрыть заказ", analytics: "Аналитика", wf_history: "История процесса", history_log: "Лог истории", wo_costs: "Затраты", purchase_info: "Инфо закупок", all_records: "Все записи", find_nav: "Найти пункт", more_actions: "Доп. действия", settings: "Настройки", export_data: "Экспорт", audit_log: "Лог аудита", share_app: "Поделиться" },
      apps: {
        ORGANIZATION: "Организации", ASSET: "Активы", LOCATION: "Местоположения", WORKORDER: "Заказы", INVENTORY: "Склад", CLASSIFICATION: "Классы", VENDOR: "Поставщики", METER: "Счетчики", DOMAINS: "Домены", CRAFTS: "Профессии", STOREROOMS: "Склады", ITEMS: "Номенклатура", INVENTORYUSAGE: "Расход склада", MR: "Заявки мат.", PR: "Заявки закупки", PO: "Заказы закупки", LABOR: "Персонал", PM: "ППР", SAFETY: "Безопасность", HAZARD: "Опасности", TAGOUT: "Блокировки", PRECUTION: "Меры", SR: "Сервис-заявки", INCIDENT: "Инциденты", ASSET_CATEGORIES: "Категории", FAILURECLASS: "Отказы", RFQ: "Котировки", CONTRACT: "Контракты", SLA: "Соглашение об уровне обслуживания", FAILURE_CODES: "Коды ошибок",
        "VENDORS": "Поставщики", "TAGOUTS": "Блокировки", "PRECAUTIONS": "Меры предосторожности", "INCIDENTS": "Инциденты", "JOBPLAN": "Техкарты (Job Plans)","ROLE": "Роли", "TOOLS": "Инструменты", "USER": "Пользователи"
      },
      dashboard: { tab_bi: "Шаблон KPI", tab_inbox: "Задачи Workflow", advanced_analytics: "Продвинутая аналитика", workflow_center: "Центр исполнения", active_tasks: "Активные задачи", history_tasks: "История", no_data: "Данных не найдено", take_action: "Действие", previous: "Назад", next: "Вперед", showing: "Показ", of: "из", actual: "Факт", target: "Цель", kpi_graph: "График KPI" },
      username: "ID пользователя",
      password: "Пароль",
      login_btn: "Войти",
      forgot_pwd: "Забыли пароль?",
      login: {
        id_placeholder: "Введите ваш ID",
        error_msg: "Неверный ID или пароль",
        server_error: "Ошибка подключения к серверу",
        just_smart: "Просто и Умно"
      },
      organizations: { title: "Организации", org_id: "Организация", description: "Описание", active: "Активно?" },
      org_detail: { org_label: "Организация", tabs: { organization: "Организация", sites: "Филиалы", map: "Карта" }, fields: { currency1: "Осн. валюта 1", currency2: "Осн. валюта 2", item_set: "Набор ТМЦ", company_set: "Набор компаний", item_status: "Статус ТМЦ", active: "Активно?" }, descs: { currency1: "Первичная валюта", currency2: "Вторичная валюта", item_set: "НАБОР ТМЦ", company_set: "НАБОР КОМПАНИЙ" }, lookups: { currency: "Валюта", item_set: "Набор ТМЦ", company_set: "Набор компаний", status: "Статус", governorate: "Область" }, sites: { management: "Управление филиалами", new_row: "Новая строка", of: "из", site_id: "ID Филиала", description: "Описание", active: "Активно?", action: "Действие", site_details: "Детали филиала", state: "Область / Край", contact: "Контакт", fin_info: "Финансы / Бюджет", yearly_budget: "Годовой бюджет", monthly_budget: "Месячный бюджет", utilization: "Использование", fin_health: "Финансовое состояние стабильное." }, toasts: { id_required: "ID обязателен!", saving: "Сохранение...", success: "Сохранено успешно!", fail: "Ошибка сохранения" } },
      domains: { title: "Домены", find_placeholder: "Найти домен...", new_domain: "Новый домен", domain_id: "Домен", description: "Описание", type: "Тип", values: "Значения" ,
        save_btn: "Сохранить", desc_placeholder: "Описание домена", synonym_values: "Синонимы", new_row: "Новая строка", internal_val: "Внутр. значение", external_desc: "Внешнее описание", default: "По умолчанию?", action: "Действие", no_values: "Значения не определены.", toasts: { loading: "Загрузка...", load_fail: "Ошибка загрузки", id_required: "ID обязателен!", saving: "Сохранение...", save_success: "Сохранено!", save_fail: "Ошибка" } },
      classifications: { parent: "Родительский класс", order: "Порядок", hierarchy: "Структура", hierarchy: "Путь иерархии", parent: "Родительская категория", gen_desc: "Создать описание?", use_with: "Использовать с объектами", attributes: "Атрибуты", attr_id: "ID атрибута", section: "Раздел", uom: "единица измерения" },
      bim: { title: "BIM Интегратор Pro", subtitle: "Продвинутое сопоставление Revit с COBie", waiting_translation: "Ожидание трансляции модели...", tabs: { "3d": "3D Просмотр", data: "Таблица данных" }, preview_table_title: "Предпросмотр компонентов COBie", controls: { destination: "Назначение", select_site: "Выбрать филиал", uploads: "Загрузка файлов", select_cobie: "Выбрать COBie", upload_revit: "Загрузить Revit", models_ready: "Модели готовы", preview_list: "Список моделей", finalizing: "Синхронизация...", commit: "Применить интеграцию BIM" }, table: { asset_name: "Имя актива", location: "Пространство / Место" } },
      importer: { title: "Универсальный загрузчик данных", target_table: "Целевая таблица", download_template: "Скачать шаблон", upload_instruction: "Выберите файл Excel", field_mapping: "Сопоставление полей", excel: "Excel", ignore: "Игнорировать", preview_title: "Предпросмотр", execute_btn: "ЗАПУСТИТЬ ИМПОРТ" },
      workflow: { title: "Движок процессов", subtitle: "Центр автоматизации", export_btn: "Экспорт CSV", new_process: "Новый процесс", loading: "Загрузка...", unnamed: "Без имени", linked_to: "Связано с", create_path: "Создать новый путь", 
                  designer_title: "Дизайнер логики (Loopback включен)", publish_btn: "ОПУБЛИКОВАТЬ", loading_designer: "Восстановление логического пути...", logic_palette: "Палитра логики", config_title: "Конфигурация", node_label: "Метка", assign_roles: "Назначить роли", post_action: "Скрипты после действия", select_lookup: "ВЫБРАТЬ ИЗ ПОИСКА", script_hint: "* Можно указать несколько скриптов через запятую.", status_auto: "Автосмена статуса", trigger: "Триггер", target_status: "Целевой статус", cond_expr: "Условное выражение (Python)", escalation: "Эскалация (часов)", select_node: "Выберите узел для редактирования", options: {no_change: "БЕЗ ИЗМЕНЕНИЯ СТАТУСА", change_status: "ИЗМЕНИТЬ СТАТУС", select_status: "ВЫБРАТЬ СТАТУС"},      lookups: {select_roles: "Поиск ролей", select_scripts: "Выбор скриптов" },
                  table : {id: "идентификатор", name: "имя процесса", app: "приложение", status: "статус"},
        swal: { publish_title: "Опубликовать процесс?", publish_text: "Это синхронизирует шаги с базой данных.", confirm_publish: "Да, опубликовать", delete_title: "Очистить логику?", delete_text: "Вы уверены, что хотите удалить", confirm_delete: "Да, удалить всё"},
        toasts: {id_required: "Введите имя процесса", saving: "Синхронизация...", save_success: "Логика синхронизирована! 🚀", save_fail: "Синхронизация не удалась", purging: "Удаление процесса...", delete_success: "Процесс удален навсегда", delete_fail: "Ошибка удаления", fetch_fail: "Ошибка загрузки данных"}
      },
      field_config: { title: "Сопоставление полей метаданных", table_name: "ИМЯ ТАБЛИЦЫ", field_name: "ИМЯ ПОЛЯ", current_mappings: "ТЕКУЩИЕ СВЯЗИ ДЛЯ", field: "Поле", linked_domain: "Связанный домен" },
      scripts: {
        title: "СКРИПТЫ ДЕЙСТВИЙ",
        subtitle: "Управление шаблонами автоматизации и логики",
        new_btn: "СОЗДАТЬ НОВЫЙ СКРИПТ",
        search_placeholder: "Поиск по имени или объекту...",
        table: {
          name: "Имя скрипта",
          object: "Целевой объект",
          created: "Дата создания"
        },
        toasts: {
          fetch_fail: "Ошибка загрузки скриптов"
        }
      },
      studio: { schema_explorer: "ПРОВОДНИК СХЕМЫ", target_context: "Контекст объекта", name_placeholder: "Назовите ваш скриپت...", engine_info: "ДВИЖОК: PYTHON 3.10", console_title: "Консоль выполнения", clear_console: "Очистить консоль", field_from: "Поле из", access_col: "Доступ к колонке: ", db_model: "Модель БД", btns: { compile: "КОМПИЛИРОВАТЬ", compiling: "КОМПИЛЯЦИЯ...", save_deploy: "СОХРАНИТЬ" }, toasts: { preserved: "Скрипт сохранен!", compiled: "Анализ пройден!" }, console: { init: "Студия запущена...", schema_sync: "Схема синхронизирована.", schema_fail: "Ошибка схемы.", saved_prefix: "Скрипт сохранен", error_op: "Ошибка сохранения.", compiling: "Анализ...", build_finish: "Сборка завершена.", syntax_error: "Ошибка синтаксиса.", build_fail: "Ошибка сборки", analyzing: "Синтаксический анализ..." } },
      reports: { title: "Шаблоны отчетов", new_btn: "Создать отчет", search_placeholder: "Поиск...", table: { name: "Название отчета", ref_obj: "Объект", updated: "Обновлено" }, 
          toasts: { load_fail: "Ошибка загрузки", clone_success: "Отчет клонирован", save_success: "Шаблон сохранен! 🚀", save_fail: "Ошибка сохранения" },
          designer: {
                title: "КОНСТРУКТОР ОТЧЕТОВ", live_preview: "Предпросмотр", publish: "Опубликовать шаблон", model_select: "Выбор модели", data_explorer: "Проводник данных", components: "Компоненты", page_break: "Разрыв страницы",
                is_summary: "Сводный отчет?", user_params: "Параметры пользователя", add_param: "Добавить поле", master_info: "Основная информация", relational_data: "Связанные данные", detail_tables: "Таблицы деталей", tabs: { body: "Содержание", header: "Шапка", footer: "Подвал", css: "Глобальный CSS" },
                fields: { wonum: "Номер заказ-наряда", assetnum: "Номер актива", desc: "Описание", status: "Статус", asset: "Имя актива", location: "ID локации", tasks_table: "Таблица задач", mat_table: "Плановые материалы", asset_basic: "Инфо актива", inv_basic: "Инфо склада", vend_basic: "Инфо поставщика" }
              },
        }, 
      assets: { 
        map: { "gps_location": "Географическое положение (GPS)", "gps_coordinates": "GPS-координаты"},
        list: { system_title: "Система управления активами", new_asset: "Новый актив", all_orgs: "Все орг.", all_sites: "Все сайты", db_total: "Всего:", display_page: "Страница:", navigate_hint: "Используйте стрелки для навигации.", col_site: "Сайт", col_org: "Орг."}, 
        modal: { migration_title: "Массовое перемещение", caution_prefix: "Внимание: вы перемещаете", caution_suffix: "активов.", dest_label: "Новое местоположение", placeholder: "ВЫБРАТЬ...", abort: "Отмена", execute: "Выполнить" },
        headers: { asset_num: "Номер актива", desc: "Описание", status: "Статус", downtime: "Общий простой", site: "Участок" },
        tabs: { details: "Детали актива", spare_parts: "Запчасти", safety: "Безопасность", meters: "Счетчики", specs: "Спецификации", history: "История работ", map: "Карта", bim: "3D вид", ai: "ИИ анализ", eval: "Оценка", attachments: "Вложения" },
        sections: { "linear_details": "Сведения о линейной привязке", general: "Общая информация", details: "Подробности", finance: "Адрес и финансы", image: "Изображение актива", audit: "Аудит", bim_info: "BIM инфо", reliability: "Анализ надежности" },
        fields: { "is_linear": "Линейный актив?", "start_measure": "Начальная точка", "end_measure": "Конечная точка", "measure_unit": "Единица измерения", "direction": "Направление потока", type: "Тип актива", location: "Расположение", parent: "Родительский актив", category: "Категория актива", is_running: "Актив работает?", serial: "Серийный номер", item: "Оборотный актив", failure: "Класс отказа", safety_plan: "План безопасности", vendor: "Поставщик", price: "Цена закупки", replace: "Стоимость замены", priority: "Приоритет", ytd_cost: "Затраты с начала года" },
        meters: { seq: "Порядок", name: "Счетчик", reading: "Посл. показание", date: "Дата показания", inspector: "Инспектор", remarks: "Заметки" },
        ai: { title: "Интеллект актива", run: "Запуск диагностики", summary: "Техническое резюме", recommend: "Рекомендации", telemetry: "Анализ телеметрии..." },
        spare_fields: { item: "Оборотный актив", qty: "Количество", issued: "Выдано", remarks: "Заметки", item_details: "Детали позиции" },
        safety: { plan_card: "Связанные планы безопасности", active_plan: "Активный план безопасности", no_plan: "ПЛАН НЕ СВЯЗАН", link_plan: "Связать план", change_plan: "Изменить план", hazard_title: "Специфические риски актива", hazard_num: "Риск", hazard_type: "Тип / Приоритет", no_hazards: "Специфические риски не связаны.", add_hazard: "Добавить риск", loto_title: "Блокировка / Маркировка (LOTO)", tag_id: "ID маркировки", req_state: "Требуемое состояние", no_loto: "Точки изоляции не определены.", add_loto: "Добавить точку изоляции", applying_proto: "Применение протокола..." }, 
        meters: { title: "Связанные счетчики", details_title: "Детали счетчика", seq: "Порядок", meter_name: "Имя счетчика", meter_type: "Тип счетчика", uom: "Ед. изм.", active_status: "Активен?", last_reading: "Посл. показание", last_date: "Дата показания", inspector: "Инспектор", remarks: "Заметки", new_meter: "Новый счетчик" },
        specs: { classification: "Классификация", select_class: "Выберите классификацию...", tech_specs: "Технические характеристики", attribute: "Атрибут", value: "Значение", uom: "Ед. изм.", data_type: "Тип данных", attr_details: "Детали атрибута", select_val: "Выберите значение" },
        history: { title: "История заказ-нарядов", wo_num: "№ Заказа", finish_date: "Дата завершения", no_history: "История не найдена.", fetching: "Загрузка истории...", wo_type: "Тип" },
        bim: { model_status: "Статус модели", linked: "СВЯЗАНО И АКТИВНО", not_linked: "НЕ СВЯЗАНО", upload_revit: "Загрузить Revit (.rvt)", urn_label: "URN модели", "show_3d": "Просмотр цифрового двойника (3D)", "not_linked": "Не связано с 3D-моделью" },
        ai: { title: "ИНТЕЛЛЕКТ АКТИВОВ", sub_title: "ИИ-анализатор", tagline: "Промышленная предиктивная диагностика IoT", run_btn: "ЗАПУСТИТЬ ДИАГНОСТИКУ", analyzing: "АНАЛИЗ ПОТОКА ТЕЛЕМЕТРИИ...", health_score: "Оценка состояния", thermal: "Тепловая тревога", vibration: "Тревога вибрации", tech_summary: "ТЕХНИЧЕСКОЕ РЕЗЮМЕ", recommendations: "РЕКОМЕНДАЦИИ", sensors_chart: "Датчики против критических пределов", init_prompt: "Нажмите ЗАПУСТИТЬ ДИАГНОСТИКУ для начала анализа ИИ", critical: "КРИТИЧЕСКИЙ", normal: "НОРМА", stable: "СТАБИЛЬНО", detected: "ОБНАРУЖЕНО", "predictive_trajectory": "Прогнозируемая траектория отказа", "est_failure": "Ожидаемый отказ", "loading_pred": "Создание модели прогнозирования..." },
        "features": {
          "feature_id": "ID объекта",
          "label": "Метка",
          "start": "Начальная отметка",
          "end": "Конечная отметка (Пусто = Точка)",
          "value": "Значение (напр. 500 мм)",
          "details": "Детали объекта",
          "y_offset": "Смещение Y (Вправо/Влево)",
          "z_offset": "Смещение Z (Глубина/Высота)"
        },

      }, 
      common: { "days": "Дни", "weeks": "Недели", "months": "Месяцы", "years": "Годы", "daysList": {"saturday": "Суббота", "sunday": "Воскресенье", "monday": "Понедельник", "tuesday": "Вторник", "wednesday": "Среда", "thursday": "Четверг", "friday": "Пятница" }, "select": "Выбрать", "search": "Поиск", "pending": "В ожидании", "pendingSelection": "--- ОЖИДАЕТСЯ ВЫБОР ---",confirm: "подтверждение", save_settings: "Сохранить конфигурацию ИИ", selected: "Активы выбраны", bulk_move: "Массовое перемещение", change_status: "Сменить статус", cancel: "Сбросить", save: "Сохранить", cancel: "Отмена", delete: "Удалить", back: "Назад", record: "Запись", total: "Всего", print: "Печать", active: "Активен", critical: "Критично", warning: "Предупреждение", healthy: "Исправен", of: "из", new_row: "Новая строка", "filter": "Фильтр...", "save_success": "Успешно сохранено", "save_fail": "Ошибка сохранения", "delete": "Удалить", "delete_success": "Успешно удалено", "delete_fail": "Ошибка удаления", "are_you_sure": "Вы уверены?", "cancel": "Отмена", "confirm": "Подтвердить", "first": "Первый", "last": "Последний", "next": "Следующий", "prev": "Предыдущий", "sar": "SAR", "all": "ВСЕ", "attachments": "Вложения", "history": "История", "change_status": "Изменить статус", "totalRecords": "Всего записей", "readOnly": "(ТОЛЬКО ЧТЕНИЕ)", "noDescription": "Нет описания", "recordLocked": "Запись заблокирована и не может быть изменена.", "descRequired": "Требуется описание!", "actionDenied": "Действие запрещено", "cantDeleteStatus": "Невозможно удалить запись со статусом: {{status}}", copy: "Копия", cancel: "Отмена", clone: "Клонировать", back: "назад", yes: "Да", no: "Нет", "main": "Основные данные", "save": "СОХРАНИТЬ", "change_status": "Изменить статус", "history": "История", "delete": "Удалить", "org": "Организация", "site": "Сайт", "new_row": "НОВАЯ СТРОКА", "location": "Локация", "asset": "Актив", "no_records": "Записи не найдены", "saving": "Сохранение...", "save_success": "Успешно сохранено!", "save_fail": "Ошибка сохранения", "are_you_sure": "Вы уверены?", "yes_delete": "Да, удалить!", "cancel": "Отмена", "delete_success": "Успешно удалено", "delete_fail": "Ошибка удаления: ", "clear_filters": "ОЧИСТИТЬ ФИЛЬТРЫ", "all": "ВСЕ", "syncing": "Синхронизация...", "showing": "Показано", "total": "Всего", "created_by": "Создано", "changed_date": "Дата изменения"},
      toasts: { save_success: "Успешно сохранено", save_fail: "Ошибка сохранения", load_fail: "Ошибка загрузки данных", delete_success: "Успешно удалено" },
      swal: { delete_title: "Вы уверены?", delete_text: "Вы собираетесь удалить актив:", confirm_delete: "Да, удалить запись" },
      "ai_settings": {
        "title": "Настройки ИИ-инженера",
        "sub_title": "Система предиктивного обслуживания на базе ИИ",
        "enable_label": "Включить авто-предиктивное обслуживание",
        "enable_sub": "Автоматическое создание заказ-наряда на основе ИИ-анализа",
        "target_lang": "Язык отчетов и задач",
        "threshold": "Порог уверенности для принятия решения",
        "auto_tasks": "Автоматически генерировать рабочие задачи (WOTasks)",
        "task_desc": "Автоматически записывать этапы работ в таблицу задач",
        "max_tasks": "Макс. количество шагов в заказ-наряде",
        "section": "Раздел",
        "technicalDetails": "Технические детали"
      },
      "export_technical_report": "ЭКСПОРТ ТЕХНИЧЕСКОГО ОТЧЕТА (PDF)",
      "availability": "Доступность",
      "mtbf": "СВБО (MTBF)",
      "mttr": "СВВ (MTTR)",
      "hrs": "ЧАС",
      "reliability_score": "Оценка надежности",
      "score": "Балл",
      "downtime_history_trend": "Динамика простоев (Последние 10 событий)",
      "values_in_hours": "Значения в часах",
      "timeline_event_date": "Шкала времени (Дата события)",
      "downtime_hours": "Время простоя (Часы)",
      "no_downtime_records": "Для этого актива пока нет записей о простоях.",
      "reliability_analysis": "Анализ надежности",
      "total_failures": "Всего отказов",
      "total_down_time": "Общее время простоя",
      "last_calculation": "Последнее вычисление",
      "maintenance_strategy_note": "Примечание к стратегии ТОиР",
      "high_mttr_detected": "Обнаружено высокое значение MTTR. Рекомендация: оцените наличие запчастей и техническую подготовку для этой категории активов.",
      "critical_availability": "Критический уровень доступности. Рассмотрите возможность увеличения частоты ТО или плановых ремонтов.",
      "nominal_performance": "Производительность актива в пределах нормы. Продолжайте стандартный график ТО.",
      "current_load_factor": "Текущий коэффициент нагрузки",
      "optimal": "Оптимально",
      statusModal: {
        "loadError": "Не удалось загрузить статусы",
        "selectFirst": "Пожалуйста, выберите статус",
        "updating": "Обновление статуса...",
        "success": "Статус обновлен",
        "failed": "Ошибка обновления",
        "changeStatus": "Изменить статус:",
        "currentStatus": "Текущий статус",
        "availableStatuses": "Доступные статусы",
        "loading": "Загрузка...",
        "chooseStatus": "Выберите статус...",
        "memo": "Обоснование / Заметка",
        "enterNotes": "Введите ваши заметки...",
        "cancel": "Отмена",
        "update": "Обновить"
      },
      attachmentsModal: {
        "loadError": "Ошибка загрузки файлов",
        "uploadSuccess": "Файл успешно прикреплен",
        "uploadFailed": "Ошибка загрузки",
        "deleteConfirmTitle": "ВЫ УВЕРЕНЫ?",
        "deleteConfirmText": "Вы собираетесь навсегда удалить '{{name}}'. Это удалит файл с наших серверов.",
        "btnYesDelete": "ДА, УДАЛИТЬ!",
        "btnCancel": "ОТМЕНА",
        "processingDelete": "Удаление...",
        "deletedTitle": "УДАЛЕНО!",
        "deletedText": "Вложение успешно удалено.",
        "deleteFailed": "Ошибка удаления",
        "headerTitle": "Библиотека вложений",
        "linkingTo": "Связан с:",
        "filesFound": "НАЙДЕНО ФАЙЛОВ:",
        "uploadBtn": "ЗАГРУЗИТЬ НОВЫЙ ДОКУМЕНТ",
        "thName": "Имя",
        "thOwner": "Владелец",
        "thStatus": "Статус",
        "thActions": "Действия",
        "statusPrivate": "Частный",
        "statusPublic": "Публичный",
        "noDocs": "Пока нет связанных документов"
      },
      enterMeters: {
        "noMeters": "Нет счетчиков, связанных с активом:",
        "saving": "Сохранение показаний...",
        "enterAtLeastOne": "Пожалуйста, введите хотя бы одно новое показание",
        "saveSuccess": "Все показания успешно сохранены!",
        "saveFailed": "Не удалось сохранить показания",
        "title": "Ввод показаний счетчиков | Актив:",
        "titleLoc": "Ввод показаний счетчиков | Локация:",
        "thIdentification": "Идентификация счетчика",
        "thNewReading": "* Новое показание",
        "thReadingDate": "* Дата показания",
        "thMeterType": "Тип счетчика",
        "thLastRecorded": "Последняя запись",
        "noDescription": "Нет описания",
        "enterValue": "Введите значение...",
        "notAvailable": "Н/Д",
        "operator": "Оператор:",
        "btnCancel": "Отмена",
        "btnUpdate": "Обновить показания"
      },
      emailSettings: {
        "loadFailed": "Не удалось загрузить настройки",
        "saveSuccess": "Настройки почты успешно сохранены!",
        "saveFailed": "Не удалось сохранить настройки",
        "connecting": "Подключение к SMTP-серверу...",
        "connFailed": "Ошибка подключения!",
        "title": "Конфигурация SMTP",
        "subtitle": "Настройки почтового сервера",
        "outgoingTitle": "Исходящая почта (SMTP - Отправка)",
        "incomingTitle": "Входящая почта (IMAP - Мониторинг)",
        "lblHost": "Хост SMTP",
        "lblPort": "Порт SMTP",
        "lblUser": "Имя пользователя / Эл. почта SMTP",
        "lblPass": "Пароль SMTP",
        "lblSender": "Эл. почта отправителя системы (От)",
        "lblImapHost": "Хост IMAP",
        "lblImapPort": "Порт IMAP",
        "enableImap": "Включить мониторинг входящих (Радар RFQ)",
        "imapDesc": "Автоматическое получение и анализ предложений поставщиков из почтового ящика.",
        "gmailNote": "Для Gmail используйте «Пароль приложения» из Google Security. Пароли учетных записей не будут работать при включенной 2FA.",
        "btnTest": "ТЕСТ",
        "btnCancel": "ОТМЕНА",
        "btnSave": "СОХРАНИТЬ КОНФИГУРАЦИЮ"
      },
      locationDetails: {
        "noBimModel": "С этой локацией не связана 3D-модель",
        "noBimLinked": "Эта локация не связана с BIM",
        "locMandatory": "Локация — обязательное поле!",
        "saving": "Сохранение изменений...",
        "saveSuccess": "Локация успешно сохранена",
        "saveFailed": "Ошибка сохранения:",
        "deleteTitle": "Вы уверены?",
        "deleteText": "Вы собираетесь удалить локацию {{id}}. Это действие нельзя отменить!",
        "btnYesDelete": "Да, удалить!",
        "btnCancel": "Отмена",
        "deleting": "Удаление локации...",
        "deleteSuccess": "Локация успешно удалена",
        "deleteFailed": "Ошибка удаления!",
        "uploadingRevit": "Загрузка и трансляция модели Revit...",
        "revitSuccess": "Модель успешно связана!",
        "uploadFailed": "Ошибка загрузки:",
        "loadingCtx": "ЗАГРУЗКА КОНТЕКСТА ЛОКАЦИИ...",
        "tooltipChangeStatus": "Изменить статус",
        "tooltipStatusHistory": "История статусов",
        "tooltipDelete": "Удалить",
        "btnSave": "СОХРАНИТЬ",
        "lblLocation": "Локация",
        "lblDescription": "Описание",
        "btnRevitLinked": "Связан с Revit",
        "tabLocation": "Локация",
        "tabAssets": "Активы",
        "tabSpecs": "Спецификации",
        "tabSafety": "Безопасность",
        "tabMeters": "Счетчики",
        "tab3D": "3D-вид",
        "tabHistory": "История",
        "secIdentity": "Идентификация локации",
        "lblStatus": "Статус",
        "lblType": "Тип",
        "lblParentLoc": "Родительская локация",
        "lblSiteID": "ID участка",
        "secGeoInfo": "Географическая информация и адрес",
        "lblServiceAddr": "Адрес обслуживания",
        "lblBimSpaceId": "ID пространства BIM",
        "lblGisCoords": "Координаты GIS",
        "secRefImage": "Эталонное изображение",
        "btnUploadPhoto": "Загрузить фото",
        "thAssetNum": "Номер актива",
        "thStatus": "Статус",
        "lblClass": "Классификация",
        "thAttr": "Атрибут",
        "thDesc": "Описание",
        "thValue": "Значение",
        "titleHazards": "Зарегистрированные опасности в этой локации",
        "btnAddHazard": "Добавить опасность",
        "lblSelectHazards": "Выбрать опасности",
        "thHazard": "Опасность",
        "thPrecaution": "Меры предосторожности",
        "titleLocMeters": "Счетчики локации",
        "showingMeters": "Показано {{current}} из {{total}}",
        "noMetersDef": "Счетчики не определены",
        "thSeq": "Посл",
        "thMeterNum": "Номер счетчика",
        "thType": "Тип",
        "thUOM": "Ед. изм.",
        "thActive": "Активен",
        "newMeter": "НОВЫЙ_СЧЕТЧИК",
        "clickNewRow": "Нажмите «Новая строка», чтобы добавить счетчик",
        "titleMeterConfig": "Конфигурация сведений о счетчике",
        "newEntry": "Новая запись",
        "lblMeterNum": "* Номер счетчика",
        "lblMeterType": "Тип счетчика",
        "lblUOM": "Единица измерения",
        "lblMeterActive": "Счетчик активен",
        "lblLastReading": "Последнее показание",
        "lblReadingDate": "Дата показания",
        "lblInspector": "Инспектор счетчика",
        "lblRemarks": "Замечания / Комментарии",
        "placeholderRemarks": "Введите технические примечания об этом счетчике...",
        "btnAddMeterRow": "Добавить новую строку счетчика",
        "titleModelStatus": "Статус модели",
        "statusLinked": "СВЯЗАНА И АКТИВНА",
        "statusNotLinked": "НЕ СВЯЗАНА",
        "btnUploadRevit": "Загрузить Revit (.rvt)",
        "titleHistory": "История транзакций и журнал аудита",
        "lblChangedBy": "Изменено:",
        "failedFetchAttr": "Не удалось получить атрибуты"
      },
      "locationList": {
        "loadFailed": "Не удалось загрузить локации с сервера.",
        "title": "Локации",
        "searchPlaceholder": "Глобальный поиск...",
        "btnClearAll": "Очистить все",
        "btnExport": "Экспорт",
        "btnNewLocation": "Новая локация",
        "thLocationId": "ID Локации",
        "thDescription": "Описание",
        "thType": "Тип",
        "thStatus": "Статус",
        "thSite": "Участок",
        "optAll": "ВСЕ",
        "optOperating": "РАБОТАЕТ",
        "optDecommissioned": "СПИСАН",
        "fetchingData": "Получение данных с сервера...",
        "noRecords": "Совпадающих записей не найдено.",
        "recordsFound": "Найдено записей:",
        "page": "Страница:"
      },
      "universalLookup": {
        "selectValue": "Выберите значение:",
        "total": "Всего",
        "searchPlaceholder": "Поиск по коду или описанию...",
        "valueCode": "Значение / Код",
        "description": "Описание",
        "site": "Участок",
        "synchronizing": "Синхронизация...",
        "noRecords": "Совпадающих записей не найдено.",
        "loadingMore": "Загрузка дополнительных записей...",
        "results": "Результаты:",
        "cancel": "Отмена"
      },
      "statusHistory": {
        "title": "Журнал аудита статусов",
        "loading": "ЗАГРУЗКА ИСТОРИИ...",
        "noRecords": "Для этого элемента не зарегистрировано изменений статуса.",
        "initial": "НАЧАЛЬНЫЙ",
        "btnClose": "Закрыть"
      },
      "personalInfo": {
        "updateSuccess": "Профиль успешно обновлен",
        "sessionExpired": "Сеанс истек, пожалуйста, войдите снова",
        "updateFailed": "Ошибка обновления",
        "title": "Личная информация и настройки по умолчанию",
        "lblDisplayName": "Полное имя для отображения",
        "lblEmail": "Адрес электронной почты",
        "lblDefaultOrg": "Организация по умолчанию",
        "selectOrg": "Выберите организацию...",
        "lblDefaultSite": "Участок по умолчанию",
        "selectSite": "Выберите участок...",
        "lblDefaultLang": "Язык по умолчанию",
        "btnCancel": "Отмена",
        "btnSave": "Применить и сохранить",
        "securityTitle": "Безопасность и 2FA",
        "enable2FA": "Включить двухфакторную аутентификацию (2FA)",
        "googleAuth": "Google Authenticator",
        "emailOTP": "OTP по электронной почте",
        "configure2FA": "Настроить 2FA",
        "scanQR": "Отсканируйте этот QR-код с помощью Google Authenticator или Authy, затем введите 6-значный код ниже для проверки.",
        "btnVerify": "Проверить",
        "setupSuccess": "Настройка 2FA выполнена успешно!",
        "invalidCode": "Неверный код проверки",
        "failedQR": "Не удалось сгенерировать QR-код"
      },
      "appSettings": {
        "savingSettings": "Сохранение настроек...",
        "saveSuccess": "Настройки успешно обновлены!",
        "saveFailed": "Не удалось сохранить настройки.",
        "title": "Конфигурация предприятия",
        "org": "Организация",
        "tabs": {
          "WORKORDER": "Рабочие задания",
          "ASSET": "Реестр активов",
          "INVENTORY": "Склад и запасы",
          "PURCHASE": "Закупки",
          "PR": "Заявки на закупку (PR)",
          "JP": "Техкарты (JP)",
          "PM": "ТОиР (PM)",
          "MR": "Заявки на материалы (MR)",
          "SR": "Заявки на обслуживание (SR)"
        },
        "systemRules": "Системные правила: {{tab}}",
        "prefix": "Префикс последовательности",
        "preview": "Предварительный просмотр",
        "seed": "Начальное значение (Seed)",
        "valuationStrategy": "Стратегия оценки",
        "movingAvg": "Скользящее среднее (Рекомендуется)",
        "fifo": "Первым пришел - первым ушел (FIFO)",
        "lifo": "Последним пришел - первым ушел (LIFO)",
        "allowNegative": "Разрешить отрицательный баланс",
        "negativeWarning": "Внимание: Влияет на финансовую точность",
        "encrypting": "Шифрование и передача...",
        "auditLogged": "Все изменения фиксируются в журнале аудита",
        "btnCancel": "Отмена",
        "btnSave": "Сохранить системную политику"
      },
      "workflowAction": {
        "successMove": "Рабочий процесс успешно перенаправлен! 🚀",
        "failedMove": "Ошибка действия",
        "btnRoute": "Направить процесс",
        "modalTitle": "ДЕЙСТВИЕ РАБОЧЕГО ПРОЦЕССА",
        "assignedAs": "Назначено вам как:",
        "defaultInstruction": "Пожалуйста, рассмотрите и примите меры.",
        "lblChoosePath": "Выберите путь",
        "valSelectPath": "Пожалуйста, выберите путь",
        "optApprove": "УТВЕРДИТЬ / ДАЛЕЕ",
        "optReject": "ОТКЛОНИТЬ / ВЕРНУТЬ",
        "lblMemo": "Заметка / Комментарии",
        "placeholderMemo": "Добавьте свои комментарии здесь...",
        "btnCancel": "Отмена",
        "btnComplete": "ЗАВЕРШИТЬ ШАГ"
      },
      "meterHistory": {
        "title": "Исторические показания счетчиков",
        "lblAsset": "Актив",
        "fetching": "Извлечение архивов...",
        "noRecords": "Исторические показания для этого актива не найдены.",
        "thMeterName": "Имя счетчика",
        "thReadingVal": "Значение показания",
        "thReadingDate": "Дата показания",
        "thEnteredBy": "Введено пользователем",
        "thEntryDate": "Дата ввода",
        "btnClose": "Закрыть историю",
        "lblLocation": "Локация",
        "noRecordsLoc": "Исторические показания для этой локации не найдены.",
      },
      rpt_print: "Печать отчетов",
      no_templates: "Шаблоны отсутствуют",
      "wo": {
        "tabs": { "workOrder": "Заказ-наряд", "plans": "Планы", "assignments": "Назначения", "actuals": "Фактические", "safety": "Безопасность", "failure": "Отчет об отказе" },
        "subTabs": { "tasks": "Задачи", "labor": "Труд", "materials": "Материалы", "tools": "Инструменты", "services": "Услуги" },
        "headers": { "workOrder": "Заказ-наряд", "status": "Статус", "totalCost": "Общая стоимость", "activeSla": "АКТИВНЫЙ МОНИТОРИНГ SLA", "targetRes": "ЦЕЛЕВОЕ РЕШЕНИЕ", "targetResp": "ЦЕЛЕВОЙ ОТВЕТ" },
        "sections": { "assetDetails": "Сведения об активе", "scheduling": "Информация о расписании", "responsibility": "Ответственность", "laborAssign": "Назначения", "totalAssign": "Всего назначений" },
        "fields": { "description": "Описание", "location": "Местоположение", "asset": "Актив", "workType": "Тип работы", "safetyCode": "Код безопасности", "supervisor": "Руководитель", "failureClass": "Класс отказа", "targStart": "Целевое начало", "targFinish": "Целевое завершение", "schedStart": "Запланированное начало", "schedFinish": "Запланированное завершение", "earlyStart": "Начать не раньше", "lateFinish": "Закончить не позднее", "actStart": "Фактическое начало", "actFinish": "Фактическое завершение", "duration": "Длительность", "timeRemaining": "Оставшееся время", "predecessors": "Предшественники", "includeTasks": "Включить задачи в расписание?", "site": "Сайт", "organization": "Организация", "priorityHigh": "Приоритет: Высокий" },
        "actions": { "routeWorkflow": "Маршрут процесса", "wfHistory": "История процесса", "changeStatus": "Изменить статус", "attachments": "Вложения", "printWO": "Печать", "printSafety": "Паспорт безопасности", "history": "История", "newTask": "Новая задача", "selectLoc": "Выбрать место", "selectAsset": "Выбрать актив", "selectType": "Выбрать тип", "selectSafety": "Выбрать план безопасности", "selectSup": "Выбрать руководителя", "selectFail": "Выбрать класс", "selectCraft": "Выбрать специальность", "selectLabor": "Выбрать работника", "selectItem": "Выбрать позицию", "selectStore": "Выбрать склад", "selectTool": "Выбрать инструмент", "addLabor": "Добавить труд", "addMaterial": "Добавить материал", "addTool": "Добавить инструмент", "addService": "Добавить услугу", "newAssign": "Новое назначение", "compAssign": "Завершить назначение", "createMR": "Создать заявку", "yesCreate": "Да, создать", "yesChange": "Да, изменить", "approve": "Утвердить", "cancel": "Отменить", "startWork": "Начать работу", "close": "Закрыть", "complete": "Завершить", "selectProblem": "Выбрать проблему", "selectCause": "Выбрать причину", "selectRemedy": "Выбрать решение" },
        "tables": { "sequence": "Посл.", "taskDesc": "Описание задачи", "estDur": "Ожидаемая длительность", "status": "Статус", "craft": "Специальность", "labor": "Работник", "qty": "Кол-во", "hrs": "Часы", "rate": "Ставка", "lineCost": "Стоимость строки", "lineType": "Тип строки", "itemNum": "Номер позиции", "description": "Описание", "unitCost": "Стоимость единицы", "storeroom": "Склад", "item": "Товар", "material": "Материал", "toolNum": "Номер инстр.", "serviceDesc": "Описание услуги", "vendor": "Поставщик", "cost": "Стоимость", "start": "Начало", "finish": "Конец", "failCode": "Код отказа" },
        "footer": { "totalLabor": "Всего труд", "totalMaterial": "Всего материалы", "assigned": "Назначено (оценка)", "toolsServ": "Инструменты и услуги", "totalActual": "Фактическая общая стоимость" },
        "safety": { "hazardsTitle": "Опасности и меры предосторожности", "hazardCode": "Код опасности", "hazardDesc": "Описание опасности", "precautions": "Требуемые меры", "noHazards": "Опасности не выявлены.", "lotoTitle": "Блокировка / маркировка (LOTO)", "step": "Шаг", "tagNum": "Номер бирки", "isoDesc": "Описание изоляции", "reqState": "Требуемое состояние", "completed": "Завершено?", "noLoto": "Шаги изоляции не требуются." },
        "failure": { "title": "Анализ отказов", "currClass": "Текущий класс", "notDefined": "НЕ ОПРЕДЕЛЕН", "problems": "ПРОБЛЕМЫ", "causes": "ПРИЧИНЫ", "remedies": "РЕШЕНИЯ", "records": "ЗАПИСИ" },
        "placeholders": { "desc": "Введите описание...", "taskDesc": "ОПИСАНИЕ ЗАДАЧИ..." },
        "messages": { "loadError": "Ошибка загрузки", "taskStatusLocal": "Статус задачи обновлен", "selectItemStore": "Выберите позицию и склад", "duplicateReqTitle": "Дублирующая заявка", "duplicateReqText": "Заявка на {{item}} существует. Создать еще?", "creatingMR": "Создание заявки...", "mrCreated": "Заявка {{num}} создана", "mrFail": "Не удалось создать заявку", "confirmStatusChange": "Изменить статус {{wonum}} на {{status}}?", "statusSuccess": "Статус изменен", "statusFail": "Не удалось изменить статус", "saving": "Сохранение...", "deleteConfirm": "Удалить {{wonum}}? Это действие необратимо!", "saveBeforeSLA": "Сначала сохраните заказ-наряд", "slaExists": "SLA уже применен!", "matchingSLA": "Поиск SLA...", "slaApplied": "SLA применен", "noMatchingSLA": "SLA не найден", "slaError": "Ошибка SLA-движка", "failureTreeLoaded": "Коды отказов применены", "zeroBalance": "Внимание: Нулевой баланс на складе {{store}}", "balanceOk": "Цена получена: {{cost}} - Остаток: {{bal}}", "storeError": "Ошибка связи со складом", "assetLinked": "Актив привязан: {{asset}}", "openAssignError": "Невозможно закрыть: {{count}} назначений не завершено.", "budgetExceeded": "Бюджет превышен!", "assignComplete": "Назначение завершено", "actionNotAllowed": "Действие недоступно для статуса {{status}}", "locked": "Заблокировано", "cantChangeCancel": "Отмененные запросы не могут менять статус", "printFail": "Не удалось создать PDF-файл", "wfRouted": "Маршрут процесса успешно задан! 🚀", "wfFail": "Не удалось задать маршрут", "taskStatusChanged": "Статус задачи {{task}} изменен на {{status}}", "noLaborAssign": "Труд не назначен.", "updateTaskProg": "Обновить прогресс задач", "noMaterials": "Материалов нет. Нажмите для добавления.", "linkedMRs": "Связанные заявки на материалы", "stocknobalance": "⚠️ Внимание: на складе этот товар находится (нулевой) остаток." },
        "linearDefect": {
          "title": "Расположение линейного дефекта",
          "startMeasure": "Начальная мера",
          "endMeasure": "Конечная мера (Необязательно)",
          "unit": "Единица",
          "yOffset": "Смещение по Y (м)"
        },
        "costs": {
          "title": "Затраты на наряд-заказ",
          "estimated": "Оценочные затраты",
          "actual": "Фактические затраты",
          "labor": "Труд",
          "materials": "Материалы",
          "tools": "Инструменты",
          "services": "Услуги",
          "total": "Итого",
          "variance": "Отклонение (Факт - Оценка)",
          "calculating": "Вычисление...",
          "no_data": "Нет данных."
        },
        "purchase_info": {
          "title": "Связанная информация о закупках",
          "mr_title": "Заявки на материалы (MR)",
          "pr_title": "Заявки на закупку (PR)",
          "po_title": "Заказы на закупку (PO)",
          "mr_num": "Номер MR",
          "pr_num": "Номер PR",
          "po_num": "Номер PO",
          "vendor": "Поставщик",
          "status": "Статус",
          "req_date": "Требуемая дата",
          "total_cost": "Общая стоимость",
          "fetching": "Получение данных...",
          "no_records": "Записи не найдены."
        },
    
      },
      "pm": {
        "tabs": { "pm": "ТО", "frequency": "Частота", "sequence": "Последовательность", "seasonaldates": "Сезонность", "forecast": "Прогноз" },
        "sections": { "assetLoc": "Актив и Расположение", "defaults": "Настройки", "compliance": "Соответствие", "siteContext": "Информация о сайте", "timeBased": "Временной интервал", "meters": "Счетчики", "sequences": "Последовательности", "seasonal": "Еженедельный график", "projections": "Журналы прогнозов" },
        "fields": { "pmNum": "Номер ТО", "description": "Описание", "status": "Статус", "site": "Сайт", "asset": "Актив", "location": "Местоположение", "route": "Маршрут", "counter": "Счетчик", "jpnum": "Тех. карта", "worktype": "Тип работы", "supervisor": "Руководитель", "glaccount": "Счет ГК", "woStatus": "Статус по умолчанию", "priority": "Приоритет", "lastStart": "Последний запуск", "lastComp": "Последнее завершение", "nextDue": "Следующий срок", "forecastFlag": "Флаг прогноза", "org": "Организация", "freqInt": "Интервал", "freqUnit": "Единица", "targStart": "Целевое время" },
        "headers": { "masterDir": "Главный каталог ТО" },
        "placeholders": { "desc": "Введите описание...", "globalSearch": "Глобальный умный поиск..." },
        "actions": { "forecast": "ПРОГНОЗ", "savePM": "СОХРАНИТЬ", "addMeter": "ДОБАВИТЬ", "addStep": "ШАГ", "newPM": "Новая запись ТО" },
        "tables": { "meterName": "Счетчик", "freq": "Частота", "nextProj": "След. прогноз", "seq": "Посл.", "jpnum": "Тех. карта", "fcDate": "Дата", "targetJp": "Целевая карта", "estCost": "Стоимость", "status": "Статус", "woNum": "Номер ЗН", "generated": "СОЗДАНО", "projected": "ПРОГНОЗ" },
        "messages": { "executingForecast": "Расчет...", "forecastSuccess": "Успешно", "forecastFail": "Ошибка", "seasonalInfo": "Отмеченные дни разрешены.", "noMeters": "Нет счетчиков.", "noSeq": "Последовательность отключена.", "noForecasts": "Нет прогнозов.", "showingProjections": "Показано {{count}} записей", "fetchListError": "Не удалось загрузить записи ТО", "syncingList": "Синхронизация с сервером...", "noRecords": "Записи не найдены." },
        "footer": { "dbTotal": "Всего в базе данных:", "currentPage": "Текущая страница:", "useNavArrows": "Используйте стрелки" }
      },
      "workflowHistory": {
        "title": "Журнал процесса",
        "trackingId": "ID отслеживания:",
        "fetching": "Получение записей...",
        "currentTask": "Текущая активная задача",
        "since": "С:",
        "by": "от",
        "noHistory": "История для этой транзакции еще не записана",
        "closeBtn": "Закрыть историю"
      },
      "pr": {
        "headers": { "prList": "Запросы на закупку" },
        "actions": { "newPR": "НОВЫЙ ЗАПРОС", "clearFilters": "ОЧИСТИТЬ ФИЛЬТРЫ", "routeWf": "МАРШРУТ ПРОЦЕССА" },
        "tabs": { "pr": "Запрос", "prlines": "Строки запроса" },
        "sections": { "general": "Общая информация", "financial": "Финансовая сводка" },
        "fields": { "prNum": "Номер запроса", "requestedBy": "Кем запрошено", "reqDate": "Требуемая дата", "refMr": "Связанная заявка", "vendor": "Поставщик", "glAccount": "Счет ГК" },
        "financial": { "subtotal": "Подытог", "taxTotal": "Сумма налога", "grandTotal": "Итоговая сумма" },
        "tables": { "prNum": "Номер запроса", "description": "Описание", "status": "Статус", "totalCost": "Общая стоимость", "reqDate": "Дата запроса", "site": "Участок", "itemNum": "Номер позиции", "itemType": "Тип", "qty": "Кол-во", "unitCost": "Цена за ед.", "tax": "Налог", "lineTotal": "Итого по строке", "taxCat": "Кат. налога" },
        "messages": { "loadFailed": "Не удалось загрузить запросы", "syncing": "Синхронизация...", "noData": "Нет данных", "noLines": "Строки пока не добавлены.", "fetchingMRLines": "Загрузка строк из заявки: {{mrnum}}...", "loadedMRLines": "Загружено {{count}} строк", "noMRLines": "В заявке нет строк", "failedMRLines": "Не удалось загрузить строки" },
        "swal": { "lockedTitle": "Заблокировано", "cantDeleteStatus": "Невозможно удалить со статусом: {{status}}", "cantChangeCancel": "Отмененные запросы не могут менять статус", "deleteWarnText": "Это навсегда удалит запрос и все его строки." },
        "placeholders": { "desc": "Введите описание...", "globalSearch": "Глобальный умный поиск..." },
        "footer": { "showing": "Показано", "totalRecords": "Всего записей" }
      },
      "po": {
        "headers": { "poList": "Заказы на закупку" },
        "actions": { "newPO": "НОВЫЙ ЗАКАЗ", "clearFilters": "ОЧИСТИТЬ ФИЛЬТРЫ", "routeWf": "МАРШРУТ ПРОЦЕССА", "addManualRow": "ДОБАВИТЬ СТРОКУ ВРУЧНУЮ", "wfHistory": "История процесса" },
        "tabs": { "po": "Заказ", "polines": "Строки заказа" },
        "sections": { "general": "Общая информация", "financial": "Финансовая сводка", "lines": "Строки заказа на закупку" },
        "fields": { "poNum": "Номер заказа", "requestedBy": "Кем запрошено", "orderDate": "Дата заказа", "refPr": "Связанная заявка", "vendor": "Поставщик", "glAccount": "Счет ГК" },
        "financial": { "subtotal": "Подытог (нетто)", "taxTotal": "Сумма налога", "grandTotal": "Итоговая сумма" },
        "tables": { "poNum": "Номер заказа", "totalCost": "Общая стоимость", "orderDate": "Дата заказа", "itemNum": "Номер позиции", "itemType": "Тип", "unitCost": "Цена за ед.", "tax": "Налог", "lineTotal": "Итого по строке", "taxCat": "Кат. налога" },
        "messages": { "loadFailed": "Не удалось загрузить заказы", "syncing": "Синхронизация...", "noData": "Подходящие заказы не найдены", "noLines": "Строки пока не добавлены.", "vendorRequired": "Поставщик обязателен для сохранения.", "fetchingLines": "Загрузка строк для: {{num}}...", "loadedLines": "Успешно загружено {{count}} строк", "noLinesFound": "В документе нет строк", "failedLines": "Не удалось загрузить строки", "cantChangeCancel": "Отмененные запросы не могут менять статус", "cantDeleteStatus": "Невозможно удалить со статусом: {{status}}" },
        "swal": { "deleteWarnText": "Это навсегда удалит заказ и все его строки." },
        "placeholders": { "desc": "Введите описание...", "globalSearch": "Глобальный умный поиск..." },
        "footer": { "showing": "Показано" }
      },
      "mr": {
        "headers": { "mrList": "Заявки на материалы" },
        "actions": { "newMR": "НОВАЯ ЗАЯВКА", "clearFilters": "ОЧИСТИТЬ ФИЛЬТРЫ", "routeWf": "МАРШРУТ ПРОЦЕССА", "createUsage": "СОЗДАТЬ РАСХОД", "createUsageDesc": "Создать запись о выдаче/перемещении", "createPR": "СОЗДАТЬ ЗАЯВКУ", "createPRDesc": "Создать заявку на закупку", "addMaterial": "Добавить материал" },
        "tabs": { "mr": "Инфо", "mrlines": "Строки заявки" },
        "sections": { "general": "Общая информация", "financial": "Финансовая сводка", "mrItems": "Позиции заявки на материалы", "financialCharging": "Детали финансового учета" }, 
        "fields": { "mrNum": "Номер заявки", "requestedBy": "Кем запрошено", "reqDate": "Требуемая дата", "refMr": "Связанная заявка", "vendor": "Поставщик", "glAccount": "Счет ГК", "targetStore": "Целевой склад", "chargeLoc": "Счет локации", "chargeAsset": "Счет актива", "chargeWO": "Счет ЗН" },
        "financial": { "subtotal": "Подытог", "taxTotal": "Сумма налога", "grandTotal": "Итого" },
        "tables": { "mrNum": "Номер заявки", "description": "Описание", "status": "Статус", "totalCost": "Общая стоимость", "enteredDate": "Дата ввода", "site": "Участок", "itemNum": "Номер позиции", "itemType": "Тип", "qty": "Кол-во", "unitCost": "Цена", "tax": "Налог", "lineTotal": "Итого по строке", "taxCat": "Кат. налога", "stockItem": "Складская позиция", "qtyReq": "Запрош. кол-во", "estUnitCost": "Оцен. цена за ед." },
        "messages": { "loadFailed": "Не удалось загрузить заявки", "syncing": "Синхронизация...", "noData": "Нет данных", "noLines": "Строки пока не добавлены.", "fetchingMRLines": "Загрузка строк: {{mrnum}}...", "loadedMRLines": "Загружено {{count}} строк", "noMRLines": "В заявке нет строк", "failedMRLines": "Не удалось загрузить строки", "generating": "Создание {{docType}}...", "generatedSuccess": "{{docType}} {{docnum}} успешно создано!", "generateFail": "Не удалось создать {{docType}}", "storeRequired": "Требуется склад!", "dateRequired": "Требуемая дата обязательна!" }, 
        "swal": { "lockedTitle": "Заблокировано", "cantDeleteStatus": "Невозможно удалить со статусом: {{status}}", "cantChangeCancel": "Отмененные запросы не могут менять статус", "deleteWarnText": "Это навсегда удалит заявку и все ее строки." },
        "placeholders": { "desc": "Введите описание...", "globalSearch": "Глобальный поиск...", "chooseLoc": "ВЫБРАТЬ ЛОКАЦИЮ", "selectAsset": "ВЫБРАТЬ АКТИВ", "chargeWO": "ОТНЕСТИ НА ЗН" }, 
        "lookups": { "storerooms": "Склады", "inventory": "Поиск по складу", "locations": "Местоположения", "assets": "Реестр активов", "workorders": "Заказ-наряды" },
        "footer": { "showing": "Показано", "totalRecords": "Всего" }
      },
      "contract": {
        "headers": { "masterNode": "Узел контрактов" },
        "placeholders": { "globalSearch": "Глобальный поиск...", "desc": "Введите сводку...", "termDesc": "Детали условия..." },
        "actions": { "newContract": "НОВЫЙ КОНТРАКТ", "save": "СОХРАНИТЬ", "addTerm": "ДОБАВИТЬ УСЛОВИЕ", "addLine": "ДОБАВИТЬ СТРОКУ", "wfHistory": "История процесса" },
        "tabs": { "general": "Общие", "slaperformance": "SLA (Оценка)", "termslegal": "Условия и Право", "contractlines": "Строки контракта" },
        "sections": { "identity": "Идентификация и Срок", "communication": "Связь", "auditInfo": "Инфо аудита", "masterSLA": "Привязка SLA", "slaBenchmarks": "Показатели SLA", "termsList": "Юридические условия", "lines": "Объем работ / Строки" },
        "options": { "supply": "Поставка", "labor": "Услуги/Труд", "lease": "Аренда", "allTypes": "ВСЕ ТИПЫ", "allStatus": "ВСЕ СТАТУСЫ", "general": "ОБЩЕЕ", "payment": "ОПЛАТА", "termination": "РАСТОРЖЕНИЕ", "warranty": "ГАРАНТИЯ", "liability": "ОТВЕТСТВЕННОСТЬ" },
        "fields": { "contractNum": "Номер", "vendorRef": "Поставщик", "startDate": "Дата начала", "endDate": "Дата окончания", "contractValue": "Сумма контракта", "currency": "Валюта", "contactPerson": "Контактное лицо", "vendorEmail": "Email поставщика", "slaRef": "Ссылка SLA", "respTime": "Время реакции (ч)", "resTime": "Время решения (ч)", "uptime": "Доступность (%)", "penalty": "Штраф (в час)", "grandTotal": "Итоговая сумма" },
        "tables": { "contractNum": "Номер", "grandTotal": "Итого", "clauseType": "Тип условия", "clauseDesc": "Описание условия", "lineDesc": "Описание строки", "rate": "Ставка", "lineTotal": "Итого по строке" },
        "messages": { "fetchError": "Ошибка синхронизации", "syncing": "Синхронизация...", "noData": "Контракты не найдены", "descMandatory": "Описание обязательно", "vendorSelected": "Поставщик {{name}} выбран", "noTerms": "Условия не заданы", "noLines": "Строки не заданы", "slaHint": "Привязка SLA применяет правила глобально." },
        "swal": { "deleteTitle": "Окончательное удаление?", "deleteText": "Контракт и все его строки будут удалены навсегда." },
        "footer": { "masterRecords": "Записи:", "currentPage": "Текущая страница:" }
      },
      "rfq": {
        "headers": { "rfqList": "Управление котировками" },
        "tabs": { "rfq": "Запрос", "rfqlines": "Строки запроса", "quotations": "Предложения" },
        "sections": { "general": "Общая информация", "financial": "Финансы" },
        "fields": { "requestedBy": "Запросил", "reqDate": "Требуемая дата", "refPr": "Связанная заявка", "vendor": "Поставщик", "vendorEmail": "Email поставщика", "glAccount": "Счет ГК" },
        "financial": { "subtotal": "Подытог", "taxTotal": "Налоги", "grandTotal": "Итого" },
        "tables": { "rfqNum": "Номер запроса", "totalCost": "Общая стоимость", "itemNum": "Номер позиции", "itemType": "Тип", "unitCost": "Цена за ед.", "tax": "Налог", "taxCat": "Кат. налога" },
        "options": { "awarded": "НАЗНАЧЕНО" },
        "actions": { "newRFQ": "НОВЫЙ ЗАПРОС", "sendEmail": "ОТПРАВИТЬ EMAIL", "wfHistory": "История процесса", "award": "УТВЕРДИТЬ И СОЗДАТЬ ЗАКАЗ" },
        "messages": { "loadFailed": "Ошибка загрузки", "syncing": "Синхронизация...", "noData": "Нет данных", "noLines": "Нет строк", "pullingPR": "Загрузка заявки...", "prImported": "Строки импортированы!", "prFailed": "Ошибка импорта", "noEmail": "Нет email!", "sending": "Создание PDF и отправка...", "sendSuccess": "Email отправлен!", "sendFailed": "Ошибка отправки", "quotesHint": "Входящие предложения появятся здесь автоматически.", "noQuotes": "Предложений пока нет.", "awarding": "Утверждение...", "awardSuccess": "Предложение утверждено!", "poCreated": "Заказ создан", "awardFailed": "Ошибка утверждения" },
        "swal": { "sendTitle": "Отправить запрос?", "sendText": "Отправить письмо поставщику {{vendor}}?", "awardTitle": "Утвердить предложение?", "awardText": "Будет автоматически создан Заказ на закупку (PO)." },
        "footer": { "showing": "Показано" }
      },
      "itemList": {
        "headers": { "master": "Номенклатура (Item Master)" },
        "actions": { "newItem": "Новая позиция" },
        "tables": { "item": "Номенклатура", "rotating": "Оборотный?" },
        "messages": { "syncFailed": "Ошибка синхронизации", "syncing": "Синхронизация...", "noData": "Позиции не найдены" },
        "footer": { "totalItems": "Всего позиций:", "page": "СТРАНИЦА" }
      },
      "itemDetails": {
        "tabs": { "item": "ТМЦ", "inventory": "ЗАПАСЫ", "vendors": "ПОСТАВЩИКИ", "specs": "ХАР-КИ", "assembly": "СБОРКА" },
        "sections": { "config": "Конфигурация", "units": "Единицы и учет", "bomList": "Спецификация (BOM)", "supplierHistory": "История поставок" },
        "actions": { "save": "СОХРАНИТЬ", "addStore": "НА СКЛАД", "newSpec": "НОВАЯ ХАР-КА", "addComponent": "ДОБ. КОМПОНЕНТ" },
        "fields": { "itemSet": "Набор ТМЦ", "rotating": "Оборотный?", "lotControl": "Партионный учет?", "inspectionReq": "Требует инспекции?", "orderUnit": "Ед. заказа", "issueUnit": "Ед. выдачи", "condition": "Учет состояния?", "sparepart": "Запчасть?", "classification": "Классификация" },
        "tables": { "store": "Склад", "avgCost": "Ср. стоимость", "balance": "Остаток", "attribute": "Атрибут", "value": "Значение", "uom": "Ед. изм.", "subItem": "Подчиненный ТМЦ", "remarks": "Заметки", "vendor": "Код поставщика", "supplierName": "Имя поставщика", "unitCost": "Цена за ед.", "refPO": "Связанный заказ", "activeVendors": "АКТИВНЫЕ ПОСТАВЩИКИ" },
        "messages": { "reqFields": "Номер и описание обязательны!", "fetchingAttributes": "Загрузка атрибутов...", "attributesLoaded": "Атрибуты загружены", "failedAttributes": "Ошибка загрузки", "stockMsgTitle": "ВНИМАНИЕ", "stockMsgDesc": "Изменение единиц повлияет на все склады.", "noInventory": "Нет записей о запасах.", "noSpecs": "Характеристики не заданы.", "noBom": "Спецификация (BOM) не задана.", "noVendors": "Поставщики не найдены." },
        "swal": { "deleteText": "ТМЦ {{num}} будет безвозвратно удален!" }
      },
      "changePassword": {
        "title": "Изменить пароль",
        "currentPwd": "Текущий пароль",
        "newPwd": "Новый пароль",
        "confirmPwd": "Подтвердите новый пароль",
        "securityTitle": "Проверка безопасности",
        "googleAuthMsg": "Введите 6-значный код из Google Authenticator, чтобы подтвердить это изменение.",
        "emailOtpMsg": "Код OTP был отправлен на вашу электронную почту.",
        "btnCancel": "Отмена",
        "btnUpdate": "Обновить пароль",
        "btnVerify": "Проверить и изменить",
        "btnBack": "Назад",
        "errMismatch": "Новые пароли не совпадают!",
        "errLength": "Пароль должен содержать не менее 6 символов.",
        "msgVerifyReq": "Пожалуйста, подтвердите свою личность, чтобы продолжить.",
        "msgSuccess": "Пароль успешно изменен!",
        "errFailed": "Не удалось изменить пароль."
      },
      "userDetails": {
        "titleNew": "НОВЫЙ ПОЛЬЗОВАТЕЛЬ",
        "titleEdit": "БЕЗОПАСНОСТЬ / ПОЛЬЗОВАТЕЛИ",
        "btnSave": "СОХРАНИТЬ",
        "saving": "СОХРАНЕНИЕ...",
        "secIdent": "Идентификация пользователя",
        "lblLoginId": "Логин пользователя",
        "lblFullName": "Полное имя",
        "lblDisplayName": "Отображаемое имя",
        "lblEmail": "Адрес электронной почты",
        "lblPassword": "Пароль",
        "lblActive": "Активный статус",
        "secAccess": "Безопасность и контроль доступа",
        "lblPrimaryRole": "Основная роль",
        "lblSecRoles": "Вторичные роли (Дополнительные)",
        "lblDefOrg": "Организация по умолчанию",
        "lblDefSite": "Сайт по умолчанию",
        "secDelegation": "Делегирование работы",
        "lblDelegateTo": "Делегировать работу",
        "lblStartDate": "Дата и время начала",
        "lblEndDate": "Дата и время окончания"
      },
      "receivingDetails": {
        "errLoadLines": "Не удалось загрузить строки заказа на закупку",
        "errMissingDist": "Пожалуйста, укажите склад и количество для всех строк",
        "errInspMandatory": "Решение по проверке ОБЯЗАТЕЛЬНО для этого товара",
        "errRejectExceeds": "Проверьте количество отклоненного (не может превышать прибывшее)",
        "msgSuccess": "Транзакция успешно обработана!",
        "msgAutoClosed": "Автоматически закрыто: ",
        "swalAssignTitle": "Назначение склада",
        "swalAssignText": "Товар {{item}} в настоящее время не привязан к {{loc}}. Привязать сейчас и завершить приемку?",
        "swalAssignBtn": "Да, привязать и завершить",
        "errUnexpected": "Произошла непредвиденная ошибка при приемке",
        "hubTitle": "Центр массовой приемки",
        "poRef": "ССЫЛКА НА ЗАКАЗ: ",
        "btnExecuting": "ВЫПОЛНЕНИЕ...",
        "btnConfirm": "ПОДТВЕРДИТЬ ПРИЕМКУ",
        "tblItemsPending": "Ожидающие приемки товары",
        "colItemDetails": "Детали товара",
        "colBalance": "Остаток",
        "lblQualityCheck": "ТРЕБУЕТСЯ ПРОВЕРКА КАЧЕСТВА",
        "lblUnits": "Ед.",
        "msgNoPending": "Ожидающие товары не найдены",
        "lblLandedCost": "Полная стоимость (Все доп. расходы)",
        "lblBaseCost": "Базовая цена за ед. по заказу",
        "lblStoreMatrix": "Матрица распределения по складам",
        "btnSplitStore": "Разделить склад",
        "colStoreroom": "Склад",
        "colArrived": "Прибыло",
        "colRejected": "Отклонено",
        "plcClickSearch": "Нажмите для поиска ->",
        "lookupSelectStore": "Выберите склад",
        "lblQcMatrix": "Матрица принятия решений контроля качества",
        "optSelectDecision": "-- Обязательно: Выберите решение --",
        "optPassed": "ПОЛНОСТЬЮ ПРОШЕЛЬ (ПРИНЯТЬ ВСЕ)",
        "optFailed": "ПОЛНОСТЬЮ ОТКЛОНЕНО (ВЕРНУТЬ ПОСТАВЩИКУ)",
        "optPartial": "ЧАСТИЧНОЕ ПРИНЯТИЕ (СМ. ПОЛЕ ОТКЛОНЕННОГО)",
        "lblInvValuation": "Оценка запасов (Средняя стоимость единицы)",
        "lblNetArrived": "Чистый прибывший запас",
        "msgSelectLine": "Выберите активную строку заказа для начала обработки"
      },
      "userList": {
        "title": "БЕЗОПАСНОСТЬ ПОЛЬЗОВАТЕЛЕЙ",
        "plcSearch": "Поиск пользователя или Email...",
        "btnNewUser": "НОВЫЙ ПОЛЬЗОВАТЕЛЬ",
        "colUserId": "ID ПОЛЬЗОВАТЕЛЯ",
        "colFullName": "ПОЛНОЕ ИМЯ",
        "colRole": "РОЛЬ",
        "colSite": "САЙТ",
        "colStatus": "СТАТУС",
        "colEmail": "EMAIL",
        "msgSyncing": "Синхронизация безопасности...",
        "lblNoRole": "НЕТ РОЛИ",
        "lblAll": "ВСЕ",
        "lblTotalUsers": "ВСЕГО ПОЛЬЗОВАТЕЛЕЙ:",
        "lblPage": "СТРАНИЦА",
        "errLoadUsers": "Ошибка загрузки пользователей"
      },
      "crafts": {
        "headers": {
          "craftList": "Справочник профессий"
        },
        "actions": {
          "newCraft": "Новая профессия"
        },
        "tables": {
          "craftCode": "Код профессии",
          "description": "Описание",
          "stdRate": "Станд. ставка/час",
          "site": "Сайт",
          "org": "Организация"
        },
        "messages": {
          "loadFailed": "Не удалось загрузить профессии"
        },
        "headers": {
          "craftList": "Справочник профессий"
        },
        "tabs": {
          "skills": "Навыки и уровни"
        },
        "sections": {
          "costing": "Затраты",
          "control": "Контроль"
        },
        "actions": {
          "newCraft": "Новая профессия",
          "addSkill": "Добавить уровень навыка"
        },
        "tables": {
          "craftCode": "Код профессии",
          "description": "Описание",
          "stdRate": "Станд. ставка/час",
          "site": "Сайт",
          "org": "Организация"
        },
        "fields": {
          "stdHourlyRate": "Стандартная почасовая ставка",
          "skillLevel": "Уровень навыка (напр., Эксперт, Младший)",
          "hourlyRate": "Почасовая ставка"
        },
        "placeholders": {
          "enterLevel": "ВВЕДИТЕ УРОВЕНЬ..."
        },
        "messages": {
          "loadFailed": "Не удалось загрузить профессии",
          "autoCalc": "Рассчитывается автоматически из суммы навыков",
          "noSkills": "Навыки еще не определены"
        }
      },
      "persons": {
        "headers": {
          "directory": "Справочник персонала"
        },
        "actions": {
          "newPerson": "Новый сотрудник"
        },
        "tables": {
          "personId": "ID сотрудника",
          "name": "Отображаемое имя",
          "site": "Сайт",
          "email": "Email",
          "phone": "Телефон"
        },
        "messages": {
          "loadFailed": "Ошибка при загрузке списка персонала"
        },
        "headers": {
          "directory": "Справочник персонала"
        },
        "tabs": {
          "profile": "Профиль",
          "contact": "Контакты",
          "access": "Доступ к системе"
        },
        "sections": {
          "personalInfo": "Личная информация",
          "statusControl": "Статус и контроль",
          "contactsDirectory": "Связанные контакты"
        },
        "tables": {
          "personId": "ID сотрудника",
          "name": "Отображаемое имя",
          "site": "Сайт",
          "email": "Email",
          "phone": "Телефон"
        },
        "fields": {
          "location": "Локация",
          "firstName": "Имя",
          "lastName": "Фамилия",
          "title": "Должность",
          "department": "Отдел",
          "currentStatus": "Текущий статус",
          "contactName": "Имя контакта",
          "position": "Должность",
          "email": "Email адрес",
          "phone": "Телефон",
          "mobile": "Мобильный",
          "primary": "Основной",
          "address": "Адрес",
          "city": "Город",
          "country": "Страна",
        },
        "actions": {
          "newPerson": "Новый сотрудник",
          "addContact": "Добавить контакт"
        },
        "messages": {
          "loadFailed": "Ошибка при загрузке списка персонала",
          "noContacts": "Контакты еще не добавлены",
          "accessControlled": "Доступ к системе контролируется модулем безопасности пользователей"
        }
      },
      "jp": {
        "list": {
          "title": "Справочник рабочих планов",
          "new_plan": "НОВЫЙ ПЛАН",
          "filter_jp": "Фильтр планов...",
          "search_desc": "Поиск по описанию...",
          "filter_site": "Сайт...",
          "no_records": "Рабочие планы не найдены",
          "fetch_error": "Не удалось загрузить рабочие планы"
        },
        "fields": {
          "jpnum": "№ плана",
          "description": "Описание",
          "status": "Статус",
          "revision": "Редакция",
          "site": "Сайт"
        },
        "details": {
          "load_error": "Не удалось загрузить рабочий план",
          "delete_warn": "Вы собираетесь удалить рабочий план {{jpnum}}. Это действие нельзя отменить!"
        },
        "tabs": {
          "job_plan": "Рабочий План",
          "plans": "Планы",
          "assets": "Активы"
        },
        "subtabs": {
          "tasks": "Задачи",
          "labor": "Труд",
          "materials": "Материалы",
          "tools": "Инструменты"
        },
        "sections": {
          "details": "Детали плана",
          "responsibility": "Ответственность",
          "woassets": "Рабочие активы и безопасность"
        },
        "fields": {
          "jpnum": "№ Плана",
          "status": "Статус",
          "description": "Описание",
          "template_type": "Тип шаблона",
          "duration": "Длительность (ч)",
          "supervisor": "Руководитель",
          "class": "Структура класса",
          "safety_plan": "План безопасности",
          "revision": "Редакция"
        },
        "table": {
          "seq": "Посл.",
          "duration": "Длит.",
          "craft": "Специальность",
          "labor": "Рабочий",
          "qty": "Кол-во",
          "hours": "Часы",
          "rate": "Ставка",
          "item": "Предмет",
          "unitcost": "Цена за ед.",
          "tool": "Инструмент"
        }
      },
      "meters": {
        "list": {
          "title": "Определения счетчиков",
          "search": "Фильтр по номеру или имени...",
          "new_meter": "НОВЫЙ СЧЕТЧИК",
          "no_records": "Счетчики не найдены"
        },
        "fields": {
          "meter_num": "№ счетчика",
          "meter_name": "Имя счетчика",
          "type": "Тип",
          "uom": "Ед. изм.",
          "active": "Активен?",
          "remarks": "Примечания",
          "last_reading": "ПОСЛЕДНЕЕ ПОКАЗАНИЕ",
          "last_date": "ДАТА ПОСЛЕДНЕГО ПОКАЗАНИЯ",
          "rollovers": "ОБНУЛЕНИЙ"
        },
        "tabs": {
          "meter": "Детали счетчика",
          "where_used": "Где используется"
        },
        "sections": {
          "info": "Информация о счетчике",
          "additional": "Дополнительные детали",
          "stats": "Статистика счетчика"
        },
        "where_used": {
          "linked_assets": "Связанные активы",
          "linked_locations": "Связанные локации",
          "linked_items": "Связанные ТМЦ",
          "searching": "🔍 Поиск по системе...",
          "no_assoc": "Связи в этой категории не найдены.",
          "asset_num": "№ Актива",
          "site": "Сайт",
          "status": "Статус",
          "location": "Локация",
          "item_num": "№ ТМЦ",
          "category": "Категория"
        }
      },
      "asset_categories": {
        "list": {
          "title": "Категории активов",
          "search": "Поиск категорий...",
          "new_category": "НОВАЯ КАТЕГОРИЯ",
          "no_records": "Категории не найдены"
        },
        "fields": {
          "category_id": "Код категории",
          "description": "Описание",
          "dep_method": "Метод аморт.",
          "life": "Срок (Лет)"
        }
      },
      "export": {
        "loading": "Извлечение данных...",
        "success": "Экспорт успешно завершен!",
        "error": "Ошибка при экспорте данных."
      },
      "labor": {
        "list": {
          "title": "Реестр сотрудников",
          "new": "НОВЫЙ СОТРУДНИК",
          "total": "Всего сотрудников",
          "unique_crafts": "Специальности на стр.",
          "no_records": "Сотрудники не найдены."
        },
        "tabs": {
          "main": "ОСНОВНАЯ",
          "person": "ЛИЦО",
          "crafts": "СПЕЦ-ТИ",
          "log": "ЖУРНАЛ"
        },
        "sections": {
          "basic": "Основная информация",
          "status": "Статус и организация",
          "additional_crafts": "Доп. специальности и навыки"
        },
        "fields": {
          "personid": "Ссылка на лицо",
          "primary_craft": "Осн. специальность",
          "actual_rate": "Факт. ставка (в час)",
          "skill": "Уровень навыка",
          "rate": "Почасовая ставка",
          "primary": "Основная?",
          "laborcode": "Код сотрудника",
          "fullname": "Полное имя",
          "craft": "Специальность"
        },
        "actions": {
          "add_craft": "ДОБАВИТЬ СПЕЦ-ТЬ"
        },
        "lookup": {
          "person": "Выбрать лицо",
          "craft": "Выбрать спец-ть",
          "skill": "Выбрать навык"
        },
        "messages": {
          "no_crafts": "Связи со специальностями не найдены"
        },
        "details": {
          "delete_warn": "Вы не сможете восстановить эту запись!"
        }
      },
      "sr": {
        "list": {
          "title": "Отслеживание запросов на обслуживание",
          "new": "НОВЫЙ ЗАПРОС"
        },
        "fields": {
          "srnum": "Номер запроса",
          "description": "Описание",
          "reportedby": "Кем заявлено",
          "reportdate": "Дата заявки",
          "priority": "Приоритет"
        },
        "messages": {
          "no_records": "Запросы на обслуживание не найдены"
        },
        "tabs": {
          "main": "Запрос на обслуживание",
          "related": "Связанные записи"
        },
        "sections": {
          "requester": "Заявитель и контакты",
          "problem": "Спецификация проблемы",
          "logistics": "Логистика и приоритет"
        },
        "fields": {
          "phone": "Телефон",
          "email": "Эл. почта",
          "asset": "Актив",
          "location": "Местоположение",
          "long_desc": "Подробное описание проблемы",
          "priority_1": "1 - АВАРИЯ (НЕМЕДЛЕННО)",
          "priority_2": "2 - ВЫСОКИЙ (СЕГОДНЯ)",
          "priority_3": "3 - СРЕДНИЙ (72 ЧАСА)",
          "priority_4": "4 - НИЗКИЙ (ПЛАНОВЫЙ)"
        },
        "lookup": {
          "person": "Выбрать лицо",
          "asset": "Выбрать актив",
          "location": "Выбрать местоположение"
        },
        "details": {
          "delete_new_only": "Только НОВЫЕ запросы могут быть удалены",
          "delete_warn": "Это навсегда удалит данный запрос на обслуживание.",
          "wf_tip": "Автоматический рабочий процесс: После сохранения используйте кнопку 'Маршрут рабочего процесса' для отправки на техническое рассмотрение.",
          "wo_tip": "Подсказка: Вы можете создать заказ на работу из этого ЗО с помощью действий рабочего процесса или скрипта 'Создать ЗР'."
        },
        "related": {
          "title": "Связанные заказы на работу для ЗО:",
          "wonum": "Номер ЗР",
          "worktype": "Тип работы",
          "no_wo": "Для этого ЗО пока не создано ни одного заказа на работу.",
          "go_to_wo": "Перейти к заказу на работу"
        }
      },
      "invusage": {
        "list": {
          "title": "История использования запасов",
          "new": "Новая транзакция"
        },
        "types": {
          "all": "ВСЕ",
          "issue": "ВЫДАЧА",
          "transfer": "ПЕРЕМЕЩЕНИЕ",
          "return": "ВОЗВРАТ"
        },
        "tabs": {
          "lines": "СТРОКИ ИСПОЛЬЗОВАНИЯ",
          "log": "ЖУРНАЛ ТРАНЗАКЦИЙ"
        },
        "details": {
          "summary": "Сводка строк",
          "transfer_dest": "Детали места назначения перевода",
          "financial": "Финансовые начисления и ссылки"
        },
        "actions": {
          "add_item": "Добавить позицию",
          "add_part": "Добавить деталь",
          "select_mr": "ВЫБРАТЬ ЗАЯВКУ (MR)"
        },
        "fields": {
          "stock_item": "Складская позиция",
          "issueunit": "Ед. изм. выдачи",
          "qty": "Количество",
          "unitcost": "Цена за единицу",
          "linecost": "Общая стоимость строки",
          "target_bin": "Целевая ячейка в",
          "target_loc": "Целевое местоположение",
          "assetnum": "Номер актива",
          "wonum": "Ссылка на заказ-наряд",
          "glaccount": "Дебет счета ГK",
          "usagenum": "ID использования",
          "type": "Тип",
          "fromstore": "Со склада",
          "lines": "Строки",
          "enterby": "Кем введено"
        },
        "placeholders": {
          "select_item": "ВЫБЕРИТЕ ПОЗИЦИЮ...",
          "dest_bin": "ВВЕДИТЕ ЦЕЛЕВУЮ ЯЧЕЙКУ...",
          "choose_loc": "ВЫБЕРИТЕ МЕСТО",
          "select_asset": "ВЫБЕРИТЕ АКТИВ",
          "charge_wo": "ОТНЕСТИ НА ЗН"
        },
        "lookup": {
          "store": "Склады",
          "dest_store": "Склады назначения",
          "mr": "Выберите утвержденную заявку",
          "item": "Поиск по складу",
          "loc": "Местоположения",
          "asset": "Реестр активов",
          "wo": "Заказы-наряды"
        },
        "messages": {
          "req_fromstore": "Сначала выберите склад!",
          "mr_loaded": "Загружены позиции из заявки:",
          "mr_fail": "Не удалось загрузить позиции заявки",
          "insufficient_title": "Недостаточно запасов!",
          "available": "Доступно",
          "create_pr": "Создать заявку на закупку (PR)?",
          "btn_create_pr": "Создать PR",
          "processing": "Обработка корректировок запасов...",
          "inventory_updated": "Уровни запасов успешно обновлены",
          "cant_delete_comp": "Невозможно удалить завершенную транзакцию!",
          "delete_warn": "Черновик транзакции будет безвозвратно удален.",
          "req_fields": "Описание и Склад обязательны для заполнения!",
          "req_transfer": "Для перевода необходимо указать Склад назначения!",
          "locked_title": "Запись заблокирована",
          "locked_text": "Эта транзакция ЗАВЕРШЕНА и не может быть изменена.",
          "cant_save_comp": "Невозможно сохранить изменения в завершенной записи",
          "balance_move": "Примечание: Остаток будет перемещен на",
          "upon_comp": "после завершения."
        }
      },
      "downtime": {
        "title": "Отчет о простое актива",
        "subtitle": "Система управления активами",
        "asset": "Актив",
        "status": "Офлайн запись",
        "start": "Дата и время начала",
        "end": "Дата окончания (необязательно)",
        "type": "Тип простоя",
        "types": {
          "unplanned": "НЕЗАПЛАНИРОВАННЫЙ (Поломка)",
          "planned": "ПЛАНОВЫЙ (Обслуживание)"
        },
        "duration": "Расчетная продолжительность",
        "hours": "ЧАСОВ",
        "prod_impact": "Эксплуатационный простой (влияние на производство)",
        "btn_commit": "Подтвердить изменения",
        "messages": {
          "recording": "Запись времени простоя...",
          "success": "Время простоя успешно записано",
          "validation_error": "Ошибка формата: Проверьте все поля",
          "server_error": "Ошибка сервера: 500"
        },
        "history": {
          "title": "История простоев актива",
          "subtitle": "Отслеживание производительности актива",
          "no_records": "Для этого актива не зафиксировано событий простоя.",
          "duration_hrs": "Длительность (ч)",
          "type_reason": "Тип/Причина",
          "impact": "Влияние",
          "reported_by": "Кем заявлено",
          "still_down": "ВСЕ ЕЩЕ ПРОСТАИВАЕТ",
          "prod_loss": "Потеря произв.",
          "technical": "Техническая",
          "active_down": "Активный простой",
          "resolved": "Решено"
        }
      },
      "incidents": {
        "list": {
          "title": "Реестр инцидентов",
          "new": "НОВЫЙ ИНЦИДЕНТ"
        },
        "fields": {
          "ticket_id": "ID заявки",
          "priority": "Приоритет",
          "reported_by": "Кем заявлено"
        },
        "details": {
          "ticket": "Заявка об инциденте",
          "general": "Общее описание",
          "detailed": "Подробные детали",
          "context": "Контекст и статус",
          "linked_asset": "Связанный актив",
          "workorder": "Заказ-наряд",
          "delete_warn": "Вы собираетесь безвозвратно удалить инцидент {{ticket}}. Это действие нельзя отменить!"
        },
        "lookup": {
          "asset": "Выберите связанный актив",
          "loc": "Выберите местоположение"
        }
      },
      "tools": {
        "list": {
          "title": "Мастер инструментов",
          "new": "НОВЫЙ ИНСТРУМЕНТ"
        },
        "fields": {
          "toolnum": "Номер инструмента",
          "type": "Тип",
          "is_stocked": "На складе?"
        },
        "tabs": {
          "tool": "ИНСТРУМЕНТ",
          "stores": "СКЛАДЫ",
          "vendors": "ПОСТАВЩИКИ",
          "specs": "СПЕЦИФИКАЦИИ",
          "quals": "КВАЛИФИКАЦИИ"
        },
        "sections": {
          "config": "Конфигурация инструмента",
          "inventory": "Инвентарь и остатки",
          "vendors": "ИСТОРИЯ ЗАКУПОК И ПОСТАВЩИКОВ",
          "quals": "Требуемые квалификации"
        },
        "fields": {
          "toolnum": "Номер инструмента",
          "type": "Тип инструмента",
          "issueunit": "Единица выдачи",
          "is_stocked": "Складируемый инструмент?",
          "rotating": "Оборотный элемент?",
          "calib_req": "Требуется калибровка?",
          "mfg": "Производитель",
          "model": "Номер модели",
          "class": "Классификация",
          "active_vendors": "АКТИВНЫЕ ПОСТАВЩИКИ"
        },
        "actions": {
          "add_store": "Добавить на склад",
          "add_qual": "Добавить квалификацию"
        },
        "tables": {
          "storeroom": "Склад",
          "balance": "Остаток",
          "attr": "Атрибут",
          "value": "Значение",
          "uom": "Ед. изм.",
          "qual": "Квалификация",
          "vendor_id": "Поставщик (Номер комп.)",
          "vendor_name": "Имя поставщика",
          "unitcost": "Цена за единицу",
          "qty": "Кол-во",
          "po": "Ссылка на заказ на закупку (PO)"
        },
        "placeholders": {
          "toolid": "ВВЕДИТЕ ID ИНСТРУМЕНТА...",
          "reg_supplier": "ЗАРЕГИСТРИРОВАННЫЙ ПОСТАВЩИК",
          "adj": "КОРР. ЗАПАСОВ"
        },
        "lookup": {
          "type": "Тип инструмента",
          "unit": "Единицы выдачи",
          "attr": "Атрибуты"
        },
        "messages": {
          "req_fields": "Номер инструмента и описание обязательны!",
          "delete_warn": "Вы не сможете отменить это!",
          "class_loaded": "Классификация и атрибуты загружены",
          "stocked_note": "Примечание: Складируемые инструменты управляются через склады и требуют учетной записи запасов для отслеживания остатков.",
          "no_stock": "На складе нет товаров"
        }
      },
      "inventory": {
        "list": {
          "title": "Реестр запасов"
        },
        "fields": {
          "itemnum": "Номер позиции",
          "location": "Склад",
          "balance": "Остаток",
          "avgcost": "Средняя стоимость"
        },
        "details": {
          "profile": "Профиль запасов",
          "reorder_logic": "Логика перезаказа",
          "reorder_pt": "Точка перезаказа",
          "eoq": "Экономичный объем заказа",
          "critical_lvl": "Критический уровень",
          "critical_desc": "Автоматическое создание PR при достижении точки перезаказа.",
          "current_stock": "Текущий уровень запасов",
          "avail_qty": "Доступное количество",
          "reserved_qty": "Зарезервированное кол-во",
          "held_wo": "Удержано для заказов-нарядов",
          "avg_cost": "Средняя стоимость единицы",
          "avg_cost_desc": "Средневзвешенное значение всех поступлений",
          "total_val": "Общая стоимость запасов",
          "total_val_desc": "Текущий остаток × Средняя стоимость",
          "last_cost": "Стоимость последнего поступления",
          "last_cost_desc": "Стоимость из последнего PO",
          "val_method": "Метод оценки запасов",
          "avg_method": "СРЕДНЯЯ СТОИМОСТЬ",
          "val_desc1": "Для этой позиции используется метод",
          "val_desc2": ". Стоимость единицы автоматически пересчитывается при каждом поступлении по заказу на закупку для отражения колебаний рыночных цен."
        },
        "tabs": {
          "balances": "Остатки",
          "trans": "История транзакций",
          "costs": "Затраты"
        },
        "actions": {
          "adjustment": "Корректировка запасов"
        },
        "tables": {
          "qty": "Количество",
          "actual_cost": "Фактическая стоимость",
          "reference": "Ссылка"
        },
        "messages": {
          "no_trans": "История транзакций не найдена"
        },
        "trans_types": {
          "receipt": "ПОСТУПЛЕНИЕ",
          "issue": "ВЫДАЧА",
          "transfer": "ПЕРЕМЕЩЕНИЕ",
          "adjustment": "КОРРЕКТИРОВКА"
        }
      },
      "storerooms": {
        "list": {
          "title": "Склады",
          "new": "НОВЫЙ СКЛАД"
        },
        "fields": {
          "location": "Склад",
          "isdefault": "По умолчанию?",
          "inventory": "Запасы",
        },
        "details": {
          "profile": "Склад",
          "record": "Запись о складе",
          "gen_settings": "Общие настройки",
          "filtered_by": "Отфильтровано по {{org}}",
          "select_org_first": "Сначала выберите организацию",
          "gl_accounts": "Счета ГК",
          "inv_control": "Контроль запасов",
          "inv_control_desc": "Все выдачи и поступления материалов для этого склада будут сбалансированы по этим счетам.",
          "items_stocked": "Товары на складе"
        },
        "tabs": {
          "main": "ОСНОВНОЕ",
          "inventory": "ЗАПАСЫ"
        },
        "fields": {
          "location": "ID местоположения",
          "isdefault": "Склад по умолчанию?",
          "useinpo": "Использовать в заказах?",
          "invowner": "Владелец запасов",
          "controlacc": "Контрольный счет",
          "shrinkacc": "Счет недостачи",
          "glaccount": "Счет ГК по умолчанию",
          "default": "ОСНОВНОЙ"
        },
        "lookup": {
          "person": "Выберите сотрудника"
        },
        "tables": {
          "itemnum": "Номер позиции",
          "uom": "Ед. изм.",
          "curbal": "Текущий остаток",
          "reserved": "Зарезервировано"
        },
        "messages": {
          "req_fields": "ID местоположения обязательно!",
          "req_org_site": "Организация и сайт обязательны!",
          "delete_warn": "Вы собираетесь удалить склад {{store}}. Это действие нельзя отменить!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "Библиотека кодов неисправностей",
          "new": "Новый класс неисправности"
        },
        "details": {
          "profile": "Класс неисправности"
        },
        "fields": {
          "class": "Класс неисправности",
          "code": "Код",
          "desc_tech": "Описание / Техническое наименование"
        },
        "tables": {
          "problems": "Проблемы (Симптомы)",
          "causes": "Причины (Основная причина)",
          "remedies": "Меры / Решения"
        },
        "placeholders": {
          "class": "Например: PUMP-FAIL",
          "desc_tech": "Укажите подробное описание этой иерархии неисправностей...",
          "code": "Введите код...",
          "desc": "Техническое описание..."
        },
        "messages": {
          "req_class": "Код класса неисправности обязателен!",
          "delete_warn": "Вы собираетесь удалить класс неисправности {{class}}. Это действие нельзя отменить!"
        }
      },
      "scheduler": {
        "title": "Диспетчеризация и Планирование",
        "ai_optimize": "АВТО-ОПТИМИЗАЦИЯ ИИ",
        "publish": "ОПУБЛИКОВАТЬ РАСПИСАНИЕ",
        "kpi_scheduled": "Запланированные работы",
        "kpi_issues": "Проблемы планирования",
        "kpi_utilization": "Всего ресурсов",
        "kpi_emergencies": "Чрезвычайные ситуации",
        "no_data": "Нет запланированных заказ-нарядов.",
        "no_resources": "Нет данных о мощности ресурсов.",
        "fetch_error": "Не удалось загрузить данные расписания.",
        "optimizing": "ИИ выравнивает нагрузку на ресурсы...",
        "optimize_fail": "Сбой оптимизации ИИ."
      },
      "features": {
        "title": "Каталог Линейных Объектов",
        "feature_id": "Код Объекта",
        "description": "Описание",
        "type": "Тип Объекта",
        "point": "Точка (напр. Клапан)",
        "linear": "Линейный (напр. Материал)",
        "error_in_use": "Невозможно удалить: объект используется на трубопроводе."
      },
      "audit": {
        "title": "Обозреватель контрольного журнала",
        "history_for": "История для",
        "retrieving": "Получение записей аудита...",
        "no_records": "Для этой записи не найдено контрольных журналов"
      },

    }
  },
  // 🇵🇰 اُردُو (Urdu)
  ur: {
    translation: {
      brand: { name: "ٹیکنورا EAM", tagline: "اثاثوں کی بہتری", version: "ٹیکنورا v1.0.4" },
      search: { placeholder: "ماڈیولز تلاش کریں..." },
      menu: {
        settings: "سیٹنگز", organization: "ادارہ", domains: "ڈومینز", field_config: "فیلڈ کنفیگریشن", classifications: "درجہ بندی", importer: "یونیورسل امپورٹر", cobie: "COBie منیجر", workflow: "ورک فلو انجن", scripts: "ایکشن اسکرپٹس",
        analytics: "تجزیات", dashboards: "BI ڈیش بورڈز", report_designer: "رپورٹ ڈیزائنر", report_wizard: "رپورٹ وزرڈ",
        assets: "اثاثے", asset_registry: "اثاثہ رجسٹری", locations: "مقامات", categories: "اثاثہ کی اقسام", meters: "میٹرز", failure_codes: "فالٹ کوڈز",
        work_management: "ورک مینجمنٹ", wo_tracking: "ورک آرڈر ٹریکنگ", labor_reporting: "شیڈولر",
        resources: "وسائل", crafts: "ہنر", labor: "لیبر", person: "شخص",
        service_desk: "سروس ڈیسک", service_requests: "سروس کی درخواستیں", incidents: "حادثاتی رجسٹری",
        procurement: "خریداری", po: "پرچیز آرڈر", pr: "خریداری کی درخواست", rfq: "کوٹیشن کی درخواست", receiving: "وصولی", vendors: "وینڈرز",
        contracts: "معاہدے", contracts_master: "ماسٹر معاہدے", sla: "سروس لیول معاہدہ",
        inventory: "انوینٹری", item_master: "آئٹم ماسٹر", tools: "اوزار", balances: "انوینٹری بیلنس", transfers: "ایشو اور ٹرانسفر", storerooms: "اسٹور رومز",
        planning: "منصوبہ بندی", pm_schedules: "PM شیڈولز", safety_plans: "سیفٹی پلانز", hazards: "خطرات", precautions: "احتیاطی تدابير", tagouts: "ٹیگ آؤٹ", job_plans: "جاب پلانز",
        security: "سیکیورٹی", user_list: "صارفین کی فہرست", groups: "سیکیورٹی گروپس", "recent": "حال ہی میں دیکھا گیا"
      },
      user_settings: { title: "صارف کی ترتیبات", default_info: "ڈیفالٹ معلومات", personal_info: "ذاتی معلومات", password_info: "پاس ورڈ کی معلومات", sign_out: "سائن آؤٹ", system_info: "سسٹم کی معلومات" },
      notifications: { title: "ان باکس ٹاسک", new_alerts: "نیا", empty: "آپ کا ان باکس صاف ہے", view_all: "تمام سرگرمیاں دیکھیں" },
      sidebar: { queries: "دستیاب استفسارات", all_assets: "تمام اثاثے", operating_assets: "فعال اثاثے", critical_assets: "اہم اثاثے", my_bookmarks: "میری نشانیان", common_actions: "عام کارروائیاں", new: "نیا", move_assets: "اثاثے منتقل کریں", print_barcodes: "بارکوڈ پرنٹ کریں", create_report: "رپورٹ بنائیں", wo_queries: "کام کے آرڈر", all_wo: "تمام ورک آرڈرز", waiting_approval: "منظوری کا منتظر", wip: "جاری ہے", completed_today: "آج مکمل ہوا", bulk_approve: "اکٹھی منظوری", record_actions: "ریکارڈ کارروائیاں", save: "محفوظ کریں", delete: "حذف کریں", workflow_status: "ورک فلو / حیثیت", change_status: "حیثیت تبدیل کریں", view_history: "تاریخچہ دیکھیں", item_ops: "آئٹم کی کارروائیاں", add_to_storeroom: "اسٹور روم میں شامل کریں", inv_ops: "انوینٹری کارروائیاں", reorder: "دوبارہ آرڈر", tax_ops: "ٹیکس کارروائیاں", tax_category: "ٹیکس کی قسم", create_po: "خریداری آرڈر بنائیں", settings_group: "ترتیبات", system_settings: "سسٹم کی ترتیبات", email_settings: "ای میل ترتیبات", asset_ops: "اثاثہ کارروائیاں", meter_readings: "میٹر ریڈنگ", hist_readings: "تاریخی ریڈنگ", report_downtime: "ڈاؤن ٹائم رپورٹ کریں", downtime_hist: "ڈاؤن ٹائم کی تاریخ", move_mod_asset: "اثاثہ منتقل/ترمیم کریں", asset_move_hist: "منتقلی کی تاریخ", create_related: "متعلقہ بنائیں", create_incident: "حادثہ بنائیں", view_inc_hist: "حادثات کی تاریخ", create_wo: "ورک آرڈر بنائیں", sr: "سروس کی درخواست", apply_sla: "SLA لاگو کریں", approve_wo: "آرڈر منظور کریں", start_work: "کام شروع کریں", complete_work: "کام مکمل کریں", close_wo: "آرڈر بند کریں", analytics: "تجزیات", wf_history: "ورک فلو کی تاریخ", history_log: "آپریشن لاگ", wo_costs: "اخراجات", purchase_info: "خریداری کی معلومات", all_records: "تمام ریکارڈز", find_nav: "آئٹم تلاش کریں", more_actions: "مزید کارروائیاں", settings: "ترتیبات", export_data: "ڈیٹا ایکسپورٹ", audit_log: "آڈٹ لاگ", share_app: "ایپ شیئر کریں" },
      apps: {
        ORGANIZATION: "ادارے", ASSET: "اثاثے", LOCATION: "مقامات", WORKORDER: "ورک آرڈر", INVENTORY: "انوینٹری", CLASSIFICATION: "درجہ بندی", VENDOR: "وینڈرز", METER: "میٹرز", DOMAINS: "ڈومینز", CRAFTS: "ہنر", STOREROOMS: "اسٹور رومز", ITEMS: "آئٹم ماسٹر", INVENTORYUSAGE: "انوینٹری کا استعمال", MR: "مٹیریل کی درخواست", PR: "خریداری کی درخواست", PO: "خریداری کے آرڈر", LABOR: "لیبر", PM: "شیڈولز", SAFETY: "سیفٹی پلانز", HAZARD: "خطرات", TAGOUT: "ٹیگ آؤٹ", PRECUTION: "احتیاطی تدابیر", SR: "سروس کی درخواست", INCIDENT: "حادثات", ASSET_CATEGORIES: "اثاثہ کی اقسام", FAILURECLASS: "فالٹ کوڈز", RFQ: "کوٹیشن کی درخواست", CONTRACT: "معاہدے", SLA: "سروس لیول کا معاہدہ", FAILURE_CODES: "ناکامی کوڈز", 
        "VENDORS": "وینڈرز", "TAGOUTS": "ٹیگ آؤٹ", "PRECAUTIONS": "احتیاطی تدابیر", "INCIDENTS": "حادثات", "JOBPLAN": "ٹیک کارٹس (Job Plans)", "ROLE": "رولز", "TOOLS": "اوزار", "USER": "صارفین"
      },
      dashboard: { tab_bi: "KPI ٹیمپلیٹ", tab_inbox: "ورک فلو ان باکس", advanced_analytics: "جدید تجزیات", workflow_center: "ایگزیکیوشن سینٹر", active_tasks: "فعال کام", history_tasks: "تاریخچہ", no_data: "کوئی ڈیٹا نہیں ملا", take_action: "کارروائی کریں", previous: "پچھلا", next: "اگلا", showing: "دکھا رہا ہے", of: "میں سے", actual: "اصل", target: "ہدف", kpi_graph: "KPI گراف" },
      username: "صارف کی آئی ڈی",
      password: "پاس ورڈ",
      login_btn: "سائن ان کریں",
      forgot_pwd: "پاس ورڈ بھول گئے؟",
      login: {
        id_placeholder: "اپنی آئی ڈی درج کریں",
        error_msg: "آئی ڈی یا پاس ورڈ غلط ہے",
        server_error: "سرور سے رابطہ ناکام ہو گیا",
        just_smart: "صرف اسمارٹ"
      },
      organizations: { title: "ادارے", org_id: "ادارہ", description: "تفصیل", active: "فعال؟" },
      org_detail: { org_label: "ادارہ", tabs: { organization: "ادارہ", sites: "سائٹس", map: "نقشہ" }, fields: { currency1: "بنیادی کرنسی 1", currency2: "بنیادی کرنسی 2", item_set: "آئٹم سیٹ", company_set: "کمپنی سیٹ", item_status: "ڈیفالٹ اسٹیٹس", active: "فعال؟" }, descs: { currency1: "اہم کرنسی", currency2: "ثانوی کرنسی", item_set: "آئٹم سیٹ", company_set: "کمپنی سیٹ" }, lookups: { currency: "کرنسی", item_set: "آئٹم سیٹ", company_set: "کمپنی سیٹ", status: "اسٹیٹس", governorate: "صوبہ" }, sites: { management: "سائٹس مینجمنٹ", new_row: "نئی رو", of: "میں سے", site_id: "سائٹ آئی ڈی", description: "تفصیل", active: "فعال؟", action: "کارروائی", site_details: "سائٹ کی تفصیلات", state: "ریاست / صوبہ", contact: "بنیادی رابطہ", fin_info: "مالیاتی / بجٹ معلومات", yearly_budget: "سالانہ بجٹ", monthly_budget: "ماہانہ بجٹ", utilization: "سالانہ استعمال", fin_health: "اس سائٹ کے مالی حالات مستحکم ہیں۔" }, toasts: { id_required: "ادارے کی آئی ڈی درکار ہے!", saving: "محفوظ ہو رہا ہے...", success: "ادارہ اور سائٹس کامیابی سے محفوظ ہو گئے!", fail: "محفوظ کرنا ناکام رہا" } },
      domains: { title: "ڈومینز", find_placeholder: "ڈومین تلاش کریں...", new_domain: "نیا ڈومین", domain_id: "ڈومین", description: "تفصیل", type: "قسم", values: "اقدار" ,
        save_btn: "محفوظ کریں", desc_placeholder: "ڈومین کی تفصیل", synonym_values: "مترادفات", new_row: "نئی رو", internal_val: "اندرونی قیمت", external_desc: "بیرونی تفصیل", default: "ڈیفالٹ؟", action: "کارروائی", no_values: "کوئی قیمت متعین نہیں ہے۔", toasts: { loading: "لوڈ ہو رہا ہے...", load_fail: "لوڈنگ ناکام", id_required: "آئی ڈی درکار ہے!", saving: "محفوظ ہو رہا ہے...", save_success: "کامیابی سے محفوظ ہو گیا!", save_fail: "محفوظ کرنا ناکام رہا" } },
      classifications: { parent: "بنیادی درجہ بندی", order: "ترتیب", hierarchy: "درجہ بندی کا ڈھانچہ", hierarchy: "شجرہ نسب کا راستہ", parent: "بنیادی درجہ بندی", gen_desc: "تفصیل خود بخود بنائیں؟", use_with: "اشیاء کے ساتھ استعمال کریں", attributes: "خصوصیات", attr_id: "خصوصیت آئی ڈی", section: "سیکشن", uom: "پیمائش کی اکائی" },
      bim: { title: "BIM انٹیگریٹر پرو", subtitle: "Revit سے COBie میپنگ", waiting_translation: "ماڈل پروسیسنگ کا انتظار ہے...", tabs: { "3d": "تھری ڈی ویو", data: "ڈیٹا ٹیبل" }, preview_table_title: "COBie اجزاء کا جائزہ", controls: { destination: "منزل", select_site: "سائٹ منتخب کریں", uploads: "فائل اپ لوڈ", select_cobie: "COBie فائل منتخب کریں", upload_revit: "Revit فائلیں اپ لوڈ کریں", models_ready: "ماڈلز تیار ہیں", preview_list: "ماڈلز کا جائزہ", finalizing: "مطابقت پذیری ہو رہی ہے...", commit: "BIM انٹیگریشن مکمل کریں" }, table: { asset_name: "اثاثہ کا نام", location: "جگہ / مقام" } },
      importer: { title: "یونیورسل ڈیٹا لوڈر", target_table: "ٹارگٹ ٹیبل", download_template: "ٹیمپلیٹ ڈاؤن لوڈ کریں", upload_instruction: "اپ لوڈ کرنے کے لیے ایکسل فائل منتخب کریں", field_mapping: "فیلڈ میپنگ", excel: "ایکسل", ignore: "نظر انداز کریں", preview_title: "جائزہ", execute_btn: "درآمد کا عمل شروع کریں" },
      workflow: { title: "ورک فلو انجن", subtitle: "آٹومیشن کنٹرول سینٹر", export_btn: "ایکسپورٹ CSV", new_process: "نیا عمل", loading: "لوڈ ہو رہا ہے...", unnamed: "بغیر نام کا عمل", linked_to: "منسلک ہے", create_path: "نیا راستہ بنائیں", 
                  designer_title: "ورک فلو لاجک ڈیزائنر (لوپ بیک فعال)", publish_btn: "شائع کریں", loading_designer: "لاجک پاتھ کی تعمیر نو ہو رہی ہے...", logic_palette: "لاجک پیلیٹ", config_title: "کنفیگریشن", node_label: "لیبل", assign_roles: "کردار تفویض کریں", post_action: "ایکاڈمی کے بعد کا سکرپٹ", select_lookup: "لوک اپ سے منتخب کریں", script_hint: "* ایک سے زیادہ سکرپٹ کو کوما سے الگ کیا جا سکتا ہے۔", status_auto: "خودکار حیثیت کی تبدیلی", trigger: "ٹریگر", target_status: "ہدف کی حیثیت", cond_expr: "مشروط اظہار (بائیتھن)", escalation: "اضافہ (گھنٹے)", select_node: "ترمیم کے لیے نوڈ منتخب کریں", options: {no_change: "حیثیت میں کوئی تبدیلی نہیں", change_status: "حیثیت تبدیل کریں", select_status: "حیثیت منتخب کریں"},
                  table : {id: "آئی ڈی", name: "عمل کا نام", app: "ایپ", status: "حیثیت"},
                  lookups: {select_roles: "کردار تلاش کریں", select_scripts: "سکرپٹ تلاش کریں"},
                  swal: {publish_title: "ورک فلو شائع کریں؟", publish_text: "یہ انجن کے مراحل کو ڈیٹا بیس کے ساتھ ہم آہنگ کر دے گا۔", confirm_publish: "جی ہاں، ابھی شائع کریں", delete_title: "لاجک صاف کریں؟", delete_text: "کیا آپ واقعی حذف کرنا چاہتے ہیں", confirm_delete: "جی ہاں، سب کچھ حذف کریں"}, 
                  toasts: {id_required: "براہ کرم عمل کا نام درج کریں", saving: "ورک فلو ہم آہنگ ہو رہا ہے...", save_success: "لاجک کامیابی سے ہم آہنگ ہو گئی! 🚀", save_fail: "ہم آہنگی ناکام رہی", purging: "ورک فلو حذف ہو رہا ہے...", delete_success: "ورک فلو مستقل طور پر حذف ہو گیا", delete_fail: "حذف کرنا ناکام رہا", fetch_fail: "ڈیٹا لوڈ کرنے میں ناکامی"}
      },
      field_config: { title: "میٹا ڈیٹا فیلڈ میپنگ", table_name: "ٹیبل کا نام", field_name: "فیلڈ کا نام", current_mappings: "موجودہ میپنگ برائے:", field: "فیلڈ", linked_domain: "منسلک ڈومین" },
      scripts: {
        title: "ایکشن اسکرپٹس",
        subtitle: "آٹومیشن اور لاجک ٹیمپلیٹس کا انتظام کریں",
        new_btn: "نیا اسکرپٹ بنائیں",
        search_placeholder: "نام یا ہدف سے تلاش کریں...",
        table: {
          name: "اسکرپٹ کا نام",
          object: "ہدف آبجیکٹ",
          created: "تخلیق کی تاریخ"
        },
        toasts: {
          fetch_fail: "اسکرپٹ لوڈ کرنے میں ناکامی"
        }
      },
      studio: { schema_explorer: "اسکیمہ ایکسپلورر", target_context: "ہدف آبجیکٹ سیاق و سباق", name_placeholder: "اسکرپٹ کا نام دیں...", engine_info: "انجن: پائیتھن 3.10", console_title: "سسٹم ایگزیکیوشن کنسول", clear_console: "کنسول صاف کریں", field_from: "فیلڈ از", access_col: "کالم تک رسائی: ", db_model: "ڈیٹا بیس ماڈل", btns: { compile: "کمپائل", compiling: "کمپائل ہو رہا ہے...", save_deploy: "محفوظ اور تعینات کریں" }, toasts: { preserved: "اسکرپٹ محفوظ ہو گیا!", compiled: "تجزیہ کامیاب!" }, console: { init: "اسٹوڈیو شروع ہو گیا...", schema_sync: "اسکیمہ ہم آہنگ ہو گیا۔", schema_fail: "ہم آہنگی ناکام۔", saved_prefix: "اسکرپٹ محفوظ ہو گیا", error_op: "محفوظ کرنے میں خرابی۔", compiling: "تجزیہ شروع...", build_finish: "تعمیر مکمل۔", syntax_error: "نحو کی غلطی۔", build_fail: "تعمیر ناکام", analyzing: "نحوی تجزیہ جاری ہے..." } },
      reports: { title: "رپورٹ ٹیمپلیٹس", new_btn: "نئی رپورٹ بنائیں", search_placeholder: "رپورٹس تلاش کریں...", table: { name: "رپورٹ کا نام", ref_obj: "حوالہ آبجیکٹ", updated: "آخری اپ ڈیٹ" }, 
          toasts: { load_fail: "لوڈ کرنے میں ناکامی", clone_success: "رپورٹ کلون ہو گئی", save_success: "ٹیمپلیٹ محفوظ ہو گیا! 🚀", save_fail: "محفوظ کرنے میں ناکامی" },
          designer: {
                  title: "رپورٹ ڈیزائنر پرو", live_preview: "براہ راست جائزہ", publish: "ٹیمپلیٹ شائع کریں", model_select: "ماڈل کا انتخاب", data_explorer: "ڈیٹا ایکسپلورر", components: "اجزاء", page_break: "صفحہ وقفہ",
                  is_summary: "خلاصہ رپورٹ؟", user_params: "صارف پیرامیٹرز", add_param: "فیلڈ شامل کریں", master_info: "بنیادی معلومات", relational_data: "متعلقہ ڈیٹا", detail_tables: "تفصیلی ٹیبلز", tabs: { body: "مواد", header: "ہیڈر", footer: "فوٹر", css: "عالمی CSS" },
                  fields: { wonum: "آرڈر نمبر", assetnum: "اثاثہ نمبر", desc: "تفصیل", status: "حیثیت", asset: "اثاثہ کا نام", location: "مقام آئی ڈی", tasks_table: "کاموں کی فہرست", mat_table: "منصوبہ بند مواد", asset_basic: "اثاثہ کی بنیادی معلومات", inv_basic: "انوینٹری کی معلومات", vend_basic: "سپلائر کی معلومات" }
                },
        }, 
      assets: { 
        map: { "gps_location": "جغرافیائی مقام (GPS)", "gps_coordinates": "GPS نقاط"},
        list: { system_title: "اثاثہ جات کا انتظام", new_asset: "نیا اثاثہ", all_orgs: "تمام تنظیمیں", all_sites: "تمام سائٹس", db_total: "کل تعداد:", display_page: "صفحہ:", col_site: "سائٹ", col_org: "تنظیم", navigate_hint: "نیویگیٹ کرنے کے لیے تیر استعمال کریں", navigate_hint:"نیویگیٹ کرنے کے لیے تیر کا استعمال کریں۔", col_site: "سائٹ", col_org: "تنظیم"}, 
        modal: { migration_title: "اثاثوں کی منتقلی", caution_prefix: "انتباہ: آپ ", caution_suffix: "اثاثے منتقل کر رہے ہیں۔ اس سے ان کا مقام اور مالیاتی نقشہ فوری طور پر اپ ڈیٹ ہو جائے گا۔", dest_label: "نئی منزل", placeholder: "مقام منتخب کریں...", abort: "منسوخ", execute: "منتقلي شروع کریں" },
        headers: { asset_num: "اثاثہ نمبر", desc: "تفصیل", status: "حیثیت", downtime: "کل ڈاؤن ٹائم", site: "سائٹ" },
        tabs: { details: "اثاثہ کی تفصیلات", spare_parts: "اسپیئر پارٹس", safety: "حفاظت", meters: "میٹرز", specs: "وضاحتیں", history: "کام کی تاریخ", map: "نقشہ", bim: "3D منظر", ai: "AI تجزیہ", eval: "تشخیص", attachments: "منسلکات" },
        sections: { "linear_details": "لکیری حوالہ کی تفصیلات", general: "عام معلومات", details: "تفصیلات", finance: "پتہ اور مالیات", image: "اثاثہ کی تصویر", audit: "آڈٹ کی معلومات", bim_info: "BIM معلومات", reliability: "اعتماد کا تجزیہ" },
        fields: { "is_linear": "کیا یہ لکیری اثاثہ ہے؟", "start_measure": "شروع کی پیمائش", "end_measure": "اختتام کی پیمائش", "measure_unit": "پیمائش کی اکائی", "direction": "بہاؤ کی سمت", type: "اثاثہ کی قسم", location: "مقام", parent: "بنیادی اثاثہ", category: "اثاثہ کا زمرہ", is_running: "کیا اثاثہ چل رہا ہے؟", serial: "سیریل نمبر", item: "گھومنے والی چیز", failure: "خرابی کی قسم", safety_plan: "حفاظتی منصوبہ", vendor: "سپلائر", price: "خریداری کی قیمت", replace: "تبدیلی کی قیمت", priority: "ترجیح", ytd_cost: "سالانہ لاگت" },
        meters: { seq: "ترتیب", name: "میٹر", reading: "آخری ریڈنگ", date: "ریڈنگ کی تاریخ", inspector: "انسپکٹر", remarks: "ریمارکس" },
        ai: { title: "اثاثہ انٹیلی جنس", run: "تشخیص چلائیں", summary: "تکنیکی خلاصہ", recommend: "سفارشات", telemetry: "ڈیٹا کا تجزیہ ہو رہا ہے..." },
        spare_fields: { item: "گھومنے والی چیز", qty: "مقدار", issued: "جاری کردہ مقدار", remarks: "ریمارکس", item_details: "آئٹم کی تفصیلات" } ,
        safety: { plan_card: "منسلک حفاظتی منصوبے", active_plan: "فعال حفاظتی منصوبہ", no_plan: "کوئی منصوبہ منسلک نہیں", link_plan: "حفاظتی منصوبہ جوڑیں", change_plan: "منصوبہ تبدیل کریں", hazard_title: "اثاثہ کے مخصوص خطرات", hazard_num: "خطرہ", hazard_type: "قسم / ترجیح", no_hazards: "اس اثاثہ سے کوئی مخصوص خطرات منسلک نہیں ہیں۔", add_hazard: "خطرہ شامل کریں", loto_title: "لاک آؤٹ / ٹیگ آؤٹ (LOTO)", tag_id: "ٹیگ آؤٹ آئی ڈی", req_state: "مطلوبہ حالت", no_loto: "آئسولیشن پوائنٹس کی وضاحت نہیں کی گئی۔", add_loto: "آئسولیشن پوائنٹ شامل کریں", applying_proto: "حفاظتی پروٹوکول لاگو کیا جا رہا ہے..." },
        meters: { title: "منسلک میٹرز", details_title: "میٹر کی تفصیلات", seq: "ترتیب", meter_name: "میٹر کا نام", meter_type: "میٹر کی قسم", uom: "پیمائش کی اکائی", active_status: "فعال؟", last_reading: "آخری ریڈنگ", last_date: "ریڈنگ کی تاریخ", inspector: "انسپکٹر", remarks: "ریمارکس", new_meter: "نیا میٹر" },
        specs: { classification: "درجہ بندی", select_class: "درجہ بندی منتخب کریں...", tech_specs: "تکنیکی وضاحتیں", attribute: "صفت", value: "قیمت", uom: "پیمائش کی اکائی", data_type: "ڈیٹا کی قسم", attr_details: "صفت کی تفصیلات", select_val: "قیمت منتخب کریں" },
        history: { title: "کام کے آرڈر کی تاریخ", wo_num: "آرڈر نمبر", finish_date: "ختم ہونے کی تاریخ", no_history: "اس اثاثہ کے لیے کوئی سابقہ کام کے آرڈر نہیں ملے۔", fetching: "تاریخ حاصل کی جا رہی ہے...", wo_type: "قسم" },
        bim: { model_status: "ماڈل کی صورتحال", linked: "منسلک اور فعال", not_linked: "منسلک نہیں ہے", upload_revit: "ریوٹ فائل اپ لوڈ کریں (.rvt)", urn_label: "ماڈل URN", "show_3d": "ڈیجیٹل ٹوئن دیکھیں (3D)", "not_linked": "3D ماڈل سے منسلک نہیں ہے" },
        ai: { title: "اثاثہ کی ذہانت", sub_title: "AI تجزیہ کار", tagline: "صنعتی IoT کی پیشن گوئی کی تشخیص", run_btn: "تشخیص چلائیں", analyzing: "ٹیلی میٹری اسٹریم کا تجزیہ کیا جا رہا ہے...", health_score: "صحت کا اسکور", thermal: "تھرمل الرٹ", vibration: "وائبریشن الرٹ", tech_summary: "تکنیکی خلاصہ", recommendations: "توصیات", sensors_chart: "سینسر بمقابلہ اہم حدود", init_prompt: "AI تجزیہ شروع کرنے کے لیے تشخیص چلائیں پر کلک کریں", critical: "انتہائی اہم", normal: "نارمل", stable: "مستحکم", detected: "پتہ چلا", "predictive_trajectory": "متوقع خرابی کا راستہ", "est_failure": "متوقع خرابی", "loading_pred": "پیشن گوئی کا ماڈل تیار کیا جا رہا ہے..." },
        "features": {
          "feature_id": "فیچر کی شناخت",
          "label": "لیبل",
          "start": "شروع کی پیمائش",
          "end": "اختتامی پیمائش (خالی = نقطہ)",
          "value": "قدر (جیسے 500mm)",
          "details": "فیچر کی تفصیلات",
          "y_offset": "افقی ہٹاؤ (دائیں/بائیں)",
          "z_offset": "عمودی ہٹاؤ (گہرائی/اونچائی)"
        },
    
        
      }, 
      common: { "days": "دن", "weeks": "ہفتے", "months": "مہینے", "years": "سال", "daysList": {"saturday": "ہفتہ", "sunday": "اتوار", "monday": "پیر", "tuesday": "منگل", "wednesday": "بدھ", "thursday": "جمعرات", "friday": "جمعہ"}, "select": "منتخب کریں", "search": "تلاش کریں", "pending": "زیر التواء", "pendingSelection": "--- انتخاب کا انتظار ہے ---",confirm: "تصدیق", save_settings: "AI ترتیب محفوظ کریں", selected: "اثاثے منتخب", bulk_move: "بڑے پیمانے پر منتقلی", change_status: "حیثیت تبدیل کریں", cancel: "فلٹرز ختم کریں", save: "محفوظ کریں", cancel: "منسوخ", delete: "حذف", back: "واپس", record: "ریکارڈ", total: "کل", print: "پرنٹ", active: "فعال", critical: "انتہائی اہم", warning: "انتباہ", healthy: "درست", of: "کا", new_row: "نیا سطر", "save_success": "کامیابی سے محفوظ ہو گیا",     "save_fail": "محفوظ کرنے میں ناکامی", "delete": "حذف کریں", "delete_success": "کامیابی سے حذف ہو گیا", "delete_fail": "حذف کرنے میں ناکامی", "are_you_sure": "کیا آپ کو یقین ہے؟", "cancel": "منسوخ کریں", "confirm": "تصدیق کریں", "first": "پہلا", "last": "آخری", "next": "اگلا", "prev": "پچھلا", "sar": "ریال", "all": "تمام", "attachments": "منسلکات", "history": "تاریخ", "change_status": "حیثیت تبدیل کریں", "totalRecords": "کل ریکارڈز", "readOnly": "(صرف پڑھنے کے لیے)", "noDescription": "کوئی تفصیل نہیں", "recordLocked": "ریکارڈ مقفل ہے اور اس میں ترمیم نہیں کی جا سکتی۔", "descRequired": "تفصیل درکار ہے!", "actionDenied": "کارروائی سے انکار", "cantDeleteStatus": "اسٹیٹس {{status}} کے ساتھ حذف نہیں کیا جا سکتا", copy: "کاپی", cancel: "منسوخ کریں", clone: "کلون", back: "واپس", yes: "جی ہاں", no: "نہیں", "main": "مرکزی تفصیلات", "save": "محفوظ کریں", "change_status": "حالت تبدیل کریں", "history": "تاریخ", "delete": "حذف کریں", "org": "تنظیم", "site": "سائٹ", "new_row": "نئی قطار", "location": "مقام", "asset": "اثاثہ", "no_records": "کوئی ریکارڈ نہیں ملا", "saving": "محفوظ ہو رہا ہے...", "save_success": "کامیابی سے محفوظ ہو گیا!", "save_fail": "محفوظ کرنے میں ناکام", "are_you_sure": "کیا آپ کو یقین ہے؟", "yes_delete": "ہاں، اسے حذف کریں!", "cancel": "منسوخ کریں", "delete_success": "کامیابی سے حذف ہو گیا", "delete_fail": "حذف کرنے میں ناکام: ", "clear_filters": "فلٹرز صاف کریں", "all": "سب", "syncing": "ہم آہنگ ہو رہا ہے...", "showing": "دکھا رہا ہے", "total": "کل", "created_by": "تخلیق کنندہ", "changed_date": "تبدیلی کی تاریخ"},
      toasts: { save_success: "کامیابی سے محفوظ ہو گیا", save_fail: "محفوظ کرنے میں ناکامی", load_fail: "ڈیٹا لوڈ کرنے میں ناکامی", delete_success: "کامیابی سے حذف ہو گیا" },
      swal: { delete_title: "کیا آپ کو یقین ہے؟", delete_text: "آپ اس اثاثہ کو حذف کرنے والے ہیں:", confirm_delete: "جی ہاں، حذف کریں" },
      "ai_settings": {
        "title": "AI انجینئر کی ترتیبات",
        "sub_title": "AI پیش گوئی دیکھ بھال کا انجن",
        "enable_label": "خودکار پیش گوئی دیکھ بھال کو فعال کریں",
        "enable_sub": "AI تجزیہ کی بنیاد پر خودکار ورک آرڈر بنائیں",
        "target_lang": "رپورٹس اور کاموں کی زبان",
        "threshold": "فیصلے کے لیے اعتماد کی حد",
        "auto_tasks": "کام کے ٹاسک خودکار طور پر تیار کریں (WOTasks)",
        "task_desc": "ٹاسک ٹیبل میں کام کے مراحل خود بخود لکھیں",
        "max_tasks": "فی ورک آرڈر زیادہ سے زیادہ مراحل",
        "section": "سیکشن",
        "technicalDetails": "تکنیکی تفصیلات"
      },
      "export_technical_report": "تکنیکی رپورٹ ایکسپورٹ کریں (PDF)",
      "availability": "دستیابی",
      "mtbf": "MTBF (خرابیوں کے درمیان اوسط وقت)",
      "mttr": "MTTR (مرمت کا اوسط وقت)",
      "hrs": "گھنٹے",
      "reliability_score": "اعتبار کا اسکور",
      "score": "اسکور",
      "downtime_history_trend": "ڈاؤن ٹائم کی تاریخ کا رجحان (آخری 10 واقعات)",
      "values_in_hours": "قدریں گھنٹوں میں",
      "timeline_event_date": "ٹائم لائن (واقعہ کی تاریخ)",
      "downtime_hours": "ڈاؤن ٹائم (گھنٹے)",
      "no_downtime_records": "ابھی تک اس اثاثے کا کوئی ڈاؤن ٹائم ریکارڈ نہیں ملا۔",
      "reliability_analysis": "اعتبار کا تجزیہ",
      "total_failures": "کل خرابیاں",
      "total_down_time": "کل ڈاؤن ٹائم",
      "last_calculation": "آخری حساب کتاب",
      "maintenance_strategy_note": "بحالی کی حکمت عملی کا نوٹ",
      "high_mttr_detected": "زیادہ MTTR کا پتہ چلا۔ سفارش: اسپیئر پارٹس کی دستیابی اور تکنیکی تربیت کا جائزہ لیں۔",
      "critical_availability": "دستیابی کی نازک سطح۔ پی ایم کی فریکوئنسی بڑھانے پر غور کریں۔",
      "nominal_performance": "اثاثہ کی کارکردگی معمول کے مطابق ہے۔ معیاری پی ایم شیڈول جاری رکھیں۔",
      "current_load_factor": "موجودہ لوڈ فیکٹر",
      "optimal": "بہترین",
      statusModal: {
        "loadError": "سٹیٹس لوڈ نہیں ہو سکا",
        "selectFirst": "براہ کرم پہلے سٹیٹس منتخب کریں",
        "updating": "سٹیٹس اپ ڈیٹ ہو رہا ہے...",
        "success": "سٹیٹس اپ ڈیٹ ہو گیا",
        "failed": "اپ ڈیٹ ناکام",
        "changeStatus": "سٹیٹس تبدیل کریں:",
        "currentStatus": "موجودہ سٹیٹس",
        "availableStatuses": "دستیاب سٹیٹس",
        "loading": "لوڈ ہو رہا ہے...",
        "chooseStatus": "سٹیٹس منتخب کریں...",
        "memo": "جواز / میمو",
        "enterNotes": "اپنے نوٹس درج کریں...",
        "cancel": "منسوخ کریں",
        "update": "اپ ڈیٹ کریں"
      },
      attachmentsModal: {
        "loadError": "فائلیں لوڈ کرنے میں خرابی",
        "uploadSuccess": "فائل کامیابی سے منسلک ہو گئی",
        "uploadFailed": "اپ لوڈ ناکام",
        "deleteConfirmTitle": "کیا آپ کو یقین ہے؟",
        "deleteConfirmText": "آپ '{{name}}' کو مستقل طور پر حذف کرنے والے ہیں۔ یہ فائل کو ہمارے سرورز سے ہٹا دے گا۔",
        "btnYesDelete": "ہاں، اسے حذف کریں!",
        "btnCancel": "منسوخ کریں",
        "processingDelete": "حذف کیا جا رہا ہے...",
        "deletedTitle": "حذف ہو گیا!",
        "deletedText": "منسلکہ کامیابی سے ہٹا دیا گیا ہے۔",
        "deleteFailed": "حذف ناکام",
        "headerTitle": "منسلکہ لائبریری",
        "linkingTo": "منسلک:",
        "filesFound": "ملی ہوئی فائلیں:",
        "uploadBtn": "نیا دستاویز اپ لوڈ کریں",
        "thName": "نام",
        "thOwner": "مالک",
        "thStatus": "سٹیٹس",
        "thActions": "اقدامات",
        "statusPrivate": "نجی",
        "statusPublic": "عوامی",
        "noDocs": "ابھی تک کوئی دستاویز منسلک نہیں ہے"
      },
      enterMeters: {
        "noMeters": "اثاثے سے کوئی میٹر منسلک نہیں ہے:",
        "saving": "ریڈنگز محفوظ کی جا رہی ہیں...",
        "enterAtLeastOne": "براہ کرم کم از کم ایک نئی ریڈنگ درج کریں",
        "saveSuccess": "تمام ریڈنگز کامیابی سے محفوظ ہو گئیں!",
        "saveFailed": "ریڈنگز محفوظ کرنے میں ناکامی",
        "title": "میٹر کی ریڈنگز درج کریں | اثاثہ:",
        "titleLoc": "میٹر کی ریڈنگز درج کریں | مقام:",
        "thIdentification": "میٹر کی شناخت",
        "thNewReading": "* نئی ریڈنگ",
        "thReadingDate": "* ریڈنگ کی تاریخ",
        "thMeterType": "میٹر کی قسم",
        "thLastRecorded": "آخری ریکارڈ شدہ",
        "noDescription": "کوئی تفصیل نہیں",
        "enterValue": "ویلیو درج کریں...",
        "notAvailable": "دستیاب نہیں",
        "operator": "آپریٹر:",
        "btnCancel": "منسوخ کریں",
        "btnUpdate": "ریڈنگز اپ ڈیٹ کریں"
      },
      emailSettings: {
        "loadFailed": "ترتیبات لوڈ کرنے میں ناکام",
        "saveSuccess": "میل کی ترتیبات کامیابی سے محفوظ ہو گئیں!",
        "saveFailed": "ترتیبات محفوظ کرنے میں ناکام",
        "connecting": "SMTP سرور سے جڑ رہا ہے...",
        "connFailed": "کنکشن ناکام!",
        "title": "SMTP کنفیگریشن",
        "subtitle": "میل سرور کی ترتیبات",
        "outgoingTitle": "آؤٹ گوئنگ میل (SMTP - بھیجنا)",
        "incomingTitle": "انکمنگ میل (IMAP - نگرانی)",
        "lblHost": "SMTP ہوسٹ",
        "lblPort": "SMTP پورٹ",
        "lblUser": "SMTP یوزرنیم / ای میل",
        "lblPass": "SMTP پاس ورڈ",
        "lblSender": "سسٹم سینڈر ای میل (کی طرف سے)",
        "lblImapHost": "IMAP ہوسٹ",
        "lblImapPort": "IMAP پورٹ",
        "enableImap": "ان باکس کی نگرانی فعال کریں (RFQ ریڈار)",
        "imapDesc": "ان باکس سے وینڈر کی کوٹیشنز خودکار طور پر حاصل اور پارس کریں۔",
        "gmailNote": "جی میل کے لیے، گوگل سیکیورٹی سے 'ایپ پاس ورڈ' استعمال کریں۔ اکاؤنٹ کے پاس ورڈز 2FA کے ساتھ کام نہیں کریں گے۔",
        "btnTest": "ٹیسٹ",
        "btnCancel": "منسوخ کریں",
        "btnSave": "کنفیگریشن محفوظ کریں"
      },
      locationDetails: {
        "noBimModel": "اس مقام سے کوئی 3D ماڈل منسلک نہیں ہے",
        "noBimLinked": "یہ مقام BIM سے منسلک نہیں ہے",
        "locMandatory": "مقام ایک لازمی فیلڈ ہے!",
        "saving": "تبدیلیاں محفوظ کی جا رہی ہیں...",
        "saveSuccess": "مقام کامیابی کے ساتھ محفوظ ہو گیا",
        "saveFailed": "محفوظ کرنا ناکام:",
        "deleteTitle": "کیا آپ کو یقین ہے؟",
        "deleteText": "آپ مقام {{id}} کو حذف کرنے والے ہیں۔ یہ کارروائی واپس نہیں لی جا سکتی!",
        "btnYesDelete": "ہاں، اسے حذف کریں!",
        "btnCancel": "منسوخ کریں",
        "deleting": "مقام حذف کیا جا رہا ہے...",
        "deleteSuccess": "مقام کامیابی کے ساتھ حذف ہو گیا",
        "deleteFailed": "حذف ناکام!",
        "uploadingRevit": "Revit ماڈل اپ لوڈ اور ترجمہ کیا جا رہا ہے...",
        "revitSuccess": "ماڈل کامیابی سے منسلک ہو گیا!",
        "uploadFailed": "اپ لوڈ ناکام:",
        "loadingCtx": "مقام کا سیاق و سباق لوڈ کیا جا رہا ہے...",
        "tooltipChangeStatus": "سٹیٹس تبدیل کریں",
        "tooltipStatusHistory": "سٹیٹس کی تاریخ",
        "tooltipDelete": "حذف کریں",
        "btnSave": "محفوظ کریں",
        "lblLocation": "مقام",
        "lblDescription": "تفصیل",
        "btnRevitLinked": "Revit منسلک",
        "tabLocation": "مقام",
        "tabAssets": "اثاثے",
        "tabSpecs": "وضاحتیں",
        "tabSafety": "حفاظت",
        "tabMeters": "میٹرز",
        "tab3D": "3D ویو",
        "tabHistory": "تاریخ",
        "secIdentity": "مقام کی شناخت",
        "lblStatus": "سٹیٹس",
        "lblType": "قسم",
        "lblParentLoc": "آبائی مقام",
        "lblSiteID": "سائٹ ID",
        "secGeoInfo": "جغرافیائی اور پتے کی معلومات",
        "lblServiceAddr": "سروس کا پتہ",
        "lblBimSpaceId": "BIM سپیس ID",
        "lblGisCoords": "GIS کوآرڈینیٹس",
        "secRefImage": "حوالہ تصویر",
        "btnUploadPhoto": "تصویر اپ لوڈ کریں",
        "thAssetNum": "اثاثہ نمبر",
        "thStatus": "سٹیٹس",
        "lblClass": "درجہ بندی",
        "thAttr": "وصف",
        "thDesc": "تفصیل",
        "thValue": "قدر",
        "titleHazards": "اس مقام پر رپورٹ شدہ خطرات",
        "btnAddHazard": "خطرہ شامل کریں",
        "lblSelectHazards": "خطرات منتخب کریں",
        "thHazard": "خطرہ",
        "thPrecaution": "احتیاط",
        "titleLocMeters": "مقام کے میٹرز",
        "showingMeters": "دکھا رہا ہے {{current}} میں سے {{total}}",
        "noMetersDef": "کوئی میٹر متعین نہیں ہے",
        "thSeq": "سلسلہ",
        "thMeterNum": "میٹر نمبر",
        "thType": "قسم",
        "thUOM": "UOM",
        "thActive": "فعال",
        "newMeter": "نیا_میٹر",
        "clickNewRow": "اس مقام میں میٹر شامل کرنے کے لیے 'نئی قطار' پر کلک کریں",
        "titleMeterConfig": "میٹر کی تفصیلات کی ترتیب",
        "newEntry": "نئی انٹری",
        "lblMeterNum": "* میٹر نمبر",
        "lblMeterType": "میٹر کی قسم",
        "lblUOM": "پیمائش کی اکائی",
        "lblMeterActive": "میٹر فعال ہے",
        "lblLastReading": "آخری ریڈنگ",
        "lblReadingDate": "ریڈنگ کی تاریخ",
        "lblInspector": "میٹر انسپکٹر",
        "lblRemarks": "ریمارکس / تبصرے",
        "placeholderRemarks": "اس میٹر کے بارے میں تکنیکی نوٹ درج کریں...",
        "btnAddMeterRow": "میٹر کی نئی قطار شامل کریں",
        "titleModelStatus": "ماڈل کا سٹیٹس",
        "statusLinked": "منسلک اور فعال",
        "statusNotLinked": "منسلک نہیں",
        "btnUploadRevit": "Revit اپ لوڈ کریں (.rvt)",
        "titleHistory": "لین دین کی تاریخ اور آڈٹ لاگ",
        "lblChangedBy": "تبدیل کیا گیا بذریعہ:",
        "failedFetchAttr": "خصوصیات لانے میں ناکام"
      },
      locationList: {
        "loadFailed": " سرور سے مقامات لوڈ کرنے میں ناکام۔",
        "title": " مقامات",
        "searchPlaceholder": "گلوبل سرچ...",
        "btnClearAll": "سب صاف کریں",
        "btnExport": "ایکسپورٹ",
        "btnNewLocation": "نیا مقام",
        "thLocationId": "مقام کی شناخت",
        "thDescription": "تفصیل",
        "thType": "قسم",
        "thStatus": "سٹیٹس",
        "thSite": "سائٹ",
        "optAll": "سب",
        "optOperating": "آپریٹنگ",
        "optDecommissioned": "ڈیکمیشنڈ",
        "fetchingData": "سرور سے ڈیٹا لایا جا رہا ہے...",
        "noRecords": "کوئی مماثل ریکارڈ نہیں ملا۔",
        "recordsFound": "ملنے والے ریکارڈز:",
        "page": "صفحہ:"
      },
      "universalLookup": {
        "selectValue": "ویلیو منتخب کریں:",
        "total": "کل",
        "searchPlaceholder": "کوڈ یا تفصیل سے تلاش کریں...",
        "valueCode": "ویلیو / کوڈ",
        "description": "تفصیل",
        "site": "سائٹ",
        "synchronizing": "ہم آہنگ کیا جا رہا ہے...",
        "noRecords": "کوئی مماثل ریکارڈ نہیں ملا۔",
        "loadingMore": "مزید ریکارڈز لوڈ کیے جا رہے ہیں...",
        "results": "نتائج:",
        "cancel": "منسوخ کریں"
      },
      "statusHistory": {
        "title": "سٹیٹس آڈٹ ٹریل",
        "loading": "تاریخ لوڈ کی جا رہی ہے...",
        "noRecords": "اس آئٹم کے لیے کوئی سٹیٹس تبدیلیاں ریکارڈ نہیں کی گئیں۔",
        "initial": "ابتدائی",
        "btnClose": "بند کریں"
      },
      "personalInfo": {
        "updateSuccess": "پروفائل کامیابی سے اپ ڈیٹ ہو گئی",
        "sessionExpired": "سیشن ختم ہو گیا، براہ کرم دوبارہ لاگ ان کریں",
        "updateFailed": "اپ ڈیٹ ناکام",
        "title": "ذاتی معلومات اور ڈیفالٹس",
        "lblDisplayName": "مکمل ڈسپلے نام",
        "lblEmail": "ای میل ایڈریس",
        "lblDefaultOrg": "ڈیفالٹ تنظیم",
        "selectOrg": "تنظیم منتخب کریں...",
        "lblDefaultSite": "ڈیفالٹ سائٹ",
        "selectSite": "سائٹ منتخب کریں...",
        "lblDefaultLang": "ڈیفالٹ زبان",
        "btnCancel": "منسوخ کریں",
        "btnSave": "لاگو کریں اور تبدیلیاں محفوظ کریں",
        "securityTitle": "سیکیورٹی اور 2FA",
        "enable2FA": "ٹو فیکٹر تصدیق (2FA) فعال کریں",
        "googleAuth": "گوگل اتھنٹیکیٹر",
        "emailOTP": "ای میل OTP",
        "configure2FA": "2FA سیٹ اپ تشکیل دیں",
        "scanQR": "Google Authenticator کا استعمال کرتے ہوئے اس QR کوڈ کو اسکین کریں، اور تصدیق کے لیے نیچے 6 ہندسوں کا کوڈ درج کریں۔",
        "btnVerify": "تصدیق کریں",
        "setupSuccess": "2FA سیٹ اپ کامیاب ہو گیا!",
        "invalidCode": "تصدیقی کوڈ غلط ہے",
        "failedQR": "QR کوڈ بنانے میں ناکامی"
      },
      "appSettings": {
        "savingSettings": "ترتیبات محفوظ کی جا رہی ہیں...",
        "saveSuccess": "ترتیبات کامیابی سے اپ ڈیٹ ہو گئیں!",
        "saveFailed": "ترتیبات محفوظ کرنے میں ناکام۔",
        "title": "انٹرپرائز کنفیگریشن",
        "org": "تنظیم",
        "tabs": {
          "WORKORDER": "ورک آرڈرز",
          "ASSET": "اثاثہ رجسٹری",
          "INVENTORY": "گودام اور اسٹاک",
          "PURCHASE": "خریداری",
          "PR": "پی آر",
          "JP": "جے پی",
          "PM": "پی ایم",
          "MR": "ایم آر",
          "SR": "ایس آر"
        },
        "systemRules": "{{tab}} سسٹم کے اصول",
        "prefix": "سلسلے کا سابقہ",
        "preview": "پیش نظارہ",
        "seed": "ابتدائی ویلیو (Seed)",
        "valuationStrategy": "تشخیص کی حکمت عملی",
        "movingAvg": "متحرک اوسط (تجویز کردہ)",
        "fifo": "پہلے آئیں، پہلے پائیں (FIFO)",
        "lifo": "آخر میں آئیں، پہلے پائیں (LIFO)",
        "allowNegative": "منفی بیلنس کی اجازت دیں",
        "negativeWarning": "انتباہ: مالی درستی کو متاثر کرتا ہے",
        "encrypting": "انکرپٹ اور منتقل کیا جا رہا ہے...",
        "auditLogged": "تمام تبدیلیاں آڈٹ ٹریل میں لاگ ہوتی ہیں",
        "btnCancel": "منسوخ کریں",
        "btnSave": "سسٹم پالیسی محفوظ کریں"
      },
      "workflowAction": {
        "successMove": "ورک فلو کامیابی سے آگے بڑھ گیا! 🚀",
        "failedMove": "اقدام ناکام ہو گیا",
        "btnRoute": "ورک فلو روٹ کریں",
        "modalTitle": "ورک فلو ایکشن",
        "assignedAs": "آپ کو تفویض کیا گیا بطور:",
        "defaultInstruction": "براہ کرم جائزہ لیں اور کارروائی کریں۔",
        "lblChoosePath": "راستہ منتخب کریں",
        "valSelectPath": "براہ کرم راستہ منتخب کریں",
        "optApprove": "منظور کریں / آگے بڑھیں",
        "optReject": "مسترد کریں / واپس کریں",
        "lblMemo": "ایکشن میمو / تبصرے",
        "placeholderMemo": "اپنے تبصرے یہاں شامل کریں...",
        "btnCancel": "منسوخ کریں",
        "btnComplete": "مرحلہ مکمل کریں"
      },
      "meterHistory": {
        "title": "تاریخی میٹر ریڈنگز",
        "lblAsset": "اثاثہ",
        "fetching": "آرکائیوز لائے جا رہے ہیں...",
        "noRecords": "اس اثاثے کے لیے کوئی تاریخی ریڈنگ نہیں ملی۔",
        "thMeterName": "میٹر کا نام",
        "thReadingVal": "ریڈنگ کی ویلیو",
        "thReadingDate": "ریڈنگ کی تاریخ",
        "thEnteredBy": "درج کیا گیا بذریعہ",
        "thEntryDate": "اندراج کی تاریخ",
        "btnClose": "تاریخ بند کریں",
        "lblLocation": "مقام",
        "noRecordsLoc": "اس مقام کے لیے کوئی تاریخی ریڈنگ نہیں ملی۔",
      },
      "rpt_print": "رپورٹیں پرنٹ کریں۔",
      no_templates: "کوئی ٹیمپلیٹس دستیاب نہیں ہیں۔",
      "wo": {
        "tabs": { "workOrder": "ورک آرڈر", "plans": "منصوبے", "assignments": "تفویضات", "actuals": "حقیقی", "safety": "حفاظت", "failure": "ناکامی کی رپورٹ" },
        "subTabs": { "tasks": "کام", "labor": "مزدور", "materials": "مواد", "tools": "ٹولز", "services": "خدمات" },
        "headers": { "workOrder": "ورک آرڈر", "status": "حیثیت", "totalCost": "کل لاگت", "activeSla": "فعال SLA نگرانی", "targetRes": "ہدف کا حل", "targetResp": "ہدف کا جواب" },
        "sections": { "assetDetails": "اثاثے کی تفصیلات", "scheduling": "شیڈولنگ کی معلومات", "responsibility": "ذمہ داری", "laborAssign": "لیبر تفویضات", "totalAssign": "کل تفویضات" },
        "fields": { "description": "تفصیل", "location": "مقام", "asset": "اثاثہ", "workType": "کام کی قسم", "safetyCode": "سیفٹی کوڈ", "supervisor": "سپروائزر", "failureClass": "ناکامی کی کلاس", "targStart": "ہدف کا آغاز", "targFinish": "ہدف کا اختتام", "schedStart": "شیڈول آغاز", "schedFinish": "شیڈول اختتام", "earlyStart": "اس سے پہلے شروع نہ کریں", "lateFinish": "اس کے بعد ختم نہ کریں", "actStart": "حقیقی آغاز", "actFinish": "حقیقی اختتام", "duration": "دورانیہ", "timeRemaining": "باقی وقت", "predecessors": "پیشرو", "includeTasks": "شیڈول میں شامل کریں؟", "site": "سائٹ", "organization": "تنظیم", "priorityHigh": "ترجیح: اعلی (سطح 1)" },
        "actions": { "routeWorkflow": "ورک فلو کو روٹ کریں", "wfHistory": "ورک فلو کی تاریخ", "changeStatus": "حیثیت تبدیل کریں", "attachments": "منسلکات", "printWO": "ورک آرڈر پرنٹ کریں", "printSafety": "سیفٹی شیٹ پرنٹ کریں", "history": "حیثیت کی تاریخ", "newTask": "نیا کام", "selectLoc": "مقام منتخب کریں", "selectAsset": "اثاثہ منتخب کریں", "selectType": "کام کی قسم منتخب کریں", "selectSafety": "سیفٹی پلان منتخب کریں", "selectSup": "سپروائزر منتخب کریں", "selectFail": "ناکامی کی کلاس منتخب کریں", "selectCraft": "ہنر منتخب کریں", "selectLabor": "مزدور منتخب کریں", "selectItem": "آئٹم منتخب کریں", "selectStore": "اسٹور منتخب کریں", "selectTool": "ٹول منتخب کریں", "addLabor": "مزدور شامل کریں", "addMaterial": "مواد شامل کریں", "addTool": "ٹول شامل کریں", "addService": "سروس شامل کریں", "newAssign": "نئی تفویض", "compAssign": "تفویض مکمل کریں", "createMR": "مواد کی درخواست بنائیں", "yesCreate": "ہاں، نئی درخواست بنائیں", "yesChange": "ہاں، اسے تبدیل کریں", "approve": "منظور کریں", "cancel": "منسوخ کریں", "startWork": "کام شروع کریں", "close": "بند کریں", "complete": "مکمل", "selectProblem": "مسئلہ منتخب کریں", "selectCause": "وجہ منتخب کریں", "selectRemedy": "علاج منتخب کریں" },
        "tables": { "sequence": "ترتیب", "taskDesc": "کام کی تفصیل", "estDur": "متوقع دورانیہ", "status": "حیثیت", "craft": "ہنر", "labor": "مزدور", "qty": "مقدار", "hrs": "گھنٹے", "rate": "شرح", "lineCost": "لائن کی لاگت", "lineType": "لائن کی قسم", "itemNum": "آئٹم #", "description": "تفصیل", "unitCost": "یونٹ کی لاگت", "storeroom": "اسٹور روم", "item": "آئٹم", "material": "مواد", "toolNum": "ٹول #", "serviceDesc": "سروس کی تفصیل", "vendor": "وینڈر", "cost": "لاگت", "start": "آغاز", "finish": "اختتام", "failCode": "ناکامی کا کوڈ" },
        "footer": { "totalLabor": "کل مزدور", "totalMaterial": "کل مواد", "assigned": "مختص (تخمینہ)", "toolsServ": "ٹولز اور خدمات", "totalActual": "کل حقیقی لاگت" },
        "safety": { "hazardsTitle": "خطرات اور مطلوبہ احتیاطیں", "hazardCode": "خطرہ کوڈ", "hazardDesc": "خطرہ کی تفصیل", "precautions": "مطلوبہ احتیاطیں / اقدامات", "noHazards": "کوئی خطرات نہیں ہیں۔", "lotoTitle": "لاک آؤٹ / ٹیگ آؤٹ", "step": "قدم", "tagNum": "ٹیگ نمبر", "isoDesc": "آئسولیشن کی تفصیل", "reqState": "مطلوبہ حالت", "completed": "مکمل؟", "noLoto": "کسی آئسولیشن کی ضرورت نہیں ہے۔" },
        "failure": { "title": "ناکامی کا تجزیہ", "currClass": "موجودہ ناکامی کی کلاس", "notDefined": "غیر متعین", "problems": "مسائل", "causes": "وجوہات", "remedies": "علاج", "records": "ریکارڈز" },
        "placeholders": { "desc": "ورک آرڈر کی تفصیل درج کریں...", "taskDesc": "کام کی تفصیل..." },
        "messages": { "loadError": "لوڈ کرنے میں خرابی", "taskStatusLocal": "کام کی حیثیت کو مقامی طور پر اپ ڈیٹ کر دیا گیا", "selectItemStore": "براہ کرم پہلے آئٹم اور اسٹور روم منتخب کریں", "duplicateReqTitle": "ڈپلیکیٹ آئٹم کی درخواست", "duplicateReqText": "آئٹم {{item}} کے لیے ایک MR موجود ہے۔ ایک اور بنائیں؟", "creatingMR": "MR بنایا جا رہا ہے...", "mrCreated": "MR {{num}} کامیابی سے بن گیا", "mrFail": "MR بنانے میں ناکامی", "confirmStatusChange": "کیا آپ حیثیت کو {{status}} میں تبدیل کرنا چاہتے ہیں؟", "statusSuccess": "حیثیت کامیابی سے تبدیل ہو گئی", "statusFail": "حیثیت تبدیل کرنے میں ناکامی", "saving": "محفوظ کیا جا رہا ہے...", "deleteConfirm": "آپ {{wonum}} کو حذف کرنے والے ہیں۔ یہ عمل ناقابل واپسی ہے!", "saveBeforeSLA": "SLA لاگو کرنے سے پہلے محفوظ کریں", "slaExists": "SLA پہلے ہی لاگو ہے!", "matchingSLA": "SLA ملایا جا رہا ہے...", "slaApplied": "SLA کامیابی سے لاگو ہو گیا", "noMatchingSLA": "کوئی مماثل SLA نہیں ملا", "slaError": "SLA انجن سے رابطے میں خرابی", "failureTreeLoaded": "ڈیفالٹ ناکامی کے کوڈز لاگو ہو گئے", "zeroBalance": "انتباہ: {{store}} میں صفر بیلنس", "balanceOk": "قیمت: {{cost}} - بیلنس: {{bal}}", "storeError": "اسٹور روم سے جڑنے میں ناکامی", "assetLinked": "اثاثہ منسلک: {{asset}}", "openAssignError": "{{count}} تفویضات نامکمل ہیں۔ بند نہیں کیا جا سکتا۔", "budgetExceeded": "بجٹ سے تجاوز ہو گیا!", "assignComplete": "تفویض کامیابی سے مکمل ہو گئی", "actionNotAllowed": "{{status}} کے لیے یہ عمل منع ہے۔", "locked": "مقفل", "cantChangeCancel": "منسوخ شدہ درخواستیں حیثیت نہیں بدل سکتیں", "printFail": "پی ڈی ایف بنانے میں ناکامی", "wfRouted": "ورک فلو کامیابی سے روٹ ہو گیا! 🚀", "wfFail": "ورک فلو کو روٹ کرنے میں ناکامی", "taskStatusChanged": "کام {{task}} کی حیثیت {{status}} میں تبدیل ہو گئی", "noLaborAssign": "ابھی تک کوئی مزدور تفویض نہیں کیا گیا۔", "updateTaskProg": "منصوبہ بند کاموں کی پیشرفت اپ ڈیٹ کریں", "noMaterials": "ابھی تک کوئی مواد نہیں ہے۔ شامل کرنے کے لیے بٹن پر کلک کریں۔", "linkedMRs": "منسلک مواد کی درخواستیں", "stocknobalance": "⚠️ وارننگ: اس آئٹم کا گودام میں بیلنس (صفر) ہے۔" },
        "linearDefect": {
          "title": "لکیری نقص کا مقام",
          "startMeasure": "ابتدائی پیمائش",
          "endMeasure": "آخری پیمائش (اختیاری)",
          "unit": "اکائی",
          "yOffset": "وائی-آفسیٹ (میٹر)"
        },
        "costs": {
          "title": "ورک آرڈر کے اخراجات",
          "estimated": "تخمینہ شدہ اخراجات",
          "actual": "اصل اخراجات",
          "labor": "مزدوری",
          "materials": "مواد",
          "tools": "اوزار",
          "services": "خدمات",
          "total": "کل",
          "variance": "فرق (اصل - تخمینہ)",
          "calculating": "حساب لگایا جا رہا ہے...",
          "no_data": "کوئی ڈیٹا دستیاب نہیں."
        },
        "purchase_info": {
          "title": "متعلقہ خریداری کی معلومات",
          "mr_title": "مواد کی درخواستیں (MR)",
          "pr_title": "خریداری کی درخواستیں (PR)",
          "po_title": "خریداری کے آرڈر (PO)",
          "mr_num": "ایم آر نمبر",
          "pr_num": "پی آر نمبر",
          "po_num": "پی او نمبر",
          "vendor": "فروش",
          "status": "حیثیت",
          "req_date": "مطلوبہ تاریخ",
          "total_cost": "کل قیمت",
          "fetching": "ڈیٹا حاصل کیا جا رہا ہے...",
          "no_records": "کوئی ریکارڈ نہیں ملا."
        },
    
      },
      "pm": {
        "tabs": { "pm": "پی ایم", "frequency": "فریکوئنسی", "sequence": "ترتیب", "seasonaldates": "موسمی تاریخیں", "forecast": "پیشین گوئی" },
        "sections": { "assetLoc": "اثاثہ اور جغرافیائی مقام", "defaults": "ڈیفالٹس", "compliance": "تعمیل میٹا ڈیٹا", "siteContext": "سائٹ کی معلومات", "timeBased": "وقت پر مبنی ترتیب", "meters": "میٹر ریڈنگز", "sequences": "جاب پلان کی ترتیب", "seasonal": "ہفتہ وار شیڈول", "projections": "پروجیکشن لاگز" },
        "fields": { "pmNum": "پی ایم نمبر", "description": "تفصیل", "status": "حیثیت", "site": "سائٹ", "asset": "اثاثہ", "location": "مقام", "route": "راستہ", "counter": "موجودہ کاؤنٹر", "jpnum": "جاب پلان", "worktype": "کام کی قسم", "supervisor": "سپروائزر", "glaccount": "جی ایل اکاؤنٹ", "woStatus": "ابتدائی حیثیت", "priority": "ترجیح", "lastStart": "آخری آغاز", "lastComp": "آخری تکمیل", "nextDue": "اگلی مقررہ تاریخ", "forecastFlag": "پیشین گوئی فلیگ", "org": "تنظیم", "freqInt": "فریکوئنسی کا وقفہ", "freqUnit": "اکائی", "targStart": "ہدف کا وقت" },
        "actions": { "forecast": "پیشین گوئی", "savePM": "محفوظ کریں", "addMeter": "میٹر شامل کریں", "addStep": "قدم شامل کریں", "newPM": "نیا پی ایم ریکارڈ" },
        "tables": { "meterName": "میٹر کا نام", "freq": "فریکوئنسی", "nextProj": "اگلی پیشین گوئی", "seq": "ترتیب", "jpnum": "جاب پلان", "fcDate": "تاریخ", "targetJp": "ہدف جاب پلان", "estCost": "تخمینہ لاگت", "status": "حیثیت", "woNum": "ورک آرڈر #", "generated": "تیار کردہ", "projected": "متوقع" },
        "messages": { "executingForecast": "انجن چل رہا ہے...", "forecastSuccess": "پیشین گوئی کامیاب", "forecastFail": "حساب میں ناکامی", "seasonalInfo": "صرف منتخب دن مجاز ہیں۔", "noMeters": "کوئی میٹر نہیں ہے۔", "noSeq": "ترتیب غیر فعال ہے۔", "noForecasts": "کوئی پیشین گوئی نہیں ہے۔", "showingProjections": "{{count}} نتائج دکھا رہا ہے", "fetchListError": "پی ایم ریکارڈ لانے میں ناکامی", "syncingList": "سرور کے ساتھ سنک ہو رہا ہے...", "noRecords": "کوئی ریکارڈ نہیں ملا۔" },
        "placeholders": { "desc": "تفصیل یہاں درج کریں...", "globalSearch": "عالمی سمارٹ تلاش..." },
        "headers": { "masterDir": "پی ایم ماسٹر ڈائرکٹری" },
        "footer": { "dbTotal": "ڈیٹا بیس کل:", "currentPage": "موجودہ صفحہ:", "useNavArrows": "تیر کا استعمال کریں" },
      },
      "workflowHistory": {
        "title": "ورک فلو آڈٹ ٹریل",
        "trackingId": "ٹریکنگ آئی ڈی:",
        "fetching": "ریکارڈ لائے جا رہے ہیں...",
        "currentTask": "موجودہ فعال کام",
        "since": "سے:",
        "by": "بذریعہ",
        "noHistory": "ابھی تک کوئی تاریخ درج نہیں کی گئی",
        "closeBtn": "تاریخ بند کریں"
      },
      "pr": {
        "headers": { "prList": "خریداری کی درخواستیں" },
        "actions": { "newPR": "نئی درخواست", "clearFilters": "فلٹرز صاف کریں", "routeWf": "ورک فلو روٹ کریں" },
        "tabs": { "pr": "خریداری کی درخواست", "prlines": "درخواست کی لائنیں" },
        "sections": { "general": "عام معلومات", "financial": "مالیاتی خلاصہ" },
        "fields": { "prNum": "درخواست نمبر", "requestedBy": "درخواست دہندہ", "reqDate": "مطلوبہ تاریخ", "refMr": "حوالہ ایم آر", "vendor": "وینڈر", "glAccount": "جی ایل اکاؤنٹ" },
        "financial": { "subtotal": "ذیلی کل", "taxTotal": "کل ٹیکس", "grandTotal": "مجموعی کل" },
        "tables": { "prNum": "درخواست نمبر", "description": "تفصیل", "status": "سٹیٹس", "totalCost": "کل لاگت", "reqDate": "تاریخ", "site": "سائٹ", "itemNum": "آئٹم نمبر", "itemType": "آئٹم کی قسم", "qty": "مقدار", "unitCost": "یونٹ کی قیمت", "tax": "ٹیکس", "lineTotal": "لائن کا کل", "taxCat": "ٹیکس کیٹیگری" },
        "messages": { "loadFailed": "درخواستیں لوڈ کرنے میں ناکامی", "syncing": "ریکارڈز ہم آہنگ ہو رہے ہیں...", "noData": "کوئی ڈیٹا نہیں ملا", "noLines": "ابھی تک کوئی لائن شامل نہیں کی گئی۔", "fetchingMRLines": "ایم آر لائنز لائی جا رہی ہیں: {{mrnum}}...", "loadedMRLines": "{{count}} لائنز لوڈ ہو گئیں", "noMRLines": "اس ایم آر میں کوئی لائنز نہیں ہیں", "failedMRLines": "ایم آر لائنز لانے میں ناکامی" },
        "swal": { "lockedTitle": "مقفل", "cantDeleteStatus": "اسٹیٹس {{status}} کے ساتھ حذف نہیں کیا جا سکتا", "cantChangeCancel": "منسوخ شدہ درخواستوں کی حیثیت تبدیل نہیں کی جا سکتی", "deleteWarnText": "یہ خریداری کی درخواست اور اس کی تمام لائنوں کو مستقل طور پر حذف کر دے گا۔" },
        "placeholders": { "desc": "درخواست کی تفصیل لکھیں...", "globalSearch": "عالمی سمارٹ تلاش..." },
        "footer": { "showing": "دکھا رہا ہے", "totalRecords": "کل ریکارڈز" }
      },
      "po": {
        "headers": { "poList": "خریداری کے آرڈرز" },
        "actions": { "newPO": "نیا آرڈر", "clearFilters": "فلٹرز صاف کریں", "routeWf": "ورک فلو روٹ کریں", "addManualRow": "دستی قطار شامل کریں", "wfHistory": "ورک فلو کی تاریخ" },
        "tabs": { "po": "خریداری آرڈر", "polines": "آرڈر کی لائنیں" },
        "sections": { "general": "عام معلومات", "financial": "مالیاتی خلاصہ", "lines": "خریداری آرڈر کی لائنیں" },
        "fields": { "poNum": "آرڈر نمبر", "requestedBy": "درخواست دہندہ", "orderDate": "آرڈر کی تاریخ", "refPr": "حوالہ پی آر", "vendor": "وینڈر", "glAccount": "جی ایل اکاؤنٹ" },
        "financial": { "subtotal": "ذیلی کل", "taxTotal": "ٹیکس کی رقم", "grandTotal": "مجموعی کل" },
        "tables": { "poNum": "آرڈر نمبر", "totalCost": "کل لاگت", "orderDate": "آرڈر کی تاریخ", "itemNum": "آئٹم نمبر", "itemType": "آئٹم کی قسم", "unitCost": "یونٹ کی قیمت", "tax": "ٹیکس", "lineTotal": "لائن کا کل", "taxCat": "ٹیکس کیٹیگری" },
        "messages": { "loadFailed": "آرڈرز لوڈ کرنے میں ناکامی", "syncing": "ہم آہنگ ہو رہا ہے...", "noData": "کوئی مماثل آرڈر نہیں ملا", "noLines": "کوئی لائن شامل نہیں کی گئی۔", "vendorRequired": "محفوظ کرنے یا حیثیت تبدیل کرنے سے پہلے وینڈر لازمی ہے۔", "fetchingLines": "حوالہ کی لائنز لائی جا رہی ہیں: {{num}}...", "loadedLines": "{{count}} لائنز کامیابی سے لوڈ ہو گئیں", "noLinesFound": "اس حوالے میں کوئی لائنز نہیں ہیں", "failedLines": "لائنز لانے میں ناکامی", "cantChangeCancel": "منسوخ شدہ درخواستیں حیثیت نہیں بدل سکتیں", "cantDeleteStatus": "اسٹیٹس {{status}} کے ساتھ حذف نہیں کیا جا سکتا" },
        "swal": { "deleteWarnText": "یہ خریداری آرڈر اور اس کی تمام لائنوں کو مستقل طور پر حذف کر دے گا۔" },
        "placeholders": { "desc": "تفصیل درج کریں...", "globalSearch": "عالمی تلاش..." },
        "footer": { "showing": "دکھا رہا ہے" }
      },
      "mr": {
        "headers": { "mrList": "مواد کی درخواستیں" },
        "actions": { "newMR": "نئی درخواست", "clearFilters": "فلٹرز صاف کریں", "routeWf": "ورک فلو روٹ کریں", "createUsage": "استعمال بنائیں", "createUsageDesc": "ایشو/ٹرانسفر ریکارڈ بنائیں", "createPR": "پی آر بنائیں", "createPRDesc": "خریداری کی درخواست بنائیں", "addMaterial": "مواد شامل کریں" },
        "tabs": { "mr": "درخواست کی معلومات", "mrlines": "درخواست کی لائنیں" },
        "sections": { "general": "عام معلومات", "financial": "مالیاتی خلاصہ", "mrItems": "مواد کی درخواست کے آئٹمز", "financialCharging": "مالیاتی چارجنگ کی تفصیلات" }, 
        "fields": { "mrNum": "درخواست نمبر", "requestedBy": "درخواست دہندہ", "reqDate": "مطلوبہ تاریخ", "refMr": "حوالہ ایم آر", "vendor": "وینڈر", "glAccount": "جی ایل اکاؤنٹ", "targetStore": "ہدف اسٹور", "chargeLoc": "چارج کا مقام", "chargeAsset": "چارج اثاثہ", "chargeWO": "چارج ورک آرڈر" },
        "financial": { "subtotal": "ذیلی کل", "taxTotal": "کل ٹیکس", "grandTotal": "مجموعی کل" },
        "tables": { "mrNum": "درخواست نمبر", "description": "تفصیل", "status": "سٹیٹس", "totalCost": "کل لاگت", "enteredDate": "اندراج کی تاریخ", "site": "سائٹ", "itemNum": "آئٹم نمبر", "itemType": "آئٹم کی قسم", "qty": "مقدار", "unitCost": "یونٹ کی قیمت", "tax": "ٹیکس", "lineTotal": "لائن کا کل", "taxCat": "ٹیکس کیٹیگری", "stockItem": "اسٹاک آئٹم", "qtyReq": "مطلوبہ مقدار", "estUnitCost": "تخمینی یونٹ لاگت" }, 
        "messages": { "loadFailed": "درخواستیں لوڈ کرنے میں ناکامی", "syncing": "ریکارڈز ہم آہنگ ہو رہے ہیں...", "noData": "کوئی ڈیٹا نہیں ملا", "noLines": "ابھی تک کوئی لائن شامل نہیں کی گئی۔", "fetchingMRLines": "ایم آر لائنز لائی جا رہی ہیں: {{mrnum}}...", "loadedMRLines": "{{count}} لائنز لوڈ ہو گئیں", "noMRLines": "اس ایم آر میں کوئی لائنز نہیں ہیں", "failedMRLines": "لائنز لانے میں ناکامی", "generating": "{{docType}} بنایا جا رہا ہے...", "generatedSuccess": "{{docType}} {{docnum}} کامیابی سے بن گیا!", "generateFail": "{{docType}} بنانے میں ناکامی", "storeRequired": "اسٹور درکار ہے!", "dateRequired": "مطلوبہ تاریخ درکار ہے!" }, 
        "swal": { "lockedTitle": "مقفل", "cantDeleteStatus": "اسٹیٹس {{status}} کے ساتھ حذف نہیں کیا جا سکتا", "cantChangeCancel": "منسوخ شدہ درخواستوں کی حیثیت تبدیل نہیں کی جا سکتی", "deleteWarnText": "یہ مواد کی درخواست اور اس کی تمام لائنوں کو مستقل طور پر حذف کر دے گا۔" },
        "placeholders": { "desc": "درخواست کی تفصیل لکھیں...", "globalSearch": "عالمی سمارٹ تلاش...", "chooseLoc": "مقام منتخب کریں", "selectAsset": "اثاثہ منتخب کریں", "chargeWO": "ورک آرڈر پر چارج کریں" },
        "lookups": { "storerooms": "اسٹور رومز", "inventory": "انوینٹری تلاش", "locations": "سائٹ کے مقامات", "assets": "اثاثہ رجسٹری", "workorders": "ورک آرڈرز" },
        "footer": { "showing": "دکھا رہا ہے", "totalRecords": "کل ریکارڈز" }
      },
      "contract": {
        "headers": { "masterNode": "کنٹریکٹس ماسٹر نوڈ" },
        "placeholders": { "globalSearch": "عالمی تلاش...", "desc": "کنٹریکٹ کا خلاصہ درج کریں...", "termDesc": "شرط کی تفصیلات لکھیں..." },
        "actions": { "newContract": "نیا کنٹریکٹ", "save": "محفوظ کریں", "addTerm": "شرط شامل کریں", "addLine": "لائن شامل کریں", "wfHistory": "ورک فلو ٹائم لائن" },
        "tabs": { "general": "عمومی", "slaperformance": "SLA (کارکردگی)", "termslegal": "شرائط و ضوابط", "contractlines": "کنٹریکٹ لائنز" },
        "sections": { "identity": "کنٹریکٹ کی شناخت اور مدت", "communication": "مواصلات کا مرکز", "auditInfo": "آڈٹ کی معلومات", "masterSLA": "SLA ربط", "slaBenchmarks": "سروس لیول کے معیارات", "termsList": "قانونی شرائط", "lines": "کام کا دائرہ / سپلائی لائنز" },
        "options": { "supply": "سپلائی کنٹریکٹ", "labor": "لیبر/سروس کنٹریکٹ", "lease": "لیز کا معاہدہ", "allTypes": "تمام اقسام", "allStatus": "تمام حالات", "general": "عمومی", "payment": "ادائیگی", "termination": "خاتمہ", "warranty": "وارنٹی", "liability": "ذمہ داری" },
        "fields": { "contractNum": "کنٹریکٹ نمبر", "vendorRef": "وینڈر", "startDate": "شروع کی تاریخ", "endDate": "ختم ہونے کی تاریخ", "contractValue": "کنٹریکٹ کی مالیت", "currency": "کرنسی", "contactPerson": "رابطہ کرنے والا شخص", "vendorEmail": "وینڈر کا ای میل", "slaRef": "SLA حوالہ", "respTime": "جواب کا وقت (گھنٹے)", "resTime": "حل کا وقت (گھنٹے)", "uptime": "دستیابی کا ہدف (%)", "penalty": "جرمانہ فی گھنٹہ", "grandTotal": "مجموعی کل" },
        "tables": { "contractNum": "کنٹریکٹ نمبر", "grandTotal": "مجموعی کل", "clauseType": "شرط کی قسم", "clauseDesc": "تفصیل", "lineDesc": "لائن کی تفصیل", "rate": "ریٹ", "lineTotal": "کل" },
        "messages": { "fetchError": "کنٹریکٹس لانے میں ناکامی", "syncing": "ہم آہنگ ہو رہا ہے...", "noData": "کوئی ڈیٹا نہیں ملا", "descMandatory": "تفصیل لازمی ہے", "vendorSelected": "وینڈر {{name}} منتخب ہو گیا", "noTerms": "کوئی قانونی شرائط نہیں ہیں", "noLines": "کوئی لائن آئٹمز نہیں ہیں", "slaHint": "SLA کو جوڑنے سے اس کے قواعد خود بخود لاگو ہوتے ہیں۔" },
        "swal": { "deleteTitle": "حتمی حذف؟", "deleteText": "یہ کنٹریکٹ اور اس کی تمام شرائط کو مستقل طور پر مٹا دے گا۔" },
        "footer": { "masterRecords": "ماسٹر ریکارڈز:", "currentPage": "موجودہ صفحہ:" }
      },
      "rfq": {
        "headers": { "rfqList": "کوٹیشنز کا انتظام" },
        "tabs": { "rfq": "آر ایف کیو", "rfqlines": "آر ایف کیو لائنیں", "quotations": "کوٹیشنز" },
        "sections": { "general": "عام معلومات", "financial": "مالیاتی خلاصہ" },
        "fields": { "requestedBy": "درخواست دہندہ", "reqDate": "مطلوبہ تاریخ", "refPr": "حوالہ پی آر", "vendor": "وینڈر", "vendorEmail": "وینڈر ای میل", "glAccount": "جی ایل اکاؤنٹ" },
        "financial": { "subtotal": "ذیلی کل", "taxTotal": "کل ٹیکس", "grandTotal": "مجموعی کل" },
        "tables": { "rfqNum": "نمبر", "totalCost": "کل لاگت", "itemNum": "آئٹم نمبر", "itemType": "قسم", "unitCost": "یونٹ لاگت", "tax": "ٹیکس", "taxCat": "ٹیکس کیٹیگری" },
        "options": { "awarded": "ایوارڈ دیا گیا" },
        "actions": { "newRFQ": "نئی درخواست", "sendEmail": "ای میل بھیجیں", "wfHistory": "ورک فلو کی تاریخ", "award": "ایوارڈ دیں اور PO بنائیں" },
        "messages": { "loadFailed": "درخواستیں لوڈ کرنے میں ناکامی", "syncing": "ریکارڈز ہم آہنگ ہو رہے ہیں...", "noData": "کوئی ریکارڈ نہیں ملا", "noLines": "کوئی لائن شامل نہیں کی گئی", "pullingPR": "لائنز کھینچی جا رہی ہیں...", "prImported": "لائنز درآمد ہو گئیں!", "prFailed": "درآمد ناکام", "noEmail": "ای میل غائب ہے!", "sending": "PDF بن رہا ہے اور ای میل بھیجی جا رہی ہے...", "sendSuccess": "ای میل بھیج دی گئی!", "sendFailed": "ای میل ناکام", "quotesHint": "وینڈرز کی کوٹیشنز یہاں خود بخود ظاہر ہوں گی۔", "noQuotes": "کوئی کوٹیشن موصول نہیں ہوئی۔", "awarding": "PO بنایا جا رہا ہے...", "awardSuccess": "ایوارڈ دیا گیا!", "poCreated": "PO بن گیا", "awardFailed": "ایوارڈ دینا ناکام" },
        "swal": { "sendTitle": "ای میل بھیجیں؟", "sendText": "کیا آپ اسے {{vendor}} کو بھیجنا چاہتے ہیں؟", "awardTitle": "کوٹیشن منظور کریں؟", "awardText": "یہ جیتنے والی کوٹیشن بن جائے گی اور خود بخود PO بن جائے گا۔" },
        "footer": { "showing": "دکھا رہا ہے" }
      },
      "itemList": {
        "headers": { "master": "آئٹم ماسٹر" },
        "actions": { "newItem": "نیا آئٹم" },
        "tables": { "item": "آئٹم", "rotating": "گھومنے والا؟" },
        "messages": { "syncFailed": "ماسٹر ڈیٹا کے ساتھ ہم آہنگ کرنے میں ناکامی", "syncing": "ریکارڈز ہم آہنگ ہو رہے ہیں...", "noData": "کوئی آئٹم نہیں ملا" },
        "footer": { "totalItems": "کل آئٹمز:", "page": "صفحہ" }
      },
      "itemDetails": {
        "tabs": { "item": "آئٹم کی تفصیل", "inventory": "انوینٹری", "vendors": "وینڈرز", "specs": "تفصیلات", "assembly": "اسمبلی (BOM)" },
        "sections": { "config": "آئٹم کی ترتیب", "units": "اکائیاں اور ٹریکنگ", "bomList": "BOM کی فہرست", "supplierHistory": "خریداری اور سپلائر کی تاریخ" },
        "actions": { "save": "آئٹم محفوظ کریں", "addStore": "اسٹور میں شامل کریں", "newSpec": "نئی تفصیل شامل کریں", "addComponent": "جز شامل کریں" },
        "fields": { "itemSet": "آئٹم سیٹ", "rotating": "گھومنے والا؟", "lotControl": "لاٹ کنٹرول؟", "inspectionReq": "معائنہ ضروری؟", "orderUnit": "آرڈر کی اکائی", "issueUnit": "جاری کرنے کی اکائی", "condition": "حالت فعال؟", "sparepart": "اسپیئر پارٹ کے طور پر شامل کریں؟", "classification": "درجہ بندی" },
        "tables": { "store": "اسٹور", "avgCost": "اوسط لاگت", "balance": "بقیہ", "attribute": "صفت", "value": "قدر", "uom": "UOM", "subItem": "ذیلی آئٹم", "remarks": "ریمارکس", "vendor": "وینڈر کا نمبر", "supplierName": "سپلائر کا نام", "unitCost": "یونٹ کی قیمت", "refPO": "حوالہ PO", "activeVendors": "فعال وینڈرز" },
        "messages": { "reqFields": "آئٹم نمبر اور تفصیل لازمی ہے!", "fetchingAttributes": "خصوصیات لائی جا رہی ہیں...", "attributesLoaded": "درجہ بندی اور خصوصیات لوڈ ہو گئیں", "failedAttributes": "خصوصیات لوڈ کرنے میں ناکامی", "stockMsgTitle": "اسٹاک کا پیغام", "stockMsgDesc": "ان اکائیوں کو اپ ڈیٹ کرنے سے تمام سائٹس کے اسٹور رومز متاثر ہوں گے۔", "noInventory": "اس آئٹم کے لیے کوئی انوینٹری ریکارڈ نہیں ہے۔", "noSpecs": "کوئی تفصیلات بیان نہیں کی گئیں۔", "noBom": "کوئی BOM بیان نہیں کیا گیا۔", "noVendors": "کوئی خریداری کا ریکارڈ نہیں ملا۔" },
        "swal": { "deleteText": "آپ آئٹم {{num}} کو حذف کرنے والے ہیں۔ اسے واپس نہیں لایا جا سکتا!" }
      },
      "changePassword": {
        "title": "پاس ورڈ تبدیل کریں",
        "currentPwd": "موجودہ پاس ورڈ",
        "newPwd": "نیا پاس ورڈ",
        "confirmPwd": "نئے پاس ورڈ کی تصدیق کریں",
        "securityTitle": "سیکیورٹی کی تصدیق",
        "googleAuthMsg": "اس تبدیلی کی تصدیق کے لیے Google Authenticator سے 6 ہندسوں کا کوڈ درج کریں۔",
        "emailOtpMsg": "آپ کے ای میل پر ایک OTP کوڈ بھیجا گیا ہے۔",
        "btnCancel": "منسوخ کریں",
        "btnUpdate": "پاس ورڈ اپ ڈیٹ کریں",
        "btnVerify": "تصدیق کریں اور تبدیل کریں",
        "btnBack": "واپس جائیں",
        "errMismatch": "نئے پاس ورڈز آپس میں نہیں ملتے!",
        "errLength": "پاس ورڈ کم از کم 6 حروف پر مشتمل ہونا چاہیے۔",
        "msgVerifyReq": "جاری رکھنے کے لیے براہ کرم اپنی شناخت کی تصدیق کریں۔",
        "msgSuccess": "پاس ورڈ کامیابی سے تبدیل ہو گیا!",
        "errFailed": "پاس ورڈ تبدیل کرنے میں ناکامی۔"
      },
      "userDetails": {
        "titleNew": "نیا صارف",
        "titleEdit": "سیکیورٹی / صارفین",
        "btnSave": "محفوظ کریں",
        "saving": "محفوظ ہو رہا ہے...",
        "secIdent": "صارف کی شناخت",
        "lblLoginId": "لاگ ان آئی ڈی",
        "lblFullName": "پورا نام",
        "lblDisplayName": "ڈسپلے کا نام",
        "lblEmail": "ای میل ایڈریس",
        "lblPassword": "پاس ورڈ",
        "lblActive": "فعال حالت",
        "secAccess": "سیکیورٹی اور رسائی کنٹرول",
        "lblPrimaryRole": "بنیادی سیکیورٹی رول",
        "lblSecRoles": "ثانوی رولز (اضافی)",
        "lblDefOrg": "ڈیفالٹ تنظیم",
        "lblDefSite": "ڈیفالٹ سائٹ",
        "secDelegation": "کام کی تفویض",
        "lblDelegateTo": "کام تفویض کریں",
        "lblStartDate": "شروع کی تاریخ اور وقت",
        "lblEndDate": "ختم ہونے کی تاریخ اور وقت"
      },
      "receivingDetails": {
        "errLoadLines": "پی او لائنز لوڈ کرنے میں ناکام",
        "errMissingDist": "براہ کرم تمام لائنز کے لیے اسٹور روم اور مقدار کی وضاحت کریں",
        "errInspMandatory": "اس آئٹم کے لیے معائنہ کا فیصلہ لازمی ہے",
        "errRejectExceeds": "مسترد شدہ مقدار چیک کریں (پہنچنے والی مقدار سے زیادہ نہیں ہو سکتی)",
        "msgSuccess": "ٹرانزیکشن کامیابی کے ساتھ مکمل ہو گئی!",
        "msgAutoClosed": "خودکار طور پر بند ہو گیا: ",
        "swalAssignTitle": "اسٹور روم کی تفویض",
        "swalAssignText": "آئٹم {{item}} فی الحال {{loc}} کو تفویض نہیں ہے۔ کیا آپ اسے ابھی تفویض کر کے وصولی مکمل کرنا چاہتے ہیں؟",
        "swalAssignBtn": "ہاں، تفویض کریں اور مکمل کریں",
        "errUnexpected": "وصولی کے دوران ایک غیر متوقع خرابی پیش آ گئی",
        "hubTitle": "بلک وصولی کا مرکز",
        "poRef": "پی او حوالہ: ",
        "btnExecuting": "عمل ہو رہا ہے...",
        "btnConfirm": "وصولی کی تصدیق کریں",
        "tblItemsPending": "وصولی کے منتظر آئٹمز",
        "colItemDetails": "آئٹم کی تفصیلات",
        "colBalance": "بقیہ",
        "lblQualityCheck": "کوالٹی چیک درکار ہے",
        "lblUnits": "یونٹس",
        "msgNoPending": "کوئی منتظر آئٹم نہیں ملا",
        "lblLandedCost": "لینڈڈ لاگت (کل اضافی چارجز)",
        "lblBaseCost": "بنیادی پی او یونٹ لاگت",
        "lblStoreMatrix": "اسٹور کی تقسیم کا میٹرکس",
        "btnSplitStore": "اسٹور تقسیم کریں",
        "colStoreroom": "اسٹور روم",
        "colArrived": "پہنچ گیا",
        "colRejected": "مسترد شدہ",
        "plcClickSearch": "تلاش کرنے کے لیے کلک کریں <-",
        "lookupSelectStore": "اسٹور روم منتخب کریں",
        "lblQcMatrix": "کوالٹی کنٹرول فیصلہ میٹرکس",
        "optSelectDecision": "-- درکار ہے: فیصلہ منتخب کریں --",
        "optPassed": "مکمل طور پر پاس (سب قبول کریں)",
        "optFailed": "مکمل طور پر مسترد (وینڈر کو واپس کریں)",
        "optPartial": "جزوی قبولیت (مسترد شدہ فیلڈ چیک کریں)",
        "lblInvValuation": "انوینٹری کی قیمت (اوسط یونٹ لاگت)",
        "lblNetArrived": "خالص پہنچنے والا اسٹاک",
        "msgSelectLine": "شروع کرنے کے لیے ایک فعال پی او لائن منتخب کریں"
      },
      "userList": {
        "title": "صارف کی سیکیورٹی",
        "plcSearch": "صارف یا ای میل تلاش کریں...",
        "btnNewUser": "نیا صارف",
        "colUserId": "صارف آئی ڈی",
        "colFullName": "پورا نام",
        "colRole": "کردار",
        "colSite": "سائٹ",
        "colStatus": "حالت",
        "colEmail": "ای میل",
        "msgSyncing": "سیکیورٹی ہم آہنگ ہو رہی ہے...",
        "lblNoRole": "کوئی کردار نہیں",
        "lblAll": "سب",
        "lblTotalUsers": "کل صارفین:",
        "lblPage": "صفحہ",
        "errLoadUsers": "صارفین کو لوڈ کرنے میں خرابی"
      },
      "crafts": {
        "headers": {
          "craftList": "ہنر کا کیٹلاگ"
        },
        "actions": {
          "newCraft": "نیا ہنر"
        },
        "tables": {
          "craftCode": "ہنر کا کوڈ",
          "description": "تفصیل",
          "stdRate": "معیاری شرح/گھنٹہ",
          "site": "سائٹ",
          "org": "تنظیم"
        },
        "messages": {
          "loadFailed": "ہنر لوڈ کرنے میں ناکام"
        },
        "headers": {
          "craftList": "ہنر کا کیٹلاگ"
        },
        "tabs": {
          "skills": "ہنر کی مہارتیں اور درجات"
        },
        "sections": {
          "costing": "لاگت",
          "control": "کنٹرول"
        },
        "actions": {
          "newCraft": "نیا ہنر",
          "addSkill": "مہارت کا درجہ شامل کریں"
        },
        "tables": {
          "craftCode": "ہنر کا کوڈ",
          "description": "تفصیل",
          "stdRate": "معیاری شرح/گھنٹہ",
          "site": "سائٹ",
          "org": "تنظیم"
        },
        "fields": {
          "stdHourlyRate": "معیاری فی گھنٹہ شرح",
          "skillLevel": "مہارت کا درجہ (جیسے ماہر، جونیئر)",
          "hourlyRate": "فی گھنٹہ شرح"
        },
        "placeholders": {
          "enterLevel": "درجہ درج کریں..."
        },
        "messages": {
          "loadFailed": "ہنر لوڈ کرنے میں ناکام",
          "autoCalc": "مہارتوں کے مجموعے سے خود بخود شمار کیا گیا",
          "noSkills": "ابھی تک کوئی مہارت متعین نہیں کی گئی"
        }
      },
      "persons": {
        "headers": {
          "directory": "افراد کی ڈائرکٹری"
        },
        "tables": {
          "personId": "شخص کی آئی ڈی",
          "name": "ڈسپلے کا نام",
          "site": "سائٹ",
          "email": "ای میل",
          "phone": "فون"
        },
        "messages": {
          "loadFailed": "افراد کی فہرست لوڈ کرنے میں ناکام"
        },
        "headers": {
          "directory": "افراد کی ڈائرکٹری"
        },
        "tabs": {
          "profile": "پروفائل کی معلومات",
          "contact": "رابطہ کی ڈائرکٹری",
          "access": "سسٹم تک رسائی"
        },
        "sections": {
          "personalInfo": "ذاتی معلومات",
          "statusControl": "حالت اور کنٹرول",
          "contactsDirectory": "متعلقہ رابطے"
        },
        "tables": {
          "personId": "شخص کی آئی ڈی",
          "name": "ڈسپلے کا نام",
          "site": "سائٹ",
          "email": "ای میل",
          "phone": "فون"
        },
        "fields": {
          "location": "مقام",
          "firstName": "پہلا نام",
          "lastName": "آخری نام",
          "title": "عہدہ",
          "department": "محکمہ",
          "currentStatus": "موجودہ حالت",
          "contactName": "رابطے کا نام",
          "position": "پوزیشن",
          "email": "ای میل ایڈریس",
          "phone": "فون",
          "mobile": "موبائل",
          "primary": "پرائمری",
          "address": "پتہ",
          "city": "شہر",
          "country": "ملک",
        },
        "actions": {
          "newPerson": "نیا شخص",
          "addContact": "رابطہ شامل کریں"
        },
        "messages": {
          "loadFailed": "افراد کی فہرست لوڈ کرنے میں ناکام",
          "noContacts": "ابھی تک کوئی رابطہ شامل نہیں کیا گیا",
          "accessControlled": "سسٹم تک رسائی کو صارف سیکیورٹی ماڈیول کے ذریعے کنٹرول کیا جاتا ہے"
        }
      },
      "jp": {
        "list": {
          "title": "جاب پلانز ڈائرکٹری",
          "new_plan": "نیا پلان",
          "filter_jp": "پلانز فلٹر کریں...",
          "search_desc": "تفصیل تلاش کریں...",
          "filter_site": "سائٹ...",
          "no_records": "کوئی جاب پلان نہیں ملا",
          "fetch_error": "جاب پلانز لوڈ کرنے میں ناکام"
        },
        "fields": {
          "jpnum": "پلان نمبر",
          "description": "تفصیل",
          "status": "حالت",
          "revision": "نظر ثانی",
          "site": "سائٹ"
        },
        "details": {
          "load_error": "جاب پلان لوڈ کرنے میں ناکام",
          "delete_warn": "آپ جاب پلان {{jpnum}} کو حذف کرنے والے ہیں۔ یہ عمل واپس نہیں لیا جا سکتا!"
        },
        "tabs": {
          "job_plan": "جاب پلان",
          "plans": "پلانز",
          "assets": "اثاثے"
        },
        "subtabs": {
          "tasks": "کام",
          "labor": "مزدور",
          "materials": "مواد",
          "tools": "اوزار"
        },
        "sections": {
          "details": "پلان کی تفصیلات",
          "responsibility": "ذمہ داری",
          "woassets": "کام کے اثاثے اور حفاظتی پلان"
        },
        "fields": {
          "jpnum": "پلان نمبر",
          "status": "حالت",
          "description": "تفصیل",
          "template_type": "ٹیمپلیٹ کی قسم",
          "duration": "دورانیہ (گھنٹے)",
          "supervisor": "سپرائزر",
          "class": "کلاس کی ساخت",
          "safety_plan": "حفاظتی پلان",
          "revision": "نظر ثانی"
        },
        "table": {
          "seq": "ترتیب",
          "duration": "دورانیہ",
          "craft": "پیشہ",
          "labor": "مزدور",
          "qty": "مقدار",
          "hours": "گھنٹے",
          "rate": "شرح",
          "item": "آئٹم",
          "unitcost": "یونٹ کی قیمت",
          "tool": "آلہ"
        }
      },
      "meters": {
        "list": {
          "title": "میٹر کی تعریفیں",
          "search": "نمبر یا نام سے فلٹر کریں...",
          "new_meter": "نیا میٹر",
          "no_records": "کوئی میٹر نہیں ملا"
        },
        "fields": {
          "meter_num": "میٹر نمبر",
          "meter_name": "میٹر کا نام",
          "type": "قسم",
          "uom": "پیمائش کی اکائی",
          "active": "فعال؟",
          "remarks": "تبصرے",
          "last_reading": "آخری ریڈنگ",
          "last_date": "آخری ریڈنگ کی تاریخ",
          "rollovers": "کل رول اوورز"
        },
        "tabs": {
          "meter": "میٹر کی تفصیلات",
          "where_used": "کہاں استعمال ہوا"
        },
        "sections": {
          "info": "میٹر کی معلومات",
          "additional": "اضافی تفصیلات",
          "stats": "میٹر کے اعدادوشمار"
        },
        "where_used": {
          "linked_assets": "منسلک اثاثے",
          "linked_locations": "منسلک مقامات",
          "linked_items": "منسلک آئٹمز",
          "searching": "🔍 سسٹم میں تلاش جاری ہے...",
          "no_assoc": "اس زمرے میں کوئی تعلق نہیں ملا۔",
          "asset_num": "اثاثہ نمبر",
          "site": "سائٹ",
          "status": "حالت",
          "location": "مقام",
          "item_num": "آئٹم نمبر",
          "category": "زمرہ"
        }
      },
      "asset_categories": {
        "list": {
          "title": "اثاثہ کیٹیگریز",
          "search": "کیٹیگریز تلاش کریں...",
          "new_category": "نئی کیٹیگری",
          "no_records": "کوئی کیٹیگری نہیں ملی"
        },
        "fields": {
          "category_id": "کیٹیگری کوڈ",
          "description": "تفصیل",
          "dep_method": "فرسودگی کا طریقہ",
          "life": "زندگی (سال)"
        }
      },
      "export": {
        "loading": "ڈیٹا نکالا جا رہا ہے...",
        "success": "کامیابی سے برآمد ہو گیا!",
        "error": "ڈیٹا برآمد کرنے میں خرابی۔"
      },
      "labor": {
        "list": {
          "title": "لیبر رجسٹری",
          "new": "نئی لیبر",
          "total": "کل لیبر",
          "unique_crafts": "صفحہ کی مہارتیں",
          "no_records": "کوئی لیبر ریکارڈ نہیں ملا۔"
        },
        "tabs": {
          "main": "مین",
          "person": "شخص",
          "crafts": "مہارتیں",
          "log": "لاگ"
        },
        "sections": {
          "basic": "بنیادی معلومات",
          "status": "حیثیت اور تنظیم",
          "additional_crafts": "اضافی مہارتیں اور تخصیصی صلاحیتیں"
        },
        "fields": {
          "personid": "شخص کا حوالہ",
          "primary_craft": "بنیادی مہارت",
          "actual_rate": "اصل شرح (فی گھنٹہ)",
          "skill": "مہارت کی سطح",
          "rate": "فی گھنٹہ شرح",
          "primary": "بنیادی؟",
          "laborcode": "لیبر کوڈ",
          "fullname": "پورا نام",
          "craft": "مہارت / پیشہ"
        },
        "actions": {
          "add_craft": "مہارت شامل کریں"
        },
        "lookup": {
          "person": "شخص منتخب کریں",
          "craft": "مہارت منتخب کریں",
          "skill": "مہارت کی سطح منتخب کریں"
        },
        "messages": {
          "no_crafts": "کوئی مہارت کا تعلق نہیں ملا"
        },
        "details": {
          "delete_warn": "آپ اس ریکارڈ کو بازیافت نہیں کر سکیں گے!"
        }
      },
      "sr": {
        "list": {
          "title": "سروس کی درخواست کی ٹریکنگ",
          "new": "نئی درخواست"
        },
        "messages": {
          "no_records": "کوئی سروس کی درخواستیں نہیں ملیں"
        },
        "tabs": {
          "main": "سروس کی درخواست",
          "related": "متعلقہ ریکارڈز"
        },
        "sections": {
          "requester": "درخواست گزار اور رابطہ",
          "problem": "مسئلے کی تفصیلات",
          "logistics": "لاجسٹکس اور ترجیح"
        },
        "fields": {
          "srnum": "درخواست نمبر",
          "description": "تفصیل",
          "reportedby": "رپورٹ کرنے والا",
          "reportdate": "رپورٹ کی تاریخ",
          "priority": "ترجیح",        
          "phone": "فون",
          "email": "ای میل",
          "asset": "اثاثہ",
          "location": "مقام",
          "long_desc": "مسئلے کی تفصیلی وضاحت",
          "priority_1": "1 - ہنگامی (فوری)",
          "priority_2": "2 - اعلیٰ (اسی دن)",
          "priority_3": "3 - درمیانہ (72 گھنٹے)",
          "priority_4": "4 - کم (منصوبہ بندی شدہ)"
        },
        "lookup": {
          "person": "شخص منتخب کریں",
          "asset": "اثاثہ منتخب کریں",
          "location": "مقام منتخب کریں"
        },
        "details": {
          "delete_new_only": "صرف نئی (NEW) درخواستیں ہی حذف کی جا سکتی ہیں",
          "delete_warn": "یہ اس سروس کی درخواست کو مستقل طور پر حذف کر دے گا۔",
          "wf_tip": "خودکار ورک فلو: محفوظ کرنے کے بعد، اس درخواست کو تکنیکی جائزے کے لیے بھیجنے کے لیے 'روٹ ورک فلو' بٹن استعمال کریں۔",
          "wo_tip": "ترکیب: آپ ورک فلو ایکشنز یا 'ورک آرڈر بنائیں' خودکار اسکرپٹ کے ذریعے اس SR سے ورک آرڈر تیار کر سکتے ہیں۔"
        },
        "related": {
          "title": "SR سے منسلک ورک آرڈرز:",
          "wonum": "WO نمبر",
          "worktype": "کام کی قسم",
          "no_wo": "اس SR کے لیے ابھی تک کوئی ورک آرڈر نہیں بنایا گیا۔",
          "go_to_wo": "ورک آرڈر پر جائیں"
        }
      },
      "invusage": {
        "list": {
          "title": "انوینٹری کے استعمال کی تاریخ",
          "new": "نیا ٹرانزیکشن بنائیں"
        },
        "types": {
          "all": "تمام",
          "issue": "اجراء",
          "transfer": "منتقلی",
          "return": "واپسی"
        },
        "tabs": {
          "lines": "استعمال کی لائنز",
          "log": "ٹرانزیکشن لاگ"
        },
        "details": {
          "summary": "لائنز کا خلاصہ",
          "transfer_dest": "منتقلی کی منزل کی تفصیلات",
          "financial": "مالیاتی چارجنگ اور حوالہ"
        },
        "actions": {
          "add_item": "آئٹم شامل کریں",
          "add_part": "پارٹ شامل کریں",
          "select_mr": "درخواست منتخب کریں"
        },
        "fields": {
          "stock_item": "اسٹاک آئٹم",
          "issueunit": "جاری کرنے کی اکائی",
          "qty": "مقدار",
          "unitcost": "اکائی کی قیمت",
          "linecost": "کل لائن ویلیو",
          "target_bin": "ہدف بن",
          "target_loc": "ہدف کا مقام",
          "assetnum": "اثاثہ نمبر",
          "wonum": "ورک آرڈر کا حوالہ",
          "glaccount": "ڈیبٹ جی ایل اکاؤنٹ",
          "usagenum": "استعمال کی آئی ڈی",
          "type": "قسم",
          "fromstore": "اسٹور سے",
          "lines": "لائنز",
          "enterby": "درج کنندہ"
        },
        "placeholders": {
          "select_item": "آئٹم منتخب کریں...",
          "dest_bin": "منزل کا بن درج کریں...",
          "choose_loc": "مقام کا انتخاب کریں",
          "select_asset": "اثاثہ منتخب کریں",
          "charge_wo": "ورک آرڈر پر چارج کریں"
        },
        "lookup": {
          "store": "اسٹور رومز",
          "dest_store": "منزل کے اسٹور رومز",
          "mr": "منظور شدہ درخواست منتخب کریں",
          "item": "انوینٹری تلاش",
          "loc": "سائٹ کے مقامات",
          "asset": "اثاثہ رجسٹری",
          "wo": "ورک آرڈرز"
        },
        "messages": {
          "req_fromstore": "براہ کرم پہلے اسٹور روم منتخب کریں!",
          "mr_loaded": "درخواست سے آئٹمز لوڈ ہو گئے:",
          "mr_fail": "درخواست آئٹمز لوڈ کرنے میں ناکامی",
          "insufficient_title": "اسٹاک ناکافی ہے!",
          "available": "دستیاب",
          "create_pr": "کیا خریداری کی درخواست (PR) بنائیں؟",
          "btn_create_pr": "PR بنائیں",
          "processing": "انوینٹری ایڈجسٹمنٹس پر کارروائی ہو رہی ہے...",
          "inventory_updated": "انوینٹری کی سطح کامیابی سے اپ ڈیٹ ہو گئی",
          "cant_delete_comp": "مکمل شدہ ٹرانزیکشن کو حذف نہیں کیا جا سکتا!",
          "delete_warn": "یہ ڈرافٹ ٹرانزیکشن کو مستقل طور پر حذف کر دے گا۔",
          "req_fields": "تفصیل اور اسٹور روم ضروری ہیں!",
          "req_transfer": "منتقلی کے لیے منزل کا اسٹور ضروری ہے!",
          "locked_title": "ریکارڈ لاک ہے",
          "locked_text": "یہ ٹرانزیکشن مکمل ہو چکی ہے اور اسے تبدیل نہیں کیا جا سکتا۔",
          "cant_save_comp": "مکمل شدہ ریکارڈ میں تبدیلیاں محفوظ نہیں کی جا سکتیں",
          "balance_move": "نوٹ: مکمل ہونے پر بیلنس منتقل کر دیا جائے گا:",
          "upon_comp": "۔"
        }
      },
      "downtime": {
        "title": "اثاثہ کے ڈاؤن ٹائم کی رپورٹ",
        "subtitle": "اثاثہ جات کے انتظام کا نظام",
        "asset": "اثاثہ",
        "status": "آف لائن ریکارڈنگ",
        "start": "شروع کی تاریخ اور وقت",
        "end": "ختم ہونے کی تاریخ (اختیاری)",
        "type": "ڈاؤن ٹائم کی قسم",
        "types": {
          "unplanned": "غیر منصوبہ بند (خرابی)",
          "planned": "منصوبہ بند (دیکھ بھال)"
        },
        "duration": "حساب شدہ مدت",
        "hours": "گھنٹے",
        "prod_impact": "آپریشنل ڈاؤن ٹائم (پیداوار پر اثر)",
        "btn_commit": "تبدیلیاں محفوظ کریں",
        "messages": {
          "recording": "ڈاؤن ٹائم ریکارڈ ہو رہا ہے...",
          "success": "ڈاؤن ٹائم کامیابی کے ساتھ ریکارڈ کر لیا گیا",
          "validation_error": "فارمیٹ کی غلطی: تمام فیلڈز چیک کریں",
          "server_error": "سرور کی خرابی: 500"
        },
        "history": {
          "title": "اثاثہ کے ڈاؤن ٹائم کی تاریخ",
          "subtitle": "اثاثہ کی کارکردگی کا سراغ لگانا",
          "no_records": "اس اثاثہ کے لیے کوئی ڈاؤن ٹائم ایونٹ ریکارڈ نہیں کیا گیا۔",
          "duration_hrs": "مدت (گھنٹے)",
          "type_reason": "قسم/وجہ",
          "impact": "اثر",
          "reported_by": "رپورٹ کرنے والا",
          "still_down": "ابھی بھی بند ہے",
          "prod_loss": "پیداواری نقصان",
          "technical": "تکنیکی",
          "active_down": "فعال ڈاؤن ٹائم",
          "resolved": "حل ہو گیا"
        }
      },
      "incidents": {
        "list": {
          "title": "واقعات کا رجسٹر",
          "new": "نیا واقعہ"
        },
        "fields": {
          "ticket_id": "ٹکٹ آئی ڈی",
          "priority": "ترجیح",
          "reported_by": "رپورٹ کرنے والا"
        },
        "details": {
          "ticket": "واقعہ کا ٹکٹ",
          "general": "عمومی تفصیل",
          "detailed": "تفصیلی معلومات",
          "context": "سیاق و سباق اور حیثیت",
          "linked_asset": "منسلک اثاثہ",
          "workorder": "ورک آرڈر",
          "delete_warn": "آپ واقعہ {{ticket}} کو مستقل طور پر حذف کرنے والے ہیں۔ یہ عمل واپس نہیں لیا جا سکتا!"
        },
        "lookup": {
          "asset": "منسلک اثاثہ منتخب کریں",
          "loc": "مقام منتخب کریں"
        }
      },
      "tools": {
        "list": {
          "title": "ٹول ماسٹر",
          "new": "نیا ٹول"
        },
        "fields": {
          "toolnum": "ٹول نمبر",
          "type": "قسم",
          "is_stocked": "اسٹاک میں ہے؟"
        },
        "tabs": {
          "tool": "ٹول",
          "stores": "اسٹورز",
          "vendors": "وینڈرز",
          "specs": "تفصیلات",
          "quals": "قابلیتیں"
        },
        "sections": {
          "config": "ٹول کی ترتیب",
          "inventory": "انوینٹری اور اسٹاک بیلنس",
          "vendors": "خریداری اور سپلائر کی تاریخ",
          "quals": "مطلوبہ قابلیتیں"
        },
        "fields": {
          "toolnum": "ٹول نمبر",
          "type": "ٹول کی قسم",
          "issueunit": "جاری کرنے کی اکائی",
          "is_stocked": "کیا اسٹاک شدہ ٹول ہے؟",
          "rotating": "گھومنے والا آئٹم؟",
          "calib_req": "انشانکن درکار ہے؟",
          "mfg": "بنانے والا",
          "model": "ماڈل نمبر",
          "class": "درجہ بندی",
          "active_vendors": "فعال وینڈرز"
        },
        "actions": {
          "add_store": "اسٹور روم میں شامل کریں",
          "add_qual": "قابلیت شامل کریں"
        },
        "tables": {
          "storeroom": "اسٹور روم",
          "balance": "بیلنس",
          "attr": "صفت",
          "value": "قدر",
          "uom": "پیمائش کی اکائی",
          "qual": "قابلیت",
          "vendor_id": "وینڈر (کمپنی نمبر)",
          "vendor_name": "سپلائر کا نام",
          "unitcost": "اکائی کی قیمت",
          "qty": "مقدار",
          "po": "حوالہ پی او"
        },
        "placeholders": {
          "toolid": "ٹول آئی ڈی درج کریں...",
          "reg_supplier": "رجسٹرڈ سپلائر",
          "adj": "اسٹاک ایڈجسٹمنٹ"
        },
        "lookup": {
          "type": "ٹول کی قسم",
          "unit": "جاری کرنے کی اکائیاں",
          "attr": "صفات"
        },
        "messages": {
          "req_fields": "ٹول نمبر اور تفصیل ضروری ہیں!",
          "delete_warn": "آپ اسے واپس نہیں کر سکیں گے!",
          "class_loaded": "درجہ بندی اور صفات لوڈ ہو گئیں",
          "stocked_note": "نوٹ: اسٹاک شدہ ٹولز کو اسٹور رومز کے ذریعے منظم کیا جاتا ہے اور بیلنس کو ٹریک کرنے کے لیے انوینٹری ریکارڈ کی ضرورت ہوتی ہے۔",
          "no_stock": "اسٹاک میں کوئی آئٹم نہیں ہے"
        }
      },
      "inventory": {
        "list": {
          "title": "انوینٹری رجسٹری"
        },
        "fields": {
          "itemnum": "آئٹم نمبر",
          "location": "اسٹور روم",
          "balance": "بیلنس",
          "avgcost": "اوسط لاگت"
        },
        "details": {
          "profile": "انوینٹری پروفائل",
          "reorder_logic": "دوبارہ آرڈر کی منطق",
          "reorder_pt": "ری آرڈر پوائنٹ",
          "eoq": "اقتصادی آرڈر کی مقدار",
          "critical_lvl": "اہم سطح",
          "critical_desc": "جب بیلنس ری آرڈر پوائنٹ تک پہنچ جائے تو خودکار پی آر بنائیں۔",
          "current_stock": "موجودہ اسٹاک کی سطح",
          "avail_qty": "دستیاب مقدار",
          "reserved_qty": "محفوظ مقدار",
          "held_wo": "ورک آرڈرز کے لیے روکا گیا",
          "avg_cost": "اوسط یونٹ لاگت",
          "avg_cost_desc": "تمام رسیدوں کی وزنی اوسط",
          "total_val": "کل اسٹاک کی مالیت",
          "total_val_desc": "موجودہ بیلنس × اوسط لاگت",
          "last_cost": "آخری رسید کی لاگت",
          "last_cost_desc": "تازہ ترین پی او سے لاگت",
          "val_method": "انوینٹری کی تشخیص کا طریقہ",
          "avg_method": "اوسط لاگت",
          "val_desc1": "یہ آئٹم",
          "val_desc2": "کا طریقہ استعمال کرتا ہے۔ مارکیٹ کی قیمتوں کے اتار چڑھاو کی عکاسی کرنے کے لیے ہر خریداری کے آرڈر کی رسید پر یونٹ کی لاگت کا خود بخود دوبارہ حساب لگایا جاتا ہے۔"
        },
        "tabs": {
          "balances": "بیلنسز",
          "trans": "ٹرانزیکشن کی تاریخ",
          "costs": "اخراجات"
        },
        "actions": {
          "adjustment": "اسٹاک ایڈجسٹمنٹ"
        },
        "tables": {
          "qty": "مقدار",
          "actual_cost": "اصل لاگت",
          "reference": "حوالہ"
        },
        "messages": {
          "no_trans": "ٹرانزیکشن کی کوئی تاریخ نہیں ملی"
        },
        "trans_types": {
          "receipt": "رسید",
          "issue": "اجراء",
          "transfer": "منتقلی",
          "adjustment": "ایڈجسٹمنٹ"
        }
      },
      "storerooms": {
        "list": {
          "title": "اسٹور رومز",
          "new": "نیا اسٹور روم"
        },
        "fields": {
          "location": "اسٹور روم",
          "isdefault": "کیا ڈیفالٹ ہے؟",
          "inventory": "انوینٹری",
        },
        "details": {
          "profile": "اسٹور روم",
          "record": "اسٹور روم ریکارڈ",
          "gen_settings": "عمومی ترتیبات",
          "filtered_by": "{{org}} سے فلٹر کیا گیا",
          "select_org_first": "پہلے تنظیم کا انتخاب کریں",
          "gl_accounts": "جی ایل اکاؤنٹس",
          "inv_control": "انوینٹری کنٹرول",
          "inv_control_desc": "اس اسٹور روم کے لیے تمام مادی اجراء اور رسیدیں ان اکاؤنٹس کے خلاف متوازن ہوں گی۔",
          "items_stocked": "اسٹاک شدہ آئٹمز"
        },
        "tabs": {
          "main": "مرکزی",
          "inventory": "انوینٹری"
        },
        "fields": {
          "location": "مقام کی آئی ڈی",
          "isdefault": "ڈیفالٹ اسٹور روم؟",
          "useinpo": "پی او میں استعمال کریں؟",
          "invowner": "انوینٹری کا مالک",
          "controlacc": "کنٹرول اکاؤنٹ",
          "shrinkacc": "شرنکیج اکاؤنٹ",
          "glaccount": "ڈیفالٹ جی ایل اکاؤنٹ",
          "default": "ڈیفالٹ"
        },
        "lookup": {
          "person": "شخص کا انتخاب کریں"
        },
        "tables": {
          "itemnum": "آئٹم نمبر",
          "uom": "پیمائش کی اکائی",
          "curbal": "موجودہ بیلنس",
          "reserved": "محفوظ مقدار"
        },
        "messages": {
          "req_fields": "مقام کی آئی ڈی درکار ہے!",
          "req_org_site": "تنظیم اور سائٹ درکار ہیں!",
          "delete_warn": "آپ اسٹور روم {{store}} کو حذف کرنے والے ہیں۔ یہ عمل واپس نہیں لیا جا سکتا!"
        }
      },
      "failure_codes": {
        "list": {
          "title": "ناکامی کوڈز کی لائبریری",
          "new": "نئی ناکامی کی کلاس"
        },
        "details": {
          "profile": "ناکامی کی کلاس"
        },
        "fields": {
          "class": "ناکامی کی کلاس",
          "code": "کوڈ",
          "desc_tech": "تفصیل / تکنیکی نام"
        },
        "tables": {
          "problems": "مسائل (مسئلہ)",
          "causes": "وجوہات (بنیادی وجہ)",
          "remedies": "علاج (کارروائی)"
        },
        "placeholders": {
          "class": "مثال کے طور پر: PUMP-FAIL",
          "desc_tech": "اس ناکامی کی درجہ بندی کی تفصیلی وضاحت فراہم کریں...",
          "code": "کوڈ درج کریں...",
          "desc": "تکنیکی تفصیل..."
        },
        "messages": {
          "req_class": "ناکامی کی کلاس کا کوڈ درکار ہے!",
          "delete_warn": "آپ ناکامی کی کلاس {{class}} کو حذف کرنے والے ہیں۔ یہ عمل واپس نہیں لیا جا سکتا!"
        }
      },
      "scheduler": {
        "title": "ترسیل اور الاٹمنٹ",
        "ai_optimize": "اے آئی آٹو آپٹیمائز",
        "publish": "شیڈول شائع کریں",
        "kpi_scheduled": "شیڈول شدہ کام",
        "kpi_issues": "شیڈولنگ کے مسائل",
        "kpi_utilization": "کل وسائل",
        "kpi_emergencies": "ہنگامی حالات",
        "no_data": "کوئی شیڈول شدہ ورک آرڈرز نہیں ہیں۔",
        "no_resources": "وسائل کی گنجائش کا کوئی ڈیٹا نہیں۔",
        "fetch_error": "شیڈولنگ کا ڈیٹا لوڈ کرنے میں ناکامی۔",
        "optimizing": "اے آئی وسائل کا بوجھ برابر کر رہا ہے...",
        "optimize_fail": "اے آئی آپٹیمائزیشن ناکام ہو گئی۔"
      },
      "features": {
        "title": "لکیری خصوصیات کی کیٹلاگ",
        "feature_id": "فیچر کوڈ",
        "description": "تفصیل",
        "type": "فیچر کی قسم",
        "point": "نقطہ (جیسے والو)",
        "linear": "لکیری (جیسے مواد)",
        "error_in_use": "حذف نہیں کر سکتے: خصوصیت پائپ لائن پر زیر استعمال ہے۔"
      },
      "audit": {
        "title": "آڈٹ ٹریل ایکسپلورر",
        "history_for": "کی تاریخ",
        "retrieving": "آڈٹ ریکارڈز بازیافت کیے جا رہے ہیں...",
        "no_records": "اس ریکارڈ کے لیے کوئی آڈٹ ٹریل نہیں ملا"
      },

    }
  }

};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng', // التأكيد على اسم المفتاح
      caches: ['localStorage'], 
    },
    interpolation: {
      escapeValue: false
    }
  });

  const applyLayoutSettings = (lng) => {
    const isRTL = lng === 'ar' || lng === 'ur';
    const dir = isRTL ? 'rtl' : 'ltr';
    const font = isRTL ? "'Cairo', sans-serif" : "'Inter', sans-serif";

    document.documentElement.dir = dir;
    document.body.dir = dir;
    document.body.style.fontFamily = font;
  };

// تشغيل الإعدادات فوراً بناءً على اللغة المكتشفة
const currentLng = i18n.language || localStorage.getItem('i18nextLng') || 'en';
applyLayoutSettings(currentLng);

// تحديث الإعدادات لو اللغة اتغيرت في أي وقت
i18n.on('languageChanged', (lng) => {
  applyLayoutSettings(lng);
});

export default i18n;
